(function() {
  'use strict';

  angular
    .module('ticket.controller.operacao', [

    ]);
})();

/**
 * Created by thainan.gomes on 16/08/2017.
 */
(function () {
  'use strict';

  angular.module('ticket.controller.operacao')
    .controller('ticket.controller.operacao.troca.form', [
      'appSettings',
      '$window',
      '$rootScope',
      '$timeout',
      '$scope',
      '$state',
      'common',
      '$stateParams',
      '$uibModal',
      'toaster',
      'ticket.service.programacao',
      'ticket.service.programacao.venda',
      'ticket.service.programacao.vendaingresso',
      'ticket.service.programacao.setor',
      'ticket.service.programacao.sessaoassento',
      'ticket.service.programacao.compra',
      'ticket.service.controleestabelecimento.estabelecimentoconfiguracaoestrutura',
      'ticket.service.programacao.sessaosetor',
      'ticket.service.controleestabelecimento.estabelecimento',
      'ticket.service.programacao.sessaosetorloteprecoingresso',
      'ngDialog',
      'GuidEmpty',
      '$filter',
      'orderByFilter',
      function (appSettings, $window, $rootScope, $timeout,$scope, $state, common, $stateParams,
                $uibModal,toaster , sessaoSvc, vendaSvc, vendaIngressoSvc, setorSvc,
                sessaoassentoSvc, compraSvc, estabconfestruturaSvc, sessaosetorSvc, estabelecimentoSvc,
                sessaoetorloteprecoingressoSvc, ngDialog, GuidEmpty, $filter, orderByFilter) {
        var vm = common.controller.basic(this, vendaSvc);


        vm.showSessao = false;
        vm.showVendas = false;
        vm.showSetor = false;
        vm.showMapa = false;
        vm.Filter = {};
        vm.item = {};
        vm.historicos = [];
        vm.listVendaIngressoNovo = [];
        vm.countAssentoSelect = [];
        vm.QtdTipoIngresso = "";
        vm.loading = false;

        if ($stateParams.CodRastreio != null) {

          vm.item.CodRastreio =  $stateParams.CodRastreio;
          vm.Filter.CodRastreio = $stateParams.CodRastreio;

          vendaSvc.rastreio({
            Config: {
              Skip: 0,
              Top: 20
            },
            Filter: vm.Filter
          }).then(function (venda) {
            vm.venda = venda[0];
          });

          vendaIngressoSvc.listvendaingressotroca(vm.Filter).then(function (vendaIngressos) {

            var indexedTeams = [];
            vm.qtdTipoIngresso = "";


            vendaIngressos.map(function(itm) {
              var teamIsNew = indexedTeams.indexOf(itm.IdEstabelecimentoIngresso) == -1;
              if (teamIsNew) {
                indexedTeams.push(itm.IdEstabelecimentoIngresso);
              }
            });

            var qtdList = indexedTeams.length;

            indexedTeams.map(function (itm, index) {
              var items = $filter('filter')(vendaIngressos, {'IdEstabelecimentoIngresso':itm});

              if((index+1) == qtdList){
                vm.QtdTipoIngresso += items.length + " " + items[0].Ingresso + "(s)";
              }else {
                vm.QtdTipoIngresso += items.length + " " + items[0].Ingresso + "(s), ";
              }
            });


            vendaIngressos.map(function(item){
              var vendaIngressoNovo = {};

              vendaIngressoNovo.Rotulo = item.Rotulo;
              vendaIngressoNovo.Ingresso = item.Ingresso;
              vendaIngressoNovo.ValorBruto = item.ValorBruto.toFixed(2);

              vendaIngressoNovo.IdVendaIngresso = item.IdVendaIngresso;
              vendaIngressoNovo.IdSessaoAssento = item.IdSessaoAssento;

              //SESSAO
              vendaIngressoNovo.IdSessao = item.IdSessao;
              vendaIngressoNovo.IdSessaoNovo = null;

              //SESSAOSETOR
              vendaIngressoNovo.IdSessaoSetor = item.IdSessaoSetor;
              vendaIngressoNovo.IdSessaoSetorNovo = null;

              //SESSAOLOTE
              vendaIngressoNovo.IdSessaoLote = item.IdSessaoLote;
              vendaIngressoNovo.IdSessaoLoteNovo = null;

              //ASSENTO

              vendaIngressoNovo.IdAssento = item.IdAssento;
              vendaIngressoNovo.IdAssentoNovo = null;
              //vendaIngressoNovo.Rotulo = item.Rotulo;
              //vendaIngressoNovo.RotuloNovo = null;

              //SESSAOSETORLOTEPRECOINGRESSO

              vendaIngressoNovo.IdSessaoSetorLotePrecoIngresso  = item.IdSessaoSetorLotePrecoIngresso;
              vendaIngressoNovo.IdSessaoSetorLotePrecoIngressoNovo = null;
              //vendaIngressoNovo.ValorBruto = item.ValorBruto;
              //vendaIngressoNovo.ValorBrutoNovo = null;
              //vendaIngressoNovo.Ingresso = item.Ingresso;
              //vendaIngressoNovo.IngressoNovo = null;

              vm.listVendaIngressoNovo.push(vendaIngressoNovo);
            });
          });
      }
      else
        $state.go('operacao.venda.grid');


       vm.save = function () {

         vm.loading = true;

         var valorTotal = 0;

         vm.listVendaIngressoNovo.forEach(function (item) {
           var objIngressoNovo = $filter('filter')(vm.sessaoSetorLotePrecoIngressoList, {'IdSessaoSetorLotePrecoIngresso':item.IdSessaoSetorLotePrecoIngressoNovo});

           valorTotal = valorTotal + objIngressoNovo[0].Valor;

           item.IdSessaoSetorNovo = vm.item.IdSessaoSetor;
           item.IdSessaoNovo = vm.item.IdSessao;
           item.IdSessaoLoteNovo = vm.item.IdSessaoLote;
         });

         valorTotal = valorTotal.toFixed(2);
         var valorBruto = vm.venda.ValorBruto.toFixed(2);

         if(valorTotal !== valorBruto) {
           vm.loading = false;
           return vm.utils.ShowWarning("Valor total inválido", "O valor total da troca precisa ser igual ao valor da venda");
         }

         vendaSvc.posttroca(vm.listVendaIngressoNovo).then(function () {
           vm.utils.ShowSuccess("Troca de assentos", "Operação realizada com sucesso!");
           $state.go('operacao.venda.grid');
         }).finally(function () {
           vm.loading = false;
         });
       };

        vm.cancel = function () {
          $state.go('operacao.venda.grid');
        };

        var currSVG = null;
        vm.svgloaded = function (svg) {
          currSVG = svg;
          loadSVG(svg);
        };

        vm.limpaIngresso = function () {
          if(vm.AssentosMapa)
            vm.AssentosMapa = [];
        };

        vm.limpaTipoIngresso = function () {
          if(vm.sessaoSetorLotePrecoIngressoList)
            vm.sessaoSetorLotePrecoIngressoList = [];
        };

        vm.troca = function () {
          vm.item.IdEstabelecimento = vm.venda.IdEstabelecimento;

          sessaoSvc.listTrocaSessao({IdAtracao: vm.venda.IdAtracao}).then(function(list) {
            vm.sessaoList = list;
            vm.showSessao = true;
          });

          estabconfestruturaSvc.get({IdEstabelecimento: vm.venda.IdEstabelecimento}).then(function (itm) {
            vm.estabconfestrutura = itm;

            if(!itm.PossuiSetor)
              vm.showMapa = true;
          });
        };

        $scope.$watch('vm.item.IdSessao', function() {
          if(vm.item.IdSessao) {
            vm.trataSetor();

            vm.Filter = {
              IdSessao : vm.item.IdSessao
            };

            vendaSvc.lote(vm.Filter).then(function(lotes) {
              vm.lotes = lotes;
            });
          }
        });

        vm.trataSetor = function () {
          sessaosetorSvc.list({IdSessao: vm.item.IdSessao}).then(function(list) {
            vm.sessaoSetorList = list;

            if(vm.estabconfestrutura.PossuiSetor){
              vm.showSetor = true;
            }else {
              vm.showSetor = false;
              vm.item.IdSessaoSetor = vm.sessaoSetorList[0].IdSessaoSetor;
            }
          });
        };

        $scope.$watch('vm.item.IdSessaoSetor', function() {
          if(vm.item.IdSessaoSetor){

            if(!vm.item.IdSessaoLote)
              vm.limpaTipoIngresso();

            vm.carregaMapa()
          }
        },true);


        $scope.$watch('vm.item.IdSessaoLote', function() {
          if(vm.item.IdSessaoLote){
            sessaoetorloteprecoingressoSvc.listtroca({IdSessaoSetor: vm.item.IdSessaoSetor, IdSessaoLote: vm.item.IdSessaoLote}).then(function(list) {
              vm.sessaoSetorLotePrecoIngressoList = list;
            });
          }else{
            vm.limpaTipoIngresso();
          }
        },true);


		var oldMap = {IdSetor: null, IdEstabelecimento: null};

        vm.loadingSvg = false;

        vm.carregaMapa = function () {
          vm.loadingSvg = true;
          var sessaoSetor = $filter('filter')(vm.sessaoSetorList, {'IdSessaoSetor':vm.item.IdSessaoSetor});

          if( oldMap.IdSetor == sessaoSetor[0].IdSetor && oldMap.IdEstabelecimento == vm.item.IdEstabelecimento )
          {
            recarregaAssentos();
          }
          else
          {
            setorSvc.getSvg({ Id: sessaoSetor[0].IdSetor, IdEstabelecimento: vm.item.IdEstabelecimento }).then(function (mapsvg) {
              oldMap.IdSetor           = sessaoSetor[0].IdSetor;
              oldMap.IdEstabelecimento = vm.item.IdEstabelecimento;
              vm.mapaSvg = mapsvg;
            }).finally(function(){
              vm.loadingSvg = false;
            });
          }
        };

		function recarregaAssentos()
        {
          sessaoassentoSvc.list({IdSessaoSetor: vm.item.IdSessaoSetor}).then(function (assentos) {

            // vm.AssentosMapa = assentos.filter(function (itm) {
            //   return itm.IdTipoAssentoOcupacao == 0;
            // });

            vm.AssentosMapa = orderByFilter(assentos, 'Rotulo');

            var status = null;

            if (assentos.length > 0) {

              var i = 0;
              for (i; i < assentos.length; i++) {
                var ass = assentos[i];

                if (ass.IdTipoAssentoOcupacao == 1)//VENDIDO
                {
                  selecionar(status, ass.IdSessaoAssento, ass.IdAssento, false, true, '#CCCCCC');
                }
                else if (ass.IdTipoAssentoOcupacao == 2) //RESERVADO
                {
                  selecionar(status, ass.IdSessaoAssento, ass.IdAssento, false, true, '#CCCCCC');
                }
                else if (ass.IdTipoAssentoOcupacao == 3) //BLOQUEADO
                {
                  selecionar(status, ass.IdSessaoAssento, ass.IdAssento, false, true, '#CCCCCC');
                }
                else if (ass.IdTipoAssentoOcupacao == 4) //SELECIONADO
                {
                  if (ass.IdUsuario == appSettings.id) {
                    selecionar(status, ass.IdSessaoAssento, ass.IdAssento, true, false, "#FF8b23");
                    vm.assentosSelecionados.push(
                      {
                        IdSessaoAssento: ass.IdSessaoAssento,
                        IdAssento: ass.IdAssento
                      });
                  }
                  else
                    selecionar(status, ass.IdSessaoAssento, ass.IdAssento, false, true, '#CCCCCC');

                }
                else {
                  selecionar(status, ass.IdSessaoAssento, ass.IdAssento, true, false, "#0085A4");
                }
              }
            }
          }).finally(function () {
            vm.loadingSvg = false;
          });
        }


        function loadSVG(svg) {
          window.we = {
            SetorLoaded: function () {
              recarregaAssentos();
            }
          }
          svg[0].dispatchEvent(new Event('load'));
        }
      }
    ])
})();

/**
 * Created by thainan.gomes on 17/08/2017.
 */
/**
 * Created by thainan.gomes on 16/08/2017.
 */
(function () {
  'use strict';

angular
  .module('ticket.controller.operacao')
  .controller('ticket.controller.operacao.troca', [
    '$scope', 'common', 'ticket.service.programacao',
    function ($scope, common, programacaoSvc) {
    var vm = common.controller.master(this, programacaoSvc, $scope);
  }])

})();

/**
 * Created by thainan.gomes on 16/08/2017.
 */
(function () {
  'use strict';

  angular.module('ticket.controller.operacao')
    .controller('ticket.controller.operacao.cancelamento.form', [
      'appSettings',
      '$window',
      '$rootScope',
      '$timeout',
      '$scope',
      '$state',
      'common',
      '$stateParams',
      '$uibModal',
      'toaster',
      'ticket.service.programacao.venda',
      'ticket.service.programacao.vendasite',
      'ticket.service.programacao.vendaingresso',
      'ngDialog',
      'GuidEmpty',
      '$filter',
      'orderByFilter',
      function (appSettings, $window, $rootScope, $timeout,$scope, $state, common, $stateParams,
                $uibModal,toaster, vendaSvc, vendaSiteSvc, vendaIngressoSvc,
                ngDialog, GuidEmpty, $filter, orderByFilter) {
        var vm = common.controller.basic(this, vendaSvc);

        vm.Filter = {};
        vm.item = {};
        vm.historicos = [];
        vm.QtdTipoIngresso = "";
        vm.loading = false;

        // vm.item.CodRastreio = $stateParams.CodRastreio;
        // vm.Filter.CodRastreio = vm.item.CodRastreio;

        if ($stateParams.CodRastreio != null) {

          vm.item.CodRastreio =  $stateParams.CodRastreio;
          vm.Filter.CodRastreio = $stateParams.CodRastreio;

          vendaSvc.rastreio({
            Config: {
              Skip: 0,
              Top: 20
            },
            Filter: vm.Filter
          }).then(function (venda) {
              vm.venda = venda[0];
          });

          vendaIngressoSvc.listvendaingressotroca(vm.Filter).then(function (vendaIngressos) {

            var indexedTeams = [];
            vm.qtdTipoIngresso = "";


            vendaIngressos.map(function(itm) {
              var teamIsNew = indexedTeams.indexOf(itm.IdEstabelecimentoIngresso) == -1;
                if (teamIsNew) {
                  indexedTeams.push(itm.IdEstabelecimentoIngresso);
              }
            });

            var qtdList = indexedTeams.length;

            indexedTeams.map(function (itm, index) {
              var items = $filter('filter')(vendaIngressos, {'IdEstabelecimentoIngresso':itm});

              if((index+1) == qtdList){
                vm.QtdTipoIngresso += items.length + " " + items[0].Ingresso + "(s)";
              }else {
                vm.QtdTipoIngresso += items.length + " " + items[0].Ingresso + "(s), ";
              }
            });
          });
        }
        else
          $state.go('operacao.venda.grid');


        vm.cancel = function () {
          $state.go('operacao.venda.grid');
        };

        vm.save = function (completo) {
          vm.loading = true;

          vendaSiteSvc.cancelar({IdVenda: vm.venda.IdVenda, DevolveCompleto: completo}).then(function () {
            vm.utils.ShowSuccess("Cancelamento de Venda", "Operação realizada com sucesso!");
            $state.go('operacao.venda.grid');
          }).finally(function () {
            vm.loading = false;
          });
        };
      }
    ])
})();

/**
 * Created by thainan.gomes on 16/08/2017.
 */
(function () {
  'use strict';

angular
  .module('ticket.controller.operacao')
  .controller('ticket.controller.operacao.cancelamento', [
    '$scope', 'common', 'ticket.service.programacao',
    function ($scope, common, programacaoSvc) {
    var vm = common.controller.master(this, programacaoSvc, $scope);
  }])

})();

/**
 * Created by thainan.gomes on 28/08/2017.
 */
(function () {
  'use strict';

  angular
    .module('ticket.controller.operacao')
    .controller('ticket.controller.operacao.vendasite.grid', [
      '$state',
      '$scope',
      '$filter',
      'common',
      'orderByFilter',
      '$stateParams',
      'ticket.service.venda.vendasite',
      'ticket.service.controleestabelecimento.estabelecimento',
      'ticket.service.conteudo.atracao',
      'ticket.service.conteudo.sessao',
      function ($state, $scope,$filter, common, orderByFilter, $stateParams, vendaSiteSvc, estabelecimentoSvc, atracaoSvc, sessaoSvc) {
        var vm = common.controller.grid(this, vendaSiteSvc);
        //
        // if($stateParams.Filter)
        //   vm.Filter = $stateParams.Filter;

        if($stateParams.Filter) {
          vm.Filter = {
            IdEstabelecimento : $stateParams.Filter.IdEstabelecimento,
            IdAtracao : vm.Filter.IdAtracao? parseInt(vm.Filter.IdAtracao): '',
            DataVendaInicio:$stateParams.Filter.DataVendaInicio,
            DataVendaFim:$stateParams.Filter.DataVendaFim,
            IdTipoStatusPagamento :$stateParams.Filter.IdTipoStatusPagamento
          }
        }


        setTimeout(function () {
          $scope.$watch('vm.Filter.IdAtracao', function () {
            if(vm.Filter.IdAtracao) {
              // sessaoSvc.list({IdAtracao: vm.Filter.IdAtracao}).then(function (data) {
              //
              //   vm.lstSessao = data.map(function (itm) {
              //     return {
              //       Id: itm.Id,
              //       DataContabil: $filter('date')(itm.DataContabil, 'dd/MM/yyyy') + ' ' + $filter('date')(itm.DataHoraInicio, 'HH:mm')
              //     }
              //   })
              // })

            sessaoSvc.getAll({
              Config: {
                Skip: 0,
                Top: 100
              },
              Filter: vm.Filter
            }).then(function (data) {

              vm.lstSessao = data.map(function (itm) {
                return {
                  Id : itm.Id,
                  DataContabil :$filter('date')(itm.DataContabil, 'dd/MM/yyyy') + ' ' + $filter('date')(itm.DataHoraInicio, 'HH:mm')
                }
              })

              //vm.lstSessao = $filter('orderBy', 'DataContabil')(vm.lstSessao)
;              });
            }
          }, 1000)
        });

        estabelecimentoSvc.listgestao({}).then(function (list) { vm.estabelecimentoList = list; });

        vm.lstStatus = [];

        vm.lstStatus.push({IdTipoStatusPagamento : 1 , Nome : 'Aprovado'})
        vm.lstStatus.push({IdTipoStatusPagamento : 2 , Nome : 'Cancelada'})
        vm.lstStatus.push({IdTipoStatusPagamento : 3 , Nome : 'Reprovada'})
        vm.lstStatus.push({IdTipoStatusPagamento : 4 , Nome : 'Em análise'})
        vm.lstStatus.push({IdTipoStatusPagamento : 5 , Nome : 'Devolvido'})


        $scope.$watch('vm.Filter.IdEstabelecimento', function() {
          if(vm.Filter.IdEstabelecimento){

            if(vm.Filter.IdAtracao)
                vm.Filter.IdAtracao = null;

            if($stateParams.Filter)
              vm.Filter.IdAtracao = vm.Filter.IdAtracao? parseInt(vm.Filter.IdAtracao): '';

            atracaoSvc.listConveniencia({IdEstabelecimento: vm.Filter.IdEstabelecimento}).then(function (list) {
              if(list.length > 0) {
                vm.atracaoList = orderByFilter(list, 'Nome');
              }
              else
                vm.atracaoList = null;

            });
          }else{
            vm.atracaoList = null;
          }
        }, true);

        vm.search = function (inScroll) {

          if(!vm.Filter.IdEstabelecimento) {
            vm.Filter.IdAtracao = null;
          }

          if (vm.searching) return;
          vm.searching = true;

          if (!inScroll) {
            vm.page = 0;
            vm.complete = false;
            vm.items = [];
          }

          vendaSiteSvc.getAll({
          Config: {
            Skip: vm.page,
              Top: 20
          },
          Filter: vm.Filter
        }).then(function (vendas) {
            vm.items = vm.items.concat(vendas);

            if (vendas.length < 20)
              vm.complete = true;

            if (vendas.length > 0)
              vm.page += 1;

            vm.searching = false;

        })}
        /*
        vm.search = function(inScroll) {

          vm.searching = true;

          if (!inScroll) {
            vm.page = 0;
            vm.complete = false;
            vm.items = [];
          }

          vm.QueryFilter.Config = { Skip: vm.page, Top: pageSize };
          vm.QueryFilter.Filter = vm.Filter;

          vendaSiteSvc.listOperacao(vm.QueryFilter)
            .then(function(data) {
              vm.items = vm.items.concat(data);

              if (data.length < pageSize)
                vm.complete = true;

              if (data.length > 0) {
                vm.page += 1;
              }

            }).finally(function() {
            vm.searching = false;
          });
        };
      */
        vm.detalhe = function (item) {
          $state.go('operacao.vendasite.form', {Id : item.IdVenda, Filter : vm.Filter})
        }
      }])

})();

/**
 * Created by thainan.gomes on 29/08/2017.
 */
(function () {
  'use strict';

  angular
    .module('ticket.controller.operacao')
    .controller('ticket.controller.operacao.vendasite.form', [
      '$state',
      '$stateParams',
      '$filter',
      'common',
      'ticket.service.venda.vendasite',
      'ticket.service.programacao.vendaingresso',
      function ($state, $stateParams, $filter, common, vendaSiteSvc, vendaIngressoSvc) {
        var vm = common.controller.basic(this);

        vm.QtdTipoIngresso = "";

          if ($stateParams.Id != null) {

            vendaSiteSvc.getOperacao({IdVenda: $stateParams.Id}).then(function (data) {
              vm.item = data;
              vm.item.Assentos = vm.item.Assentos.substring(0,vm.item.Assentos.lastIndexOf(','))
            }).finally(function () {
              vm.searching = false;
            });

            vendaIngressoSvc.listvendaingressotroca({IdVenda: $stateParams.Id}).then(function (vendaIngressos) {

              var indexedTeams = [];
              vm.qtdTipoIngresso = "";

              vendaIngressos.map(function (itm) {
                var teamIsNew = indexedTeams.indexOf(itm.IdEstabelecimentoIngresso) == -1;
                if (teamIsNew) {
                  indexedTeams.push(itm.IdEstabelecimentoIngresso);
                }
              });

              var qtdList = indexedTeams.length;

              indexedTeams.map(function (itm, index) {
                var items = $filter('filter')(vendaIngressos, {'IdEstabelecimentoIngresso': itm});

                if ((index + 1) == qtdList) {
                  vm.QtdTipoIngresso += items.length + " " + items[0].Ingresso + "(s)";
                } else {
                  vm.QtdTipoIngresso += items.length + " " + items[0].Ingresso + "(s), ";
                }
              });
            });
          }

          vm.cancel = function () {
            $state.go('operacao.vendasite.grid', {Filter : $stateParams.Filter})
          }
      }])
})();

/**
 * Created by thainan.gomes on 28/08/2017.
 */
(function () {
  'use strict';

  angular
    .module('ticket.controller.operacao')
    .controller('ticket.controller.operacao.vendasite', [
      '$scope', 'common', 'ticket.service.operacao.vendasite',
      function ($scope, common, vendaSiteSvc) {
        var vm = common.controller.master(this, vendaSiteSvc, $scope);
      }])

})();


/**
 * Created by thainan.gomes on 28/08/2017.
 */
(function () {
  'use strict';

  angular
    .module('ticket.controller.operacao')
    .controller('ticket.controller.operacao.vendapagamentofilafraude.grid', [
      '$state',
      '$scope',
      'common',
      '$stateParams',
      'ticket.service.controleestabelecimento.estabelecimento',
      'ticket.service.operacao.vendapagamentofilafraude',
      'ticket.service.conteudo.atracao',
      function ($state, $scope,common, $stateParams, estabelecimentoSvc, vendapagamentofilafraudeSvc, atracaoSvc) {
        var vm = common.controller.grid(this, vendapagamentofilafraudeSvc);

        if($stateParams.Filter) {
          vm.Filter = $stateParams.Filter;
        }

        estabelecimentoSvc.listgestao({}).then(function (list) { vm.estabelecimentoList = list; });

        $scope.$watch('vm.Filter.IdEstabelecimento', function() {

          vm.Filter.IdAtracao = null;

          if(vm.Filter.IdEstabelecimento){

            atracaoSvc.list({IdEstabelecimento: vm.Filter.IdEstabelecimento}).then(function (list) {
                vm.atracaoList = list;
            });
          }
        }, true);

        vm.detalhe = function (item) {
          $state.go('operacao.vendapagamentofilafraude.form', {IdVendaPagamento : item.IdVendaPagamento, Filter : vm.Filter})
        }

      }])

})();

/**
 * Created by thainan.gomes on 29/08/2017.
 */
(function () {
  'use strict';

  angular
    .module('ticket.controller.operacao')
    .controller('ticket.controller.operacao.vendapagamentofilafraude.form', [
      '$state',
      '$stateParams',
      '$filter',
      'common',
      'toaster',
      'ticket.service.operacao.vendapagamentofilafraude',
      function ($state, $stateParams, $filter, common,toaster, vendapagamentofilafraudeSvc) {
        var vm = common.controller.basic(this);

        if($stateParams) {
          vendapagamentofilafraudeSvc.getValidar({IdVendaPagamento: $stateParams.IdVendaPagamento}).then(function (data) {
            vm.item = data;
          });
        }
        else{
          back();
        }

          vm.cancel = function () {
            back();
          }

          function back() {
            $state.go('operacao.vendapagamentofilafraude.grid', {Filter : $stateParams.Filter})
          }

        vm.AprovarReprovar = function (tipo) {
          vm.loading = true;
          vm.item["Aprovar"] = tipo;
          vendapagamentofilafraudeSvc.aprovarreprovar(vm.item).then(function () {

            if(tipo)
              toaster.pop('success', 'Aprovação', "Venda aprovada com sucesso!");
            else
              toaster.pop('success', 'Reprovação', "Venda reprovada com sucesso!");

            $state.go('operacao.vendapagamentofilafraude.grid');

          }, function () {
            vm.loading = false;
          });
        }

      }])
})();

/**
 * Created by thainan.gomes on 28/08/2017.
 */
(function () {
  'use strict';

  angular
    .module('ticket.controller.operacao')
    .controller('ticket.controller.operacao.vendapagamentofilafraude', [
      '$scope', 'common',
      function ($scope, common) {
        var vm = common.controller.master(this);
      }])

})();


/**
 * Created by thainan.gomes on 16/08/2017.
 */
(function () {
  'use strict';

  angular.module('ticket.controller.operacao')
    .controller('ticket.controller.operacao.venda.grid', [
      'common',
      '$state',
      '$scope',
      '$stateParams',
      'ticket.service.programacao.venda',
      'ticket.service.controleestabelecimento.estabelecimento',
      function (common,$state, $scope,$stateParams, vendaSvc, estabelecimentoSvc) {
        var vm = common.controller.grid(this);

        if($stateParams.Filter)
          vm.Filter = $stateParams.Filter;

        vm.CountAtracao = 0;
        vm.page = 0;
        vm.complete = false;
        vm.items = [];
        var pageSize = 20;
        vm.searching = false;
        vm.estabDisabled = true;

        estabelecimentoSvc.listgestao({}).then(function (list) {
          vm.estabelecimentoList = list;
        });

        $scope.$watch('vm.Filter', function() {
          if(!vm.Filter || !vm.Filter.CodRastreio && !vm.Filter.CPF && !vm.Filter.Login && !vm.Filter.Nome && !vm.Filter.SobreNome){
            vm.estabDisabled = true;
          }else {
            vm.estabDisabled = false;
          }
        },true);

        // !vm.Filter || !vm.Filter.CodRastreio
        // && vm.Filter.CPF && vm.Filter.Login && vm.Filter.Nome && vm.Filter.SobreNome

        vm.search = function (inScroll) {

          if(!vm.Filter || !vm.Filter.CodRastreio && !vm.Filter.CPF && !vm.Filter.Login
            && !vm.Filter.Nome && !vm.Filter.SobreNome  && !vm.Filter.IdEstabelecimento) {

            if(inScroll)
              return;
            else
              return vm.utils.ShowWarning("Nenhum filtro preenchido", "Preencha pelo menos um filtro!");

          }

          if (vm.searching) return;
          vm.searching = true;

          if (!inScroll) {
            vm.page = 0;
            vm.complete = false;
            vm.items = [];
          }


          // vm.Filter && vm.Filter.CodRastreio || vm.Filter.IdEstabelecimento
          // || vm.Filter.CPF || vm.Filter.Login || vm.Filter.Nome || vm.Filter.SobreNome
          //
          //
          // if(!vm.Filter || !vm.Filter.CodRastreio && !vm.Filter.IdEstabelecimento
          //   && !vm.Filter.CPF && !vm.Filter.Login && !vm.Filter.Nome && !vm.Filter.SobreNome) {
          //   vm.searching = false;
          //   return vm.utils.ShowWarning("Nenhum filtro preenchido", "Preencha pelo menos um filtro!");
          // }
          //
          // if(vm.Filter.IdEstabelecimento && !vm.Filter.CodRastreio
          //   && !vm.Filter.CPF && !vm.Filter.Login && !vm.Filter.Nome && !vm.Filter.SobreNome) {
          //   vm.searching = false;
          //   return vm.utils.ShowWarning("Nenhum filtro preenchido", "Preencha pelo menos um filtro!");
          // }

          vendaSvc.rastreio({
            Config: {
              Skip: vm.page,
              Top: pageSize
            },
            Filter: vm.Filter
          }).then(function(vendas) {
            //vm.items = vendas;
            vm.items = vm.items.concat(vendas);

            if (vendas.length < pageSize)
              vm.complete = true;

            if (vendas.length > 0)
              vm.page += 1;

            vm.searching = false;
          });
        };

        vm.trocasessao = function (item) {

          if(!item.PermiteTroca)
            vm.utils.Confirm("Troca de Sessão", "Já foi ultrapassado o prazo de 24 hs antes do início da sessão para a troca. Deseja prosseguir? ").then(function() {
              $state.go('operacao.troca.form', {CodRastreio: item.CodRastreio})
            });
          else
            $state.go('operacao.troca.form', {CodRastreio: item.CodRastreio})
        };

        vm.cancelamento = function (item) {

          if(!item.PermiteCancelamento)
            vm.utils.Confirm("Cancelamento de Sessão", "Já foi ultrapassado o prazo de 24 hs antes do início da sessão para a efetuar o cancelamento. Deseja prosseguir? ").then(function() {

              $state.go('operacao.cancelamento.form', {CodRastreio : item.CodRastreio})
            });
          else
            $state.go('operacao.cancelamento.form', {CodRastreio : item.CodRastreio})
        };

        vm.detalhe = function (item) {
          $state.go('operacao.venda.form', {CodRastreio : item.CodRastreio, Filter : vm.Filter})
        };

        vm.limparFiltro = function () {
          vm.Filter = {};
        }
      }
    ])
})();

/**
 * Created by thainan.gomes on 16/08/2017.
 */
(function () {
  'use strict';

  angular.module('ticket.controller.operacao')
    .controller('ticket.controller.operacao.venda.form', [
      'appSettings',
      '$window',
      '$rootScope',
      '$timeout',
      '$scope',
      '$state',
      'common',
      '$stateParams',
      '$uibModal',
      'toaster',
      'ticket.service.programacao.venda',
      'ticket.service.programacao.vendaingresso',
      'ngDialog',
      'GuidEmpty',
      '$filter',
      'orderByFilter',
      function (appSettings, $window, $rootScope, $timeout,$scope, $state, common, $stateParams,
                $uibModal,toaster, vendaSvc, vendaIngressoSvc,
                ngDialog, GuidEmpty, $filter, orderByFilter) {
        var vm = common.controller.basic(this, vendaSvc);


        vm.Filter = {};
        vm.item = {};
        vm.historicos = [];
        vm.QtdTipoIngresso = "";
        vm.loading = false;

        vm.item.CodRastreio = $stateParams.CodRastreio;
        vm.Filter.CodRastreio = vm.item.CodRastreio;

        if ($stateParams.CodRastreio != null) {

          vm.item.CodRastreio =  $stateParams.CodRastreio;
          vm.Filter.CodRastreio = $stateParams.CodRastreio;

          vendaSvc.rastreio({
            Config: {
              Skip: 0,
              Top: 20
            },
            Filter: vm.Filter
          }).then(function (venda) {
            vm.venda = venda[0];
          });

          vendaIngressoSvc.listvendaingressotroca(vm.Filter).then(function (vendaIngressos) {

            var indexedTeams = [];
            vm.qtdTipoIngresso = "";

            vendaIngressos.map(function(itm) {
              var teamIsNew = indexedTeams.indexOf(itm.IdEstabelecimentoIngresso) == -1;
              if (teamIsNew) {
                indexedTeams.push(itm.IdEstabelecimentoIngresso);
              }
            });

            var qtdList = indexedTeams.length;

            indexedTeams.map(function (itm, index) {
              var items = $filter('filter')(vendaIngressos, {'IdEstabelecimentoIngresso':itm});

              if((index+1) == qtdList){
                vm.QtdTipoIngresso += items.length + " " + items[0].Ingresso + "(s)";
              }else {
                vm.QtdTipoIngresso += items.length + " " + items[0].Ingresso + "(s), ";
              }
            });
          });
        }
        else
          $state.go('programacao.venda.grid');

        vm.cancel = function () {
          $state.go('operacao.venda.grid',{Filter : $stateParams.Filter});
        };
      }
    ])
})();

/**
 * Created by thainan.gomes on 17/08/2017.
 */
/**
 * Created by thainan.gomes on 16/08/2017.
 */
(function () {
  'use strict';

angular
  .module('ticket.controller.operacao')
  .controller('ticket.controller.operacao.venda', [
    '$scope', 'common', 'ticket.service.programacao',
    function ($scope, common, programacaoSvc) {
    var vm = common.controller.master(this, programacaoSvc, $scope);
  }])

})();

(function() {
  'use strict';

  angular
    .module('ticket.controller.estabelecimento', []);
})();
(function() {
  'use strict';
  angular.module('ticket.controller.estabelecimento')
    .config(routeConfig);

  routeConfig.$inject = ['$stateProvider'];

  function routeConfig($stateProvider) {
    $stateProvider
      .state('estabelecimento.formapagamento', {
        abstract: true,
        url: '/controleformapagamento',
        parent: 'estabelecimento',
        templateUrl: "view/estabelecimento/controleformapagamento/index.html"
      })
      .state('estabelecimento.formapagamento.grid', {
        url: '/consulta',
        parent: 'estabelecimento.formapagamento',
        data: {
          displayName: 'Formas Pagamento'
        },
        templateUrl: 'view/estabelecimento/controleformapagamento/grid.html',
        controller: 'ticket.controller.estabelecimento.formapagamento.grid',
        controllerAs: 'vm'
      })

    .state('estabelecimento.formapagamento.form', {
      url: '/form/:IdEstabelecimento',
      params: {
        IdEstabelecimento: null
      },
      parent: 'estabelecimento.formapagamento',
      data: {
        displayName: 'Associar Formas Pagamento'
      },
      templateUrl: 'view/estabelecimento/controleformapagamento/form.html',
      controller: 'ticket.controller.estabelecimento.formapagamento.form',
      controllerAs: 'vm'
    });
  }

})();

(function() {
  'use strict';
  angular.module('ticket.controller.estabelecimento')
    .config(routeConfig);

  routeConfig.$inject = ['$stateProvider'];

  function routeConfig($stateProvider) {
    $stateProvider
      .state('estabelecimento.convenienciaestabelecimento', {
        abstract: true,
        url: '/convenienciaestabelecimento',
        parent: 'estabelecimento',
        templateUrl: "view/estabelecimento/convenienciaestabelecimento/index.html"
      })
      .state('estabelecimento.convenienciaestabelecimento.grid', {
        url: '/consulta',
        parent: 'estabelecimento.convenienciaestabelecimento',
        data: {
          displayName: 'Conveniencias'
        },
        templateUrl: 'view/estabelecimento/convenienciaestabelecimento/grid.html',
        controller: 'ticket.controller.estabelecimento.convenienciaestabelecimento.grid',
        controllerAs: 'vm'
      })

    .state('estabelecimento.convenienciaestabelecimento.form', {
      url: '/form/',
      params: {

      },
      parent: 'estabelecimento.convenienciaestabelecimento',
      data: {
        displayName: 'Adicionar Conveniencias'
      },
      templateUrl: 'view/estabelecimento/convenienciaestabelecimento/form.html',
      controller: 'ticket.controller.estabelecimento.convenienciaestabelecimento.form',
      controllerAs: 'vm'
    });
  }

})();

(function() {
  'use strict';

  angular
    .module('ticket.controller.controleingresso', []);
})();
(function() {
  'use strict';
  angular.module('ticket.controller.controleingresso')
    .config(routeConfig);

  routeConfig.$inject = ['$stateProvider'];

  function routeConfig($stateProvider) {
    $stateProvider
      .state('controleingresso.regraingressoestabelecimento', {
        abstract: true,
        url: '/regraingressoestabelecimento',
        parent: 'controleingresso',
        templateUrl: "view/controleingresso/regraIngressoEstabelecimento/index.html"
      })
      .state('controleingresso.regraingressoestabelecimento.grid', {
        url: '/consulta',
        parent: 'controleingresso.regraingressoestabelecimento',
        data: {
          displayName: 'Regras Ingresso Estabelecimento'
        },
        templateUrl: 'view/controleingresso/regraIngressoEstabelecimento/grid.html',
        controller: 'ticket.controller.controleingresso.regraIngressoEstabelecimento.grid',
        controllerAs: 'vm'
      })

    .state('controleingresso.regraingressoestabelecimento.form', {
      url: '/form/:IdEstabelecimento',
      params: {
        IdEstabelecimento: null
      },
      parent: 'controleingresso.regraingressoestabelecimento',
      data: {
        displayName: 'Adicionar Regra'
      },
      templateUrl: 'view/controleingresso/regraIngressoEstabelecimento/form.html',
      controller: 'ticket.controller.controleingresso.regraIngressoEstabelecimento.form',
      controllerAs: 'vm'
    });
  }


})();
(function() {
  'use strict';

  angular
    .module('ticket.controller.conteudo', [

    ]);
})();
(function() {
  'use strict';
  angular.module('ticket.controller.conteudo')
    .config(routeConfig);

  routeConfig.$inject = ['$stateProvider'];

  function routeConfig($stateProvider) {
    $stateProvider
      .state('conteudo.inadequacao', {
        abstract: true,
        url: '/inadequacao',
        parent: 'conteudo',
        templateUrl: "view/conteudo/inadequacao/index.html"
      })
      .state('conteudo.inadequacao.grid', {
        url: '/consulta',
        parent: 'conteudo.inadequacao',
        data: {
          displayName: 'Inadequação'
        },
        templateUrl: 'view/conteudo/inadequacao/grid.html',
        controller: 'ticket.controller.conteudo.inadequacao.grid',
        controllerAs: 'vm'
      })

    .state('conteudo.inadequacao.form', {
      url: '/form/:Id',
      params: {
        Id: null
      },
      parent: 'conteudo.inadequacao',
      data: {
        displayName: 'Inadequação'
      },
      templateUrl: 'view/conteudo/inadequacao/form.html',
      controller: 'ticket.controller.conteudo.inadequacao.form',
      controllerAs: 'vm'
    });
  }


})();
(function() {
  'use strict';
  angular.module('ticket.controller.conteudo')
    .config(routeConfig);

  routeConfig.$inject = ['$stateProvider'];

  function routeConfig($stateProvider) {
    $stateProvider
      .state('conteudo.genero', {
        abstract: true,
        url: '/genero',
        parent: 'conteudo',
        templateUrl: "view/conteudo/genero/index.html"
      })
      .state('conteudo.genero.grid', {
        url: '/consulta',
        parent: 'conteudo.genero',
        data: {
          displayName: 'Gênero'
        },
        templateUrl: 'view/conteudo/genero/grid.html',
        controller: 'ticket.controller.conteudo.genero.grid',
        controllerAs: 'vm'
      })

    .state('conteudo.genero.form', {
      url: '/form/:Id',
      params: {
        Id: null
      },
      resolve: {
        listTipoAtracao: listTipoAtracao
      },
      parent: 'conteudo.genero',
      data: {
        displayName: 'Gênero'
      },
      templateUrl: 'view/conteudo/genero/form.html',
      controller: 'ticket.controller.conteudo.genero.form',
      controllerAs: 'vm'
    });
  }
  listTipoAtracao.$inject = ['ticket.service.conteudo.tipoatracao'];

  function listTipoAtracao(tipoAtracaoSrv) {
    return tipoAtracaoSrv.getAll({
      Config: {}
    });
  }

})();
(function() {
  'use strict';
  angular.module('ticket.controller.conteudo')
    .config(routeConfig);

  routeConfig.$inject = ['$stateProvider'];

  function routeConfig($stateProvider) {
    $stateProvider
    //BANDA
      .state('conteudo.banda', {
        abstract: true,
        url: '/banda',
        parent: 'conteudo',
        templateUrl: "view/conteudo/banda/index.html"
      })
      .state('conteudo.banda.grid', {
        url: '/consulta',
        parent: 'conteudo.banda',
        data: {
          displayName: 'Bandas'
        },
        templateUrl: 'view/conteudo/banda/grid.html',
        controller: 'ticket.controller.conteudo.banda.grid',
        controllerAs: 'vm'
      })

    .state('conteudo.banda.form', {
        url: '/form/:IdBanda/:NumeroVersao',
        params: {
          IdBanda: null,
          NumeroVersao:null
        },
        parent: 'conteudo.banda',
        data: {
          displayName: 'Adicionar Bandas'
        },
        templateUrl: 'view/conteudo/banda/form.html',
        controller: 'ticket.controller.conteudo.banda.form',
        controllerAs: 'vm'
      })
      //FIM BANDA

  }


})();

(function() {
  'use strict';
  angular.module('ticket.controller.conteudo')
    .config(routeConfig);

  routeConfig.$inject = ['$stateProvider'];

  function routeConfig($stateProvider) {
    //Artista
    $stateProvider
    //ATRACAO
      .state('conteudo.atracao', {
        data: {
          displayName: 'Atração'
        },
        parent: 'conteudo',
        url: '/atracao',
        templateUrl: 'view/conteudo/atracao/index.html',
        controller: "ticket.controller.conteudo.atracao",
        controllerAs: 'vm'
      })
      .state('conteudo.atracao.ordenacao', {
        url: '/ordenacao',
        parent: 'conteudo.atracao',
        params: {filter: null},
        data: {
          displayName: 'Ordenar Atrações da Home(Site)'
        },
        templateUrl: 'view/conteudo/atracao/ordenacao.html',
        controller: 'ticket.controller.conteudo.atracao.ordenacao',
        controllerAs: 'vm'
      })
      .state('conteudo.atracao.grid', {
        templateUrl: 'view/conteudo/atracao/grid.html',
        url: '/:filter',
        parent: 'conteudo.atracao',
        data: {
          displayName: 'Atrações'
        },
        params: {
          items: null,
          filter: null
        },
        controller: 'ticket.controller.conteudo.atracao.grid',
        controllerAs: 'vm'
      })

      .state('conteudo.atracao.informacoesexclusivas', {
        url: '/info/:IdAtracao',
        params: {
          Id: null,
          IdEstabelecimento: null
        },
        parent: 'conteudo.atracao',
        data: {
          displayName: 'INFORMAÇÕES EXCLUSIVAS'
        },
        templateUrl: 'view/conteudo/atracao/informacoesexclusivas.html',
        controller: 'ticket.controller.conteudo.atracao.informacoesexclusivas',
        controllerAs: 'vm'
      })
      .state('conteudo.atracao.pre_cadastro', {
        url: '/pre_cadastro/:filter',
        params: {
          items: null,
          filter: null
        },
        data: {
          displayName: 'Pré cadastro'
        },
        templateUrl: 'view/conteudo/atracao/pre_cadastro.html',
        controller: 'ticket.controller.conteudo.pre_cadastro',
        controllerAs: 'vm'
      })
      .state('conteudo.atracao.wizard', {
        url: "/wizard",
        templateUrl: "view/conteudo/atracao/form_wizard.html",
        controller: 'ticket.controller.conteudo.wizard',
        controllerAs: 'vm',
        params: {
          filter: null //{ IdTipoAtracao: null, Id: null, NumeroVersao: null } -- proteção contra refresh: filter com valor default null
        },
        abstract: true,
        parent: 'conteudo.atracao',
        data: {
          displayName: 'Atração'
        },
        resolve: {
          loadPlugin: ['$ocLazyLoad', function($ocLazyLoad) {
            return $ocLazyLoad.load([{
              files: ['/css/plugins/steps/jquery.steps.css']
            }]);
          }]
        }

      })
      .state('conteudo.atracao.wizard.ficha_tecnica', {
        url: '/ficha_tecnica',
        templateUrl: 'view/conteudo/atracao/template/ficha_tecnica_tmpl.html',
        parent: 'conteudo.atracao.wizard',
        data: {
          displayName: 'Ficha Técnica'
        }
      })
      .state('conteudo.atracao.wizard.participantes', {
        url: '/participantes',
        templateUrl: 'view/conteudo/atracao/template/participantes_tmpl.html',
        //controller: 'ticket.controller.conteudo.wizard.participante',
        //controllerAs: 'vm',
        parent: 'conteudo.atracao.wizard',
        data: {
          displayName: 'Participantes'
        }
      })
      .state('conteudo.atracao.wizard.sinopse', {
        url: '/sinopse',
        templateUrl: 'view/conteudo/atracao/template/sinopse_tmpl.html',
        //controller: 'ticket.controller.conteudo.wizard.sinopse',
        //controllerAs: 'vm',
        parent: 'conteudo.atracao.wizard',
        data: {
          displayName: 'Sinopse'
        }
      })
      .state('conteudo.atracao.wizard.midia', {
        url: '/midia',
        templateUrl: 'view/conteudo/atracao/template/midia_tmpl.html',
        //controller: 'ticket.controller.conteudo.wizard.midia',
        //controllerAs: 'vm',
        parent: 'conteudo.atracao.wizard',
        data: {
          displayName: 'Midia'
        }
      })

      //FIM ATRACAO
  }


})();

(function() {
  'use strict';
  angular.module('ticket.controller.conteudo')
    .config(['$stateProvider', function ($stateProvider) {
    //Artista
    $stateProvider
      .state('conteudo.artista', {
        abstract: true,
        url: '/artista',
        parent: 'conteudo',
        templateUrl: "view/conteudo/artista/index.html"
      })
      .state('conteudo.artista.grid', {
        url: '/consulta',
        parent: 'conteudo.artista',
        data: {
          displayName: 'Artistas'
        },
        templateUrl: 'view/conteudo/artista/grid.html',
        controller: 'ticket.controller.conteudo.artista.grid',
        controllerAs: 'vm'
      })

    .state('conteudo.artista.form', {
        url: '/form/:Id/:NumeroVersao',
        params: {
          Id: null,
          NumeroVersao:null
        },
        parent: 'conteudo.artista',
        data: {
          displayName: 'Adicionar Artistas'
        },
        templateUrl: 'view/conteudo/artista/form.html',
        controller: 'ticket.controller.conteudo.artista.form',
        controllerAs: 'vm'
      })
      //Fim Artista
  }
]);

  

})();

(function() {
  'use strict';

  angular
    .module('ticket.controller.configuracao', []);
})();

(function() {
  'use strict';

  angular.module('ticket.controller.configuracao')
    .controller('ticket.controller.configuracao.filafraude.grid', [
      '$state',
      '$scope',
      'common',
      'toaster',
      'ticket.service.controleestabelecimento.convenienciaestabelecimento',
      'ticket.service.controleestabelecimento.estabelecimento',
      'ticket.service.conteudo.atracaoestabelecimentofilafraude',
      'ticket.service.controleestabelecimento.estabelecimentofilafraude',
  function(
    $state,
    $scope,
    common,
    toaster,
    convenienciaEstabelecimentoSvc,
    estabelecimentoSvc  ,
    atracaoestabelecimentofilafraudeSvc,
    estabelecimentofilafraudeSvc
  ) {

    var vm = common.controller.grid(this, estabelecimentofilafraudeSvc);

    vm.tipofilafraude = [
     {
        Nome: "Estabelecimento",
        Cod: "E"
      },
      {
        Nome: "Atração",
        Cod: "A"
      }
    ];

    estabelecimentoSvc.list({}).then(function(listData) {
      vm.estabelecimentos = listData;
    });

    vm.include = function() {
      $state.go('configuracao.filafraude.form');
    };

    vm.inativar = function (item) {

      if(item.TipoFilaFraude == 'E') {

        estabelecimentofilafraudeSvc.put(item).then(function () {
          item.Status = 2;
          toaster.pop('success', 'Inativar', "Fila Fraude inativada com sucesso!");
          $state.go('configuracao.filafraude.grid');
        })
      }
      else if(item.TipoFilaFraude == 'A') {
        atracaoestabelecimentofilafraudeSvc.put(item).then(function () {
          item.Status = 2;
          toaster.pop('success', 'Inativar', "Fila Fraude inativada com sucesso!");
          $state.go('configuracao.filafraude.grid');
        })
      }
    }
  }]);
})();

(function() {
  'use strict';

  angular.module('ticket.controller.configuracao')
    .controller('ticket.controller.configuracao.filafraude.form',[
      '$state',
      '$scope',
      'common',
      '$filter',
      '$stateParams',
      'orderByFilter',
      'toaster',
      'ticket.service.controleestabelecimento.estabelecimento',
      'ticket.service.conteudo.atracao',
      'ticket.service.configuracao.estabelecimentofilafraude',
      'ticket.service.configuracao.atracaoestabelecimentofilafraude',
  function(
    $state,
    $scope,
    common,
    $filter,
    $stateParams,
    orderByFilter,
    toaster,
    estabelecimentoSvc,
    atracaoSvc,
    estabelecimentofilafraudeSvc,
    atracaoestabelecimentofilafraudeSvc
    ) {

    var vm = common.controller.form(this, estabelecimentoSvc);

    estabelecimentoSvc.list({}).then(function(listData) {
      vm.estabelecimentos = listData;
    });

    $scope.currentDate = new Date();

    vm.tipofilafraude = [
     {
        Nome: "Estabelecimento",
        Cod: "E"
      },
      {
        Nome: "Atração",
        Cod: "A"
      }
    ];


    $scope.$watch('vm.item.Estabelecimento.IdEstabelecimento', function(newValue) {
      if(vm.item.Estabelecimento && vm.item.Estabelecimento.IdEstabelecimento)
      switch (vm.TipoFilaFraude) {
        case "A":
          atracaoSvc.listConveniencia({IdEstabelecimento: newValue}).then(function(listData) {

            listData = orderByFilter(listData, 'Nome');
            vm.atracoes = listData;
          });

          vm.item.TipoAtracao = null;
          vm.item.Atracao = null;
          break;
      }
    });

    vm.chengeTipoFilaFraude = function () {
      if(vm.item.Estabelecimento)
        vm.item.Estabelecimento.IdEstabelecimento = null;
    }

   vm.save = function() {

      vm.loading = true;

      if(vm.TipoFilaFraude == 'E')
      {
        estabelecimentofilafraudeSvc.post(
          {
            IdEstabelecimento : vm.item.Estabelecimento.IdEstabelecimento,
            DataInicio : vm.item.DataInicio,
            DataFim : vm.item.DataFim }
            ).then(function (data) {
          toaster.pop('success', 'Cadastro', "Cadastro efetuado com sucesso!");
          $state.go('configuracao.filafraude.grid');
        },function () {
          vm.loading = false;
        })
      }
      else if(vm.TipoFilaFraude == 'A')
      {
        atracaoestabelecimentofilafraudeSvc.post(
          {
            IdEstabelecimento : vm.item.Estabelecimento.IdEstabelecimento,
            IdAtracao : vm.item.Atracao.IdAtracao,
            DataInicio : vm.item.DataInicio,
            DataFim : vm.item.DataFim }
        ).then(function (data) {
          toaster.pop('success', 'Cadastro', "Cadastro efetuado com sucesso!");
          $state.go('configuracao.filafraude.grid');
        },function () {
          vm.loading = false;
        })
      }

    // convenienciaSvc.PostGenerico(convenienciaGenerica).then(function() {
    //     vm.loading = false;
    //      vm.utils.ShowSuccess("Inclusão de registro", "Operação realizada com sucesso!");
    //      $state.go('estabelecimento.convenienciaestabelecimento.grid');
    //    })
    //      .finally(function() {
    //        vm.loading = false;
    //   });
    };

  }]);
})();

(function() {
  'use strict';

  angular.module('ticket.controller.configuracao')
    .controller('ticket.controller.configuracao.cidade.master',[
      '$scope',
      'common',
      function ($scope,common){

      var vm = common.controller.master(this);

    }]);

})();

(function() {
  'use strict';

  angular.module('ticket.controller.configuracao')
    .controller('ticket.controller.configuracao.cidade.grid', ['common', 'ticket.service.controleregiao.cidade', function (common, cidadeSrv) {
    var vm = common.controller.grid(this, cidadeSrv);
    vm.add = function() {
      return false;
    };
  }]);

  
  
})();

(function() {
  'use strict';
  angular.module('ticket.controller.configuracao')

    .controller('ticket.controller.configuracao.cidade.form', ['$scope', '$state', 'common', 'ticket.service.controleregiao.cidade', 'ticket.helper.controleregiao.uf', function ($scope, $state, common, cidadeSrv, ufHelper) {
    var vm = common.controller.form(this, cidadeSrv);
    vm.cancel = function() {
      $state.go('cidade.grid');
    };

    // //Validar form
    $scope.$watch('frm.$valid', function(value) {
      $scope.validateForm = !value;
    });

    var isEditing = false;

    vm.loaded = function() {
      if (vm.item.Id !== undefined || vm.item.Id !== null)
        isEditing = true;


      if (isEditing) {
        $state.$current.data = {
          displayName: 'EDIÇÃO'
        }
      }
    };

    vm.ufList = ufHelper.ufList;

  }]);

  


})();

(function () {
  'use strict';

  angular
    .module('ticket.controller.reports', []);
})();

(function() {
  'use strict';

  angular
    .module('ticket.controller.reports')
    .controller('ticket.controller.reports.bordero',
      ["$scope", "common", "ticket.service.reports.bordero",
        function ($scope, common, borderoSvc) {
          var vm = common.controller.master(this, borderoSvc, $scope);
        }]);
})();

(function() {
  'use strict';

  angular.module('ticket.controller.reports')

    .controller('ticket.controller.reports.bordero.grid', [
      "common"
      ,'$sce'
      ,'$state'
      ,"ticket.service.reports.bordero"
      ,"ticket.service.controleestabelecimento.estabelecimento"
      ,"orderByFilter",
      function(common, $sce, $state, borderoService, estabelecimentoSvc, orderByFilter) {
        var vm = common.controller.grid(this, borderoService, estabelecimentoSvc, orderByFilter);
        vm.exibir = function (item) {
          $state.go('reports.bordero.form', {  Uri: item.Uri });
        };

        estabelecimentoSvc.list({}).then(function (data) {
          data = orderByFilter(data, 'Nome');
          vm.lstEstabelecimento = data;
        });
      }]);
})();

(function () {
  'use strict';

  angular
    .module('ticket.controller.reports')
    .controller('ticket.controller.reports.bordero.form', [
      'common'
      , '$stateParams'
      , '$sce'
      ,'$state'
      , 'ticket.service.reports.bordero'
      , function (common, $stateParams, $sce, $state, borderoSrv) {
        var vm = common.controller.basic(this, borderoSrv);
        vm.loading = true;
        var element = angular.element(document.querySelector('body'));
        vm.height = element[0].offsetHeight;
        vm.style = {
          "width" : "100%",
          "height" : vm.height / 1.4
        }

        if($stateParams.Uri == null && $stateParams.IdSessao == null)
          $state.go('reports.bordero.grid');

        if($stateParams.Uri == null && $stateParams.IdSessao) {
          borderoSrv.bordero($stateParams).then(function (data) {
            vm.pdfUrl = $sce.trustAsResourceUrl(data.Url);
            vm.loading = false;
          });
        }
        else
        {
          vm.pdfUrl = $sce.trustAsResourceUrl($stateParams.Uri);
          vm.loading = false;
        }

        vm.voltar = function () {
          $state.go('reports.bordero.grid');
        }
      }])
})();

(function() {
  'use strict';

  angular
    .module('ticket.controller.site', [

    ]);
})();
(function() {
  'use strict';

  angular
    .module('ticket.controller.site')
    .controller('ticket.controller.site.home', [function() {
      var vm = this;

    }]);


})();
(function() {
  'use strict';

  angular
    .module('ticket.controller.reports')
    .controller('ticket.controller.reports.previa',
      ["$scope", "common", "ticket.service.reports.bordero",
        function ($scope, common, borderoSvc) {
          var vm = common.controller.master(this, borderoSvc, $scope);
        }]);
})();

(function() {
  'use strict';

  angular.module('ticket.controller.reports')
    .controller('ticket.controller.reports.previa.grid', [
      "common",
      "ticket.service.reports.bordero",
      "ticket.service.controleestabelecimento.estabelecimento",
      "orderByFilter",
      function(common, borderoService, estabelecimentoSvc, orderByFilter) {
        var vm = common.controller.grid(this, borderoService, estabelecimentoSvc, orderByFilter);

        vm.Filter.Previa = true;

        estabelecimentoSvc.list({}).then(function (data) {
          data = orderByFilter(data, 'Nome');
          vm.lstEstabelecimento = data;
        });

        // vm.search = function () {
        //   vm.searching = true;
        //   borderoService.getallprevia({
        //     Config: {
        //     Skip: 0,
        //       Top: 0
        //   },
        //   Filter: {
        //     Nome: vm.Filter.Nome,
        //     Data: vm.Filter.Data
        //   }}
        //   ).then(function (data) {
        //     vm.searching = false;
        //     vm.items = data;
        //   });
        // }
      }]);
})();

(function () {
  'use strict';

  angular
    .module('ticket.controller.reports')
    .controller('ticket.controller.reports.previa.form', [
      'common'
      , '$stateParams'
      , '$sce'
      ,'$state'
      ,'$window'
      , 'ticket.service.reports.bordero'
      , function (common, $stateParams, $sce, $state,$window, borderoSrv) {

        var vm = common.controller.basic(this, borderoSrv);
        vm.loading = true;

        var element = angular.element(document.querySelector('body'));
        vm.height = element[0].offsetHeight;
        vm.style = {
          "width" : "100%",
          "height" : vm.height / 1.4
        }

        // var appWindow = angular.element($window);
        // appWindow.bind('resize', function () {
        //   var element = angular.element(document.querySelector('body'));
        //   vm.height = element[0].offsetHeight;
        //   vm.style = {
        //     "width" : "100%",
        //     "height" : vm.height / 1.5
        //   }
        // });

        borderoSrv.previa($stateParams).then(function (data) {
          vm.pdfUrl = $sce.trustAsResourceUrl(data.Url);
          vm.loading = false;
        });

        vm.voltar = function () {
          $state.go('reports.previa.grid');
        }
      }])
})();

(function() {
  'use strict';

  angular
    .module('ticket.controller.reports').controller('ticket.controller.reports.futuras-dia',
      ["$scope", "common", "ticket.service.reports.futuras",
        function ($scope, common, futurasSvc) {
          var vm = common.controller.master(this, futurasSvc, $scope);
        }]);
})();

(function () {
  'use strict';

  angular.module('ticket.controller.reports').controller('ticket.controller.reports.futuras-dia.grid', [
    "common"
    , "$state"
    , "$scope"
    , 'orderByFilter'
    , "ticket.service.reports.futuras"
    , "ticket.service.conteudo.atracao"
    , "ticket.service.controleestabelecimento.estabelecimento"
    , function (common, $state, $scope, orderByFilter, futurasSvc, atracaoSvc, estabelecimentoSvc) {

      var vm = common.controller.grid(this, futurasSvc, atracaoSvc, estabelecimentoSvc);
      vm.gerar = false;
      vm.disabled = true;
      vm.Filter.DoDia = true;

      //vm.Filter.Data  = moment(moment(new Date()).format('MM/DD/YYYY'),'MM/DD/YYYY').toDate();


      estabelecimentoSvc.list({}).then(function (data) {
        data = orderByFilter(data, 'Nome');
        vm.lstEstabelecimento = data;
      });

      $scope.$watch('vm.Filter.Data ', function () {
        if (vm.Filter.Data) {
          vm.loading = true;
          atracaoSvc.listFuturas({IdEstabelecimento: vm.Filter.IdEstabelecimento, Data: moment( vm.Filter.Data).format()}).then(function (data) {
            data = orderByFilter(data, 'Nome');
            vm.lstAtracao = data;
            vm.loading = false;
            vm.disabled = false;
          })
        }
      }, true);


      $scope.$watch('vm.Filter.IdEstabelecimento', function() {
           vm.Filter.Data = null;
           vm.Filter.IdAtracao = null;
      });


      vm.Gerar = function () {
        vm.loading = false;
        var semana = ['Domingo', 'Segunda-feira', 'Terça-feira', 'Quarta-feira', 'Quinta-feira', 'Sexta-feira', 'Sábado'];
        var mdata = moment.parseZone(vm.Filter.Data);
        var diaSemana = semana[mdata.day()];
        if (vm.Filter.DoDia || ( !vm.Filter.DoDia && diaSemana === 'Domingo')) {
          vm.gerar = true;
          vm.Filter.Data = moment( vm.Filter.Data).format();
          futurasSvc.futuras(vm.Filter).then(function (data) {
            $state.go('reports.futuras-dia.form', {Uri: data.Url});
          })
        }
        else {
          vm.utils.ShowWarning("Aviso", "Escolha um domingo!");
        }
      }

    }
  ])
  ;
})
();

(function () {
  'use strict';

  angular
    .module('ticket.controller.reports').controller('ticket.controller.reports.futuras-dia.form', [
      'common'
      , '$stateParams'
      , '$sce'
      ,'$state'
      , 'ticket.service.reports.futuras'
      , function (common, $stateParams, $sce, $state, futurasSvc) {

        var vm = common.controller.basic(this, futurasSvc);

        vm.loading = true;

        var element = angular.element(document.querySelector('body'));
        vm.height = element[0].offsetHeight;
        vm.style = {
          "width" : "100%",
          "height" : vm.height / 1.4
        }

        if(!$stateParams.Uri)
        {
          $state.go('reports.futuras-dia.grid');
        }

        if($stateParams.Uri) {
            vm.pdfUrl = $sce.trustAsResourceUrl($stateParams.Uri);
            vm.loading = false;
        }


        vm.voltar = function () {
          $state.go('reports.futuras-dia.grid');
        }
      }])
})();

(function() {
  'use strict';

  angular
    .module('ticket.controller.reports').controller('ticket.controller.reports.futuras',
      ["$scope", "common", "ticket.service.reports.futuras",
        function ($scope, common, futurasSvc) {
          var vm = common.controller.master(this, futurasSvc, $scope);
        }]);
})();

(function () {
  'use strict';

  angular.module('ticket.controller.reports').controller('ticket.controller.reports.futuras.grid', [
    "common"
    ,"$state"
    ,"orderByFilter"
    ,"ticket.service.reports.futuras"
    , "ticket.service.conteudo.atracao"
    , function (common,$state, orderByFilter, futurasSvc, atracaoSvc) {

      var vm = common.controller.grid(this, futurasSvc, atracaoSvc);
      vm.gerar = false;

      vm.Filter.Data  = moment(moment(new Date()).format('MM/DD/YYYY'),'MM/DD/YYYY').toDate();
      //vm.Filter.DataFim = moment(moment(new Date()).format('MM/DD/YYYY'),'MM/DD/YYYY').toDate()

      atracaoSvc.list({}).then(function (data) {
        data = orderByFilter(data, 'Nome');
        vm.lstAtracao = data;
      })

      vm.Gerar = function () {
        vm.gerar = true;
        futurasSvc.futuras(vm.Filter).then(function (data) {
          $state.go('reports.futuras.form', {  Uri: data.Url });
        })
      }

    }]);
})();

(function () {
  'use strict';

  angular
    .module('ticket.controller.reports').controller('ticket.controller.reports.futuras.form', [
      'common'
      , '$stateParams'
      , '$sce'
      ,'$state'
      , 'ticket.service.reports.futuras'
      , function (common, $stateParams, $sce, $state, futurasSvc) {

        var vm = common.controller.basic(this, futurasSvc);

        vm.loading = true;

        var element = angular.element(document.querySelector('body'));
        vm.height = element[0].offsetHeight;
        vm.style = {
          "width" : "100%",
          "height" : vm.height / 1.4
        }

        if(!$stateParams.Uri)
        {
          $state.go('reports.futuras.grid');
        }

        if($stateParams.Uri) {
            vm.pdfUrl = $sce.trustAsResourceUrl($stateParams.Uri);
            vm.loading = false;
        }


      vm.voltar = function () {
        $state.go('reports.futuras-dia.grid');
      }
      }])
})();

(function() {
  'use strict';

  angular
    .module('ticket.controller.reports')
    .controller('ticket.controller.reports.financeiro',
      ["$scope", "common", "ticket.service.reports.financeiro",
        function ($scope, common, financeiroSvc) {
          var vm = common.controller.master(this, financeiroSvc, $scope);
        }]);
})();

(function () {
  'use strict';

  angular.module('ticket.controller.reports').controller('ticket.controller.reports.financeiro.grid', [
    "common"
    ,"$state"
    ,"$scope"
    ,"orderByFilter"
    ,"ticket.service.reports.financeiro"
    , "ticket.service.conteudo.atracao"
    , "ticket.service.controleestabelecimento.estabelecimento"
    , function (common,$state, $scope, orderByFilter, financeiroSvc, atracaoSvc, estabelecimentoSvc) {

      var vm = common.controller.grid(this, financeiroSvc, atracaoSvc, estabelecimentoSvc);
      vm.gerar = false;

      //vm.Filter.DataInicio  ='03/02/2017';
      //vm.Filter.DataFim = '03/02/2017';
      //vm.Filter.IdAtracao = 51;//2092;//1061;


      estabelecimentoSvc.list({}).then(function (data) {
        data = orderByFilter(data, 'Nome');
        vm.lstEstabelecimento = data;
      });


      $scope.$watch('vm.Filter.IdEstabelecimento', function(newValue) {
        if(vm.Filter.IdEstabelecimento)
          atracaoSvc.list({IdEstabelecimento: newValue}).then(function (data) {
            data = orderByFilter(data, 'Nome');
            vm.lstAtracao = data;
          });
        else
          vm.Filter.IdAtracao = null;
      });


      vm.Gerar = function () {
        vm.gerar = true;

        //moment(moment(new Date()).format('MM/DD/YYYY'),'MM/DD/YYYY').toDate()

        vm.Filter.DataInicio = moment(vm.Filter.DataInicio).format();
        vm.Filter.DataFim =    moment(vm.Filter.DataFim).format();

        financeiroSvc.financeiro(vm.Filter).then(function (data) {
          $state.go('reports.financeiro.form', {  Uri: data.Url });
        })
      }

    }]);
})();

(function () {
  'use strict';

  angular
    .module('ticket.controller.reports')
    .controller('ticket.controller.reports.financeiro.form', [
      'common'
      , '$stateParams'
      , '$sce'
      ,'$state'
      , 'ticket.service.reports.financeiro'
      , function (common, $stateParams, $sce, $state, financeiroSvc) {

        var vm = common.controller.basic(this, financeiroSvc);

        vm.loading = true;
        var element = angular.element(document.querySelector('body'));
        vm.height = element[0].offsetHeight;
        vm.style = {
          "width" : "100%",
          "height" : vm.height / 1.4
        }

        if(!$stateParams.Uri)
        {
          $state.go('reports.financeiro.grid');
        }

        if($stateParams.Uri) {
            vm.pdfUrl = $sce.trustAsResourceUrl($stateParams.Uri);
            vm.loading = false;
        }


        vm.voltar = function () {
          $state.go('reports.financeiro.grid');
        }
      }])
})();

(function() {
  'use strict';

  angular
    .module('ticket.controller.moderacao', [

    ]);
})();
(function() {
  'use strict';
  angular.module('ticket.controller.moderacao')
    .controller('ticket.controller.moderacao.artista', ["$scope", "common", "ticket.service.moderacao.atracao", function($scope, common, moderacaoSvc) {
      var vm = common.controller.master(this, moderacaoSvc, $scope);
    }])
    .controller('ticket.controller.moderacao.artista.grid', ["$state", 'common', "ticket.service.moderacao.artista",
      function($state, common, artistaModeracaoSvc) {
        var vm = common.controller.grid(this, artistaModeracaoSvc);
        //Default values
        vm.Filter.Situacao = 1;
        vm.Filter.Periodo = 3;
        vm.Filter.Ocorrencia = 1;

        vm.PeriodoList = [
          {Nome:'Últimos 3 dias', Valor:3},
          {Nome:'Última semana', Valor:7},
          {Nome:'Últimos 15 dias', Valor:15},
          {Nome:'1 mês', Valor:30},
          {Nome:'3 meses', Valor:60},
          {Nome:'6 meses', Valor:180},
          {Nome:'1 ano', Valor:365}
        ];

        vm.SituacaoList = [
          {Nome:'Todos', Valor:1},
          {Nome:'Aprovados', Valor:2},
          {Nome:'Reprovados', Valor:3},
          {Nome:'A Aprovar', Valor:4}
        ];

        vm.OcorrenciaList = [
          {Nome:'Todos', Valor:1},
          {Nome:'Novos', Valor:2},
          {Nome:'Atualização', Valor:3}
        ];

      }
    ])
    .controller('ticket.controller.moderacao.artista.form', ["$state", 'common', "ticket.service.moderacao.artista", function($state, common, artistaModeracaoSvc) {
      var vm = common.controller.form(this, artistaModeracaoSvc);
      var loading = true;
      /**
       * verifica se está editando um artista
       * @param  int $state.params.Id !     Id do artista
       * @return
       */
      if (loading === true) {
        if ($state.params.Id !== undefined || $state.params.Id !== null) {
          artistaModeracaoSvc.get({
            Id: $state.params.Id
          }).then(function(artista) {
            vm.items = artista;

          }).finally(function() {
            vm.loading = false;
          });
        }
      }

      /**
       * Faz a aprovação de um artista
       * @return void
       */
      vm.aprovar = function() {
        var objAprovacao = {};
        var objAprovacaoTipoArtista = {};
        if (vm.items !== null) {
          objAprovacao = {
            Id: vm.items.Id,
            NumeroVersao: vm.items.NumeroVersao,
            ModeradoSite: true
          };

          objAprovacaoTipoArtista = {
            IdArtista: vm.items.Id,
            NumeroVersao: vm.items.NumeroVersao,
            ModeradoSite: true
          };
        }
        artistaModeracaoSvc.put({
          Artista: {
            Id: objAprovacao.Id,
            ModeradoSite: true
          },
          ArtistaVersao: objAprovacao,
          ArtistaTipoArtista: objAprovacaoTipoArtista
        }).then(function(data) {
          vm.utils.ShowSuccess("Aprovação de artista", "Operação realizada com sucesso!");
          $state.go('moderacao.artista.grid');
        });
      };
      /**
       * Faz a reprovação de um artista
       * @return void
       */
      vm.reprovar = function() {
        var objReprovacao = {};
        if (vm.items !== null) {
          objReprovacao = {
            Id: vm.items.Id,
            NumeroVersao: vm.items.NumeroVersao,
            ModeradoSite: false
          };
        }
        artistaModeracaoSvc.put({
          Artista: {
            Id: objReprovacao.Id,
            ModeradoSite: false
          },
          ArtistaVersao: objReprovacao
        }).then(function(data) {
          vm.utils.ShowSuccess("Reprovação de banda", "Operação realizada com sucesso!");
          $state.go('moderacao.artista.grid');
        });
      };

      /**
       * volta para o grid
       * @return void
       */
      vm.cancel = function() {
        $state.go('moderacao.artista.grid');
      };
    }]);
})();

(function() {
  'use strict';

  angular.module('ticket.controller.operacao')
    .controller('ticket.controller.operacao.usuario.master',[
      '$scope',
      'common',
      function ($scope,common){

      var vm = common.controller.master(this);

    }]);

})();

(function() {
  'use strict';

  angular.module('ticket.controller.operacao')
    .controller('ticket.controller.operacao.usuario.grid',[
      '$scope',
      'common',
      '$state',
      'toaster',
      'ticket.service.configuracao.cliente',
      'ticket.service.controleacesso.usuario',
      function ($scope,common, $state,toaster, clienteSvc, usuarioSvc){

      var vm = common.controller.grid(this, clienteSvc);

        vm.validar = function (cliente) {
          usuarioSvc.valida(cliente).then(function () {
            cliente.EmailValidado = true;
            toaster.pop('success', 'Validação', "Usuário validado com sucesso!");

          })
        }

        vm.detalhes = function (item) {
          $state.go('operacao.usuario.form', {IdCliente : item.IdCliente});
        }

    }]);

})();

(function() {
  'use strict';

  angular.module('ticket.controller.operacao')
    .controller('ticket.controller.operacao.usuario.form',[
      '$scope',
      'common',
      '$q',
      'toaster',
      '$stateParams',
      '$state',
      'ticket.service.venda.vendasite',
      'ticket.service.cliente.clientedadoscadastrais',
      function ($scope,common, $q, toaster, $stateParams,$state, vendaSiteSvc, clientedadoscadastraisSvc){

      var vm = common.controller.basic(this);

      if($stateParams.IdCliente) {

          clientedadoscadastraisSvc.get({IdCliente : $stateParams.IdCliente}).then(function (data) {
            vm.Cliente = data;
          })

          searchVendas();
        }

        function searchVendas(inScroll) {

          if (vm.searching) return;
          vm.searching = true;

          if (!inScroll) {
            vm.page = 0;
            vm.complete = false;
            vm.items = [];
          }

          vendaSiteSvc.getAll({
            Config: {
              Skip: vm.page,
              Top: 20
            },
            Filter: {
              IdUsuario: $stateParams.IdCliente
            }
          }).then(function (vendas) {

            //vm.items = vendas;
            vm.items = vm.items.concat(vendas);

            if (vendas.length < 20)
              vm.complete = true;

            if (vendas.length > 0)
              vm.page += 1;

            vm.searching = false;

          })
        }

        vm.search = function (inScroll) {
          searchVendas(inScroll);
        }

        vm.back = function () {
          $state.go('operacao.usuario.grid')
        }

    }]);

})();

/**
 * Created by thainan.gomes on 28/08/2017.
 */
(function () {
  'use strict';

  angular
    .module('ticket.controller.operacao')
    .controller('ticket.controller.operacao.caixa.grid', [
      '$state',
      'common',
      'ticket.service.fluxocaixa.caixa',
      'ticket.service.controleestabelecimento.estabelecimento',
      'ticket.service.venda.vendasite',
      function ($state, common, caixaSvc, estabelecimentoSvc, vendaSiteSvc) {
        var vm = common.controller.grid(this);

        vm.page = 0;
        vm.items = [];
        vm.searching = false;
        vm.complete = false;
        var pageSize = 20;
        vm.QueryFilter = {};

        vm.caixaList = [
          {Nome: 'SITE'},
          {Nome: 'PDV'}
        ];

        vm.situacaoList = [
          {Nome: 'Aberto'},
          {Nome: 'Fechado'}
        ];

        estabelecimentoSvc.listgestao({}).then(function (list) {
          vm.estabelecimentoList = list;
        });

        vm.search = function(inScroll) {

          vm.searching = true;

          if (!inScroll) {
            vm.page = 0;
            vm.complete = false;
            vm.items = [];
          }

          vm.QueryFilter.Config = { Skip: vm.page, Top: pageSize };
          vm.QueryFilter.Filter = vm.Filter;

          caixaSvc.caixaSemanal(vm.QueryFilter)
            .then(function(data) {
              vm.items = vm.items.concat(data);

              if (data.length < pageSize)
                vm.complete = true;

              if (data.length > 0) {
                vm.page += 1;
              }

            }).finally(function() {
            vm.searching = false;
          });
        };

        // vm.search = function(inScroll) {
        //
        //   if(!vm.Filter.DataAberturaInicio || !vm.Filter.DataAberturaFim || !vm.Filter.IdEstabelecimento){
        //     return;
        //   }
        //
        //   vm.searching = true;
        //
        //   if (!inScroll) {
        //     vm.page = 0;
        //     vm.complete = false;
        //     vm.items = [];
        //   }
        //
        //   vm.QueryFilter.Config = { Skip: vm.page, Top: pageSize };
        //   vm.QueryFilter.Filter = vm.Filter;
        //
        //   vm.utils.ShowSuccess("chama", "chama");
        //   caixaSvc.caixaSemanal(vm.QueryFilter)
        //     .then(function(data) {
        //       vm.items = vm.items.concat(data);
        //
        //       if (data.length < pageSize)
        //         vm.complete = true;
        //
        //       if (data.length > 0) {
        //         vm.page += 1;
        //       }
        //
        //     }).finally(function() {
        //     vm.searching = false;
        //   });
        // };

        vm.detalhe = function (item) {
          $state.go('operacao.caixa.form', {Id : item.IdCaixa})
        }

      }])
})();

/**
 * Created by thainan.gomes on 29/08/2017.
 */
(function () {
  'use strict';

  angular
    .module('ticket.controller.operacao')
    .controller('ticket.controller.operacao.caixa.form', [
      '$state', '$stateParams', 'common', 'ticket.service.fluxocaixa.caixa',
      function ($state, $stateParams, common, caixaSvc) {
        var vm = common.controller.basic(this);

          if ($stateParams.Id != null) {

            caixaSvc.getCaixaSemanal({IdCaixa: $stateParams.Id}).then(function (data) {
              vm.item = data;
            }).finally(function () {
              vm.searching = false;
            });
          }

          vm.cancel = function () {
            $state.go('operacao.caixa.grid')
          }
      }])
})();

/**
 * Created by thainan.gomes on 28/08/2017.
 */
(function () {
  'use strict';

  angular
    .module('ticket.controller.operacao')
    .controller('ticket.controller.operacao.caixa', [
      '$scope', 'common', 'ticket.service.operacao.caixa',
      function ($scope, common, caixaSvc) {
        var vm = common.controller.master(this, caixaSvc, $scope);
      }])

})();


(function() {
  'use strict';

  angular
    .module('ticket.controller.moderacao')
    .controller('ticket.controller.moderacao.video', [function() {
      var vm = this;
    }])


  .controller('ticket.controller.moderacao.video.grid', ["$state", 'common', "ticket.service.moderacao.video", function($state, common, moderacaoVideoSvc) {

    var vm = common.controller.grid(this, moderacaoVideoSvc);

    //Default values
    vm.Filter.Status = 3;
    vm.Filter.Periodo = 3;
    vm.Filter.StatusRegistro = 3;

    vm.add = function() {
      $state.go("^.form");
    };

  }])


  .controller('ticket.controller.moderacao.video.form', ['$scope', '$state', '$stateParams', '$sce', 'common', 'ticket.service.moderacao.video', 'ticket.service.conteudo.atracao', function($scope, $state, $stateParams, $sce, common, moderacaoVideoSvc, atracaoSvc) {
      var vm = common.controller.form(this, moderacaoVideoSvc);

      vm.item = {};
      var pk = $stateParams;

      vm.uploadVideo = function(file) {
        if (file) {
          atracaoSvc.uploadVideoGestao(file).then(function(resp) {
              vm.item.Uri = resp.data.Video.Uri;
              vm.item.Arquivo = resp.data.Video.Arquivo;
              vm.item.IdTipoArquivo = 4;
            },
            function(resp) {},
            function(evt) {
              vm.videoProgress = Math.round(evt.loaded / evt.total * 100);
            }
          ).finally(function() {});

        }
      };



      moderacaoVideoSvc.get({
        IdAtracaoArquivo: $stateParams.IdAtracaoArquivo
      }).then(function(data) {
        data.Uri = undefined;
        vm.item = data;
      });


      vm.save = function() {
        moderacaoVideoSvc.put(vm.item)
          .then(function(v) {
            vm.utils.ShowSuccess("Inclusão de registro", "Operação realizada com sucesso!");
            $state.go('^.grid');
          })
          .finally(function() {
            vm.loading = false;
          });
      }

      vm.cancel = function() {
        $state.go('^.grid');
      };
    }])
    .filter('trusted', function($sce) {
      return function(url) {
        return $sce.trustAsResourceUrl(url);
      };
    });



})();
(function () {
  'use strict';

  angular.module('ticket.controller.moderacao')
    .controller('ticket.controller.moderacao.produtor', [
      '$scope',
      '$state',
      'common',
      function ($scope, $state, common) {
        var vm = common.controller.master(this);
      }
    ])
})();




(function () {
  'use strict';

  angular.module('ticket.controller.moderacao')
    .controller('ticket.controller.moderacao.produtor.grid', [
      '$scope',
      '$state',
      'common',
      'ticket.service.moderacao.produtor',
      function ($scope, $state, common, produtorSvc) {
        var vm = common.controller.grid(this, produtorSvc);
      }
    ])
})();

(function () {
  'use strict';

  angular.module('ticket.controller.moderacao')
    .controller('ticket.controller.moderacao.produtor.form', [
      '$scope',
      '$state',
      'common',
      'ticket.service.moderacao.produtor',
      function ($scope, $state, common, produtorSvc) {
        var vm = common.controller.basic(this, produtorSvc);

        produtorSvc.resumomoderacao({
          IdUsuario: $state.params.IdUsuario
        }).then(function(resumo) {
          vm.items = resumo;
        });

        vm.aprovarreprovar = function (moderacao) {
            vm.items.Moderado = moderacao;
          produtorSvc.put(vm.items).then(function(data) {
            if(moderacao)
              vm.utils.ShowSuccess("Aprovação de Produtor", "Produtor aprovado com sucesso!");
            else
              vm.utils.ShowSuccess("Reprovação de Produtor", "Produtor reprovado com sucesso!");

            $state.go('^.grid');
          })
        }

        vm.cancel = function () {
          $state.go('^.grid');
        }
      }
    ])
})();

(function() {
  'use strict';

  angular
    .module('ticket.controller.moderacao')

  .controller('ticket.controller.moderacao.ingresso', [
    "$scope"
    , "common"
    , "ticket.service.moderacao.ingresso"
    , function(
      $scope
      , common
      , ingressoSvc)
    {
    var vm = common.controller.master(this, ingressoSvc, $scope);
  }])

  .controller('ticket.controller.moderacao.ingresso.grid', [
    "$scope",
    "$state",
    'common',
    "ticket.service.moderacao.ingresso",
    "ticket.service.controleingresso.estabelecimentoingresso",
    function($scope, $state, common, ingressoSvc, estabelecimentoingressoSvc) {

      var vm = common.controller.grid(this, estabelecimentoingressoSvc);
      //Default values
      vm.Filter.Situacao = 1;
      vm.Filter.Periodo = 3;
      vm.Filter.Ocorrecia = 1;

      vm.getallmoderacao = function () {
        vm.searching = true;
        var filter = {
          filter : {
            Situacao : vm.Filter.Situacao,
            Periodo: vm.Filter.Periodo,
            Ocorrecia: vm.Filter.Ocorrecia,
            Nome: vm.Filter.Nome
          } }

        estabelecimentoingressoSvc.getAllModeracao(filter).then(function (data) {
          vm.items = data;
          vm.searching = false;
        });

        vm.moderar = function (itm) {
            $state.go('moderacao.ingresso.form', { Id: itm.Id });
        }
      }
    }
  ])


  .controller('ticket.controller.moderacao.ingresso.form', [
    '$state',
    '$scope',
    'common',
    'Lightbox',
    "ticket.service.controleingresso.estabelecimentoingresso",
    function($state, $scope, common, Lightbox, estabelecimentoingressoSvc) {

      var vm = common.controller.form(this, estabelecimentoingressoSvc);
      vm.aprovar = function(itm) {
        itm.ModeradoSite = true;
        estabelecimentoingressoSvc.moderar(itm).then(function () {

          vm.utils.ShowSuccess("Moderação de ingresso", "Ingresso aprovado com sucesso!");
          $state.go('moderacao.ingresso.grid');
        });
      };

      vm.reprovar = function(itm) {
        itm.ModeradoSite = false;
        estabelecimentoingressoSvc.moderar(itm).then(function () {
          vm.utils.ShowSuccess("Moderação de ingresso", "Ingresso reprovado com sucesso!");
          $state.go('moderacao.ingresso.grid');
        });
      };

      vm.cancel = function() {
        $state.go('moderacao.ingresso.grid');
      };
    }
  ])

})();

(function() {
  'use strict';
  angular.module('ticket.controller.moderacao')
  .controller('ticket.controller.moderacao.banda', ["$scope", "common", "ticket.service.moderacao.atracao", function($scope, common, moderacaoSvc) {
    var vm = common.controller.master(this, moderacaoSvc, $scope);
  }])
  .controller('ticket.controller.moderacao.banda.grid', ["$state", 'common', 'ticket.service.moderacao.banda',
    function($state, common, moderacaoBandaSvc) {
      var vm = common.controller.grid(this, moderacaoBandaSvc);
      //Default values
      vm.Filter.Situacao = 1;
      vm.Filter.Periodo = 3;
      vm.Filter.Ocorrecia = 1;

      vm.PeriodoList = [
        {Nome:'Últimos 3 dias', Valor:3},
        {Nome:'Última semana', Valor:7},
        {Nome:'Últimos 15 dias', Valor:15},
        {Nome:'1 mês', Valor:30},
        {Nome:'3 meses', Valor:60},
        {Nome:'6 meses', Valor:180},
        {Nome:'1 ano', Valor:365}
      ];

      vm.SituacaoList = [
        {Nome:'Todos', Valor:1},
        {Nome:'Aprovados', Valor:2},
        {Nome:'Reprovados', Valor:3},
        {Nome:'A Aprovar', Valor:4}
      ];

      vm.OcorrenciaList = [
        {Nome:'Todos', Valor:1},
        {Nome:'Novos', Valor:2},
        {Nome:'Atualização', Valor:3}
      ];
    }
  ])
  .controller('ticket.controller.moderacao.banda.form', ["$state", 'common', "ticket.service.moderacao.banda", "ticket.service.conteudo.bandaartista", function($state, common, moderacaoBandaSvc, bandaartistaSvc) {
    var vm = common.controller.form(this, moderacaoBandaSvc);
    var loading = true;
    /**
     * verifica se está editando um artista
     * @param  int $state.params.Id !     Id do artista
     * @return
     */

    //console.log('$state.params',$state.params);

    if (loading === true) {
      if (($state.params.Id !== undefined || $state.params.Id !== null) && $state.params.NumeroVersao ) {
        moderacaoBandaSvc.get({
          Id: $state.params.Id
        }).then(function(banda) {
          vm.items = banda;

        }).finally(function() {
          vm.loading = false;
        });

        bandaartistaSvc.list({IdBanda : $state.params.Id, NumeroVersao: $state.params.NumeroVersao }).then(function (data) {
          vm.BandaArtista = data;
        });
      }
    }
    /**
     * Faz a aprovação da banda
     * @return void
     */
    vm.aprovar = function() {
      var objAprovacao = {};
      if (vm.items !== null) {
        objAprovacao = {
          Id: vm.items.Id,
          NumeroVersao: vm.items.NumeroVersao,
          ModeradoSite: true
        };
      }
      moderacaoBandaSvc.put({
        Banda: {
          IdBanda: objAprovacao.Id
        },
        BandaVersao: objAprovacao,
        BandaArtista:vm.BandaArtista
      }).then(function(data) {
        vm.utils.ShowSuccess("Aprovação de banda", "Operação realizada com sucesso!");
        $state.go('moderacao.banda.grid');
      });
    };
    /**
     * Faz a reprovação da banda
     * @return void
     */
    vm.reprovar = function() {
      var objReprovacao = {};
      if (vm.items !== null) {
        objReprovacao = {
          Id: vm.items.Id,
          NumeroVersao: vm.items.NumeroVersao,
          ModeradoSite: false
        };
      }
      moderacaoBandaSvc.put({
        Banda: {
          IdBanda: objReprovacao.Id
        },
        BandaVersao: objReprovacao,
        BandaArtista:vm.BandaArtista
      }).then(function(data) {
        vm.utils.ShowSuccess("Reprovação de banda", "Operação realizada com sucesso!");
        $state.go('moderacao.banda.grid');
      });
    };

    /**
     * volta para o grid
     * @return void
     */
    vm.cancel = function() {
      $state.go('moderacao.banda.grid');
    };
  }])
})();

(function() {
  'use strict';

  angular
    .module('ticket.controller.moderacao')

  .controller('ticket.controller.moderacao.atracao', ["$scope", "common", "ticket.service.moderacao.atracao", function($scope, common, atracaoSvc) {
    var vm = common.controller.master(this, atracaoSvc, $scope);
  }])

  .controller('ticket.controller.moderacao.atracao.grid', [
    "$scope",
    "$state",
    'common',
    "ticket.service.moderacao.atracao",
    function($scope, $state, common, atracaoSvc) {
      var vm = common.controller.grid(this, atracaoSvc);
      //Default values
      vm.Filter.Situacao = 1;
      vm.Filter.Periodo = 3;
      vm.Filter.Ocorrecia = 1;


    }
  ])

  .controller('ticket.controller.moderacao.atracao.form', [
    '$state',
    '$scope',
    'common',
    'Lightbox',
    'ticket.service.moderacao.atracao',
    'ticket.service.conteudo.atracaogenero',
    'ticket.service.conteudo.atracaoinadequacao',
    'ticket.service.conteudo.atracaoarquivo',
    'ticket.service.conteudo.atracaoavaliacao',
    function($state, $scope, common, Lightbox, atracaoModeracaoSvc, atracaoGeneroSrv, atracaoInadequacaoSrv, atracaoarquivoSrv, atracaoavaliacaoSvc) {

      var vm = common.controller.form(this, atracaoModeracaoSvc);

      atracaoModeracaoSvc.get({
        Id: $state.params.Id
      }).then(function(atracao) {
        vm.items = atracao;
        vm.items.imagensDaGaleria = [];

        var iframe = angular.element("[name='sinopse']")[0];

        var doc  = iframe.contentWindow.document;
        doc.open();
        doc.write(vm.items.Sinopse);
        $('head',doc).append("<style>* { font-family: 'Open Sans', 'Helvetica', 'Arial', sans-serif;} </style>");
        doc.close();

        if (vm.items.NumeroVersao > 0) {
          atracaoGeneroSrv.list({
            IdAtracao: $state.params.Id,
            NumeroVersao: vm.items.NumeroVersao
          }).then(function(generos) {
            vm.items.generos = generos;
          });


          atracaoInadequacaoSrv.list({
            IdAtracao: $state.params.Id,
            NumeroVersao: vm.items.NumeroVersao
          }).then(function(inadequacoes) {
            vm.items.inadequacoes = inadequacoes;
          });

          atracaoarquivoSrv.list({
            IdAtracao: $state.params.Id,
            NumeroVersao: vm.items.NumeroVersao,
            IdTipoArquivo: 3
          }).then(function(fotosGaleria) {
            fotosGaleria.forEach(function(foto) {
              vm.items.imagensDaGaleria.push({
                url: foto.Uri
              });
            });
          });

        }

        // atracaoavaliacaoSvc.ListModeracao({IdAtracao : $state.params.Id}).then(function (data) {
        //   vm.AtracaoAvaliacao = data;
        // });
      });

      $scope.openLightboxModal = function(index) {
        Lightbox.openModal(vm.items.imagensDaGaleria, index);
      };

      vm.aprovar = function() {
        var objAprovacao = {};

        if (vm.items !== null) {
          objAprovacao = {
            Id: vm.items.Id,
            IdTipoArquivo: vm.items.IdTipoArquivo,
            NumeroVersao: vm.items.NumeroVersao,
            ModeradoSite: true
          };
        }

        atracaoModeracaoSvc.put({
          Atracao: {
            IdAtracao: objAprovacao.Id,
            IdTipoAtracao: vm.items.IdTipoAtracao
          },
          AtracaoVersao: objAprovacao,
          AtracaoAvaliacao: vm.AtracaoAvaliacao
        }).then(function(data) {
          vm.utils.ShowSuccess("Aprovação de atração", "Operação realizada com sucesso!");
          $state.go('^.grid');
        });
      };

      vm.reprovar = function() {
        var objReprovacao = {};

        if (vm.items !== null) {
          objReprovacao = {
            Id: vm.items.Id,
            IdTipoArquivo: vm.items.IdTipoArquivo,
            NumeroVersao: vm.items.NumeroVersao,
            ModeradoSite: false
          };
        }

        atracaoModeracaoSvc.put({
          Atracao: {
            IdAtracao: objReprovacao.Id
          },
          AtracaoVersao: objReprovacao,
          AtracaoAvaliacao: vm.AtracaoAvaliacao
        }).then(function(data) {

          vm.utils.ShowSuccess("Reprovação de atração", "Operação realizada com sucesso!");
          $state.go('^.grid');
        });
      };


      vm.cancel = function() {
        $state.go('moderacao.atracao.grid');
      };

    }
  ])

})();

(function() {
  'use strict';

  angular
    .module('ticket.controller.financeiro', [

    ]);
})();

(function() {
  'use strict';

  angular
    .module('ticket.controller.financeiro')

    .controller('ticket.controller.financeiro.repasse', [
      "$scope"
      , "common"
      , "ticket.service.moderacao.ingresso"
      , function($scope, common, ingressoSvc){

        var vm = common.controller.master(this, ingressoSvc, $scope);
      }])

})();

(function() {
  'use strict';
  angular.module('ticket.controller.financeiro')
    .controller('ticket.controller.financeiro.repasse.grid', [
      "$scope",
      "$state",
      'common',
      'toaster',
      'ticket.service.reports.repasse',
      'ticket.service.repasse',
      'ticket.service.repasseempresa',
      function($scope, $state, common,toaster, reportRepasseSvc, repasseSvc, repasseempresaSvc) {
        var vm = common.controller.grid(this);

        vm.search = function () {
          repasseSvc.listrepasse({}).then(function (data) {
            vm.items = data;
          });

        }

        vm.repasseResumo = function (itm) {

          itm.searching = true;
          vm.exec = true;

          var filter = {
            IdEmpresa: itm.IdEmpresa,
            IdRepasseEmpresa: itm.IdRepasseEmpresa
          }

          reportRepasseSvc.repasseresumo(filter).then(
            function (data) {
              itm.searching = false;
              vm.exec = false;
              $state.go('financeiro.repasse.form-relatorio', {Uri: data.Url});
            });
        }

        vm.aprovar = function (itm) {

          itm.searching = true;
          vm.exec = true;
          repasseempresaSvc.aprovarrepasse(itm.IdRepasseEmpresa).then(function (data) {
            vm.items = data;
            itm.searching = false;
            vm.exec = false;
            toaster.pop('success', 'Sucesso!', 'Repasse aprovado com sucesso!');
          });
        }



      }
    ])

})();

(function() {
  'use strict';
  angular.module('ticket.controller.financeiro')
   .controller('ticket.controller.financeiro.repasse.form', [
    '$state',
    '$scope',
    'common',
    "ticket.service.controleingresso.estabelecimentoingresso",
    function($state, $scope, common, estabelecimentoingressoSvc) {

      var vm = common.controller.form(this, estabelecimentoingressoSvc);

    }
  ])
})();

(function () {
  'use strict';

  angular
    .module('ticket.controller.financeiro')
    .controller('ticket.controller.financeiro.repasse.form-relatorio', [
      'common'
      , '$stateParams'
      , '$sce'
      , '$state'
      , 'ticket.service.repasse'
      , function (common, $stateParams, $sce, $state, repasseSrv) {

        var vm = common.controller.basic(this);
        vm.loading = true;

        var element = angular.element(document.querySelector('body'));
        vm.height = element[0].offsetHeight;
        vm.style = {
          "width": "100%",
          "height": vm.height / 1.4
        }


        if ($stateParams.Uri == "" || $stateParams.Uri == null) {

          $state.go('financeiro.repasse.grid');
        }
        else {
          vm.pdfUrl = $sce.trustAsResourceUrl($stateParams.Uri);
          vm.loading = false;
        }


        vm.voltar = function () {
          $state.go('financeiro.repasse.grid');
        }
      }])
})();

/**
 * Created by thainan.gomes on 25/07/2017.
 */
(function() {
  'use strict';

  angular.module('ticket.controller.estabelecimento')
    .controller('ticket.controller.estabelecimento.formapagamento.grid', [
      '$state',
      'common',
      'ticket.service.controleestabelecimento.estabelecimento',
      function(
        $state,
        common,
        estabelecimentoSvc
      ) {

        var vm = common.controller.grid(this, estabelecimentoSvc);

        vm.edit = function(itm) {
          $state.go('estabelecimento.formapagamento.form', {IdEstabelecimento: itm.Id});
        };
      }]);
})();

/**
 * Created by thainan.gomes on 25/07/2017.
 */
(function() {
  'use strict';

  angular.module('ticket.controller.estabelecimento')
    .controller('ticket.controller.estabelecimento.formapagamento.form', [
      '$state',
      '$scope',
      'common',
      '$filter',
      '$stateParams',
      'ticket.service.controleestabelecimento.estabelecimento',
      'ticket.service.controleformapagamento.formapagamento',
      'ticket.service.controleformapagamento.formapagamentoestabelecimento',
      function(
        $state,
        $scope,
        common,
        $filter,
        $stateParams,
        estabelecimentoSvc,
        formaPagamentoSvc,
        formapagamentoestabelecimentoSvc
      ) {

        var vm = common.controller.basic(this, estabelecimentoSvc);
        vm.item = {};
        vm.LugarNaoMarcado = false;
        $scope.validateForm = true;


        estabelecimentoSvc.get({Id: $stateParams.IdEstabelecimento}).then(function(estabelecimento) {
          vm.estabelecimento = estabelecimento;
        });

        vm.item.IdEstabelecimento = $stateParams.IdEstabelecimento;

        vm.cancel = function() {
          $state.go('estabelecimento.formapagamento.grid');
        };

        formaPagamentoSvc.ListByEstabelecimento({IdEstabelecimento:vm.item.IdEstabelecimento}).then(function(listData) {
          vm.listFormaPagamento = listData;
        });


        vm.check = function() {
          vm.filtro = $filter('filter')(vm.listFormaPagamento, {'Checked':'true'});

          if(vm.filtro.length == 0){
            vm.LugarNaoMarcado = true;
            $scope.validateForm = true;
          }else {
            vm.LugarNaoMarcado = false;
            $scope.validateForm = false;
          }
        };

        vm.checkUpdate = function() {
          vm.filtro = $filter('filter')(vm.listFormaPagamento, {'Checked':'true'});

          if(vm.filtro.length == 0){
            vm.LugarNaoMarcado = true;
            $scope.validateForm = true;
          }else {
            vm.LugarNaoMarcado = false;
            $scope.validateForm = false;
          }
        };

        vm.save = function() {
          vm.loading = true;

          if(vm.listFormaPagamento.filter(function (itm) {
              return itm.Checked == true;
            }).length == 0){
            vm.LugarNaoMarcado = true;
            return ;
          }

          vm.formapagamentoestabelecimentolist = $filter('filter')(vm.listFormaPagamento, {'Checked':'true'}).map(function (item) {

              return {
                IdFormaPagamento: item.IdFormaPagamento,
                IdEstabelecimento: vm.item.IdEstabelecimento,
                AceitaCancelamento: item.AceitaCancelamento,
                Update: item.Update
              };
          });

          formapagamentoestabelecimentoSvc.post(vm.formapagamentoestabelecimentolist).then(function () {
            vm.utils.ShowSuccess("Inclusão de registro", "Operação realizada com sucesso!");
            $state.go('estabelecimento.formapagamento.grid');
          }).finally(function () {
            vm.loading = false;
          });
        };

      }]);
})();

(function () {
    'use strict';

    angular
        .module('ticket.controller.estabelecimento')

        .controller('ticket.controller.estabelecimento.estabelecimentoconfiguracaoestrutura', ["$scope", "common", "ticket.service.controleestabelecimento.estabelecimentoconfiguracaoestrutura",
            function ($scope, common, structSvc) {
                var vm = common.controller.master(this, structSvc, $scope);
            }])


      .controller('ticket.controller.estabelecimento.estabelecimentoconfiguracaoestrutura.grid',
        [ "$scope",
          "common",
          "ticket.service.controleestabelecimento.estabelecimentoconfiguracaoestrutura",
          "ticket.service.estabelecimento",
        function ($scope, common, structSvc, estabelecimentoSrv) {
          var vm = common.controller.grid(this, estabelecimentoSrv, $scope);
        }])

        .controller('ticket.controller.estabelecimento.estabelecimentoconfiguracaoestrutura.form',
          [ "common",
            "toaster",
            "$state",
            "$stateParams",
            "ticket.service.controleestabelecimento.estabelecimentoconfiguracaoestrutura",
            "ticket.service.controleestabelecimento.formatoingresso",
            function (common, toaster, $state, $stateParams, structSvc, formatoingressoSvc) {
                var vm = common.controller.basic(this, structSvc);

                vm.item = {
                  FluxoAtracao: "C",
                  PossuiLayout: false,
                  PossuiSetor: false,
                  PossuiZona: false,
                  Status: 1,
                  PossuiLote: false,
                  GerenteAutorizaCortesia: false,
                  GerenteAutorizaDevolucaoDinheiro: false,
                  GerenteAutorizaDevolucaoVenda: false,
                  VendaIntegradaPinPad: false,
                  MensagemPinPad: "*** DIVERTIX ***   Bem-Vindo!",
                  UrlIntegradora: null,
                  CodEstabelecimentoIntegradora: null
                };

              formatoingressoSvc.list({}).then(function (data) {
                vm.lstFormatoIngresso = data;
              })

                structSvc.list({ IdEstabelecimento: $stateParams.Id, Status:'Todos' }).then(function (data) {
                    if(data.length > 0) {
                      vm.item = data[0];
                    }
                    else {
                      vm.item.FluxoAtracao = 'C';
                    }
                });

                vm.save = function () {
                  vm.loading = true;

                  if(vm.item.IdEstabelecimento){
                    structSvc.put(vm.item).then(
                      function () {
                        toaster.pop('success', 'Sucesso!', 'Configuração realizada com sucesso!');
                        vm.loading = false;
                        $state.go('estabelecimento.estrutura.grid');
                      },
                      function () {
                        vm.loading = false;
                      }
                    );
                  }else {
                    vm.item.IdEstabelecimento = $stateParams.Id;

                    structSvc.post(vm.item).then(
                      function () {
                        toaster.pop('success', 'Sucesso!', 'Configuração realizada com sucesso!');
                        vm.loading = false;
                        $state.go('estabelecimento.estrutura.grid');
                      },
                      function () {
                        vm.loading = false;
                      }
                    );
                  }
                };

              vm.cancel = function () {
                $state.go('estabelecimento.estrutura.grid');
              }

            }]);
})();

(function () {
    'use strict';

    angular
        .module('ticket.controller.estabelecimento')

        .controller('ticket.controller.estabelecimento.estabelecimentoconfiguracao', ["$scope", "common", "ticket.service.controleestabelecimento.estabelecimentoconfiguracaoinformacao",
            function ($scope, common, estabelecimentoconfiguracaoSvc) {
                var vm = common.controller.master(this, estabelecimentoconfiguracaoSvc, $scope);
            }])

        .controller('ticket.controller.estabelecimento.estabelecimentoconfiguracao.grid', ["common", "ticket.service.controleestabelecimento.estabelecimentoconfiguracaoinformacao",
            function (common, estabelecimentoconfiguracaoSvc) {
                var vm = common.controller.grid(this, estabelecimentoconfiguracaoSvc);
            }])

        .controller('ticket.controller.estabelecimento.estabelecimentoconfiguracao.form', ["common", "toaster", "ticket.service.controleestabelecimento.estabelecimentoconfiguracaoinformacao",
            function (common, toaster, estabelecimentoConfiguracaoInformacaoSvc) {
                var vm = common.controller.basic(this, estabelecimentoConfiguracaoInformacaoSvc);

              estabelecimentoConfiguracaoInformacaoSvc.get({ pk: null }).then(function (data) {
                    vm.item = data;
                });

                vm.Salvar = function () {
                  vm.loading = true;
                    if (vm.item.Id != null) {

                      estabelecimentoConfiguracaoInformacaoSvc.put(vm.item).then(
                            function (data) {

                                toaster.pop('success', 'Sucesso!', 'Configuração realizada com sucesso!');
                            },
                            function () {
                              vm.loading = false;
                            }
                      ).finally(function () {
                        vm.loading = false;
                      });
                    }
                    else {
                      estabelecimentoConfiguracaoInformacaoSvc.post(vm.item).then(
                        function (data) {
                            vm.item = data;
                            toaster.pop('success', 'Sucesso!', 'Configuração realizada com sucesso!');
                        },
                        function () {
                          vm.loading = false;
                        }
                  ).finally(function () {
                        vm.loading = false;
                      });
                    }
                }
            }]);
})();

(function() {
  'use strict';

  angular
    .module('ticket.controller.authentication', [

    ]);
})();
(function() {
  'use strict';

  angular
    .module('ticket.controller.authentication')
    .controller('ticket.controller.authentication.lock', LockController);

  /* @ngInject */
  function LockController($state, triSettings) {
    var vm = this;
    vm.loginClick = loginClick;
    vm.user = {
      name: 'Morris Onions',
      email: 'info@oxygenna.com',
      password: ''
    };
    vm.triSettings = triSettings;

    ////////////////

    // controller to handle login check
    function loginClick() {
      // user logged in ok so goto the dashboard
      $state.go('triangular.dashboard-general');
    }
  }
})();
(function() {
  'use strict';

  angular.module('ticket.controller.estabelecimento')
    .controller('ticket.controller.estabelecimento.convenienciaestabelecimento.grid', [
      '$state',
      '$scope',
      'common',
      'toaster',
      'ticket.service.controleestabelecimento.convenienciaestabelecimento',
      'ticket.service.controleestabelecimento.estabelecimento',
      'ticket.service.controleacesso.sistema',
      'ticket.service.controleestabelecimento.convenienciasessao',
  function(
    $state,
    $scope,
    common,
    toaster,
    convenienciaEstabelecimentoSvc,
    estabelecimentoSvc,
    sistemaSvc,
    convenienciasessaoSvc) {

    var vm = common.controller.grid(this);

    vm.Filter = {};

    vm.regrasConveniencia = [
      {
        Nome: "Padrão",
        Cod: "P"
      },
      {
        Nome: "Estabelecimento",
        Cod: "E"
      },
      {
        Nome: "Atração",
        Cod: "A"
      },
      {
        Nome: "Sessão",
        Cod: "S"
      },
      {
        Nome: "Tipo Atração",
        Cod: "TA"
      },
      {
        Nome: "Tipo Sessão",
        Cod: "TS"
      }
    ];

    convenienciaEstabelecimentoSvc.ListConveniencia(vm.Filter).then(function(listData) {
      vm.items = listData;
    });

    estabelecimentoSvc.list({}).then(function(listData) {
      vm.estabelecimentos = listData;
    });

    sistemaSvc.list({Vende: 1}).then(function(listData) {
      vm.sistemas = listData;
    });

    vm.search = function() {
      convenienciaEstabelecimentoSvc.ListConveniencia(vm.Filter).then(function(list) {
          vm.items = list;
        });
    };

    vm.regerar = function (item) {
      convenienciasessaoSvc.regerar(item).then(function () {
        toaster.pop('success', 'Conveniencia', "Conveniencia regerada com sucesso!");
        item.Regerado = true;
      })
    }
    vm.include = function() {
      $state.go('estabelecimento.convenienciaestabelecimento.form');
    };
  }]);
})();

(function() {
  'use strict';

  angular.module('ticket.controller.estabelecimento')
    .controller('ticket.controller.estabelecimento.convenienciaestabelecimento.form',[
      '$state',
      '$scope',
      'common',
      '$filter',
      '$stateParams',
      'orderByFilter',
      'ticket.service.controleestabelecimento.conveniencia',
      'ticket.service.controleestabelecimento.estabelecimento',
      'ticket.service.conteudo.atracao',
      'ticket.service.conteudo.sessao',
      'ticket.service.conteudo.tipoatracao',
      'ticket.service.conteudo.tiposessao',
      'ticket.service.controleacesso.sistema',
  function(
    $state,
    $scope,
    common,
    $filter,
    $stateParams,
    orderByFilter,
    convenienciaSvc,
    estabelecimentoSvc,
    atracaoSvc,
    sessaoSvc,
    tipoAtracaoSvc,
    tipoSessaoSvc,
    sistevaSvc) {
    var vm = common.controller.form(this, convenienciaSvc);

    vm.item = { TipoTaxa : "F"}


    vm.LugarNaoMarcadoPlataforma = false;
    vm.LugarNaoMarcadoSessao = false;
    $scope.validateForm = true;
    vm.ListaSessaoVazia = false;
    vm.ListaAtracaoVazia = false;
    vm.ListaTipoSessaoVazia = false;
    vm.ListaTipoAtracaoVazia = false;
    $scope.currentDate = new Date();

    vm.parcelas =
      [
        {
          Id: 1,
          Nome :"1 Parcela"
        },
        {
          Id: 2,
          Nome :"2 Parcelas"
        },{
          Id: 3,
          Nome :"3 Parcelas"
        },
        {
        Id: 4,
        Nome :"4 Parcelas"
      },
        {
        Id: 5,
        Nome :"5 Parcelas"
      },
        {
        Id: 6,
        Nome :"6 Parcelas"
      }
      ]

    vm.regrasConveniencia = [
      {
        Nome: "Padrão",
        Cod: "P"
      },
      {
        Nome: "Estabelecimento",
        Cod: "E"
      },
      {
        Nome: "Atração",
        Cod: "A"
      },
      {
        Nome: "Sessão",
        Cod: "S"
      },
      {
        Nome: "Tipo Atração",
        Cod: "TA"
      },
      {
        Nome: "Tipo Sessão",
        Cod: "TS"
      }
    ];


    vm.tipoTaxas = [
      {
        Nome: "Fixa",
        Cod: "F"
      },
      {
        Nome: "Porcentagem",
        Cod: "P"
      }
    ];


    $scope.$watch('vm.item.TipoTaxa', function(newValue) {
      if(vm.item.TipoTaxa)
        vm.item.ValorTaxa = null;
    });


    $scope.$watch('vm.item.Atracao.IdAtracao', function(newValue) {
      if(vm.item.Atracao && vm.item.Atracao.IdAtracao)
        if(vm.CodRegraConveniencia == "S"){
          sessaoSvc.listConveniencia({IdAtracao: newValue}).then(function(listData) {
            vm.sessoes = listData;

            if(listData.length == 0){
              vm.ListaSessaoVazia = true;
              $scope.validateForm = true;
            }else {
              vm.ListaSessaoVazia = false;
              $scope.validateForm = false;
            }
          });
        }
    });


    $scope.$watch('vm.item.Estabelecimento.IdEstabelecimento', function(newValue) {
      if(vm.item.Estabelecimento && vm.item.Estabelecimento.IdEstabelecimento)
      switch (vm.CodRegraConveniencia) {
        case "A":
          atracaoSvc.listConveniencia({IdEstabelecimento: newValue}).then(function(listData) {

            listData = orderByFilter(listData, 'Nome');

            vm.atracoes = listData;

            if(listData.length == 0){
              vm.ListaAtracaoVazia = true;
            }else {
              vm.ListaAtracaoVazia = false;
            }
          });

          vm.item.TipoAtracao = null;
          vm.item.TipoSessao = null;
          vm.item.Atracao = null;

          break;
        case "S":
          atracaoSvc.listConveniencia({IdEstabelecimento: newValue}).then(function(listData) {

            listData = orderByFilter(listData, 'Nome');
            vm.atracoes = listData;

            if(listData.length == 0){
              vm.ListaAtracaoVazia = true;
            }else {
              vm.ListaAtracaoVazia = false;
            }
          });

          vm.item.TipoAtracao = null;
          vm.item.TipoSessao = null;
          vm.item.Atracao = null;
          break;
        case "TA":
          tipoAtracaoSvc.listConveniencia({IdEstabelecimento: newValue}).then(function(listData) {
            vm.tipoAtracoes = listData;

            if(listData.length == 0){
              vm.ListaTipoAtracaoVazia = true;
            }else {
              vm.ListaTipoAtracaoVazia = false;
            }
          });

          vm.item.TipoSessao = null;
          vm.item.Atracao = null;
          vm.item.TipoAtracao = null;

          break;
        case "TS":
          tipoSessaoSvc.list({}).then(function(listData) {
            vm.tipoSessoes = listData;

            if(listData.length == 0){
              vm.ListaTipoSessaoVazia = true;
            }else {
              vm.ListaTipoSessaoVazia = false;
            }
          });

          vm.item.TipoSessao = null;
          vm.item.Atracao = null;
          vm.item.TipoAtracao = null;

          break;
      }
    });


    $scope.$watch('vm.CodRegraConveniencia', function() {
      vm.item.Estabelecimento = null;
    });

    estabelecimentoSvc.list({}).then(function(listData) {
      vm.estabelecimentos = listData;
    });

    sistevaSvc.list({Vende: 1}).then(function(listData) {
      vm.sistemas = listData;
    });

    vm.save = function() {

      vm.loading = true;

      var convenienciaGenerica  = {};

      if(vm.sessoes && vm.sessoes.length > 0)
      vm.item.sessoesSelect = $filter('filter')(vm.sessoes, {'Checked':'true'}).map(function (itm) {
        return itm.Id;
      }).filter(function (itm, idx, array) {
        return array.indexOf(itm) == idx;
      });


      if(vm.sistemas && vm.sistemas.length > 0)
      vm.item.sistemasSelect = $filter('filter')(vm.sistemas, {'Checked':'true'}).map(function (itm) {
        return itm.IdSistema;
      }).filter(function (itm, idx, array) {
        return array.indexOf(itm) == idx;
      });

      convenienciaGenerica.IdSistema = vm.item.sistemasSelect;
      convenienciaGenerica.IdEstabelecimento = vm.item.Estabelecimento ? vm.item.Estabelecimento.IdEstabelecimento  : null;
      convenienciaGenerica.DataInicio = vm.item.DataInicio;
      convenienciaGenerica.DataFim = null;
      convenienciaGenerica.Taxa = vm.item.TipoTaxa == "P" ? vm.item.ValorTaxa * 100 : vm.item.ValorTaxa;
      convenienciaGenerica.TipoConveniencia = vm.item.TipoTaxa;

      convenienciaGenerica.CodRegraConveniencia = vm.CodRegraConveniencia;
      convenienciaGenerica.IdAtracao = vm.item.Atracao ? vm.item.Atracao.IdAtracao  : null;
      convenienciaGenerica.IdSessao = vm.item.sessoesSelect ? vm.item.sessoesSelect  : null;
      convenienciaGenerica.IdTipoAtracao = vm.item.TipoAtracao ? vm.item.TipoAtracao.IdTipoAtracao  : null;
      convenienciaGenerica.IdTipoSessao = vm.item.TipoSessao ?  vm.item.TipoSessao.IdTipoSessao  : null;

      convenienciaGenerica.QtdParcelas = vm.item.QtdParcelas;
      convenienciaGenerica.ValorMinimoParcela = vm.item.ValorMinimoParcela;

      convenienciaSvc.PostGenerico(convenienciaGenerica).then(function() {
        vm.loading = false;
         vm.utils.ShowSuccess("Inclusão de registro", "Operação realizada com sucesso!");
         $state.go('estabelecimento.convenienciaestabelecimento.grid');
       })
         .finally(function() {
           vm.loading = false;
      });
    };

    vm.checkPlataforma = function() {
      vm.filtro = $filter('filter')(vm.sistemas, {'Checked':'true'});

      if(vm.filtro.length == 0){
        vm.LugarNaoMarcadoPlataforma = true;
        $scope.validateForm = true;
      }else {

        vm.LugarNaoMarcadoPlataforma = false;

        //check sessao
        if(vm.CodRegraConveniencia == "S"){

          vm.flt = $filter('filter')(vm.sessoes, {'Checked':'true'});

          if(vm.flt.length == 0){
            vm.LugarNaoMarcadoSessao = true;
            $scope.validateForm = true;
          }else {
            vm.LugarNaoMarcadoSessao = false;
            $scope.validateForm = false;
          }

        }else {
          $scope.validateForm = false;
        }
      }
    };

    vm.checkSessao = function() {
      if(vm.CodRegraConveniencia == "S"){
        vm.filtro = $filter('filter')(vm.sessoes, {'Checked':'true'});

        if(vm.filtro.length == 0){
          vm.LugarNaoMarcadoSessao = true;
          $scope.validateForm = true;
        }else {
          vm.LugarNaoMarcadoSessao = false;
          $scope.validateForm = false;
        }
      }

      vm.checkPlataforma();
    };

  }]);
})();

(function() {
  'use strict';

  angular.module('ticket.controller.controleingresso')
    .controller('ticket.controller.controleingresso.regraIngressoEstabelecimento.grid', [
      '$state',
      'common',
      'ticket.service.controleingresso.regraingressoestabelecimento',
      'ticket.service.controleestabelecimento.estabelecimento',
      'ticket.service.controleingresso.regraingresso'
    ,

   function(
    $state,
    common,
    regraIngressoEstabelecimentoSrv,
    estabelecimentoSvc,
    regraIngressoSvc) {

    var vm = common.controller.grid(this, estabelecimentoSvc);

   /* estabelecimentoSvc.list().then(function(estabelecimentos) {
      vm.itens = estabelecimentos;
    });*/

    vm.edit = function(itm) {
      $state.go('controleingresso.regraingressoestabelecimento.form', {IdEstabelecimento: itm.Id});
    };

     /*vm.search = function() {
      console.log(vm.Filter.Nome);

      estabelecimentoSvc.list(vm.Filter).then(function(listAll) {
        vm.itens = listAll;
      });
    };*/
  }]);

})();

(function() {
  'use strict';

  angular.module('ticket.controller.controleingresso')
    .controller('ticket.controller.controleingresso.regraIngressoEstabelecimento.form', regraIngressoEstabelecimentoFormController);

  regraIngressoEstabelecimentoFormController.$inject = [
  '$state',
  '$scope',
  'common',
  '$filter',
  '$stateParams',
  'ticket.service.controleingresso.regraingressoestabelecimento',
  'ticket.service.controleestabelecimento.estabelecimento',
  'ticket.service.controleingresso.regraingresso' ];

  function regraIngressoEstabelecimentoFormController(
    $state,
    $scope,
    common,
    $filter,
    $stateParams,
    regraIngressoEstabelecimentoSvc,
    estabelecimentoSvc,
    regraIngressoSvc) {

    var vm = common.controller.basic(this, regraIngressoEstabelecimentoSvc);
    vm.item = {};
    vm.regrasIngressoEstabelecimentoList = [];
    vm.loaded = loaded;
    vm.LugarNaoMarcado = false;
    $scope.validateForm = true;

    vm.cancel = function() {
      $state.go('controleingresso.regraingressoestabelecimento.grid');
    };

    estabelecimentoSvc.get({Id: $stateParams.IdEstabelecimento}).then(function(estabelecimento) {
      vm.estabelecimento = estabelecimento;
    });

    vm.item.IdEstabelecimento = $stateParams.IdEstabelecimento;

    regraIngressoSvc.ListByEstabelecimento({IdEstabelecimento:vm.item.IdEstabelecimento}).then(function(regrasFiltradas) {
      vm.regrasFiltradasList = regrasFiltradas;
    });

    vm.save = function() {
        vm.loading = true;

        if(vm.regrasFiltradasList.filter(function (itm) {
             return itm.Checked == true;
          }).length == 0){
          vm.LugarNaoMarcado = true;
          return ;
     }

      vm.regrasIngressoListSelect = $filter('filter')(vm.regrasFiltradasList, {'Checked':'true'});
      vm.regrasIngressoEstabelecimentoList = [];

      angular.forEach(vm.regrasIngressoListSelect, function(value, key){
           vm.regrasIngressoEstabelecimentoList.push({
            IdEstabelecimento: vm.item.IdEstabelecimento,
            IdRegraIngresso: value.IdRegraIngresso
           });
      });

      regraIngressoEstabelecimentoSvc.post(vm.regrasIngressoEstabelecimentoList).then(function () {
        vm.utils.ShowSuccess("Inclusão de registro", "Operação realizada com sucesso!");
        $state.go('controleingresso.regraingressoestabelecimento.grid');
      }).finally(function () {
        vm.loading = false;
      });
    };


    vm.check = function() {
      vm.filtro = $filter('filter')(vm.regrasFiltradasList, {'Checked':'true'});

      if(vm.filtro.length == 0){
        vm.LugarNaoMarcado = true;
        $scope.validateForm = true;
      }else {
        vm.LugarNaoMarcado = false;
        $scope.validateForm = false;
      }
    }

    function loaded() {

    }
  }
})();

(function() {
  'use strict';

  angular.module('ticket.controller.conteudo')
    .controller('ticket.controller.conteudo.video.master',['$scope','common', 'ticket.service.conteudo.video', function ($scope,common, videoSvc){

      var vm = common.controller.master(this, videoSvc);

    }]);

})();

(function() {
  'use strict';

  angular.module('ticket.controller.conteudo')
    .controller('ticket.controller.conteudo.video.grid',['$scope','common','$state','toaster', 'ticket.service.conteudo.video', function ($scope,common, $state,toaster, videoSvc){

      var vm = common.controller.grid(this, videoSvc);

      vm.editarVideo = function (item) {
        $state.go('conteudo.video.form', {IdVideoHome : item.IdVideoHome});
      }

      vm.customToggle = function customToggle(itm) {

        var text = itm.Status === 1 ? 'Deseja inativar esse video?' : 'Deseja ativar esse video?';
        var textTitle = itm.Status === 1 ? 'Inativar video' : 'Ativar video.';

        vm.utils.Confirm(textTitle, text).then(function () {
          videoSvc.toggle({IdVideoHome : itm.IdVideoHome}).then(function (v) {

            var text = '';
            if(itm.Status === 1) {
              text = 'Vídeo inativado com sucesso.';
              itm.Status = 2;
            }
            else{
                text = 'Vídeo ativado com sucesso.';
                itm.Status = 1;
              }

              toaster.pop('success', 'Sucesso', text);

          });
        });
      }

    }]);

})();

(function() {
  'use strict';

  angular.module('ticket.controller.conteudo')
    .controller('ticket.controller.conteudo.video.form',[
      '$scope',
      'common',
      '$q',
      'toaster',
      '$stateParams',
      '$state',
      '$sce',
      'ticket.service.conteudo.video',
      'ticket.service.controleestabelecimento.estabelecimento',
      'ticket.service.conteudo.atracao'
      , function ($scope,common, $q, toaster, $stateParams,$state, $sce, videoSvc, estabelecimentoSvc, atracaoSvc){

      var vm = common.controller.basic(this, videoSvc);

        vm.QueryFilter = {};
        vm.imagem = {
          Desktop : null,
          Phone : null
        }

        if($stateParams.IdVideoHome != null) {

            videoSvc.get({IdVideoHome : $stateParams.IdVideoHome}).then(function (data) {
              console.log('data',data)
              vm.data = data;

              vm.IdVideoHome = data.IdVideoHome;
              vm.IdAtracao = data.IdAtracao;
              vm.IdYouTube = data.IdYouTube;
              vm.urlVideo = $sce.trustAsResourceUrl('https://www.youtube.com/embed/' + data.IdYouTube);
              vm.imagem.Desktop = data.UriDesktop;
              vm.imagem.Phone = data.UriPhone;
              vm.Nome = data.Nome
              $scope.IdYouTube = vm.IdYouTube;
            })
        }

        // vm.getIframeSrc = function(src) {
        //   return 'https://www.youtube.com/embed/' + src;
        // };

        $scope.getIframeSrc = function(src) {
          return 'https://www.youtube.com/embed/' + src;
        };

        atracaoSvc.list({}).then(function (data) {
          vm.atracaoList = data;
        })

      //video DESKTOP
      $scope.$watch('vm.FileDesktop', function () {

        if (vm.FileDesktop != null) {
          vm.spinFotoDesktop = true;
          vm.stt_des = 'uploading'
          UploadFotoDesktop(vm.FileDesktop);
        }
      });

      $scope.$watch('vm.IdYouTube', function () {
        //vm.urlVideo = $sce.trustAsResourceUrl('https://www.youtube.com/embed/' + vm.IdYouTube)

        $scope.IdYouTube = vm.IdYouTube;
      });

      vm.uploadDesktop = function ($files) {
        UploadFotoDesktop($files);
      }

      vm.DeleteFotoDesktop = function (imagem, ev) {

        vm.utils.Confirm('EXCLUIR', 'Confirma a exclusão da imagem?').then(function () {
          vm.imagem.Desktop = null;
        });
      };

      function UploadFotoDesktop(files) {

        if (files.length > 0) {

          upload(files).then(function (v) {
            vm.imagem.Desktop = v[0];
            var imgs = [];
            imgs.push({w: 740, h: 380});

          }).finally(function () {
            vm.spinFotoDesktop = false;
          });
        }
      }
      //FIM BANNER DESKTOP

      //BANNER CELULAR
      $scope.$watch('vm.FilePhone', function () {
        if (vm.FilePhone != null) {
          vm.spinFotoPhone = true;
          UploadFotoPhone(vm.FilePhone);
        }
      });

      vm.uploadPhone = function ($files) {
        UploadFotoPhone($files);
      };

      function UploadFotoPhone(files) {

        if (files.length > 0) {

          upload(files).then(function (v) {
            vm.imagem.Phone = v[0];
          }).finally(function () {
            vm.spinFotoDesktop = false;
          });
        }
      }

      vm.DeleteFotoPhone = function (imagem, ev) {
        vm.utils.Confirm('EXCLUIR', 'Confirma a exclusão da imagem?').then(function () {
          vm.imagem.Phone = null;
        });
      };

      //FIM BANNER CELULAR
      function upload($files) {

        if ($files.length > 0) {

          var def = $q.defer();
          var file = $files[0];
          var result = [];
          var reader = new FileReader();
          reader.onerror = reader.onabort = function () {
            def.reject('Falha ao ler o arquivo')
          }
          reader.onload = function (evt) {
            $scope.$apply(function () {
              if (result.indexOf(evt.target.result) === -1) {
                result.push(evt.target.result);
              }

              if ($files.length == 0)
                def.resolve(result);
              else
                reader.readAsDataURL($files.splice(0, 1)[0]);
            });
          };
          reader.readAsDataURL($files.splice(0, 1)[0]);
          return def.promise;
        }
      };


      vm.Save = function () {

        var image = document.createElement('img');
        image.src = vm.imagem.Desktop;

        var form =
          {
            IdVideoHome : vm.IdVideoHome,
            Nome : vm.Nome,
            Base64Desktop :  vm.imagem.Desktop,
            Base64Phone :  vm.imagem.Phone,
            IdAtracao : vm.IdAtracao,
            IdYouTube : vm.IdYouTube,
            UriDesktop : vm.data ? vm.data.UriDesktop : null,
            ArquivoDesktop : vm.data ? vm.data.ArquivoDesktop : null,
            UriPhone : vm.data ? vm.data.UriPhone : null,
            ArquivoPhone : vm.data ? vm.data.ArquivoPhone : null
          };

        var imageDesktop = document.createElement('img');
        imageDesktop.src = vm.imagem.Desktop;
        if(imageDesktop.width != 1120 || imageDesktop.height != 400)
        {
          toaster.pop('warning', 'Aviso!', 'Imagem para exibição desktop não está no formaro de 1120x400.');
           return false;
         }

        var imagePhone = document.createElement('img');
        imagePhone.src = vm.imagem.Phone
        if(imagePhone.width != 375 || imagePhone.height != 471)
         {
           toaster.pop('warning', 'Imagem para exibição em celular não está no formaro de 375x471.');
           return false;
         }

        videoSvc.uploadVideo(form).then(function (data) {

          if(data.status == 200) {
            toaster.pop('success', 'Banners salvo com sucesso');
            $state.go('conteudo.video.grid');
          }
          else{
            if(data.data.ExceptionType == "Barn.Util.BarnException")
                  toaster.pop('warning', data.data.ExceptionMessage);
            else
                  toaster.pop('error', data.data.ExceptionMessage);
          }

        },function (data) {
        });
      }

    }]);

})();

(function() {
  'use strict';
  angular.module('ticket.controller.conteudo')
    .config(routeConfig);

  routeConfig.$inject = ['$stateProvider'];

  function routeConfig($stateProvider) {
    $stateProvider
      .state('conteudo.video', {
        abstract: true,
        url: '/video',
        parent: 'conteudo',
        templateUrl: "view/conteudo/video/index.html"
      })
      .state('conteudo.video.grid', {
        url: '/consulta',
        parent: 'conteudo.video',
        data: {
          displayName: 'Vídeo'
        },
        templateUrl: 'view/conteudo/video/grid.html',
        controller: 'ticket.controller.conteudo.video.grid',
        controllerAs: 'vm'
      })

      .state('conteudo.video.form', {
        url: '/form/:IdVideoHome',
        params: {
          IdVideoHome: null
        },
        parent: 'conteudo.video',
        data: {
          displayName: 'Adicionar video'
        },
        templateUrl: 'view/conteudo/video/form.html',
        controller: 'ticket.controller.conteudo.video.form',
        controllerAs: 'vm'
      })
  }
})();

(function() {
  'use strict';

  angular
    .module('ticket.controller.programacao', [

    ]);
})();

(function() {
  'use strict';

  angular.module('ticket.controller.programacao')
    .controller('ticket.controller.programacao.resumoprogramacao',[
      '$state',
      '$scope',
      'common',
      'dateFilter',
      '$filter',
      '$stateParams',
      'ticket.service.programacao',
      'ticket.service.controleestabelecimento.estabelecimento',
      function(
        $state,
        $scope,
        common,
        dateFilter,
        $filter,
        $stateParams,
        sessaoSvc,
        estabelecimentoSvc) {

        var vm = common.controller.basic(this);

        vm.oneAtATime = false;
        vm.accordionArray = []
        //USAR SELECT  > ISESSAOLOTE

        sessaoSvc.resumoProgramacao({Id:  $stateParams.IdSessao}).then(function(data) {
          data.HoraAbertura = moment(data.HoraAbertura, "HH:mm").format('HH:mm');
          vm.item = data;
          vm.item.DiaSemana = moment(data.DataHoraInicio).format('dddd').substring(0,3).toUpperCase();
          if(vm.item.ListaTipoIngresso && vm.item.ListaTipoIngresso.$values) vm.Ordena(vm.item.ListaTipoIngresso.$values);
        });


        vm.Ordena = function (lista) {
          var indexedTeams = [];
          vm.ListaSetorTipoIngressos = [];

          lista.map(function(itm) {
            var teamIsNew = indexedTeams.indexOf(itm.IdSetor) == -1;
            if (teamIsNew) {
              indexedTeams.push(itm.IdSetor);
              vm.ListaSetorTipoIngressos.push(
                {
                  IdSetor: itm.IdSetor,
                  NomeSetor: itm.NomeSetor,
                  ValorBase: itm.ValorBase,
                  ListaTipoIngresso: $filter('filter')(lista, {'IdSetor':itm.IdSetor})
                }
              );
            }
          });
        };

        vm.cancel = function (itm) {
          $state.go('programacao.grid');
        }

      }]);
})();

(function () {
  'use strict';

  angular.module('ticket.controller.programacao')
    .controller('ticket.controller.programacao.ingresso', [
      '$scope',
      '$state',
      'common',
      '$stateParams',
      '$uibModal',
      'toaster',
      'ticket.service.programacao',
      'ticket.service.programacao.sessaotiposessaoempresa',
      function ($scope, $state, common, $stateParams, $uibModal,toaster , sessaoSvc, sessaotiposessaoempresaSvc) {
        var vm = common.controller.basic(this);

        vm.oneAtATime = true;
        vm.accordionArray = [];
        //Para o Primeiro setor sempre vir aberto.
        vm.accordionArray[0] = true;

        vm.Sessao = {
          ListaSessaoTipoSessaoEmpresa : []
        };
        //;
        vm.IdEstabelecimento = $stateParams.IdEstabelecimento;

        if ($stateParams.Id) {
          MontaSessao($stateParams.Id)
        }

        function MontaSessao(idSessao, copia) {

          vm.lotes = [];
          vm.setores = [];
          vm.IdSessao = idSessao;

          if (vm.IdSessao) {
            sessaoSvc.get({
              Id: idSessao
            }).then(function (sessao) {

              if (sessao != null) {

                vm.Sessao.Id = vm.IdSessao;
                vm.Sessao.IdTipoAtracao = sessao.IdTipoAtracao;
                vm.Sessao.IdAtracao = sessao.IdAtracao;
                vm.Sessao.IdSala = sessao.IdSala;
                vm.Sessao.IdLayout = sessao.IdLayout;
                vm.Sessao.VendeRemoto = sessao.VendeRemoto;

                vm.Sessao.ExistiuVenda = copia ? false : sessao.ExistiuVenda;
                vm.Sessao.ModelCancelaReservaMinutoAntes = sessao.ModelCancelaReservaMinutoAntes;
                vm.Sessao.ModelDataEncerraVendaAposSessao = sessao.ModelDataEncerraVendaAposSessao;
                vm.Sessao.ModelDataEncerraVendaRemotoAntesSessao = sessao.ModelDataEncerraVendaRemotoAntesSessao;

                vm.Sessao.IdTipoLote = sessao.IdTipoLote;
                vm.Sessao.IdTipoAudio = sessao.IdTipoAudio;
                vm.Sessao.IdLegendaIdioma = sessao.IdLegendaIdioma;

                vm.Sessao.IdEstabelecimento = sessao.IdEstabelecimento;

                vm.Sessao.IdProducao = sessao.IdProducao;

              }
            });

            // sessaotiposessaoempresaSvc.list({
            //   IdSessao: vm.IdSessao
            // }).then(function (data) {
            //   //vm.Sessao.ListaSessaoTipoSessaoEmpresa.push(data);
            // });
          }

          sessaoSvc.listSessao({
            Id: vm.IdSessao
          }).then(function (sessaoLotes) {

            if (!sessaoLotes || sessaoLotes.length === 0) return;

            for (var k = 0; k < sessaoLotes[0].ListaSetores.length; k++) {

              var st = sessaoLotes[0].ListaSetores[k];

              vm.setores.push({
                IdLayout: null,
                IdMapa: null,
                InformacaoAcesso: null,
                MsgIngresso: null,
                NomeZona: st.NomeZona,
                //VendeRemoto: true,
                QuantidadeLugares: st.QtdLugaresMaxima,
                Nome: st.NomeSetor,
                Id: st.IdSetor,
                LugarMarcado: st.LugarMarcado,
                ValorBase: st.ValorBase,
                IdSessao : idSessao
              });
            }

            for (var i = 0; i < sessaoLotes.length; i++) {
              var lote = sessaoLotes[i];
              var NewLote = {
                IndexLote: (vm.lotes.length + 1) - vm.QtdLoteDeleted,
                IdLote: copia ? null : lote.IdLote,
                setores: [],
                spinDelLot: false,
                QtdIngresso: lote.Quantidadeingresso,
                DataEncerramentoLote: new Date(lote.DataEncerramentoLote),
                HoraEncerramentoLote: lote.HoraEncerramentoLote,
                ExistiuVenda: copia ? false : lote.ExistiuVenda,
                LoteEncerrado: copia ? false : lote.LoteEncerrado,
                active: i == 0 ? true : false,
                IdSessaoLote: copia ? null : lote.IdSessaoLote
              };

              for (var j = 0; j < lote.ListaSetores.length; j++) {
                var setor = lote.ListaSetores[j];

                var valorBase = 0;
                if (setor.ListaIngressos.length > 0)
                  valorBase = setor.ListaIngressos[0].ValorBase;

                var setorNew = {
                  IdSetor: setor.IdSetor,
                  Nome: setor.NomeSetor,
                  NomeZona: setor.NomeZona,
                  QuantidadeLugares: setor.QtdLugaresMaxima,
                  tipoIngresso: [],
                  ValorBase: valorBase,
                  LugarMarcado: setor.LugarMarcado,
                  tabelaPreco: {},
                  IdSessaoSetor: copia ? null : setor.IdSessaoSetor
                }

                for (var l = 0; l < setor.ListaIngressos.length; l++) {
                  var ingresso = setor.ListaIngressos[l];
                  //console.log('ingresso',ingresso);
                  var ingressoNew = {
                    IdSessaoSetorLotePrecoIngresso: copia ? null : ingresso.IdSessaoSetorLotePrecoIngresso,
                    IdTipoingresso: ingresso.IdEstabelecimentoIngresso,
                    Nome: ingresso.NomeIngresso,
                    Valor: ingresso.ValorIngresso,
                    IdSetor: ingresso.IdSetor,
                    TipoDesconto: ingresso.TipoDesconto,
                    ValorRegra: ingresso.ValorRegra,
                    IdEstabelecimentoIngresso: ingresso.IdEstabelecimentoIngresso,
                    deleted: null,
                    StatusRegistro: null,
                    excluido: false,
                    ValorBase: setor.ValorBase,
                    IdRegraIngresso: ingresso.IdRegraIngresso,
                    ExibeQtd : ingresso.ExibeQtd,
                    QuantidadeIngressos : ingresso.QuantidadeMaximaIngressos > 0 ? ingresso.QuantidadeMaximaIngressos : null,
                    IdSessaoIngresso : ingresso.IdSessaoIngresso,
                    DefineValorNaSessao : ingresso.DefineValorNaSessao,
                    VendeBilheteria : ingresso.VendeBilheteria,
                    VendeRemoto : ingresso.VendeRemoto

                  }
                  setorNew.tipoIngresso.push(ingressoNew);
                }
                NewLote.setores.push(setorNew);
              }
              vm.lotes.push(NewLote);
            }

          }).finally(function () {

            if (vm.setores.length > 0) {
              vm.QtdIngressoSetores = vm.setores.map(function (itm) {
                return itm.QuantidadeLugares;
              }).reduce(function (total, value) {
                return total + value;
              });
            }
          });
        }

        //Adiciona ingressos ao setor
        vm.addTipoIngresso = function (lote, setor, $event, index, IdEstabelecimento) {

          //vm.ValidaLote();

          $event.preventDefault();
          $event.stopPropagation();

          vm.accordionArray[index] = true;

          $uibModal.open({
            animation: false,
            templateUrl: 'view/conteudo/programacao/popup/ingresso.popup.html',
            controller: 'ticket.controller.conteudo.programacao.popingresso',
            controllerAs: 'vm',
            size: 'lg',
            resolve: {
              setor: function () {
                return setor
              },
              IdEstabelecimento: function () {
                return vm.IdEstabelecimento
              }
            }
          }).result.then(function (items) {

            var valor = 0;

            if (items.length > 0) {

              for (var i = 0; i < items.length; i++) {
                //Se a RegraIngresso for "8", o valor a ser pego é o da própria regra. Pois é para valor fixo.
                if (items[i].IdRegraIngresso == 8) {
                  valor = items[i].ValorRegra;
                } else {

                  valor = parseFloat(items[i].TipoDesconto == 'F' ? setor.ValorBase !== null ? setor.ValorBase - items[i].ValorRegra : 0 : setor.ValorBase !== null ? setor.ValorBase - ((setor.ValorBase * items[i].ValorRegra)) : 0);
                }
                setor.tipoIngresso.push({
                  IdSessaoSetorLotePrecoIngresso: null,
                  IdTipoingresso: items[i].IdEstabelecimentoIngresso,
                  Nome: items[i].Nome,
                  Valor: valor > 0 ? valor : 0,
                  IdSetor: setor.IdSetor,
                  TipoDesconto: items[i].TipoDesconto,
                  ValorRegra: items[i].TipoDesconto == "F" ? items[i].ValorRegra : items[i].ValorRegra,
                  IdEstabelecimentoIngresso: items[i].Id,
                  deleted: null,
                  excluido: false,
                  IdRegraIngresso: items[i].IdRegraIngresso,
                  DefineValorNaSessao : items[i].DefineValorNaSessao,
                  VendeBilheteria : items[i].VendeBilheteria,
                  VendeRemoto : items[i].VendeRemoto
                });
              }
            }
            ValidaIngressoSetor();
          });
        }

        vm.delIngresso = function (item, setor) {

          if (item.IdSessaoSetorLotePrecoIngresso == null) {
            item.deleted = true;
          } else {
            item.excluido = true;
            item.deleted = true;
          }

          if (setor.tipoIngresso.length > 0) {

            var ingresso = setor.tipoIngresso = setor.tipoIngresso.filter(function (itm) {

              return itm.deleted == null || (itm.deleted == true && itm.excluido == true);
            });

            if (ingresso.length == 0)
              setor.tabelaPreco = {};
          }
          ValidaIngressoSetor();
        }

        function ValidaIngressoSetor() {


          for (var i = 0; i < vm.lotes.length; i++) {
            var lote = vm.lotes[i];

            if (lote.setores.length > 0) {

              vm.HasIngresso = true;

              for (var j = 0; j < lote.setores.length; j++) {
                var setor = lote.setores[j];


                if (setor.tipoIngresso.length == 0) {
                  vm.HasIngresso = false;
                  return false;
                }

                setor.IngNeg = false;

                setor.tipoIngresso.forEach(function (itm) {

                  if (itm.Valor <= 0 && itm.IdRegraIngresso != 5) {
                    vm.HasIngresso = false;
                    setor.IngNeg = true;
                  }
                })
              }
            }
          }
        }

        vm.save = function () {

          var ListaSessaoLote = [];
          var sessaoLote = {};
          var ListaSessaoSetor = [];
          var sessaoSetor = {};
          var ListaSessaoSetorLotePrecoIngresso = [];
          var sessaoSetorLotePrecoIngresso = {};
          var ListSessao = [];
          ListSessao.push(vm.Sessao);

          if (vm.lotes.length > 0) {
            for (var i = 0; i < vm.lotes.length; i++) {

              if (vm.lotes[i].setores.length > 0) {

                for (var j = 0; j < vm.lotes[i].setores.length; j++) {

                  if (vm.lotes[i].setores[j].tipoIngresso.length > 0) {

                    for (var l = 0; l < vm.lotes[i].setores[j].tipoIngresso.length; l++) {
                      var p = vm.lotes[i].setores[j].tipoIngresso[l];

                      //if(!p.excluido) {
                        var valorBase = vm.lotes[i].setores[j].ValorBase;
                        sessaoSetorLotePrecoIngresso = {
                          Id: p.IdSessaoSetorLotePrecoIngresso,
                          IdSessaoSetor: null,
                          IdSessaoLote: null,
                          IdEstabelecimentoIngresso: p.IdEstabelecimentoIngresso,
                          ValorIngresso: p.Valor,
                          excluido: p.excluido,
                          ValorBase: valorBase,
                          IdRegraIngresso: p.IdRegraIngresso,
                          QuantidadeIngressos: p.QuantidadeIngressos,
                          IdSessaoIngresso : p.IdSessaoIngresso
                        }
                      //}

                      if (ListaSessaoSetorLotePrecoIngresso !== null || ListaSessaoSetorLotePrecoIngresso !== undefined)
                        ListaSessaoSetorLotePrecoIngresso.push(sessaoSetorLotePrecoIngresso);
                      sessaoSetorLotePrecoIngresso = null;
                    }
                  }

                  var s = vm.lotes[i].setores[j];
                  sessaoSetor = {
                    Id: s.IdSessaoSetor,
                    IdSessao: vm.IdSessao,
                    IdSetor: s.IdSetor,
                    QtdLugaresMaxima: s.QuantidadeLugares,
                    LugarMarcado: s.LugarMarcado,
                    ListaSessaoSetorLotePrecoIngresso: ListaSessaoSetorLotePrecoIngresso
                  }
                  ListaSessaoSetorLotePrecoIngresso = [];
                  ListaSessaoSetor.push(sessaoSetor);
                  sessaoSetor = [];
                }
              }

              var l = vm.lotes[i];

              sessaoLote = {
                Id: l.IdSessaoLote,
                IdSessaoLote: null,
                IdSessao: vm.IdSessao,
                DataHoraEncerramento: l.DataEncerramentoLote,
                HoraEncerramentoLote: l.HoraEncerramentoLote,
                QuantidadeIngressos: vm.PossuiLote ? l.QtdIngresso : vm.QtdIngressoSetores,
                ListaSessaoSetor: ListaSessaoSetor,
                deleted: l.deleted,
                Ordem: l.IndexLote
              }
              ListaSessaoSetor = [];
              ListaSessaoLote.push(sessaoLote);
              sessaoLote = null;
            }
          }

          sessaoSvc.alteraringresso({
            ListaSessaoLote: ListaSessaoLote,
            ListaSessao: ListSessao
          }).then(function () {
            toaster.pop('success', 'Sucesso!', 'Programação Alterada com sucesso!');
            $state.go('programacao.grid');
          });
        }

        vm.incluirQuantidade = function (itm) {
          itm.ExibeQtd = true;
        }

        vm.cancel = function (itm) {
          $state.go('programacao.grid');
        }
      }
    ])
    .controller("ticket.controller.conteudo.programacao.popingresso", [
      "common",
      "$scope",
      "$uibModalInstance",
      "setor",
      "IdEstabelecimento",
      "$rootScope",
      "ticket.service.ingresso.estabelecimentoingresso",
      function (common, $scope, $uibModalInstance, setor, IdEstabelecimento, $rootScope, ingressoSvc) {
        var vm = common.controller.grid(this, ingressoSvc);

        vm.search = function () {
          ingressoSvc.getAll({
            Config: {
              Skip: 0,
              Top: 20
            },
            Filter: {
              IdEstabelecimento: IdEstabelecimento,
              Nome : vm.Filter.Nome
            }
          }).then(function (data) {
            vm.items = data;
            vm.dirty = true;
            vm.Tabelaingressos = data.filter(function (itm) {
              return setor.tipoIngresso.filter(function (itmTable) {
                  return (itmTable.IdEstabelecimentoIngresso == itm.Id) && itmTable.deleted != true;
                }).length == 0;
            });
          });
        }

        vm.LimteAlcancado = false;

        var gridIngressos = angular.copy(setor);

        //Só faço o count com os Ingresso que não foram deletados, pois os ingressos que foram deletadas permanecem no objeto com o "deleted = true".
        var countGrid = gridIngressos.tipoIngresso.filter(function (itm) {
          return itm.deleted == null;
        }).length;

        if (countGrid == 30)
          vm.LimteAlcancado = true;

        vm.selected = function (items, itm) {

          if (itm.selected)
            itm.selected = false;
          else
            itm.selected = true;

          var count = items.filter(function (itm) {
            return itm.selected == true > 0
          }).length;

          if (count > 0)
            vm.btnPopupIngresso = true;
          else
            vm.btnPopupIngresso = false;

        }
        vm.myfilter = function (v) {
          return v.selected == true;
        };

        vm.Confirm = function (lst) {
          var countLst = lst.length;
          if ((countGrid + countLst) > 30) {
            vm.LimteAlcancado = true;
            return false;
          }
          else {
            vm.LimteAlcancado = false;
          }

          $uibModalInstance.close(lst);
        };
        vm.Cancel = function () {
          $uibModalInstance.dismiss('cancel');
        };
      }
    ])
})();

(function() {
  'use strict';
  angular.module('ticket.controller.programacao')
    .controller('ticket.controller.programacao.grid',
      [
      "$scope",
      "$state",
      'common',
      'toaster',
      'ticket.service.programacao',
      'ticket.service.conteudo.atracao',
      'ticket.service.controleestabelecimento.estabelecimento',
      function($scope, $state, common,toaster,programacaoSvc, atracaoSvc, estabelecimentoSvc) {
        var vm = common.controller.grid(this, programacaoSvc);

        vm.Filter.Encerrada = false;

        vm.changeNaoLiberada = function () {
          if (vm.Filter.VendaLiberada) {
            vm.Filter.Todos = false;
          }
          else {
            vm.Filter.Todos = null;
          }
        };

        $scope.$watch('vm.Filter.IdEstabelecimento', function() {

          if(vm.Filter.IdEstabelecimento){
            atracaoSvc.listAtracaoProgramacao({IdEstabelecimento: vm.Filter.IdEstabelecimento}).then(function(listData) {
              if(listData.length>0)
                vm.atracoes = listData;
              else{

                vm.atracoes = null;
                if(vm.Filter.IdAtracao)
                  vm.Filter.IdAtracao = null;
              }
            });
          }else {
            vm.atracoes = null;
            if(vm.Filter.IdAtracao)
              vm.Filter.IdAtracao = null;
          }
        });

        estabelecimentoSvc.list({}).then(function(listData) {
          vm.estabelecimentos = listData;
        });

        vm.editaringresso = function (itm) {
          $state.go('programacao.ingresso',{Id: itm.Id, IdEstabelecimento : itm.IdEstabelecimento});
        }

        vm.resumoProgramacao = function (itm) {
          $state.go('programacao.resumoprogramacao', {IdSessao: itm.Id});
        }
      }
    ])

})();

(function () {
  'use strict';

  angular.module('ticket.controller.programacao')
    .controller('ticket.controller.programacao.form', [
      '$scope',
      '$state',
      'common',
      function ($scope, $state, common) {
        var vm = common.controller.form(this);
      }
    ])
})();

(function() {
  'use strict';

  angular
    .module('ticket.controller.programacao')
    .config(moduleConfig);

  /* @ngInject */
  function moduleConfig($stateProvider, menuProvider) {

    $stateProvider
      .state('programacao', {
        abstract: true,
        url: '/programacao',
        templateUrl: "view/site/_content.html"
      })

      .state('programacao.grid', {
        url: '/consulta',
        parent: 'programacao',
        data: {
          displayName: 'Programação'
        },
        templateUrl: 'view/conteudo/programacao/grid.html',
        controller: 'ticket.controller.programacao.grid',
        controllerAs: 'vm'
      })

    .state('programacao.form', {
      url: '/form/:Id',
      params: {
        Id: null
      },
      parent: 'programacao',
      data: {
        displayName: 'Programação'
      },
      templateUrl: 'view/conteudo/programacao/form.html',
      controller: 'ticket.controller.programacao.form',
      controllerAs: 'vm'
    })

    .state('programacao.ingresso', {
      url: '/ingresso/:Id/:IdEstabelecimento',
      params: {
        Id: null,
        IdEstabelecimento:null
      },
      parent: 'programacao',
      data: {
        displayName: 'Programação'
      },
      templateUrl: 'view/conteudo/programacao/ingresso.html',
      controller: 'ticket.controller.programacao.ingresso',
      controllerAs: 'vm'
    })

     // .state('programacao.cancelamento', {
     //    data: {
     //      displayName: 'Cancelamento'
     //    },
     //    abstract: true,
     //    parent: 'programacao',
     //    url: '/cancelamento',
     //    templateUrl: 'view/conteudo/programacao/venda/cancelamento/index.html',
     //    controller: 'ticket.controller.programacao.cancelamento',
     //    controllerAs: 'vm'
     //  })
     //
     //
     //  .state('programacao.cancelamento.form', {
     //    data: {
     //      displayName: 'Cancelamento'
     //    },
     //    url: '/form/:CodRastreio',
     //    params: {
     //      CodRastreio: null
     //    },
     //    parent: 'programacao.cancelamento',
     //    templateUrl: 'view/conteudo/programacao/venda/cancelamento/form.html',
     //    controller: 'ticket.controller.programacao.cancelamento.form',
     //    controllerAs: 'vm'
     //  })
     //
     //
     //  .state('programacao.troca', {
     //    data: {
     //      displayName: 'Venda'
     //    },
     //    abstract: true,
     //    parent: 'programacao',
     //    url: '/troca',
     //    templateUrl: 'view/conteudo/programacao/venda/troca/index.html',
     //    controller: 'ticket.controller.programacao.troca',
     //    controllerAs: 'vm'
     //  })
     //
     //
     //  .state('programacao.troca.form', {
     //    data: {
     //      displayName: 'Troca'
     //    },
     //    url: '/form/:CodRastreio',
     //    params: {
     //      CodRastreio: null
     //    },
     //    parent: 'programacao.troca',
     //    templateUrl: 'view/conteudo/programacao/venda/troca/form.html',
     //    controller: 'ticket.controller.programacao.troca.form',
     //    controllerAs: 'vm'
     //  })
     //
     //  .state('programacao.venda', {
     //    data: {
     //      displayName: 'Venda'
     //    },
     //    abstract: true,
     //    parent: 'programacao',
     //    url: '/venda',
     //    templateUrl: 'view/conteudo/programacao/venda/index.html',
     //    controller: 'ticket.controller.programacao.venda',
     //    controllerAs: 'vm'
     //  })
     //
     //  .state('programacao.venda.grid', {
     //    templateUrl: 'view/conteudo/programacao/venda/grid.html',
     //    url: '/consulta',
     //    parent: 'programacao.venda',
     //    data: {
     //      displayName: 'Pesquisa Venda'
     //    },
     //    params: {
     //      items: null,
     //      filter: null
     //    },
     //    controller: 'ticket.controller.programacao.venda.grid',
     //    controllerAs: 'vm'
     //  })

      .state('programacao.resumoprogramacao', {
        data: {
          displayName: 'Resumo da Programação'
        },
        url: '/resumoProgramacao/:IdSessao',
        params: {
          IdSessao: null
        },
        parent: 'programacao',
        templateUrl: 'view/conteudo/programacao/resumoProgramacao/resumo.html',
        controller: 'ticket.controller.programacao.resumoprogramacao',
        controllerAs: 'vm'
      });



    menuProvider.left.add({
      name: 'Programação',
      icon: 'fa fa-building',
      type: 'link',
      priority: 1.0,
      state: 'programacao',
      childs: [{
        second:true,
        name: 'Consultar',
        icon: 'fa fa-building',
        type: 'link',
        priority: 1.0,
        state: 'programacao.grid'
      }]
    });

    menuProvider.left.add({
      type: 'divider',
      priority: 1.1
    });
  }
})();

(function() {
  'use strict';

  angular.module('ticket.controller.conteudo')
    .controller('ticket.controller.conteudo.inadequacao.grid', inadequacaoGridController);

  inadequacaoGridController.$inject = [
    'common',
    'ticket.service.conteudo.inadequacao'
  ];

  function inadequacaoGridController(common, inadequacaoSrv) {
    var vm = common.controller.grid(this, inadequacaoSrv);
  }

})();
(function() {
  'use strict';

  angular.module('ticket.controller.conteudo')
    .controller('ticket.controller.conteudo.inadequacao.form', inadequacaoFormController);

  inadequacaoFormController.$inject = ['common', 'ticket.service.conteudo.inadequacao'];

  function inadequacaoFormController(common, inadequacaoSrv) {
    var vm = common.controller.form(this, inadequacaoSrv);
  }
})();
(function() {
  'use strict';

  angular.module('ticket.controller.conteudo')
    .controller('ticket.controller.conteudo.genero.grid', generoGridController);

  generoGridController.$inject = [
    'common',
    'ticket.service.conteudo.genero'
  ];

  function generoGridController(common, generoSrv) {
    var vm = common.controller.grid(this, generoSrv);
  }

})();
(function() {
  'use strict';

  angular.module('ticket.controller.conteudo')
    .controller('ticket.controller.conteudo.genero.form', bandaFormController);

  bandaFormController.$inject = ['$state', '$stateParams', 'common', 'ticket.service.conteudo.genero', 'listTipoAtracao'];

  function bandaFormController($state, $stateParams, common, generoSrv, listTipoAtracao) {
    var vm = common.controller.form(this, generoSrv);
    vm.listaTipoAtracao = listTipoAtracao;
    if (!edit())
      vm.save = post;
    else
      vm.save = put;


    function edit() {
      if (!$stateParams || !$stateParams.Id) return false;
      vm.editing = true;
      generoSrv.get($stateParams).then(function(data) {
        vm.item = {};
        vm.item.Genero = {};
        vm.item.GeneroTipoAtracao = {};

        vm.item.Genero.Nome = data.Nome;
        vm.item.Genero.Id = data.Id;
        vm.item.GeneroTipoAtracao.IdTipoAtracao = data.IdTipoAtracao;
        return vm.item;
      });
      return true;
    }

    function post() {
      generoSrv.postGestao(vm.item).then(function(data) {

        vm.utils.ShowSuccess("Inclusão de registro", "Operação realizada com sucesso!");
        $state.go('^.grid');
        return data;

      });
    }

    function put() {
      generoSrv.putGestao(vm.item).then(function(data) {

        vm.utils.ShowSuccess("Inclusão de registro", "Operação realizada com sucesso!");
        $state.go('^.grid');
        return data;

      });
    }
  }
})();

(function() {
  'use strict';
  angular.module('ticket.controller.conteudo')
    .config(routeConfig);

  routeConfig.$inject = ['$stateProvider'];

  function routeConfig($stateProvider) {
    $stateProvider
      .state('conteudo.banner', {
        abstract: true,
        url: '/banner',
        parent: 'conteudo',
        templateUrl: "view/conteudo/banner/index.html"
      })
      .state('conteudo.banner.grid', {
        url: '/consulta',
        parent: 'conteudo.banner',
        data: {
          displayName: 'Banner'
        },
        templateUrl: 'view/conteudo/banner/grid.html',
        controller: 'ticket.controller.conteudo.banner.grid',
        controllerAs: 'vm'
      })

      .state('conteudo.banner.form', {
        url: '/form/:IdAtracao',
        params: {
          IdAtracao: null
        },
        parent: 'conteudo.banner',
        data: {
          displayName: 'Adicionar banner'
        },
        templateUrl: 'view/conteudo/banner/form.html',
        controller: 'ticket.controller.conteudo.banner.form',
        controllerAs: 'vm'
      })
  }
})();

(function() {
  'use strict';

  angular.module('ticket.controller.conteudo')
    .controller('ticket.controller.conteudo.banner.master',['$scope','common', 'ticket.service.conteudo.banner', function ($scope,common, bannerSvc){

      var vm = common.controller.master(this, bannerSvc);

    }]);

})();

(function() {
  'use strict';

  angular.module('ticket.controller.conteudo')
    .controller('ticket.controller.conteudo.banner.grid',['$scope','common','$state','toaster', 'ticket.service.conteudo.banner', function ($scope,common, $state,toaster, bannerSvc){

      var vm = common.controller.grid(this, bannerSvc);

      vm.editarBanner = function (item) {
        $state.go('conteudo.banner.form', {IdAtracao : item.IdAtracao});
      }

      vm.customToggle = function customToggle(itm) {

        var text = itm.Status === 1 ? 'Deseja inativar esse banner?' : 'Deseja ativar esse banner?';
        var textTitle = itm.Status === 1 ? 'Inativar banner' : 'Ativar banner.';

        vm.utils.Confirm(textTitle, text).then(function () {
          bannerSvc.desabilitarBanner({IdAtracao : itm.IdAtracao}).then(function (v) {

            var text = '';
            if(itm.Status === 1) {
              text = 'Banner inativado com sucesso.';
              itm.Status = 2;
            }
            else{
                text = 'Banner ativado com sucesso.'
                itm.Status = 1;
              }

              toaster.pop('success', 'Sucesso', text);

          });
        });
      }

    }]);

})();

(function() {
  'use strict';

  angular.module('ticket.controller.conteudo')
    .controller('ticket.controller.conteudo.banner.form',[
      '$scope',
      'common',
      '$q',
      'toaster',
      '$stateParams',
      '$state',
      'ticket.service.conteudo.banner',
      'ticket.service.controleestabelecimento.estabelecimento',
      'ticket.service.conteudo.atracao'
      , function ($scope,common, $q, toaster, $stateParams,$state, bannerSvc,estabelecimentoSvc, atracaoSvc){

      var vm = common.controller.basic(this, bannerSvc);

        vm.QueryFilter = {};
        vm.Banner = {
          Desktop : null,
          Phone : null
        }

        if($stateParams.IdAtracao != null)
        {
          bannerSvc.getbanners({IdAtracao :$stateParams.IdAtracao }).then(function (data) {

            vm.Banner.Phone = data.filter(function (itm) {return itm.IdTipoArquivo == 6})[0].Uri;

            vm.Banner.Desktop = data.filter(function (itm) {return itm.IdTipoArquivo == 7})[0].Uri;

            vm.IdEstabelecimento = data[0].IdEstabelecimento;
            vm.IdAtracao = data[0].IdAtracao;
            vm.Prioridade = data[0].Prioridade;

            vm.data = data;
          })
        }

        estabelecimentoSvc.listgestao({}).then(function (list) {
          vm.estabelecimentoList = list;
        });

        $scope.$watch('vm.IdEstabelecimento', function() {
          if (vm.IdEstabelecimento) {
            atracaoSvc.listConveniencia({IdEstabelecimento: vm.IdEstabelecimento}).then(function (list) {
              if (list.length > 0)
                vm.atracaoList = list;
              else
                vm.atracaoList = null;

            });
          } else {
            vm.atracaoList = null;
          }

        });



      //BANNER DESKTOP
      $scope.$watch('vm.FileDesktop', function () {

        if (vm.FileDesktop != null) {
          vm.spinFotoDesktop = true;
          vm.stt_des = 'uploading'
          UploadFotoDesktop(vm.FileDesktop);
        }
      });

      vm.uploadDesktop = function ($files) {
        UploadFotoDesktop($files);
      }

      vm.DeleteFotoDesktop = function (imagem, ev) {

        vm.utils.Confirm('EXCLUIR', 'Confirma a exclusão da imagem?').then(function () {
          vm.Banner.Desktop = null;
        });
      };

      function UploadFotoDesktop(files) {

        if (files.length > 0) {

          upload(files).then(function (v) {
            vm.Banner.Desktop = v[0];
            var imgs = [];
            imgs.push({w: 740, h: 380});

          }).finally(function () {
            vm.spinFotoDesktop = false;
          });
        }
      }
      //FIM BANNER DESKTOP

      //BANNER CELULAR
      $scope.$watch('vm.FilePhone', function () {
        if (vm.FilePhone != null) {
          vm.spinFotoPhone = true;
          UploadFotoPhone(vm.FilePhone);
        }
      });

      vm.uploadPhone = function ($files) {
        UploadFotoPhone($files);
      };

      function UploadFotoPhone(files) {

        if (files.length > 0) {

          upload(files).then(function (v) {
            vm.Banner.Phone = v[0];
          }).finally(function () {
            vm.spinFotoDesktop = false;
          });
        }
      }

      vm.DeleteFotoPhone = function (imagem, ev) {
        vm.utils.Confirm('EXCLUIR', 'Confirma a exclusão da imagem?').then(function () {
          vm.Banner.Phone = null;
        });
      };

      //FIM BANNER CELULAR
      function upload($files) {

        if ($files.length > 0) {

          var def = $q.defer();
          var file = $files[0];
          var result = [];
          var reader = new FileReader();
          reader.onerror = reader.onabort = function () {
            def.reject('Falha ao ler o arquivo')
          }
          reader.onload = function (evt) {
            $scope.$apply(function () {
              if (result.indexOf(evt.target.result) === -1) {
                result.push(evt.target.result);
              }

              if ($files.length == 0)
                def.resolve(result);
              else
                reader.readAsDataURL($files.splice(0, 1)[0]);
            });
          };
          reader.readAsDataURL($files.splice(0, 1)[0]);
          return def.promise;
        }
      };


      vm.Save = function () {

        var image = document.createElement('img');
        image.src = vm.Banner.Desktop;

        var imgs = [];
        imgs.push(
          {
          Base64 :  vm.Banner.Desktop,
          IdTipoArquivo : 7,
          IdAtracao : vm.IdAtracao,
          Prioridade : vm.Prioridade,
          IdAtracaoBanner : vm.data ? vm.data.find(function (itm) {return itm.IdTipoArquivo == 7}).IdAtracaoBanner : null,
          Arquivo : vm.data ? vm.data.find(function (itm) {return itm.IdTipoArquivo == 7}).Arquivo : null,
          Uri : vm.data ? vm.data.find(function (itm) {return itm.IdTipoArquivo == 7}).Uri : null
          });

        imgs.push(
          {
            Base64:   vm.Banner.Phone,
            IdTipoArquivo : 6,
            IdAtracao : vm.IdAtracao,
            Prioridade : vm.Prioridade,
            IdAtracaoBanner : vm.data ? vm.data.find(function (itm) {return itm.IdTipoArquivo == 6}).IdAtracaoBanner : null,
            Arquivo : vm.data ? vm.data.find(function (itm) {return itm.IdTipoArquivo == 6}).Arquivo : null,
            Uri : vm.data ? vm.data.find(function (itm) {return itm.IdTipoArquivo == 6}).Uri : null
          });

        var imageDesktop = document.createElement('img');
        imageDesktop.src = imgs[0].Base64;
        if(imgs[0].IdTipoArquivo == 7 && imageDesktop.width != 1120 || imageDesktop.height != 400)
        {
          toaster.pop('warning', 'Aviso!', 'Imagem para exibição desktop não está no formaro de 1120x400.');
           return false;
         }

        var imagePhone = document.createElement('img');
        imagePhone.src = imgs[1].Base64
        if(imgs[1].IdTipoArquivo == 6 && (imagePhone.width != 375 || imagePhone.height != 471))
         {
           toaster.pop('warning', 'Imagem para exibição em celular não está no formaro de 375x471.');
           return false;
         }

        bannerSvc.uploadImagem(imgs).then(function (data) {
          vm.Banner.Desktope = data;
          if(data.status == 200) {
            toaster.pop('success', 'Banners salvo com sucesso');
            $state.go('conteudo.banner.grid');
          }
          else{
            if(data.data.ExceptionType == "Barn.Util.BarnException")
                  toaster.pop('warning', data.data.ExceptionMessage);
            else
                  toaster.pop('error', data.data.ExceptionMessage);
          }

        },function (data) {
        });
      }

    }]);

})();

(function() {
  'use strict';

  angular.module('ticket.controller.conteudo')
    .controller('ticket.controller.conteudo.banda', bandaMasterController);

  bandaMasterController.$inject = [
    '$scope',
    '$state',
    'common',
    'ticket.service.conteudo.banda'
  ];

  function bandaMasterController($scope, $state, common, bandaSrv) {
    var vm = common.controller.master(this, bandaSrv, $scope);
  }
})();
(function() {
  'use strict';

  angular.module('ticket.controller.conteudo')
    .controller('ticket.controller.conteudo.banda.grid', bandaGridController);

  bandaGridController.$inject = [
    'common',
    'ticket.service.conteudo.banda'
  ];

  function bandaGridController(common, bandaSrv) {
    var vm = common.controller.grid(this, bandaSrv);
  }

})();
(function() {
  'use strict';

  angular.module('ticket.controller.conteudo')
    .controller('ticket.controller.conteudo.banda.form', bandaFormController);

  bandaFormController.$inject = [
    '$scope',
    '$state',
    '$q',
    '$uibModal',
    'common',
    'ticket.helper.fields.fieldhelper',
    'ticket.service.conteudo.banda',
    'ticket.service.conteudo.bandaartista',
    'ticket.service.conteudo.bandaversao',
    'ticket.service.conteudo.artistatipoartista',
    'ticket.service.conteudo.atracaoparticipante',
    'ticket.service.conteudo.artista',
  ];

  function bandaFormController($scope, $state, $q, $uibModal, common, fieldHelper, bandaSrv, bandaArtistaSrv, bandaversaoSrv, artistaTipoArtistaSvc, atracaoParticipanteSvc,artistaSvc) {
    var vm = common.controller.form(this, bandaSrv);

    //Inicialização e outros
    vm.BandaVersao = {
      FotoPerfil : null,
      PodeEditar: true
    };
    vm.Musicos = [];
    vm.Banda = {
      ModeradoSite: null
    };


    vm.artistaBandaFilter = null;

    if ($state.params.IdBanda !== null && $state.params.NumeroVersao !== null) {

      vm.loadData = function() {

        bandaversaoSrv.get({
          IdBanda: $state.params.IdBanda,
          NumeroVersao: $state.params.NumeroVersao
        }).then(function(band) {
          //HAND MAPPING =( > AUTO MAPPING
          if (band !== null || band !== undefined) {

            vm.BandaVersao = {
              NomeHistorico: band.NomeHistorico,
              IdBanda : band.IdBanda,
              ModeradoSite : band.ModeradoBandaVersao,
              PodeEditar :band.PodeEditar,
              FotoPerfil: band.FotoPerfil
            };

            vm.Banda = {
              IdBanda : band.IdBanda,
              ModeradoSite : band.ModeradoBanda
            };

            vm.BandaVersao.FotoPerfil = band.FotoPerfil;

            //Obtem lista de artista para colocar no chip
            bandaArtistaSrv.list({
              IdBanda: $state.params.IdBanda,
              NumeroVersao: band.NumeroVersao,
              IdTipoArtista: 3
            }).then(function(artistas) {
              vm.Musicos = artistas;
            });

          }


        });
      }();
    }

    vm.artistaBandaFilter = function(filter) {
      var nome = filter.toLowerCase();
      return artistaTipoArtistaSvc.list({
        NomeArtistico: nome,
        IdTipoArtista: 3
      })
    };


    // $scope.$watch('frm.$valid', function(value) {
    //   $scope.validateForm = !value;
    // });


    $scope.$watch('vm.BandaVersao.NomeHistorico', function() {
      if (vm.BandaVersao !== undefined) {
        vm.BandaVersao.UriHistorico = fieldHelper.gerarUri(vm.BandaVersao.NomeHistorico);
      }
    });


    vm.save = function() {
      var artistaVersao = [];

      // IDBANDA, NOME, MODERADOSITE,
      //
      // IDBANDA, NUMEROVERSAO, FOTOPERFIL, MODERADOSITE, NOMEHISTORICO, URIHISTORICO


      vm.Musicos.forEach(function (itm) {
        artistaVersao.push({
          IdArtista: itm.IdArtista,
          IdTipoArtista: 3,
          NomeArtisticoHistorico: itm.Nome
        })
      });

      if(!vm.Banda.ModeradoSite && !vm.Banda.IdBanda)
          vm.Banda.ModeradoSite = null;

      bandaSrv.post({
          ArtistaVersao: artistaVersao,
          Banda: vm.Banda,
          BandaVersao: vm.BandaVersao,
          BandaArtista: null,
          Artista: null
        }).then(function() {
          vm.utils.ShowSuccess("Inclusão de registro", "Operação realizada com sucesso!");
          $state.go('conteudo.banda.grid');
        })
        .finally(function() {
          vm.loading = false;
        });
    };
    vm.DialogCrop = function(image) {
      return $uibModal.open({
        animation: true,
        modalFade: false,
          templateUrl: 'view/conteudo/banda/template/crop_tmpl.html',
          controller: 'ticket.controller.conteudo.banda.crop_image',
          controllerAs: 'vm',
          size: 'lg',
          resolve: {
            image: function() {
              return image;
            }
          }
        })
        .result.then(function(imgResult) {
            return imgResult;
          },
          function(e) {
            console.log(e);
          });
    };


    //FotoPerfil
    //EVENTO
    $scope.$watch('vm.FotoPerfil', function() {
      if (vm.FotoPerfil != null) {
        vm.spinFotoPerfil = true;
        UploadFotoPerfil(vm.FotoPerfil);
      }
    });

    //UPLOAD EVENTO
    vm.uploadFotoPerfil = function($files) {
      UploadFotoPerfil($files);
    };

    //UPLOAD
    function UploadFotoPerfil(files) {
      upload(files).then(function(v) {
        vm.DialogCrop(v).then(function(images) {
          var arrImagens = [];
          arrImagens.push(images);
          bandaSrv.uploadImagem(arrImagens).then(function(data) {
            if (data.statusText = "OK") {
              vm.BandaVersao.FotoPerfil = data.data.Imagem;
            }
          }).finally(function() {
            vm.spinFotoPerfil = false;
            vm.BandaVersao.FotoPerfil = vm.BandaVersao.FotoPerfil;
          });
        });
      });
    }

    //DELETE
    vm.DeleteFotoPerfil = function(imagem, ev) {
      vm.utils.Confirm('EXCLUIR', 'Confirma a exclusão da imagem?').then(function() {
        vm.BandaVersao.FotoPerfil = null;
      });
    };
    //FIM UPLOAD CAPA

    function upload($files) {
      var def = $q.defer();
      var file = $files[0];
      var result = [];
      var reader = new FileReader();
      reader.onerror = reader.onabort = function() {
        def.reject('Falha ao ler o arquivo')
      };
      reader.onload = function(evt) {
        $scope.$apply(function() {
          if (result.indexOf(evt.target.result) === -1) {
            result.push(evt.target.result);
          }

          if ($files.length == 0)
            def.resolve(result);
          else
            reader.readAsDataURL($files.splice(0, 1)[0]);
        });
      };
      reader.readAsDataURL($files.splice(0, 1)[0]);
      return def.promise;
    }


  }
})();

(function() {
  'use strict';

  angular.module('ticket.controller.conteudo')
    .controller('ticket.controller.conteudo.banda.crop_image', bandaCropController);

  bandaCropController.$inject = ["$uibModalInstance", "image"];

  function bandaCropController($uibModalInstance, image) {
    var vm = this;

    vm.size = 'large';
    vm.type = 'square';
    vm.imageDataURI = image[0];
    vm.resImageDataURI = '';
    vm.resImgFormat = 'image/jpg';
    vm.resImgQuality = 1;
    //vm.selMinSize = 100;
    //vm.resImgSize = 200;

    vm.Confirm = function() {
      $uibModalInstance.close(vm.resImageDataURI);
    };

    vm.Cancel = function() {
      $uibModalInstance.dismiss('cancel');
    };
  }

})();
(function () {
  'use strict';

  angular
    .module('ticket.controller.conteudo')

    .controller('ticket.controller.conteudo.wizard', [
      'common', '$scope', '$q', '$timeout', 'Upload', '$uibModal', '$stateParams', '$state', 'orderByFilter', '$filter',
      'ticket.service.conteudo.atracao',
      'ticket.service.conteudo.inadequacao',
      'ticket.service.conteudo.genero',
      'ticket.service.conteudo.artistatipoartista',
      'ticket.service.conteudo.classificacao',
      'ticket.service.conteudo.banda',
      'ticket.service.conteudo.atracaoversao',
      'ticket.service.conteudo.atracaoinadequacao',
      'ticket.service.conteudo.atracaogenero',
      'ticket.service.conteudo.atracaoparticipante',
      'ticket.service.conteudo.atracaoarquivo',
      'ticket.service.conteudo.atracaobanda',
      function (common, $scope, $q, $timeout, Upload, $uibModal, $stateParams, $state, orderByFilter, $filter, atracaoSvc, inadequacaoSvc, generoSvc, artistaSvc, classificacaoSvc, bandaSvc, atracaoVersaoSvc, atracaoInadequacaoSvc, atracaoGeneroSvc, atracaoParticipanteSvc, atracaoArquivoSvc, atracaobandaSvc) {
        var vm = common.controller.grid(this, atracaoSvc);

        vm.spinFotoDestaque = false;
        vm.spinFotoCapa = false;
        vm.spinFotoGaleria = false;
        vm.ValidaGenero = false;
        vm.PodeEditar = false;
        var objFotoGaleria = {}

        var FichaTecnica = {
          PaisOrigem: 'Brasil',
          IdiomaOriginal : 'Português'
        };
        var Sinopse = {};

        if ($stateParams.filter == null) {
          $state.go('conteudo.atracao.grid'); //PROTEÇÃO CONTRA REFRESH: SE FILTER NÃO FOI INFORMADO, RETORNA PRO GRID.
        }

        if (!$stateParams.filter.IdAtracao) {
          vm.PodeEditar = true;
        }

        if ($stateParams.filter != null) {
          vm.TipoVisao = $stateParams.filter.IdTipoAtracao;
          FichaTecnica.Nome = $stateParams.filter.NomeAtracao
        }

        // GET DOS DADOS PARA EDIÇÃO
        if ($stateParams.filter != null && $stateParams.filter.IdAtracao != null) {

          var IdAtracao = $stateParams.filter.IdAtracao;
          var IdTipoAtracao = $stateParams.filter.IdTipoAtracao;
          var NumeroVersao = $stateParams.filter.NumeroVersao;



          vm.itensCount = 0;
          vm.loadInadequacoes = true;
          vm.loadGeneros = true;

          // atracaoSvc.get({IdAtracao: IdAtracao}).then(function (atracao) {
          //
          // });

          atracaoVersaoSvc.get({IdAtracao: IdAtracao, NumeroVersao: NumeroVersao}).then(function (p) {
            FichaTecnica.Nome = p.NomeHistorico;
            FichaTecnica.NomeOriginal = p.NomeOriginal;
            FichaTecnica.UrlOficial = p.UrlOficial;
            FichaTecnica.PaisOrigem = p.PaisOrigem;
            FichaTecnica.IdiomaOriginal = p.IdiomaOriginal;
            FichaTecnica.AnoLancamento = p.AnoLancamento;
            FichaTecnica.DataEstreia = p.DataEstreia;
            FichaTecnica.Duracao = p.Duracao;
            FichaTecnica.IdClassificacao = p.IdClassificacao;
            FichaTecnica.PodeEditar = p.PodeEditar;
            Sinopse.Texto = p.Sinopse;

            vm.PodeEditar = p.PodeEditar;
          });

          atracaoArquivoSvc.listarquivos({IdAtracao: IdAtracao}).then(function (data) {

            var fotoDestaque = data.filter(function (itm) {
              return itm.IdTipoArquivo == 2;
            });
            vm.Atracao.Midia.FotoDestaque = fotoDestaque[0];

            var fotoCapa = data.filter(function (itm) {
              return itm.IdTipoArquivo == 1;
            });
            vm.Atracao.Midia.FotoCapa = fotoCapa[0];

            var fotoGaleria = data.filter(function (itm) {
              return ((itm.IdTipoArquivo == 5) || (itm.IdTipoArquivo == 3));
            });

            var lstGaleria = [];
            lstGaleria = arrGaleria(fotoGaleria);

            if (lstGaleria.length > 0) {
              lstGaleria.forEach(function (itm) {
                vm.Atracao.Midia.FotoGaleria.push(itm);
              })
            }

            // for (var i = 0; i < fotoGaleria.length; i++) {
            //
            //   console.log('fotoGaleria', fotoGaleria);
            //
            //   vm.FotoGaleria = fotoGaleria;
            //   objFotoGaleria = angular.copy(objFotoGaleria);
            //
            //   objFotoGaleria.Id = guid();
            //
            //   var galeria = fotoGaleria[i];
            //
            //   if (galeria.IdTipoArquivo == 5)
            //     objFotoGaleria.Thumb = galeria;
            //   if (galeria.IdTipoArquivo == 3)
            //     objFotoGaleria.Normal = galeria;
            //
            //   // var Imagem = {
            //   //   Id: fotoGaleria[i].Id,
            //   //   Uri: fotoGaleria[i].Uri,
            //   //   Arquivo: fotoGaleria[i].Arquivo,
            //   //   IdTipoArquivo: fotoGaleria[i].IdTipoArquivo
            //   // }
            //
            //   vm.Atracao.Midia.FotoGaleria.push(objFotoGaleria);
            // }


            var video = data.filter(function (itm) {
              return itm.IdTipoArquivo == 4;
            });
            vm.Atracao.Midia.Video = video[0];
          });


          vm.Filter.IdAtracao = IdAtracao;
          vm.Filter.NumeroVersao = NumeroVersao;

          atracaoInadequacaoSvc.list(vm.Filter).then(function (data) {
              vm.Inadequacoes = orderByFilter(data, 'Nome');
            }
          ).finally(function () {
            vm.loadInadequacoes = false;
          });

          atracaoGeneroSvc.list(vm.Filter).then(function (data) {
              data.forEach(function (itm, index) {

                if (itm.Principal)
                  vm.GeneroPrincipal = itm.Id;
              })

              vm.Generos = orderByFilter(data, 'Nome');
            }
          ).finally(function () {
            vm.loadGeneros = false;
          });

          //AUTOR
          atracaoParticipanteSvc.list({
            IdTipoArtista: 1,
            IdAtracao: IdAtracao,
            NumeroVersao: NumeroVersao
          }).then(function (data) {
              vm.Autoria = orderByFilter(data, 'Nome');
            }
          ).finally(function () {
            vm.itensCount++;
          });

          //Diretor
          atracaoParticipanteSvc.list({
            IdTipoArtista: 2,
            IdAtracao: IdAtracao,
            NumeroVersao: NumeroVersao
          }).then(function (data) {
              vm.loaDiretor = true;
              vm.Direcao = orderByFilter(data, 'Nome');
            }
          ).finally(function () {
            vm.itensCount++;
          });

          ////Elenco
          atracaoParticipanteSvc.list({
            IdTipoArtista: 4,
            IdAtracao: IdAtracao,
            NumeroVersao: NumeroVersao
          }).then(function (elenco) {
              vm.Elenco = orderByFilter(elenco, 'Nome');
            }
          ).finally(function () {
            vm.itensCount++;
          });

          ////Produtor
          atracaoParticipanteSvc.list({
            IdTipoArtista: 6,
            IdAtracao: IdAtracao,
            NumeroVersao: NumeroVersao
          }).then(function (producao) {
              vm.Producao = orderByFilter(producao, 'Nome');
            }
          ).finally(function () {
            vm.itensCount++;
          });

          ////Diretor Musical - Tipo 7
          atracaoParticipanteSvc.list({
            IdTipoArtista: 5,
            IdAtracao: IdAtracao,
            NumeroVersao: NumeroVersao
          }).then(function (direcaoMusical) {
              vm.DirecaoMusical = orderByFilter(direcaoMusical, 'Nome');
              ;
            }
          ).finally(function () {
            vm.itensCount++;
          });

          ////Elenco Musical(Musicos) - Tipo 3
          if (IdTipoAtracao == 2) {
            atracaoParticipanteSvc.list({
              IdTipoArtista: 3,
              IdAtracao: IdAtracao,
              NumeroVersao: NumeroVersao
            }).then(
              function (elencoMusical) {
                vm.ElencoMusical = orderByFilter(elencoMusical, 'Nome');
              }
            ).finally(function () {
              vm.itensCount++;
            });
          }

          ////Musico - Tipo 3
          if (IdTipoAtracao == 1) {
            atracaoParticipanteSvc.list({
              IdTipoArtista: 3,
              IdAtracao: IdAtracao,
              NumeroVersao: NumeroVersao
            }).then(function (artistas) {
                vm.Musico = orderByFilter(artistas, 'Nome');
              }
            ).finally(function () {
              vm.itensCount++;
            });
          }

          atracaobandaSvc.list({
            IdAtracao: IdAtracao,
            NumeroVersao: NumeroVersao
          }).then(function (data) {
              vm.Banda = orderByFilter(data, 'Nome');
            }
          ).finally(function () {
            vm.itensCount++;
          });

          vm.result = false;
          var Atracao = {
            IdAtracao: IdAtracao,
            FilaFraude: true,
            IdTipoAtracao: IdTipoAtracao,
            Ativo: true,
            User: ''
          }

        }
        // FIM GET DOS DADOS PARA EDIÇÃO

        if ($stateParams.filter != null) {
          vm.result = false;
          var Atracao = {
            IdAtracao: $stateParams.filter.IdAtracao,
            FilaFraude: true,
            IdTipoAtracao: $stateParams.filter.IdTipoAtracao,
            Ativo: true,
            User: ''
          }
        }

        vm.Atracao = {
          Atracao: Atracao,
          AtracaoEstabelecimento: {Ativo: true, NomeImpressao: ''},
          FichaTecnica: FichaTecnica,
          Participantes: {},
          Banda: [],
          Sinopse: Sinopse,
          Midia: {FotoDestaque: null, FotoCapa: null, FotoGaleria: [], Video: null,}
        }

        $scope.$watch('vm.Generos',function () {

          if(vm.Generos.length > 0)
            vm.ValidaGenero = true;
          else
            vm.ValidaGenero = false;

          if(vm.Generos.length == 1)
          {
            vm.Generos[0].Principal = true;
            vm.GeneroPrincipal = vm.Generos[0].Id;
          }

        },true);

        //INICIO DO SALVAMENTO
        vm.Save = function () {
          vm.loading = true;
          vm.Atracao.FichaTecnica.Inadequacoes = [];
          vm.Atracao.FichaTecnica.Generos = [];
          vm.Atracao.Participantes = [];
          vm.Atracao.Midia.AtracaoArquivo = [];

          for (var i = 0; i < vm.Inadequacoes.length; i++) {
            vm.Atracao.FichaTecnica.Inadequacoes.push({Id: vm.Inadequacoes[i].Id});
          }

          for (var i = 0; i < vm.Generos.length; i++) {
            var principal = false;

            if (vm.Generos[i].Id == vm.GeneroPrincipal)
              principal = true;

            vm.Atracao.FichaTecnica.Generos.push({
              Id: vm.Generos[i].Id,
              Principal: principal
            });
          }

          //PARTICIPANTES
          for (var i = 0; i < vm.Direcao.length; i++) {
            vm.Atracao.Participantes.push({
              IdArtista: vm.Direcao[i].IdArtista,
              IdTipoArtista: vm.Direcao[i].IdTipoArtista || 2,
              Nome: vm.Direcao[i].Nome
            });
          }

          for (var i = 0; i < vm.Autoria.length; i++) {
            vm.Atracao.Participantes.push({
              IdArtista: vm.Autoria[i].IdArtista,
              IdTipoArtista: vm.Autoria[i].IdTipoArtista || 1,
              Nome: vm.Autoria[i].Nome,
            });
          }

          for (var i = 0; i < vm.Elenco.length; i++) {
            vm.Atracao.Participantes.push({
              IdArtista: vm.Elenco[i].IdArtista,
              IdTipoArtista: vm.Elenco[i].IdTipoArtista || 4,
              Nome: vm.Elenco[i].Nome
            });
          }

          for (var i = 0; i < vm.Producao.length; i++) {
            vm.Atracao.Participantes.push({
              IdArtista: vm.Producao[i].IdArtista,
              IdTipoArtista: vm.Producao[i].IdTipoArtista || 6,
              Nome: vm.Producao[i].Nome
            });
          }

          for (var i = 0; i < vm.DirecaoMusical.length; i++) {
            vm.Atracao.Participantes.push({
              IdArtista: vm.DirecaoMusical[i].IdArtista,
              IdTipoArtista: vm.DirecaoMusical[i].IdTipoArtista || 5,
              Nome: vm.DirecaoMusical[i].Nome
            });
          }

          for (var i = 0; i < vm.ElencoMusical.length; i++) {
            vm.Atracao.Participantes.push({
              IdArtista: vm.ElencoMusical[i].IdArtista,
              IdTipoArtista: vm.ElencoMusical[i].IdTipoArtista || 3,
              Nome: vm.ElencoMusical[i].Nome
            });
          }

          for (var i = 0; i < vm.Musico.length; i++) {
            vm.Atracao.Participantes.push({
              IdArtista: vm.Musico[i].IdArtista,
              IdTipoArtista: vm.Musico[i].IdTipoArtista || 3,
              Nome: vm.Musico[i].Nome
            });
          }
          //FIM PARTICIPANTES

          //BANDA
          if (vm.Banda != null && vm.Banda.length > 0) {
            for (var i = 0; i < vm.Banda.length; i++) {
              vm.Atracao.Banda.push({
                IdBanda: vm.Banda[i].IdBanda,
                Nome: vm.Banda[i].Nome
              });
            }
          }
          //FIM BANDA

          //BANDA


          vm.Atracao.IdEstabelecimento = $stateParams.filter.IdEstabelecimento;

          //FIM BANDA





          if (vm.Atracao.Midia.FotoDestaque != null) {
            vm.Atracao.Midia.FotoDestaque.Id = guid();
            vm.Atracao.Midia.AtracaoArquivo.push(vm.Atracao.Midia.FotoDestaque);
          }

          if (vm.Atracao.Midia.FotoCapa != null) {
            vm.Atracao.Midia.FotoCapa.Id = guid();
            vm.Atracao.Midia.AtracaoArquivo.push(vm.Atracao.Midia.FotoCapa);
          }

          if (vm.Atracao.Midia.Video != null) {
            vm.Atracao.Midia.Video.Id = guid();
            vm.Atracao.Midia.AtracaoArquivo.push(vm.Atracao.Midia.Video);
          }


          for (var i = 0; i < vm.Atracao.Midia.FotoGaleria.length; i++) {

            var galeria = vm.Atracao.Midia.FotoGaleria[i];

            var newGuid = guid();

            var normal = galeria.Normal;
            vm.Atracao.Midia.AtracaoArquivo.push({
              Id: newGuid,
              IdAtracao: normal.IdAtracao,
              NumeroVersao: normal.NumeroVersao,
              IdTipoArquivo: normal.IdTipoArquivo,
              Uri: normal.Uri,
              Arquivo: normal.Arquivo,
              Base64: normal.Base64,
              IdAtracaoArquivoOriginal: normal.IdAtracaoArquivoOriginal
            });

            var thumb = galeria.Thumb;
            vm.Atracao.Midia.AtracaoArquivo.push({
              Id: guid(),
              IdAtracao: thumb.IdAtracao,
              NumeroVersao: thumb.NumeroVersao,
              IdTipoArquivo: thumb.IdTipoArquivo,
              Uri: thumb.Uri,
              Arquivo: thumb.Arquivo,
              Base64: thumb.Base64,
              IdAtracaoArquivoOriginal: newGuid
            });
          }

          // function MontaObjetoGaleria(obj,newGuid) {
          //   console.log('obj', obj);
          //
          //   var atracaoArquivo = {
          //     Id: obj.Id,
          //     IdAtracao: obj.IdAtracao,
          //     NumeroVersao: obj.NumeroVersao,
          //     IdTipoArquivo: obj.IdTipoArquivo,
          //     Uri: obj.Uri,
          //     Arquivo: obj.Arquivo,
          //     Base64: obj.Base64,
          //     IdAtracaoArquivoOriginal: obj.IdAtracaoArquivoOriginal
          //   }
          //   console.log('atracaoArquivo', atracaoArquivo);
          //   return atracaoArquivo;
          // }

          atracaoSvc.save(vm.Atracao).then(function (v) {
            var pk = v.Atracao.IdAtracao;
            var IdEstabelecimento = v.IdEstabelecimento;

            vm.utils.Confirm('ATRAÇÃO CADASTRADA COM SUCESSO!', 'Deseja preencher as informações exclusivas do estabelecimento?').then(function () {
                $state.go('conteudo.atracao.informacoesexclusivas', {Id: pk, IdEstabelecimento: IdEstabelecimento});
              },
              function () {
                $state.go('conteudo.atracao.grid');
              });
          }).finally(function () {
            vm.loading = false;
          });
        };
        //FIM DO SALVAMENTO

        //BUSCANDO OS DADOS PARA CRIAÇÂO DE UMA NOVA ATRAÇÃO, EX.: PREENCHER COMBO, AUTOCOMPLETE E ETC
        classificacaoSvc.list({}).then(function (data) {
          vm.classificacoes = orderByFilter(data, 'Nome');
        });

        vm.Inadequacoes = [];
        vm.Generos = [];
        //PARTICIPANTES
        vm.Autoria = [];
        vm.Direcao = [];
        vm.Elenco = [];
        vm.Producao = [];
        vm.DirecaoMusical = [];
        vm.ElencoMusical = [];
        vm.Musico = [];
        vm.Banda = [];

        //INADEQUAÇÕES
        vm.inadequacoesSearch = function (filter) {
          var nome = filter.toLowerCase();
          return inadequacaoSvc.list({Nome: nome});
        }
        //GENEROS
        vm.generosSearch = function (filter) {
          var nome = filter.toLowerCase();
          return generoSvc.list({Nome: nome})
        };


        //BANDA
        vm.searchBanda = function (filter) {
          var nome = filter.toLowerCase();

          return bandaSvc.list({Nome: nome});
          //vm.BandaArray = data;
        };


        //AUTOR - Tipo 1
        vm.autoriaSearch = function (filter) {
          var nome = filter.toLowerCase();
          return artistaSvc.list({NomeArtistico: nome, IdTipoArtista: 1})
        };

        //DIRETOR 2
        vm.direcaoSearch = function (filter) {
          var nome = filter.toLowerCase();
          return artistaSvc.list({NomeArtistico: nome, IdTipoArtista: 2})
        };

        //Musico - Tipo 3
        vm.musicoSearch = function (filter) {
          var nome = filter.toLowerCase();
          return artistaSvc.list({NomeArtistico: nome, IdTipoArtista: 3})
        };

        //Elenco Musical(Musicos) - Tipo 3
        vm.elencoMusicalSearch = function (filter) {
          var nome = filter.toLowerCase();
          return artistaSvc.list({NomeArtistico: nome, IdTipoArtista: 3})
        };

        //Elenco - Tipo 4
        vm.elencoSearch = function (filter) {
          var nome = filter.toLowerCase();
          return artistaSvc.list({NomeArtistico: nome, IdTipoArtista: 4})
        };

        //Produtor - Tipo 6
        vm.producaoSearch = function (filter) {
          var nome = filter.toLowerCase();
          return artistaSvc.list({NomeArtistico: nome, IdTipoArtista: 6})
        };

        //Diretor Musical - Tipo 7
        vm.direcaoMusicalSearch = function (filter) {
          var nome = filter.toLowerCase();
          return artistaSvc.list({NomeArtistico: nome, IdTipoArtista: 5})
        };


        //========================== WIZARD MIDIA ============================


        ////========================== FOTO DESTAQUE ============================
        vm.uploadDestaque = function ($files) {
          UploadFotoDestaque($files);
        }

        $scope.$watch('vm.FileDestaque', function () {
          if (vm.FileDestaque != null) {
            vm.spinFotoDestaque = true;
            vm.stt_des = 'uploading'
            UploadFotoDestaque(vm.FileDestaque);
          }
        });

        function UploadFotoDestaque(files) {

          if (files.length > 0) {

            upload(files).then(function (v) {

              var imgs = [];
              imgs.push({w: 740, h: 380});

              var configIgm = {
                tpImg: 'retangular',
                imgs: imgs,
                ratio: 1.95
              }

              vm.DialogCrop(v, configIgm).then(function (images) {

                vm.Atracao.Midia.FotoDestaque = {Uri :'../img/foto-destaque-loading.gif'};

                if (images !== undefined) {

                  var atracaoArquivo = {
                    Base64: images[0].dataURI,
                    IdTipoArquivo: 2
                  };

                  atracaoSvc.uploadImagem(atracaoArquivo).then(function (data) {

                    vm.Atracao.Midia.FotoDestaque = data.data;
                    vm.Atracao.Midia.FotoDestaque.IdTipoArquivo = 2;

                  });
                }
              });
            }).finally(function () {
              vm.spinFotoDestaque = false;
            });
          }
        }

        vm.DeleteFotoDestaque = function (imagem, ev) {

          vm.utils.Confirm('EXCLUIR', 'Confirma a exclusão da imagem?').then(function () {
            vm.Atracao.Midia.FotoDestaque = null;
            var arrImagem = [];
            arrImagem.push(imagem);
            // atracaoSvc.deleteImagem(arrImagem).then(function (data) {
            //   if (data.statusText == "OK") {
            //     vm.Atracao.Midia.FotoDestaque = null;
            //   }
            // });
          });
        };


        ////========================== FOTO CAPA============================
        $scope.$watch('vm.FileCapa', function () {
          if (vm.FileCapa != null) {
            vm.spinFotoCapa = true;
            UploadFotoCapa(vm.FileCapa);
          }
        });

        vm.uploadCapa = function ($files) {
          UploadFotoCapa($files);
        };

        function UploadFotoCapa(files) {
          if (files.length > 0) {
            upload(files).then(function (v) {

              var imgs = [];
              imgs.push({w: 370, h: 550});

              var configIgm = {
                tpImg: 'square',
                imgs: imgs,
                ratio: 0.67
              }


              vm.DialogCrop(v, configIgm).then(function (images) {

                vm.Atracao.Midia.FotoCapa = {Uri :'../img/foto-capa-loading.gif'};

                if (images !== undefined) {

                  var atracaoArquivo = {
                    Base64: images[0].dataURI,
                    IdTipoArquivo: 1
                  };

                  atracaoSvc.uploadImagem(atracaoArquivo).then(function (data) {
                    vm.Atracao.Midia.FotoCapa = data.data;
                    vm.Atracao.Midia.FotoCapa.IdTipoArquivo = 1;
                  }).finally(function () {
                    vm.spinFotoCapa = false;
                  });
                }

              });
            });
          }
        }

        vm.DeleteFotoCapa = function (imagem, ev) {
          vm.utils.Confirm('EXCLUIR', 'Confirma a exclusão da imagem?').then(function () {
            vm.Atracao.Midia.FotoCapa = null;
            var arrImagem = [];
            arrImagem.push(imagem);
            // atracaoSvc.deleteImagem(arrImagem).then(function (data) {
            //   if (data.statusText == "OK") {
            //     vm.Atracao.Midia.FotoCapa = null;
            //   }
            // });
          });
        };


        ////========================== FOTO GALERIA============================
        function guid() {
          function s4() {
            return Math.floor((1 + Math.random()) * 0x10000)
              .toString(16)
              .substring(1);
          }

          return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
            s4() + '-' + s4() + s4() + s4();
        }

        $scope.$watch('vm.FileGaleria', function () {
          if (vm.FileGaleria != null) {
            vm.spinFotoGaleria = true;
            UploadFotoGaleria(vm.FileGaleria);
          }
        });

        function UploadFotoGaleria(files, index) {

          if (files.length > 0) {
            var imgs = [];
            imgs.push({w: 352, h: 235, IdTipoArquivo: 5});
            imgs.push({w: 960, h: 640, IdTipoArquivo: 3});

            var configIgm = {
              tpImg: 'square',
              imgs: imgs,
              ratio: 1.5
            }

            upload(files).then(function (v) {
              vm.DialogCrop(v, configIgm).then(function (images) {

                var imgGaleria = [];

                if (images !== undefined) {

                  objFotoGaleria = angular.copy(objFotoGaleria);

                  objFotoGaleria.Thumb = {
                    Uri :'../img/foto-galeria-loading.gif'
                  };

                  //var objFotoGaleria = {};

                  var idAtracaoArquivo = guid();
                  objFotoGaleria.Id = guid();//'Id' + Math.floor((1 + Math.random()) * 0x10000).toString(16);

                  images.forEach(function (itm, idx) {

                    var idTipoArquivo = 3;

                    if (itm.w == 352)
                      idTipoArquivo = 5;

                    var atracaoArquivo = {
                      Base64: itm.dataURI,
                      IdTipoArquivo: idTipoArquivo
                    };

                    atracaoSvc.uploadImagem(atracaoArquivo).then(function (data) {

                      if (itm.w == 352) {
                        objFotoGaleria.Thumb = data.data;
                        objFotoGaleria.Thumb.Id = guid();
                        objFotoGaleria.Thumb.IdAtracaoArquivoOriginal = idAtracaoArquivo;
                      }
                      else {
                        objFotoGaleria.Normal = data.data;
                        objFotoGaleria.Normal.Id = idAtracaoArquivo;
                        objFotoGaleria.Normal.IdAtracaoArquivoOriginal = null;
                      }

                    }).finally(function () {
                      vm.spinFotoCapa = false;
                    });

                  })

                  if(index === undefined)
                    vm.Atracao.Midia.FotoGaleria.push(objFotoGaleria);
                  else
                    vm.Atracao.Midia.FotoGaleria[index] = objFotoGaleria;

                }
              });
            }).finally(function () {
              vm.spinFotoGaleria = false;
            });
          }
        }

        function reqImage(resp, ls) {
          var req = {
            loading: true,
            Imagem: resp.data.Imagem,
            img: '',
            IdAtracao: "",
            NumeroVersao: "",
            IdTipoArquivo: ls.IdTipoArquivo,
            Uri: "",
            Arquivo: "",
            Base64: '',

            // prom: atracaoSvc.uploadImagem(ls).then(function (data) {
            //     req.Imagem = data.data.Imagem;
            //   },
            //   function (err) {
            //     req.error = true;
            //   }
            // ).finally(function () {
            //   req.loading = false;
            // })
          }
          return req;
        }

        vm.DeleteFotoGaleria = function (idx, itm, ev) {

          vm.utils.Confirm('EXCLUIR', 'Confirma a exclusão da imagem?').then(function () {
            vm.Atracao.Midia.FotoGaleria.splice(idx, 1);

            //var arrArquivo = [];
            //arrArquivo.push(itm.Normal);
            //arrArquivo.push(itm.Thumb);

            // atracaoSvc.deleteImagem(arrArquivo).then(function (data) {
            // });
            //atracaoSvc.deleteImagem(itm.Thumb).then(function (data) {});
          });
        };

        vm.updateGaleria = function ($files, $index) {
          UploadFotoGaleria($files, $index);
        };


        ////========================== UPLOAD VIDEO============================
        $scope.$watch('vm.FileVideo', function () {
          if (vm.FileVideo != null) {
            atracaoSvc.uploadVideo({file: vm.FileVideo}).then(function (data) {
                vm.result = true;
                vm.Atracao.Midia.Video = data.data.Video;
                vm.Atracao.Midia.Video.IdTipoArquivo = 4;
                vm.Atracao.Midia.Video.Uri = data.data.Video.Uri;
              },
              function (resp) {
              },
              function (evt) {
                vm.videoProgress = Math.round(evt.loaded / evt.total * 100);
              }
            ).finally(function () {
              vm.videoProgress = null;
            });

          }
        });

        //DELETE
        vm.DeleteVideo = function (video) {
          vm.Atracao.Midia.Video = null;

          var arrVideo = [];
          arrVideo.push(video);
          // atracaoSvc.deleteImagem(arrVideo).then(function (data) {
          //   if (data.Status == "OK") {
          //     vm.Atracao.Midia.Video = null;
          //   }
          // });
        }

        //UPLOAD
        vm.UpdateVideo = function ($files) {

          if ($files != null) {
            atracaoSvc.uploadVideo({file: $files}).then(function (data) {
                vm.result = true;
                vm.Atracao.Midia.Video = data.data.Video;
                vm.Atracao.Midia.Video.IdTipoArquivo = 4;
                vm.Atracao.Midia.Video.Uri = data.data.Video.Uri;
              },
              function (resp) {
              },
              function (evt) {
                vm.videoProgress = Math.round(evt.loaded / evt.total * 100);
              }
            ).finally(function () {
              vm.videoProgress = null;
            });

          }
        }


        ////========================== METODOS GENERICOS============================
        function upload($files) {

          if ($files.length > 0) {

            var def = $q.defer();
            var file = $files[0];
            var result = [];
            var reader = new FileReader();
            reader.onerror = reader.onabort = function () {
              def.reject('Falha ao ler o arquivo')
            }
            reader.onload = function (evt) {
              $scope.$apply(function () {
                if (result.indexOf(evt.target.result) === -1) {
                  result.push(evt.target.result);
                }

                if ($files.length == 0)
                  def.resolve(result);
                else
                  reader.readAsDataURL($files.splice(0, 1)[0]);
              });
            };
            reader.readAsDataURL($files.splice(0, 1)[0]);
            return def.promise;
          }
        };

        vm.DialogCrop = function (image, configIgm) {
          return $uibModal.open({
            animation: true,
            modalFade: false,
            templateUrl: 'view/conteudo/atracao/template/crop_tmpl.html',
            controller: 'app.controller.conteudo.atracao.wizard_crop',
            controllerAs: 'vm',
            size: 'lg',
            resolve: {
              image: function () {
                vm.loadingCrop = true;
                return image;
              },
              configIgm: function () {
                return configIgm;
              }
            }
          })
            .result.then(function (imgResult) {
                vm.loadingCrop = true;
                return imgResult;
              },
              function (e) {
              });
        };

        //========================== FIM WIZARD MIDIA ============================

        vm.Cancelar = function () {
          $state.go('conteudo.atracao.grid');
        }

        function arrGaleria(fotoGaleria) {
          var mapFotoGaleria = [];
          if (fotoGaleria.length > 0) {

            fotoGaleria.forEach(function (itm, idx, arr) {
              itm.Thumb = arr.find(function (a) {
                return a.IdAtracaoArquivoOriginal == itm.IdAtracaoArquivo
              });

            });
            fotoGaleria = fotoGaleria.filter(function (a) {
              return a.IdAtracaoArquivoOriginal == '00000000-0000-0000-0000-000000000000' || a.IdAtracaoArquivoOriginal === null;
            });

            mapFotoGaleria = fotoGaleria.map(function (itm) {
                var guidId = guid();
                return objFotoGaleria = {
                  Id: guid(),
                  Thumb: {
                    Id: itm.Thumb.Id,
                    IdAtracao: itm.Thumb.IdAtracao,
                    NumeroVersao: itm.Thumb.NumeroVersao,
                    IdTipoArquivo: itm.Thumb.IdTipoArquivo,
                    Uri: itm.Thumb.Uri,
                    Arquivo: itm.Thumb.Arquivo,
                    Base64: itm.Thumb.Base64,
                    IdAtracaoArquivoOriginal: itm.Thumb.IdAtracaoArquivoOriginal
                  },
                  Normal: {
                    Id: itm.Id,
                    IdAtracao: itm.IdAtracao,
                    NumeroVersao: itm.NumeroVersao,
                    IdTipoArquivo: itm.IdTipoArquivo,
                    Uri: itm.Uri,
                    Arquivo: itm.Arquivo,
                    Base64: itm.Base64,
                    IdAtracaoArquivoOriginal: itm.IdAtracaoArquivoOriginal
                  }
                }
              }
            );
          }

          return mapFotoGaleria;
        }
      }
    ])

    .controller("app.controller.conteudo.atracao.wizard_crop", ["$scope", "$uibModalInstance", "image", "configIgm", function ($scope, $uibModalInstance, image, configIgm) {
      var vm = this;


      var configIgm = configIgm;
      var arrImagem = configIgm.imgs;

      var tpImg = 'square';
      var w = 200;
      var h = 200;
      var ratio = null;

      var resultImageSize = [];

      if (configIgm !== undefined) {

        if (configIgm.tpImg != undefined && configIgm.tpImg === 'retangular')
          tpImg = 'rectangle';

        if (arrImagem.length > 0) {
          arrImagem.forEach(function (img, i) {
            if (img.w !== undefined && img.h !== undefined) {
              resultImageSize.push({w: img.w, h: img.h});
            }
          })
        }
        else {
          resultImageSize.push({w: w, h: h});
        }

        if (configIgm.ratio !== undefined) {
          ratio = configIgm.ratio;
        }
      }


      vm.size = 'large';
      vm.tipoImagem = 'rectangle';
      vm.imageDataURI = image[0];
      vm.resImageDataURI = '';
      vm.resultImageFormat = 'image/jpg';
      vm.resultImageQuality = 1;
      vm.resultImageSize = resultImageSize;
      vm.ratio = ratio;
      //vm.selMinSize = 100;
      //vm.resImgSize = 200;

      vm.Confirm = function () {
        vm.loadingCrop = true;
        $uibModalInstance.close(vm.resArrImagens);
      };

      vm.Cancel = function () {
        $uibModalInstance.dismiss('cancel');
      };
    }]);

})
();


(function() {
  'use strict';

  angular
    .module('ticket.controller.conteudo')

  .controller('ticket.controller.conteudo.pre_cadastro', [
    'common',
    '$state',
    '$scope',
    'toaster',
    'orderByFilter',
    'ticket.service.conteudo.atracao',
    'ticket.service.controleestabelecimento.estabelecimentoTipoAtracao',
    'ticket.service.conteudo.atracaoestabelecimento',
    'ticket.service.controleestabelecimento.estabelecimento',
    function(common, $state, $scope, toaster,orderByFilter, atracaoSvc, tipoSvc, atracaoEstabelecimentoSvc, estabelecimentoSvc) {

      var vm = common.controller.grid(this, atracaoSvc);

      vm.NovaAtracao = novaAtracao;
      vm.customToggle = customToggle;

      vm.Filter.Todos = 1;
      vm.Filter.Status = 3;
      vm.showCard = true;

      estabelecimentoSvc.list({}).then(function(listData) {
        vm.lstEstabelecimento = listData;
      });

      $scope.$watch('vm.Filter.IdEstabelecimento', function(newValue) {
        vm.showCard = false;
        if(vm.Filter.IdEstabelecimento){
          tipoSvc.listGestao({IdEstabelecimento: newValue}).then(function(listData) {
            vm.lstTipoAtracao = orderByFilter(listData, '-Principal');
            vm.Filter.TipoAtracao = vm.lstTipoAtracao[0].IdTipoAtracao;
          });
        }
        else{
          vm.lstTipoAtracao = null;
          vm.Filter.TipoAtracao = null;
          vm.Filter.Nome = null;
        }
      });


      vm.search = function() {
        vm.loading = true;
        var QueryFilter = {
          Config: {

          },
          Filter: vm.Filter
        };

        atracaoSvc.getAll(QueryFilter).then(function(listData) {
          vm.items = listData;
        }).finally().then(function () {
          vm.loading = false;
          vm.showCard= true;
        });
      };


      vm.associarDesassociar = function (itm) {
        atracaoEstabelecimentoSvc.associar(
          {
            Id: itm.IdAtracao,
            NomeImpressao: itm.NomeAtracao,
            IdEstabelecimento: vm.Filter.IdEstabelecimento
          }).then(function () {
          toaster.pop('success', 'Associação', "Associação realizada com sucesso!");
          itm.Associada = true;
          itm.Status = 1;
        });
      };

      vm.customToggle = function(itm) {
        var key = { Id: itm.IdAtracao, IdEstabelecimento: itm.IdEstabelecimento};

        var text = itm.Status === 1 ? 'Deseja inativar essa atração?' : 'Deseja ativar essa atração?';
        var textTitle = itm.Status === 1 ? 'Inativar Atração' : 'Ativar atração.';

        vm.utils.Confirm(textTitle, text).then(function () {

          atracaoEstabelecimentoSvc.toggle(key).then(function (v) {
            itm.Status = v;
          });
        });
      };


/*      tipoSvc.listGestao({}).then(function(v) {
        v = orderByFilter(v, '-Principal');

        vm.Filter.TipoAtracao = v[0].IdTipoAtracao;
        vm.Filter.Todos = 1;
        vm.Filter.Status = 1;

        if (v.length > 0) {
          vm.tiposAtracao = v;

          vm.ObterTitulo = function() {

            return vm.tiposAtracao.filter(
              function(v) {
                return v.IdTipoAtracao == vm.Filter.TipoAtracao;
              })[0].IdTipoAtracao
          }
        } else {

          vm.ObterTitulo = function() {
            return v[0].IdTipoAtracao == 1 ? 'SHOW' : v[0].IdTipoAtracao == 2 ? 'SHOW' : '';
          }
        }
      });*/

      function customToggle(itm) {
        var key = {
          IdAtracao: itm.Id
        };

        var text = itm.Status === 1 ? 'Deseja inativar essa atração?' : 'Deseja ativar essa atração?';
        var textTitle = itm.Status === 1 ? 'Inativar Atração' : 'Ativar atração.';

        vm.utils.Confirm(textTitle, text).then(function() {

          atracaoEstabelecimentoSvc.toggle(key).then(function(v) {
            itm.Status = v;
          });
        });
      }

      function novaAtracao() {
        $state.go('conteudo.atracao.wizard.ficha_tecnica', {
          filter: {
            IdTipoAtracao: vm.Filter.TipoAtracao,
            NomeAtracao: vm.Filter.Nome,
            IdEstabelecimento: vm.Filter.IdEstabelecimento
          }
        });
      }
    }
  ])
})();

(function() {
  'use strict';
  angular.module('ticket.controller.conteudo')
    .controller('ticket.controller.conteudo.atracao.grid',
      [
        "common",
        "$state",
        "ticket.service.conteudo.atracao",
        "ticket.service.conteudo.atracaoestabelecimento",
        "ticket.service.controleestabelecimento.estabelecimento",
        function (common, $state, atracaoSvc, atracaoEstabelecimentoSvc, estabelecimentoSvc) {

          var vm = common.controller.grid(this, atracaoSvc);

          vm.CountAtracao = 0;
          vm.page = 0;
          vm.items = [];
          vm.searching = false;
          vm.complete = false;
          vm.sh = false;
          vm.NotResult = false;
          var pageSize = 20;


          estabelecimentoSvc.list({}).then(function(listData) {
            vm.lstEstabelecimento = listData;
          });

          // atracaoSvc.getAllGestao({
          //   Config: {
          //     Skip: vm.page,
          //     Top: pageSize
          //   },
          //   Filter: {
          //     Todos: true
          //   }
          // })
          // .then(function(data) {
          //   vm.CountAtracao = data.length;
          // });


          vm.search = function(inScroll) {

            vm.sh = true;
            if (vm.searching) return;
            vm.searching = true;

            if (!inScroll) {
              vm.page = 0;
              vm.complete = false;
              vm.items = [];
            }

            var QueryFilter = {
              Config: {
                Skip: vm.page,
                Top: pageSize
              },
              Filter: vm.Filter
            };

            atracaoSvc.getAllGestao(QueryFilter)
              .then(function(data) {

                vm.items = vm.items.concat(data);

                if (data.length < pageSize)
                  vm.complete = true;

                if (data.length > 0) {
                  vm.NotResult = false;
                  vm.page += 1;
                }
                else
                {
                  vm.NotResult = true;
                }

              }).finally(function() {
              vm.searching = false;
            });
          };



          // var atracao  = atracaoEstabelecimentoSvc.list({IdEstabelecimento:''}).then(function (atr) {
          //   console.log('count atr', atr.length);
          // });

          vm.editarInformacoesExclusivas = editarInformacoesExclusivas;
          vm.editarAtracao = editarAtracao;
          vm.customToggle = customToggle;
          vm.desassociar = desassociar;

          // Obter Ativos
          vm.Filter.Status = 1;
          vm.atracaoEstabelecimentoSvc = atracaoEstabelecimentoSvc;

          vm.ordenar = function() {

            $state.go('conteudo.atracao.ordenacao')
          };

          vm.novaAtracao = function() {

            $state.go('conteudo.atracao.pre_cadastro')
          };



          /* funções */
          function desassociar(itm) {
            vm.utils.Confirm("Desassociar Atração", "Deseja desassociar esta atração?").then(function() {

              var key = {
                IdAtracao: itm.Id
              };
              vm.loadPopup = true;
              vm.atracaoEstabelecimentoSvc.del(key).then(function(data) {
                vm.items.splice(vm.items.indexOf(itm), 1);
                vm.utils.ShowSuccess("Desassociar Atração", "Atração desassociada com sucesso!");
              }).finally(function() {
                delete vm.loadPopup;
              });
            });
          }


          function editarAtracao(itm) {
            //$state.go('conteudo.atracao.wizard.ficha_tecnica', { filter: { Id: itm.Id, NumeroVersao: itm.NumeroVersao, IdTipoAtracao: itm.IdTipoAtracao } });
            $state.go('conteudo.atracao.wizard.ficha_tecnica', {
              filter: {
                NumeroVersao: itm.NumeroVersao,
                IdTipoAtracao: itm.IdTipoAtracao,
                IdAtracao: itm.IdAtracao,
                IdEstabelecimento: itm.IdEstabelecimento
              }
            });
          }

          function editarInformacoesExclusivas(itm) {

            $state.go('conteudo.atracao.informacoesexclusivas', {
              Id: itm.IdAtracao,
              IdEstabelecimento: itm.IdEstabelecimento
            });
          }

          function customToggle(itm) {
            var key = {
              Id: itm.IdAtracao,
              IdEstabelecimento: itm.IdEstabelecimento
            };


            vm.atracaoEstabelecimentoSvc.toggle(key).then(function(v) {
              itm.Status = v;
            });
          }
        }
      ])

})();

(function() {
  'use strict';

  angular
    .module('ticket.controller.conteudo')
    .controller('ticket.controller.conteudo.atracao', ["$scope", "common", "ticket.service.conteudo.atracao", "ticket.service.conteudo.atracaoestabelecimento", function($scope, common, atracaoSvc) {
      var vm = common.controller.master(this, atracaoSvc, $scope);


    }])
    .controller('ticket.controller.conteudo.atracao.form', ["common", "ticket.service.conteudo.atracao",
      function(common, atracaoSvc) {

        var vm = common.controller.form(this, atracaoSvc);

      }
    ])
    .controller('ticket.controller.conteudo.atracao.informacoesexclusivas', ["$state", '$stateParams', "common", "ticket.service.conteudo.atracaoestabelecimento", "ticket.service.controleestabelecimento.estabelecimentoconfiguracaoinformacao",
      function($state, $stateParams, common, atracaoestabelecimentoSvc, estabelecimentoConfiguracaoInformacaoSvc) {

        var vm = common.controller.form(this, atracaoestabelecimentoSvc);



        if ($stateParams.Id === null && $stateParams.IdAtracao === "") {

          estabelecimentoConfiguracaoInformacaoSvc.get({
            Id: $stateParams.IdEstabelecimento
          }).then(function(data) {
            vm.item.NotasAtracaoCompra = data.NotasEstabelecimentoCompra;
            vm.item.NotasAtracaoImpressao = data.NotasEstabelecimentoImpressao;
          });
        }

      }
    ]);

})();

(function() {
  'use strict';

  angular
    .module('ticket.controller.conteudo')

    .controller('ticket.controller.conteudo.atracao.ordenacao', [
      "$state",
      '$stateParams',
      "common",
      "$scope",
      '$element',
      'toaster',
      'ticket.service.conteudo.atracao',
      'dragulaService',
      'ticket.service.conteudo.atracaodestaque',
      function($state, $stateParams, common, $scope,$element,toaster, atracaoSvc,dragulaService, atracaoDestaqueSvc) {

        var vm = common.controller.basic(this);

        var filter = {
          IdTipoArquivo: 1,
          IdTipoDestaque: 1,
          CidadeUri: null
        };
        atracaoSvc.listAtracaosite(filter).then(function (data) {
          vm.items = data;
        })

        vm.save = function () {
          vm.loading = true;
          atracaoDestaqueSvc.ordenar(vm.items).then(function () {
            toaster.pop('success', 'Ordenação', "Ordenação realizada com sucesso!");
          }).finally(function () {
            vm.loading = false;
          })
        }
      }

    ]);
})();

(function() {
  'use strict';
  angular.module('ticket.controller.conteudo').controller('ticket.controller.conteudo.artista.grid',  [
    '$state',
    'common',
    'ticket.service.conteudo.artista',
    'ticket.service.conteudo.artistaversao',
    function ($state, common, artistaSrv, artistaVersaoSrv) {

    var vm = common.controller.grid(this, artistaSrv);
    vm.add = function() {
      $state.go('conteudo.artista.form');
    };
  }
  ]);


})();
(function () {
  'use strict';
  angular.module('ticket.controller.conteudo')
    .controller('ticket.controller.conteudo.artista.form', [
    '$state',
    '$scope',
    'common',
    'Upload',
    '$q',
    '$uibModal',
    'ticket.helper.fields.fieldhelper',
    'ticket.service.conteudo.artista',
    'ticket.service.conteudo.artistaversao',
    'ticket.service.conteudo.tipoartista',
    'ticket.service.conteudo.artistatipoartista',
    function ($state, $scope, common, Upload, $q, $uibModal, fieldHelper, artistaSrv, artistaVersaoSrv, tipoartistaSvc, artistatipoartistaSvc) {

    var vm = common.controller.form(this, artistaSrv);

    vm.items = {};
    vm.Artista = {};
    vm.ArtistaVersao = {};
    vm.LugarNaoMarcado = false;
    vm.cancel = function () {
      $state.go('conteudo.artista.grid');
    };

    //Inicialização e outros

    if (vm.sexoList === null || vm.sexoList === undefined) {
      vm.sexoList = fieldHelper.sexoList;
    }
    vm.ArtistaVersao =
      {
        FotoPerfil: null,
        PodeEditar: true,
        ModeradoSite: null
      }

    vm.Ok = false;
    //FIM initialize

    tipoartistaSvc.list({}).then(function (data) {
      vm.TipoArtistas = data;
    }).finally(function () {
      vm.Ok = true;
    });

    if ($state.params.Id !== null && $state.params.NumeroVersao) {

      artistaVersaoSrv.get({
        IdArtista: $state.params.Id
        , NumeroVersao: $state.params.NumeroVersao
      }).then(function (art) {


        //HAND MAPPING =( > AUTO MAPPING
        if (art !== null || art !== undefined) {

          vm.items = art;
          vm.ArtistaVersao = {
            IdArtista: art.IdArtista,
            NomeArtisticoHistorico: art.NomeArtisticoHistorico,
            NomeCompleto: art.NomeCompleto,
            FotoPerfil: art.FotoPerfil,
            Sexo: art.Sexo,
            PodeEditar: art.PodeEditar,
            ModeradoSite: art.ModeradoArtistaVersao
          }
        }
        vm.Artista = {
          IdArtista: art.IdArtista,
          ModeradoSite: art.ModeradoArtista
        }
      });

      $scope.$watch('vm.Ok', function () {

        if (vm.TipoArtistas) {
          artistatipoartistaSvc.list({
            IdArtista: $state.params.Id
            , NumeroVersao: $state.params.NumeroVersao
          }).then(function (data) {

            vm.TipoArtistas.forEach(function (item) {
              data.forEach(function (itmData) {
                if (itmData.IdTipoArtista == item.Id)
                  item.Selecionado = true;
              })

            })
          })
        }
      }, true);

    }


    $scope.$watch('vm.ArtistaVersao.NomeArtisticoHistorico', function () {
      if (vm.items !== undefined) {
        vm.items.Uri = fieldHelper.gerarUri(vm.ArtistaVersao.NomeArtisticoHistorico);
      }
    });


    vm.save = function () {

      if(vm.TipoArtistas.filter(function (itm) {
          return itm.Selecionado == true;
        }).length == 0){

        vm.LugarNaoMarcado = true;
        return ;
      }

      artistaSrv.post({
        Artista: vm.Artista,
        ArtistaVersao: vm.ArtistaVersao,
        TipoArtista: vm.TipoArtistas
      }).then(function () {
        vm.utils.ShowSuccess("Inclusão de registro", "Operação realizada com sucesso!");
        $state.go('conteudo.artista.grid');
      })
        .finally(function () {
          vm.loading = false;
        });

    };
    vm.DialogCrop = function (image) {
      return $uibModal.open({
        animation: false,
        templateUrl: 'view/conteudo/artista/template/crop_tmpl.html',
        controller: 'ticket.controller.conteudo.artista.crop_image',
        controllerAs: 'vm',
        size: 'lg',
        resolve: {
          image: function () {
            return image;
          }
        }
      })
        .result.then(function (imgResult) {
            return imgResult;
          },
          function (e) {
            console.log(e);
          });
    };


    //FOTO PERFIL
    //EVENTO
    $scope.$watch('vm.FotoPerfil', function () {
      if (vm.FotoPerfil != null) {
        vm.spinFotoPerfil = true;
        UploadFotoPerfil(vm.FotoPerfil);
      }
    });

    //UPLOAD EVENTO
    vm.uploadFotoPerfil = function ($files) {
      UploadFotoPerfil($files);
    };

    //UPLOAD
    function UploadFotoPerfil(files) {
      upload(files).then(function (v) {
        vm.DialogCrop(v).then(function (images) {
          var arrImagens = [];
          arrImagens.push(images);
          artistaSrv.uploadImagem(arrImagens).then(function (data) {
            if (data.statusText = "OK") {
              vm.ArtistaVersao.FotoPerfil = data.data.Imagem;
            }
          }).finally(function () {
            vm.spinFotoPerfil = false;
            vm.items.FotoPerfil = vm.ArtistaVersao.FotoPerfil;
          });
        });
      });
    }

    //DELETE
    vm.DeleteFotoPerfil = function (imagem, ev) {
      vm.utils.Confirm('EXCLUIR', 'Confirma a exclusão da imagem?').then(function () {
        vm.ArtistaVersao.FotoPerfil = null;
        vm.items.FotoPerfil = null;
      });
    };
    //FIM UPLOAD CAPA

    function upload($files) {
      var def = $q.defer();
      var file = $files[0];
      var result = [];
      var reader = new FileReader();
      reader.onerror = reader.onabort = function () {
        def.reject('Falha ao ler o arquivo')
      };
      reader.onload = function (evt) {
        $scope.$apply(function () {
          if (result.indexOf(evt.target.result) === -1) {
            result.push(evt.target.result);
          }

          if ($files.length == 0)
            def.resolve(result);
          else
            reader.readAsDataURL($files.splice(0, 1)[0]);
        });
      };
      reader.readAsDataURL($files.splice(0, 1)[0]);
      return def.promise;
    }

  }
  ]);

  

  
})();

(function() {
  'use strict';
  angular.module('ticket.controller.conteudo')
    .controller("ticket.controller.conteudo.artista.crop_image", ["$scope", "$uibModalInstance", "image", function ($scope, $uibModalInstance, image) {
    var vm = this;

    vm.size = 'large';
    vm.type = 'square';
    vm.imageDataURI = image[0];
    vm.resImageDataURI = '';
    vm.resImgFormat = 'image/jpg';
    vm.resImgQuality = 1;
    //vm.selMinSize = 100;
    //vm.resImgSize = 200;

    vm.Confirm = function() {
      $uibModalInstance.close(vm.resImageDataURI);
    };

    vm.Cancel = function() {
      $uibModalInstance.dismiss('cancel');
    };
  }] );

})();
(function() {
  'use strict';

  angular
    .module('ticket.controller.authentication')
    .controller('ticket.authentication.signup.controller', ["$scope", "$state", "$mdToast", "$http", "$filter", "triSettings", function($scope, $state, $mdToast, $http, $filter, triSettings) {
      var vm = this;
      vm.triSettings = triSettings;
      vm.signupClick = signupClick;
      vm.user = {
        name: '',
        email: '',
        password: '',
        confirm: ''
      };



      ////////////////

      function signupClick() {
        $mdToast.show(
          $mdToast.simple()
          .content($filter('triTranslate')('Confirmation sent'))
          .position('bottom right')
          .action($filter('triTranslate')('Login'))
          .highlightAction(true)
          .hideDelay(0)
        ).then(function() {
          $state.go('authentication.login');
        });
      }
    }]);
})();
(function() {
  'use strict';

  angular
    .module('ticket.controller.authentication')
    .controller('ticket.controller.authentication.login', ["$state", "ticketSettings", "$scope", "common", "ticket.service.controleacesso.login",
      function($state, ticketSettings, $scope, common, loginSvc) {
        var vm = common.controller.instantiate(this);

        //SE ENTROU NESSE CONTROLLER, ENTÃO PERDE AS CREDENCIAIS.
        loginSvc.Logout(true);


        function loginClick() {
          vm.loading = true;
          loginSvc.Logon(vm.user)
            .then(function(v) {
                $state.go('site.home');
              },
              function(e) {
                var msg = "Usuário/Senha incorretos. Verifique as informações e tente novamente.";

                if (e.status == -1) {
                  msg = "Falha ao acessar o serviço. Verifique sua conexão com a internet."
                }

                vm.utils.ShowError("Identificação no sistema", msg);

              })
            .finally(function(e) {
              vm.loading = false;
            });
        }

        vm.loginClick = loginClick;
        vm.socialLogins = [{
          icon: 'fa fa-twitter',
          color: '#5bc0de',
          url: '#'
        }, {
          icon: 'fa fa-facebook',
          color: '#337ab7',
          url: '#'
        }, {
          icon: 'fa fa-google-plus',
          color: '#e05d6f',
          url: '#'
        }, {
          icon: 'fa fa-linkedin',
          color: '#337ab7',
          url: '#'
        }];
        vm.ticketSettings = ticketSettings;
        // create blank user variable for login form
        vm.user = {
          email: '',
          password: ''
        };





      }
    ]);


})();
(function() {
  'use strict';

  angular
    .module('ticket.controller.authentication')
    .controller('ticket.controller.authentication.resetpassword', ["$q", "$state", "$stateParams", "common", "ticket.service.controleacesso.usuario", "ticket.service.controleacesso.login", "ticketSettings", function($q, $state, $stateParams, common, usuarioSvc, loginSvc, ticketSettings) {
      var vm = common.controller.basic(this);

      vm.user = {
        Password: '',
        Token: $stateParams.token
      };
      vm.pageTitle = $state.current.data.pageTitle;

      vm.loading = true;
      vm.err = false;
      vm.showFields = false;

      usuarioSvc.resetPasswordValidate($stateParams.token).then(
        function(res) {
          vm.showFields = true;
        },
        function(err) {
          vm.err = true;
          var d = {
            Message: 'Ocorreu um erro ao acessar o serviço'
          }
          var m = err.data || d;
          vm.errMsg = m.Message || d.Message;
        }
      ).finally(function() {
        vm.loading = false;
      });

      vm.ComparaSenha = function(value) {
        var def = $q.defer();

        if (value == vm.user.Password) {
          def.resolve(true);
        } else {
          def.reject(false);
        }

        return def.promise;
      };

      vm.Change = function() {
        vm.loading = true;
        usuarioSvc.resetPasswordConfirm(vm.user).then(
          function(res) {
            vm.utils.ShowSuccess("Alteração de senha", "Sua senha foi alterada com sucesso.")

            loginSvc.Logon({
              email: res.Login,
              password: vm.user.Password
            }).then(function(v) {
              (v.estabelecimento == null) ? $state.go('auth.establishment'): $state.go('site.home');
            });
          },
          function(e) {}
        ).finally(function() {
          vm.loading = false;
        });
      }


    }]);


})();
(function() {
    'use strict';

    angular
        .module('ticket.controller.authentication')
        .controller('ticket.controller.authentication.forgot', ["$state", "ticketSettings", "common", "ticket.service.controleacesso.captcha", "ticket.service.controleacesso.usuario", function ($state, ticketSettings, common, captchaSvc, usuarioSvc) {
            var vm = common.controller.instantiate(this);

            vm.ticketSettings = ticketSettings;
            vm.user = { Email: '' };

            vm.loadingCaptcha = true;
            vm.loadingError   = false;

            //busca um novo hash e renderiza o captcha que está associado.
            vm.reload = function(){
                vm.loadingError = false;

                return captchaSvc.get()
                    .then
                    (
                        function(v){ vm.user.Hash = v.Chave; },
                        function(err){ vm.ImgCaptcha = null; vm.loadingError = true; }
                    )
                    .finally
                    (
                        function(){ vm.loadingCaptcha = false; }
                    );
            }

            //renderiza o captcha
            vm.renderCaptcha = function(){
                vm.loadingCaptcha = true;
                vm.loadingError = false;

                captchaSvc.render({Chave: vm.user.Hash})
                .then(
                    function(v){vm.ImgCaptcha = v;},
                    function(err){vm.reload();}
                )
                .finally(
                    function(){vm.loadingCaptcha = false;}
                );
            };

            vm.reseting = false;

            //Dispara o reinicio da senha
            vm.resetClick = function(){
                vm.reseting = true;
                usuarioSvc.resetPasswordV2(vm.user).then(
                    function(){
                        vm.utils.ShowSuccess("Recuperação de senha", "Enviamos as instruções para o seu e-mail.")
                        $state.go('auth.login')
                    },
                    function(err){
                        vm.reload();
                    }
                ).finally(function(){
                    vm.reseting = false;
                });
            }


            vm.reload().then(function(){ vm.renderCaptcha(); });

        }]);

})();

(function() {
  'use strict';

  angular
    .module('ticket.service.conteudo', []);
})();
(function() {
  'use strict';

  angular
    .module('ticket.service.conteudo')
    .factory('ticket.service.conteudo.video', ['common', 'Upload', 'appSettings', '$http', '$q', function(common, Upload, appSettings, $http, $q) {
      var res = {

        uploadVideo: function(imageBase64) {

          return $http.post(appSettings.url + "controleconteudo/videohome/UploadVideo", imageBase64)
            .then(function(resp) {
              return resp;
            }, function(err) {
              return err;
            }, function(evt) {
              return parseInt(100.0 * evt.loaded / evt.total);
            });
        },

        deleteImagem: function(imagem) {

          var Imagem = {
            Nome: imagem
          };

          return $http.post(appSettings.url + "artista/DeleteImage", Imagem)
            .then(function(resp) {
              return resp;
            }, function(err) {
              return err;
            }, function(evt) {
              return parseInt(100.0 * evt.loaded / evt.total);
            });
        },
        desabilitarBanner: function (key) {
          return this.request("desabilitarBanner", key);
        },
        getbanners: function (key) {
          return this.request("getbanners", key);
        }
      }; //<-- Customize aqui seu service
      return common.service.instantiate(res, "controleconteudo/videohome/");
    }]);
})();

/**
 * Created by thainan.gomes on 26/06/2017.
 */
(function() {
  'use strict';

  var mod = angular.module('ticket.service.conteudo');

  mod.factory("ticket.service.conteudo.tiposessao", ["common", function(common) {
    var res = {}; //<-- Customize aqui seu service

    return common.service.instantiate(res, "programacao/tiposessao/");
  }]);

})();

/**
 * Created by thainan.gomes on 26/06/2017.
 */
(function() {
  'use strict';

  var mod = angular.module('ticket.service.conteudo');

  mod.factory("ticket.service.conteudo.tipoatracao", ["common", function(common) {
    var res = {
      listConveniencia: function(filter) {
        return this.request("listconveniencia", filter);
      }
    }; //<-- Customize aqui seu service

    return common.service.instantiate(res, "controleconteudo/tipoAtracao/");
  }]);

})();

(function() {
  'use strict';

  angular
    .module('ticket.service.conteudo')
    .factory('ticket.service.conteudo.tipoartista', ['common', function(common) {
      var res = {}; //<-- Customize aqui seu service
      return common.service.instantiate(res, "controleconteudo/tipoartista/");
    }])
})();

(function() {
  'use strict';

  var mod = angular.module('ticket.service.conteudo');

  mod.factory("ticket.service.conteudo.sessao", ["common", function(common) {
    var res = {

      listConveniencia: function(filter) {
        return this.request("listconveniencia", filter);
      }
    }; //<-- Customize aqui seu service

    return common.service.instantiate(res, "programacao/sessao/");
  }]);

})();

(function() {
  'use strict';

  var mod = angular.module('ticket.service.conteudo');

  mod.factory("ticket.service.conteudo.inadequacao", ["common", "$q", "$timeout", function(common, $q, $timeout) {
    var res = {};

    return common.service.instantiate(res, "controleconteudo/inadequacao/");

  }]);

})();
(function() {
  'use strict';

  angular.module('ticket.service.conteudo')
    .factory("ticket.service.conteudo.genero", generoFactory);

  generoFactory.$inject = ["common"];

  function generoFactory(common) {
    var res = {
      postGestao: postGestao,
      putGestao: putGestao
    }; //<-- Customize aqui seu service
    return common.service.instantiate(res, "controleconteudo/genero/");


    function postGestao(itm) {
      return this.request("postgestao", itm);
    }

    function putGestao(itm) {
      return this.request("putgestao", itm);
    }
  }

})();
(function() {
  'use strict';

  angular.module('ticket.service.conteudo')

  .factory("ticket.service.conteudo.classificacao", ["common", function(common) {
    var res = {}; //<-- Customize aqui seu service

    return common.service.instantiate(res, "controleconteudo/classificacao/");
  }]);

})();
(function() {
  'use strict';

  angular
    .module('ticket.service.conteudo')
    .factory('ticket.service.conteudo.banner', ['common', 'Upload', 'appSettings', '$http', '$q', function(common, Upload, appSettings, $http, $q) {
      var res = {

        uploadImagem: function(imageBase64) {

          return $http.post(appSettings.url + "controleconteudo/atracaobanner/UploadImage", imageBase64)
            .then(function(resp) {
              return resp;
            }, function(err) {
              return err;
            }, function(evt) {
              return parseInt(100.0 * evt.loaded / evt.total);
            });
        },

        deleteImagem: function(imagem) {

          var Imagem = {
            Nome: imagem
          };

          return $http.post(appSettings.url + "artista/DeleteImage", Imagem)
            .then(function(resp) {
              return resp;
            }, function(err) {
              return err;
            }, function(evt) {
              return parseInt(100.0 * evt.loaded / evt.total);
            });
        },
        desabilitarBanner: function (key) {
          return this.request("desabilitarBanner", key);
        },
        getbanners: function (key) {
          return this.request("getbanners", key);
        }
      }; //<-- Customize aqui seu service
      return common.service.instantiate(res, "controleconteudo/atracaobanner/");
    }]);
})();

(function() {
  'use strict';

  angular
    .module('ticket.service.conteudo')
    .factory('ticket.service.conteudo.bandaversao', ['common', function(common) {
      var res = {}; //<-- Customize aqui seu service
      return common.service.instantiate(res, "controleconteudo/bandaversao/");
    }])
})();
(function() {
  'use strict';

  angular
    .module('ticket.service.conteudo')
    .factory('ticket.service.conteudo.bandaartista', ['common', function(common) {
      var res = {}; //<-- Customize aqui seu service
      return common.service.instantiate(res, "controleconteudo/bandaartista/");
    }])
})();
(function() {
  'use strict';

  angular
    .module('ticket.service.conteudo')
    .factory('ticket.service.conteudo.banda', ['common', 'Upload', 'appSettings', '$http', '$q', function(common, Upload, appSettings, $http, $q) {
      var res = {
        uploadImagem: function(imageBase64) {

          return $http.post(appSettings.url + "controleconteudo/banda/UploadImage", imageBase64)
            .then(function(resp) {
              return resp;
            }, function(err) {
              return err;
            }, function(evt) {
              return parseInt(100.0 * evt.loaded / evt.total);
            });
        },

        deleteImagem: function(imagem) {

          var Imagem = {
            Nome: imagem
          };

          return $http.post(appSettings.url + "controleconteudo/banda/DeleteImage", Imagem)
            .then(function(resp) {
              return resp;
            }, function(err) {
              return err;
            }, function(evt) {
              return parseInt(100.0 * evt.loaded / evt.total);
            });
        }
      }; //<-- Customize aqui seu service
      return common.service.instantiate(res, "controleconteudo/banda/");
    }])
})();
(function() {
  'use strict';

  angular.module('ticket.service.conteudo')

  .factory("ticket.service.conteudo.atracaoversao", [
    "common",
    "Upload",
    "ticket.service.controleacesso.login",
    "appSettings",
    "$http",
    "$q",
    function(common, Upload, loginSvc, appSettings, $http, $q) {

      var res = {}; //<-- Customize aqui seu service

      //return res;

      return common.service.instantiate(res, "controleconteudo/atracaoversao/");
    }
  ]);

})();
(function() {
  'use strict';

  var mod = angular.module('ticket.service.conteudo');

  mod.factory("ticket.service.conteudo.atracaoparticipante", ["common", "$q", "$timeout", function(common, $q, $timeout) {
    var res = {};

    return common.service.instantiate(res, "controleconteudo/atracaoparticipante/");

  }]);

})();
(function() {
  'use strict';

  var mod = angular.module('ticket.service.conteudo');

  mod.factory("ticket.service.conteudo.atracaoestabelecimentofilafraude", ["common", function(common) {
    var res = {}

    return common.service.instantiate(res, "controleconteudo/atracaoestabelecimentofilafraude/");
  }]);

})();

(function() {
  'use strict';

  var mod = angular.module('ticket.service.conteudo');

  mod.factory("ticket.service.conteudo.atracaoestabelecimento", ["common", function(common) {
    var res = {

      associar: function (form) {
        return this.request("associar", form);
      }
    };
    return common.service.instantiate(res, "controleconteudo/atracaoestabelecimento/");
  }]);

})();

(function() {
  'use strict';

  var mod = angular.module('ticket.service.conteudo');

  mod.factory("ticket.service.conteudo.atracaobanda", ["common", "$q", "$timeout", function(common, $q, $timeout) {
    var res = {};

    return common.service.instantiate(res, "controleconteudo/atracaobanda/");

  }]);

})();
(function() {
  'use strict';

  angular
    .module('ticket.service.conteudo')
    .factory('ticket.service.conteudo.atracaoarquivo', ['common', function(common) {
      var res = { listarquivos: function (filter) {
        return this.request("listarquivos", filter);
      }}; //<-- Customize aqui seu service
      return common.service.instantiate(res, "controleconteudo/atracaoarquivo/");
    }])
})();

(function() {
  'use strict';

  angular
    .module('ticket.service.conteudo')
    .factory('ticket.service.conteudo.atracaoinadequacao', ['common', function(common) {
      var res = {}; //<-- Customize aqui seu service
      return common.service.instantiate(res, "controleconteudo/atracaoinadequacao/");
    }])
})();
(function() {
  'use strict';

  angular
    .module('ticket.service.conteudo')
    .factory('ticket.service.conteudo.atracaogenero', ['common', function(common) {
      var res = {}; //<-- Customize aqui seu service
      return common.service.instantiate(res, "controleconteudo/atracaogenero/");
    }])
})();
(function() {
  'use strict';

  angular
    .module('ticket.service.conteudo')
    .factory('ticket.service.conteudo.atracaoavaliacao', ['common', function(common) {
      var res = {

 	   ListModeracao: function(filter){
       	 return this.request('listModeracao', filter);
       }
      }; //<-- Customize aqui seu service
      return common.service.instantiate(res, "controleconteudo/atracaoavaliacao/");
    }])
})();
(function() {
  'use strict';

  angular.module('ticket.service.conteudo')

  .factory("ticket.service.conteudo.atracao", [
    "common",
    "Upload",
    "ticket.service.controleacesso.login",
    "appSettings",
    "$http",
    "$q",
    function(common, Upload, loginSvc, appSettings, $http, $q) {

      var res = {

        listFuturas: function (filter) {
          return this.request("listFuturas", filter);
        },

        getAllGestao: function(filter) {
          return this.request("getallgestao", filter);
        },

        uploadVideoGestao: function(file) {
          if (!file) return;

          var fd = new FormData();

          fd.append("file", file);

          var def = $q.defer();

          $http.post(appSettings.url + "controleconteudo/atracao/UploadVideo", fd, {
              transformRequest: angular.identity,
              headers: {
                'Content-Type': undefined
              },
              uploadEventHandlers: {
                progress: function(e) {
                  def.notify(e);
                }
              }
            })
            .then(
              function(resp) {
                def.resolve(resp);
              },
              function(err) {
                def.reject(err);
              }
            );

          return def.promise;
        },

        uploadVideo: function(itm) {

          var fd = new FormData();

          fd.append("file", itm.file[0]);

          var def = $q.defer();

          $http.post(appSettings.url + "controleconteudo/atracao/UploadVideo", fd, {
              transformRequest: angular.identity,
              headers: {
                'Content-Type': undefined
              },
              uploadEventHandlers: {
                progress: function(e) {
                  def.notify(e);
                }
              }
            })
            .then(
              function(resp) {
                def.resolve(resp);
              },
              function(err) {
                def.reject(err);
              }
            );

          return def.promise;
        },

        // uploadImagem: function (imageBase64) {
        //   return this.request("UploadImage", imageBase64);
        // },

        uploadImagem: function(imageBase64) {

          return $http.post(appSettings.url + "controleconteudo/atracao/UploadImage", imageBase64)
            .then(function(resp) {
              return resp;
            }, function(err) {
              return err;
            }, function(evt) {
              return parseInt(100.0 * evt.loaded / evt.total);
            });
        },

        deleteImagem: function(imagem) {

          //var Imagem = { Nome: imagem };

          return $http.post(appSettings.url + "controleconteudo/atracao/DeleteImage", imagem)
            .then(function(resp) {
              return resp;
            }, function(err) {
              return err;
            }, function(evt) {
              return parseInt(100.0 * evt.loaded / evt.total);
            });
        },

        save: function(NovaAtracao) {

          var Atracao = {
            Nome: NovaAtracao.FichaTecnica.Nome,
            IdAtracao: NovaAtracao.Atracao.IdAtracao,
            FilaFraude: true,
            IdTipoAtracao: NovaAtracao.Atracao.IdTipoAtracao,
            Ativo: true,
            User: ''
          }

          var AtracaoEstabelecimento = {};

          var Generos = NovaAtracao.FichaTecnica.Generos;
          var Inadequacoes = NovaAtracao.FichaTecnica.Inadequacoes;
          var Participantes = NovaAtracao.Participantes;
          var Banda = NovaAtracao.Banda;

          var AtracaoVersao = {
            NomeHistorico: NovaAtracao.FichaTecnica.Nome,
            NomeOriginal: NovaAtracao.FichaTecnica.NomeOriginal,
            IdClassificacao: NovaAtracao.FichaTecnica.IdClassificacao,
            Sinopse: NovaAtracao.Sinopse.Texto,
            Duracao: NovaAtracao.FichaTecnica.Duracao,
            PaisOrigem: NovaAtracao.FichaTecnica.PaisOrigem,
            IdiomaOriginal: NovaAtracao.FichaTecnica.IdiomaOriginal,
            UrlOficial: NovaAtracao.FichaTecnica.UrlOficial,
            AnoLancamento: NovaAtracao.FichaTecnica.AnoLancamento,
            DataEstreia: NovaAtracao.FichaTecnica.DataEstreia,
            Uri: "Uri",
            Status: "",
            User: ""
          }

          var AtracaoArquivo = NovaAtracao.Midia.AtracaoArquivo;

          return this.request("post", {
            IdEstabelecimento: NovaAtracao.IdEstabelecimento,
            Atracao: Atracao,
            Generos: Generos,
            Inadequacoes: Inadequacoes,
            Participantes: Participantes,
            Bandas: Banda,
            AtracaoVersao: AtracaoVersao,
            AtracaoEstabelecimento: AtracaoEstabelecimento,
            AtracaoArquivo: AtracaoArquivo
          });
        },

        listConveniencia: function(filter) {
          return this.request("listconveniencia", filter);
        },

        listAtracaoProgramacao: function(filter) {
          return this.request("listatracaoprogramacao", filter);
        },

        listAtracaosite : function (filter) {
          return this.request("sitelist", filter)
        }


      }; //<-- Customize aqui seu service

      //return res;

      return common.service.instantiate(res, "controleconteudo/atracao/");
    }
  ]);

})();

(function() {
  'use strict';

  angular
    .module('ticket.service.conteudo')
    .factory('ticket.service.conteudo.atracaodestaque', ['common', 'Upload', 'appSettings', '$http', '$q', function(common, Upload, appSettings, $http, $q) {
      var res = {
        ordenar: function (form) {
          return this.request("ordenar", form);
        },
      }; //<-- Customize aqui seu service
      return common.service.instantiate(res, "controleconteudo/atracaodestaque/");
    }]);
})();

(function() {
  'use strict';

  angular
    .module('ticket.service.conteudo')
    .factory('ticket.service.conteudo.artistaversao', ['common', function(common) {
      var res = {}; //<-- Customize aqui seu service
      return common.service.instantiate(res, "controleconteudo/artistaversao/");
    }])
})();

(function() {
  "use strict";

  var mod = angular.module('ticket.service.conteudo');

  mod.factory("ticket.service.conteudo.artistatipoartista", ["common", function(common) {
    var res = {}; //<-- Customize aqui seu service

    return common.service.instantiate(res, "controleconteudo/artistatipoartista/");

  }])
})();
(function() {
  'use strict';

  angular
    .module('ticket.service.conteudo')
    .factory('ticket.service.conteudo.artista', ['common', 'Upload', 'appSettings', '$http', '$q', function(common, Upload, appSettings, $http, $q) {
      var res = {

        uploadImagem: function(imageBase64) {

          return $http.post(appSettings.url + "artista/UploadImage", imageBase64)
            .then(function(resp) {
              return resp;
            }, function(err) {
              return err;
            }, function(evt) {
              return parseInt(100.0 * evt.loaded / evt.total);
            });
        },

        deleteImagem: function(imagem) {

          var Imagem = {
            Nome: imagem
          };

          return $http.post(appSettings.url + "artista/DeleteImage", Imagem)
            .then(function(resp) {
              return resp;
            }, function(err) {
              return err;
            }, function(evt) {
              return parseInt(100.0 * evt.loaded / evt.total);
            });
        }
      }; //<-- Customize aqui seu service
      return common.service.instantiate(res, "artista/");
    }]);
})();
(function() {
  'use strict';

  angular
    .module('ticket.translate', [
      'pascalprecht.translate',
      'LocalStorageModule'
    ]);
})();
(function() {
  'use strict';

  angular
    .module('ticket.translate')
    .filter('ticketTranslate', appTranslateFilter);

  /* @ngInject */
  function appTranslateFilter($injector, $filter) {
    return function(input) {
      // if angular translate installed this will return true
      // so we can translate
      if ($injector.has('translateFilter')) {
        return $filter('translate')(input);
      } else {
        // no translation active so just return the same input
        return input;
      }
    };
  }
})();
(function() {
  'use strict';

  angular
    .module('ticket.translate')
    .config(translateConfig);

  /* @ngInject */
  function translateConfig($translateProvider, $translatePartialLoaderProvider, appSettingsProvider) {
    var appLanguages = [{
      name: 'English',
      key: 'en'
    }, {
      name: 'Portuguese',
      key: 'pt'
    }];

    /**
     *  each module loads its own translation file - making it easier to create translations
     *  also translations are not loaded when they aren't needed
     *  each module will have a i18n folder that will contain its translations
     */
    $translateProvider.useLoader('$translatePartialLoader', {
      urlTemplate: '{part}/i18n/{lang}.json'
    });

    $translatePartialLoaderProvider.addPart('app');

    // make sure all values used in translate are sanitized for security
    $translateProvider.useSanitizeValueStrategy('sanitize');

    // cache translation files to save load on server
    $translateProvider.useLoaderCache(true);


    var angularTranslateLanguageKeys = [];
    for (var language in appLanguages) {
      angularTranslateLanguageKeys.push(appLanguages[language].key);

      appSettingsProvider.addLanguage({
        name: appLanguages[language].name,
        key: appLanguages[language].key
      });
    }

    /**
     *  try to detect the users language by checking the following
     *      navigator.language
     *      navigator.browserLanguage
     *      navigator.systemLanguage
     *      navigator.userLanguage
     */
    $translateProvider
      .registerAvailableLanguageKeys(angularTranslateLanguageKeys, {
        'en_US': 'en',
        'en_UK': 'en',
        'pt_BR': 'pt',
        'pt_PT': 'pt'
      })
      .use('pt');

    // store the users language preference in a cookie
    $translateProvider.useLocalStorage();
  }
})();
(function() {
  'use strict';

  angular
    .module('ticket.service.venda', []);
})();

/**
 * Created by thainan.gomes on 28/08/2017.
 */
(function () {
  'use strict';

  angular
    .module('ticket.service.venda')

    .factory("ticket.service.venda.vendasite", ["common", function (common) {
      var res = {
        listOperacao: function (filter) {
          return this.request("listOperacao", filter);
        },

        getOperacao: function (key) {
          return this.request("getOperacao", key);
        }
      }; //<-- Customize aqui seu service

      return common.service.instantiate(res, "venda/vendasite/");
    }]);

})();

(function() {
    'use strict';

    angular
        .module('ticket.service.reports', [ ]);
})();

(function(){
  'use strict';

  angular.module('ticket.service.reports')

    .factory("ticket.service.reports.repasse", ["common", function(common){
      var res = {
        repasseresumo: function(filter){
          return this.request("repasseresumo/", filter);
        },

      }; //<-- Customize aqui seu service

      return common.service.instantiate(res, "relatorio/repasse/");
    }]);

})();

(function(){
  'use strict';

  angular.module('ticket.service.reports')

    .factory("ticket.service.reports.futuras", ["common", function(common){
      var res = {
        futuras: function(filter){
          return this.request("futuras/", filter);
        },

      }; //<-- Customize aqui seu service

      return common.service.instantiate(res, "relatorio/futuras/");
    }]);

})();

(function(){
  'use strict';

  angular.module('ticket.service.reports')

    .factory("ticket.service.reports.financeiro", ["common", function(common){
      var res = {
        financeiro: function(filter){
          return this.request("financeiro/", filter);
        },

      }; //<-- Customize aqui seu service

      return common.service.instantiate(res, "relatorio/financeiro/");
    }]);

})();

(function () {
  'use strict';

  angular.module('ticket.service.reports')
    .factory("ticket.service.reports.bordero", borderoFactory);

  borderoFactory.$inject = ['common'];
  function borderoFactory(common) {
    var res = {
      previa: function(idSessao){
        return this.request("previa/", idSessao);
      },
      bordero: function(idSessao){
        return this.request("bordero/", idSessao);
      },
      getallprevia: function(filter){
        return this.request("getallprevia", filter);
      }
    };
    return common.service.instantiate(res, "reports/bordero/");
  }
})();

(function() {
  'use strict';
  angular
    .module('ticket.service.repasseempresa', []);
})();

(function() {
    'use strict';

    angular
      .module('ticket.service.repasseempresa')

    .factory("ticket.service.repasseempresa", ["common", function(common){
        var res = {
          aprovarrepasse : function (key) {
            var key = {IdRepasseEmpresa : key};
            return this.request("aprovarrepasse", key);
          }
        }; //<-- Customize aqui seu service

        return common.service.instantiate(res, "fluxocaixa/repasseempresa/");
    }]);

})();


(function() {
  'use strict';
  angular
    .module('ticket.service.repasse', []);
})();

(function() {
  'use strict';

  angular
    .module('ticket.service.repasse')
    .factory('ticket.service.repasse', ['common', function(common) {
      var res = {
        listrepasse: function () {
        return this.request("listrepasse");
      },

        repasseresumo: function (filter) {
          return this.request("repasseresumo", filter);
        }

      }; //<-- Customize aqui seu service
      return common.service.instantiate(res, "fluxocaixa/repasse/");
    }])
})();

(function() {
  'use strict';

  angular
    .module('ticket.service.promocao', []);
})();

(function () {
  'use strict';

  angular
    .module('ticket.service.promocao')

    .factory("ticket.service.promocao", ["common", function (common) {
      var res = { 
      	listsemelhante: function(filter){
      		return this.request("listsemelhante", filter);
      	}
      }; //<-- Customize aqui seu service
      
      return common.service.instantiate(res, "promocao/sessaopromocao/");
    }]);

})();

(function () {
  'use strict';

  angular
    .module('ticket.service.promocao')

    .factory("ticket.service.sessaoassentopromocao", ["common", function (common) {
      var res = {  }; //<-- Customize aqui seu service
      
      return common.service.instantiate(res, "promocao/sessaoassentopromocao/");
    }]);

})();

(function() {
  'use strict';

  angular
    .module('ticket.service.programacao', []);
})();

/**
 * Created by thainan.gomes on 23/08/2017.
 */

(function(){
  'use strict';

  angular.module('ticket.service.programacao')

    .factory("ticket.service.programacao.vendasite", ["common","$http","appSettings", function(common,$http,appSettings){
      var res = {
        cancelar: function (key) {
          return this.request("cancelar", key);
        }
      }; //<-- Customize aqui seu service

      return common.service.instantiate(res, "venda/vendasite/");
    }]);

})();

/**
 * Created by thainan.gomes on 18/08/2017.
 */
(function(){
  'use strict';

  angular.module('ticket.service.programacao')

    .factory("ticket.service.programacao.vendaingresso", ["common","$http","appSettings", function(common,$http,appSettings){
      var res = {

        listvendaingressotroca: function (filter) {
          return this.request("listvendaingressotroca", filter);
        }

      }; //<-- Customize aqui seu service

      return common.service.instantiate(res, "venda/vendaingresso/");
    }]);

})();


(function(){
  'use strict';

  angular.module('ticket.service.programacao')

    .factory("ticket.service.programacao.venda", ["common","$http","appSettings", function(common,$http,appSettings){
      var res = {

        rastreio: function (filter) {
          return this.request("rastreio", filter);
        },
        lote: function (filter) {
          return this.request("lote", filter);
        },

        posttroca: function (obj) {
          return this.request("posttroca", obj);
        }
      }; //<-- Customize aqui seu service

      return common.service.instantiate(res, "venda/venda/");
    }]);

})();


(function(){
  'use strict';

  angular.module('ticket.service.programacao')

    .factory("ticket.service.programacao.trocasessao", ["common","$http","appSettings", function(common,$http,appSettings){
      var res = {}; //<-- Customize aqui seu service

      return common.service.instantiate(res, "programacao/trocasessao/");
    }]);

})();

(function () {
    'use strict';

    angular.module('ticket.service.programacao')

        .factory("ticket.service.programacao.setor", ["common", function (common) {
            var res = {
                getSvg: function (filter) {
                    return this.request('svg', filter);
                },

                verificazonalugarlivre: function (idSessao) {
                    return this.request('verificazonalugarlivre?idSessao='+idSessao);
                }
            }; //<-- Customize aqui seu service

            return common.service.instantiate(res, "local/setor/");
        }]);

})();

(function(){
    'use strict';

    angular.module('ticket.service.programacao')

    .factory("ticket.service.programacao.sessaotiposessaoempresa", ["common","$http","appSettings", function(common,$http,appSettings){
        var res = {}; //<-- Customize aqui seu service

        return common.service.instantiate(res, "programacao/sessaotiposessaoempresa/");
    }]);

})();

/**
 * Created by thainan.gomes on 21/08/2017.
 */

(function(){
  'use strict';

  angular.module('ticket.service.programacao')

    .factory("ticket.service.programacao.sessaosetorloteprecoingressoconveniencia", ["common","$http","appSettings", function(common,$http, appSettings){
      var res = {

      }; //<-- Customize aqui seu service

      return common.service.instantiate(res, "programacao/sessaosetorloteprecoingressoconveniencia/");
    }]);
})();

/**
 * Created by thainan.gomes on 21/08/2017.
 */

(function(){
  'use strict';

  angular.module('ticket.service.programacao')

    .factory("ticket.service.programacao.sessaosetorloteprecoingresso", ["common","$http","appSettings", function(common,$http,appSettings){
      var res = {

        listtroca: function (filter) {
          return this.request('listtroca', filter);
        }
      }; //<-- Customize aqui seu service

      return common.service.instantiate(res, "programacao/sessaosetorloteprecoingresso/");
    }]);
})();

/**
 * Created by thainan.gomes on 17/08/2017.
 */
(function(){
  'use strict';

  angular.module('ticket.service.programacao')

    .factory("ticket.service.programacao.sessaosetor", ["common","$http","appSettings", function(common,$http,appSettings){
      var res = {}; //<-- Customize aqui seu service

      return common.service.instantiate(res, "/programacao/sessaosetor/");
    }]);

})();


(function () {
    'use strict';

    angular.module('ticket.service.programacao')

        .factory("ticket.service.programacao.sessaoassento", ["common", function (common) {
            var res = {
                selecionar: function (form) {
                    return this.request('selecionar', form);
                },
                selecionarList: function (lstForm) {
                    return this.request('selecionarmultiplo', lstForm);
                },
                selecionarlivre: function (lstForm) {
                    return this.request('selecionarlivre', lstForm);
                },
                tempoextra: function (lstKey) {
                    return this.request('tempoextra', lstKey);
                },
                
                listall: function(key){ return this.request('listall', key); }

            }; //<-- Customize aqui seu service

            return common.service.instantiate(res, "programacao/sessaoassento/");
        }]);

})();

(function () {
  'use strict';

  angular
    .module('ticket.service.programacao')

    .factory("ticket.service.programacao", ["common", function (common) {
      var res = {
        listSessao: function (key) {
          return this.request("listSessao", key);
        },

        alteraringresso : function (frm) {
          return this.request("alteraringresso", frm);
        },

        resumoProgramacao: function (filter) {
          return this.request("resumoprogramacao", filter);
        },

        listConveniencia: function (filter) {
        return this.request("listconveniencia", filter);
        },

        listTrocaSessao: function (filter) {
          return this.request("listTrocaSessao", filter);
        },

        listProximos: function(filter){
          return this.request("horariolist", filter);
        }


      }; //<-- Customize aqui seu service

      return common.service.instantiate(res, "programacao/sessao/");
    }]);

})();

(function () {
    'use strict';

    angular.module('ticket.service.programacao')

        .factory("ticket.service.programacao.reservaassento", ["common", function (common) {
            var res = {
                limpar: function () {
                    return this.request('limpar');
                }

            }; //<-- Customize aqui seu service

            return common.service.instantiate(res, "venda/reservaassento/");
        }]);

})();

(function () {
    angular.module('ticket.service.programacao')

      .factory('ticket.service.programacao.compra', [
        '$http',
        '$rootScope',
        '$timeout',
        '$state',
        '$window',
        '$q',
        'ngDialog',
        'common',
        'appSettings',
        'ticket.service.programacao.sessaoassento',
        'ticket.service.programacao.reservaassento',
        function ($http, $rootScope, $timeout, $state, $window, $q, ngDialog, common, appSettings, sessaoassentoSvc, reservaassentoSvc) {

            var vm = this;
            var temporizador = {
                Tempo: 0,
                ContagemRegressiva: 0
            }

            var tempo = 600;
            var tempoExtra = 600;
            var tempoResposta = 20;

            var carrinho = {
                IdSessao: null,
                IdLayout: null,
                Setor: {
                    IdSetor: null
                },
                Uri: null,
                LugarTipoIngresso: [],
                Pagamento: {
                    Termos: null
                },
                TotalCompra: 0,
                Ingressos: []
            };

            var controle = {
                SetorEscolhido: false,
                LugarEscolhido: false,
                LugarMarcado: false,
                TipoIngressoEscolhido: false,
                PossuiZona: false,
                PossuiSetor: false,
                HabilitaTextoIngresso: false,
                LimiteIngresso: false,
                LoadingSVG: true,
                LoadingSVGSetor: true,
                ExibirContador: false
            };

            var etiquetas = {
                /*Zona:1,
                 Setor:2,
                 Lugar:3,
                 Pagamento:4*/
            }

            //Inicialização de variaveis
            temporizador.Tempo = tempo;
            //Fim Inicialização de variaveis

            var promiseLimpar = null;

            var srv = {
                getCarrinho: function () {
                    return carrinho;
                }

                , getControle: function () {
                    return controle;
                }

                , getTemporizador: function () {
                    return temporizador;
                }

                , limparSetor: function () {
                    carrinho.Setor.IdSetor = null;
                    carrinho.Setor.NomeSetor = null;
                    controle.SetorEscolhido = false;
                    controle.HabilitaTextoIngresso = false;
                    controle.LugarEscolhido = false;
                }

                , limparLugarTipoIngresso: function () {

                    if(!promiseLimpar){
                        var deferred = $q.defer();

                        promiseLimpar = deferred.promise;

                        reservaassentoSvc.limpar().then(function (res) {
                            deferred.resolve(res);
                            controle.LugarEscolhido = false;
                            controle.HabilitaTextoIngresso = false;
                            carrinho.LugarTipoIngresso = [];
                            promiseLimpar  = null;
                        },function(e){
                            deferred.reject(e);
                            promiseLimpar  = null;
                        });
                    }
                    return promiseLimpar ;
                }

                , limparPagamento: function () {
                    carrinho.Pagamento = {};
                }

                , getEtiquetas: function () {
                    if (controle.PossuiZona && controle.PossuiSetor && controle.LugarMarcado) {
                        etiquetas.Zona = 1;
                        etiquetas.Setor = 2;
                        etiquetas.Lugar = 3;
                        etiquetas.Ingresso = 4;
                        etiquetas.Pagamento = 5
                    }
                    else if (controle.PossuiZona && controle.PossuiSetor && !controle.LugarMarcado) {
                        etiquetas.Zona = 1;
                        etiquetas.Setor = 2;
                        etiquetas.Ingresso = 3;
                        etiquetas.Pagamento = 4
                    }
                    else if (!controle.PossuiZona && controle.PossuiSetor && controle.LugarMarcado) {
                        etiquetas.Setor = 1;
                        etiquetas.Lugar = 2;
                        etiquetas.Ingresso = 3;
                        etiquetas.Pagamento = 4;
                    }
                    else if (!controle.PossuiZona && controle.PossuiSetor && !controle.LugarMarcado) {
                        etiquetas.Setor = 1;
                        etiquetas.Ingresso = 2;
                        etiquetas.Pagamento = 3;
                    }
                    else if (!controle.PossuiZona && !controle.PossuiSetor && controle.LugarMarcado) {
                        etiquetas.Lugar = 1;
                        etiquetas.Ingresso = 2;
                        etiquetas.Pagamento = 3;
                    }
                    else if (!controle.PossuiZona && !controle.PossuiSetor && !controle.LugarMarcado) {
                        etiquetas.Ingresso = 1;
                        etiquetas.Pagamento = 2;
                    }

                    return etiquetas;
                }

                , ligarContadorCompra: function () {

                    //Controle que ativa a exibição do CONTADOR na header da página
                    controle.ExibirContador = true;

                    //CONTADOR
                    if ((temporizador.Tempo - 1) >= 0) {
                        // Pega a parte inteira dos minutos
                        var min = parseInt(temporizador.Tempo / 60);
                        // Calcula os segundos restantes
                        var seg = temporizador.Tempo % 60;

                        // Formata o número menor que dez, ex: 08, 07, ...
                        if (min < 10) {
                            min = "0" + min;
                            min = min.substr(0, 2);
                        }
                        if (seg <= 9) {
                            seg = "0" + seg;
                        }

                        //var horaImprimivel = '00:' + min + ':' + seg;
                        var horaImprimivel = min + ':' + seg;

                        var contagemRegressiva = horaImprimivel;

                        temporizador.timer = $timeout(srv.ligarContadorCompra, 1000);

                        temporizador.Tempo--;

                        temporizador.ContagemRegressiva = contagemRegressiva;
                        //return contagemRegressiva;

                    }
                    else {

                        //Só abro o Dialog de tempo extra caso o usuário não tenha tido um tempo extra.
                        if (!temporizador.TempoExtra) {
                            //SE O TEMPO CHEGAR AO FIM

                            //Volto o contador para o valor padrão
                            temporizador.Tempo = tempo;
                            controle.ExibirContador = false;
                            var timeout;

                            //Abre o Dialog para perguntar ao usuário se ele deseja tempo extra.
                            ngDialog.openConfirm({
                                id: 'dlgTempo',
                                CloseByDocument: true,
                                closeByEscape: false,
                                showClose: false,
                                width: 370,
                                template: 'templates/checkout/dialogs/template-tempo-esgotado.html',
                                className: 'ngdialog-theme-default',
                                controller: ['$scope', '$timeout', 'ngDialog', function ($scope, $timeout, currentDialog) {

                                    //Valores defaults para a diretiva mini-pie, usada para fazer o cantador no Dialog
                                    $scope.item = {
                                        pct: 0,
                                        angle: -90,
                                        gap: 0,
                                        rad: 32,
                                        color: '#F17709',
                                        lineWidth: 33,
                                        hasText: false,
                                        textSize: 30,
                                        cursorColor: '#f2f2f2'
                                    };

                                    var end = tempoResposta;
                                    var counter = 0;

                                    function doIt() {
                                        counter++;
                                        var pct = 0.1;
                                        $scope.item.pct = Math.round(counter / end * 100 * pct);

                                        if ((counter * pct) < end)
                                            timeout = $timeout(doIt, 1000 * pct);
                                        else {
                                            //Se o tempo acabar e o usuário não interagir com os botões
                                            srv._onDlgCose = true;
                                            currentDialog.close();
                                            srv.tempoCompraEsgotado();
                                        }
                                    }

                                    doIt();

                                    $scope.$on('$destroy', function () {
                                        $timeout.cancel(timeout);
                                    });
                                }],
                                preCloseCallback: function (value) {
                                    if (value == '$document') {
                                        return false;
                                    }
                                    return true;
                                }
                            }).then(function (value) {
                                //Usuario quer tempo extra para finalizar a COMPRA
                                srv.tempoExtra();
                            }, function (reason) {
                                //Usuario não quer tempo extra para finalizar a COMPRA
                                if(!srv._onDlgCose){
                                    srv.limparLugarTipoIngresso().then(function () {
                                        var cidade = $window.localStorage.getItem('city');
                                        var uri = carrinho.Uri;
                                        $window.location.href = '/' + cidade + '/teatro/' + uri + '';
                                    });
                                }
                            });

                        }
                        else {
                            //Fim do tempo extra sem finalizar a COMPRA
                            srv.tempoCompraEsgotado();
                        }
                    }
                }
                , desligarContadorCompra: function(){
                    srv.pararContadorCompra();
                    srv.temporizadorInicio();
                }
                , pararContadorCompra: function (reset) {
                    controle.ExibirContador = false;
                    if(reset){
                        $timeout.cancel(temporizador.timer);

                        temporizador.Tempo = tempo;
                    }
                }
                ,
                tempoCompraEsgotado: function (tempoExtraNegado) {

                    srv.pararContadorCompra();

                    srv.temporizadorInicio();
                    srv.pararContadorCompra();
                    srv.limparLugarTipoIngresso().then(retorno, retorno);

                    function retorno(){
                        if (tempoExtraNegado) {
                            controle.LoadingSVG = true;
                            $rootScope.$broadcast('carrinho_expirado');
                            $state.go('checkout.steps.assento');
                            controle.LoadingSVG = false;
                        }
                        else {
                            ngDialog.openConfirm({
                                template: 'templates/checkout/dialogs/template-tempo-esgotado-redirecionamento.html',
                                CloseByDocument: true,
                                closeByEscape: false,
                                showClose: false,
                                width: 370,
                                className: 'ngdialog-theme-default',
                                preCloseCallback: function (value) {
                                    if (value == '$document') {
                                        return false;
                                    }
                                    return true;

                                }
                            }).then(function (value) {
                                var cidade = $window.localStorage.getItem('city');
                                var uri = carrinho.Uri;
                                $window.location.href = '/' + cidade + '/teatro/' + uri + '';

                            });
                        }
                    }

                }
                , temporizadorInicio: function () {
                    controle.ExibirContador = false;
                    temporizador.Tempo = tempo;
                    temporizador.TempoExtra = false;
                }
                , tempoExtra: function () {
                    temporizador.Tempo = tempoExtra;
                    temporizador.TempoExtra = true;
                    srv.ligarContadorCompra();

                    var idSessaoSetor = carrinho.Setor.IdSessaoSetor;
                    var lstAssento = [];

                    carrinho.LugarTipoIngresso.forEach(function (itm) {
                        lstAssento.push(
                            {
                                //IdAssento: itm.IdAssento,
                                IdSessaoAssento: itm.IdSessaoAssento
                                //,IdSessaoSetor: idSessaoSetor
                            }
                        )
                    });

                    //Após o usuario optar por tempo extra, atualiza-se a DataCadastro da tabela "SessaoAssentoOcupacao"
                    sessaoassentoSvc.tempoextra(lstAssento).then(function (data) {
                        // carrinho.LugarTipoIngresso.forEach(function (itm) {
                        //     itm.IdSessaoAssento = data.find(function (a) {
                        //         return a.IdAssento == itm.IdAssento;
                        //     }).IdSessaoAssento;
                        // });
                    });
                }

            }


            return common.service.basic(srv);

        }])
})();

(function() {
  'use strict';

  angular
    .module('ticket.service.operacao', []);
})();

/**
 * Created by thainan.gomes on 28/08/2017.
 */
(function () {
  'use strict';

  angular
    .module('ticket.service.operacao')

    .factory("ticket.service.operacao.vendapagamentofilafraude", ["common", function (common) {
      var res = {
        getValidar : function (key) {
          return this.request('getvalidar', key);
        },

        aprovarreprovar  : function (form) {
          return this.request('aprovarreprovar', form);
        }
      }


      return common.service.instantiate(res, "venda/vendapagamentofilafraude/");
    }]);

})();

(function() {
  'use strict';

  angular
    .module('ticket.service.moderacao', []);
})();
(function() {
  'use strict';

  angular.module('ticket.service.moderacao')

  .factory("ticket.service.moderacao.video", ["common", function(common) {
    var res = {}; //<-- Customize aqui seu service

    return common.service.instantiate(res, "controleconteudo/videomoderacao/");
  }]);

})();
(function() {
  'use strict';

  angular.module('ticket.service.moderacao')

  .factory("ticket.service.moderacao.produtor", ["common", function(common) {
    var res = {

      resumomoderacao: function (key) {
        return this.request("resumomoderacao", key);
      },
    }; //<-- Customize aqui seu service

    return common.service.instantiate(res, "cliente/produtor/");
  }]);

})();

(function() {
  'use strict';

  angular.module('ticket.service.moderacao')

  .factory("ticket.service.moderacao.ingresso", ["common", function(common) {
    var res = {}; //<-- Customize aqui seu service

    return common.service.instantiate(res, "controleingresso/ingressomoderacao/");
  }]);

})();

(function() {
  'use strict';

  angular.module('ticket.service.moderacao')

  .factory("ticket.service.moderacao.banda", ["common", function(common) {
    var res = {}; //<-- Customize aqui seu service

    return common.service.instantiate(res, "controleconteudo/bandamoderacao/");
  }]);

})();
(function() {
  'use strict';

  angular.module('ticket.service.moderacao')

  .factory("ticket.service.moderacao.atracao", ["common", function(common) {
    var res = {}; //<-- Customize aqui seu service

    return common.service.instantiate(res, "controleconteudo/atracaomoderacao/");
  }]);

})();
(function() {
  'use strict';

  angular.module('ticket.service.moderacao')

  .factory("ticket.service.moderacao.artista", ["common", function(common) {
    var res = {}; //<-- Customize aqui seu service

    return common.service.instantiate(res, "controleconteudo/artistamoderacao/");
  }]);

})();
(function() {
    'use strict';

    angular
        .module('ticket.service.local', [ ]);
})();
(function(){
    'use strict';

    angular.module('ticket.service.local')
    
    .factory("ticket.service.local.tipoobjetomapa", ["common", function(common){
        var res = {}; //<-- Customize aqui seu service

        return common.service.instantiate(res, "local/tipoobjetomapa/");
    }]);

})();
(function(){
    'use strict';

    angular.module('ticket.service.local')
    
    .factory("ticket.service.local.tipoassento", ["common", function(common){
        var res = {}; //<-- Customize aqui seu service

        return common.service.instantiate(res, "local/tipoassento/");
    }]);

})();
(function() {
  'use strict';

  angular.module('ticket.service.local')

  .factory("ticket.service.local.setor", ["common", function(common) {
    var res = {
      getSvg: function(filter) {
        return this.request('svg', filter);
      }
    }; //<-- Customize aqui seu service

    return common.service.instantiate(res, "local/setor/");
  }]);

})();
(function(){
    'use strict';

    angular.module('ticket.service.local')
    
    .factory("ticket.service.local.sala", ["common", function(common){
        var res = {
        	
        }; //<-- Customize aqui seu service

        return common.service.instantiate(res, "local/sala/");
    }]);

})();
(function(){
    'use strict';

    angular.module('ticket.service.local')

    .factory("ticket.service.local.pavimento", ["common", function(common){
        var res = { }; //<-- Customize aqui seu service

        return common.service.instantiate(res, "local/zona/");
    }]);

})();

(function(){
    'use strict';

    angular.module('ticket.service.local')

    .factory("ticket.service.local.objetolayoutsetor", ["common", function(common){
        var res = {}; //<-- Customize aqui seu service

        return common.service.instantiate(res, "local/objetolayoutsetor/");
    }]);

})();

(function(){
    'use strict';

    angular.module('ticket.service.local')
    
    .factory("ticket.service.local.objetolayout", ["common", function(common){
        var res = {}; //<-- Customize aqui seu service

        return common.service.instantiate(res, "local/objetolayout/");
    }]);

})();
(function(){
    'use strict';

    angular.module('ticket.service.local')
    
    .factory("ticket.service.local.mapaassento", ["common", function(common){
        var res = {}; //<-- Customize aqui seu service

        return common.service.instantiate(res, "local/mapaassento/");
    }]);

})();
(function(){
    'use strict';

    angular.module('ticket.service.local')
    
    .factory("ticket.service.local.layout", ["common", function(common){
        var res = {

        	

        }; //<-- Customize aqui seu service

        return common.service.instantiate(res, "local/layout/");
    }]);

})();
(function() {
  'use strict';

  angular.module('ticket.service.local')

  .factory("ticket.service.local.assento", ["common", function(common) {
    var res = {}; //<-- Customize aqui seu service

    return common.service.instantiate(res, "local/assento/");
  }]);

})();
(function() {
    'use strict';

    angular
        .module('ticket.service.estabelecimentoingresso', [ ]);
})();

(function(){
    'use strict';

    angular.module('ticket.service.estabelecimentoingresso')

    .factory("ticket.service.ingresso.estabelecimentoingresso", ["common", function (common) {
        var res = {}; //<-- Customize aqui seu service
        return common.service.instantiate(res, "controleingresso/estabelecimentoingresso/");
    }]);

})();

(function() {
  'use strict';

  angular
    .module('ticket.service.fluxocaixa', []);
})();

/**
 * Created by thainan.gomes on 28/08/2017.
 */
(function () {
  'use strict';

  angular
    .module('ticket.service.fluxocaixa')

    .factory("ticket.service.fluxocaixa.caixa", ["common", function (common) {
      var res = {

        caixaSemanal: function (filter) {
          return this.request("caixaSemanal", filter);
        },

        getCaixaSemanal: function (key) {
          return this.request("getCaixaSemanal", key);
        }
      }; //<-- Customize aqui seu service

      return common.service.instantiate(res, "fluxocaixa/caixa/");
    }]);

})();

(function() {
  'use strict';
  angular
    .module('ticket.service.estabelecimento', []);
})();
(function() {
  'use strict';

  angular
    .module('ticket.service.estabelecimento')
    .factory('ticket.service.estabelecimento', ['common', function(common) {
      var res = {}; //<-- Customize aqui seu service
      return common.service.instantiate(res, "controleestabelecimento/estabelecimento/");
    }])
})();
(function() {
  'use strict';

  angular
    .module('ticket.service.empresa', []);
})();
(function() {
  'use strict';

  angular
    .module('ticket.service.empresa')
    .factory('ticket.service.empresa', ['common', function(common) {
      var res = {}; //<-- Customize aqui seu service
      return common.service.instantiate(res, "controleestabelecimento/empresa/");
    }])
})();
(function() {
  'use strict';

  angular
    .module('ticket.service.controleregiao', []);
})();
(function() {
  'use strict';

  angular
    .module('ticket.service.controleregiao')
    .factory("ticket.service.controleregiao.cidade", ["common", function(common) {
    var res = {}; //<-- Customize aqui seu service

    return common.service.instantiate(res, "controleregiao/cidade/");
  }]);

})();

(function() {
  'use strict';

  angular
    .module('ticket.service.controleingresso', []);
})();

(function() {
  'use strict';

  angular
    .module('ticket.service.controleingresso')
    .factory('ticket.service.controleingresso.regraingressoestabelecimento', ['common', function(common) {
      var res = {

	     ListLikeEstabelecimento: function(filter){
       	 return this.request('getallEstabelecimento', filter);
       }
       
      }; //<-- Customize aqui seu service
      return common.service.instantiate(res, "controleingresso/regraingressoestabelecimento/");
    }])
})();
(function() {
  'use strict';

  var mod = angular.module('ticket.service.controleingresso');

  mod.factory("ticket.service.controleingresso.regraingresso", ["common", function(common) {
    var res = {

       ListByEstabelecimento: function(filter){
       	 return this.request('listRegraIngresso', filter);
       }
    }; //<-- Customize aqui seu service

    return common.service.instantiate(res, "controleingresso/regraingresso/");
  }]);

})();
(function() {
  'use strict';

  angular
    .module('ticket.service.controleingresso')
    .factory('ticket.service.controleingresso.estabelecimentoingresso', ['common', function(common) {
      var res = {
        getAllModeracao: function(filter) { return this.request("getallmoderacao", filter); },
        moderar: function(itm) { return this.request("moderar", itm); },
        listarPromocao: function(filter){ return this.request("listarpromocao", filter); }
      }; //<-- Customize aqui seu service

      return common.service.instantiate(res, "controleingresso/estabelecimentoingresso/");
    }])
})();

(function() {
  'use strict';

  angular
    .module('ticket.service.controleformapagamento', []);
})();

/**
 * Created by thainan.gomes on 25/07/2017.
 */
(function() {
  'use strict';

  angular
    .module('ticket.service.controleformapagamento')
    .factory('ticket.service.controleformapagamento.formapagamentoestabelecimento', ['common', function(common) {
      var res = {

      }; //<-- Customize aqui seu service
      return common.service.instantiate(res, "formapagamento/formapagamentoestabelecimento/");
    }])
})();

/**
 * Created by thainan.gomes on 25/07/2017.
 */
(function() {
  'use strict';

  angular
    .module('ticket.service.controleformapagamento')
    .factory('ticket.service.controleformapagamento.formapagamento', ['common', function(common) {
      var res = {

        ListByEstabelecimento: function(filter){
          return this.request('listFormaPagamentoEstabelecimento', filter);
        }

      }; //<-- Customize aqui seu service
      return common.service.instantiate(res, "formapagamento/formapagamento/");
    }])
})();

(function() {
  'use strict';

  angular
    .module('ticket.service.controleestabelecimento', []);
})();
/**
 * Created by thainan.gomes on 11/07/2017.
 */

(function() {
  'use strict';

  var mod = angular.module('ticket.service.controleestabelecimento');

  mod.factory("ticket.service.controleestabelecimento.formatoingresso", ["common", function(common) {
    var res = {}
    ; //<-- Customize aqui seu service

    return common.service.instantiate(res, "controleestabelecimento/formatoingresso/");
  }]);

})();

(function() {
  'use strict';

  var mod = angular.module('ticket.service.controleestabelecimento');

  mod.factory("ticket.service.controleestabelecimento.estabelecimentofilafraude", ["common", function(common) {
    var res = {}

    return common.service.instantiate(res, "controleestabelecimento/estabelecimentofilafraude/");
  }]);

})();

(function(){
	'use strict';

	var mod = angular.module('ticket.service.controleestabelecimento');

	mod.factory("ticket.service.controleestabelecimento.estabelecimentoconfiguracaoestrutura", ["common", function (common) {
		var res = {}; //<-- Customize aqui seu service

		return common.service.instantiate(res, "controleestabelecimento/estabelecimentoconfiguracaoestrutura/");
	}]);

})();

(function() {
  'use strict';

  var mod = angular.module('ticket.service.controleestabelecimento');

  mod.factory("ticket.service.controleestabelecimento.estabelecimentoTipoAtracao", ["common", function(common) {
    var res = {
      listGestao: function(filter) {
        return this.request("listgestao", filter);
      }
    }; //<-- Customize aqui seu service

    return common.service.instantiate(res, "controleestabelecimento/estabelecimentotipoatracao/");
  }]);

})();
(function() {
  'use strict';

  var mod = angular.module('ticket.service.controleestabelecimento');

  mod.factory("ticket.service.controleestabelecimento.estabelecimentoconfiguracaoinformacao", ["common", function(common) {
    var res = {}; //<-- Customize aqui seu service

    return common.service.instantiate(res, "controleestabelecimento/estabelecimentoconfiguracaoinformacao/");
  }]);

})();
(function() {
  'use strict';

  var mod = angular.module('ticket.service.controleestabelecimento');

  mod.factory("ticket.service.controleestabelecimento.estabelecimento", ["common", function(common) {
    var res = {

       ListByRegraIngressoEstabelecimento: function(filter){
       	 return this.request('ListByRegraIngressoEstabelecimento', filter);
       },

       ListLikeNome: function(filter){
         return this.request('listLikeNome', filter);
       },

      listgestao: function(filter){
        return this.request('listgestao', filter);
      }

    }; //<-- Customize aqui seu service

    return common.service.instantiate(res, "controleestabelecimento/estabelecimento/");
  }]);

})();

(function() {
  'use strict';

  var mod = angular.module('ticket.service.controleestabelecimento');

  mod.factory("ticket.service.controleestabelecimento.convenienciasessao", ["common", function(common) {
    var res = {


      regerar: function (key) {
        return this.request('regerar', key);
      }
      }
    ; //<-- Customize aqui seu service

    return common.service.instantiate(res, "controleestabelecimento/convenienciasessao/");
  }]);

})();

(function() {
  'use strict';

  var mod = angular.module('ticket.service.controleestabelecimento');

  mod.factory("ticket.service.controleestabelecimento.convenienciaestabelecimentotiposessao", ["common", function(common) {
    var res = {}
    ; //<-- Customize aqui seu service

    return common.service.instantiate(res, "controleestabelecimento/convenienciaestabelecimentotiposessao/");
  }]);

})();

(function() {
  'use strict';

  var mod = angular.module('ticket.service.controleestabelecimento');

  mod.factory("ticket.service.controleestabelecimento.convenienciaestabelecimentotipoatracao", ["common", function(common) {
    var res = {}
    ; //<-- Customize aqui seu service

    return common.service.instantiate(res, "controleestabelecimento/convenienciaestabelecimentotipoatracao/");
  }]);

})();

(function() {
  'use strict';

  var mod = angular.module('ticket.service.controleestabelecimento');

  mod.factory("ticket.service.controleestabelecimento.convenienciaestabelecimento", ["common", function(common) {
    var res = {

        ListConveniencia: function(filter){
          return this.request('listConveniencia', filter);
        }
      }
    ; //<-- Customize aqui seu service

    return common.service.instantiate(res, "controleestabelecimento/convenienciaestabelecimento/");
  }]);

})();

(function() {
  'use strict';

  var mod = angular.module('ticket.service.controleestabelecimento');

  mod.factory("ticket.service.controleestabelecimento.convenienciaatracao", ["common", function(common) {
    var res = {}
    ; //<-- Customize aqui seu service

    return common.service.instantiate(res, "controleestabelecimento/convenienciaatracao/");
  }]);

})();

/**
 * Created by thainan.gomes on 11/07/2017.
 */

(function() {
  'use strict';

  var mod = angular.module('ticket.service.controleestabelecimento');

  mod.factory("ticket.service.controleestabelecimento.conveniencia", ["common", function(common) {
    var res = {

        PostGenerico: function(item){
          return this.request('postGenerico', item);
        }
      }
    ; //<-- Customize aqui seu service

    return common.service.instantiate(res, "controleestabelecimento/conveniencia/");
  }]);

})();

(function() {
  'use strict';

  angular
    .module('ticket.service.controleacesso', []);
})();
(function() {

  angular.module("ticket.service.controleacesso")
    .factory("ticket.service.controleacesso.usuario", ["common", "appSettings", function(common, appSettings) {
      var res = {
        getProfile: function() {
          return this.request("getprofile");
        },
        /* resetPassword: function(mdl) {
          return this.request("resetpassword", mdl);
        }, */
        resetPasswordV2: function(mdl) {
          return this.request("resetpassword2", Object.assign({}, mdl, { IdSistema: appSettings.appKey }));
        },
        resetPasswordValidate: function(token) {
          return this.request("resetpasswordvalidate", {
            Token: token
          });
        },
        resetPasswordConfirm: function(mdl) {
          return this.request("resetpasswordconfirm", mdl);
        },
        checkRegisteredLogin: function(mdl) {
          return this.request("checkregisteredlogin", mdl, {
            supressError: true
          });
        },
        valida: function (usuario) {
          return this.request("valida", usuario);
        },
      };

      return common.service.instantiate(res, "controleacesso/usuario/");
    }])
})();

/**
 * Created by thainan.gomes on 10/07/2017.
 */


(function() {

  angular.module("ticket.service.controleacesso")
    .factory("ticket.service.controleacesso.sistema", ["common", function(common) {
      var res = {
      };

      return common.service.instantiate(res, "controleacesso/sistema/");
    }])
})();

(function() {

  angular.module("ticket.service.controleacesso")
    .factory("ticket.authentication.signup.service", ["$http", "$mdToast", "API_CONFIG", function($http, $mdToast, API_CONFIG) {

      return {};

    }])



})();
(function() {
  'use strict';

  var mod = angular.module('ticket.service.controleacesso');

  mod.factory("ticket.controleacesso.perfilestabelecimento.service", ["common", function(common) {
    var res = {}; //<-- Customize aqui seu service

    return common.service.instantiate(res, "controleacesso/perfilestabelecimento/");
  }]);

})();
(function() {
  'use strict';

  var mod = angular.module('ticket.service.controleacesso');

  mod.factory("ticket.service.controleacesso.perfil", ["common", function(common) {
    var res = {}; //<-- Customize aqui seu service

    return common.service.instantiate(res, "controleacesso/perfil/");
  }]);

})();
(function() {

  angular.module("ticket.service.controleacesso")
    .factory("ticket.service.controleacesso.login", ["$http", "appSettings", "$rootScope", "$q", function($http, appSettings, $rootScope, $q) {

      var authData = null;



      var svc = {
        CheckProfile: function(arr) {
          if (authData == null)
            return false;
          else
            return arr.indexOf(authData.profile) >= 0;
        },
        Logon: function(mdl) {
          var data = "grant_type=password&username=" + encodeURIComponent(mdl.email) + "&password=" + encodeURIComponent(mdl.password);
          var cfg = {
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded',
              'Authorization': 'Basic ' + btoa(appSettings.appId + ':' + appSettings.appKey)
            },
            xhrFields: {
              withCredentials: true
            }
          };

          return $http.post(appSettings.auth, data, cfg)
            .then(function(v) {
                authData = v.data;
                appSettings.setUserStore(authData);
                $rootScope.$broadcast("app.logon", authData);
                return authData;
              },
              function(e) {
                svc.Logout(true);
                return $q.reject(e);
              });
        },
        Logout: function(silence) {
          appSettings.clearUserStore();
          $rootScope.$broadcast("app.logoff");
        },
        RefreshToken: function(IdEstabelecimento) {
          IdEstabelecimento = IdEstabelecimento || '';
          var d = svc.Restore();

          if (d == null || d.access_token == null)
            return $q.reject("Não autenticado");
          else {
            appSettings.clearUserStore();
            $rootScope.$broadcast("app.logoff");

            return $http({
              method: 'POST',
              url: appSettings.auth,
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
              },
              data: $.param({
                grant_type: 'refresh_token',
                refresh_token: d.refresh_token,
                client_id: appSettings.appId,
                client_secret: appSettings.appKey,
                estab_id: IdEstabelecimento
              })
            }).then(
              function(v) {
                if (v.status == 200) {
                  authData = v.data;
                  appSettings.setUserStore(authData);
                  $rootScope.$broadcast("app.logon", authData);
                  return authData;
                }
              },
              function(err) {
                //svc.Logout(true);
                return $q.reject("Falha na autenticação automática");
              });
          }
        },
        Restore: function() {

          if (!authData)
            authData = appSettings.getUserStore();

          if (authData == null || authData.access_token == null)
            return null;
          else
            return authData;
        }
      };


      return svc;


    }])



})();
(function() {

  angular.module("ticket.service.controleacesso")
    .factory("ticket.service.controleacesso.captcha", ["common", function(common) {


        var res = {
          get: function(key) {
            return this.request("get", key);
          },
          render: function(key) {
            return this.request("render", key);
          }
        }

        return common.service.basic(res, "controleacesso/captcha/");

      }

    ]);
})();
(function() {
  'use strict';

  angular
    .module('ticket.service.configuracao', []);
})();

(function() {

  angular.module("ticket.service.configuracao")
    .factory("ticket.service.configuracao.estabelecimentofilafraude", ["common", function(common) {
      var res = {};

      return common.service.instantiate(res, "controleestabelecimento/estabelecimentofilafraude/");
    }])
})();

(function() {

  angular.module("ticket.service.configuracao")
    .factory("ticket.service.configuracao.cliente", ["common", function(common) {
      var res = {};

      return common.service.instantiate(res, "cliente/cliente/");
    }])
})();

(function() {

  angular.module("ticket.service.configuracao")
    .factory("ticket.service.configuracao.atracaoestabelecimentofilafraude", ["common", function(common) {
      var res = {};

      return common.service.instantiate(res, "controleconteudo/atracaoestabelecimentofilafraude/");
    }])
})();

(function() {
  'use strict';

  angular
    .module('ticket.service.cliente', []);
})();

/**
 * Created by thainan.gomes on 25/07/2017.
 */
(function() {
  'use strict';

  angular
    .module('ticket.service.cliente')
    .factory('ticket.service.cliente.clientedadoscadastrais', ['common', function(common) {
      var res = {
      }; //<-- Customize aqui seu service
      return common.service.instantiate(res, "cliente/dadoscadastrais/");
    }])
})();

(function() {
  'use strict';

  angular
    .module('ticket.helper.fields', []);
})();
(function() {
  'use strict';

  angular.module('ticket.helper.fields')

  .factory("ticket.helper.fields.fieldhelper", [function() {

    //Enum
    var obterStatus = function(reg) {
      var status = '';

      switch (reg) {
        case 1:
          status = 'Ativo';
          break;
        case 2:
          status = 'Inativo';
          break;
        case 3:
          status = 'Todos';
          break;
        default:
          status = 'Cancelado';
          break;
      }

      return status;
    };


    var gerarUri = function(nome) {

      if (nome === undefined) return;

      var othersPattern = /([^a-zA-Z0-9\ç\-]+)/g;
      var spacePattern = /\s/g;
      var cPattern = /\ç/g;
      var aPattern = /[áàâã]/g;
      var ePattern = /[éèê]/g;
      var iPattern = /[ííî]/g;
      var oPattern = /[õóò]/g;


      var nomeUri = nome;

      nomeUri = nomeUri.replace(spacePattern, "-");
      nomeUri = nomeUri.replace(cPattern, "c");
      nomeUri = nomeUri.replace(aPattern, "a");
      nomeUri = nomeUri.replace(ePattern, "e");
      nomeUri = nomeUri.replace(iPattern, "i");
      nomeUri = nomeUri.replace(oPattern, "o");
      nomeUri = nomeUri.replace(othersPattern, "");

      return nomeUri.toLowerCase();
    };

    var sexo = {
      0: {
        Id: 'M',
        Nome: 'Masculino'
      },
      1: {
        Id: 'F',
        Nome: 'Feminino'
      }
    };

    return {
      sexoList: sexo,
      gerarUri: gerarUri,
      obterStatus: obterStatus
    };

  }]);

})();
(function() {
  'use strict';

  angular
    .module('ticket.helper.controleregiao', []);
})();
(function() {
  'use strict';

  angular.module('ticket.helper.controleregiao')

  .factory("ticket.helper.controleregiao.uf", [function() {

    var ufList = {
      0: {
        Id: 'AC',
        Nome: 'Acre'
      },
      1: {
        Id: 'AL',
        Nome: 'Alagoas'
      },
      2: {
        Id: 'AP',
        Nome: 'Amapá'
      },
      3: {
        Id: 'AM',
        Nome: 'Amazonas'
      },
      4: {
        Id: 'AM',
        Nome: 'Amazonas'
      },
      5: {
        Id: 'BA',
        Nome: 'Bahia'
      },
      6: {
        Id: 'CE',
        Nome: 'Ceará'
      },
      7: {
        Id: 'DF',
        Nome: 'Distrito Federal'
      },
      8: {
        Id: 'ES',
        Nome: 'Espírito Santo'
      },
      9: {
        Id: 'CE',
        Nome: 'Ceará'
      },
      10: {
        Id: 'GO',
        Nome: 'Goiás'
      },
      11: {
        Id: 'MA',
        Nome: 'Maranhão'
      },
      12: {
        Id: 'MT',
        Nome: 'Mato Grosso'
      },
      13: {
        Id: 'MS',
        Nome: 'Mato Grosso do Sul'
      },
      14: {
        Id: 'MG',
        Nome: 'Minas Gerais'
      },
      15: {
        Id: 'PA',
        Nome: 'Pará'
      },
      16: {
        Id: 'PB',
        Nome: 'Paraíba'
      },
      17: {
        Id: 'PR',
        Nome: 'Paraná'
      },
      18: {
        Id: 'PE',
        Nome: 'Pernambuco'
      },
      19: {
        Id: 'PI',
        Nome: 'Piauí'
      },
      20: {
        Id: 'RJ',
        Nome: 'Rio de Janeiro'
      },
      21: {
        Id: 'RN',
        Nome: 'Rio Grande do Norte'
      },
      22: {
        Id: 'RS',
        Nome: 'Rio Grande do Sul'
      },
      23: {
        Id: 'RO',
        Nome: 'Rondônia'
      },
      24: {
        Id: 'RR',
        Nome: 'Roraima'
      },

      25: {
        Id: 'SC',
        Nome: 'Santa Catarina'
      },

      26: {
        Id: 'SP',
        Nome: 'São Paulo'
      },
      27: {
        Id: 'SE',
        Nome: 'Sergipe'
      },
      28: {
        Id: 'TO',
        Nome: 'Tocantins'
      }

    };


    return {
      ufList: ufList
    };

  }]);

})();
(function() {
  'use strict';
  angular.module('ticket.filter', []);
})();
(function() {
  'use strict';

  angular.module('ticket.filter')

  .filter("obterStatus", function() {

    return function(input) {
      //Enum
      var status = '';

      switch (input) {
        case 1:
          status = 'Ativo';
          break;
        case 2:
          status = 'Inativo';
          break;
        case 3:
          status = 'Todos';
          break;
        default:
          status = 'Cancelado';
          break;
      }

      return status;
    };
  });

})();
(function() {
  'use strict';

  angular
    .module('ticket.controller.configuracao')
    .config(moduleConfig);

  /* @ngInject */
  function moduleConfig($stateProvider, menuProvider) {

    $stateProvider

      .state('configuracao', {
        abstract: true,
        url: '/configuracao',
        templateUrl: "view/site/_content.html"
      })

      .state('configuracao.cidade', {
        abstract: true,
        url: '/cidade',
        templateUrl: "view/configuracao/cidade/index.html"
      })
      .state('configuracao.cidade.grid', {
        url: '/consulta',
        parent: 'configuracao.cidade',
        data: {
          displayName: 'Cidades'
        },
        templateUrl: 'view/configuracao/cidade/grid.html',
        controller: 'ticket.controller.configuracao.cidade.grid',
        controllerAs: 'vm'
      })

      .state('configuracao.cidade.form', {
        url: '/form/:Id',
        params: {
          Id: null
        },
        parent: 'configuracao.cidade',
        data: {
          displayName: 'Adicionar Cidade'
        },
        templateUrl: 'view/configuracao/cidade/form.html',
        controller: 'ticket.controller.configuracao.cidade.form',
        controllerAs: 'vm'
      })
      .state('configuracao.filafraude', {
        abstract: true,
        url: '/filafraude',
        parent: 'configuracao',
        templateUrl: "view/configuracao/filafraude/index.html"
      })
      .state('configuracao.filafraude.grid', {
        url: '/consulta',
        parent: 'configuracao.filafraude',
        data: {
          displayName: 'Fila Fraudes'
        },
        templateUrl: 'view/configuracao/filafraude/grid.html',
        controller: 'ticket.controller.configuracao.filafraude.grid',
        controllerAs: 'vm'
      })

      .state('configuracao.filafraude.form', {
        url: '/form/',
        params: {

        },
        parent: 'configuracao.filafraude',
        data: {
          displayName: 'Adicionar Fila Fraude'
        },
        templateUrl: 'view/configuracao/filafraude/form.html',
        controller: 'ticket.controller.configuracao.filafraude.form',
        controllerAs: 'vm'
      });
    //
    // $stateProvider
    //   .state('configuracao', {
    //     abstract: true,
    //     url: '/configuracao',
    //     templateUrl: "view/site/_content.html"
    //   })

    menuProvider.left.add({
      name: 'Configuração',
      icon: 'fa fa-home',
      type: 'link',
      priority: 1.0,
      state: 'configuracao',
      childs: [
        {
          second:true,
          name: 'Cidade',
          icon: 'fa fa-home',
          type: 'link',
          priority: 1.0,
          state: 'configuracao.cidade.grid'
        },
        {
          second:true,
          name: 'Fila Fraude',
          icon: 'fa fa-home',
          type: 'link',
          priority: 1.0,
          state: 'configuracao.filafraude.grid'
        }
      ]
    });

    menuProvider.left.add({
      type: 'divider',
      priority: 1.1
    });
  }
})();

(function() {
  'use strict';

  angular.module('ticket.filter')

  .filter("obterRegistro", function() {

    return function(input) {
      //Enum
      var registro = '';

      switch (input) {
        case 1:
          registro = 'Novo';
          break;
        case 2:
          registro = 'Atualizar';
          break;
        default:
          registro = 'Todos';
          break;
      }

      return registro;
    };
  });

})();
(function() {
  'use strict';

  angular.module('ticket.filter')

  .filter('defaultDate', function($filter) {
    var angularDateFilter = $filter('date');
    return function(date) {
      return angularDateFilter(date, 'dd/MM/yyyy HH:mm');
    };
  });

})();
(function() {
  'use strict';

  angular
    .module('ticket.controller.site')
    .config(moduleConfig);

  /* @ngInject */
  function moduleConfig($stateProvider, menuProvider) {

    $stateProvider
      .state('site', {
        abstract: true,
        url: '/site',
        templateUrl: "view/site/_content.html"
      })
      .state('site.home', {
        url: '/home',
        data: {
          displayName: 'Home'
        },
        templateUrl: 'view/site/home/index.html',
        controller: 'ticket.controller.site.home',
        controllerAs: 'vm'
      })
      .state('site.user-home', {
        templateUrl: 'view/site/home/index.html',
        controller: function($state) {
          $state.go('site.home')
        },
        controllerAs: 'vm'
      })



    menuProvider.left.add({
      type: 'divider',
      priority: 1.1
    });
  }
})();
(function () {
  'use strict';

  angular
    .module('ticket.controller.reports')
    .config(moduleConfig);

  /* @ngInject */
  function moduleConfig($stateProvider, menuProvider) {

    $stateProvider

    $stateProvider
      .state('reports', {
        abstract: true,
        url: '/reports',
        templateUrl: "view/site/_content.html"
      })
      .state('reports.previa', {
        data: {
          displayName: 'Borderô Provisório'
        },
        abstract: true,
        parent: 'reports',
        url: '/previa',
        templateUrl: 'view/reports/previa/index.html',
        controller: 'ticket.controller.reports.previa',
        controllerAs: 'vm'
      })
      .state('reports.previa.grid', {
        templateUrl: 'view/reports/previa/grid.html',
        url: '/:filter',
        parent: 'reports.previa',
        data: {
          displayName: 'Borderô Provisório'
        },
        params: {
          items: null,
          filter: null
        },
        controller: 'ticket.controller.reports.previa.grid',
        controllerAs: 'vm'
      })
      .state('reports.previa.form', {
        templateUrl: 'view/reports/previa/form.html',
        url: '/form/:IdSessao',
        parent: 'reports.previa',
        data: {
          displayName: 'Borderô Provisório'
        },
        params: {
          IdSessao: null
        },
        controller: 'ticket.controller.reports.previa.form',
        controllerAs: 'vm'
      })


      .state('reports.bordero', {
        data: {
          displayName: 'Borderô'
        },
        abstract: true,
        parent: 'reports',
        url: '/bordero',
        templateUrl: 'view/reports/bordero/index.html',
        controller: 'ticket.controller.reports.bordero',
        controllerAs: 'vm'
      })
      .state('reports.bordero.grid', {
        templateUrl: 'view/reports/bordero/grid.html',
        url: '/:filter',
        parent: 'reports.bordero',
        data: {
          displayName: 'Borderô Definitivo'
        },
        params: {
          items: null,
          filter: null
        },
        controller: 'ticket.controller.reports.bordero.grid',
        controllerAs: 'vm'
      })
      .state('reports.bordero.form', {
        templateUrl: 'view/reports/bordero/form.html',
        url: '/form/:IdSessao',
        parent: 'reports.bordero',
        data: {
          displayName: 'Borderô Definitivo'
        },
        params: {
          IdSessao: null,
          Uri:null
        },
        controller: 'ticket.controller.reports.bordero.form',
        controllerAs: 'vm'
      })
      .state('reports.financeiro', {
        data: {
          displayName: 'Financeiro'
        },
        abstract: true,
        parent: 'reports',
        url: '/financeiro',
        templateUrl: 'view/reports/financeiro/index.html',
        controller: 'ticket.controller.reports.financeiro',
        controllerAs: 'vm'
      })
      .state('reports.financeiro.grid', {
        templateUrl: 'view/reports/financeiro/grid.html',
        url: '/:filter',
        parent: 'reports.financeiro',
        data: {
          displayName: 'Financeiro'
        },
        params: {
          items: null,
          filter: null
        },
        controller: 'ticket.controller.reports.financeiro.grid',
        controllerAs: 'vm'
      })
      .state('reports.financeiro.form', {
        templateUrl: 'view/reports/financeiro/form.html',
        url: '/form/',
        parent: 'reports.financeiro',
        data: {
          displayName: 'Financeiro'
        },
        params: {
          IdSessao: null,
          Uri:null
        },
        controller: 'ticket.controller.reports.financeiro.form',
        controllerAs: 'vm'
      })

      .state('reports.futuras', {
        data: {
          displayName: 'Futuras'
        },
        abstract: true,
        parent: 'reports',
        url: '/futuras',
        templateUrl: 'view/reports/futuras/index.html',
        controller: 'ticket.controller.reports.futuras',
        controllerAs: 'vm'
      })
      // .state('reports.futuras.grid', {
      //   templateUrl: 'view/reports/futuras/grid.html',
      //   url: '/:filter',
      //   parent: 'reports.futuras',
      //   data: {
      //     displayName: 'Futuras'
      //   },
      //   params: {
      //     items: null,
      //     filter: null
      //   },
      //   controller: 'ticket.controller.reports.futuras.grid',
      //   controllerAs: 'vm'
      // })
      .state('reports.futuras.form', {
        templateUrl: 'view/reports/futuras/form.html',
        url: '/form/',
        parent: 'reports.futuras',
        data: {
          displayName: 'Futuras'
        },
        params: {
          IdSessao: null,
          Uri:null
        },
        controller: 'ticket.controller.reports.futuras.form',
        controllerAs: 'vm'
      })

      .state('reports.futuras-dia', {
        data: {
          displayName: 'Futuras'
        },
        abstract: true,
        parent: 'reports',
        url: '/futuras-dia',
        templateUrl: 'view/reports/futuras-dia/index.html',
        controller: 'ticket.controller.reports.futuras-dia',
        controllerAs: 'vm'
      })
      .state('reports.futuras-dia.grid', {
        templateUrl: 'view/reports/futuras-dia/grid.html',
        url: '/:filter',
        parent: 'reports.futuras-dia',
        data: {
          displayName: 'Futuras'
        },
        params: {
          items: null,
          filter: null
        },
        controller: 'ticket.controller.reports.futuras-dia.grid',
        controllerAs: 'vm'
      })
      .state('reports.futuras-dia.form', {
        templateUrl: 'view/reports/futuras-dia/form.html',
        url: '/form/',
        parent: 'reports.futuras-dia',
        data: {
          displayName: 'Futuras'
        },
        params: {
          IdSessao: null,
          Uri:null
        },
        controller: 'ticket.controller.reports.futuras-dia.form',
        controllerAs: 'vm'
      })
    ;

    menuProvider.left.add({
      name: 'Relatórios',
      icon: 'fa fa-clipboard',
      type: 'group',
      state: 'reports',
      priority: 1.0,
      childs: [
        {
          second:true,
          name: 'Borderô Provisório',
          state: 'reports.previa.grid'
        },
        {
          second:true,
          name: 'Borderô Definitivo',
          state: 'reports.bordero.grid'
        },
        {
          second:true,
          name: 'Financeiro',
          state: 'reports.financeiro.grid'
        },
        // {
        //   name: 'Futuras por Período',
        //   state: 'reports.futuras.grid'
        // },
        {
          second:true,
          name: 'Futuras',
          state: 'reports.futuras-dia.grid'
        }
      ]
    });
    menuProvider.left.add({
      type: 'divider',
      priority: 1.1
    });
  }
})();

(function() {
  'use strict';

  angular
    .module('ticket.controller.promocao', [ ]);
})();
(function() {
  'use strict';

  angular.module('ticket.controller.promocao')
    .controller('ticket.controller.promocao.grid', ['$rootScope','common', 'ticket.service.promocao','ticket.service.conteudo.atracao', 'ticket.service.estabelecimento', function($rootScope, common, svcPromocao, svcAtracao, svcEstabelecimento){

    	var vm = common.controller.grid(this, svcPromocao);

    	svcEstabelecimento.list({}).then(function(estabelecimentos){ vm.estabelecimentos = estabelecimentos; });

        $rootScope.$on('queried', function(){
            // vm.Current = (new Date()).toJSON();

          vm.Current = moment(moment((new Date()).toJSON()).format('YYYY-MM-DD HH:mm:ss')).format()
        });

    	vm.TrocarEstabelecimento = function(){
    		vm.Filter.IdAtracao = null;

    		if(vm.Filter.IdEstabelecimento)
    			svcAtracao.list({IdEstabelecimento: vm.Filter.IdEstabelecimento}).then(function(atracoes){
                    vm.atracoes = atracoes;
                });
    		else
    			vm.atracoes = null;
    	}

        vm.Liberar = function(){
            var ls = vm.items.filter(function(itm){ return itm.checked && itm.Status != 1 });
            if( ls.length > 0  )
            {

                var expiradas = ls.filter(function(itm){ return itm.DataTermino && itm.DataTermino <= new Date(); })

                if( expiradas.length>0 )
                {
                    vm.utils.ShowWarning('Liberação de promoções', 'Promoções expiradas devem ter sua data de término redefinida para serem reativadas. Desmarque-as para continuar');
                }
                else
                {
                    vm.utils.Confirm('LIBERAR PROMOÇÕES', 'Deseja liberar as promoções selecionadas?').then(function(){
                        svcPromocao.toggle(ls).then(function(){
                            for(var i=0; i< ls.length; i++ )
                            {   ls[i].Status = 1; }

                             vm.utils.ShowSuccess('Liberação de promoções', 'Promoções liberadas com sucesso.');
                        });
                    });
                }
            }
            else
            {
                vm.utils.ShowWarning('Liberação de promoções', 'Selecione pelo menos uma promoção inativa que deva ser liberada.');
            }
        }

        vm.Suspender = function(){
            var ls = vm.items.filter(function(itm){ return itm.checked && itm.Status == 1});
            if( ls.length > 0  )
            {
                vm.utils.Confirm('SUSPENDER PROMOÇÕES', 'Deseja suspender as promoções selecionadas?').then(function(){
                    svcPromocao.toggle(ls).then(function(){
                        for(var i=0; i< ls.length; i++ )
                        {   ls[i].Status = 2; }

                        vm.utils.ShowSuccess('Suspensão de promoções', 'Promoções suspensas com sucesso.');
                    });
                });
            }
            else
            {
                vm.utils.ShowWarning('Suspensão de promoções', 'Selecione pelo menos uma promoção ativa que deva ser suspensa.');
            }
        }

        vm.MarcarTodos = function()
        {
            vm.items.forEach(function(itm){
                itm.checked = vm.chkTodos;
            });
        }


    }]);
})();

(function() {
  'use strict';
  angular.module('ticket.controller.promocao').controller('ticket.controller.promocao.form', [
                                                  '$q',
                                                  '$filter',
                                                  '$uibModal',
  																							  'common',
  																							  'ticket.service.promocao',
  																							  'ticket.service.conteudo.atracao',
  																							  'ticket.service.estabelecimento',
  																							  'ticket.service.programacao',
  																							  'ticket.service.local.layout',
  																							  'ticket.service.local.objetolayout',
  																							  'ticket.service.local.tipoassento',
  																							  'ticket.service.programacao.setor',
  																							  'ticket.service.local.assento',
  																							  'ticket.service.programacao.sessaosetor',
  																							  'ticket.service.programacao.sessaoassento',
  																							  'ticket.service.controleingresso.estabelecimentoingresso',
                                                  'ticket.service.sessaoassentopromocao',
  																							  'orderByFilter',
                                                  'mapaassento',
																				  function(
                                                 $q,
                                                 $filter,
                                                 $uibModal,
																				  		   common,
																				  		   svcPromocao,
																				  		   svcAtracao,
																				  		   svcEstabelecimento,
																				  		   svcProgramacao,
																				  		   svcLayout,
																				  		   svcObjetolayout,
																				  		   svcTipoAssento,
																				  		   svcSetor,
																				  		   svcAssento,
																				  		   svcSessaoSetor,
																				  		   svcSessaoassento,
																				  		   svcEstabelecimentoingresso,
                                                 svcAssentopromocao,
																				  		   orderByFilter,
                                                 mapaassento){

      var IsLoading = false;
      var vm = common.controller.form(this, svcPromocao, function(v){
        IsLoading = v;
      });

      vm.loaded = function(){
        vm.IsEdit = true;
        $q.all([
            svcEstabelecimentoingresso.listarPromocao({Id: vm.item.IdEstabelecimento}).then(function(ingressos){ vm.ingressos = ingressos;}),
            svcAtracao.list({IdEstabelecimento: vm.item.IdEstabelecimento}).then(function(atracoes){ vm.atracoes = atracoes;  }),
            svcProgramacao.listProximos({IdEstabelecimento: vm.item.IdEstabelecimento, IdAtracao : vm.item.IdAtracao }).then(function(sessoes){
              vm.sessoes = sessoes.map(function(v){ return { Id: v.IdSessao, IdLayout: v.IdLayout, Nome: $filter('date')(v.DataHoraInicio, "dd-MM-yyyy HH:mm") + ' - ' + v.NomeSala   }; });
            })
          ]).then(function(){
            IsLoading = false;
            vm.TrocarSessao();

            var fmt = function(v){
              var s = "0" + String(v);
              return s.substr(s.length-2);
            }
            if(vm.item.DataTermino)
            {
              var d = new Date(vm.item.DataTermino);
              vm.item.HoraTermino = fmt(d.getHours()) + ":" + fmt(d.getMinutes()) ;

              vm.item.Data = d;
            }
          });
      }


      vm.tiposAssento = [];
      svcTipoAssento.list({}).then(function(tipos){ vm.tiposAssento = tipos; });

      svcEstabelecimento.list({}).then(function(estabelecimentos){ vm.estabelecimentos = estabelecimentos; });

      vm.TrocarEstabelecimento = function(){
        if(!IsLoading)
        {
    		  vm.item.IdAtracao = null;


      		if(vm.item.IdEstabelecimento)
      		{
      			svcEstabelecimentoingresso.listarPromocao({Id: vm.item.IdEstabelecimento}).then(function(ingressos){ vm.ingressos = ingressos;})
      			svcAtracao.list({IdEstabelecimento: vm.item.IdEstabelecimento}).then(function(atracoes){ vm.atracoes = atracoes;  });

      		}
      		else
      		{
      			vm.ingressos = null;
      			vm.atracoes = null;
      		}
        }
    	}

    	vm.TrocarAtracao = function(){
        if(!IsLoading)
        {
    		  vm.item.IdSessao = null;

      		if(vm.item.IdEstabelecimento && vm.item.IdAtracao)
      		{
      			svcProgramacao.listProximos({IdEstabelecimento: vm.item.IdEstabelecimento, IdAtracao : vm.item.IdAtracao }).then(function(sessoes){
      				vm.sessoes = sessoes.map(function(v){ return { Id: v.IdSessao, IdLayout: v.IdLayout, Nome: $filter('date')(v.DataHoraInicio, "dd-MM-yyyy HH:mm") + ' - ' + v.NomeSala   }; });
      			});
      		}
      		else
      		{
      			vm.sessoes = null;
      		}
    		}
    	}


		vm.TrocarIngresso = function(){
      if(!IsLoading)
      {
  			if(vm.item.IdEstabelecimentoIngresso != null)
  			{
  				var ls = vm.ingressos.filter(function(v){ return vm.item.IdEstabelecimentoIngresso == v.Id });
  				if(ls.length == 1 )
  				{
  					vm.item.Valor = ls[0].ValorRegra;
  				}
  				else
  				{
  					vm.item.Valor = 0;
  				}
  			}
      }
		}

    	vm.TrocarSessao = function(){
        if(!IsLoading)
        {
          if(vm.item.IdSessao)
          {
            vm.assentos = [];
            vm.selecionados = [];

            var itms = vm.sessoes.filter(function(v){ return v.Id == vm.item.IdSessao });
            svcSessaoSetor.list({ IdSessao: vm.item.IdSessao }).then(function(setores){vm.sessoessetores = setores;});
            if(itms.length>0)
            {
              svcSetor.list({ Idlayout: itms[0].IdLayout }).then(function(setores){
                  vm.setores = setores;

                  var promisesSetor = [];
                  var promisesSessaoAssento = [];
                  setores.forEach(function(s){
                    promisesSetor.push(svcAssento.list({IdMapa: s.IdMapa}));
                  });

                  $q.all(promisesSetor).then(function(results){
                      results.forEach(function(itms, idx){
                        vm.assentos = vm.assentos.concat(itms);

                        var ss = vm.sessoessetores.find( function(v){ return v.IdSetor == setores[idx].Id } )
                        promisesSessaoAssento.push(svcSessaoassento.listall({Id: ss.IdSessaoSetor}));
                      });

                      $q.all(promisesSessaoAssento).then(function (assentos_setor) {

                          var assentos = [];
                          assentos_setor.forEach(function(a_s){
                            assentos = assentos.concat(a_s);
                          })

                          vm.AssentosMapa = orderByFilter(assentos, 'Rotulo');

                          if (assentos.length > 0) {
                            for (var i = 0; i < assentos.length; i++) {
                              var ass = assentos[i];

                              if (ass.IdTipoAssentoOcupacao >= 1)
                              {
                                mapaassento.block('mapa1', ass.IdAssento, '#CFCFCF')
                              }
                              else
                              {
                                var assento = vm.assentos.find(function(a){ return a.IdAssento == ass.IdAssento; });
                                assento.IdSessaoSetor = ass.IdSessaoSetor;
                              }
                            }
                          }

                          if(vm.item && vm.item.Selecionados)
                          {
                            vm.item.Selecionados.forEach(function(s){
                              mapaassento.select('mapa1', s.IdAssento);
                            });
                          }

                        }).finally(function () {
                          vm.loadingSvg = false;
                        });




                });


              });

              svcObjetolayout.list({IdLayout: itms[0].IdLayout}).then(function(objetos){ vm.objetos = objetos; });
              svcLayout.get({Id: itms[0].IdLayout}).then(function(layout){ vm.layout = layout; });
            }
          }
        }

      }


      var _save = vm.save;
      vm.save = function()
      {
          if(vm.selecionados.length == 0)
            vm.utils.ShowWarning("Seleção de assentos", "Selecione pelo menos um assento que fará parte da promoção");
          else
          {
            vm.item.Selecionados = [];
            vm.selecionados.forEach(function(s){


              //console.log('s', s);

              vm.item.Selecionados.push(s);
            });

            vm.item.Data = moment(moment(vm.item.Data).format('YYYY-MM-DD')).format();

            var nd = new Date();
            var t = nd.getTimezoneOffset();
            vm.item.TimeZone = t * -1;

            _save();
          }
      }

    	// vm.AlterarTermino = function()
    	// {
        // if(!IsLoading)
        // {
      	// 	if(vm.item.Termino)
      	// 	{
  	  //   		var h = (vm.item.HoraTermino) ? vm.item.HoraTermino.split(':') : ['0','0'];
  	  //   		vm.item.DataTermino = new Date(vm.item.Termino.getFullYear(), vm.item.Termino.getMonth(), vm.item.Termino.getDate(), Number.parseInt(h[0]), Number.parseInt(h[1]));
  	  //   	}
        // }
    	// }


      vm.Copiar = function(){
        $uibModal.open({
        animation: true,
        modalFade: false,
          templateUrl: 'view/promocao/copiar.html',
          controller: 'ticket.controller.promocao.copiar',
          controllerAs: 'vm',
          size: 'lg',
          resolve: {
            Filter: function() {
              return {IdSessao: vm.item.IdSessao};
            }
          }
        })
        .result.then(function(item) {

            svcAssentopromocao.list({IdPromocao: item.IdPromocao}).then(function(assentos){
              assentos.forEach(function(s){
                if(!vm.selecionados.find(function(sel){ return sel.IdAssento == s.IdAssento } ))
                  mapaassento.select('mapa1', s.IdAssento);
              });
            })

          },
          function(e) {
            console.log(e);
          });
      }

  }]);
})();

(function() {
  'use strict';
  angular.module('ticket.controller.promocao').controller('ticket.controller.promocao.copiar', [
                                                  'common', 
  																							  'ticket.service.promocao',
                                                  '$uibModalInstance',
                                                  'Filter',
																				  function(
                                                 common, 
																				  		   svcPromocao,
                                                 $uibModalInstance,
                                                 Filter){
      
      
      var vm = common.controller.basic(this);


      
      vm.Filter = {IdSessao: Filter.IdSessao};
      vm.searching = false;
      vm.complete = false;
      vm.items = [];
      var pageSize = 20;
      vm.isPost = true;
      vm.initial = true;
      
      vm.yes = function() {
        $uibModalInstance.close(vm.selecionado);
      };

      vm.no = function() {
        $uibModalInstance.dismiss('cancel');
      };

      vm.search = function (inScroll) {

        if (vm.searching) return;

        vm.searching = true;

        if (!inScroll || vm.isPost) {
          vm.isPost = false;
          vm.page = 0;
          vm.complete = false;
          vm.items = [];
        }
        svcPromocao.listsemelhante({
          Config: {
            Skip: vm.page,
            Top: pageSize
          },
          Filter: vm.Filter
        })
          .then(function (v) {

            vm.items = vm.items.concat(v);

            if (v.length < pageSize)
              vm.complete = true;

            if (v.length > 0) {
              vm.page += 1;
            }

          })
          .finally(function () {
            vm.searching = false;
            vm.initial = false;
          });
      };

      vm.search();

  }]);
})();
(function() {
  'use strict';

  angular
    .module('ticket.controller.promocao')
    .config(moduleConfig);

  /* @ngInject */
  function moduleConfig($stateProvider, menuProvider) {

    $stateProvider

    $stateProvider
      .state('promocao', {
        abstract: true,
        url: '/promocao',
        templateUrl: "view/site/_content.html"
      })

      .state('promocao.promocao', {
        data: { displayName: 'Promoção'},
        abstract: true,
        parent: 'promocao',
        url: '/promocao',
        templateUrl: 'view/promocao/index.html'
      })

      .state('promocao.promocao.grid', {
        url: '/:filter',
        parent: 'promocao.promocao',
        data: { displayName: 'Promoção' },
        templateUrl: 'view/promocao/grid.html',
        controller: 'ticket.controller.promocao.grid',
        controllerAs: 'vm'
      })

    .state('promocao.promocao.form', {
      url: '/form/:IdPromocao',
      params: { IdPromocao: null },
      parent: 'promocao.promocao',
      data: { displayName: 'Promoção' },
      templateUrl: 'view/promocao/form.html',
      controller: 'ticket.controller.promocao.form',
      controllerAs: 'vm'
    })

      .state('promocao.promocao.associar', {
        data: { displayName: 'Associar promoção' },
        url: '/form-relatorio/',
        params: { Uri: null },
        parent: 'promocao.promocao',
        templateUrl: 'view/promocao/associar.html',
        controller: 'ticket.controller.promocao.associar',
        controllerAs: 'vm'
      })


    menuProvider.left.add({
      name: 'Promoção',
      icon: 'fa fa-home',
      type: 'link',
      priority: 1.0,
      state: 'promocao',
      childs: [{
        second:true,
        name: 'Consultar',
        icon: 'fa fa-home',
        type: 'link',
        priority: 1.0,
        state: 'promocao.promocao.grid'
      }]
    });

    menuProvider.left.add({
      type: 'divider',
      priority: 1.1
    });
  }
})();

(function() {
  'use strict';

  angular
    .module('ticket.controller.operacao')
    .config(moduleConfig);

  /* @ngInject */
  function moduleConfig($stateProvider, menuProvider) {
    $stateProvider
      .state('operacao', {
        abstract: true,
        url: '/operacao',
        templateUrl: "view/site/_content.html"
      })

      .state('operacao.caixa', {
        data: {
          displayName: 'Caixa'
        },
        abstract: true,
        parent: 'operacao',
        url: '/caixa',
        templateUrl: 'view/operacao/caixa/index.html',
        controller: 'ticket.controller.operacao.caixa',
        controllerAs: 'vm'
      })

      .state('operacao.caixa.grid', {
        data: {
          displayName: 'Caixas'
        },
        parent: 'operacao',
        url: '/caixa/consulta',
        templateUrl: 'view/operacao/caixa/grid.html',
        controller: 'ticket.controller.operacao.caixa.grid',
        controllerAs: 'vm'
      })

      .state('operacao.caixa.form', {
        data: {
          displayName: 'Detalhe Caixa'
        },
        parent: 'operacao',
        url: '/caixa/form/:Id',
        params: {
          Id: null
        },
        templateUrl: 'view/operacao/caixa/form.html',
        controller: 'ticket.controller.operacao.caixa.form',
        controllerAs: 'vm'
      })

      .state('operacao.vendasite', {
        data: {
          displayName: 'Venda Site'
        },
        abstract: true,
        parent: 'operacao',
        url: '/vendasite',
        templateUrl: 'view/operacao/venda/vendasite/index.html',
        controller: 'ticket.controller.operacao.vendasite',
        controllerAs: 'vm'
      })

      .state('operacao.vendasite.grid', {
        data: {
          displayName: 'Venda Site'
        },
        parent: 'operacao',
        url: '/vendasite/ultimas-vendas',
        params: {
          Filter: null
        },
        templateUrl: 'view/operacao/venda/vendasite/grid.html',
        controller: 'ticket.controller.operacao.vendasite.grid',
        controllerAs: 'vm'
      })

      .state('operacao.vendasite.form', {
        data: {
          displayName: 'Detalhe Venda Site'
        },
        parent: 'operacao',
        url: '/vendasite/detalhe/:Id',
        params: {
          Id: null,
          Filter: null
        },
        templateUrl: 'view/operacao/venda/vendasite/form.html',
        controller: 'ticket.controller.operacao.vendasite.form',
        controllerAs: 'vm'
      })

    .state('operacao.cancelamento', {
        data: {
          displayName: 'Cancelamento'
        },
        abstract: true,
        parent: 'operacao',
        url: '/cancelamento',
        templateUrl: 'view/operacao/venda/pesquisar-venda/cancelamento/index.html',
        controller: 'ticket.controller.operacao.cancelamento',
        controllerAs: 'vm'
      })


      .state('operacao.cancelamento.form', {
        data: {
          displayName: 'Cancelamento'
        },
        url: '/:CodRastreio',
        params: {
          CodRastreio: null
        },
        parent: 'operacao.cancelamento',
        templateUrl: 'view/operacao/venda/pesquisar-venda/cancelamento/form.html',
        controller: 'ticket.controller.operacao.cancelamento.form',
        controllerAs: 'vm'
      })


      .state('operacao.troca', {
        data: {
          displayName: 'Venda'
        },
        abstract: true,
        parent: 'programacao',
        url: '/troca',
        templateUrl: 'view/operacao/venda/pesquisar-venda/troca/index.html',
        controller: 'ticket.controller.operacao.troca',
        controllerAs: 'vm'
      })


      .state('operacao.troca.form', {
        data: {
          displayName: 'Troca'
        },
        url: '/:CodRastreio',
        params: {
          CodRastreio: null
        },
        parent: 'operacao.troca',
        templateUrl: 'view/operacao/venda/pesquisar-venda/troca/form.html',
        controller: 'ticket.controller.operacao.troca.form',
        controllerAs: 'vm'
      })

      .state('operacao.venda', {
        data: {
          displayName: 'Venda'
        },
        abstract: true,
        parent: 'operacao',
        url: '/venda',
        templateUrl: 'view/operacao/venda/pesquisar-venda/index.html',
        controller: 'ticket.controller.operacao.venda',
        controllerAs: 'vm'
      })

      .state('operacao.venda.grid', {
        templateUrl: 'view/operacao/venda/pesquisar-venda/grid.html',
        url: '/consulta',
        parent: 'operacao.venda',
        data: {
          displayName: 'Pesquisa Venda'
        },
        params: {
          items: null,
          Filter: null
        },
        controller: 'ticket.controller.operacao.venda.grid',
        controllerAs: 'vm'
      })

      .state('operacao.venda.form', {
        data: {
          displayName: 'Detalhe da venda'
        },
        url: '/detalhe/:CodRastreio',
        params: {
          CodRastreio: null,
          Filter : null
        },
        parent: 'operacao.venda',
        templateUrl: 'view/operacao/venda/pesquisar-venda/form.html',
        controller: 'ticket.controller.operacao.venda.form',
        controllerAs: 'vm'
      })

      .state('operacao.vendapagamentofilafraude', {
        data: {
          displayName: 'Venda Fila Fraude'
        },
        abstract: true,
        parent: 'operacao',
        url: '/vendapagamentofilafraude',
        templateUrl: 'view/operacao/venda/vendapagamentofilafraude/index.html',
        controller: 'ticket.controller.operacao.vendapagamentofilafraude',
        controllerAs: 'vm'
      })

      .state('operacao.vendapagamentofilafraude.grid', {
        data: {
          displayName: 'Vendas Fila Fraude'
        },
        parent: 'operacao',
        params: {
          items: null,
          Filter: null
        },
        url: '/fila-fraude/consulta',
        templateUrl: 'view/operacao/venda/vendapagamentofilafraude/grid.html',
        controller: 'ticket.controller.operacao.vendapagamentofilafraude.grid',
        controllerAs: 'vm'
      })

      .state('operacao.vendapagamentofilafraude.form', {
        data: {
          displayName: 'Validar Venda'
        },
        parent: 'operacao',
        url: '/vendapagamentofilafraude/form/:IdVendaPagamento',
        params: {
          IdVendaPagamento: null
        },
        templateUrl: 'view/operacao/venda/vendapagamentofilafraude/form.html',
        controller: 'ticket.controller.operacao.vendapagamentofilafraude.form',
        controllerAs: 'vm'
      })
      .state('operacao.usuario', {
        abstract: true,
        url: '/usuario',
        parent: 'operacao',
        templateUrl: "view/operacao/usuario/index.html"
      })
      .state('operacao.usuario.grid', {
        url: '/consulta',
        parent: 'operacao.usuario',
        data: {
          displayName: 'Usuários'
        },
        templateUrl: 'view/operacao/usuario/grid.html',
        controller: 'ticket.controller.operacao.usuario.grid',
        controllerAs: 'vm'
      })

      .state('operacao.usuario.form', {
        url: '/form/:IdCliente',
        params: {
          IdCliente: null
        },
        parent: 'operacao.usuario',
        data: {
          displayName: 'Detalhes do Cliente'
        },
        templateUrl: 'view/operacao/usuario/form.html',
        controller: 'ticket.controller.operacao.usuario.form',
        controllerAs: 'vm'
      });

    menuProvider.left.add({
      name: 'Operação',
      icon: 'fa fa-music',
      type: 'link',
      priority: 1.0,
      state: 'operacao',
      childs: [{
        second:true,
        name: 'Caixas',
        icon: 'fa fa-music',
        type: 'link',
        priority: 1.0,
        state: 'operacao.caixa.grid'
      },
      {
        second:true,
        name: 'Últimas Vendas',
        icon: 'fa fa-music',
        type: 'link',
        priority: 1.0,
        state: 'operacao.vendasite.grid'
      },
        {
          second:true,
          name: 'Pesquisar Vendas',
          icon: 'fa fa-building',
          type: 'link',
          priority: 1.0,
          state: 'operacao.venda.grid'
        },{
          second:true,
          name: 'Últimos Cadastros',
          icon: 'fa fa-home',
          type: 'link',
          priority: 1.0,
          state: 'operacao.usuario.grid'
        }
        ,{
          second:true,
          name: 'Validar Vendas',
          icon: 'fa fa-home',
          type: 'link',
          priority: 1.0,
          state: 'operacao.vendapagamentofilafraude.grid'
        }]
    });

    menuProvider.left.add({
      type: 'divider',
      priority: 1.1
    });
  }
})();

(function() {
  'use strict';

  angular
    .module('ticket.controller.moderacao')
    .config(moduleConfig);

  /* @ngInject */
  function moduleConfig($stateProvider, menuProvider) {

    $stateProvider

    //moderacao.atracao
      .state('moderacao', {
        abstract: true,
        url: '/moderacao',
        templateUrl: "view/site/_content.html"
      })
      .state('moderacao.atracao', {
        url: '/atracao',
        data: {
          displayName: 'Moderação de Atração'
        },
        templateUrl: 'view/moderacao/atracao/index.html',
        controller: 'ticket.controller.moderacao.atracao',
        controllerAs: 'vm'
      })

    .state('moderacao.atracao.grid', {
      url: '/:filter',
      parent: 'moderacao.atracao',
      data: {
        displayName: 'Moderação de Atração'
      },
      templateUrl: 'view/moderacao/atracao/grid.html',
      controller: 'ticket.controller.moderacao.atracao.grid',
      controllerAs: 'vm'
    })

    .state('moderacao.atracao.form', {
      data: {
        displayName: 'Detalhes da Atração'
      },
      url: '/form/:Id',
      params: {
        Id: null
      },
      parent: 'moderacao.atracao',
      templateUrl: 'view/moderacao/atracao/form.html',
      controller: 'ticket.controller.moderacao.atracao.form',
      controllerAs: 'vm'
    })

    //moderacao.video
    .state('moderacao.video', {
      data: {
        displayName: 'Moderação de Vídeo da Atração'
      },
      abstract: true,
      parent: 'moderacao',
      url: '/video',
      templateUrl: 'view/moderacao/video/index.html',
      controller: 'ticket.controller.moderacao.video',
      controllerAs: 'vm'
    })

    .state('moderacao.video.grid', {
      url: '/:filter',
      parent: 'moderacao.video',
      data: {
        displayName: 'Tratamento de Vídeo da Atração'
      },
      params: {
        items: null,
        filter: null
      },
      templateUrl: 'view/moderacao/video/grid.html',
      controller: 'ticket.controller.moderacao.video.grid',
      controllerAs: 'vm'
    })

    .state('moderacao.video.form', {
      data: {
        displayName: 'Tratamento de Vídeo da Atração'
      },
      url: '/form/:IdAtracaoArquivo',
      params: {
        IdAtracaoArquivo: null
      },
      parent: 'moderacao.video',
      templateUrl: 'view/moderacao/video/form.html',
      controller: 'ticket.controller.moderacao.video.form',
      controllerAs: 'vm'
    })

    //moderacao.artista
    .state('moderacao.artista', {
      data: {
        displayName: 'Moderação de Artista'
      },
      abstract: true,
      parent: 'moderacao',
      url: '/artista',
      templateUrl: 'view/moderacao/artista/index.html',
      controller: 'ticket.controller.moderacao.artista',
      controllerAs: 'vm'
    })

    .state('moderacao.artista.grid', {
      url: '/:filter',
      parent: 'moderacao.artista',
      data: {
        displayName: 'Moderação de Artista'
      },
      templateUrl: 'view/moderacao/artista/grid.html',
      controller: 'ticket.controller.moderacao.artista.grid',
      controllerAs: 'vm'
    })

    .state('moderacao.artista.form', {
      data: {
        displayName: 'Moderação de Artista > Detalhes'
      },
      url: '/form/:Id',
      params: {
        Id: null
      },
      parent: 'moderacao.artista',
      templateUrl: 'view/moderacao/artista/form.html',
      controller: 'ticket.controller.moderacao.artista.form',
      controllerAs: 'vm'
    })


    //moderacao.banda
    .state('moderacao.banda', {
      data: {
        displayName: 'Moderação de Banda'
      },
      abstract: true,
      parent: 'moderacao',
      url: '/banda',
      templateUrl: 'view/moderacao/banda/index.html',
      controller: 'ticket.controller.moderacao.banda',
      controllerAs: 'vm'
    })

    .state('moderacao.banda.grid', {
      url: '/:filter',
      parent: 'moderacao.banda',
      data: {
        displayName: 'Moderação de Banda'
      },
      params: {
        items: null,
        filter: null
      },
      templateUrl: 'view/moderacao/banda/grid.html',
      controller: 'ticket.controller.moderacao.banda.grid',
      controllerAs: 'vm'
    })

    .state('moderacao.banda.form', {
      data: {
        displayName: 'Moderação de Banda > Detalhes'
      },
      url: '/form/:Id/:NumeroVersao',
      params: {
        Id: null,
        NumeroVersao:null
      },
      parent: 'moderacao.banda',
      templateUrl: 'view/moderacao/banda/form.html',
      controller: 'ticket.controller.moderacao.banda.form',
      controllerAs: 'vm'
    })

    //moderacao.ingresso
      .state('moderacao.ingresso', {
        url: '/ingresso',
        data: {
          displayName: 'Moderação de Ingresso'
        },
        templateUrl: 'view/moderacao/ingresso/index.html',
        controller: 'ticket.controller.moderacao.ingresso',
        controllerAs: 'vm'
      })

      .state('moderacao.ingresso.grid', {
        url: '/:filter',
        parent: 'moderacao.ingresso',
        data: {
          displayName: 'Moderação de Ingresso'
        },
        templateUrl: 'view/moderacao/ingresso/grid.html',
        controller: 'ticket.controller.moderacao.ingresso.grid',
        controllerAs: 'vm'
      })

      .state('moderacao.ingresso.form', {
        data: {
          displayName: 'Detalhes do Ingresso'
        },
        url: '/form/:Id',
        params: {
          Id: null
        },
        parent: 'moderacao.ingresso',
        templateUrl: 'view/moderacao/ingresso/form.html',
        controller: 'ticket.controller.moderacao.ingresso.form',
        controllerAs: 'vm'
      })

      //MODERACAO PRODUTOR
      .state('moderacao.produtor', {
        url: '/produtor',
        data: {
          displayName: 'Moderação de Ingresso'
        },
        templateUrl: 'view/moderacao/ingresso/index.html',
        controller: 'ticket.controller.moderacao.ingresso',
        controllerAs: 'vm'
      })

      .state('moderacao.produtor.grid', {
        url: '/:filter',
        parent: 'moderacao.produtor',
        data: {
          displayName: 'Moderação de Produtor'
        },
        templateUrl: 'view/moderacao/produtor/grid.html',
        controller: 'ticket.controller.moderacao.produtor.grid',
        controllerAs: 'vm'
      })

      .state('moderacao.produtor.form', {
        data: {
          displayName: 'Detalhes do Produtor'
        },
        url: '/form/:IdUsuario',
        params: {
          IdUsuario: null
        },
        parent: 'moderacao.produtor',
        templateUrl: 'view/moderacao/produtor/form.html',
        controller: 'ticket.controller.moderacao.produtor.form',
        controllerAs: 'vm'
      })


    menuProvider.left.add({
      name: 'Moderação',
      icon: 'fa fa-cog',
      type: 'link',
      priority: 1.0,
      state: 'moderacao',

      childs: [{
        second:true,
        name: 'Moderação de Atração',
        icon: 'fa fa-home',
        type: 'link',
        priority: 1.0,
        state: 'moderacao.atracao.grid'

      }, {
        second:true,
        name: 'Moderação de Vídeo',
        icon: 'fa fa-home',
        type: 'link',
        priority: 1.0,
        state: 'moderacao.video.grid'

      }, {
        second:true,
        name: 'Moderação de Artista',
        icon: 'fa fa-home',
        type: 'link',
        priority: 1.0,
        state: 'moderacao.artista.grid'

      }, {
        second:true,
        name: 'Moderação de Banda',
        icon: 'fa fa-home',
        type: 'link',
        priority: 1.0,
        state: 'moderacao.banda.grid'

      },
        {
          second:true,
          name: 'Moderação de Ingresso',
          icon: 'fa fa-home',
          type: 'link',
          priority: 1.0,
          state: 'moderacao.ingresso.grid'

        },
        {
          second:true,
          name: 'Moderação de Produtor',
          icon: 'fa fa-home',
          type: 'link',
          priority: 1.0,
          state: 'moderacao.produtor.grid'

        }

      ]
    });

    menuProvider.left.add({
      type: 'divider',
      priority: 1.1
    });
  }
})();

(function() {
  'use strict';

  angular
    .module('ticket.controller.financeiro')
    .config(moduleConfig);

  /* @ngInject */
  function moduleConfig($stateProvider, menuProvider) {

    $stateProvider

    $stateProvider
      .state('financeiro', {
        abstract: true,
        url: '/financeiro',
        templateUrl: "view/site/_content.html"
      })

      .state('financeiro.repasse', {
        data: {
          displayName: 'Repasse'
        },
        abstract: true,
        parent: 'financeiro',
        url: '/repasse',
        templateUrl: 'view/financeiro/repasse/index.html',
        controller: 'ticket.controller.financeiro.repasse',
        controllerAs: 'vm'
      })

      .state('financeiro.repasse.grid', {
        url: '/:filter',
        parent: 'financeiro.repasse',
        data: {
          displayName: 'Repasse'
        },
        templateUrl: 'view/financeiro/repasse/grid.html',
        controller: 'ticket.controller.financeiro.repasse.grid',
        controllerAs: 'vm'
      })

    .state('financeiro.repasse.form', {
      url: '/form/:Id',
      params: {
        Id: null
      },
      parent: 'financeiro.repasse',
      data: {
        displayName: 'Repasse'
      },
      templateUrl: 'view/financeiro/repasse/form.html',
      controller: 'ticket.controller.financeiro.repasse.form',
      controllerAs: 'vm'
    })

      .state('financeiro.repasse.form-relatorio', {
        data: {
          displayName: 'Resumo Repasse'
        },
        url: '/form-relatorio/',
        params: {
          Uri: null
        },
        parent: 'financeiro.repasse',
        templateUrl: 'view/financeiro/repasse/form-relatorio.html',
        controller: 'ticket.controller.financeiro.repasse.form-relatorio',
        controllerAs: 'vm'
      })


    menuProvider.left.add({
      name: 'Financeiro',
      icon: 'fa fa-home',
      type: 'link',
      priority: 1.0,
      state: 'financeiro',
      childs: [{
        second:true,
        name: 'Repasse',
        icon: 'fa fa-home',
        type: 'link',
        priority: 1.0,
        state: 'financeiro.repasse.grid'
      }]
    });

    menuProvider.left.add({
      type: 'divider',
      priority: 1.1
    });
  }
})();

(function() {
  'use strict';

  angular.module('ticket.controller.estabelecimento')
    .controller('ticket.controller.estabelecimento.popupmapa', estabelecimentoPopUpMapaController);

  estabelecimentoPopUpMapaController.$inject = ['$q', 'common', '$scope', '$uibModalInstance', 'uiGmapGoogleMapApi', 'latitude', 'longitude', 'ticket.service.estabelecimento'];

  function estabelecimentoPopUpMapaController($q, common, $scope, $uibModalInstance, uiGmapGoogleMapApi, latitude, longitude, estabelecimentoSrv) {
    var vm = common.controller.grid(this, estabelecimentoSrv);


    $scope.map = {
      center: {
        latitude: (latitude === undefined || latitude === null) ? -22.887235 : latitude,
        longitude: (longitude === undefined || longitude === null) ? -43.282357 : longitude
      },
      zoom: 13,
      markers: [{
        id: 1,
        latitude: (latitude === undefined || latitude === null) ? -22.887235 : latitude,
        longitude: (longitude === undefined || longitude === null) ? -43.282357 : longitude,
        showWindow: false,
        options: {

          draggable: true
        }
      }]
    };

    var onMarkerClicked = function(marker) {
      marker.showWindow = true;
      $scope.$apply();
      //window.alert("Marker: lat: " + marker.latitude + ", lon: " + marker.longitude + " clicked!!")
    };


    $scope.onMarkerClicked = onMarkerClicked;

    $scope.map.markersEvents = {
      dragend: function(marker, eventName, model, args) {
        //model.options.labelContent = "Dragged lat: " + model.latitude + " lon: " + model.longitude;
      }
    };

    vm.confirm = function(lst) {
      $uibModalInstance.close(lst);
    };

    vm.cancel = function() {
      //fix do issue #863 do angular-google-maps
      $uibModalInstance.dismiss('close');
      $scope.closeModal = true;

    };

    $scope.setarLocalizacao = function(address) {
      if ((typeof address !== "undefined" && address !== null)) {
        obterLocalizacao(address).then(function(data) {
          $scope.map.center.latitude = data.lat();
          $scope.map.center.longitude = data.lng();
          $scope.map.markers[0].latitude = data.lat();
          $scope.map.markers[0].longitude = data.lng();
        });
      }
    };



    /**
     * Obtem localização
     * Lat e Long
     * @param endereco
     * @returns objeto com as coordenadas
     */
    function obterLocalizacao(endereco) {
      var deferred = $q.defer();

      uiGmapGoogleMapApi.then(function(maps) {
        var geocoder = new google.maps.Geocoder();
        geocoder.geocode({
          'address': endereco
        }, function(result, status) {
          if (status == google.maps.GeocoderStatus.OK) {
            deferred.resolve(result[0].geometry.location);
          }
        });
      });
      return deferred.promise;
    }
  }
})();
(function() {
    'use strict';
    angular
        .module('ticket.controller.estabelecimento')
        .controller('ticket.controller.estabelecimento.mapa', ["$stateParams", "common", "$uibModal", "ticket.service.local.layout","ticket.service.local.objetolayout", "ticket.service.local.setor", "ticket.service.local.assento", "ticket.service.local.mapaassento", "ticket.service.local.tipoassento", "ticket.service.local.sala", function($stateParams, common, $uibModal, layoutSvc, objetolayoutSvc, setorSvc, assentoSvc, mapaassentoSvc, tipoassentoSvc, salaSvc){
            var vm = common.controller.basic(this);
            var pk = angular.fromJson($stateParams); //ID DO LAYOUT
            vm.label = 'Rotulo';


            function init(_pk)
            {
                vm.svg = { x: 0, y: 0, w : 0, h: 0 };
                vm.x = 0;
                vm.y = 0;
                vm.width = 0;
                vm.height = 0;



                vm.layout={};
                vm.salas = [];
                //vm.zonas = [];//TODO: Aguardando implementação
                vm.objetos = [];
                vm.setores = [];
                vm.assentos = [];
                vm.tiposAssento = [];
                vm.selecionados = [];

                tipoassentoSvc.list({}).then(function(tipos){ vm.tiposAssento = tipos; });
                salaSvc.list({IdEstabelecimento: _pk.IdEstabelecimento}).then(function(res){
                    vm.salas = res;
                });

                if(_pk.IdLayout)
                {
                  var sts = [];

                    setorSvc.list({ Idlayout: _pk.IdLayout, IdEstabelecimento: _pk.IdEstabelecimento }).then(function(setores){
                      vm.setores = setores;

                      setores.forEach(function (t) {
                        sts.push({Id : t.Id})
                      })

                      objetolayoutSvc.list({IdLayout: _pk.IdLayout, IdSetor : sts}).then(function(objetos)
                      {
                        vm.objetos = objetos;
                      });



                        setores.forEach(function(s){
                          assentoSvc.list({IdMapa: s.IdMapa}).then(function(assentos){ vm.assentos = vm.assentos.concat(assentos); });
                        });


                    });

                    layoutSvc.get({Id: _pk.IdLayout}).then(function(layout){
                        vm.item = layout;
                    });
                }
                else
                {
                    vm.item = {IdSala : pk.IdSala, IdEstabelecimento: pk.IdEstabelecimento};
                }

            }

            init(pk);

            vm.selAssento = function(ta){ vm.assento = ta; }


            var newId=-1;
            vm.editSetor = function(setor){
                if(!setor)
                {
                  setor = { Id: newId--, IdMapa: newId, Nome: 'Novo Setor', ArquivoSvg:'', PosicaoLayoutX: 0, PosicaoLayoutY:0 };
                  vm.setores.push(setor);
                }

                var svgBKP = setor.ArquivoSvg;
                var xBkp   = setor.PosicaoLayoutX;
                var yBkp   = setor.PosicaoLayoutY;
                var corBkp = setor.CorPrincipal;

                $uibModal.open({
                animation: false,
                template: '<div class="modal-header">' +
                          '   <h3 class="modal-title">Edição de setor</h3>' +
                          '</div>' +
                          '<form>'+
                          '<div class="modal-body">' +
                          '<div class="row">'+
                          ' <div class="col-md-2">'+
                          '   <ng-field name="posX" label="X" model="vm.setor.PosicaoLayoutX" ></ng-field>' +
                          ' </div>' +
                          ' <div class="col-md-2">'+
                          '   <ng-field name="posY" label="Y" model="vm.setor.PosicaoLayoutY" ></ng-field>' +
                          ' </div>' +
                          ' <div class="col-md-6">'+
                          '   <ng-field name="Nome" label="Nome" model="vm.setor.Nome" ></ng-field>' +
                          ' </div>' +

                          ' <div class="col-md-2">'+
                          '   <div class="form-group">' +
                          '     <label for="color-input" >Cor</label>' +
                          '     <input minicolors="vm.customSettings" id="color-input"  class="form-control" type="text" ng-model="vm.setor.CorPrincipal" >' +
                          '   </div>' +
                          ' </div>' +

                          '</div>'  +
                          '<textarea rows="10" style="width:100%" ng-model="vm.setor.ArquivoSvg" />' +
                          '</div>'  +
                          '</form>'+
                          '<div class="modal-footer">' +
                          '   <button class="btn btn-warning" ng-click="vm.cancel();">Cancelar</button><button class="btn btn-primary" ng-click="vm.ok();">Confirmar</button>' +
                          '</div>',
                  controller: ["$uibModalInstance", "setor",function($uibModalInstance, s) {
                    var vm = this;
                    vm.setor = s;

                    vm.customSettings= {
                      control: 'brightness',
                      theme: 'bootstrap',
                      position: 'bottom left'
                    };

                    vm.ok       = function() { $uibModalInstance.close(true); }
                    vm.cancel   = function() { $uibModalInstance.close(false); }

                  }],
                  controllerAs: 'vm',
                  resolve: {
                    setor: function() { return setor; }
                  },
                  size: 'lg'
                })
                .result.then(function(v){
                    if( !v )
                    {
                        setor.ArquivoSvg = svgBKP;
                        setor.PosicaoLayoutX = xBkp;
                        setor.PosicaoLayoutY = yBkp;
                        setor.CorPrincipal   = corBkp;

                        if(setor.Id == newId)
                          vm.setores.splice(vm.setores.indexOf(setor));
                    }
                    else
                    {
                        setor.changed = true;
                    }
                },function(){
                    setor.ArquivoSvg = svgBKP;
                    setor.PosicaoLayoutX = xBkp;
                    setor.PosicaoLayoutY = yBkp;
                    setor.CorPrincipal   = corBkp;
                    if(setor.Id == newId)
                      vm.setores.splice(vm.setores.indexOf(setor));
                })
              }


              vm.editObjeto = function(objeto){
                if(!objeto)
                {
                  objeto = { Id: newId--, Rotulo: 'Novo Objeto', ArquivoSvg:'', PosicaoLayoutX: 0, PosicaoLayoutY:0 };
                  vm.objetos.push(objeto);
                }

                var svgBKP = objeto.ArquivoSvg;
                var xBkp   = objeto.PosicaoLayoutX;
                var yBkp   = objeto.PosicaoLayoutY;
                var corBkp = objeto.CorPrincipal;

                $uibModal.open({
                animation: false,
                template: '<div class="modal-header">' +
                          '   <h3 class="modal-title">Edição de objeto de layout</h3>' +
                          '</div>' +
                          '<form>'+
                          '<div class="modal-body">' +
                          '<div class="row">'+

                          '<div class="col-md-3" ng-if="vm.loadingSetores">' +
                            '<div class="row">'+
                              '<div>'+
                              '<i class="fa fa-spinner fa-pulse fa-1x fa-fw"></i></i> Carregando Setores...</div>' +
                            '</div>' +
                          '</div>'+

                          '<div class="col-md-3" ng-if="!vm.loadingSetores" style="max-height: 260px;overflow-y: auto">'+

                                '<div class="m-t-xs">'+
                                  '<input icheck type="checkbox" ng-model="vm.objeto.NoLayout" style="text-align: right"><strong class="m-l-sm">&nbsp;NO LAYOUT</strong>'+
                                '</div>'+



                              '<div class="m-t-xs" ng-repeat="setor in vm.sts">'+
                                '<input icheck type="checkbox" ng-model="setor.Selected"  style="text-align: right"><strong class="m-l-sm">&nbsp;{{setor.Nome}}</strong>'+
                                // '<input icheck type="checkbox" ng-model="vm.Id" ng-change="vm.onChenged(setor)"  style="text-align: right"><strong class="m-l-sm">&nbsp;{{setor.Nome}}</strong>'+
                              '</div>'+

                              // '<pre>{{vm.setores | json}}</pre>'+

                          '</div>'+

                          '<div class="col-md-9">'+
                              ' <div class="col-md-2">'+
                              '   <ng-field name="posX" label="X" model="vm.objeto.PosicaoLayoutX" ></ng-field>' +
                              ' </div>' +
                              ' <div class="col-md-2">'+
                              '   <ng-field name="posY" label="Y" model="vm.objeto.PosicaoLayoutY" ></ng-field>' +
                              ' </div>' +
                              ' <div class="col-md-6">'+
                              '   <ng-field name="Rotulo" label="Rótulo" model="vm.objeto.Rotulo" ></ng-field>' +
                              ' </div>' +

                              ' <div class="col-md-2">'+
                              '   <div class="form-group">' +
                              '     <label for="color-input" >Cor</label>' +
                              '     <input minicolors="vm.customSettings" id="color-input"  class="form-control" type="text" ng-model="vm.objeto.CorPrincipal" >' +
                              '   </div>' +
                              ' </div>' +

                              '<textarea rows="10" style="width:100%" ng-model="vm.objeto.ArquivoSvg" />' +
                          '</div>'+
                          '</div>'  +

                          '<div class="alert alert-warning alert-dismissible m-t-xs" role="alert" ng-if="!vm.podeSalvar">'+
                          '<strong>Vincule o objeto ao Layout ou a um dos setores.</strong>'+
                          '</div>'+

                          '</div>'  +
                          '</form>'+
                          '<div class="modal-footer">' +
                          '   <button class="btn btn-warning" ng-click="vm.cancel();">Cancelar</button><button class="btn btn-primary" ng-click="vm.ok();">Confirmar</button>' +
                          '</div>',
                  controller: [
                    "$uibModalInstance",
                    "objeto",
                    "setores",
                    "ticket.service.local.objetolayoutsetor",
                    "ticket.service.local.objetolayout",
                    function($uibModalInstance, obj, setores, objetolayoutsetorSvc, objetolayout) {
                    var vm = this;
                    vm.objeto = obj;
                    vm.podeSalvar = true;

                    vm.objeto.ObjetoLayoutSetores = [];
                    vm.sts = [];

                    vm.sts = setores;

                    vm.customSettings= {
                      control: 'brightness',
                      theme: 'bootstrap',
                      position: 'bottom left'
                    };

                      if(obj.Id >0) {
                      vm.loadingSetores = true;

                        objetolayout.get({Id : obj.Id}).then(function (objetoLayout) {

                          if(objetoLayout.IdLayout)
                            vm.objeto.NoLayout = true;

                        })

                        objetolayoutsetorSvc.list({IdObjetoLayout: obj.Id}).then(function (objetolayoutsetor) {
                          vm.sts.forEach(function (set) {
                            set.Selected = false;
                          });

                          vm.sts.forEach(function (set) {
                            objetolayoutsetor.forEach(function (_set) {
                              if(set.Id == _set.IdSetor)
                                  set.Selected = true;
                            })

                          })

                          vm.loadingSetores = false;
                        })
                      }

                    // vm.sts.forEach(function (set) {
                    //   if(set.PossuiLayout)
                    //     set.Selected = true;
                    // })

                    vm.ok = function() {

                      var count = vm.sts.filter(function (t) {
                        return t.Selected == true;
                      }).length

                      if(!vm.objeto.NoLayout && count ==0) {
                        vm.podeSalvar = false;
                        return;
                      }
                      else {
                        vm.podeSalvar = true;
                      }

                      vm.sts.forEach(function (set) {
                        if(set.Selected)
                          vm.objeto.ObjetoLayoutSetores.push({IdSetor : set.Id});
                      })

                      $uibModalInstance.close(true,vm.objeto.setorComLayout);
                    }
                    vm.cancel   = function() { $uibModalInstance.close(false); }

                  }],
                  controllerAs: 'vm',
                  resolve: {
                    objeto: function() { return objeto; },
                    setores: function() { return vm.setores}
                  },
                  size: 'lg'
                })
                .result.then(function(v){



                    if( !v )
                    {
                        objeto.ArquivoSvg = svgBKP;
                        objeto.PosicaoLayoutX = xBkp;
                        objeto.PosicaoLayoutY = yBkp;
                        objeto.CorPrincipal   = corBkp;

                        if(objeto.Id == newId)
                          vm.objetos.splice(vm.objetos.indexOf(objeto));
                    }
                    else
                    {
                        objeto.changed = true;
                        objeto.Status  = 1;
                    }
                },function(){
                    objeto.ArquivoSvg = svgBKP;
                    objeto.PosicaoLayoutX = xBkp;
                    objeto.PosicaoLayoutY = yBkp;
                    objeto.CorPrincipal   = corBkp;
                    if(objeto.Id == newId)
                      vm.objetos.splice(vm.objetos.indexOf(objeto));
                })
              }



            vm.save = function(){

                var qtd = vm.validate();
                if(qtd>0)
                {
                  vm.utils.ShowWarning("Layout do mapa", "Existem " + qtd + " assentos sem um setor definido.");
                  return;
                }

                var itm = {
                    Id:                   vm.item.Id,
                    IdSala:               vm.item.IdSala,
                    Comprimento:          vm.item.Comprimento,
                    Largura:              vm.item.Largura,
                    Nome:                 vm.item.Nome,
                    Status:               vm.item.Status,
                    PalcoAutomatico:      vm.item.PalcoAutomatico,
                    Assentos:             vm.assentos.filter(function(a){ return a.changed; }),
                    Setores:              vm.setores.filter(function(s){ return s.changed; }),
                    Objetos:              vm.objetos.filter(function(o){ return o.changed; }),
                    //ObjetoLayoutSetores:  vm.objetos[0].setorComLayout
                };

                vm.loading = true;

                //return;

                if( vm.item.Id <= 0 )
                    layoutSvc.post(itm)
                    .then(function(v){
                        vm.utils.ShowSuccess("Inclusão de registro", "Operação realizada com sucesso!");
                        init({ IdLayout: v.Id });
                    })
                    .finally(function(){
                        vm.loading = false;
                    });
                else
                    layoutSvc.put(itm)
                    .then(function(v){
                        vm.utils.ShowSuccess("Alteração de registro", "Operação realizada com sucesso!");
                        init(pk);
                    })
                    .finally(function(){
                        vm.loading = false;
                    });;


            }

        }]);
})();

(function() {
    'use strict';

    angular
        .module('ticket.controller.estabelecimento')

        .controller('ticket.controller.estabelecimento.layouts', ["$stateParams", "$state", "common", "ticket.service.local.sala", "ticket.service.local.layout", function($stateParams, $state, common, salaSvc, layoutSvc){
            var vm = common.controller.grid(this, layoutSvc);
            var fk = angular.fromJson($stateParams); 
            
            vm.Filter = vm.Filter || {};
            vm.Filter.IdSala = 0;
            vm.Filter.IdEstabelecimento = fk.IdEstabelecimento;

            salaSvc.list({IdEstabelecimento: fk.IdEstabelecimento}).then(function(res){
        		vm.salas = res;
            });

            vm.mapa = function(item) {
		      $state.go('estabelecimento.mapa', { IdLayout: item.Id, IdEstabelecimento: fk.IdEstabelecimento });
		    };

            vm.add = function() {
              $state.go('estabelecimento.mapa', { IdEstabelecimento: fk.IdEstabelecimento });
            };


        }])

})();

(function() {
  'use strict';

  angular.module('ticket.controller.estabelecimento')
    .controller('ticket.controller.estabelecimento.grid', estabelecimentoGridController);
  estabelecimentoGridController.$inject = ['$state', 'common', 'ticket.service.estabelecimento']

  function estabelecimentoGridController($state, common, estabelecimentoSrv) {
    var vm = common.controller.grid(this, estabelecimentoSrv);

    vm.add = function() {
      $state.go('estabelecimento.form');
    };

      vm.layout = function(item) {
        $state.go('estabelecimento.layouts', { IdEstabelecimento: item.Id });
      };

    
  }
})();
(function() {
  'use strict';

  angular.module('ticket.controller.estabelecimento')
    .controller('ticket.controller.estabelecimento.form', estabelecimentoFormController);

  estabelecimentoFormController.$inject = ['$scope', '$state', 'common', '$uibModal', 'ticket.service.estabelecimento', 'ticket.service.empresa', 'ticket.service.controleregiao.cidade'];

  function estabelecimentoFormController($scope, $state, common, $uibModal, estabelecimentoSrv, empresaSrv, cidadeSrv, regraIngressoSrv) {
    var vm = common.controller.form(this, estabelecimentoSrv);
    vm.loaded = loaded;

    vm.cancel = function() {
      $state.go('estabelecimento.grid');
    };

    if (vm.item != null) {
      vm.item.Status = vm.item.Status == undefined ? false : vm.item.Status
    }

    empresaSrv.list({}).then(function(empresas) {
      vm.empresaList = empresas;
    });

    cidadeSrv.list({}).then(function(cidades) {
      vm.cidadeList = cidades;
    });

    // //Validar form
    $scope.$watch('frm.$valid', function(value) {
      $scope.validateForm = !value;
    });


    vm.openModel = function() {
      $uibModal.open({
        animation: false,
        templateUrl: 'view/estabelecimento/template/mapa.tmpl.html',
        controller: 'ticket.controller.estabelecimento.popupmapa',
        controllerAs: 'vm',
        size: 'md',
        resolve: {
          latitude: function() {

            if (vm.item === undefined)
              vm.item = {};

            return vm.item.Latitude;
          },
          longitude: function() {

            if (vm.item === undefined)
              vm.item = {};

            return vm.item.Longitude;
          }

        }
      }).result.then(function(item) {
        vm.item.Latitude = item.latitude;
        vm.item.Longitude = item.longitude;
      });
    };

    function loaded() {
      if (vm.item != null) {
        vm.item.Status = vm.item.Status == 2 ? true : false
      }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('ticket.controller.estabelecimento')
    .config(moduleConfig);

  /* @ngInject */
  function moduleConfig($stateProvider, menuProvider) {

    $stateProvider
      .state('estabelecimento', {
        abstract: true,
        url: '/estabelecimento',
        templateUrl: "view/site/_content.html"
      })

      .state('estabelecimento.grid', {
        url: '/consulta',
        parent: 'estabelecimento',
        data: {
          displayName: 'Estabelecimentos'
        },
        templateUrl: 'view/estabelecimento/grid.html',
        controller: 'ticket.controller.estabelecimento.grid',
        controllerAs: 'vm'
      })

    .state('estabelecimento.form', {
      url: '/form/:Id',
      params: {
        Id: null
      },
      parent: 'estabelecimento',
      data: {
        displayName: 'Adicionar Estabelecimento'
      },
      templateUrl: 'view/estabelecimento/form.html',
      controller: 'ticket.controller.estabelecimento.form',
      controllerAs: 'vm'
    })

    .state('estabelecimento.layouts', {
      url: '/layouts/:IdEstabelecimento',
      params: {
        IdEstabelecimento: null
      },
      parent: 'estabelecimento',
      data: {
        displayName: 'Layouts do Estabelecimento'
      },
      templateUrl: 'view/estabelecimento/layouts.html',
      controller: 'ticket.controller.estabelecimento.layouts',
      controllerAs: 'vm'
    })

    .state('estabelecimento.mapa', {
      url: '/mapa/:IdLayout/:IdEstabelecimento',
      params: {
        IdLayout: null,
        IdSala: null,
        IdEstabelecimento: null
      },
      parent: 'estabelecimento',
      data: {
        displayName: 'Mapa do Layout'
      },
      templateUrl: 'view/estabelecimento/mapa.html',
      controller: 'ticket.controller.estabelecimento.mapa',
      controllerAs: 'vm'
    })

     .state('estabelecimento.estrutura', {
     data: {
     displayName: 'Estrutura'
     },
     abstract: true,
     parent: 'estabelecimento',
     url: '/estrutura',
     templateUrl: 'view/estabelecimento/estrutura/index.html',
     controller: 'ticket.controller.estabelecimento.estabelecimentoconfiguracaoestrutura',
     controllerAs: 'vm'
     })

     .state('estabelecimento.estrutura.form', {
     data: {
     displayName: 'Estrutura'
     },
     url: '/form/:Id',
     params: {
     Id: null
     },
     parent: 'estabelecimento.estrutura',
     templateUrl: 'view/estabelecimento/estrutura/form.html',
     controller: 'ticket.controller.estabelecimento.estabelecimentoconfiguracaoestrutura.form',
     controllerAs: 'vm'
     })

    .state('estabelecimento.estrutura.grid', {
      url: '/consulta',
      parent: 'estabelecimento.estrutura',
      data: {
        displayName: 'Estabelecimento Estrutura'
      },
      templateUrl: 'view/estabelecimento/estrutura/grid.html',
      controller: 'ticket.controller.estabelecimento.estabelecimentoconfiguracaoestrutura.grid',
      controllerAs: 'vm'
    })

    // menuProvider.left.add({
    //   name: 'Estabelecimento',
    //   icon: 'fa fa-credit-card',
    //   type: 'link',
    //   priority: 1.0,
    //   state: 'estabelecimento',
    //   childs: [{
    //       name: 'Consultar',
    //       icon: 'fa fa-credit-card',
    //       type: 'link',
    //       priority: 1.0,
    //       state: 'estabelecimento.grid'
    //     },
    //     {
    //       name: 'Estrutura',
    //       icon: 'fa fa-user',
    //       type: 'link',
    //       priority: 2.0,
    //       state: 'estabelecimento.estrutura.grid'
    //     },
    //     {
    //       name: 'Conveniencia',
    //       icon: 'fa fa-user',
    //       type: 'link',
    //       priority: 2.0,
    //       state: 'estabelecimento.convenienciaestabelecimento.grid'
    //     },
    //     {
    //       name: 'Forma Pagamento',
    //       icon: 'fa fa-user',
    //       type: 'link',
    //       priority: 2.0,
    //       state: 'estabelecimento.formapagamento.grid'
    //     }
    //     ]
    // });
    //
    // menuProvider.left.add({
    //   type: 'divider',
    //   priority: 1.1
    // });
  }
})();

(function() {
  'use strict';

  angular
    .module('ticket.controller.empresa', [

    ]);
})();
(function() {
  'use strict';

  angular.module('ticket.controller.empresa')
    .controller('ticket.controller.empresa.grid', empresaGridController);

  empresaGridController.$inject = ['$state', '$rootScope', 'common', 'ticket.service.empresa'];

  function empresaGridController($state, $rootScope, common, empresaSrv) {
    var vm = common.controller.grid(this, empresaSrv);
    vm.add = function() {
      $state.go('empresa.form');
    };

  }

})();
(function() {
  'use strict';

  angular.module('ticket.controller.empresa')
    .controller('ticket.controller.empresa.form', empresaFormController);

  empresaFormController.$inject = ['$scope', '$state', 'common', 'ticket.service.empresa', 'ticket.service.controleregiao.cidade'];

  function empresaFormController($scope, $state, common, empresaSrv, cidadeSrv) {
    var vm = common.controller.form(this, empresaSrv);
    vm.cancel = function() {
      $state.go('empresa.grid');
    };
    //Inicializar listas
    vm.cidadeList = null;



    cidadeSrv.list({}).then(function(data) {
      vm.cidadeList = data;
    });

    // //Validar form
    $scope.$watch('frm.$valid', function(value) {
      $scope.validateForm = !value;
    });


  }

})();
(function() {
  'use strict';

  angular
    .module('ticket.controller.empresa')
    .config(moduleConfig);

  /* @ngInject */
  function moduleConfig($stateProvider, menuProvider) {

    $stateProvider
      .state('empresa', {
        abstract: true,
        url: '/empresa',
        templateUrl: "view/site/_content.html"
      })
      .state('empresa.grid', {
        url: '/consulta',
        parent: 'empresa',
        data: {
          displayName: 'Empresas'
        },
        templateUrl: 'view/empresa/grid.html',
        controller: 'ticket.controller.empresa.grid',
        controllerAs: 'vm'
      })

    .state('empresa.form', {
      url: '/form/:Id',
      params: {
        Id: null
      },
      parent: 'empresa',
      data: {
        displayName: 'Adicionar Empreas'
      },
      templateUrl: 'view/empresa/form.html',
      controller: 'ticket.controller.empresa.form',
      controllerAs: 'vm'
    })


    //ANTIGO
    // menuProvider.left.add({
    //   name: 'Cliente',
    //   icon: 'fa fa-building',
    //   type: 'link',
    //   priority: 1.0,
    //   state: 'empresa',
    //   childs: [{
    //     name: 'Empresa',
    //     icon: 'fa fa-building',
    //     type: 'link',
    //     priority: 1.0,
    //     state: 'empresa.grid'
    //   }]
    // });



    menuProvider.left.add({
      name: 'Cliente',
      icon: 'fa fa-building',
      type: 'link',
      priority: 1.0,
      state: 'empresa',
      childs: [{
        third: true,
        name: 'Empresa',
        icon: 'fa fa-building',
        type: 'link',
        priority: 1.0,
        state: 'empresa',
        childs: [{
          second: true,
          name: 'Dados Bancários',
          icon: 'fa fa-credit-card',
          type: 'link',
          priority: 1.0,
          state: 'empresa.grid'
        }]
      },
        {
          third: true,
          name: 'Estabelecimento',
          icon: 'fa fa-credit-card',
          type: 'link',
          priority: 1.0,
          state: 'estabelecimento',
          childs: [{
            second: true,
            name: 'Consultar',
            icon: 'fa fa-credit-card',
            type: 'link',
            priority: 1.0,
            state: 'estabelecimento.grid'
          },
            {
              second: true,
              name: 'Estrutura',
              icon: 'fa fa-user',
              type: 'link',
              priority: 1.0,
              state: 'estabelecimento.estrutura.grid'
            },
            {
              second: true,
              name: 'Conveniencia',
              icon: 'fa fa-user',
              type: 'link',
              priority: 1.0,
              state: 'estabelecimento.convenienciaestabelecimento.grid'
            },
            {
              second: true,
              name: 'Forma Pagamento',
              icon: 'fa fa-user',
              type: 'link',
              priority: 1.0,
              state: 'estabelecimento.formapagamento.grid'
            }
          ]
        }
      ]
    });

    menuProvider.left.add({
      type: 'divider',
      priority: 1.1
    });
  }
})();

(function() {
  'use strict';

  angular
    .module('ticket.controller.controleingresso')
    .config(moduleConfig);

  /* @ngInject */
  function moduleConfig($stateProvider, menuProvider) {

   $stateProvider
   .state('controleingresso', {
      abstract: true,
      url: '/controleingresso',
      templateUrl: "view/site/_content.html"
    })

   menuProvider.left.add({
      name: 'Controle Ingresso',
      icon: 'fa fa-credit-card',
      type: 'link',
      priority: 1.0,
      state: 'controleingresso',
      childs: [{
          second:true,
          name: 'Regras Ingresso Estabelecimento',
          icon: 'fa fa-credit-card',
          type: 'link',
          priority: 1.0,
          state: 'controleingresso.regraingressoestabelecimento.grid'
        }
      ]
    });

    menuProvider.left.add({
      type: 'divider',
      priority: 1.1
    });

  }
})();

(function() {
  'use strict';

  angular
    .module('ticket.controller.conteudo')
    .config(moduleConfig);

  /* @ngInject */
  function moduleConfig($stateProvider, menuProvider) {
    $stateProvider
      .state('conteudo', {
        abstract: true,
        url: '/conteudo',
        templateUrl: "view/site/_content.html"
      });

    menuProvider.left.add({
      name: 'Conteúdo',
      icon: 'fa fa-music',
      type: 'link',
      priority: 1.0,
      state: 'conteudo',
      childs: [{
          second:true,
          name: 'Atração',
          icon: 'fa fa-music',
          type: 'link',
          priority: 1.0,
          state: 'conteudo.atracao.grid'
        }, {
          second:true,
          name: 'Artistas',
          icon: 'fa fa-music',
          type: 'link',
          priority: 1.0,
          state: 'conteudo.artista.grid'
        }, {
          second:true,
          name: 'Bandas',
          icon: 'fa fa-music',
          type: 'link',
          priority: 1.0,
          state: 'conteudo.banda.grid'
        }, {
          second:true,
          name: 'Gêneros',
          icon: 'fa fa-venus-mars',
          type: 'link',
          priority: 1.0,
          state: 'conteudo.genero.grid'
        }, {
          second:true,
          name: 'Inadequações',
          icon: 'fa fa-venus-mars',
          type: 'link',
          priority: 1.0,
          state: 'conteudo.inadequacao.grid'
        },
        {
          second:true,
          name: 'Banner',
          icon: 'fa fa-venus-mars',
          type: 'link',
          priority: 1.0,
          state: 'conteudo.banner.grid'
        },
        {
          second:true,
          name: 'Vídeo',
          icon: 'fa fa-video',
          type: 'link',
          priority: 1.0,
          state: 'conteudo.video.grid'
        }

      ]
    });

    menuProvider.left.add({
      type: 'divider',
      priority: 1.1
    });
  }
})();

(function() {
  'use strict';

  angular
    .module('ticket.controller.authentication')
    .run(["$rootScope", "$state", "ticket.service.controleacesso.login", function($rootScope, $state, loginSvc) {

      // create roles for app
      //RoleStore
      //.defineRole('GESTÃO', ['site.user-home', 'conteudo.atracao', 'conteudo.atracao.nova', 'conteudo.atracao.nova-wizard'], checkRole);


      ///////////////////////

      // default redirect if access is denied
      function accessDenied() {
        $state.go('401');
      }

      // function that calls user service to check if permission is allowed
      function checkRole(permission, transitionProperties) {
        return loginSvc.hasPermission(permission, transitionProperties);
      }

      // watches

      // redirect all denied permissions to 401
      var deniedHandle = $rootScope.$on('$stateChangePermissionDenied', accessDenied);

      // remove watch on destroy
      $rootScope.$on('$destroy', function() {
        deniedHandle();
      });
    }]);
})();
(function() {
  'use strict';

  angular
    .module('ticket.controller.authentication')
    .config(moduleConfig);

  /* @ngInject */
  function moduleConfig($stateProvider, menuProvider) {

    $stateProvider
      .state('auth', {
        abstract: true,
        templateUrl: "view/authentication/_content.html"
      })
      .state('auth.login', {
        url: '/login',
        templateUrl: 'view/authentication/login/login.html',
        controller: 'ticket.controller.authentication.login',
        controllerAs: 'vm',
        data: {
          pageTitle: 'Login',
          specialClass: 'gray-bg'
        }
      })
      .state('auth.forgot', {
        url: '/forgot',
        templateUrl: 'view/authentication/forgot/forgot.html',
        controller: 'ticket.controller.authentication.forgot',
        controllerAs: 'vm'
      })
      .state('auth.resetpassword', {
        url: '/resetpassword/:token',
        templateUrl: 'view/authentication/forgot/reset.html',
        controller: 'ticket.controller.authentication.resetpassword',
        controllerAs: 'vm',
        data: {
          pageTitle: 'Recuperação de senha'
        }
      })
      .state('auth.lock', {
        url: '/lock',
        templateUrl: 'app/authentication/lock/lock.tmpl.html',
        controller: 'ticket.controller.authentication.lock',
        controllerAs: 'vm'
      })
      .state('auth.setpassword', {
        url: '/setpassword/:token',
        templateUrl: 'view/authentication/forgot/reset.html',
        controller: 'ticket.controller.authentication.resetpassword',
        controllerAs: 'vm',
        data: {
          pageTitle: 'Definir senha',
        }
      });



  }
})();
(function() {
  'use strict';

  angular
    .module("ticket", ['app', 'ticket.translate', 'ticket.helper', 'ticket.service', 'ticket.controller', 'ticket.filter'])
})();
(function() {
  'use strict';

  angular
    .module('ticket')
    .provider('ticketSettings', settingsProvider);

  /* @ngInject */
  function settingsProvider() {
    // Provider
    var settings = {
      name: 'Divertix',
      logo: 'fa fa-ticket',
      copyright: '',
      version: ''
    };

    this.setLogo = setLogo;
    this.setName = setName;
    this.setCopyright = setCopyright;
    this.setVersion = setVersion;


    function setLogo(logo) {
      settings.logo = logo;
    }

    function setName(name) {
      settings.name = name;
    }

    function setCopyright(copy) {
      settings.copyright = copy;
    }

    function setVersion(version) {
      settings.version = version;
    }

    // Service
    this.$get = function() {
      return {
        name: settings.name,
        copyright: settings.copyright,
        logo: settings.logo,
        version: settings.version,
        defaultSkin: settings.defaultSkin
      };
    };
  }
})();
(function() {
  'use strict';

  angular
    .module('ticket.service', [
      'ticket.service.controleacesso',
      'ticket.service.empresa',
      'ticket.service.estabelecimento',
      'ticket.service.local',
      'ticket.service.moderacao',
      'ticket.service.controleregiao',
      'ticket.service.conteudo',
      'ticket.service.controleestabelecimento',
      'ticket.service.controleformapagamento',
      'ticket.service.controleingresso',
      'ticket.service.repasse',
      'ticket.service.reports',
      'ticket.service.repasseempresa',
      'ticket.service.programacao',
      'ticket.service.promocao',
      'ticket.service.estabelecimentoingresso',
      'ticket.service.fluxocaixa',
      'ticket.service.venda',
      'ticket.service.configuracao',
      'ticket.service.operacao',
      'ticket.service.cliente'
      // 'ticket.service.controleregraingresso',
      // 'ticket.service.controleregraingressoestabelecimento'
    ]);
})();

(function() {
  'use strict';

//  angular.module('inspinia', ['ngAnimate', 'ngCookies', 'ngTouch', 'ngSanitize', 'ngMessages', 'ngAria', 'ngResource', 'ui.router', 'ui.bootstrap', 'toaster', 'ui.mask', 'ngFileUpload', 'oc.lazyLoad', 'ticket', 'ngImgCrop', 'ui.utils.masks', 'multipleDatePicker', 'bootstrapLightbox', 'infinite-scroll', 'tableSort']);

  angular.module('inspinia', ['ngAnimate', 'ngCookies', 'ngTouch', 'ngSanitize', 'ngMessages', 'ngAria', 'ngResource', 'ui.router', 'ui.bootstrap', 'toaster', 'ui.mask', 'ngFileUpload', 'oc.lazyLoad', 'ticket', 'ngImgCrop', 'ui.utils.masks', 'multipleDatePicker', 'bootstrapLightbox', 'infinite-scroll', 'textAngular', 'tableSort', angularDragula(angular)]);

})();

'use strict';
angular.module('inspinia')
  .controller('MainController', function () {

    var vm = this;

    vm.userName = 'Example user';
    vm.helloText = 'Welcome in INSPINIA Gulp SeedProject';
    vm.descriptionText = 'It is an application skeleton for a typical AngularJS web app. You can use it to quickly bootstrap your angular webapp projects.';

  });

/*--------------------------------------------------------------------------
 * linq.js - LINQ for JavaScript
 * ver 3.0.3-Beta4 (Oct. 9th, 2012)
 *
 * created and maintained by neuecc <ils@neue.cc>
 * licensed under MIT License
 * http://linqjs.codeplex.com/
 *------------------------------------------------------------------------*/
(function(w,j){var l="enumerator is disposed",q="single:sequence contains more than one element.",a=false,b=null,e=true,g={Identity:function(a){return a},True:function(){return e},Blank:function(){}},i={Boolean:typeof e,Number:typeof 0,String:typeof"",Object:typeof{},Undefined:typeof j,Function:typeof function(){}},d={createLambda:function(a){if(a==b)return g.Identity;if(typeof a==i.String)if(a=="")return g.Identity;else if(a.indexOf("=>")==-1){var m=new RegExp("[$]+","g"),c=0,j;while(j=m.exec(a)){var e=j[0].length;if(e>c)c=e}for(var f=[],d=1;d<=c;d++){for(var h="",l=0;l<d;l++)h+="$";f.push(h)}var n=Array.prototype.join.call(f,",");return new Function(n,"return "+a)}else{var k=a.match(/^[(\s]*([^()]*?)[)\s]*=>(.*)/);return new Function(k[1],"return "+k[2])}return a},isIEnumerable:function(b){if(typeof Enumerator!==i.Undefined)try{new Enumerator(b);return e}catch(c){}return a},defineProperty:Object.defineProperties!=b?function(c,b,d){Object.defineProperty(c,b,{enumerable:a,configurable:e,writable:e,value:d})}:function(b,a,c){b[a]=c},compare:function(a,b){return a===b?0:a>b?1:-1},dispose:function(a){a!=b&&a.dispose()}},o={Before:0,Running:1,After:2},f=function(d,f,g){var c=new u,b=o.Before;this.current=c.current;this.moveNext=function(){try{switch(b){case o.Before:b=o.Running;d();case o.Running:if(f.apply(c))return e;else{this.dispose();return a}case o.After:return a}}catch(g){this.dispose();throw g;}};this.dispose=function(){if(b!=o.Running)return;try{g()}finally{b=o.After}}},u=function(){var c=b;this.current=function(){return c};this.yieldReturn=function(a){c=a;return e};this.yieldBreak=function(){return a}},c=function(a){this.getEnumerator=a};c.Utils={};c.Utils.createLambda=function(a){return d.createLambda(a)};c.Utils.createEnumerable=function(a){return new c(a)};c.Utils.createEnumerator=function(a,b,c){return new f(a,b,c)};c.Utils.extendTo=function(i){var e=i.prototype,f;if(i===Array){f=h.prototype;d.defineProperty(e,"getSource",function(){return this})}else{f=c.prototype;d.defineProperty(e,"getEnumerator",function(){return c.from(this).getEnumerator()})}for(var a in f){var g=f[a];if(e[a]==g)continue;if(e[a]!=b){a=a+"ByLinq";if(e[a]==g)continue}g instanceof Function&&d.defineProperty(e,a,g)}};c.choice=function(){var a=arguments;return new c(function(){return new f(function(){a=a[0]instanceof Array?a[0]:a[0].getEnumerator!=b?a[0].toArray():a},function(){return this.yieldReturn(a[Math.floor(Math.random()*a.length)])},g.Blank)})};c.cycle=function(){var a=arguments;return new c(function(){var c=0;return new f(function(){a=a[0]instanceof Array?a[0]:a[0].getEnumerator!=b?a[0].toArray():a},function(){if(c>=a.length)c=0;return this.yieldReturn(a[c++])},g.Blank)})};c.empty=function(){return new c(function(){return new f(g.Blank,function(){return a},g.Blank)})};c.from=function(j){if(j==b)return c.empty();if(j instanceof c)return j;if(typeof j==i.Number||typeof j==i.Boolean)return c.repeat(j,1);if(typeof j==i.String)return new c(function(){var b=0;return new f(g.Blank,function(){return b<j.length?this.yieldReturn(j.charAt(b++)):a},g.Blank)});if(typeof j!=i.Function){if(typeof j.length==i.Number)return new h(j);if(!(j instanceof Object)&&d.isIEnumerable(j))return new c(function(){var c=e,b;return new f(function(){b=new Enumerator(j)},function(){if(c)c=a;else b.moveNext();return b.atEnd()?a:this.yieldReturn(b.item())},g.Blank)});if(typeof Windows===i.Object&&typeof j.first===i.Function)return new c(function(){var c=e,b;return new f(function(){b=j.first()},function(){if(c)c=a;else b.moveNext();return b.hasCurrent?this.yieldReturn(b.current):this.yieldBreak()},g.Blank)})}return new c(function(){var b=[],c=0;return new f(function(){for(var a in j){var c=j[a];!(c instanceof Function)&&Object.prototype.hasOwnProperty.call(j,a)&&b.push({key:a,value:c})}},function(){return c<b.length?this.yieldReturn(b[c++]):a},g.Blank)})},c.make=function(a){return c.repeat(a,1)};c.matches=function(h,e,d){if(d==b)d="";if(e instanceof RegExp){d+=e.ignoreCase?"i":"";d+=e.multiline?"m":"";e=e.source}if(d.indexOf("g")===-1)d+="g";return new c(function(){var b;return new f(function(){b=new RegExp(e,d)},function(){var c=b.exec(h);return c?this.yieldReturn(c):a},g.Blank)})};c.range=function(e,d,a){if(a==b)a=1;return new c(function(){var b,c=0;return new f(function(){b=e-a},function(){return c++<d?this.yieldReturn(b+=a):this.yieldBreak()},g.Blank)})};c.rangeDown=function(e,d,a){if(a==b)a=1;return new c(function(){var b,c=0;return new f(function(){b=e+a},function(){return c++<d?this.yieldReturn(b-=a):this.yieldBreak()},g.Blank)})};c.rangeTo=function(d,e,a){if(a==b)a=1;return d<e?new c(function(){var b;return new f(function(){b=d-a},function(){var c=b+=a;return c<=e?this.yieldReturn(c):this.yieldBreak()},g.Blank)}):new c(function(){var b;return new f(function(){b=d+a},function(){var c=b-=a;return c>=e?this.yieldReturn(c):this.yieldBreak()},g.Blank)})};c.repeat=function(a,d){return d!=b?c.repeat(a).take(d):new c(function(){return new f(g.Blank,function(){return this.yieldReturn(a)},g.Blank)})};c.repeatWithFinalize=function(a,e){a=d.createLambda(a);e=d.createLambda(e);return new c(function(){var c;return new f(function(){c=a()},function(){return this.yieldReturn(c)},function(){if(c!=b){e(c);c=b}})})};c.generate=function(a,e){if(e!=b)return c.generate(a).take(e);a=d.createLambda(a);return new c(function(){return new f(g.Blank,function(){return this.yieldReturn(a())},g.Blank)})};c.toInfinity=function(d,a){if(d==b)d=0;if(a==b)a=1;return new c(function(){var b;return new f(function(){b=d-a},function(){return this.yieldReturn(b+=a)},g.Blank)})};c.toNegativeInfinity=function(d,a){if(d==b)d=0;if(a==b)a=1;return new c(function(){var b;return new f(function(){b=d+a},function(){return this.yieldReturn(b-=a)},g.Blank)})};c.unfold=function(h,b){b=d.createLambda(b);return new c(function(){var d=e,c;return new f(g.Blank,function(){if(d){d=a;c=h;return this.yieldReturn(c)}c=b(c);return this.yieldReturn(c)},g.Blank)})};c.defer=function(a){return new c(function(){var b;return new f(function(){b=c.from(a()).getEnumerator()},function(){return b.moveNext()?this.yieldReturn(b.current()):this.yieldBreak()},function(){d.dispose(b)})})};c.prototype.traverseBreadthFirst=function(g,b){var h=this;g=d.createLambda(g);b=d.createLambda(b);return new c(function(){var i,k=0,j=[];return new f(function(){i=h.getEnumerator()},function(){while(e){if(i.moveNext()){j.push(i.current());return this.yieldReturn(b(i.current(),k))}var f=c.from(j).selectMany(function(a){return g(a)});if(!f.any())return a;else{k++;j=[];d.dispose(i);i=f.getEnumerator()}}},function(){d.dispose(i)})})};c.prototype.traverseDepthFirst=function(g,b){var h=this;g=d.createLambda(g);b=d.createLambda(b);return new c(function(){var j=[],i;return new f(function(){i=h.getEnumerator()},function(){while(e){if(i.moveNext()){var f=b(i.current(),j.length);j.push(i);i=c.from(g(i.current())).getEnumerator();return this.yieldReturn(f)}if(j.length<=0)return a;d.dispose(i);i=j.pop()}},function(){try{d.dispose(i)}finally{c.from(j).forEach(function(a){a.dispose()})}})})};c.prototype.flatten=function(){var h=this;return new c(function(){var j,i=b;return new f(function(){j=h.getEnumerator()},function(){while(e){if(i!=b)if(i.moveNext())return this.yieldReturn(i.current());else i=b;if(j.moveNext())if(j.current()instanceof Array){d.dispose(i);i=c.from(j.current()).selectMany(g.Identity).flatten().getEnumerator();continue}else return this.yieldReturn(j.current());return a}},function(){try{d.dispose(j)}finally{d.dispose(i)}})})};c.prototype.pairwise=function(b){var e=this;b=d.createLambda(b);return new c(function(){var c;return new f(function(){c=e.getEnumerator();c.moveNext()},function(){var d=c.current();return c.moveNext()?this.yieldReturn(b(d,c.current())):a},function(){d.dispose(c)})})};c.prototype.scan=function(i,g){var h;if(g==b){g=d.createLambda(i);h=a}else{g=d.createLambda(g);h=e}var j=this;return new c(function(){var b,c,k=e;return new f(function(){b=j.getEnumerator()},function(){if(k){k=a;if(!h){if(b.moveNext())return this.yieldReturn(c=b.current())}else return this.yieldReturn(c=i)}return b.moveNext()?this.yieldReturn(c=g(c,b.current())):a},function(){d.dispose(b)})})};c.prototype.select=function(e){e=d.createLambda(e);if(e.length<=1)return new m(this,b,e);else{var g=this;return new c(function(){var b,c=0;return new f(function(){b=g.getEnumerator()},function(){return b.moveNext()?this.yieldReturn(e(b.current(),c++)):a},function(){d.dispose(b)})})}};c.prototype.selectMany=function(g,e){var h=this;g=d.createLambda(g);if(e==b)e=function(b,a){return a};e=d.createLambda(e);return new c(function(){var k,i=j,l=0;return new f(function(){k=h.getEnumerator()},function(){if(i===j)if(!k.moveNext())return a;do{if(i==b){var f=g(k.current(),l++);i=c.from(f).getEnumerator()}if(i.moveNext())return this.yieldReturn(e(k.current(),i.current()));d.dispose(i);i=b}while(k.moveNext());return a},function(){try{d.dispose(k)}finally{d.dispose(i)}})})};c.prototype.where=function(b){b=d.createLambda(b);if(b.length<=1)return new n(this,b);else{var e=this;return new c(function(){var c,g=0;return new f(function(){c=e.getEnumerator()},function(){while(c.moveNext())if(b(c.current(),g++))return this.yieldReturn(c.current());return a},function(){d.dispose(c)})})}};c.prototype.choose=function(a){a=d.createLambda(a);var e=this;return new c(function(){var c,g=0;return new f(function(){c=e.getEnumerator()},function(){while(c.moveNext()){var d=a(c.current(),g++);if(d!=b)return this.yieldReturn(d)}return this.yieldBreak()},function(){d.dispose(c)})})};c.prototype.ofType=function(c){var a;switch(c){case Number:a=i.Number;break;case String:a=i.String;break;case Boolean:a=i.Boolean;break;case Function:a=i.Function;break;default:a=b}return a===b?this.where(function(a){return a instanceof c}):this.where(function(b){return typeof b===a})};c.prototype.zip=function(){var i=arguments,e=d.createLambda(arguments[arguments.length-1]),g=this;if(arguments.length==2){var h=arguments[0];return new c(function(){var i,b,j=0;return new f(function(){i=g.getEnumerator();b=c.from(h).getEnumerator()},function(){return i.moveNext()&&b.moveNext()?this.yieldReturn(e(i.current(),b.current(),j++)):a},function(){try{d.dispose(i)}finally{d.dispose(b)}})})}else return new c(function(){var a,h=0;return new f(function(){var b=c.make(g).concat(c.from(i).takeExceptLast().select(c.from)).select(function(a){return a.getEnumerator()}).toArray();a=c.from(b)},function(){if(a.all(function(a){return a.moveNext()})){var c=a.select(function(a){return a.current()}).toArray();c.push(h++);return this.yieldReturn(e.apply(b,c))}else return this.yieldBreak()},function(){c.from(a).forEach(d.dispose)})})};c.prototype.merge=function(){var b=arguments,a=this;return new c(function(){var e,g=-1;return new f(function(){e=c.make(a).concat(c.from(b).select(c.from)).select(function(a){return a.getEnumerator()}).toArray()},function(){while(e.length>0){g=g>=e.length-1?0:g+1;var a=e[g];if(a.moveNext())return this.yieldReturn(a.current());else{a.dispose();e.splice(g--,1)}}return this.yieldBreak()},function(){c.from(e).forEach(d.dispose)})})};c.prototype.join=function(n,i,h,l,k){i=d.createLambda(i);h=d.createLambda(h);l=d.createLambda(l);k=d.createLambda(k);var m=this;return new c(function(){var o,r,p=b,q=0;return new f(function(){o=m.getEnumerator();r=c.from(n).toLookup(h,g.Identity,k)},function(){while(e){if(p!=b){var c=p[q++];if(c!==j)return this.yieldReturn(l(o.current(),c));c=b;q=0}if(o.moveNext()){var d=i(o.current());p=r.get(d).toArray()}else return a}},function(){d.dispose(o)})})};c.prototype.groupJoin=function(l,h,e,j,i){h=d.createLambda(h);e=d.createLambda(e);j=d.createLambda(j);i=d.createLambda(i);var k=this;return new c(function(){var m=k.getEnumerator(),n=b;return new f(function(){m=k.getEnumerator();n=c.from(l).toLookup(e,g.Identity,i)},function(){if(m.moveNext()){var b=n.get(h(m.current()));return this.yieldReturn(j(m.current(),b))}return a},function(){d.dispose(m)})})};c.prototype.all=function(b){b=d.createLambda(b);var c=e;this.forEach(function(d){if(!b(d)){c=a;return a}});return c};c.prototype.any=function(c){c=d.createLambda(c);var b=this.getEnumerator();try{if(arguments.length==0)return b.moveNext();while(b.moveNext())if(c(b.current()))return e;return a}finally{d.dispose(b)}};c.prototype.isEmpty=function(){return!this.any()};c.prototype.concat=function(){var e=this;if(arguments.length==1){var g=arguments[0];return new c(function(){var i,h;return new f(function(){i=e.getEnumerator()},function(){if(h==b){if(i.moveNext())return this.yieldReturn(i.current());h=c.from(g).getEnumerator()}return h.moveNext()?this.yieldReturn(h.current()):a},function(){try{d.dispose(i)}finally{d.dispose(h)}})})}else{var h=arguments;return new c(function(){var a;return new f(function(){a=c.make(e).concat(c.from(h).select(c.from)).select(function(a){return a.getEnumerator()}).toArray()},function(){while(a.length>0){var b=a[0];if(b.moveNext())return this.yieldReturn(b.current());else{b.dispose();a.splice(0,1)}}return this.yieldBreak()},function(){c.from(a).forEach(d.dispose)})})}};c.prototype.insert=function(h,b){var g=this;return new c(function(){var j,i,l=0,k=a;return new f(function(){j=g.getEnumerator();i=c.from(b).getEnumerator()},function(){if(l==h&&i.moveNext()){k=e;return this.yieldReturn(i.current())}if(j.moveNext()){l++;return this.yieldReturn(j.current())}return!k&&i.moveNext()?this.yieldReturn(i.current()):a},function(){try{d.dispose(j)}finally{d.dispose(i)}})})};c.prototype.alternate=function(a){var g=this;return new c(function(){var j,i,k,h;return new f(function(){if(a instanceof Array||a.getEnumerator!=b)k=c.from(c.from(a).toArray());else k=c.make(a);i=g.getEnumerator();if(i.moveNext())j=i.current()},function(){while(e){if(h!=b)if(h.moveNext())return this.yieldReturn(h.current());else h=b;if(j==b&&i.moveNext()){j=i.current();h=k.getEnumerator();continue}else if(j!=b){var a=j;j=b;return this.yieldReturn(a)}return this.yieldBreak()}},function(){try{d.dispose(i)}finally{d.dispose(h)}})})};c.prototype.contains=function(f,b){b=d.createLambda(b);var c=this.getEnumerator();try{while(c.moveNext())if(b(c.current())===f)return e;return a}finally{d.dispose(c)}};c.prototype.defaultIfEmpty=function(g){var h=this;if(g===j)g=b;return new c(function(){var b,c=e;return new f(function(){b=h.getEnumerator()},function(){if(b.moveNext()){c=a;return this.yieldReturn(b.current())}else if(c){c=a;return this.yieldReturn(g)}return a},function(){d.dispose(b)})})};c.prototype.distinct=function(a){return this.except(c.empty(),a)};c.prototype.distinctUntilChanged=function(b){b=d.createLambda(b);var e=this;return new c(function(){var c,g,h;return new f(function(){c=e.getEnumerator()},function(){while(c.moveNext()){var d=b(c.current());if(h){h=a;g=d;return this.yieldReturn(c.current())}if(g===d)continue;g=d;return this.yieldReturn(c.current())}return this.yieldBreak()},function(){d.dispose(c)})})};c.prototype.except=function(e,b){b=d.createLambda(b);var g=this;return new c(function(){var h,i;return new f(function(){h=g.getEnumerator();i=new r(b);c.from(e).forEach(function(a){i.add(a)})},function(){while(h.moveNext()){var b=h.current();if(!i.contains(b)){i.add(b);return this.yieldReturn(b)}}return a},function(){d.dispose(h)})})};c.prototype.intersect=function(e,b){b=d.createLambda(b);var g=this;return new c(function(){var h,i,j;return new f(function(){h=g.getEnumerator();i=new r(b);c.from(e).forEach(function(a){i.add(a)});j=new r(b)},function(){while(h.moveNext()){var b=h.current();if(!j.contains(b)&&i.contains(b)){j.add(b);return this.yieldReturn(b)}}return a},function(){d.dispose(h)})})};c.prototype.sequenceEqual=function(h,f){f=d.createLambda(f);var g=this.getEnumerator();try{var b=c.from(h).getEnumerator();try{while(g.moveNext())if(!b.moveNext()||f(g.current())!==f(b.current()))return a;return b.moveNext()?a:e}finally{d.dispose(b)}}finally{d.dispose(g)}};c.prototype.union=function(e,b){b=d.createLambda(b);var g=this;return new c(function(){var k,h,i;return new f(function(){k=g.getEnumerator();i=new r(b)},function(){var b;if(h===j){while(k.moveNext()){b=k.current();if(!i.contains(b)){i.add(b);return this.yieldReturn(b)}}h=c.from(e).getEnumerator()}while(h.moveNext()){b=h.current();if(!i.contains(b)){i.add(b);return this.yieldReturn(b)}}return a},function(){try{d.dispose(k)}finally{d.dispose(h)}})})};c.prototype.orderBy=function(b){return new k(this,b,a)};c.prototype.orderByDescending=function(a){return new k(this,a,e)};c.prototype.reverse=function(){var b=this;return new c(function(){var c,d;return new f(function(){c=b.toArray();d=c.length},function(){return d>0?this.yieldReturn(c[--d]):a},g.Blank)})};c.prototype.shuffle=function(){var b=this;return new c(function(){var c;return new f(function(){c=b.toArray()},function(){if(c.length>0){var b=Math.floor(Math.random()*c.length);return this.yieldReturn(c.splice(b,1)[0])}return a},g.Blank)})};c.prototype.weightedSample=function(a){a=d.createLambda(a);var e=this;return new c(function(){var c,d=0;return new f(function(){c=e.choose(function(e){var c=a(e);if(c<=0)return b;d+=c;return{value:e,bound:d}}).toArray()},function(){if(c.length>0){var f=Math.floor(Math.random()*d)+1,e=-1,a=c.length;while(a-e>1){var b=Math.floor((e+a)/2);if(c[b].bound>=f)a=b;else e=b}return this.yieldReturn(c[a].value)}return this.yieldBreak()},g.Blank)})};c.prototype.groupBy=function(i,h,e,g){var j=this;i=d.createLambda(i);h=d.createLambda(h);if(e!=b)e=d.createLambda(e);g=d.createLambda(g);return new c(function(){var c;return new f(function(){c=j.toLookup(i,h,g).toEnumerable().getEnumerator()},function(){while(c.moveNext())return e==b?this.yieldReturn(c.current()):this.yieldReturn(e(c.current().key(),c.current()));return a},function(){d.dispose(c)})})};c.prototype.partitionBy=function(j,i,g,h){var l=this;j=d.createLambda(j);i=d.createLambda(i);h=d.createLambda(h);var k;if(g==b){k=a;g=function(b,a){return new t(b,a)}}else{k=e;g=d.createLambda(g)}return new c(function(){var b,n,o,m=[];return new f(function(){b=l.getEnumerator();if(b.moveNext()){n=j(b.current());o=h(n);m.push(i(b.current()))}},function(){var d;while((d=b.moveNext())==e)if(o===h(j(b.current())))m.push(i(b.current()));else break;if(m.length>0){var f=k?g(n,c.from(m)):g(n,m);if(d){n=j(b.current());o=h(n);m=[i(b.current())]}else m=[];return this.yieldReturn(f)}return a},function(){d.dispose(b)})})};c.prototype.buffer=function(e){var b=this;return new c(function(){var c;return new f(function(){c=b.getEnumerator()},function(){var b=[],d=0;while(c.moveNext()){b.push(c.current());if(++d>=e)return this.yieldReturn(b)}return b.length>0?this.yieldReturn(b):a},function(){d.dispose(c)})})};c.prototype.aggregate=function(c,b,a){a=d.createLambda(a);return a(this.scan(c,b,a).last())};c.prototype.average=function(a){a=d.createLambda(a);var c=0,b=0;this.forEach(function(d){c+=a(d);++b});return c/b};c.prototype.count=function(a){a=a==b?g.True:d.createLambda(a);var c=0;this.forEach(function(d,b){if(a(d,b))++c});return c};c.prototype.max=function(a){if(a==b)a=g.Identity;return this.select(a).aggregate(function(a,b){return a>b?a:b})};c.prototype.min=function(a){if(a==b)a=g.Identity;return this.select(a).aggregate(function(a,b){return a<b?a:b})};c.prototype.maxBy=function(a){a=d.createLambda(a);return this.aggregate(function(b,c){return a(b)>a(c)?b:c})};c.prototype.minBy=function(a){a=d.createLambda(a);return this.aggregate(function(b,c){return a(b)<a(c)?b:c})};c.prototype.sum=function(a){if(a==b)a=g.Identity;return this.select(a).aggregate(0,function(a,b){return a+b})};c.prototype.elementAt=function(d){var c,b=a;this.forEach(function(g,f){if(f==d){c=g;b=e;return a}});if(!b)throw new Error("index is less than 0 or greater than or equal to the number of elements in source.");return c};c.prototype.elementAtOrDefault=function(g,c){if(c===j)c=b;var f,d=a;this.forEach(function(c,b){if(b==g){f=c;d=e;return a}});return!d?c:f};c.prototype.first=function(c){if(c!=b)return this.where(c).first();var f,d=a;this.forEach(function(b){f=b;d=e;return a});if(!d)throw new Error("first:No element satisfies the condition.");return f};c.prototype.firstOrDefault=function(d,c){if(c===j)c=b;if(d!=b)return this.where(d).firstOrDefault(b,c);var g,f=a;this.forEach(function(b){g=b;f=e;return a});return!f?c:g};c.prototype.last=function(c){if(c!=b)return this.where(c).last();var f,d=a;this.forEach(function(a){d=e;f=a});if(!d)throw new Error("last:No element satisfies the condition.");return f};c.prototype.lastOrDefault=function(d,c){if(c===j)c=b;if(d!=b)return this.where(d).lastOrDefault(b,c);var g,f=a;this.forEach(function(a){f=e;g=a});return!f?c:g};c.prototype.single=function(d){if(d!=b)return this.where(d).single();var f,c=a;this.forEach(function(a){if(!c){c=e;f=a}else throw new Error(q);});if(!c)throw new Error("single:No element satisfies the condition.");return f};c.prototype.singleOrDefault=function(f,c){if(c===j)c=b;if(f!=b)return this.where(f).singleOrDefault(b,c);var g,d=a;this.forEach(function(a){if(!d){d=e;g=a}else throw new Error(q);});return!d?c:g};c.prototype.skip=function(e){var b=this;return new c(function(){var c,g=0;return new f(function(){c=b.getEnumerator();while(g++<e&&c.moveNext());},function(){return c.moveNext()?this.yieldReturn(c.current()):a},function(){d.dispose(c)})})};c.prototype.skipWhile=function(b){b=d.createLambda(b);var g=this;return new c(function(){var c,i=0,h=a;return new f(function(){c=g.getEnumerator()},function(){while(!h)if(c.moveNext()){if(!b(c.current(),i++)){h=e;return this.yieldReturn(c.current())}continue}else return a;return c.moveNext()?this.yieldReturn(c.current()):a},function(){d.dispose(c)})})};c.prototype.take=function(e){var b=this;return new c(function(){var c,g=0;return new f(function(){c=b.getEnumerator()},function(){return g++<e&&c.moveNext()?this.yieldReturn(c.current()):a},function(){d.dispose(c)})})};c.prototype.takeWhile=function(b){b=d.createLambda(b);var e=this;return new c(function(){var c,g=0;return new f(function(){c=e.getEnumerator()},function(){return c.moveNext()&&b(c.current(),g++)?this.yieldReturn(c.current()):a},function(){d.dispose(c)})})};c.prototype.takeExceptLast=function(e){if(e==b)e=1;var g=this;return new c(function(){if(e<=0)return g.getEnumerator();var b,c=[];return new f(function(){b=g.getEnumerator()},function(){while(b.moveNext()){if(c.length==e){c.push(b.current());return this.yieldReturn(c.shift())}c.push(b.current())}return a},function(){d.dispose(b)})})};c.prototype.takeFromLast=function(e){if(e<=0||e==b)return c.empty();var g=this;return new c(function(){var j,h,i=[];return new f(function(){j=g.getEnumerator()},function(){while(j.moveNext()){i.length==e&&i.shift();i.push(j.current())}if(h==b)h=c.from(i).getEnumerator();return h.moveNext()?this.yieldReturn(h.current()):a},function(){d.dispose(h)})})};c.prototype.indexOf=function(d){var c=b;if(typeof d===i.Function)this.forEach(function(e,b){if(d(e,b)){c=b;return a}});else this.forEach(function(e,b){if(e===d){c=b;return a}});return c!==b?c:-1};c.prototype.lastIndexOf=function(b){var a=-1;if(typeof b===i.Function)this.forEach(function(d,c){if(b(d,c))a=c});else this.forEach(function(d,c){if(d===b)a=c});return a};c.prototype.asEnumerable=function(){return c.from(this)};c.prototype.toArray=function(){var a=[];this.forEach(function(b){a.push(b)});return a};c.prototype.toLookup=function(c,b,a){c=d.createLambda(c);b=d.createLambda(b);a=d.createLambda(a);var e=new r(a);this.forEach(function(g){var f=c(g),a=b(g),d=e.get(f);if(d!==j)d.push(a);else e.add(f,[a])});return new v(e)};c.prototype.toObject=function(b,a){b=d.createLambda(b);a=d.createLambda(a);var c={};this.forEach(function(d){c[b(d)]=a(d)});return c};c.prototype.toDictionary=function(c,b,a){c=d.createLambda(c);b=d.createLambda(b);a=d.createLambda(a);var e=new r(a);this.forEach(function(a){e.add(c(a),b(a))});return e};c.prototype.toJSONString=function(a,c){if(typeof JSON===i.Undefined||JSON.stringify==b)throw new Error("toJSONString can't find JSON.stringify. This works native JSON support Browser or include json2.js");return JSON.stringify(this.toArray(),a,c)};c.prototype.toJoinedString=function(a,c){if(a==b)a="";if(c==b)c=g.Identity;return this.select(c).toArray().join(a)};c.prototype.doAction=function(b){var e=this;b=d.createLambda(b);return new c(function(){var c,g=0;return new f(function(){c=e.getEnumerator()},function(){if(c.moveNext()){b(c.current(),g++);return this.yieldReturn(c.current())}return a},function(){d.dispose(c)})})};c.prototype.forEach=function(c){c=d.createLambda(c);var e=0,b=this.getEnumerator();try{while(b.moveNext())if(c(b.current(),e++)===a)break}finally{d.dispose(b)}};c.prototype.write=function(c,f){if(c==b)c="";f=d.createLambda(f);var g=e;this.forEach(function(b){if(g)g=a;else document.write(c);document.write(f(b))})};c.prototype.writeLine=function(a){a=d.createLambda(a);this.forEach(function(b){document.writeln(a(b)+"<br />")})};c.prototype.force=function(){var a=this.getEnumerator();try{while(a.moveNext());}finally{d.dispose(a)}};c.prototype.letBind=function(b){b=d.createLambda(b);var e=this;return new c(function(){var g;return new f(function(){g=c.from(b(e)).getEnumerator()},function(){return g.moveNext()?this.yieldReturn(g.current()):a},function(){d.dispose(g)})})};c.prototype.share=function(){var i=this,c,h=a;return new s(function(){return new f(function(){if(c==b)c=i.getEnumerator()},function(){if(h)throw new Error(l);return c.moveNext()?this.yieldReturn(c.current()):a},g.Blank)},function(){h=e;d.dispose(c)})};c.prototype.memoize=function(){var j=this,h,c,i=a;return new s(function(){var d=-1;return new f(function(){if(c==b){c=j.getEnumerator();h=[]}},function(){if(i)throw new Error(l);d++;return h.length<=d?c.moveNext()?this.yieldReturn(h[d]=c.current()):a:this.yieldReturn(h[d])},g.Blank)},function(){i=e;d.dispose(c);h=b})};c.prototype.catchError=function(b){b=d.createLambda(b);var e=this;return new c(function(){var c;return new f(function(){c=e.getEnumerator()},function(){try{return c.moveNext()?this.yieldReturn(c.current()):a}catch(d){b(d);return a}},function(){d.dispose(c)})})};c.prototype.finallyAction=function(b){b=d.createLambda(b);var e=this;return new c(function(){var c;return new f(function(){c=e.getEnumerator()},function(){return c.moveNext()?this.yieldReturn(c.current()):a},function(){try{d.dispose(c)}finally{b()}})})};c.prototype.log=function(a){a=d.createLambda(a);return this.doAction(function(b){typeof console!==i.Undefined&&console.log(a(b))})};c.prototype.trace=function(c,a){if(c==b)c="Trace";a=d.createLambda(a);return this.doAction(function(b){typeof console!==i.Undefined&&console.log(c,a(b))})};var k=function(f,b,c,e){var a=this;a.source=f;a.keySelector=d.createLambda(b);a.descending=c;a.parent=e};k.prototype=new c;k.prototype.createOrderedEnumerable=function(a,b){return new k(this.source,a,b,this)};k.prototype.thenBy=function(b){return this.createOrderedEnumerable(b,a)};k.prototype.thenByDescending=function(a){return this.createOrderedEnumerable(a,e)};k.prototype.getEnumerator=function(){var h=this,d,c,e=0;return new f(function(){d=[];c=[];h.source.forEach(function(b,a){d.push(b);c.push(a)});var a=p.create(h,b);a.GenerateKeys(d);c.sort(function(b,c){return a.compare(b,c)})},function(){return e<c.length?this.yieldReturn(d[c[e++]]):a},g.Blank)};var p=function(c,d,e){var a=this;a.keySelector=c;a.descending=d;a.child=e;a.keys=b};p.create=function(a,d){var c=new p(a.keySelector,a.descending,d);return a.parent!=b?p.create(a.parent,c):c};p.prototype.GenerateKeys=function(d){var a=this;for(var f=d.length,g=a.keySelector,e=new Array(f),c=0;c<f;c++)e[c]=g(d[c]);a.keys=e;a.child!=b&&a.child.GenerateKeys(d)};p.prototype.compare=function(e,f){var a=this,c=d.compare(a.keys[e],a.keys[f]);return c==0?a.child!=b?a.child.compare(e,f):d.compare(e,f):a.descending?-c:c};var s=function(a,b){this.dispose=b;c.call(this,a)};s.prototype=new c;var h=function(a){this.getSource=function(){return a}};h.prototype=new c;h.prototype.any=function(a){return a==b?this.getSource().length>0:c.prototype.any.apply(this,arguments)};h.prototype.count=function(a){return a==b?this.getSource().length:c.prototype.count.apply(this,arguments)};h.prototype.elementAt=function(a){var b=this.getSource();return 0<=a&&a<b.length?b[a]:c.prototype.elementAt.apply(this,arguments)};h.prototype.elementAtOrDefault=function(c,a){if(a===j)a=b;var d=this.getSource();return 0<=c&&c<d.length?d[c]:a};h.prototype.first=function(d){var a=this.getSource();return d==b&&a.length>0?a[0]:c.prototype.first.apply(this,arguments)};h.prototype.firstOrDefault=function(e,a){if(a===j)a=b;if(e!=b)return c.prototype.firstOrDefault.apply(this,arguments);var d=this.getSource();return d.length>0?d[0]:a};h.prototype.last=function(d){var a=this.getSource();return d==b&&a.length>0?a[a.length-1]:c.prototype.last.apply(this,arguments)};h.prototype.lastOrDefault=function(e,a){if(a===j)a=b;if(e!=b)return c.prototype.lastOrDefault.apply(this,arguments);var d=this.getSource();return d.length>0?d[d.length-1]:a};h.prototype.skip=function(d){var b=this.getSource();return new c(function(){var c;return new f(function(){c=d<0?0:d},function(){return c<b.length?this.yieldReturn(b[c++]):a},g.Blank)})};h.prototype.takeExceptLast=function(a){if(a==b)a=1;return this.take(this.getSource().length-a)};h.prototype.takeFromLast=function(a){return this.skip(this.getSource().length-a)};h.prototype.reverse=function(){var b=this.getSource();return new c(function(){var c;return new f(function(){c=b.length},function(){return c>0?this.yieldReturn(b[--c]):a},g.Blank)})};h.prototype.sequenceEqual=function(d,e){return(d instanceof h||d instanceof Array)&&e==b&&c.from(d).count()!=this.count()?a:c.prototype.sequenceEqual.apply(this,arguments)};h.prototype.toJoinedString=function(a,e){var d=this.getSource();if(e!=b||!(d instanceof Array))return c.prototype.toJoinedString.apply(this,arguments);if(a==b)a="";return d.join(a)};h.prototype.getEnumerator=function(){var a=this.getSource(),b=-1;return{current:function(){return a[b]},moveNext:function(){return++b<a.length},dispose:g.Blank}};var n=function(b,a){this.prevSource=b;this.prevPredicate=a};n.prototype=new c;n.prototype.where=function(a){a=d.createLambda(a);if(a.length<=1){var e=this.prevPredicate,b=function(b){return e(b)&&a(b)};return new n(this.prevSource,b)}else return c.prototype.where.call(this,a)};n.prototype.select=function(a){a=d.createLambda(a);return a.length<=1?new m(this.prevSource,this.prevPredicate,a):c.prototype.select.call(this,a)};n.prototype.getEnumerator=function(){var c=this.prevPredicate,e=this.prevSource,b;return new f(function(){b=e.getEnumerator()},function(){while(b.moveNext())if(c(b.current()))return this.yieldReturn(b.current());return a},function(){d.dispose(b)})};var m=function(c,a,b){this.prevSource=c;this.prevPredicate=a;this.prevSelector=b};m.prototype=new c;m.prototype.where=function(a){a=d.createLambda(a);return a.length<=1?new n(this,a):c.prototype.where.call(this,a)};m.prototype.select=function(a){var b=this;a=d.createLambda(a);if(a.length<=1){var f=b.prevSelector,e=function(b){return a(f(b))};return new m(b.prevSource,b.prevPredicate,e)}else return c.prototype.select.call(b,a)};m.prototype.getEnumerator=function(){var e=this.prevPredicate,g=this.prevSelector,h=this.prevSource,c;return new f(function(){c=h.getEnumerator()},function(){while(c.moveNext())if(e==b||e(c.current()))return this.yieldReturn(g(c.current()));return a},function(){d.dispose(c)})};var r=function(){var d=function(a,b){return Object.prototype.hasOwnProperty.call(a,b)},h=function(a){return a===b?"null":a===j?"undefined":typeof a.toString===i.Function?a.toString():Object.prototype.toString.call(a)},m=function(d,c){var a=this;a.key=d;a.value=c;a.prev=b;a.next=b},k=function(){this.first=b;this.last=b};k.prototype={addLast:function(c){var a=this;if(a.last!=b){a.last.next=c;c.prev=a.last;a.last=c}else a.first=a.last=c},replace:function(c,a){if(c.prev!=b){c.prev.next=a;a.prev=c.prev}else this.first=a;if(c.next!=b){c.next.prev=a;a.next=c.next}else this.last=a},remove:function(a){if(a.prev!=b)a.prev.next=a.next;else this.first=a.next;if(a.next!=b)a.next.prev=a.prev;else this.last=a.prev}};var l=function(c){var a=this;a.countField=0;a.entryList=new k;a.buckets={};a.compareSelector=c==b?g.Identity:c};l.prototype={add:function(i,j){var a=this,g=a.compareSelector(i),f=h(g),c=new m(i,j);if(d(a.buckets,f)){for(var b=a.buckets[f],e=0;e<b.length;e++)if(a.compareSelector(b[e].key)===g){a.entryList.replace(b[e],c);b[e]=c;return}b.push(c)}else a.buckets[f]=[c];a.countField++;a.entryList.addLast(c)},"get":function(i){var a=this,c=a.compareSelector(i),g=h(c);if(!d(a.buckets,g))return j;for(var e=a.buckets[g],b=0;b<e.length;b++){var f=e[b];if(a.compareSelector(f.key)===c)return f.value}return j},"set":function(k,l){var b=this,g=b.compareSelector(k),j=h(g);if(d(b.buckets,j))for(var f=b.buckets[j],c=0;c<f.length;c++)if(b.compareSelector(f[c].key)===g){var i=new m(k,l);b.entryList.replace(f[c],i);f[c]=i;return e}return a},contains:function(j){var b=this,f=b.compareSelector(j),i=h(f);if(!d(b.buckets,i))return a;for(var g=b.buckets[i],c=0;c<g.length;c++)if(b.compareSelector(g[c].key)===f)return e;return a},clear:function(){this.countField=0;this.buckets={};this.entryList=new k},remove:function(g){var a=this,f=a.compareSelector(g),e=h(f);if(!d(a.buckets,e))return;for(var b=a.buckets[e],c=0;c<b.length;c++)if(a.compareSelector(b[c].key)===f){a.entryList.remove(b[c]);b.splice(c,1);if(b.length==0)delete a.buckets[e];a.countField--;return}},count:function(){return this.countField},toEnumerable:function(){var d=this;return new c(function(){var c;return new f(function(){c=d.entryList.first},function(){if(c!=b){var d={key:c.key,value:c.value};c=c.next;return this.yieldReturn(d)}return a},g.Blank)})}};return l}(),v=function(a){var b=this;b.count=function(){return a.count()};b.get=function(b){return c.from(a.get(b))};b.contains=function(b){return a.contains(b)};b.toEnumerable=function(){return a.toEnumerable().select(function(a){return new t(a.key,a.value)})}},t=function(b,a){this.key=function(){return b};h.call(this,a)};t.prototype=new h;if(typeof define===i.Function&&define.amd)define("linqjs",[],function(){return c});else if(typeof module!==i.Undefined&&module.exports)module.exports=c;else w.Enumerable=c})(this)
'use strict';
angular.module("ngLocale", [], ["$provide", function($provide) {
  var PLURAL_CATEGORY = {ZERO: "zero", ONE: "one", TWO: "two", FEW: "few", MANY: "many", OTHER: "other"};
  $provide.value("$locale", {
    "DATETIME_FORMATS": {
      "AMPMS": [
        "AM",
        "PM"
      ],
      "DAY": [
        "domingo",
        "segunda-feira",
        "ter\u00e7a-feira",
        "quarta-feira",
        "quinta-feira",
        "sexta-feira",
        "s\u00e1bado"
      ],
      "ERANAMES": [
        "antes de Cristo",
        "depois de Cristo"
      ],
      "ERAS": [
        "a.C.",
        "d.C."
      ],
      "FIRSTDAYOFWEEK": 6,
      "MONTH": [
        "janeiro",
        "fevereiro",
        "mar\u00e7o",
        "abril",
        "maio",
        "junho",
        "julho",
        "agosto",
        "setembro",
        "outubro",
        "novembro",
        "dezembro"
      ],
      "SHORTDAY": [
        "dom",
        "seg",
        "ter",
        "qua",
        "qui",
        "sex",
        "s\u00e1b"
      ],
      "SHORTMONTH": [
        "jan",
        "fev",
        "mar",
        "abr",
        "mai",
        "jun",
        "jul",
        "ago",
        "set",
        "out",
        "nov",
        "dez"
      ],
      "STANDALONEMONTH": [
        "janeiro",
        "fevereiro",
        "mar\u00e7o",
        "abril",
        "maio",
        "junho",
        "julho",
        "agosto",
        "setembro",
        "outubro",
        "novembro",
        "dezembro"
      ],
      "WEEKENDRANGE": [
        5,
        6
      ],
      "fullDate": "EEEE, d 'de' MMMM 'de' y",
      "longDate": "d 'de' MMMM 'de' y",
      "medium": "d 'de' MMM 'de' y HH:mm:ss",
      "mediumDate": "d 'de' MMM 'de' y",
      "mediumTime": "HH:mm:ss",
      "short": "dd/MM/yy HH:mm",
      "shortDate": "dd/MM/yy",
      "shortTime": "HH:mm"
    },
    "NUMBER_FORMATS": {
      "CURRENCY_SYM": "R$",
      "DECIMAL_SEP": ",",
      "GROUP_SEP": ".",
      "PATTERNS": [
        {
          "gSize": 3,
          "lgSize": 3,
          "maxFrac": 3,
          "minFrac": 0,
          "minInt": 1,
          "negPre": "-",
          "negSuf": "",
          "posPre": "",
          "posSuf": ""
        },
        {
          "gSize": 3,
          "lgSize": 3,
          "maxFrac": 2,
          "minFrac": 2,
          "minInt": 1,
          "negPre": "-\u00a4",
          "negSuf": "",
          "posPre": "\u00a4",
          "posSuf": ""
        }
      ]
    },
    "id": "pt-br",
    "localeID": "pt_BR",
    "pluralCat": function(n, opt_precision) {  if (n >= 0 && n <= 2 && n != 2) {    return PLURAL_CATEGORY.ONE;  }  return PLURAL_CATEGORY.OTHER;}
  });
}]);

(function() {
  'use strict';
  angular.module('ticket.helper', ['ticket.helper.controleregiao', 'ticket.helper.fields']);
})();
(function() {
  'use strict';
  angular.module("app.directive", ['ngSanitize']);
})();
(function () {
  angular.module('app.directive')
    .directive('readMore', function () {
      return {
        restrict: 'A',
        transclude: true,
        replace: true,
        template: '<p></p>',
        scope: {
          moreText: '@',
          lessText: '@',
          words: '@',
          ellipsis: '@',
          char: '@',
          limit: '@',
          content: '@'
        },
        link: function (scope, elem, attr, ctrl, transclude) {
          var moreText = angular.isUndefined(scope.moreText) ? ' <a class="read-more">Ver mais</a>' : ' <a class="read-more">' + scope.moreText + '</a>',
            lessText = angular.isUndefined(scope.lessText) ? ' <a class="read-less">Ocultar</a>' : ' <a class="read-less">' + scope.lessText + '</a>',
            ellipsis = angular.isUndefined(scope.ellipsis) ? '' : scope.ellipsis,
            limit = angular.isUndefined(scope.limit) ? 80 : scope.limit;

          attr.$observe('content', function (str) {
            readmore(str);
          });

          transclude(scope.$parent, function (clone, scope) {
            readmore(clone.text().trim());
          });

          function readmore(text) {

            var text = text,
              orig = text,
              regex = /\s+/gi,
              charCount = text.length,
              wordCount = text.trim().replace(regex, ' ').split(' ').length,
              countBy = 'char',
              count = charCount,
              foundWords = [],
              markup = text,
              more = '';

            if (!angular.isUndefined(attr.words)) {
              countBy = 'words';
              count = wordCount;
            }

            if (countBy === 'words') { // Count words

              foundWords = text.split(/\s+/);

              if (foundWords.length > limit) {
                text = foundWords.slice(0, limit).join(' ') + ellipsis;
                more = foundWords.slice(limit, count).join(' ');
                markup = text + moreText + '<span class="more-text">' + more + lessText + '</span>';
              }

            } else { // Count characters

              if (count > limit) {
                text = orig.slice(0, limit) + ellipsis;
                more = orig.slice(limit, count);
                markup = text + moreText + '<span class="more-text">' + more + lessText + '</span>';
              }

            }

            elem.append(markup);

            elem.find('.read-more').show();
            elem.find('.more-text').hide().removeClass('show');
            
            elem.find('.read-more').on('click', function () {
              $(this).hide();
              elem.find('.more-text').addClass('show').slideDown();
            });
            elem.find('.read-less').on('click', function () {
              elem.find('.read-more').show();
              elem.find('.more-text').hide().removeClass('show');
            });

          }
        }
      };
    });
})();
(function() {

  //TIPOS DE INPUTS

  /*

  1 - select
   options -  Array (Utilizado para fazer o bind)
   valueField - Usado quando o identificar for diferente de "Id"
   textField -  Usado quando o texto for diferente de "Nome"

  2 - number
   number|{int} - Total de casas decimais. (Default = "0")
   maxlength={int} - Quantidade máxima de caracteres que o usuário poderá digitar.



    */

  angular.module("app.directive")
    .directive('ngField', ['$compile', function($compile) {

      function getTemplate(scope, elm) {
        var engines = {
          date: 'uib-datepicker-popup="dd/MM/yyyy" ',
          cpf: ' ng-cpf ',
          cnpj: ' ng-cnpj ',
          cep: 'ng-cep',
          text: ''
        };
        var masks = {
          cpf: '999.999.999-99',
          cnpj: '99.999.999/9999-99',
          cep: '99.999-999'
        };
        var patterns = {
          email: '/^[a-z]+[a-z0-9._]+@[a-z]+\.[a-z.]{2,}$/'
        };

        var required = (scope.required) ? ' ng-required="true" ' : '';

        var pattern = (patterns[scope.type]) ? ' ng-pattern="' + patterns[scope.type] + '" ' : "";

        var $frm = elm.closest('form');
        scope.form = ($frm.length == 0 || $frm.attr("name") == "" || $frm.attr("name") == null) ? 'frm' : $frm.attr("name");
        scope.name = scope.name || "txt_" + elm.index();

        var flagPopup = scope.name + '_popup';

        scope.valueField = scope.valueField || 'Id';
        scope.textField = scope.textField || 'Nome';
        var diretiveDisabled =  ' ng-disabled="ngDisabled" ';

        var maxlength = scope.maxlength != null ? ' maxlength="{{maxlength}}"' : '';
        scope.ngDisabled = scope.ngDisabled || false;

        var rows = scope.rows != null ? 'rows= {{rows}}' : 'rows=4';

        var htmlTooltip = scope.tooltip != null ? '<span class="input-group-addon btn btn-primary" style="border-color:#ccc; background-color:white!important" popover-placement="auto top"  uib-popover="{{tooltip}}" popover-trigger="mouseenter"><i class="fa fa-question-circle" style="color:black" aria-hidden="true"></i></span>' : '';

        var res = '';

        if ($frm.length == 0) {
          res += '    <span class="help-block">Elemento de formulário não encontrado.</span>';
        } else {
          res =
            '<ng-form name={{form}}>' +
            ' <div class="form-group form-group-sm ">' +
            '    <h4 class="text-bold text-left">{{label}}</h4>' +
            '    <div ng-class="{\'has-success\':(' + scope.form + '.' + scope.name + '.$valid && !' + scope.form + '.' + scope.name + '.$pending && !loading), \'has-error\':(!' + scope.form + '.' + scope.name + '.$valid && !' + scope.form + '.' + scope.name + '.$pending && !loading) }">';

          if (scope.type == 'select') {
            res += (scope.tooltip != null ? '<div class="input-group">' : '<div class="form-group">') +
              '      <select ' + diretiveDisabled + ' class="form-control" aria-label="{{label}}" ' + maxlength + ' ng-model="model" name="' + scope.name + '" ' + required + '  validate-async="validateAsync" ng-field-validator  >' +
              '<option></option>' +
              '        <option ng-repeat="o in options" value="{{o.' + scope.valueField + '}}">{{o.' + scope.textField + '}}</option>' +
              '      </select>' +
              htmlTooltip +
              '</div>';
          } else if (scope.type == 'date') {
            scope.dateOptions = {
              minDate: scope.minDate,
              'class': 'datepicker'
            };
            res += '<div class="input-group">' +
              '<input ' + diretiveDisabled + ' type="text" class="form-control" aria-label="{{label}}" ng-model="model" name="' + scope.name + '" ' + required + ' uib-datepicker-popup="dd/MM/yyyy" show-button-bar="false" datepicker-options="dateOptions" is-open="' + flagPopup + '" />' +
              '<span class="input-group-btn">' +
              '<button type="button" class="btn btn-sm btn-primary" ng-click="' + flagPopup + '=true;">' +
              '<i class="glyphicon glyphicon-calendar"></i>' +
              '</button>' +
              '</span>' +
              htmlTooltip +
              '</div>';
          } else if (scope.type == 'time') {

            res += (scope.tooltip != null ? '<div class="input-group">' : '<div class="form-group">') +
              '<input ' + diretiveDisabled + ' type="text" ui-time-mask="short" class="form-control" aria-label="{{label}}" ' + maxlength + ' ' + format + ' ng-model="model" name="' + scope.name + '" ' + required + pattern + '  validate-async="validateAsync" ng-field-validator  />' +
              htmlTooltip +
              '</div>';
          } else if (scope.type == 'phone') {

            res += (scope.tooltip != null ? '<div class="input-group">' : '<div class="form-group">') +
              '<input ' + diretiveDisabled + ' type="text" ui-br-phone-number class="form-control" aria-label="{{label}}" ' + maxlength + ' ' + format + ' ng-model="model" name="' + scope.name + '" ' + required + pattern + '  validate-async="validateAsync" ng-field-validator  />' +
              htmlTooltip +
              '</div>';
          } else if (scope.type == 'password') {
            res += '      <input ' + diretiveDisabled + ' type="password" class="form-control" aria-label="{{label}}" ' + maxlength + ' ng-model="model" name="' + scope.name + '" ' + required + pattern + '  validate-async="validateAsync" ng-field-validator  />';
          } else if (scope.type == 'textarea') {
            res += (scope.tooltip != null ? '<div class="input-group">' : '<div class="form-group">') +
              '<textarea ' + rows + ' ' + diretiveDisabled + 'name="' + scope.name + '" class="form-control" ng-model="model"' + maxlength + required + ' style="resize:none"></textarea>' +
              htmlTooltip +
              '</div>';
          } else {
            var format = "";

            if (scope.type != null) {
              var arr = scope.type.split('|');

              if (arr[0] == "number") {
                format = (arr.length == 1) ? "ui-hide-group-sep ui-number-mask='0'" : "ui-hide-group-sep ui-number-mask='" + arr[1] + "'"
              } else if (arr[0] == "cpf")
                format = "ui-br-cpf-mask";
              else if (arr[0] == "percentual")
                format = (arr.length == 1) ? "ui-percentage-mask" : "ui-percentage-mask='" + arr[1] + "'"
              else if (arr[0] == "money")
                format = (arr.length == 1) ? "ui-money-mask" : "ui-money-mask='" + arr[1] + "'"
            }

            res += (scope.tooltip != null ? '<div class="input-group">' : '<div class="form-group">') +
              '<input ' + diretiveDisabled + ' type="text" class="form-control" aria-label="{{label}}" ' + maxlength + ' ' + format + ' ng-model="model"  name="' + scope.name + '" ' + required + pattern + '  validate-async="validateAsync" ng-field-validator  />' +
              htmlTooltip +
              '</div>';
          }

          if (scope.validateSubmit === undefined) {

            res += '    </div>' +
              '    <span class="help-block" ng-show="' + scope.form + '.' + scope.name + '.$error.required">Preenchimento obrigatório</span>' +
              '    <span class="help-block" ng-show="' + scope.name + '.$error.pattern">Formato inválido</span>' +
              '    <span class="help-block" ng-show="' + scope.name + '.$error.custom">{{validateAsyncError}}</span>' +
              ' </div> ' +
              '</ng-form>';
          } else {
            res += '    </div>' +
              '    <span class="help-block" ng-show="validateSubmit  && ' + scope.form + '.' + scope.name + '.$error.required">Preenchimento obrigatório</span>' +
              '    <span class="help-block" ng-show="validateSubmit  && ' + scope.name + '.$error.pattern">Formato inválido</span>' +
              '    <span class="help-block" ng-show="validateSubmit  && ' + scope.name + '.$error.custom">{{validateAsyncError}}</span>' +
              ' </div> ' +
              '</ng-form>';
          }


        }

        return res;
      }

      return {
        restrict: 'E',
        //label - título do campo, form: nome do form que o campo pertence, name: nome usado pelo js, model: model :), type: email, cpf, data, etc., required : obrigatoriedade, mask: máscara de formatação (type costuma ter sua formatação implicita), validate: função que recebe o valor e evento do campo e retorna bool que será aplicado na validação, validateAsync: retorna um promise onde function(modelValue, viewValue) {return $http.post(url)}
        scope: {
          changed: '=?',
          label: '@label',
          name: '@name',
          model: '=?',
          ngDisabled: "=?",
          maxlength: "=",
          tooltip: "@tooltip",
          rows: '=',
          type: '@type',
          required: '@',
          mask: '@mask',
          validate: '=?',
          validateAsync: '=?',
          validateAsyncError: '@',
          loading: '=',
          pattern: '@',
          size: '@',
          options: '=',
          valueField: '@',
          textField: '@',
          options: '=',
          valueField: '@',
          textField: '@',
          maskPercentual: '@',
          minDate: '=',
          validateSubmit: '=?'
        },
        link: function(scope, elm, attrs) {

          var htm = getTemplate(scope, elm);
          elm.html(htm).show();
          $compile(elm.contents())(scope);


          scope.$watch('model', function() {
            if (scope.type == 'date' && typeof(scope.model) === "string")
              scope.model = new Date(scope.model);
            else if (scope.type == 'select' && typeof(scope.model) != "string" && scope.model !== undefined && scope.model != null)
              scope.model = scope.model.toString();

            if(scope.changed && scope.changed())
            {
              scope.changed()();
            }

          });
        }
      };
    }])

  .directive('ngFieldValidator', ['$compile', function($compile) {
    return {
      restrict: 'A',
      require: 'ngModel',
      scope: {
        validate: '&',
        validateAsync: '=?'
      },
      link: function(scope, elm, attrs, ngModel) {
        if (ngModel && scope.validateAsync)
          ngModel.$asyncValidators.custom = scope.validateAsync;
      }
    };
  }]);

})();
(function () {
angular.module("app.directive")
  .directive('ngEnter', function () {
    return function (scope, element, attrs) {
      element.bind("keydown keypress", function (event) {
        if (event.which === 13) {
          scope.$apply(function () {
            scope.$eval(attrs.ngEnter);
          });
          event.preventDefault();
        }
      });
    };
  });
})
();

(function() {
  angular.module("app.directive")
    .directive('ngSvg', [function() {
      return {
        restrict: 'E',
        scope: {
          content: '=',
          loaded: '&',
          'class': '@',
          width: '@',
          height: '@',
          mouseover: '&'
        },
        link: function(scope, elm, attrs) {

          var chgSize = function($svg) {
            if (scope.width && scope.width != '')
              $svg.attr('width', scope.width);

            if (scope.height && scope.height != '')
              $svg.attr('height', scope.height);
          }


          scope.$watch("content", function() {
            elm.html('');
            if (scope.content) {
              
              if(scope.content.indexOf("<svg") != 0)
                scope.content = "<svg>" + scope.content + "</svg>";

              elm.html(scope.content);
              elm.attr('ng-mouseover', scope.mouseover);
              if (scope.loaded())
                scope.loaded()(elm.find('svg'));

              chgSize(elm.find('svg'));
            }

          });
          scope.$watch("width", function() {
            chgSize(elm.find('svg'));
          });
          scope.$watch("height", function() {
            chgSize(elm.find('svg'));
          });
        }
      };

    }])
    .directive('svgLoading', [function() {
      return {
        restrict: 'E',
        template: '<svg width="20px" height="20px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid" class="uil-ring svg-purple-color"><rect x="0" y="0" width="100" height="100" fill="none" class="bk"></rect><circle cx="50" cy="50" r="40" stroke-dasharray="163.36281798666926 87.9645943005142" stroke="#d25353" fill="none" stroke-width="20"><animateTransform attributeName="transform" type="rotate" values="0 50 50;180 50 50;360 50 50;" keyTimes="0;0.5;1" dur="1s" repeatCount="indefinite" begin="0s"></animateTransform></circle></svg>'
      };
    }]);

})();
(function() {

  angular
    .module("app.directive")

    .directive('ngVbox', [
      function () {
        return {
          restrict : 'A',
          link: function (scope, element, attributes) {
            attributes.$observe('ngVbox', function(value) {
              //element.attr('ngVbox', value);
              element[0].setAttributeNS(null, 'viewBox', value);
            });
          },
        };
      }
    ])
    .directive('mapaassento', ['$rootScope', '$compile', '$sce', function($rootScope, $compile, $sce) {
      var newIdAssento = -1;


      return {
        restrict : 'A',
        scope: {
          defaultColor: '@',
          selectedColor: '@',
          realWidth: '=',
          realHeight: '=',
          objetos:'=',
          setores: '=',
          assentos:'=',
          blockeds: '=?',
          mapname: '@',
          selecionados: '=?',
          tiposAssento: '=',
          item2add:'=',
          ngViewbox: '=',
          hAlignLeft:'=?',
          hAlignCenter: '=?',
          hAlignRight: '=?',
          vAlignTop: '=?',
          vAlignMiddle: '=?',
          vAlignBottom: '=?',
          vDistribute: '=?',
          clone: '=?',
          hDistribute: '=?',
          rename:'=?',
          internetToggle: '=?',
          release: '=?',
          readOnly: '=',
          validate:'=?',
          textField:'=?'
        },
        link: function(scope, element, attrs){


          scope.selecionados  = scope.selecionados || [];
          scope.defaultColor  = scope.defaultColor || '#c9c9c9';
          scope.selectedColor = scope.selectedColor || '#FF0000';
          scope.textField     = scope.textField || 'Rotulo'

          var svg = element[0].childNodes[0];
          var pt = svg.createSVGPoint();

          var svgns = "http://www.w3.org/2000/svg";
          var rect = null;

          function selectBySquare(sel, dlg)
          {
               if( Math.abs((sel.xFim-sel.xIni) * (sel.yFim-sel.yIni)) > 100 )//DEFININDO AREA MINIMA PARA PESQUISA em 100 pixels quadrado.
               {
                   $(svg).find("g[class='action'] svg").each(function(i){
                      var a = $(this);
                      var w = Number(a.attr("width"));
                      var h = Number(a.attr("height"));
                      var x = Number(a.attr("x"));
                      var y = Number(a.attr("y"));

                      var pct = 0.4;//40% da área do container do círculo é selecionável
                      var btn = {
                                xIni : x + (w/2) - (w*pct/2), xFim: x + (w/2) + (w*pct/2),
                                yIni:  y + (h/2) - (h*pct/2), yFim: y + (h/2) + (h*pct/2)
                              };
                      if(
                          (btn.xIni >= sel.xIni && btn.xIni <= sel.xFim && btn.yIni >= sel.yIni && btn.yIni <= sel.yFim) ||
                          (btn.xFim >= sel.xIni && btn.xFim <= sel.xFim && btn.yFim >= sel.yIni && btn.yFim <= sel.yFim)
                        )
                      {
                        dlg(a);// a.click();
                      }
                   });
               }
          }

          scope.validate = function(){

            //Zera todos os mapas
            scope.assentos.forEach(function(a){
              a.tmpMapaAssento = a.IdMapaAssento;
              a.IdMapaAssento = null;
            });

            scope.setores.forEach(function(s){


               var $sector = $(svg).find('#se_' + s.Id );

               var sqr = $sector[0].getBoundingClientRect();

                s.LarguraSvg      = sqr.width  * (scope.realWidth * 50) / $('#aro')[0].getBoundingClientRect().width ;
                s.ComprimentoSvg  = sqr.height  * (scope.realHeight * 50)  / $('#aro')[0].getBoundingClientRect().height ;

                s.LarguraReal     = s.LarguraSvg/scope.avg.width;
                s.ComprimentoReal = s.ComprimentoSvg/scope.avg.height;


                s.PosicaoMapaAssentoX = s.PosicaoLayoutX/scope.avg.width;
                s.PosicaoMapaAssentoY = s.PosicaoLayoutY/scope.avg.height;
                s.changed = true;

               $(svg).find("g[class='action'] svg").each(function(i){
                  var a = $(this);
                  var aPos = this.getBoundingClientRect();

                  if(aPos.x >= sqr.x && aPos.x <= (sqr.x + sqr.width ) && aPos.y >= sqr.y && aPos.y <= ( sqr.y + sqr.height ))
                  {
                     var id = a.data("assento");
                    var arr = scope.assentos.filter(function(itm){ return itm.IdAssento == id });
                    if(arr.length==1)
                      arr[0].IdMapaAssento = s.IdMapa;
                  }
               });
            });

            scope.assentos.forEach(function(a){
              if(a.tmpMapaAssento != a.IdMapaAssento)
                a.changed = true;
              a.tmpMapaAssento = null;
            });

            scope.objetos.forEach(function(o){


               var $objeto = $(svg).find('#ob_' + o.Id );

               var sqr = $objeto[0].getBoundingClientRect();

                o.LarguraSvg      = sqr.width * (scope.dataSVG.width / (scope.avg.width * 20));
                o.ComprimentoSvg  = sqr.height * (scope.dataSVG.height / (scope.avg.height * 20));

                o.LarguraReal     = o.LarguraSvg/scope.avg.width;
                o.ComprimentoReal = o.ComprimentoSvg/scope.avg.height;

                o.PosicaoMapaAssentoX = o.PosicaoLayoutX/scope.avg.width;
                o.PosicaoMapaAssentoY = o.PosicaoLayoutY/scope.avg.height;
            });


            return scope.assentos.filter(function(a){ return a.IdMapaAssento == null && a.Status == 'A'; }).length;
          }

          $(svg).bind("DOMMouseScroll mousewheel onmousewheel", function(event) {
            var _evt = window.event || event; // old IE support
            pt.x = _evt.clientX;
            pt.y = _evt.clientY;

            var mp = pt.matrixTransform(svg.getScreenCTM().inverse());

            var delta = (_evt.wheelDelta || -_evt.detail);

            scope.$apply(function(){ scope.zoom(delta, mp); });

            // for IE
            event.returnValue = false;
            // for Chrome and Firefox
            if(event.preventDefault)
                event.preventDefault();
          });



          function selectArea(_evt)
           {

                pt.x = _evt.clientX;
                pt.y = _evt.clientY;
                var mtIni = pt.matrixTransform(svg.getScreenCTM().inverse());

                if(rect!=null)
                {
                   svg.removeChild(rect);
                   rect = null;
                }

                rect = document.createElementNS(svgns, 'rect');
                rect.setAttributeNS(null, 'x', mtIni.x);
                rect.setAttributeNS(null, 'y', mtIni.y);
                rect.setAttributeNS(null, 'height', '0');
                rect.setAttributeNS(null, 'width', '0');
                rect.setAttributeNS(null, 'fill', (scope.item2add) ? scope.selectedColor : '#0000ff');
                rect.setAttributeNS(null, 'fill-opacity', "0.25");
                rect.setAttributeNS(null, 'stroke',(scope.item2add) ?'#ff9999' : '#9999ff');
                rect.setAttributeNS(null, 'stroke-width', 2);
                svg.appendChild(rect);

                svg.style.cursor = 'all-scroll';

                $(window).mouseup(function(){

                    svg.style.cursor = 'inherit';
                    var sel =
                    {
                       xIni : Number(rect.getAttributeNS(null, 'x')),
                       yIni : Number(rect.getAttributeNS(null, 'y'))
                    };

                    sel.xFim = sel.xIni + Number(rect.getAttributeNS(null, 'width'));
                    sel.yFim = sel.yIni + Number(rect.getAttributeNS(null, 'height'));

                    if(scope.item2add)
                    {
                      scope.$apply(function(){
                          var posY = sel.yIni;

                          while(posY <= sel.yFim)
                          {
                            var posX = sel.xIni;

                            while(posX<= sel.xFim)
                            {
                              var a = {
                                IdAssento: newIdAssento--,
                                PosicaoX: (posX/scope.avg.width) + (scope.item2add.LarguraReal/2),
                                PosicaoY: (posY/scope.avg.height) + (scope.item2add.ComprimentoReal/2),
                                changed: true,
                                Rotulo: 'XX',
                                Status: 'A',
                                cor: scope.selectedColor,
                                IdTipoAssento: scope.item2add.IdTipoAssento,
                                tipo: scope.item2add
                                //"tipo":{"Arquivo":"<circle cx=\"100\" cy=\"100\" r=\"70\" stroke-width=\"0\" />","ComprimentoReal":0.5,"ComprimentoSvg":200,"LarguraReal":0.5,"LarguraSvg":200,"Nome":"Circulo","IdTipoAssento":3,"$$hashKey":"object:154"}
                              };

                              scope.assentos.push(a);
                              scope.selecionados.push(a);


                              posX+=scope.item2add.LarguraReal * scope.avg.width;;

                            }

                            posY+= scope.item2add.ComprimentoReal * scope.avg.height;

                          }
                      });

                    }
                    else
                    {
                       selectBySquare(sel, function(a){ a.click(); });
                    }


                     svg.removeChild(rect);
                     rect = null;
                     $(window).off("mouseup");
                     element.off("mousemove");
                });

                element.mousemove(function(_evt)
                {
                  pt.x = _evt.clientX;
                  pt.y = _evt.clientY;
                  var mtFim = pt.matrixTransform(svg.getScreenCTM().inverse());

                  if( mtFim.x > mtIni.x )
                  {
                    rect.setAttributeNS(null, 'x', mtIni.x );
                    rect.setAttributeNS(null, 'width',  mtFim.x - mtIni.x );
                  }
                  else
                  {
                    rect.setAttributeNS(null, 'x', mtFim.x );
                    rect.setAttributeNS(null, 'width', mtIni.x - mtFim.x );
                  }

                  if( mtFim.y > mtIni.y )
                  {
                    rect.setAttributeNS(null, 'y', mtIni.y );
                    rect.setAttributeNS(null, 'height',  mtFim.y - mtIni.y );
                  }
                  else
                  {
                    rect.setAttributeNS(null, 'y', mtFim.y );
                    rect.setAttributeNS(null, 'height', mtIni.y - mtFim.y );
                  }
                })
           }

          element.mousedown(function(evt){
             selectArea(evt);
          });

          element.find(".action svg").bind("mousedown", function(){
             var a = $(this);
             scope.$apply(function(){
                var id = $(this).data("assento");
                scope.sel(scope.assentos.filter(function(itm){ return itm.IdAssento == id })[0]);
             });
          })

          //CHAMADO EM NIVEL DE DOM
          function move(x, y)
          {
              scope.$apply(function(){scope.move(x,y);});
              return false;
          }

          function remove()
          {
              scope.$apply(function(){

                var arrNews = scope.selecionados.filter(function(itm){ return itm.IdAssento <=0  });
                var arrOlds = scope.selecionados.filter(function(itm){ return itm.IdAssento > 0 });

                arrOlds.forEach(function (itm) {
                    itm.changed = true;
                    itm.Status = (itm.Status == 'C') ? 'A' : 'C';
                    itm.cor = (itm.Status == 'A') ? scope.selectedColor : '#FFDD99' ; //'#FFDD99' : '#c9c9c9'
                    scope.selecionados.splice(scope.selecionados.indexOf(itm), 1);
                });

                arrNews.forEach(function (itm) {
                    scope.assentos.splice(scope.assentos.indexOf(itm), 1);
                    scope.selecionados.splice(scope.selecionados.indexOf(itm), 1);
                });
              });

              return false;
          }


          $(window).keydown(function(_evt){
              if (scope.selecionados.length>0 && !scope.readOnly)
              {

                  var step = (_evt.shiftKey) ? 0.1 : 0.01;

                  switch (_evt.key) {
                      case "ArrowDown":
                          return move(0, step);
                      case "ArrowUp":
                          return move(0, -step);
                      case "ArrowRight":
                          return move(step, 0);
                      case "ArrowLeft":
                          return move(-step, 0);
                      case "Delete":
                          return remove();
                      case "Escape":
                          return scope.$apply(scope.release());
                  }
              }
          });

        },
        controller: ["$scope","$uibModal", function($scope, $uibModal){
             var vm = this;
             vm.x = 0;
             vm.y = 0;

             vm.width = 20;       //metros
             vm.height = 20;  //metros

             $scope.dataSVG = {  x:0, y: 0, width: 1000, height: 1000 };//pixels

             $scope.selecionados = $scope.selecionados || [];

             $scope.viewBox = ([$scope.dataSVG.x, $scope.dataSVG.y, $scope.dataSVG.width, $scope.dataSVG.height]).join(' ');

             $scope.avg = {width: $scope.dataSVG.width/vm.width, height: $scope.dataSVG.height/vm.height };

             $scope.blockeds = [];

             $rootScope.$on('mapaassento.select', function(e, v){
                if($scope.mapname == v.mapName)
                {
                  var a = $scope.assentos.find(function(itm){ return itm.IdAssento == v.id });
                  $scope.sel(a);
                }
             });

             $rootScope.$on('mapaassento.block', function(e, v){
                if($scope.mapname == v.mapName)
                {
                  var a = $scope.assentos.find(function(itm){ return itm.IdAssento == v.id });
                  var idx = $scope.blockeds.indexOf(a);

                  if(idx == -1)
                  {
                    a.cor = v.color;
                    $scope.blockeds.push( a );
                    if(v.delegate)
                      v.delegate(a, true);
                  }
                  else
                  {
                    a.cor = $scope.defaultColor;
                    $scope.blockeds.splice(idx, 1);
                    if(v.delegate)
                      v.delegate(a, false);
                  }
                }

             });


             $scope.hAlignLeft = function(){
               var enm = Enumerable.from($scope.selecionados);
               $scope.moveTo( enm.min(function(itm){return itm.PosicaoX;}), null );
             }

             $scope.hAlignCenter = function(){
               var enm = Enumerable.from($scope.selecionados);
               $scope.moveTo( (enm.min(function(itm){return itm.PosicaoX;}) + enm.max(function(itm){return itm.PosicaoX;}))/2, null );
             }

             $scope.hAlignRight = function(){
               var enm = Enumerable.from($scope.selecionados);
               $scope.moveTo( enm.max(function(itm){return itm.PosicaoX;}), null );
             }

             $scope.vAlignTop = function(){
               var enm = Enumerable.from($scope.selecionados);
               $scope.moveTo( null, enm.min(function(itm){return itm.PosicaoY;}) );
             }

             $scope.vAlignMiddle = function(){
               var enm = Enumerable.from($scope.selecionados);
               $scope.moveTo( null, (enm.min(function(itm){return itm.PosicaoY;}) + enm.max(function(itm){return itm.PosicaoY;}))/2 );
             }

             $scope.vAlignBottom = function(){
               var enm = Enumerable.from($scope.selecionados);
               $scope.moveTo( null, enm.max(function(itm){return itm.PosicaoY;}) );
             }

             $scope.hDistribute = function(){
               var enm = Enumerable.from($scope.selecionados);
               var ls  = enm.where(function(itm){return itm.Status!= 'C';});
               var min = ls.min(function(itm){return itm.PosicaoX;});
               var max = ls.max(function(itm){return itm.PosicaoX;});

               var step = (max - min)/($scope.selecionados.length-1);

               $scope.selecionados.forEach(function (itm, idx) {
                    if( itm.Status != 'C' )
                    {
                      itm.changed = true;
                      itm.PosicaoX = min + (step * idx);
                    }
                });

             }
             $scope.vDistribute = function(){
               var enm = Enumerable.from($scope.selecionados);
               var ls  = enm.where(function(itm){return itm.Status!= 'C';});
               var min = ls.min(function(itm){return itm.PosicaoY;});
               var max = ls.max(function(itm){return itm.PosicaoY;});

               var step = (max - min)/($scope.selecionados.length-1);

               $scope.selecionados.forEach(function (itm, idx) {
                    if( itm.Status != 'C' )
                    {
                      itm.changed = true;
                      itm.PosicaoY = min + (step * idx);
                    }
                });

             }




             $scope.clone = function(){

                var ls = [];

                for(var i=0; i<$scope.selecionados.length; i++)
                  ls.push($scope.selecionados[i]);

                for(var i=0; i<ls.length; i++)
                {
                  var c = ls[i];
                  var a = {
                            IdAssento: newIdAssento--,
                            PosicaoX: c.PosicaoX + 0.1,
                            PosicaoY: c.PosicaoY + 0.1,
                            changed: true,
                            Rotulo: 'XX',
                            Status: 'A',
                            cor: $scope.selectedColor,
                            IdTipoAssento: c.IdTipoAssento,
                            tipo: c.tipo
                          };

                  $scope.assentos.push(a);
                  $scope.selecionados.push(a);
                  c.cor = $scope.defaultColor;
                  $scope.selecionados.splice($scope.selecionados.indexOf(c), 1);

                }
             }

             $scope.zoom = function(delta, mp)
              {
                  var pct = 1-(delta/1000);
                  $scope.dataSVG.x = ($scope.dataSVG.x * pct) + (mp.x-mp.x*pct);
                  $scope.dataSVG.y = ($scope.dataSVG.y * pct) + (mp.y-mp.y*pct);
                  $scope.dataSVG.width = $scope.dataSVG.width * pct;
                  $scope.dataSVG.height = $scope.dataSVG.height * pct;

                  $scope.viewBox = ([$scope.dataSVG.x, $scope.dataSVG.y, $scope.dataSVG.width, $scope.dataSVG.height]).join(' ');
              }



             $scope.$watch('assentos', function(){
               if($scope.assentos != null && $scope.assentos.length>0)
               {
                 var $tipos = Enumerable.from($scope.tiposAssento);

                 for(var i=0; i<$scope.assentos.length; i++)
                 {
                    var a = $scope.assentos[i];
                    a.tipo = $tipos.where(function(v){return v.IdTipoAssento == a.IdTipoAssento;} ).first();
                 }
               }
             });




             $scope.move = function(x,y){
                $scope.selecionados.forEach(function (itm) {
                    if( itm.Status != 'C' )
                    {
                      itm.changed = true;
                      itm.PosicaoY += y;
                      itm.PosicaoX += x;
                    }
                });
             }

             $scope.moveTo = function(x,y){
                $scope.selecionados.forEach(function (itm) {
                    if( itm.Status != 'C' )
                    {
                      itm.changed = true;
                      if(y)
                      itm.PosicaoY = y;

                      if(x)
                      itm.PosicaoX = x;
                    }
                });
             }

             $scope.DrawSector = function(id){

             }

             $scope.rename = function(){

               $uibModal.open({
                animation: false,
                template: '<div class="modal-header">' +
                          '   <h3 class="modal-title">{{vm.itm.tit}}</h3>' +
                          '</div>' +
                          '<div class="modal-body">' +
                          '<form>'+
                          ' <div class="grid">' +
                          '  <div class="row">' +
                          '   <div class="col-md-6">' +
                          '    <h3>Descrição</h3>' +
                          '   </div>' +
                          '   <div class="col-md-6">' +
                          '    <h3>Rótulo</h3>' +
                          '   </div>' +
                          '  </div>' +
                          ' <div class="grid">' +
                          '  <div class="row">' +
                          '   <div class="col-md-6">' +
                          '    <ng-field name="PrefixoD" label="Prefixo" model="vm.PrefixoD"></ng-field>' +
                          '    <ng-field name="Valor" label="Valor" model="vm.Valor" maxlength="6"></ng-field>' +
                          '    <ng-field name="SufixoD" label="Sufixo" model="vm.SufixoD" ></ng-field>' +
                          '   </div>' +
                          '   <div class="col-md-6">' +
                          '    <ng-field name="PrefixoR" label="Prefixo" model="vm.PrefixoR" maxlength="6"></ng-field>' +
                          '    <ng-field name="Valor" label="Valor" model="vm.Valor" ng-disabled="true"></ng-field>' +
                          '    <ng-field name="SufixoR" label="Sufixo" model="vm.SufixoR" maxlength="6"></ng-field>' +
                          '   </div>' +
                          '  </div>' +
                          ' </div>' +
                          '</form>' +
                          '</div>'  +
                          '<div class="modal-footer">' +
                          '    <input type="checkbox" ng-model="vm.Intercalar">Intercalar' +
                          '    <input type="checkbox" ng-model="vm.Invertido">Invertido' +
                          '   <button class="btn btn-primary" ng-click="vm.ok();">OK</button>' +
                          '</div>',
                  controller: function($uibModalInstance) {
                    var vm = this;
                    vm.ok = function() {
                      $uibModalInstance.close({prefixoR: vm.PrefixoR, prefixoD: vm.PrefixoD, sufixoR: vm.SufixoR, sufixoD: vm.SufixoD, inicio: vm.Valor, intercalar: vm.Intercalar, invertido: vm.Invertido} );
                    }
                  },
                  controllerAs: 'vm',
                  size: 'sm'
                })
                .result.then(function(mdl){

                       var ls =  Enumerable.from($scope.selecionados);
                       var v = (isNaN(mdl.inicio))? mdl.inicio.charCodeAt(0) : Number(mdl.inicio);

                       ls.forEach(function(itm, idx){
                          mdl.prefixoR  = mdl.prefixoR || '';
                          mdl.sufixoR   = mdl.sufixoR || '';
                          mdl.prefixoD  = mdl.prefixoD || '';
                          mdl.sufixoD   = mdl.sufixoD || '';

                          var s = "000000" + String(v);
                          itm.Rotulo    = mdl.prefixoR + ((isNaN(mdl.inicio))? String.fromCharCode(v) : s.substr(s.length-String(mdl.inicio).length) ) + mdl.sufixoR;
                          itm.Descricao = mdl.prefixoD + ((isNaN(mdl.inicio))? String.fromCharCode(v) : s.substr(s.length-String(mdl.inicio).length) ) + mdl.sufixoD;
                          itm.changed = true;
                          v += (mdl.intercalar) ? ((mdl.invertido)? -2 : 2) : ((mdl.invertido)? -1 : 1) ;
                       });

                });


             }

             $scope.internetToggle = function(flag){
                $scope.selecionados.forEach(function(itm){
                    itm.VendeRemoto = !itm.VendeRemoto;
                    itm.changed = true;
                });



             }

             $scope.release = function(){
               while($scope.selecionados.length>0)
               {
                  $scope.selecionados[0].cor = ($scope.selecionados[0].Status == 'C') ? '#FFDD99' : $scope.defaultColor;
                  $scope.selecionados.splice(0, 1);
               }
               return false;
             }

             vm.resolveUrlTipo  = function(v){ return '#TIPO_' + v; };
             vm.resolveUrlObjeto  = function(v){ return '#OBJETO_' + v; };
             vm.resolveUrlSetor = function(v){ return '#SETOR_' + v; };
             vm.formatHTML      = function (v){return $sce.trustAsHtml(v);}

             $scope.sel = function(a){
              if($scope.blockeds.indexOf(a)<0)
              {
               var idx = $scope.selecionados.indexOf(a);
                if( idx < 0 )
                {
                  $scope.selecionados.push(a);
                  a.cor = (a.Status == 'C') ? '#FF8888' : $scope.selectedColor;
                }
                else
                {
                  $scope.selecionados.splice(idx, 1);
                  a.cor = (a.Status == 'C') ? '#FFDD99' : $scope.defaultColor;
                }
              }
             }

        }],
        controllerAs: 'vm',
        template:'<svg width="100%" height="100%" ng-vbox="{{viewBox}}" version="1.1" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:1.5;" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">'+
                 '<defs>'+
                 '<style>'+
                  '.action svg, .action text'+
                  '{cursor: pointer;}'+
                  '.action:hover .tooltiptext {'+
                  '  visibility: visible;'+
                  '}'+
                  '.noaction .tooltiptext {'+
                  '  visibility: hidden;'+
                  '}'+
                  '.action text,'+
                  '.action text:hover'+
                  '{'+
                    '-webkit-transition: font 0.2s ease;'+
                    '+-moz-transition: font 0.2s ease;'+
                    '-o-transition: font 0.2s ease;'+
                    '-ms-transition: font 0.2s ease;'+
                  '}'+
                  '.action text:hover'+
                  '{'+
                    'font-size: 1.9em;'+
                  '}'+
                  'svg {'+
                      '-webkit-user-select: none;'+
                      '-moz-user-select: none;'+
                      '-ms-user-select: none;'+
                      'user-select: none;'+
                  '}'+
                 '</style>'+
                 '<symbol ng-repeat="o in objetos"      ng-attr-id="OBJETO_{{o.Id}}" ng-bind-html="vm.formatHTML(o.ArquivoSvg)"></symbol>'+
                 '<symbol ng-repeat="s in setores"      ng-attr-id="SETOR_{{s.Id}}" ng-bind-html="vm.formatHTML(s.ArquivoSvg)"></symbol>'+
                 '<symbol ng-repeat="t in tiposAssento" ng-attr-id="TIPO_{{t.IdTipoAssento}}" ng-bind-html="vm.formatHTML(t.Arquivo)"></symbol>'+
                 '<symbol id="alert"><path d="M14.4242327,6.14839275 C15.2942987,4.74072976 16.707028,4.74408442 17.5750205,6.14839275 L28.3601099,23.59738 C29.5216388,25.4765951 28.6755462,27 26.4714068,27 L5.5278464,27 C3.32321557,27 2.47386317,25.4826642 3.63914331,23.59738 Z M16,20 C16.5522847,20 17,19.5469637 17,19.0029699 L17,12.9970301 C17,12.4463856 16.5561352,12 16,12 C15.4477153,12 15,12.4530363 15,12.9970301 L15,19.0029699 C15,19.5536144 15.4438648,20 16,20 Z M16,24 C16.5522848,24 17,23.5522848 17,23 C17,22.4477152 16.5522848,22 16,22 C15.4477152,22 15,22.4477152 15,23 C15,23.5522848 15.4477152,24 16,24 Z M16,24"/></symbol>' +
                 '</defs>'+
                 '<g>'+
                 '  <svg ng-repeat="s in setores" id="se_{{s.Id}}" ng-attr-x="{{s.PosicaoLayoutX}}" ng-attr-y="{{s.PosicaoLayoutY}}" width="2000" height="2000" viewBox="0 0 2000 2000"  fill="#f3f3f3">'+
                 '   <use xlink:href="{{vm.resolveUrlSetor(s.Id)}}" />'+
                 '  </svg>'+
                 '</g>'+
                 '<g>'+
                 '  <svg ng-repeat="o in objetos" id="ob_{{o.Id}}" ng-attr-x="{{o.PosicaoLayoutX}}" ng-attr-y="{{o.PosicaoLayoutY}}" width="2000" height="2000" viewBox="0 0 2000 2000"  fill="{{o.CorPrincipal}}">'+
                 '   <use xlink:href="{{vm.resolveUrlObjeto(o.Id)}}" />'+
                 '  </svg>'+
                 '</g>'+
                 '<g ng-repeat="a in assentos" class="action" font-size="5">'+
                 ' <svg ng-attr-x="{{(a.PosicaoX - (a.tipo.LarguraReal/2)) * avg.width}}" ng-attr-y="{{(a.PosicaoY - (a.tipo.ComprimentoReal/2)) * avg.height}}" ng-attr-width="{{a.tipo.LarguraReal * avg.width}}" ng-attr-height="{{a.tipo.ComprimentoReal * avg.height}}" viewBox="0 0 200 200" ng-attr-fill="{{ a.cor || defaultColor }}" data-assento="{{a.IdAssento}}" ng-click="sel(a)">'+
                 '  <use xlink:href="{{vm.resolveUrlTipo(a.tipo.IdTipoAssento)}}" />'+
                 ' </svg>'+
                 ' <text ng-attr-x="{{(a.PosicaoX ) * avg.width}}" ng-attr-y="{{(a.PosicaoY) * avg.height}}" text-anchor="middle" dy=".4em" font-family="Verdana" fill="#000000"  ng-click="sel(a)" ng-bind="a[textField]"></text>'+
                 ' <svg ng-if="a.VendeRemoto == false" ng-attr-x="{{(a.PosicaoX * avg.width)}}" ng-attr-y="{{(a.PosicaoY) * avg.height}}" width="10" height="10" viewBox="0 0 30 30" fill="#EEAA55">'+
                 '  <use xlink:href="#alert" />'+
                 ' </svg>'+
                 '</g>'+
                 '<rect id="aro" x="1" y="1" ng-attr-width="{{(realWidth || 0) * avg.width}}" ng-attr-height="{{(realHeight || 0) * avg.height}}" style="fill:transparent;stroke-width:1;stroke:#FF9898"></rect>' +
                 '</svg>'
      }

    }])

    .factory('mapaassento', ['$rootScope', function($rootScope) {
      return {
        block: function(mapName, id, color, dlg){
          $rootScope.$broadcast('mapaassento.block',{mapName:mapName, id:id, color:color, delegate: dlg});
        },
        select : function(mapName, id, dlg)
        {
          $rootScope.$broadcast('mapaassento.select',{mapName:mapName, id:id, delegate: dlg});
        }
      }
    }]);
})();

(function() {

  angular.module("app.directive")
    .directive('icheck', function($timeout) {
      return {
        restrict: 'A',
        require: 'ngModel',
        link: function($scope, element, $attrs, ngModel) {
          return $timeout(function() {
            var value;
            value = $attrs['value'];

            $scope.$watch($attrs['ngModel'], function(newValue) {
              $(element).iCheck('update');
            })

            return $(element).iCheck({
              checkboxClass: 'icheckbox_square-green',
              radioClass: 'iradio_square-green'

            }).on('ifChanged', function(event) {
              if ($(element).attr('type') === 'checkbox' && $attrs['ngModel']) {
                $scope.$apply(function() {
                  return ngModel.$setViewValue(event.target.checked);
                });
              }
              if ($(element).attr('type') === 'radio' && $attrs['ngModel']) {
                return $scope.$apply(function() {
                  return ngModel.$setViewValue(value);
                });
              }
            });
          });
        }
      };
    });
})();
(function () {

  angular.module("app.directive")
    .directive('chips', function () {
      return {
        restrict: 'E',
        scope: {
          tags: '=',
          selecionado: '=',
          autocomplete: '=autocomplete',
          placeholder: '@',
          valueField: '@',
          textField: '@',
          iconField: '@',
          max: '@', //Quantidade de itens que poderão ser adicionado ao chip
          disabled: '=', // Se 'true' desabilita o chip
          hasImage: '=', //Se definido como 'false', o chips não terá imagem, default 'true'
          allowNewItem: '=', // Se definido como 'false', o chip não permitirá a inclusão de novo item, default 'true'.
          selectedItemChange: '=?',
          items: '=?',
          removed:'=?',
          hasCheck: '=',
          enterNew: '='
        },
        template: '<div class="tags">' +
        '<div ng-repeat="t in tags" class="tag">' +
        '<img src="{{t[iconField]}}" fallback-src="../img/user_32x32.png" ng-if="t[iconField] != undefined" ng-hide="{{hasImage}}">&nbsp;' +
        '<img src="../img/user_32x32.png" ng-if="t[iconField] == undefined" ng-show="{{hasImage == false ? false : true}}"></img>' +
        '<span style="line-height: 30px;margin-left: 5px;">{{t[textField]}} </span> <b  class="badge badge-danger" ng-if="t[valueField]==null">Novo</b>&nbsp;&nbsp' +
        '<a class="close" ng-click="remove($index, t)" ng-hide="{{disabled}}">' +
        '<i class="fa fa-times-circle fa-5x" style="margin-top: 5px" aria-hidden="true"></i></a>' +
        '<input ng-if="hasCheck" icheck name="{{optName}}" type="radio" ng-model="$parent.$parent.selecionado" ng-value="t[valueField]" />'+
        '</div>' +
        '</div>' +
        '<div class="input-form">' +
        '<input type="text" id="txtBusca" class="form-control" placeholder="{{placeholder}}" ng-disabled="disabled" ng-model="newValue" /> '+
        '<div class="text-danger" ng-if="limiteAlcancado"><strong>O limite foi alcançado.</strong></div>' +
        '<h4 class="text-primary" ng-if="enterNew"><small>Pressione a tecla "ENTER" para incluir um novo registro.</small></h4>',
        // '<div class="progress progress-striped active" style="height: 4px;margin-top: -5px;">' +
        // '<div style="width:{{progress}}%" class="progress-bar progress-bar-success">' +
        // '</div>' +
        // '</div>',

        // '<span class="input-group-btn"><a class="btn btn-default" ng-click="add()">Add</a></span></div>',
        link: function ($scope, $element, attrs) {
          $scope.optName    =  "opt_" + Math.floor((1 + Math.random()) * 0x10000).toString(16)
          $scope.valueField = $scope.valueField || 'Id';
          $scope.textField = $scope.textField || 'Nome';
          $scope.iconField = $scope.iconField || '';

          if($scope.hasImage === undefined || $scope.hasImage === null){
            attrs.$set('hasImage', true);
            //$scope.hasImage = true;
          }

          var max = $scope.max;
          var input = angular.element($element).find('#txtBusca');

          $scope.autocompleteFocus = function (event, ui) {

            //input.val(ui.item[$scope.textField]);

            return false;
          };

          $scope.autocompleteSelect = function (event, ui) {
            $scope.newValue = ui.item[$scope.textField];

            if ($scope.selectedItemChange != undefined)
              $scope.selectedItemChange(ui);

            $scope.$apply(function () {
              $scope.add(ui.item)
            });

            return false;
          };

          $scope.progress = 0;

          $($element).find('#txtBusca').autocomplete({
            minLength: 0,

            source: function (req, resp) {

              $scope.items(req.term).then(function (data) {
                return resp(data);
              }).finally(function () {
                $scope.progress = 0;
              });
            },

            focus: (function (_this) {

              return function (event, ui) {

                return $scope.autocompleteFocus(event, ui);
              };
            })(this),

            select: (function (_this) {
              return function (event, ui) {

                return $scope.autocompleteSelect(event, ui);
              };
            })(this)

          }).autocomplete("instance")._renderItem = function (ul, item) {
//            maxShowItems: 5;

            // if($scope.hasImage === undefined || $scope.hasImage === null){
            //   $scope.hasImage = true;
            // }

            var $li = $('<li>');
            $li.attr("data-id", item[$scope.valueField])
            var $div = $('<div>');
            var $img = $('<img>');
            var $a = $('<a>');

            if($scope.hasImage === undefined || $scope.hasImage === true){
              if (item[$scope.iconField] != undefined) {
                $img.attr({
                  src: item[$scope.iconField],
                  alt: item[$scope.textField],
                  'fallback-src' : '../img/user_32x32.png'
                });
                $a.append($img);
              }
              else {
                $a.append('<img src="../img/user_32x32.png"> </img>');
              }
            }

            $a.append(item[$scope.textField]);
            $div.append($a);
            $li.append($div);
            ul.addClass("chips");

            $img.error(function() {
//              $(this).attr("src", "https://www.google.com/images/srpr/logo3w.png");
              $(this).attr("src", "../img/user_32x32.png");
            })

            return $li.appendTo(ul);
          }

          $scope.add = function (itm) {

            if ($scope.tags.length == max && max > 1) {
              $scope.limiteAlcancado = true;
              input.attr('disabled', true);
              $scope.newValue = "";
              input.val('');
            }

            if ($scope.allowNewItem != false || $scope.allowNewItem == undefined || itm[$scope.valueField] != undefined) {
              //if ($scope.tags.length < max || max == undefined) {
              if ($scope.tags.filter(function (item) {
                  if (itm[$scope.valueField] == !undefined)
                    return item[$scope.valueField] == itm[$scope.valueField]
                  else
                    return item[$scope.textField] == itm[$scope.textField]
                }).length == 0) {

                if(itm.Nome != undefined && itm.Nome != "") {
                  itm.Selecionado = null;
                  if(max == 1) {
                    $scope.tags = [];
                    $scope.tags.push(itm);
                  }
                  else
                    $scope.tags.push(itm);
                }
              }
              $scope.newValue = "";
              input.val('');
              input.blur();
              $('#txtBusca').autocomplete('close');
              //}
              //else {
              // if (itm != undefined) {
              //   $scope.tags = [];
              //   $scope.tags.push(itm);
              //   $scope.newValue = "";
              // }
              // }

            }
            if ($scope.tags.length == max && max > 1) {
              input.attr('disabled', true);
            }

            $('#txtBusca').autocomplete('close');
          }

          $scope.remove = function(idx, itm) {
            $scope.limiteAlcancado = false;
            $scope.tags.splice(idx, 1);
            input.attr('disabled', false);

            if(itm.Principal == true)
              $scope.selecionado = null;

            if ($scope.removed != undefined)
              return $scope.removed(itm);
          };

          input.bind('keypress', function (event) {
            if (event.keyCode == 13) {
              $scope.$apply(function () {
                $scope.add({Nome: $scope.newValue});
                $scope.newValue = "";
              });
            }
            $element.find('input').focus();
          });

          input.bind('focus', function(event) {
            $element.find('input').autocomplete("search");
          });
        }
      };
    });
})();

(function() {

  angular.module('app.directive')
    .directive('breadcrumb', ['$interpolate', '$state', 'appSettings', function($interpolate, $state, appSettings) {
      return {
        restrict: 'E',
        templateUrl: 'view/common/breadcrumb.html',
        scope: {
          displaynameProperty: '@',
          abstractProxyProperty: '@?'
        },
        link: function(scope) {
          scope.breadcrumbs = [];
          if ($state.$current.name !== '') {
            updateBreadcrumbsArray();
          }
          scope.$on('$stateChangeSuccess', function() {
            updateBreadcrumbsArray();
          });

          /**
           * Start with the current state and traverse up the path to build the
           * array of breadcrumbs that can be used in an ng-repeat in the template.
           */
          function updateBreadcrumbsArray() {
            var workingState;
            var displayName;
            var breadcrumbs = [];
            var currentState = $state.$current;

            var authData = appSettings.getUserStore();


            while (currentState && currentState.name !== '') {
              workingState = getWorkingState(currentState);
              if (workingState) {
                displayName = getDisplayName(workingState);

                if (displayName !== false && !stateAlreadyInBreadcrumbs(workingState, breadcrumbs)) {
                  breadcrumbs.push({
                    displayName: displayName,
                    route: workingState.name
                  });
                }
              }
              currentState = currentState.parent;
            }
            breadcrumbs.reverse();
            scope.breadcrumbs = breadcrumbs;
            if (breadcrumbs.length > 0)
              scope.title = breadcrumbs[breadcrumbs.length - 1].displayName
            else
              scope.title = "TITULO DA PÁGINA";

            if (authData) {
              scope.estabelecimento = authData.estabelecimento;
              scope.usuario = authData.apelido || authData.login;
            }

          }

          /**
           * Get the state to put in the breadcrumbs array, taking into account that if the current state is abstract,
           * we need to either substitute it with the state named in the `scope.abstractProxyProperty` property, or
           * set it to `false` which means this breadcrumb level will be skipped entirely.
           * @param currentState
           * @returns {*}
           */
          function getWorkingState(currentState) {
            var proxyStateName;
            var workingState = currentState;
            if (currentState.abstract === true) {
              if (typeof scope.abstractProxyProperty !== 'undefined') {
                proxyStateName = getObjectValue(scope.abstractProxyProperty, currentState);
                if (proxyStateName) {
                  workingState = $state.get(proxyStateName);
                } else {
                  workingState = false;
                }
              } else {
                workingState = false;
              }
            }
            return workingState;
          }

          /**
           * Resolve the displayName of the specified state. Take the property specified by the `displayname-property`
           * attribute and look up the corresponding property on the state's config object. The specified string can be interpolated against any resolved
           * properties on the state config object, by using the usual {{ }} syntax.
           * @param currentState
           * @returns {*}
           */
          function getDisplayName(currentState) {
            var interpolationContext;
            var propertyReference;
            var displayName;

            if (!scope.displaynameProperty) {
              // if the displayname-property attribute was not specified, default to the state's name
              return currentState.name;
            }
            propertyReference = getObjectValue(scope.displaynameProperty, currentState);

            if (propertyReference === false) {
              return false;
            } else if (typeof propertyReference === 'undefined') {
              return currentState.name;
            } else {
              // use the $interpolate service to handle any bindings in the propertyReference string.
              interpolationContext = (typeof currentState.locals !== 'undefined') ? currentState.locals.globals : currentState;
              displayName = $interpolate(propertyReference)(interpolationContext);
              return displayName;
            }
          }

          /**
           * Given a string of the type 'object.property.property', traverse the given context (eg the current $state object) and return the
           * value found at that path.
           *
           * @param objectPath
           * @param context
           * @returns {*}
           */
          function getObjectValue(objectPath, context) {
            var i;
            var propertyArray = objectPath.split('.');
            var propertyReference = context;

            for (i = 0; i < propertyArray.length; i++) {
              if (angular.isDefined(propertyReference[propertyArray[i]])) {
                propertyReference = propertyReference[propertyArray[i]];
              } else {
                // if the specified property was not found, default to the state's name
                return undefined;
              }
            }
            return propertyReference;
          }

          /**
           * Check whether the current `state` has already appeared in the current breadcrumbs array. This check is necessary
           * when using abstract states that might specify a proxy that is already there in the breadcrumbs.
           * @param state
           * @param breadcrumbs
           * @returns {boolean}
           */
          function stateAlreadyInBreadcrumbs(state, breadcrumbs) {
            var i;
            var alreadyUsed = false;
            for (i = 0; i < breadcrumbs.length; i++) {
              if (breadcrumbs[i].route === state.name) {
                alreadyUsed = true;
              }
            }
            return alreadyUsed;
          }
        }
      };
    }]);
})();
(function() {
  'use strict';

  angular
    .module('ticket.controller', [
      'ticket.controller.authentication',
      'ticket.controller.site',
      'ticket.controller.empresa',
      'ticket.controller.estabelecimento',
      'ticket.controller.conteudo',
      'ticket.controller.moderacao',
      'ticket.controller.configuracao',
      'ticket.controller.financeiro',
      'ticket.controller.controleingresso',
      'ticket.controller.programacao',
      'ticket.controller.promocao',
      'ticket.controller.operacao',
      'ticket.controller.reports'
    ]);
})();

/**
 * INSPINIA - Responsive Admin Theme
 * 2.5
 *
 * Custom scripts
 */

angular.element(document).ready(function ($timeout) {


  // Full height of sidebar
  function fix_height() {
    var heightWithoutNavbar = angular.element("body > #wrapper").height() - 61;
    angular.element(".sidebard-panel").css("min-height", heightWithoutNavbar + "px");

    var navbarHeigh = angular.element('nav.navbar-default').height();
    var wrapperHeigh = angular.element('#page-wrapper').height();

    if(navbarHeigh > wrapperHeigh){
      angular.element('#page-wrapper').css("min-height", navbarHeigh + "px");
    }

    if(navbarHeigh < wrapperHeigh){
      angular.element('#page-wrapper').css("min-height", angular.element(window).height()  + "px");
    }

    if (angular.element('body').hasClass('fixed-nav')) {
      if (navbarHeigh > wrapperHeigh) {
        angular.element('#page-wrapper').css("min-height", navbarHeigh - 60 + "px");
      } else {
        angular.element('#page-wrapper').css("min-height", angular.element(window).height() - 60 + "px");
      }
    }

  }

  angular.element(window).bind("load resize scroll", function() {
    if(!angular.element("body").hasClass('body-small')) {
      fix_height();
    }
  });

  // Move right sidebar top after scroll
  angular.element(window).scroll(function(){
    if (angular.element(window).scrollTop() > 0 && !angular.element('body').hasClass('fixed-nav') ) {
      angular.element('#right-sidebar').addClass('sidebar-top');
    } else {
      angular.element('#right-sidebar').removeClass('sidebar-top');
    }
  });

  $timeout(function(){
    fix_height();
  });

  // Minimalize menu when screen is less than 768px
  angular.element(window).bind("load resize", function() {
    if (angular.element(document).width() < 769) {
      angular.element('body').addClass('body-small')
    } else {
      angular.element('body').removeClass('body-small')
    }
  })

});

(function() {
  'use strict';

  angular
    .module('inspinia')
    .run(runBlock);

  /** @ngInject */
  function runBlock($log) {

    $log.debug('runBlock end');

// moment.js locale configuration
// locale : brazilian portuguese (pt-br)
// author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira

    (function (factory) {
      if (typeof define === 'function' && define.amd) {
        define(['moment'], factory); // AMD
      } else if (typeof exports === 'object') {
        module.exports = factory(require('../moment')); // Node
      } else {
        factory(window.moment); // Browser global
      }
    }(function (moment) {
      return moment.defineLocale('pt-br', {
        months : 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split('_'),
        monthsShort : 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
        weekdays : 'domingo_segunda-feira_terça-feira_quarta-feira_quinta-feira_sexta-feira_sábado'.split('_'),
        weekdaysShort : 'dom_seg_ter_qua_qui_sex_sáb'.split('_'),
        weekdaysMin : 'dom_2ª_3ª_4ª_5ª_6ª_sáb'.split('_'),
        longDateFormat : {
          LT : 'HH:mm',
          L : 'DD/MM/YYYY',
          LL : 'D [de] MMMM [de] YYYY',
          LLL : 'D [de] MMMM [de] YYYY [às] LT',
          LLLL : 'dddd, D [de] MMMM [de] YYYY [às] LT'
        },
        calendar : {
          sameDay: '[Hoje às] LT',
          nextDay: '[Amanhã às] LT',
          nextWeek: 'dddd [às] LT',
          lastDay: '[Ontem às] LT',
          lastWeek: function () {
            return (this.day() === 0 || this.day() === 6) ?
              '[Último] dddd [às] LT' : // Saturday + Sunday
              '[Última] dddd [às] LT'; // Monday - Friday
          },
          sameElse: 'L'
        },
        relativeTime : {
          future : 'em %s',
          past : '%s atrás',
          s : 'segundos',
          m : 'um minuto',
          mm : '%d minutos',
          h : 'uma hora',
          hh : '%d horas',
          d : 'um dia',
          dd : '%d dias',
          M : 'um mês',
          MM : '%d meses',
          y : 'um ano',
          yy : '%d anos'
        },
        ordinal : '%dº'
      });
    }));

    //angular.module('infinite-scroll').value('THROTTLE_MILLISECONDS', 1000);

    /* Brazilian initialisation for the jQuery UI date picker plugin. */
    /* Written by Leonildo Costa Silva (leocsilva@gmail.com). */
    jQuery(function($){
      $.datepicker.regional['pt-BR'] = {
        closeText: 'Fechar',
        prevText: '&#x3c;Anterior',
        nextText: 'Pr&oacute;ximo&#x3e;',
        currentText: 'Hoje',
        monthNames: ['Janeiro','Fevereiro','Mar&ccedil;o','Abril','Maio','Junho',
          'Julho','Agosto','Setembro','Outubro','Novembro','Dezembro'],
        monthNamesShort: ['Jan','Fev','Mar','Abr','Mai','Jun',
          'Jul','Ago','Set','Out','Nov','Dez'],
        dayNames: ['Domingo','Segunda-feira','Ter&ccedil;a-feira','Quarta-feira','Quinta-feira','Sexta-feira','Sabado'],
        dayNamesShort: ['Dom','Seg','Ter','Qua','Qui','Sex','Sab'],
        dayNamesMin: ['Dom','Seg','Ter','Qua','Qui','Sex','Sab'],
        weekHeader: 'Sm',
        dateFormat: 'dd/mm/yy',
        firstDay: 0,
        isRTL: false,
        showMonthAfterYear: false,
        yearSuffix: ''};
      $.datepicker.setDefaults($.datepicker.regional['pt-BR']);
    });
  }

})();

(function() {
  'use strict';

  angular
    .module('inspinia')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider, menuProvider) {

    $stateProvider
      .state('404', {
        url: '/404',
        views: {
          'root': {
            templateUrl: 'view/common/404.tmpl.html',
            controller: 'ErrorPageController',
            controllerAs: 'vm'
          }
        }
      })

    .state('401', {
      url: '/401',
      views: {
        'root': {
          templateUrl: 'view/common/401.tmpl.html',
          controller: 'ErrorPageController',
          controllerAs: 'vm'
        }
      }
    })

    .state('500', {
      url: '/500',
      views: {
        'root': {
          templateUrl: 'view/common/500.tmpl.html',
          controller: 'ErrorPageController',
          controllerAs: 'vm'
        }
      }
    });


    // set default routes when no path specified
    $urlRouterProvider.when('', '/login');
    $urlRouterProvider.when('/', '/login');

    // always goto 404 if route not found
    $urlRouterProvider.otherwise('/404');



  }

})();
(function() {
  'use strict';
  angular
    .module('inspinia')
})();
(function() {
  angular
    .module('ticket')
    .controller('ErrorPageController', ErrorPageController);

  /* @ngInject */
  function ErrorPageController($state) {
    var vm = this;

    vm.goHome = goHome;


    function goHome() {
      $state.go('auth.login');
    }
  }
})();
'use strict';

//Directive used to set metisMenu and minimalize button
angular.module('inspinia')
    .factory("navigation", ["common", function (common) {
        var res = { items: [], menuLeft: { add: function (itm) { res.push(itm); } } };

        return res;
    }])

    .directive('sideNavigation', function ($timeout) {
        return {
            restrict: 'A',
            link: function (scope, element) {
                // Call metsi to build when user signup
                scope.$watch('authentication.user', function () {
                    $timeout(function () {
                        element.metisMenu();
                    });
                });

            }
        };
    })
    .directive('minimalizaSidebar', function ($timeout) {
        return {
            restrict: 'A',
            template: '<a class="navbar-minimalize minimalize-styl-2 btn btn-primary " href="" ng-click="minimalize()"><i class="fa fa-bars"></i></a>',
            controller: function ($scope) {
                $scope.minimalize = function () {
                    angular.element('body').toggleClass('mini-navbar');
                    if (!angular.element('body').hasClass('mini-navbar') || angular.element('body').hasClass('body-small')) {
                        // Hide menu in order to smoothly turn on when maximize menu
                        angular.element('#side-menu').hide();
                        // For smoothly turn on menu
                        $timeout(function () {
                            angular.element('#side-menu').fadeIn(400);
                        }, 200);
                    } else {
                        // Remove all inline style from jquery fadeIn function to reset menu state
                        angular.element('#side-menu').removeAttr('style');
                    }
                };
            }
        };
    });



(function() {
  angular.module("app", [
    'app.directive',
    'uiGmapgoogle-maps',
    'ngDialog'
  ])


})();

 (function() {
   'use strict';
   angular.module('app')
     .factory('dateInterceptor', function() {
       var regexIso8601 = /^(\d{4}|\+\d{6})(?:-(\d{2})(?:-(\d{2})(?:T(\d{2}):(\d{2}):(\d{2})\.(\d{1,})(Z|([\-+])(\d{2}):(\d{2}))?)?)?)?$/;

       function matchDate(dateString) {
         if (dateString.length === 27) {
           return dateString.match(regexIso8601);
         }
         return false;
       };

       function convertDateStringsToDates(object) {
         // ensure that we're processing an object
         if (typeof object !== "object") {
           return object;
         }

         for (var key in object) {
           if (!object.hasOwnProperty(key)) {
             continue;
           }
           var value = object[key];

           // check for string properties with a date format
           if (typeof value === "string" && matchDate(value)) {
             var date = new Date(value); // create the date from the date string
             object[key] = date; // we're mutating the response directly
           } else if (typeof value === "object") {
             convertDateStringsToDates(value); // recurse into object
           }
         }
         return null;
       }

       var interceptor = {
         'response': function(response) {
           if (response.data) {
             convertDateStringsToDates(response.data);
           }
           return response;
         }
       };
       return interceptor;
     })
 })();
(function () {
  angular.module("ticket")
    .factory("common", ["$rootScope", "$state", "$stateParams", "$q", "$http", "appSettings", "$log", "$timeout", "toaster", "$uibModal", "ticket.service.controleacesso.login", function ($rootScope, $state, $stateParams, $q, $http, appSettings, $log, $timeout, toaster, $uibModal, loginSvc) {

      var AlertType = {
        INFO: "info",
        ERRO: "error",
        ALERTA: "warning",
        SUCESSO: "success",
        AGUARDE: "wait"
      };
      var utils = {
        AlertType: AlertType,
        Messages: {
          post: {
            tit: "Alteração de informações",
            msg: "Atualização realizada com sucesso!",
            type: AlertType.SUCESSO
          },
          put: {
            tit: "Inclusão de informações",
            msg: "Cadastro realizado com sucesso!",
            type: AlertType.SUCESSO
          },
          status: {
            tit: "Alteração de status",
            msg: "Atualização de status realizado com sucesso!",
            type: AlertType.SUCESSO
          },
          del: {
            tit: "Exclusão de informações",
            msg: "Exclusão realizada com sucesso!",
            type: AlertType.SUCESSO
          },
          putPhoto: {
            tit: "Envio de foto",
            msg: "A foto foi enviada com sucesso!",
            type: AlertType.SUCESSO
          },
          errorQuery: {
            tit: "Resultado da Pesquisa:",
            msg: "Nenhum registro encontrado!",
            type: AlertType.INFO
          }
        },
        Confirm: function (tit, msg) {
          return $uibModal.open({
            animation: false,
            templateUrl: "view/common/confirm.html",
            controller: function ($uibModalInstance, itm) {
              var vm = this;
              vm.itm = itm;
              vm.no = function () {
                $uibModalInstance.dismiss('cancel');
              }
              vm.yes = function () {
                $uibModalInstance.close(vm.item);
              }
            },
            controllerAs: 'vm',
            size: 'sm',
            resolve: {
              itm: function () {
                return {
                  tit: tit,
                  msg: msg
                };
              }
            }
          })
            .result;
        },
        SendAlert: function (data) {
          toaster.pop(data.type, data.tit, data.msg);
        },
        ShowError: function (tit, msg) {
          utils.SendAlert({
            tit: tit,
            msg: msg,
            type: AlertType.ERRO
          });
        },
        ShowInfo: function (tit, msg) {
          utils.SendAlert({
            tit: tit,
            msg: msg,
            type: AlertType.INFO
          });
        },
        ShowWarning: function (tit, msg) {
          utils.SendAlert({
            tit: tit,
            msg: msg,
            type: AlertType.ALERTA
          });
        },
        ShowSuccess: function (tit, msg) {
          utils.SendAlert({
            tit: tit,
            msg: msg,
            type: AlertType.SUCESSO
          });
        }
      };

      var common = {
        controller: {
          basic: function (obj) {
            var vm = {};
            vm.utils = utils;

            obj.__proto__ = vm;

            return obj;
          },
          master: function (obj, svc, $scope) {
            var vm = {};
            vm.utils = utils;


            var _queried = $rootScope.$on('queried', function (evt, items) {
              vm.items = items;
            });

            $scope.$on('$destroy', _queried);

            var _canceled = $rootScope.$on('canceled', function () {
              if (vm.items && vm.items.length > 0) {
                for (var i = 0; i < vm.items.length; i++)
                  vm.items[i].updated = false;

                $state.go('^.grid', {
                  items: vm.items
                });
              } else {
                $state.go('^.grid');
              }

            });

            $scope.$on('$destroy', _canceled);

            var _saved = $rootScope.$on('saved', function (evt, pk) {

              if (vm.items && vm.items.length > 0) {
                //VERIFICA SE A PK QUE RETORNOU DA EDIÇÃO EXISTE NA GRID
                var rows = vm.items.filter(function (itm) {
                  itm.updated = false;
                  for (var i in pk) {
                    if (itm[i] != pk[i])
                      return false;
                  }

                  return true;
                });

                //BUSCA O REGISTRO DA GRID ATUALIZADO NO SERVIDOR
                svc.getOne(pk)
                  .then(function (res) {

                    //POSICIONA O REGISTRO ATUALIZADO NA GRID. SE FOR INCLUSÃO, IRÁ PARA A PRIMEIRA POSIÇÃO

                    var index = (rows.length > 0) ? vm.items.indexOf(rows[0]) : -1;

                    res[0].updated = true;

                    if (index == -1) {
                      vm.items.splice(0, 0, res[0]);
                    } else {
                      vm.items.splice(index, 1, res[0]);
                    }

                    $state.go('^.grid', {
                      items: vm.items
                    });

                  });
              } else {
                svc.getOne(pk)
                  .then(function (res) {
                    $state.go('^.grid', {
                      items: res
                    });
                  });
              }


            });

            $scope.$on('$destroy', _saved);

            obj.__proto__ = vm;

            return obj;

          },
          grid: function (obj, svc) {
            var vm = {};
            vm.utils = utils;
            vm.Filter = {};
            vm.debounce = 0;
            vm.searching = false;
            vm.complete = false;
            vm.items = [];
            var pageSize = 20;
            vm.isPost = true;
            vm.initial = true;
            //PESQUISA DA GRID
            vm.search = function (inScroll) {

              if (vm.searching) return;

              vm.searching = true;

              if (!inScroll || vm.isPost) {
                vm.isPost = false;
                vm.page = 0;
                vm.complete = false;
                vm.items = [];
              }
              svc.getAll({
                Config: {
                  Skip: vm.page,
                  Top: pageSize
                },
                Filter: vm.Filter
              })
                .then(function (v) {
                  $rootScope.$emit('queried', v);

                  vm.items = vm.items.concat(v);

                  if (v.length < pageSize)
                    vm.complete = true;

                  if (v.length > 0) {
                    vm.page += 1;
                  }


                  if (obj.loaded)
                    obj.loaded();
                })
                .finally(function () {
                  vm.searching = false;
                  vm.initial = false;
                });
            }


            //INCLUSÃO
            vm.add = function () {
              $state.go('^.form');
            }

            //EDIÇÃO
            vm.edit = function (pk) {

              $state.go('^.form', pk);
            }

            //STATUS ON/OFF
            vm.toggle = function (itm) {
              svc.toggle(itm).then(function (v) {
                itm.Status = v;
              });
            }

            //EXCLUSÃO
            vm.del = function (itm) {
              utils.Confirm("Exclusão de registro", "Deseja excluir esse registro?").then(function () {
                svc.del(itm).then(function (v) {
                  vm.items.splice(vm.items.indexOf(itm), 1);
                  utils.ShowSuccess("Exclusão de registro.", "Esse registro foi excluído com sucesso!");
                });
              });
            }


            if ($stateParams.items) {
              vm.items = angular.fromJson(angular.toJson($stateParams.items));
            }

            if ($stateParams.filter) {
              vm.Filter = angular.fromJson($stateParams.filter);
              vm.search();
            }


            obj.__proto__ = vm;

            return obj;

          },
          form: function (obj, svc, dlg) {
            var vm = {
              utils: utils
            };


            pk = angular.fromJson($stateParams);

            var hasProp = false;
            if (pk != null) {
              for (var _p in pk) {
                if (pk[_p] != "" && pk[_p] != null) {
                  hasProp = true;
                  break;
                }
              }
            }

            if (!hasProp) 
            {
              vm.action = "INCLUSÃO";
              vm.item = {};
            } 
            else 
            { vm.action = "EDIÇÃO";}

            vm.search = function()
            {
              vm.loading = true;
              svc.get(pk)
                 .then(function (res) {
                                  vm.item = res;
                                  if (obj.loaded)
                                    obj.loaded();
                                }, 
                                function (err) { vm.cancel(); })
                 .finally(function() { vm.loading = false;});
            }

            vm.cancel = function () {
              $rootScope.$emit('canceled');
              $state.go('^.grid')
            };

            vm.save = function () {
              vm.loading = true;
              if (!hasProp) {
                svc.post(vm.item)
                  .then(function (v) {
                    utils.ShowSuccess("Inclusão de registro", "Operação realizada com sucesso!");
                    $rootScope.$emit('saved', v);
                    $state.go('^.grid');
                  })
                  .finally(function () {
                    vm.loading = false;
                  });
              } else {
                svc.put(vm.item)
                  .then(function (v) {
                    utils.ShowSuccess("Atualização de registro", "Operação realizada com sucesso!");
                    $rootScope.$emit('saved', pk);
                    $state.go('^.grid');
                  })
                  .finally(function () {
                    vm.loading = false;
                  });
              }
            }

            obj.__proto__ = vm;
            
            if (hasProp) 
              vm.search();

            if (dlg)
                dlg(hasProp);

            return obj;
          },
          instantiate: function (obj) {
            var res = {
              utils: utils
            };

            obj.__proto__ = res;

            return obj;
          }
        },
        service: {

          basic: function (obj, url) {
            var logLevel = {
              ERROR: 1,
              WARNING: 2,
              DEBUG: 4,
              INFO: 8,
              LOG: 16
            };

            function log(msg, level) {
              if (level == logLevel.ERROR && (appSettings.debugLevel & logLevel.ERROR > 0)) {
                $log.error(msg);
              }
              if (level == logLevel.WARNING && (appSettings.debugLevel & logLevel.WARNING > 0)) {
                $log.warn(msg);
              }
              if (level == logLevel.DEBUG && (appSettings.debugLevel & logLevel.DEBUG > 0)) {
                $log.debug(msg);
              }
              if (level == logLevel.INFO && (appSettings.debugLevel & logLevel.INFO > 0)) {
                $log.info(msg);
              }
              if (level == logLevel.LOG && (appSettings.debugLevel & logLevel.LOG > 0)) {
                $log.log(msg);
              }
            }


            function result_success(result) {
              return result.data;
            }

            function req(service, data, config) {

              function fail(err) {

                var msg = "";

                switch (err.status) {
                  case -1:
                    msg = "Falha ao acessar o servidor. Verifique sua internet.";
                    break;
                  case 401:
                    msg = "Serviço não autorizado. Verifique se você tem permissão para acessar esse recurso.";
                    break;
                  case 404:
                    msg = "Serviço não localizado. Talvez ele esteja apenas indisponível.";
                    break;
                  default:
                    msg = "Falha na chamada do serviço.";
                    break;
                }

                if (err.status != 401) {

                  msg = (err.data && err.data.Message) ? err.data.Message : msg;
                  msg = (err.data && err.data.error_description) ? err.data.error_description : msg;
                  msg = (err.data && err.data.ExceptionMessage) ? err.data.ExceptionMessage : msg;

                  log(err.config.method + ": " + err.config.url, logLevel.INFO);
                  if( err.data && err.data.ExceptionType == 'Barn.Util.BarnWarning' )
                    utils.ShowWarning("Alerta sobre a operação", msg);
                  else
                    utils.ShowError("Erro no servidor", msg);

                  return $q.reject(err);
                } else {
                  var usr = appSettings.getUserStore();
                  if (usr) {
                    return loginSvc.RefreshToken(usr.id_estabelecimento).then(function (v) {
                        return req(service, data, config);
                      },
                      function (err) {
                        return $uibModal.open({
                          backdrop: 'static',
                          keyboard: false,
                          animation: true,
                          //templateUrl: 'view/ingresso/ingresso/template/regra.tmpl.html',
                          template: '' +
                          '<div class="middle-box text-center loginscreen  animated fadeInDown"><div>' +
                          '<p>Identifique-se para continuar.</p>' +
                          '<form class="m-t" role="form" novalidate name="frm">' +
                          '<ng-field label="Email" name="email" ng-disabled="true" model="vm.user.email" type="text" required="true"></ng-field>' +
                          '<ng-field label="Senha" name="pwd" model="vm.user.password" type="password" required="true"></ng-field>' +
                          '<button type="submit" class="btn btn-primary block full-width m-b" ng-click="vm.loginClick()"  ng-disabled="vm.loading || frm.$invalid">' +
                          '<i class="fa " ng-disabled="vm.loading" ng-class="{\'fa-sing-in\': !vm.loading,  \'fa-spinner fa-pulse\': vm.loading}" ></i> Login' +
                          '</button>' +
                          '</form>' +
                          '</div>' +
                          '</div>',
                          controller: function ($uibModalInstance) {
                            var vm = this;
                            loginSvc.Logout(true);

                            vm.user = {
                              email: usr.login
                            }

                            vm.loginClick = function () {
                              vm.loading = true;
                              loginSvc.Logon(vm.user).then(function (v) {
                                  $uibModalInstance.close();
                                  //(v.estabelecimento == null ) ?  $state.go('auth.establishment') : $state.go('site.home');
                                },
                                function (e) {
                                  var msg = "Usuário/Senha incorretos. Verifique as informações e tente novamente.";
                                  if (e.status == -1) {
                                    msg = "Falha ao acessar o serviço. Verifique sua conexão com a internet."
                                  } else if (e.data && e.data.error == "no_establishment") {
                                    msg = e.data.error_description;
                                  }

                                  toaster.pop("error", "Identificação no sistema", msg);

                                })
                                .finally(function (e) {
                                  vm.loading = false;
                                });

                            }
                          },
                          controllerAs: 'vm',
                          size: 'sm',
                          resolve: {}
                        }).result.then(function () {
                          return req(service, data, config)
                        });
                      })


                  }
                }

              }

              config = config || {};
              config.supressError = config.supressError || false;

              if(!config.headers){
                config.headers = {};
              }
              //config.headers.timestamp = new Date().toISOString();
              config.headers.timestamp = moment( new Date()).format();

              if (config.supressError) {
                return $http.post(appSettings.url + url + service, data, config).then(result_success);
              } else {
                return $http.post(appSettings.url + url + service, data, config).then(result_success, fail);
              }
            }


            var res = {
              utils: utils,
              request: req,
              log: log
            }


            obj.__proto__ = res;

            return obj;

          },
          instantiate: function (obj, url) {

            obj = obj || {};

            obj.cachedData = [];

            function listCached(filter) {
              return $q(function (resolve, reject) {
                $timeout(function () {
                  resolve(
                    (
                      (obj.cachedData.length == 0) ?
                        obj.list({}).then(function (r) {
                          obj.cachedData = r;
                          return ((filter) ? obj.cachedData.filter(filter) : obj.cachedData);
                        }) :
                        ((filter) ? obj.cachedData.filter(filter) : obj.cachedData)
                    )
                  );

                }, 0, true)
              });

            }


            var res = {

              get: function (pk) {
                return this.request("get", pk)
              },
              getOne: function (pk) {
                return this.request("getone", pk);
              },
              getAll: function (filter) {
                return this.request("getall", filter);
              },
              put: function (mdl) {
                return this.request("put", mdl);
              },
              post: function (mdl) {
                return this.request("post", mdl);
              },
              del: function (pk) {
                return this.request("del", pk);
              },
              toggle: function (mdl) {
                return this.request("toggle", mdl);
              },
              list: function (filter) {
                return this.request("list", filter);
              },
              listCached: listCached
            }


            obj.__proto__ = common.service.basic(res, url);


            return obj;
          }
        }
      };

      return common;


    }]);
})();

(function () {
  "use strict";

  var storeAuthName = "oAuthTICKET_1.0"; //MUDANDO ESSA VERSÃƒO, TODAS AS CONEXÃ•ES EM CACHE NO CLIENTE SERÃƒO REINICIADAS

  angular
    .module("app")
    .constant("GuidEmpty", "00000000-0000-0000-0000-000000000000");

  angular
    .module("app")
    .provider("appSettings", [
      function () {
        var languages = [];
        var settings = {
          url: "https://api.prd3.divertix.com.br/api/",
          appId: "TICKET.GESTAO",
          appKey: "6F0F7EED-81D6-4840-AAA2-0CF12E50182D",
          auth: "https://api.prd3.divertix.com.br/token",
          pageSize: 30,
          debugLevel: 15, //DEBUG LEVEL: 1. ERRO, 2. WARNING, 4. DEBUG, 8. INFO
        };

        this.addLanguage = addLanguage;
        this.getUserStore = getUserStore;
        this.setUserStore = setUserStore;
        this.clearUserStore = clearUserStore;

        function getUserStore() {
          var $window = angular.injector(["ng"]).get("$window");
          var u = $window.sessionStorage.getItem(storeAuthName);
          return u != "" && u != null ? angular.fromJson(u) : null;
        }

        function setUserStore(v) {
          var $window = angular.injector(["ng"]).get("$window");
          return $window.sessionStorage.setItem(
            storeAuthName,
            angular.toJson(v)
          );
        }

        function clearUserStore() {
          var $window = angular.injector(["ng"]).get("$window");
          $window.sessionStorage.removeItem(storeAuthName);
        }

        function addLanguage(newLanguage) {
          languages.push(newLanguage);
        }
        // Service
        this.$get = function () {
          return {
            url: settings.url,
            appId: settings.appId,
            appKey: settings.appKey,
            auth: settings.auth,
            pageSize: settings.pageSize,
            debugLevel: settings.debugLevel,
            languages: languages,
            getUserStore: getUserStore,
            setUserStore: setUserStore,
            clearUserStore: clearUserStore,
          };
        };
      },
    ])
    .provider("menu", [
      function () {
        var menuLeft = [];
        this.left = {
          add: function (itm) {
            menuLeft.push(itm);
          },
        };
        this.$get = function () {
          return {
            menuLeft: menuLeft,
          };
        };
      },
    ])
    .factory("BearerAuthInterceptor", [
      "$q",
      "$rootScope",
      "appSettings",
      function ($q, $rootScope, appSettings) {
        var authData = appSettings.getUserStore();

        $rootScope.$on("app.logon", function (arg, v) {
          authData = v;
        });
        $rootScope.$on("app.logoff", function (arg, v) {
          authData = null;
        });

        return {
          request: function (config) {
            config.headers = config.headers || {};

            if (authData && authData.access_token)
              config.headers.Authorization = "Bearer " + authData.access_token;

            return $q.when(config);
          },
        };
      },
    ])

    .config([
      "$httpProvider",
      function ($httpProvider) {
        $httpProvider.interceptors.push("BearerAuthInterceptor"); //OAuth 2.0
        //$httpProvider.interceptors.push('dateInterceptor');
      },
    ])
    .directive("menuLeft", function ($timeout, menu) {
      return {
        restrict: "E",
        templateUrl: "view/common/navigation.html",
        controller: [
          "$scope",
          "$state",
          "$rootScope",
          "appSettings",
          "ticketSettings",
          function ($scope, $state, $rootScope, appSettings, ticketSettings) {
            var vm = this;

            $rootScope.$state = $state;

            var authData = appSettings.getUserStore();

            vm.Nome = authData.apelido || authData.login;
            vm.Perfil = authData.perfil;

            vm.items = menu.menuLeft;
            vm.appSettings = ticketSettings;

            // vm.Nome = 'TESTE'
          },
        ],
        controllerAs: "vm",
      };
    })

    .filter("trustUrl", [
      "$sce",
      function ($sce) {
        return function (recordingUrl) {
          return $sce.trustAsResourceUrl(recordingUrl);
        };
      },
    ])
    //GOOGLE MAPS CONFIG
    .config(function (uiGmapGoogleMapApiProvider) {
      uiGmapGoogleMapApiProvider.configure({
        key: "AIzaSyBnIkA6ntAunR9DzTnYyw0OY_OCvBmd5t8", //API TEMPORARIA
        libraries: "geometry,visualization,places",
      });
    })

    //CONFIGURAÃ‡Ã‚O PARA O YOUTUBE
    .config(function ($sceDelegateProvider) {
      $sceDelegateProvider.resourceUrlWhitelist([
        "self",
        "https://www.youtube.com/**",
      ]);
    });
})();

angular.module("inspinia").run(["$templateCache", function($templateCache) {$templateCache.put("view/main/main.html","<div class=\"wrapper wrapper-content animated fadeInRight\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"text-center m-t-lg\"><h1>{{main.helloText}}</h1><small>{{main.descriptionText}} <i class=\"glyphicon glyphicon-pencil\"></i></small></div></div></div></div>");
$templateCache.put("view/minor/minor.html","<div class=\"wrapper wrapper-content animated fadeInRight\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"text-center m-t-lg\"><h1>Simple example of second view</h1><small>Configure in app.js as index.minor state.</small></div></div></div></div>");
$templateCache.put("view/controller/authentication/lock/lock.tmpl.html","<div layout=\"row\" flex=\"\" layout-padding=\"\" layout-fill=\"\" layout-align=\"center center\"><div flex=\"40\" flex-lg=\"50\" flex-md=\"70\" flex-xs=\"100\"><md-card><md-toolbar class=\"padding-20\"><div layout=\"row\" layout-align=\"center center\"><img ng-src=\"{{::vm.triSettings.logo}}\" alt=\"{{vm.triSettings.name}}\"></div><div layout=\"row\" layout-align=\"center center\"><h1 class=\"md-headline\"><span translate=\"\">Welcome back</span> {{vm.user.name}}</h1></div></md-toolbar><md-content class=\"md-padding\"><p class=\"margin-top-20 margin-bottom-20\" translate=\"\">You have been logged out due to idleness. Enter your password to log back in.</p><form name=\"lock\"><md-input-container class=\"md-block\"><label for=\"password\" translate=\"\">password</label> <input label=\"password\" name=\"password\" type=\"password\" ng-model=\"vm.user.password\" required=\"\"><div ng-messages=\"\" for=\"lock.password.$error\" md-auto-hide=\"false\" ng-show=\"lock.password.$touched\"><div ng-message=\"\" when=\"required\"><span translate=\"\">Please enter your password.</span></div></div></md-input-container><div layout=\"row\"><md-button flex=\"\" href=\"#/login\" translate=\"Log out\"></md-button><md-button flex=\"\" class=\"md-primary\" ng-click=\"vm.loginClick()\" ng-disabled=\"lock.$invalid\" translate=\"Log in\"></md-button></div></form></md-content></md-card></div></div>");
$templateCache.put("view/controller/authentication/signup/password.messages.html","");
$templateCache.put("view/controller/authentication/signup/signup.tmpl.html","<div layout=\"row\" flex=\"\" layout-padding=\"\" layout-fill=\"\" layout-align=\"center center\"><div flex=\"40\" flex-lg=\"50\" flex-md=\"70\" flex-xs=\"100\"><md-card><md-toolbar class=\"padding-20\"><div layout=\"row\" layout-align=\"center center\"><img ng-src=\"{{::vm.triSettings.logo}}\" alt=\"{{vm.triSettings.name}}\"></div><div layout=\"row\" layout-align=\"center center\"><h1 class=\"md-headline\" translate=\"\">Sign up</h1></div></md-toolbar><md-content class=\"md-padding\"><form name=\"signup\"><md-input-container class=\"md-block\"><label for=\"name\" translate=\"\">name</label> <input id=\"name\" label=\"name\" name=\"name\" type=\"text\" ng-model=\"vm.user.name\" required=\"\"><div ng-messages=\"signup.name.$error\" md-auto-hide=\"false\" ng-show=\"signup.name.$touched\"><div ng-message=\"\" when=\"required\"><span translate=\"\">Please enter your name</span></div></div></md-input-container><md-input-container class=\"md-block\"><label for=\"email\" translate=\"\">email</label> <input id=\"email\" label=\"email\" name=\"email\" type=\"email\" ng-model=\"vm.user.email\" required=\"\"><div ng-messages=\"signup.email.$error\" md-auto-hide=\"false\" ng-show=\"signup.email.$touched\"><div ng-message=\"\" when=\"required\"><span translate=\"\">Please enter your email address</span></div><div ng-message=\"\" when=\"email\"><span translate=\"\">Please enter a valid email address</span></div></div></md-input-container><md-input-container class=\"md-block\"><label for=\"password\" translate=\"\">password</label> <input id=\"password\" label=\"password\" name=\"password\" type=\"password\" ng-model=\"vm.user.password\" tri-same-password=\"signup.confirm\" ng-minlength=\"8\" required=\"\"><ng-messages for=\"signup.password.$error\" md-auto-hide=\"false\" ng-show=\"signup.password.$touched\"><div ng-message=\"\" when=\"required\"><span translate=\"\">Please enter a password</span></div><div ng-message=\"\" when=\"minlength\"><span translate=\"\">Your password must be greater than 8 characters long</span></div><div ng-message=\"\" when=\"samePassword\"><span translate=\"\">You need to enter the same password</span></div></ng-messages></md-input-container><md-input-container class=\"md-block\"><label for=\"password\" translate=\"\">confirm password</label> <input id=\"confirm\" label=\"confirm\" name=\"confirm\" type=\"password\" ng-model=\"vm.user.confirm\" tri-same-password=\"signup.password\" ng-minlength=\"8\" required=\"\"><ng-messages for=\"signup.confirm.$error\" md-auto-hide=\"false\" ng-show=\"signup.confirm.$touched\"><div ng-message=\"\" when=\"required\"><span translate=\"\">Please enter a password</span></div><div ng-message=\"\" when=\"minlength\"><span translate=\"\">Your password must be greater than 8 characters long</span></div><div ng-message=\"\" when=\"samePassword\"><span translate=\"\">You need to enter the same password</span></div></ng-messages></md-input-container><md-button class=\"md-raised md-primary full-width margin-left-0 margin-right-0 margin-top-10 margin-bottom-10\" ng-click=\"vm.signupClick()\" ng-disabled=\"signup.$invalid\" translate=\"Sign Up\" aria-label=\"{{\'Sign Up\' | triTranslate}}\"></md-button><md-button class=\"md-primary full-width margin-left-0 margin-right-0 margin-top-10 margin-bottom-10\" href=\"#/login\" translate=\"Already have an account? Login here.\" aria-label=\"{{\'Already have an account? Login here.\' | triTranslate}}\"></md-button></form></md-content></md-card></div></div>");
$templateCache.put("view/controller/site/home/home.tmpl.html","<div layout=\"row\" flex=\"\" layout-padding=\"\" layout-fill=\"\" layout-align=\"center center\"><div flex=\"40\" flex-lg=\"50\" flex-md=\"70\" flex-xs=\"100\"><md-card><md-toolbar class=\"padding-20\"><div flex=\"\" layout=\"row\" layout-align=\"center center\"><img ng-src=\"{{::vm.triSettings.logo}}\" alt=\"{{vm.triSettings.name}}\"></div><div layout=\"row\" layout-align=\"center center\"><h1 class=\"md-headline\" translate=\"\">Home</h1></div></md-toolbar><md-content class=\"md-padding\">pagina inicial</md-content></md-card></div></div>");
$templateCache.put("view/controller/site/layouts/index.tmpl.html","<div class=\"full-image-background mb-bg-fb-05\" layout=\"row\" layout-fill=\"\"><div class=\"animate-wrapper\" flex=\"\" layout=\"row\"><div id=\"ui-login\" class=\"login-frame\" ui-view=\"\" flex=\"\" layout=\"column\"></div></div></div>");
$templateCache.put("view/authentication/_content.html","<div id=\"wrapper\" class=\"top-navigation\"><div id=\"page-wrapper\" class=\"gray-bg {{$state.current.name}}\"><div class=\"wrapper wrapper-content\"><div ui-view=\"\"></div></div></div></div>");
$templateCache.put("view/authentication/index.html","<div ui-view=\"\"></div>");
$templateCache.put("view/common/401.tmpl.html","<h3>Página de teste</h3>");
$templateCache.put("view/common/404.tmpl.html","<h1>erro 404</h1>");
$templateCache.put("view/common/500.tmpl.html","<h1>erro 500</h1>");
$templateCache.put("view/common/breadcrumb.html","<div class=\"row\"><nav class=\"navbar purple-bg\" role=\"navigation\" style=\"margin-bottom: 0\"><div class=\"navbar-header\"></div><ul class=\"nav navbar-top-links navbar-left\"><li><h2 class=\"title\">{{title}}</h2></li></ul><ul class=\"nav navbar-top-links navbar-right\"><li class=\"breadcrumb-nav-item\"><h4 class=\"text-white\">{{usuario}}</h4><h5 class=\"text-white\">{{estabelecimento}}</h5></li><li uib-dropdown=\"\"><a href=\"\" uib-dropdown-toggle=\"\"><img src=\"../img/icons/more_vert.png\" style=\"width: 25px; height: 100%;\"><div class=\"md-ripple-container\"></div></a><ul role=\"menu\" uib-dropdown-menu=\"\"><li ng-if=\"quantidade_estabelecimento > 1\"><a href=\"/#/establishment\">Mudar de estabelecimento</a></li><li class=\"m-t\"><a href=\"#\">Sair</a></li></ul></li></ul></nav></div>");
$templateCache.put("view/common/confirm.html","<div class=\"modal-header\"><h3 class=\"modal-title\">{{vm.itm.tit}}</h3></div><div class=\"modal-body\"><p>{{vm.itm.msg}}</p></div><div class=\"modal-footer\"><button class=\"btn btn-outline btn-link pull-right\" type=\"button\" ng-click=\"vm.no();\">Não</button> <button class=\"btn btn-w-m btn-success pull-right\" type=\"button\" ng-click=\"vm.yes();\">Sim</button></div>");
$templateCache.put("view/common/content.html","<div id=\"wrapper\"><div ng-include=\"\'views/common/navigation.html\'\"></div><div id=\"page-wrapper\" class=\"gray-bg {{$state.current.name}}\"><div ng-include=\"\'views/common/topnavbar.html\'\"></div><div ui-view=\"\"></div><div ng-include=\"\'views/common/footer.html\'\"></div></div><div ng-include=\"\'views/common/right_sidebar.html\'\"></div></div>");
$templateCache.put("view/common/content_top_navigation.html","<div id=\"wrapper\" class=\"top-navigation\"><div ng-include=\"\'views/common/top_navigation.html\'\"></div><div id=\"page-wrapper\" class=\"gray-bg {{$state.current.name}}\"><div ui-view=\"\"></div><div ng-include=\"\'views/common/footer.html\'\"></div></div></div>");
$templateCache.put("view/common/footer.html","<div class=\"footer fixed\"><div><strong>Copyright</strong> Divertix &copy; 2017</div></div>");
$templateCache.put("view/common/ibox_tools.html","<div class=\"ibox-tools\" uib-dropdown=\"\"><a ng-click=\"showhide()\"><i class=\"fa fa-chevron-up\"></i></a> <a href=\"\" uib-dropdown-toggle=\"\"><i class=\"fa fa-wrench\"></i></a><ul uib-dropdown-menu=\"\"><li><a href=\"\">Config option 1</a></li><li><a href=\"\">Config option 2</a></li></ul><a ng-click=\"closebox()\"><i class=\"fa fa-times\"></i></a></div>");
$templateCache.put("view/common/ibox_tools_full_screen.html","<div class=\"ibox-tools\" uib-dropdown=\"\"><a ng-click=\"showhide()\"><i class=\"fa fa-chevron-up\"></i></a> <a ng-click=\"fullscreen()\"><i class=\"fa fa-expand\"></i></a> <a href=\"\" uib-dropdown-toggle=\"\"><i class=\"fa fa-wrench\"></i></a><ul class=\"dropdown-user\" uib-dropdown-menu=\"\"><li><a href=\"\">Config option 1</a></li><li><a href=\"\">Config option 2</a></li></ul><a ng-click=\"closebox()\"><i class=\"fa fa-times\"></i></a></div>");
$templateCache.put("view/common/navigation.html","<nav class=\"navbar-default navbar-static-side\" role=\"navigation\"><div class=\"sidebar-collapse\"><ul side-navigation=\"\" class=\"nav metismenu\" id=\"side-menu\"><li class=\"nav-header\"><div class=\"dropdown profile-element\"><a data-toggle=\"dropdown\" class=\"dropdown-toggle\" ui-sref=\"site.home\"><h1><strong><i class=\"{{vm.appSettings.logo}}\"></i> {{vm.appSettings.name}}</strong></h1></a></div></li><li ng-repeat=\"itm in vm.items\" ng-class=\"{divider: itm.type == \'divider\', active: $state.includes(itm.state)}\"><a ng-if=\"itm.type != \'divider\'\" href=\"index.html\"><i class=\"{{itm.icon}}\"></i> <span class=\"nav-label\">{{itm.name}}</span> <span class=\"fa arrow\"></span></a><ul ng-if=\"itm.childs\" class=\"nav nav-second-level collapse\" ng-class=\"{in: $state.includes(itm.state)}\"><li ng-repeat=\"itm2 in itm.childs | filter:{second:true}\" ui-sref-active=\"active\"><a ui-sref=\"{{itm2.state}}\">{{ itm2.name }}</a></li><li ng-repeat=\"itm3 in itm.childs | filter:{third:true}\" ng-class=\"{divider: itm3.type == \'divider\', active: $state.includes(itm3.state)}\"><a ng-if=\"itm3.type != \'divider\'\" href=\"index.html\"><i class=\"{{itm3.icon}}\"></i> <span class=\"nav-label\">{{itm3.name}}</span> <span class=\"fa arrow\"></span></a><ul ng-if=\"itm3.childs\" class=\"nav nav-third-level collapse\" ng-class=\"{in: $state.includes(itm3.state)}\"><li ng-repeat=\"itm4 in itm3.childs | filter:{second:true}\" ui-sref-active=\"active\"><a ui-sref=\"{{itm4.state}}\">{{ itm4.name }}</a></li></ul></li></ul></li></ul></div></nav>");
$templateCache.put("view/common/navigation_full_height.html","<nav class=\"navbar-default navbar-static-side\" role=\"navigation\"><div class=\"sidebar-collapse\" full-scroll=\"\"><ul side-navigation=\"\" class=\"nav metismenu\" id=\"side-menu\"><li class=\"nav-header\"><div class=\"profile-element\" uib-dropdown=\"\"><img alt=\"image\" class=\"img-circle\" src=\"img/profile_small.jpg\"> <a uib-dropdown-toggle=\"\" href=\"\"><span class=\"clear\"><span class=\"block m-t-xs\"><strong class=\"font-bold\">David Williams</strong></span> <span class=\"text-muted text-xs block\">Art Director <b class=\"caret\"></b></span></span></a><ul uib-dropdown-menu=\"\" class=\"animated fadeInRight m-t-xs\"><li><a ui-sref=\"profile\">Profile</a></li><li><a ui-sref=\"contacts\">Contacts</a></li><li><a ui-sref=\"inbox\">Mailbox</a></li><li class=\"divider\"></li><li><a href=\"../login.html\">Logout</a></li></ul></div><div class=\"logo-element\">IN+</div></li><li ng-class=\"{active: $state.includes(\'dashboards\')}\"><a href=\"index.html\"><i class=\"fa fa-th-large\"></i> <span class=\"nav-label\">{{ \'DASHBOARD\' | translate }}</span> <span class=\"fa arrow\"></span></a><ul class=\"nav nav-second-level\" ng-class=\"{in: $state.includes(\'dashboards\')}\"><li ui-sref-active=\"active\"><a ui-sref=\"dashboards.dashboard_1\">{{ \'DASHBOARD\' | translate }} v.1</a></li><li ui-sref-active=\"active\"><a ui-sref=\"dashboards.dashboard_2\">{{ \'DASHBOARD\' | translate }} v.2</a></li><li ui-sref-active=\"active\"><a ui-sref=\"dashboards.dashboard_3\">{{ \'DASHBOARD\' | translate }} v.3</a></li><li ui-sref-active=\"active\"><a ui-sref=\"dashboards.dashboard_4_1\">{{ \'DASHBOARD\' | translate }} v.4</a></li></ul></li><li ui-sref-active=\"active\"><a ui-sref=\"layouts\"><i class=\"fa fa-diamond\"></i> <span class=\"nav-label\">{{ \'LAYOUTS\' | translate }}</span></a></li><li ng-class=\"{active: $state.includes(\'charts\')}\"><a href=\"\"><i class=\"fa fa-bar-chart-o\"></i> <span class=\"nav-label\">{{ \'GRAPHS\' | translate }}</span><span class=\"fa arrow\"></span></a><ul class=\"nav nav-second-level\" ng-class=\"{in: $state.includes(\'charts\')}\"><li ui-sref-active=\"active\"><a ui-sref=\"charts.flot_chart\">Flot Charts</a></li><li ui-sref-active=\"active\"><a ui-sref=\"charts.rickshaw_chart\">Rickshaw Charts</a></li><li ui-sref-active=\"active\"><a ui-sref=\"charts.chartjs_chart\">Chart.js</a></li><li ui-sref-active=\"active\"><a ui-sref=\"charts.chartist_chart\">Chartist</a></li><li ui-sref-active=\"active\"><a ui-sref=\"charts.peity_chart\">Peity Charts</a></li><li ui-sref-active=\"active\"><a ui-sref=\"charts.sparkline_chart\">Sparkline Charts</a></li></ul></li><li ng-class=\"{active: $state.includes(\'mailbox\')}\"><a ui-sref=\"inbox\"><i class=\"fa fa-envelope\"></i> <span class=\"nav-label\">{{ \'MAILBOX\' | translate }}</span><span class=\"label label-warning pull-right\">16/24</span></a><ul class=\"nav nav-second-level\" ng-class=\"{in: $state.includes(\'mailbox\')}\"><li ui-sref-active=\"active\"><a ui-sref=\"mailbox.inbox\">Inbox</a></li><li ui-sref-active=\"active\"><a ui-sref=\"mailbox.email_view\">Email view</a></li><li ui-sref-active=\"active\"><a ui-sref=\"mailbox.email_compose\">Compose email</a></li><li ui-sref-active=\"active\"><a ui-sref=\"mailbox.email_template\">Email template</a></li></ul></li><li ui-sref-active=\"active\"><a ui-sref=\"metrics\"><i class=\"fa fa-pie-chart\"></i> <span class=\"nav-label\">{{ \'METRICS\' | translate }}</span> <span class=\"label label-primary pull-right\">NEW</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"widgets\"><i class=\"fa fa-flask\"></i> <span class=\"nav-label\">{{ \'WIDGETS\' | translate }}</span></a></li><li ng-class=\"{active: $state.includes(\'forms\')}\"><a href=\"\"><i class=\"fa fa-edit\"></i> <span class=\"nav-label\">{{ \'FORMS\' | translate }}</span><span class=\"fa arrow\"></span></a><ul class=\"nav nav-second-level\" ng-class=\"{in: $state.includes(\'forms\')}\"><li ui-sref-active=\"active\"><a ui-sref=\"forms.basic_form\">Basic form</a></li><li ui-sref-active=\"active\"><a ui-sref=\"forms.advanced_plugins\">Advanced Plugins</a></li><li ui-sref-active=\"active\"><a ui-sref=\"forms.wizard.step_one\">Wizard</a></li><li ui-sref-active=\"active\"><a ui-sref=\"forms.file_upload\">File Upload</a></li><li ui-sref-active=\"active\"><a ui-sref=\"forms.text_editor\">Text Editor</a></li></ul></li><li ng-class=\"{active: $state.includes(\'app\')}\"><a href=\"\"><i class=\"fa fa-desktop\"></i> <span class=\"nav-label\">{{ \'APPVIEWS\' | translate }}</span> <span class=\"pull-right label label-primary\">SPECIAL</span></a><ul class=\"nav nav-second-level\" ng-class=\"{in: $state.includes(\'app\')}\"><li ui-sref-active=\"active\"><a ui-sref=\"app.contacts\">Contacts</a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.profile\">Profile</a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.projects\">Projects</a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.project_detail\">Project detail</a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.teams_board\">Teams board</a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.social_feed\">Social feed</a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.clients\">Clients</a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.file_manager\">File manager</a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.calendar\">Calendar</a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.issue_tracker\">Issue tracker</a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.blog\">Blog</a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.article\">Article</a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.faq\">FAQ</a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.timeline\">Timeline</a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.pin_board\">Pin board</a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.invoice\">Invoice</a></li></ul></li><li ng-class=\"{active: $state.includes(\'pages\')}\"><a href=\"\"><i class=\"fa fa-files-o\"></i> <span class=\"nav-label\">{{ \'OTHERPAGES\' | translate }}</span><span class=\"fa arrow\"></span></a><ul class=\"nav nav-second-level\" ng-class=\"{in: $state.includes(\'pages\')}\"><li ui-sref-active=\"active\"><a ui-sref=\"pages.search_results\">Search results</a></li><li><a ui-sref=\"lockscreen\">Lockscreen</a></li><li><a ui-sref=\"errorOne\">404 Page</a></li><li><a ui-sref=\"errorTwo\">500 Page</a></li><li><a ui-sref=\"login\">Login</a></li><li><a ui-sref=\"login_two_columns\">Login v.2</a></li><li><a ui-sref=\"forgot_password\">Forgot password</a></li><li><a ui-sref=\"register\">Register</a></li><li ui-sref-active=\"active\"><a ui-sref=\"pages.empy_page\">Empty page</a></li></ul></li><li ng-class=\"{active: $state.includes(\'miscellaneous\')}\"><a href=\"\"><i class=\"fa fa-globe\"></i> <span class=\"nav-label\">{{ \'MISCELLANEOUS\' | translate }}</span> <span class=\"label label-info pull-right\">NEW</span></a><ul class=\"nav nav-second-level\" ng-class=\"{in: $state.includes(\'miscellaneous\')}\"><li ui-sref-active=\"active\"><a ui-sref=\"miscellaneous.notify\">Notification</a></li><li ui-sref-active=\"active\"><a ui-sref=\"miscellaneous.nestable_list\">Nestable list</a></li><li ui-sref-active=\"active\"><a ui-sref=\"miscellaneous.agile_board\">Agile board</a></li><li ui-sref-active=\"active\"><a ui-sref=\"miscellaneous.timeline_2\">Timeline v.2</a></li><li ui-sref-active=\"active\"><a ui-sref=\"miscellaneous.diff\">Diff</a></li><li ui-sref-active=\"active\"><a ui-sref=\"miscellaneous.sweet_alert\">Sweet alert</a></li><li ui-sref-active=\"active\"><a ui-sref=\"miscellaneous.idle_timer\">Idle timer</a></li><li ui-sref-active=\"active\"><a ui-sref=\"miscellaneous.spinners\">Spinners</a></li><li ui-sref-active=\"active\"><a ui-sref=\"miscellaneous.live_favicon\">Live favicon</a></li><li ui-sref-active=\"active\"><a ui-sref=\"miscellaneous.google_maps\">Google maps</a></li><li ui-sref-active=\"active\"><a ui-sref=\"miscellaneous.code_editor\">Code editor</a></li><li ui-sref-active=\"active\"><a ui-sref=\"miscellaneous.forum_view\">Forum view</a></li><li ui-sref-active=\"active\"><a ui-sref=\"miscellaneous.validation\">Validation</a></li><li ui-sref-active=\"active\"><a ui-sref=\"miscellaneous.modal_window\">Modal window</a></li><li ui-sref-active=\"active\"><a ui-sref=\"miscellaneous.chat_view\">Chat view</a></li></ul></li><li ng-class=\"{active: $state.includes(\'ui\')}\"><a href=\"\"><i class=\"fa fa-flask\"></i> <span class=\"nav-label\">{{ \'UIELEMENTS\' | translate }}</span><span class=\"fa arrow\"></span></a><ul class=\"nav nav-second-level\" ng-class=\"{in: $state.includes(\'ui\')}\"><li ui-sref-active=\"active\"><a ui-sref=\"ui.typography\">Typography</a></li><li ui-sref-active=\"active\"><a ui-sref=\"ui.icons\">Icons</a></li><li ui-sref-active=\"active\"><a ui-sref=\"ui.draggable\">Draggable Panels</a></li><li ui-sref-active=\"active\"><a ui-sref=\"ui.buttons\">Buttons</a></li><li ui-sref-active=\"active\"><a ui-sref=\"ui.video\">Video</a></li><li ui-sref-active=\"active\"><a ui-sref=\"ui.tabs_panels\">Panels</a></li><li ui-sref-active=\"active\"><a ui-sref=\"ui.tabs\">Tabs</a></li><li ui-sref-active=\"active\"><a ui-sref=\"ui.notifications_tooltips\">Notifications & Tooltips</a></li><li ui-sref-active=\"active\"><a ui-sref=\"ui.badges_labels\">Badges, Labels, Progress</a></li></ul></li><li ui-sref-active=\"active\"><a ui-sref=\"grid_options\"><i class=\"fa fa-laptop\"></i> <span class=\"nav-label\">{{ \'GRIDOPTIONS\' | translate }}</span></a></li><li ng-class=\"{active: $state.includes(\'tables\')}\"><a href=\"\"><i class=\"fa fa-table\"></i> <span class=\"nav-label\">{{ \'TABLES\' | translate }}</span><span class=\"fa arrow\"></span></a><ul class=\"nav nav-second-level\" ng-class=\"{in: $state.includes(\'tables\')}\"><li ui-sref-active=\"active\"><a ui-sref=\"tables.static_table\">Static Tables</a></li><li ui-sref-active=\"active\"><a ui-sref=\"tables.data_tables\">Data Tables</a></li><li ui-sref-active=\"active\"><a ui-sref=\"tables.foo_table\">Foo Table</a></li><li ui-sref-active=\"active\"><a ui-sref=\"tables.nggrid\">NG Grid</a></li></ul></li><li ng-class=\"{active: $state.includes(\'commerce\')}\"><a href=\"#\"><i class=\"fa fa-shopping-cart\"></i> <span class=\"nav-label\">{{ \'COMMERCE\' | translate }}</span><span class=\"fa arrow\"></span></a><ul class=\"nav nav-second-level\" ng-class=\"{in: $state.includes(\'commerce\')}\"><li ui-sref-active=\"active\"><a ui-sref=\"commerce.products_grid\">Products list (front)</a></li><li ui-sref-active=\"active\"><a ui-sref=\"commerce.product_list\">Product list (admin)</a></li><li ui-sref-active=\"active\"><a ui-sref=\"commerce.product\">Product edit</a></li><li ui-sref-active=\"active\"><a ui-sref=\"commerce.orders\">Orders</a></li></ul></li><li ng-class=\"{active: $state.includes(\'gallery\')}\"><a href=\"\"><i class=\"fa fa-picture-o\"></i> <span class=\"nav-label\">{{ \'GALLERY\' | translate }}</span><span class=\"fa arrow\"></span></a><ul class=\"nav nav-second-level\" ng-class=\"{in: $state.includes(\'gallery\')}\"><li ui-sref-active=\"active\"><a ui-sref=\"gallery.basic_gallery\">Lightbox Gallery</a></li><li ui-sref-active=\"active\"><a ui-sref=\"gallery.bootstrap_carousel\">Bootstrap Carusela</a></li></ul></li><li><a href=\"\"><i class=\"fa fa-sitemap\"></i> <span class=\"nav-label\">{{ \'MENULEVELS\' | translate }}</span><span class=\"fa arrow\"></span></a><ul class=\"nav nav-second-level\"><li><a href=\"\">Third Level <span class=\"fa arrow\"></span></a><ul class=\"nav nav-third-level\"><li><a href=\"\">Third Level Item</a></li><li><a href=\"\">Third Level Item</a></li><li><a href=\"\">Third Level Item</a></li></ul></li><li><a href=\"\">Second Level Item</a></li><li><a href=\"\">Second Level Item</a></li><li><a href=\"\">Second Level Item</a></li></ul></li><li ui-sref-active=\"active\"><a ui-sref=\"css_animations\"><i class=\"fa fa-magic\"></i> <span class=\"nav-label\">{{ \'ANIMATIONS\' | translate }}</span><span class=\"label label-info pull-right\">62</span></a></li><li class=\"landing_link\"><a ui-sref=\"landing\"><i class=\"fa fa-star\"></i> <span class=\"nav-label\">{{ \'LANDING\' | translate }}</span> <span class=\"label label-warning pull-right\">NEW</span></a></li></ul></div></nav>");
$templateCache.put("view/common/navigation_off_canvas.html","<nav class=\"navbar-default navbar-static-side\" role=\"navigation\"><div class=\"sidebar-collapse\" full-scroll=\"\"><span close-off-canvas=\"\"></span><ul side-navigation=\"\" class=\"nav metismenu\" id=\"side-menu\"><li class=\"nav-header\"><div class=\"profile-element\" uib-dropdown=\"\"><img alt=\"image\" class=\"img-circle\" src=\"img/profile_small.jpg\"> <a uib-dropdown-toggle=\"\" href=\"\"><span class=\"clear\"><span class=\"block m-t-xs\"><strong class=\"font-bold\">David Williams</strong></span> <span class=\"text-muted text-xs block\">Art Director <b class=\"caret\"></b></span></span></a><ul uib-dropdown-menu=\"\" class=\"animated fadeInRight m-t-xs\"><li><a ui-sref=\"profile\">Profile</a></li><li><a ui-sref=\"contacts\">Contacts</a></li><li><a ui-sref=\"inbox\">Mailbox</a></li><li class=\"divider\"></li><li><a href=\"../login.html\">Logout</a></li></ul></div><div class=\"logo-element\">IN+</div></li><li ng-class=\"{active: $state.includes(\'dashboards\')}\"><a href=\"index.html\"><i class=\"fa fa-th-large\"></i> <span class=\"nav-label\">{{ \'DASHBOARD\' | translate }}</span> <span class=\"fa arrow\"></span></a><ul class=\"nav nav-second-level\" ng-class=\"{in: $state.includes(\'dashboards\')}\"><li ui-sref-active=\"active\"><a ui-sref=\"dashboards.dashboard_1\">{{ \'DASHBOARD\' | translate }} v.1</a></li><li ui-sref-active=\"active\"><a ui-sref=\"dashboards.dashboard_2\">{{ \'DASHBOARD\' | translate }} v.2</a></li><li ui-sref-active=\"active\"><a ui-sref=\"dashboards.dashboard_3\">{{ \'DASHBOARD\' | translate }} v.3</a></li><li ui-sref-active=\"active\"><a ui-sref=\"dashboards.dashboard_4_1\">{{ \'DASHBOARD\' | translate }} v.4</a></li></ul></li><li ui-sref-active=\"active\"><a ui-sref=\"layouts\"><i class=\"fa fa-diamond\"></i> <span class=\"nav-label\">{{ \'LAYOUTS\' | translate }}</span></a></li><li ng-class=\"{active: $state.includes(\'charts\')}\"><a href=\"\"><i class=\"fa fa-bar-chart-o\"></i> <span class=\"nav-label\">{{ \'GRAPHS\' | translate }}</span><span class=\"fa arrow\"></span></a><ul class=\"nav nav-second-level\" ng-class=\"{in: $state.includes(\'charts\')}\"><li ui-sref-active=\"active\"><a ui-sref=\"charts.flot_chart\">Flot Charts</a></li><li ui-sref-active=\"active\"><a ui-sref=\"charts.rickshaw_chart\">Rickshaw Charts</a></li><li ui-sref-active=\"active\"><a ui-sref=\"charts.chartjs_chart\">Chart.js</a></li><li ui-sref-active=\"active\"><a ui-sref=\"charts.chartist_chart\">Chartist</a></li><li ui-sref-active=\"active\"><a ui-sref=\"charts.peity_chart\">Peity Charts</a></li><li ui-sref-active=\"active\"><a ui-sref=\"charts.sparkline_chart\">Sparkline Charts</a></li></ul></li><li ng-class=\"{active: $state.includes(\'mailbox\')}\"><a ui-sref=\"inbox\"><i class=\"fa fa-envelope\"></i> <span class=\"nav-label\">{{ \'MAILBOX\' | translate }}</span><span class=\"label label-warning pull-right\">16/24</span></a><ul class=\"nav nav-second-level\" ng-class=\"{in: $state.includes(\'mailbox\')}\"><li ui-sref-active=\"active\"><a ui-sref=\"mailbox.inbox\">Inbox</a></li><li ui-sref-active=\"active\"><a ui-sref=\"mailbox.email_view\">Email view</a></li><li ui-sref-active=\"active\"><a ui-sref=\"mailbox.email_compose\">Compose email</a></li><li ui-sref-active=\"active\"><a ui-sref=\"mailbox.email_template\">Email template</a></li></ul></li><li ui-sref-active=\"active\"><a ui-sref=\"metrics\"><i class=\"fa fa-pie-chart\"></i> <span class=\"nav-label\">{{ \'METRICS\' | translate }}</span> <span class=\"label label-primary pull-right\">NEW</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"widgets\"><i class=\"fa fa-flask\"></i> <span class=\"nav-label\">{{ \'WIDGETS\' | translate }}</span></a></li><li ng-class=\"{active: $state.includes(\'forms\')}\"><a href=\"\"><i class=\"fa fa-edit\"></i> <span class=\"nav-label\">{{ \'FORMS\' | translate }}</span><span class=\"fa arrow\"></span></a><ul class=\"nav nav-second-level\" ng-class=\"{in: $state.includes(\'forms\')}\"><li ui-sref-active=\"active\"><a ui-sref=\"forms.basic_form\">Basic form</a></li><li ui-sref-active=\"active\"><a ui-sref=\"forms.advanced_plugins\">Advanced Plugins</a></li><li ui-sref-active=\"active\"><a ui-sref=\"forms.wizard.step_one\">Wizard</a></li><li ui-sref-active=\"active\"><a ui-sref=\"forms.file_upload\">File Upload</a></li><li ui-sref-active=\"active\"><a ui-sref=\"forms.text_editor\">Text Editor</a></li></ul></li><li ng-class=\"{active: $state.includes(\'app\')}\"><a href=\"\"><i class=\"fa fa-desktop\"></i> <span class=\"nav-label\">{{ \'APPVIEWS\' | translate }}</span> <span class=\"pull-right label label-primary\">SPECIAL</span></a><ul class=\"nav nav-second-level\" ng-class=\"{in: $state.includes(\'app\')}\"><li ui-sref-active=\"active\"><a ui-sref=\"app.contacts\">Contacts</a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.profile\">Profile</a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.projects\">Projects</a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.project_detail\">Project detail</a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.teams_board\">Teams board</a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.social_feed\">Social feed</a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.clients\">Clients</a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.file_manager\">File manager</a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.calendar\">Calendar</a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.issue_tracker\">Issue tracker</a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.blog\">Blog</a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.article\">Article</a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.faq\">FAQ</a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.timeline\">Timeline</a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.pin_board\">Pin board</a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.invoice\">Invoice</a></li></ul></li><li ng-class=\"{active: $state.includes(\'pages\')}\"><a href=\"\"><i class=\"fa fa-files-o\"></i> <span class=\"nav-label\">{{ \'OTHERPAGES\' | translate }}</span><span class=\"fa arrow\"></span></a><ul class=\"nav nav-second-level\" ng-class=\"{in: $state.includes(\'pages\')}\"><li ui-sref-active=\"active\"><a ui-sref=\"pages.search_results\">Search results</a></li><li><a ui-sref=\"lockscreen\">Lockscreen</a></li><li><a ui-sref=\"errorOne\">404 Page</a></li><li><a ui-sref=\"errorTwo\">500 Page</a></li><li><a ui-sref=\"login\">Login</a></li><li><a ui-sref=\"login_two_columns\">Login v.2</a></li><li><a ui-sref=\"forgot_password\">Forgot password</a></li><li><a ui-sref=\"register\">Register</a></li><li ui-sref-active=\"active\"><a ui-sref=\"pages.empy_page\">Empty page</a></li></ul></li><li ng-class=\"{active: $state.includes(\'miscellaneous\')}\"><a href=\"\"><i class=\"fa fa-globe\"></i> <span class=\"nav-label\">{{ \'MISCELLANEOUS\' | translate }}</span> <span class=\"label label-info pull-right\">NEW</span></a><ul class=\"nav nav-second-level\" ng-class=\"{in: $state.includes(\'miscellaneous\')}\"><li ui-sref-active=\"active\"><a ui-sref=\"miscellaneous.notify\">Notification</a></li><li ui-sref-active=\"active\"><a ui-sref=\"miscellaneous.nestable_list\">Nestable list</a></li><li ui-sref-active=\"active\"><a ui-sref=\"miscellaneous.agile_board\">Agile board</a></li><li ui-sref-active=\"active\"><a ui-sref=\"miscellaneous.timeline_2\">Timeline v.2</a></li><li ui-sref-active=\"active\"><a ui-sref=\"miscellaneous.diff\">Diff</a></li><li ui-sref-active=\"active\"><a ui-sref=\"miscellaneous.sweet_alert\">Sweet alert</a></li><li ui-sref-active=\"active\"><a ui-sref=\"miscellaneous.idle_timer\">Idle timer</a></li><li ui-sref-active=\"active\"><a ui-sref=\"miscellaneous.spinners\">Spinners</a></li><li ui-sref-active=\"active\"><a ui-sref=\"miscellaneous.live_favicon\">Live favicon</a></li><li ui-sref-active=\"active\"><a ui-sref=\"miscellaneous.google_maps\">Google maps</a></li><li ui-sref-active=\"active\"><a ui-sref=\"miscellaneous.code_editor\">Code editor</a></li><li ui-sref-active=\"active\"><a ui-sref=\"miscellaneous.forum_view\">Forum view</a></li><li ui-sref-active=\"active\"><a ui-sref=\"miscellaneous.validation\">Validation</a></li><li ui-sref-active=\"active\"><a ui-sref=\"miscellaneous.modal_window\">Modal window</a></li><li ui-sref-active=\"active\"><a ui-sref=\"miscellaneous.chat_view\">Chat view</a></li></ul></li><li ng-class=\"{active: $state.includes(\'ui\')}\"><a href=\"\"><i class=\"fa fa-flask\"></i> <span class=\"nav-label\">{{ \'UIELEMENTS\' | translate }}</span><span class=\"fa arrow\"></span></a><ul class=\"nav nav-second-level\" ng-class=\"{in: $state.includes(\'ui\')}\"><li ui-sref-active=\"active\"><a ui-sref=\"ui.typography\">Typography</a></li><li ui-sref-active=\"active\"><a ui-sref=\"ui.icons\">Icons</a></li><li ui-sref-active=\"active\"><a ui-sref=\"ui.draggable\">Draggable Panels</a></li><li ui-sref-active=\"active\"><a ui-sref=\"ui.buttons\">Buttons</a></li><li ui-sref-active=\"active\"><a ui-sref=\"ui.video\">Video</a></li><li ui-sref-active=\"active\"><a ui-sref=\"ui.tabs_panels\">Panels</a></li><li ui-sref-active=\"active\"><a ui-sref=\"ui.tabs\">Tabs</a></li><li ui-sref-active=\"active\"><a ui-sref=\"ui.notifications_tooltips\">Notifications & Tooltips</a></li><li ui-sref-active=\"active\"><a ui-sref=\"ui.badges_labels\">Badges, Labels, Progress</a></li></ul></li><li ui-sref-active=\"active\"><a ui-sref=\"grid_options\"><i class=\"fa fa-laptop\"></i> <span class=\"nav-label\">{{ \'GRIDOPTIONS\' | translate }}</span></a></li><li ng-class=\"{active: $state.includes(\'tables\')}\"><a href=\"\"><i class=\"fa fa-table\"></i> <span class=\"nav-label\">{{ \'TABLES\' | translate }}</span><span class=\"fa arrow\"></span></a><ul class=\"nav nav-second-level\" ng-class=\"{in: $state.includes(\'tables\')}\"><li ui-sref-active=\"active\"><a ui-sref=\"tables.static_table\">Static Tables</a></li><li ui-sref-active=\"active\"><a ui-sref=\"tables.data_tables\">Data Tables</a></li><li ui-sref-active=\"active\"><a ui-sref=\"tables.foo_table\">Foo Table</a></li><li ui-sref-active=\"active\"><a ui-sref=\"tables.nggrid\">NG Grid</a></li></ul></li><li ng-class=\"{active: $state.includes(\'commerce\')}\"><a href=\"#\"><i class=\"fa fa-shopping-cart\"></i> <span class=\"nav-label\">{{ \'COMMERCE\' | translate }}</span><span class=\"fa arrow\"></span></a><ul class=\"nav nav-second-level\" ng-class=\"{in: $state.includes(\'commerce\')}\"><li ui-sref-active=\"active\"><a ui-sref=\"commerce.products_grid\">Products list (front)</a></li><li ui-sref-active=\"active\"><a ui-sref=\"commerce.product_list\">Product list (admin)</a></li><li ui-sref-active=\"active\"><a ui-sref=\"commerce.product\">Product edit</a></li><li ui-sref-active=\"active\"><a ui-sref=\"commerce.orders\">Orders</a></li></ul></li><li ng-class=\"{active: $state.includes(\'gallery\')}\"><a href=\"\"><i class=\"fa fa-picture-o\"></i> <span class=\"nav-label\">{{ \'GALLERY\' | translate }}</span><span class=\"fa arrow\"></span></a><ul class=\"nav nav-second-level\" ng-class=\"{in: $state.includes(\'gallery\')}\"><li ui-sref-active=\"active\"><a ui-sref=\"gallery.basic_gallery\">Lightbox Gallery</a></li><li ui-sref-active=\"active\"><a ui-sref=\"gallery.bootstrap_carousel\">Bootstrap Carusela</a></li></ul></li><li><a href=\"\"><i class=\"fa fa-sitemap\"></i> <span class=\"nav-label\">{{ \'MENULEVELS\' | translate }}</span><span class=\"fa arrow\"></span></a><ul class=\"nav nav-second-level\"><li><a href=\"\">Third Level <span class=\"fa arrow\"></span></a><ul class=\"nav nav-third-level\"><li><a href=\"\">Third Level Item</a></li><li><a href=\"\">Third Level Item</a></li><li><a href=\"\">Third Level Item</a></li></ul></li><li><a href=\"\">Second Level Item</a></li><li><a href=\"\">Second Level Item</a></li><li><a href=\"\">Second Level Item</a></li></ul></li><li ui-sref-active=\"active\"><a ui-sref=\"css_animations\"><i class=\"fa fa-magic\"></i> <span class=\"nav-label\">{{ \'ANIMATIONS\' | translate }}</span><span class=\"label label-info pull-right\">62</span></a></li><li class=\"landing_link\"><a ui-sref=\"landing\"><i class=\"fa fa-star\"></i> <span class=\"nav-label\">{{ \'LANDING\' | translate }}</span> <span class=\"label label-warning pull-right\">NEW</span></a></li></ul></div></nav>");
$templateCache.put("view/common/notify.html","<div class=\"cg-notify-message inspinia-notify\" ng-class=\"$classes\"><div class=\"p-lg\"><div ng-show=\"!$messageTemplate\">{{$message}}</div><div ng-show=\"$messageTemplate\" class=\"cg-notify-message-template\"></div><button type=\"button\" class=\"cg-notify-close\" ng-click=\"$close()\"><span aria-hidden=\"true\">&times;</span> <span class=\"cg-notify-sr-only\">Close</span></button></div></div>");
$templateCache.put("view/common/right_sidebar.html","<div id=\"right-sidebar\" ng-show=\"rightSidebar\" class=\"sidebar-open\"><div class=\"sidebar-container\" full-scroll=\"\"><ul class=\"nav nav-tabs navs-3\"><li ng-class=\"{active: tab1}\"><a ng-click=\"tab1 = true; tab2 = false; tab3 = false\" ng-init=\"tab1 = true\">Notes</a></li><li ng-class=\"{active: tab2}\"><a ng-click=\"tab2 = true; tab1 = false; tab3 = false\">Projects</a></li><li ng-class=\"{active: tab3}\"><a ng-click=\"tab3 = true; tab1 = false; tab2 = false\"><i class=\"fa fa-gear\"></i></a></li></ul><div class=\"tab-content\"><div class=\"tab-pane\" ng-class=\"{active: tab1}\"><div class=\"sidebar-title\"><h3><i class=\"fa fa-comments-o\"></i> Latest Notes</h3><small><i class=\"fa fa-tim\"></i> You have 10 new message.</small></div><div><div class=\"sidebar-message\"><a href=\"#\"><div class=\"pull-left text-center\"><img alt=\"image\" class=\"img-circle message-avatar\" src=\"img/a1.jpg\"><div class=\"m-t-xs\"><i class=\"fa fa-star text-warning\"></i> <i class=\"fa fa-star text-warning\"></i></div></div><div class=\"media-body\">There are many variations of passages of Lorem Ipsum available.<br><small class=\"text-muted\">Today 4:21 pm</small></div></a></div><div class=\"sidebar-message\"><a href=\"#\"><div class=\"pull-left text-center\"><img alt=\"image\" class=\"img-circle message-avatar\" src=\"img/a2.jpg\"></div><div class=\"media-body\">The point of using Lorem Ipsum is that it has a more-or-less normal.<br><small class=\"text-muted\">Yesterday 2:45 pm</small></div></a></div><div class=\"sidebar-message\"><a href=\"#\"><div class=\"pull-left text-center\"><img alt=\"image\" class=\"img-circle message-avatar\" src=\"img/a3.jpg\"><div class=\"m-t-xs\"><i class=\"fa fa-star text-warning\"></i> <i class=\"fa fa-star text-warning\"></i> <i class=\"fa fa-star text-warning\"></i></div></div><div class=\"media-body\">Mevolved over the years, sometimes by accident, sometimes on purpose (injected humour and the like).<br><small class=\"text-muted\">Yesterday 1:10 pm</small></div></a></div><div class=\"sidebar-message\"><a href=\"#\"><div class=\"pull-left text-center\"><img alt=\"image\" class=\"img-circle message-avatar\" src=\"img/a4.jpg\"></div><div class=\"media-body\">Lorem Ipsum, you need to be sure there isn\'t anything embarrassing hidden in the<br><small class=\"text-muted\">Monday 8:37 pm</small></div></a></div><div class=\"sidebar-message\"><a href=\"#\"><div class=\"pull-left text-center\"><img alt=\"image\" class=\"img-circle message-avatar\" src=\"img/a8.jpg\"></div><div class=\"media-body\">All the Lorem Ipsum generators on the Internet tend to repeat.<br><small class=\"text-muted\">Today 4:21 pm</small></div></a></div><div class=\"sidebar-message\"><a href=\"#\"><div class=\"pull-left text-center\"><img alt=\"image\" class=\"img-circle message-avatar\" src=\"img/a7.jpg\"></div><div class=\"media-body\">Renaissance. The first line of Lorem Ipsum, \"Lorem ipsum dolor sit amet..\", comes from a line in section 1.10.32.<br><small class=\"text-muted\">Yesterday 2:45 pm</small></div></a></div><div class=\"sidebar-message\"><a href=\"#\"><div class=\"pull-left text-center\"><img alt=\"image\" class=\"img-circle message-avatar\" src=\"img/a3.jpg\"><div class=\"m-t-xs\"><i class=\"fa fa-star text-warning\"></i> <i class=\"fa fa-star text-warning\"></i> <i class=\"fa fa-star text-warning\"></i></div></div><div class=\"media-body\">The standard chunk of Lorem Ipsum used since the 1500s is reproduced below.<br><small class=\"text-muted\">Yesterday 1:10 pm</small></div></a></div><div class=\"sidebar-message\"><a href=\"#\"><div class=\"pull-left text-center\"><img alt=\"image\" class=\"img-circle message-avatar\" src=\"img/a4.jpg\"></div><div class=\"media-body\">Uncover many web sites still in their infancy. Various versions have.<br><small class=\"text-muted\">Monday 8:37 pm</small></div></a></div></div></div><div class=\"tab-pane\" ng-class=\"{active: tab2}\"><div class=\"sidebar-title\"><h3><i class=\"fa fa-cube\"></i> Latest projects</h3><small><i class=\"fa fa-tim\"></i> You have 14 projects. 10 not completed.</small></div><ul class=\"sidebar-list\"><li><a href=\"#\"><div class=\"small pull-right m-t-xs\">9 hours ago</div><h4>Business valuation</h4>It is a long established fact that a reader will be distracted.<div class=\"small\">Completion with: 22%</div><div class=\"progress progress-mini\"><div style=\"width: 22%;\" class=\"progress-bar progress-bar-warning\"></div></div><div class=\"small text-muted m-t-xs\">Project end: 4:00 pm - 12.06.2014</div></a></li><li><a href=\"#\"><div class=\"small pull-right m-t-xs\">9 hours ago</div><h4>Contract with Company</h4>Many desktop publishing packages and web page editors.<div class=\"small\">Completion with: 48%</div><div class=\"progress progress-mini\"><div style=\"width: 48%;\" class=\"progress-bar\"></div></div></a></li><li><a href=\"#\"><div class=\"small pull-right m-t-xs\">9 hours ago</div><h4>Meeting</h4>By the readable content of a page when looking at its layout.<div class=\"small\">Completion with: 14%</div><div class=\"progress progress-mini\"><div style=\"width: 14%;\" class=\"progress-bar progress-bar-info\"></div></div></a></li><li><a href=\"#\"><span class=\"label label-primary pull-right\">NEW</span><h4>The generated</h4>There are many variations of passages of Lorem Ipsum available.<div class=\"small\">Completion with: 22%</div><div class=\"small text-muted m-t-xs\">Project end: 4:00 pm - 12.06.2014</div></a></li><li><a href=\"#\"><div class=\"small pull-right m-t-xs\">9 hours ago</div><h4>Business valuation</h4>It is a long established fact that a reader will be distracted.<div class=\"small\">Completion with: 22%</div><div class=\"progress progress-mini\"><div style=\"width: 22%;\" class=\"progress-bar progress-bar-warning\"></div></div><div class=\"small text-muted m-t-xs\">Project end: 4:00 pm - 12.06.2014</div></a></li><li><a href=\"#\"><div class=\"small pull-right m-t-xs\">9 hours ago</div><h4>Contract with Company</h4>Many desktop publishing packages and web page editors.<div class=\"small\">Completion with: 48%</div><div class=\"progress progress-mini\"><div style=\"width: 48%;\" class=\"progress-bar\"></div></div></a></li><li><a href=\"#\"><div class=\"small pull-right m-t-xs\">9 hours ago</div><h4>Meeting</h4>By the readable content of a page when looking at its layout.<div class=\"small\">Completion with: 14%</div><div class=\"progress progress-mini\"><div style=\"width: 14%;\" class=\"progress-bar progress-bar-info\"></div></div></a></li><li><a href=\"#\"><span class=\"label label-primary pull-right\">NEW</span><h4>The generated</h4>There are many variations of passages of Lorem Ipsum available.<div class=\"small\">Completion with: 22%</div><div class=\"small text-muted m-t-xs\">Project end: 4:00 pm - 12.06.2014</div></a></li></ul></div><div class=\"tab-pane\" ng-class=\"{active: tab3}\"><div class=\"sidebar-title\"><h3><i class=\"fa fa-gears\"></i> Settings</h3><small><i class=\"fa fa-tim\"></i> You have 14 projects. 10 not completed.</small></div><div class=\"setings-item\"><span>Show notifications</span><div class=\"switch\"><div class=\"onoffswitch\"><input type=\"checkbox\" name=\"collapsemenu\" class=\"onoffswitch-checkbox\" id=\"example\"> <label class=\"onoffswitch-label\" for=\"example\"><span class=\"onoffswitch-inner\"></span> <span class=\"onoffswitch-switch\"></span></label></div></div></div><div class=\"setings-item\"><span>Disable Chat</span><div class=\"switch\"><div class=\"onoffswitch\"><input type=\"checkbox\" name=\"collapsemenu\" checked=\"\" class=\"onoffswitch-checkbox\" id=\"example2\"> <label class=\"onoffswitch-label\" for=\"example2\"><span class=\"onoffswitch-inner\"></span> <span class=\"onoffswitch-switch\"></span></label></div></div></div><div class=\"setings-item\"><span>Enable history</span><div class=\"switch\"><div class=\"onoffswitch\"><input type=\"checkbox\" name=\"collapsemenu\" class=\"onoffswitch-checkbox\" id=\"example3\"> <label class=\"onoffswitch-label\" for=\"example3\"><span class=\"onoffswitch-inner\"></span> <span class=\"onoffswitch-switch\"></span></label></div></div></div><div class=\"setings-item\"><span>Show charts</span><div class=\"switch\"><div class=\"onoffswitch\"><input type=\"checkbox\" name=\"collapsemenu\" class=\"onoffswitch-checkbox\" id=\"example4\"> <label class=\"onoffswitch-label\" for=\"example4\"><span class=\"onoffswitch-inner\"></span> <span class=\"onoffswitch-switch\"></span></label></div></div></div><div class=\"setings-item\"><span>Offline users</span><div class=\"switch\"><div class=\"onoffswitch\"><input type=\"checkbox\" checked=\"\" name=\"collapsemenu\" class=\"onoffswitch-checkbox\" id=\"example5\"> <label class=\"onoffswitch-label\" for=\"example5\"><span class=\"onoffswitch-inner\"></span> <span class=\"onoffswitch-switch\"></span></label></div></div></div><div class=\"setings-item\"><span>Global search</span><div class=\"switch\"><div class=\"onoffswitch\"><input type=\"checkbox\" checked=\"\" name=\"collapsemenu\" class=\"onoffswitch-checkbox\" id=\"example6\"> <label class=\"onoffswitch-label\" for=\"example6\"><span class=\"onoffswitch-inner\"></span> <span class=\"onoffswitch-switch\"></span></label></div></div></div><div class=\"setings-item\"><span>Update everyday</span><div class=\"switch\"><div class=\"onoffswitch\"><input type=\"checkbox\" name=\"collapsemenu\" class=\"onoffswitch-checkbox\" id=\"example7\"> <label class=\"onoffswitch-label\" for=\"example7\"><span class=\"onoffswitch-inner\"></span> <span class=\"onoffswitch-switch\"></span></label></div></div></div><div class=\"sidebar-content\"><h4>Settings</h4><div class=\"small\">I belive that. Lorem Ipsum is simply dummy text of the printing and typesetting industry. And typesetting industry. Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500s. Over the years, sometimes by accident, sometimes on purpose (injected humour and the like).</div></div></div></div></div></div>");
$templateCache.put("view/common/top_navigation.html","<div class=\"row border-bottom white-bg\"><nav class=\"navbar navbar-static-top\" role=\"navigation\"><div class=\"navbar-header\"><button aria-controls=\"navbar\" aria-expanded=\"false\" data-target=\"#navbar\" data-toggle=\"collapse\" class=\"navbar-toggle collapsed\" type=\"button\"><i class=\"fa fa-reorder\"></i></button> <a href=\"#\" class=\"navbar-brand\">Inspinia</a></div><div class=\"navbar-collapse collapse\" id=\"navbar\"><ul class=\"nav navbar-nav\"><li class=\"active\"><a ui-sref=\"layouts\" href=\"#\">Back to main Layout page</a></li><li uib-dropdown=\"\"><a href=\"\" uib-dropdown-toggle=\"\">Menu item <span class=\"caret\"></span></a><ul role=\"menu\" uib-dropdown-menu=\"\"><li><a href=\"#\">Menu item</a></li><li><a href=\"#\">Menu item</a></li><li><a href=\"#\">Menu item</a></li><li><a href=\"#\">Menu item</a></li></ul></li><li uib-dropdown=\"\"><a href=\"\" uib-dropdown-toggle=\"\">Menu item <span class=\"caret\"></span></a><ul role=\"menu\" uib-dropdown-menu=\"\"><li><a href=\"#\">Menu item</a></li><li><a href=\"#\">Menu item</a></li><li><a href=\"#\">Menu item</a></li><li><a href=\"#\">Menu item</a></li></ul></li><li uib-dropdown=\"\"><a href=\"\" uib-dropdown-toggle=\"\">Menu item <span class=\"caret\"></span></a><ul role=\"menu\" uib-dropdown-menu=\"\"><li><a href=\"#\">Menu item</a></li><li><a href=\"#\">Menu item</a></li><li><a href=\"#\">Menu item</a></li><li><a href=\"#\">Menu item</a></li></ul></li><li uib-dropdown=\"\"><a href=\"\" uib-dropdown-toggle=\"\">Menu item <span class=\"caret\"></span></a><ul role=\"menu\" uib-dropdown-menu=\"\"><li><a href=\"#\">Menu item</a></li><li><a href=\"#\">Menu item</a></li><li><a href=\"#\">Menu item</a></li><li><a href=\"#\">Menu item</a></li></ul></li></ul><ul class=\"nav navbar-top-links navbar-right\"><li><a href=\"login.html\"><i class=\"fa fa-sign-out\"></i> Log out</a></li></ul></div></nav></div>");
$templateCache.put("view/common/topnavbar.html","<div class=\"row border-bottom\"><nav class=\"navbar navbar-static-top\" role=\"navigation\" style=\"margin-bottom: 0\"><div class=\"navbar-header\"><span minimaliza-sidebar=\"\"></span><form role=\"search\" class=\"navbar-form-custom\" method=\"post\" action=\"views/search_results.html\"><div class=\"form-group\"><input type=\"text\" placeholder=\"{{ \'SEARCH\' | translate }}\" class=\"form-control\" name=\"top-search\" id=\"top-search\"></div></form></div><ul class=\"nav navbar-top-links navbar-right\"><li uib-dropdown=\"\"><a class=\"count-info\" href=\"\" uib-dropdown-toggle=\"\">Language</a><ul uib-dropdown-menu=\"\" class=\"animated fadeInRight m-t-xs\" ng-controller=\"translateCtrl\"><li><a ng-click=\"changeLanguage(\'en\')\">English</a></li><li><a ng-click=\"changeLanguage(\'es\')\">Spanish</a></li></ul></li><li uib-dropdown=\"\"><a class=\"count-info\" href=\"\" uib-dropdown-toggle=\"\"><i class=\"fa fa-envelope\"></i> <span class=\"label label-warning\">16</span></a><ul class=\"dropdown-messages\" uib-dropdown-menu=\"\"><li><div class=\"dropdown-messages-box\"><a ui-sref=\"profile\" class=\"pull-left\"><img alt=\"image\" class=\"img-circle\" src=\"img/a7.jpg\"></a><div><small class=\"pull-right\">46h ago</small> <strong>Mike Loreipsum</strong> started following <strong>Monica Smith</strong>.<br><small class=\"text-muted\">3 days ago at 7:58 pm - 10.06.2014</small></div></div></li><li class=\"divider\"></li><li><div class=\"dropdown-messages-box\"><a ui-sref=\"profile\" class=\"pull-left\"><img alt=\"image\" class=\"img-circle\" src=\"img/a4.jpg\"></a><div><small class=\"pull-right text-navy\">5h ago</small> <strong>Chris Johnatan Overtunk</strong> started following <strong>Monica Smith</strong>.<br><small class=\"text-muted\">Yesterday 1:21 pm - 11.06.2014</small></div></div></li><li class=\"divider\"></li><li><div class=\"dropdown-messages-box\"><a ui-sref=\"profile\" class=\"pull-left\"><img alt=\"image\" class=\"img-circle\" src=\"img/profile.jpg\"></a><div><small class=\"pull-right\">23h ago</small> <strong>Monica Smith</strong> love <strong>Kim Smith</strong>.<br><small class=\"text-muted\">2 days ago at 2:30 am - 11.06.2014</small></div></div></li><li class=\"divider\"></li><li><div class=\"text-center link-block\"><a ui-sref=\"mailbox.inbox\"><i class=\"fa fa-envelope\"></i> <strong>Read All Messages</strong></a></div></li></ul></li><li uib-dropdown=\"\"><a class=\"count-info\" href=\"\" uib-dropdown-toggle=\"\"><i class=\"fa fa-bell\"></i> <span class=\"label label-primary\">8</span></a><ul class=\"dropdown-alerts\" uib-dropdown-menu=\"\"><li><a ui-sref=\"inbox\"><div><i class=\"fa fa-envelope fa-fw\"></i> You have 16 messages <span class=\"pull-right text-muted small\">4 minutes ago</span></div></a></li><li class=\"divider\"></li><li><a ui-sref=\"profile\"><div><i class=\"fa fa-twitter fa-fw\"></i> 3 New Followers <span class=\"pull-right text-muted small\">12 minutes ago</span></div></a></li><li class=\"divider\"></li><li><a ui-sref=\"grid_options\"><div><i class=\"fa fa-upload fa-fw\"></i> Server Rebooted <span class=\"pull-right text-muted small\">4 minutes ago</span></div></a></li><li class=\"divider\"></li><li><div class=\"text-center link-block\"><a ui-sref=\"miscellaneous.notify\"><strong>See All Alerts</strong> <i class=\"fa fa-angle-right\"></i></a></div></li></ul></li><li><a ui-sref=\"login\"><i class=\"fa fa-sign-out\"></i> Log out</a></li><li><a ng-click=\"$root.rightSidebar = !$root.rightSidebar\"><i class=\"fa fa-tasks\"></i></a></li></ul></nav></div>");
$templateCache.put("view/empresa/form.html","<div class=\"wrapper wrapper-content animated fadeInDown\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><form name=\"frm\"><div class=\"row\"><div class=\"col-xs-11 col-md-12\"><ng-field name=\"Nome\" label=\"Nome da empresa\" model=\"vm.item.Nome\" type=\"text\" required=\"true\" maxlength=\"100\"></ng-field></div></div><div class=\"row\"><div class=\"col-md-3\"><ng-field label=\"Cidade\" required=\"true\" type=\"select\" model=\"vm.item.IdCidade\" options=\"vm.cidadeList\" value-field=\"Id\" text-field=\"Nome\"></ng-field></div><div class=\"col-md-3\"><ng-field name=\"Bairro\" label=\"Bairro\" model=\"vm.item.Bairro\" type=\"text\" maxlength=\"100\"></ng-field></div><div class=\"col-md-3\"><ng-field label=\"Cep\" name=\"Cep\" type=\"number\" model=\"vm.item.CEP\" maxlength=\"8\"></ng-field></div></div><div class=\"row\"><div class=\"col-md-3\"><ng-field name=\"Logradouro\" label=\"Logradouro\" model=\"vm.item.Logradouro\" type=\"text\" maxlength=\"200\"></ng-field></div><div class=\"col-md-3\"><ng-field name=\"Numero\" label=\"Numero\" model=\"vm.item.EnderecoNumero\" type=\"number\" maxlength=\"50\"></ng-field></div><div class=\"col-md-3\"><ng-field label=\"Complemento\" name=\"Complemento\" type=\"text\" model=\"vm.item.Complemento\" maxlength=\"60\"></ng-field></div></div><div class=\"row\"><div class=\"col-md-3\"><ng-field label=\"DDD 1\" name=\"DDD1\" type=\"number\" model=\"vm.item.DDD1\" maxlength=\"2\"></ng-field></div><div class=\"col-md-3\"><ng-field label=\"Telefone 1\" name=\"Telefone1\" type=\"number\" model=\"vm.item.Telefone1\" maxlength=\"12\"></ng-field></div><div class=\"col-md-3\"><ng-field label=\"Ramal 1\" name=\"Ramal1\" type=\"number\" model=\"vm.item.Ramal1\" maxlength=\"6\"></ng-field></div></div><div class=\"row\"><div class=\"col-md-3\"><ng-field label=\"DDD 2\" name=\"DDD2\" type=\"number\" model=\"vm.item.DDD2\" maxlength=\"2\"></ng-field></div><div class=\"col-md-3\"><ng-field label=\"Telefone 2\" name=\"Telefone2\" type=\"number\" model=\"vm.item.Telefone2\" maxlength=\"12\"></ng-field></div><div class=\"col-md-3\"><ng-field label=\"Ramal 2\" name=\"Ramal2\" type=\"number\" model=\"vm.item.Ramal2\" maxlength=\"6\"></ng-field></div></div><div class=\"row\"><ng-field type=\"textarea\" label=\"Mensagem RPS\" model=\"vm.item.MensagemRPS\" maxlength=\"200\"></ng-field></div></form><div class=\"row\"><div class=\"form-group\"><div class=\"col-md-1 col-md-offset-10\"><button class=\"btn btn-outline pull-right\" type=\"button\" ng-click=\"vm.cancel();\">CANCELAR</button></div><div class=\"col-md-1\"><button class=\"btn btn-primary pull-right\" ng-disabled=\"validateForm\" type=\"button\" ng-click=\"vm.save();\">SALVAR</button></div></div></div></div></div></div>");
$templateCache.put("view/empresa/grid.html","<div class=\"wrapper wrapper-content animated fadeInDown\"><div class=\"row\"><div class=\"col-lg-12\"><button ng-click=\"vm.add()\" type=\"button\" class=\"btn btn-w-m btn-success m-b-md pull-right\">ADICIONAR EMPRESA</button><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><button type=\"button\" class=\"btn btn-w-m btn-success pull-right col-offset-m1\" ng-click=\"vm.search()\">FILTRAR</button><div class=\"input-group col-xs-7 col-sm-8 col-md-9 col-lg-10\"><div class=\"input-group-addon\"><i class=\"fa fa-search\"></i></div><input type=\"search\" ng-model=\"vm.Filter.Nome\" class=\"form-control\" placeholder=\"Digite para filtrar os resultados\" aria-controls=\"DataTables_Table_0\"></div></div><br><div class=\"ibox-content\"><table class=\"table table-striped table-hover\" role=\"grid\"><thead><tr role=\"row\"><th>Nome</th><th>Cidade</th><th>UF</th><th>Ações</th></tr></thead><tbody><tr class=\"gradeA odd\" role=\"row\" ng-repeat=\"item in vm.items\"><td class=\"project-title\"><span>{{item.Nome}}</span></td><td class=\"project-title\"><span>{{item.Cidade}}</span></td><td class=\"project-title\"><span>{{item.UF}}</span></td><td class=\"project-actions\"><span uib-dropdown=\"\" on-toggle=\"toggled(open)\"><a role=\"button\" uib-dropdown-toggle=\"\"><i class=\"fa fa-wrench\"></i></a><ul class=\"pull-right\" uib-dropdown-menu=\"\" aria-labelledby=\"simple-dropdown\"><li><a role=\"button\" ng-click=\"vm.edit(item);\"><i class=\"fa fa-edit\"></i> Editar</a> <a role=\"button\" ng-click=\"vm.del(item);\"><i class=\"fa fa-trash\"></i> Excluir</a></li></ul></span></td></tr></tbody></table></div></div></div></div></div>");
$templateCache.put("view/empresa/index.html","<div ui-view=\"\"></div>");
$templateCache.put("view/estabelecimento/form.html","<div class=\"wrapper wrapper-content animated fadeInDown\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><form name=\"frm\"><div class=\"row\"><div class=\"col-xs-11 col-md-5\"><ng-field name=\"Nome\" label=\"Nome do estabelecimento\" model=\"vm.item.Nome\" type=\"text\" required=\"true\" maxlength=\"50\"></ng-field></div><div class=\"col-xs-11 col-md-5\"><ng-field label=\"Empresa\" required=\"true\" type=\"select\" model=\"vm.item.IdEmpresa\" options=\"vm.empresaList\" value-field=\"Id\" text-field=\"Nome\"></ng-field></div><div class=\"col-xs-1 col-md-2 m-t-lg\"><input type=\"checkbox\" ng-model=\"vm.item.Status\" name=\"status\" icheck=\"\"> <strong>Inativo</strong></div></div><div class=\"row\"><div class=\"col-md-3\"><ng-field label=\"Cidade\" required=\"true\" type=\"select\" model=\"vm.item.IdCidade\" options=\"vm.cidadeList\" value-field=\"Id\" text-field=\"Nome\"></ng-field></div><div class=\"col-md-3\"><ng-field name=\"Bairro\" label=\"Bairro\" model=\"vm.item.Bairro\" type=\"text\" maxlength=\"100\" required=\"true\"></ng-field></div><div class=\"col-md-3\"><ng-field label=\"Cep\" name=\"Cep\" type=\"number\" model=\"vm.item.CEP\" maxlength=\"8\" required=\"true\"></ng-field></div></div><div class=\"row\"><div class=\"col-md-3\"><ng-field name=\"Logradouro\" label=\"Logradouro\" model=\"vm.item.Logradouro\" type=\"text\" maxlength=\"200\" required=\"true\"></ng-field></div><div class=\"col-md-3\"><ng-field name=\"Numero\" label=\"Numero\" model=\"vm.item.EnderecoNumero\" type=\"number\" maxlength=\"50\" required=\"true\"></ng-field></div><div class=\"col-md-3\"><ng-field label=\"Complemento\" name=\"Complemento\" type=\"text\" model=\"vm.item.Complemento\" maxlength=\"60\" required=\"true\"></ng-field></div></div><div class=\"row\"><div class=\"col-md-3\"><ng-field label=\"DDD 1\" name=\"DDD1\" type=\"number\" model=\"vm.item.DDD1\" maxlength=\"2\" required=\"true\"></ng-field></div><div class=\"col-md-3\"><ng-field label=\"Telefone 1\" name=\"Telefone1\" type=\"number\" model=\"vm.item.Telefone1\" maxlength=\"12\" required=\"true\"></ng-field></div><div class=\"col-md-3\"><ng-field label=\"Ramal 1\" name=\"Ramal1\" type=\"number\" model=\"vm.item.Ramal1\" maxlength=\"6\"></ng-field></div></div><div class=\"row\"><div class=\"col-md-3\"><ng-field label=\"DDD 2\" name=\"DDD2\" type=\"number\" model=\"vm.item.DDD2\" maxlength=\"2\"></ng-field></div><div class=\"col-md-3\"><ng-field label=\"Telefone 2\" name=\"Telefone2\" type=\"number\" model=\"vm.item.Telefone2\" maxlength=\"12\"></ng-field></div><div class=\"col-md-3\"><ng-field label=\"Ramal 2\" name=\"Ramal2\" type=\"number\" model=\"vm.item.Ramal2\" maxlength=\"6\"></ng-field></div></div><div class=\"row\"><div class=\"col-md-3\"><a class=\"btn btn-primary m-t\" ng-click=\"vm.openModel()\">Definir localização do estabelecimento</a></div></div></form><div class=\"row\"><div class=\"form-group\"><div class=\"col-md-1 col-md-offset-10\"><button class=\"btn btn-outline pull-right\" type=\"button\" ng-click=\"vm.cancel();\">CANCELAR</button></div><div class=\"col-md-1\"><button class=\"btn btn-primary pull-right\" ng-disabled=\"validateForm\" type=\"button\" ng-click=\"vm.save();\">SALVAR</button></div></div></div></div></div></div>");
$templateCache.put("view/estabelecimento/grid.html","<div class=\"wrapper wrapper-content animated fadeInDown\"><div class=\"row\"><div class=\"col-lg-12\"><button ng-click=\"vm.add()\" type=\"button\" class=\"btn btn-w-m btn-success m-b-md pull-right\">ADICIONAR ESTABELECIMENTO</button><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><button type=\"button\" class=\"btn btn-w-m btn-success pull-right col-offset-m1\" ng-click=\"vm.search()\">FILTRAR</button><div class=\"input-group col-xs-7 col-sm-8 col-md-9 col-lg-10\"><div class=\"input-group-addon\"><i class=\"fa fa-search\"></i></div><input type=\"search\" ng-model=\"vm.Filter.Nome\" class=\"form-control\" placeholder=\"Digite para filtrar os resultados\" aria-controls=\"DataTables_Table_0\"></div></div><br><div class=\"ibox-content\"><table class=\"table table-striped table-hover\" role=\"grid\"><thead><tr role=\"row\"><th>Nome</th><th>Empresa</th><th>Cidade</th><th>UF</th><th>Status</th><th>Ações</th></tr></thead><tbody><tr class=\"gradeA odd\" role=\"row\" ng-repeat=\"item in vm.items\"><td class=\"project-title\"><span>{{item.Nome}}</span></td><td class=\"project-title\"><span>{{item.Empresa}}</span></td><td class=\"project-title\"><span>{{item.Cidade}}</span></td><td class=\"project-title\"><span>{{item.UF}}</span></td><td class=\"center\">{{item.Status == 1 ? \'Ativo\' : \'Inativo\'}}</td><td class=\"project-actions\"><span uib-dropdown=\"\" on-toggle=\"toggled(open)\"><a role=\"button\" uib-dropdown-toggle=\"\"><i class=\"fa fa-wrench\"></i></a><ul class=\"pull-right\" uib-dropdown-menu=\"\" aria-labelledby=\"simple-dropdown\"><li><a role=\"button\" ng-click=\"vm.edit(item);\"><i class=\"fa fa-edit\"></i> Editar</a></li><li><a role=\"button\" ng-click=\"vm.del(item);\"><i class=\"fa fa-trash\"></i> Excluir</a></li><li class=\"divider\"></li><li><a role=\"button\" ng-click=\"vm.layout(item);\"><i class=\"fa fa-object-group\"></i> Layouts</a></li></ul></span></td></tr></tbody></table></div></div></div></div></div>");
$templateCache.put("view/estabelecimento/index.html","<div ui-view=\"\"></div>");
$templateCache.put("view/estabelecimento/layouts.html","<div class=\"wrapper wrapper-content animated fadeInDown\"><div class=\"row\"><div class=\"col-lg-12\"><button ng-click=\"vm.add()\" type=\"button\" class=\"btn btn-w-m btn-success m-b-md pull-right\">ADICIONAR LAYOUT</button><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-2 col-sm-2 col-md-2 col-lg-2\"><select class=\"form-control\" ng-model=\"vm.Filter.IdSala\"><option ng-repeat=\"s in vm.salas\" value=\"{{s.IdSala}}\">{{s.Nome}}</option></select></div><div class=\"col-xs-6 col-sm-7 col-md-8 col-lg-9\"><div class=\"input-group\"><div class=\"input-group-addon\"><i class=\"fa fa-search\"></i></div><input type=\"search\" ng-model=\"vm.Filter.Nome\" class=\"form-control\" placeholder=\"Digite para filtrar os resultados\" aria-controls=\"DataTables_Table_0\"></div></div><div class=\"col-lg-1\"><button class=\"btn btn-w-m btn-success pull-right\" ng-click=\"vm.search()\">FILTRAR</button></div></div></div><br><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-lg-12\"><table class=\"table table-striped table-bordered table-hover\" role=\"grid\"><thead><tr role=\"row\"><th>Nome</th><th style=\"width:100px;\">Status</th><th style=\"width:80px;\">Ações</th></tr></thead><tbody><tr class=\"gradeA odd\" role=\"row\" ng-repeat=\"item in vm.items\"><td class=\"project-title\"><span>{{item.Nome}}</span></td><td class=\"project-title\"><span>{{item.Ativo ? \"Ativo\" : \"Inativo\"}}</span></td><td class=\"project-actions\"><span uib-dropdown=\"\" on-toggle=\"toggled(open)\"><a role=\"button\" uib-dropdown-toggle=\"\"><i class=\"fa fa-wrench\"></i></a><ul class=\"pull-right\" uib-dropdown-menu=\"\" aria-labelledby=\"simple-dropdown\"><li><a role=\"button\" ng-click=\"vm.mapa(item);\"><i class=\"fa fa-edit\"></i> Editar</a> <a role=\"button\" ng-click=\"vm.del(item);\"><i class=\"fa fa-trash\"></i> Excluir</a></li></ul></span></td></tr></tbody></table></div></div></div></div></div></div></div>");
$templateCache.put("view/estabelecimento/mapa.html","<div class=\"wrapper wrapper-content animated fadeInDown\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"btn-group\" uib-dropdown=\"\"><button type=\"button\" class=\"btn btn-primary\" uib-dropdown-toggle=\"\" ng-disabled=\"disabled\">SETORES <span class=\"caret\"></span></button><ul class=\"dropdown-menu\" uib-dropdown-menu=\"\" role=\"menu\" aria-labelledby=\"single-button\"><li role=\"menuitem\"><a role=\"button\" ng-click=\"vm.editSetor()\"><i class=\"fa fa-plus-circle\"></i> INCLUIR</a></li><li class=\"divider\" ng-show=\"vm.setores.length!=0\"></li><li role=\"menuitem\" ng-repeat=\"s in vm.setores\"><a role=\"button\" ng-click=\"vm.editSetor(s)\">{{s.Nome}}</a></li></ul></div><div class=\"btn-group\" uib-dropdown=\"\"><button type=\"button\" class=\"btn btn-primary\" uib-dropdown-toggle=\"\" ng-disabled=\"disabled\">OBJETOS <span class=\"caret\"></span></button><ul class=\"dropdown-menu\" uib-dropdown-menu=\"\" role=\"menu\" aria-labelledby=\"single-button\"><li role=\"menuitem\"><a role=\"button\" ng-click=\"vm.editObjeto()\"><i class=\"fa fa-plus-circle\"></i> INCLUIR</a></li><li class=\"divider\" ng-show=\"vm.objetos.length!=0\"></li><li role=\"menuitem\" ng-repeat=\"o in vm.objetos\"><a role=\"button\" ng-click=\"vm.editObjeto(o)\">{{o.Rotulo}}</a></li></ul></div><div class=\"btn-group\" uib-dropdown=\"\"><button type=\"button\" class=\"btn btn-default\" uib-dropdown-toggle=\"\" ng-disabled=\"disabled\">ASSENTOS <span class=\"caret\"></span></button><ul class=\"dropdown-menu\" uib-dropdown-menu=\"\" role=\"menu\" aria-labelledby=\"single-button\"><li role=\"menuitem\" ng-repeat=\"ta in vm.tiposAssento\"><a role=\"button\" ng-click=\"vm.selAssento(ta)\"><i class=\"fa fa-plus-circle\"></i> {{ta.Nome}}</a></li></ul></div><div class=\"btn-group\" ng-if=\"vm.assento!=null\"><button class=\"btn btn-default\" ng-click=\"vm.selAssento(null)\">{{vm.assento.Nome}}</button></div><div class=\"btn-group\" role=\"group\" ng-show=\"vm.selecionados.length>0\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.vAlignTop()\" uib-tooltip=\"Alinhar pela mais alta\" tooltip-placement=\"bottom\" tooltip-append-to-body=\"true\"><span class=\"fa-stack\"><i class=\"fa fa-align-left fa-rotate-90\"></i></span></button> <button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.vAlignMiddle()\" uib-tooltip=\"Centralizar linha\" tooltip-placement=\"bottom\" tooltip-append-to-body=\"true\"><span class=\"fa-stack\"><i class=\"fa fa-align-center fa-rotate-90\"></i></span></button> <button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.vAlignBottom()\" uib-tooltip=\"Alinhar pela mais baixa\" tooltip-placement=\"bottom\" tooltip-append-to-body=\"true\"><span class=\"fa-stack\"><i class=\"fa fa-align-right fa-rotate-90\"></i></span></button></div><div class=\"btn-group\" role=\"group\" ng-show=\"vm.selecionados.length>0\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.hAlignLeft()\" uib-tooltip=\"Alinhar coluna a esquerda\" tooltip-placement=\"bottom\" tooltip-append-to-body=\"true\"><span class=\"fa-stack\"><i class=\"fa fa-align-left\"></i></span></button> <button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.hAlignCenter()\" uib-tooltip=\"Centralizar coluna\" tooltip-placement=\"bottom\" tooltip-append-to-body=\"true\"><span class=\"fa-stack\"><i class=\"fa fa-align-center\"></i></span></button> <button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.hAlignRight()\" uib-tooltip=\"Alinhar coluna a direita\" tooltip-placement=\"bottom\" tooltip-append-to-body=\"true\"><span class=\"fa-stack\"><i class=\"fa fa-align-right\"></i></span></button></div><div class=\"btn-group\" role=\"group\" ng-show=\"vm.selecionados.length>0\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.hDistribute()\" uib-tooltip=\"Distribuir a linha pelos extremos\" tooltip-placement=\"bottom\" tooltip-append-to-body=\"true\"><span class=\"fa-stack\"><i class=\"fa fa-align-justify fa-rotate-90\"></i></span></button> <button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.vDistribute()\" uib-tooltip=\"Distribuir a coluna pelos extremos\" tooltip-placement=\"bottom\" tooltip-append-to-body=\"true\"><span class=\"fa-stack\"><i class=\"fa fa-align-justify\"></i></span></button></div><div class=\"btn-group\" role=\"group\" ng-show=\"vm.selecionados.length>0\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.clone()\" uib-tooltip=\"Duplicar selecionados\" tooltip-placement=\"bottom\" tooltip-append-to-body=\"true\"><span class=\"fa-stack\"><i class=\"fa fa-align-justify fa-clone\"></i></span></button></div><div class=\"btn-group\" role=\"group\" ng-show=\"vm.selecionados.length>0\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.internetToggle()\" uib-tooltip=\"Suspender vendas para internet\" tooltip-placement=\"bottom\" tooltip-append-to-body=\"true\"><span class=\"fa-stack\"><i class=\"fa fa-cloud fa-stack-1x\"></i> <i class=\"fa fa-ban fa-stack-2x text-danger\"></i></span></button> <button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.rename()\" uib-tooltip=\"Renomear selecionados\" tooltip-placement=\"bottom\" tooltip-append-to-body=\"true\"><span class=\"fa-stack\"><i class=\"fa fa-square fa-stack-2x\"></i> <i class=\"fa fa-terminal fa-stack-1x fa-inverse\"></i></span></button> <button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.release()\" uib-tooltip=\"Desmarcar selecionados\" tooltip-placement=\"bottom\" tooltip-append-to-body=\"true\"><span class=\"fa-stack\"><i class=\"fa fa-ban\"></i></span></button></div><div class=\"btn-group\"><label class=\"btn btn-default\" ng-model=\"vm.label\" uib-btn-radio=\"\'Rotulo\'\">Rótulo</label> <label class=\"btn btn-default\" ng-model=\"vm.label\" uib-btn-radio=\"\'Descricao\'\">Descrição</label></div></div></div><form><div class=\"row\"><div class=\"col-md-2\"><ng-field name=\"Sala\" label=\"Sala\" options=\"vm.salas\" model=\"vm.item.IdSala\" type=\"select\" value-field=\"IdSala\" text-field=\"Nome\" required=\"true\" disabled=\"vm.Item.IdLayout==null\"></ng-field></div><div class=\"col-md-3\"><ng-field name=\"Nome\" label=\"Nome\" model=\"vm.item.Nome\" maxlength=\"50\" required=\"true\"></ng-field></div><div class=\"col-md-2\"><ng-field name=\"Largura\" label=\"Largura(metros)\" model=\"vm.item.Largura\" maxlength=\"5\" required=\"true\" type=\"number\"></ng-field></div><div class=\"col-md-2\"><ng-field name=\"Comprimento\" label=\"Comprimento(metros)\" model=\"vm.item.Comprimento\" maxlength=\"5\" required=\"true\" type=\"number\"></ng-field></div><div class=\"col-md-3\"><div class=\"m-t-lg\"><input icheck=\"\" type=\"checkbox\" ng-model=\"vm.item.PalcoAutomatico\" style=\"text-align: right\"><strong class=\"m-l-sm\">PALCO AUTOMÁTICO</strong></div></div></div></form><div class=\"row\"><div class=\"col-md-12\"><div style=\"width:1100px; height:800px;\" mapaassento=\"\" real-width=\"vm.item.Largura\" real-height=\"vm.item.Comprimento\" setores=\"vm.setores\" objetos=\"vm.objetos\" assentos=\"vm.assentos\" tipos-assento=\"vm.tiposAssento\" h-align-left=\"vm.hAlignLeft\" h-align-center=\"vm.hAlignCenter\" h-align-right=\"vm.hAlignRight\" v-align-top=\"vm.vAlignTop\" v-align-middle=\"vm.vAlignMiddle\" v-align-bottom=\"vm.vAlignBottom\" v-distribute=\"vm.vDistribute\" h-distribute=\"vm.hDistribute\" clone=\"vm.clone\" selecionados=\"vm.selecionados\" release=\"vm.release\" rename=\"vm.rename\" internet-toggle=\"vm.internetToggle\" item2add=\"vm.assento\" validate=\"vm.validate\" text-field=\"vm.label\"></div></div></div><br><div class=\"row\"><div class=\"form-group\"><div class=\"col-md-1 col-md-offset-10\"><button class=\"btn btn-outline pull-right\" type=\"button\" ng-click=\"vm.cancel();\">CANCELAR</button></div><div class=\"col-md-1\"><button class=\"btn btn-primary pull-right\" ng-disabled=\"validateForm\" type=\"button\" ng-click=\"vm.save();\"><i class=\"fa fa-spin fa-pulse\" ng-if=\"vm.loading\"></i>SALVAR</button></div></div></div></div></div></div>");
$templateCache.put("view/promocao/copiar.html","<div class=\"modal-header\"><h3 class=\"modal-title\">COPIAR A PROMOÇÃO ANTERIOR</h3></div><div class=\"modal-body\"><form name=\"frm\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-md-12\"><label>Pesquisar</label><div class=\"input-group\"><input type=\"text\" class=\"form-control\" placeholder=\"Nome da promoção ou atração\" ng-model=\"vm.Filter.Nome\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-success\" ng-click=\"vm.search()\"><i class=\"fa fa-search\"></i></button></span></div></div></div></div><div class=\"ibox-content\" style=\"height:300px; overflow-y: auto;\"><div class=\"alert alert-warning\" ng-show=\"!vm.initial && vm.items.length==0 && !vm.searching\">Nenhum registro encontrado para os filtros informados.</div><table class=\"table table-striped table-bordered table-hover\" role=\"grid\" ng-show=\"vm.items.length>0\"><thead><tr role=\"row\"><th></th><th>Data atração</th><th>Atração</th><th>Sala</th><th>Promoção</th></tr></thead><tbody><tr class=\"gradeA odd\" role=\"row\" ng-repeat=\"item in vm.items\"><td class=\"project-title\"><input type=\"radio\" ng-model=\"vm.selecionado\" name=\"item\" ng-value=\"item\"></td><td class=\"project-title\"><span>{{item.DataHoraInicio | date: \'dd/MM/yyyy HH:mm\'}}</span></td><td class=\"project-title\"><span>{{item.NomeAtracao}}</span></td><td class=\"project-title\"><span>{{item.NomeSala}}</span></td><td class=\"project-title\"><span>{{item.Nome}}</span></td></tr></tbody></table></div></div></div></div></form></div><div class=\"modal-footer\"><button class=\"btn btn-outline btn-link pull-right\" type=\"button\" ng-click=\"vm.no();\">Cancelar</button> <button class=\"btn btn-w-m btn-success pull-right\" type=\"button\" ng-click=\"vm.yes();\">Confirmar</button></div>");
$templateCache.put("view/promocao/form.html","<div class=\"wrapper wrapper-content animated fadeInDown\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><form name=\"frm\"><div class=\"row\"><div class=\"col-md-3\"><ng-field name=\"Nome\" label=\"Nome\" model=\"vm.item.Nome\" type=\"text\" required=\"true\" maxlength=\"50\"></ng-field></div><div class=\"col-md-3\"><ng-field type=\"select\" label=\"Estabelecimento\" options=\"vm.estabelecimentos\" changed=\"vm.TrocarEstabelecimento\" required=\"true\" model=\"vm.item.IdEstabelecimento\" ng-disabled=\"vm.IsEdit\"></ng-field></div><div class=\"col-md-3\"><ng-field type=\"select\" label=\"Atração\" options=\"vm.atracoes\" changed=\"vm.TrocarAtracao\" required=\"true\" model=\"vm.item.IdAtracao\" value-field=\"IdAtracao\" ng-disabled=\"vm.IsEdit\"></ng-field></div><div class=\"col-md-3\"><ng-field name=\"Sessao\" label=\"Sessão\" model=\"vm.item.IdSessao\" required=\"true\" type=\"select\" options=\"vm.sessoes\" changed=\"vm.TrocarSessao\" ng-disabled=\"vm.IsEdit\"></ng-field></div></div><div class=\"row\"><div class=\"col-md-3\"><ng-field name=\"Ingresso\" label=\"Ingresso\" model=\"vm.item.IdEstabelecimentoIngresso\" required=\"true\" type=\"select\" options=\"vm.ingressos\" changed=\"vm.TrocarIngresso\" ng-disabled=\"vm.IsEdit\"></ng-field></div><div class=\"col-md-2\"><ng-field name=\"Valor\" label=\"Valor\" model=\"vm.item.Valor\" required=\"true\" type=\"money\" ng-disabled=\"vm.IsEdit\"></ng-field></div><div class=\"col-md-2\"><ng-field name=\"DataTermino\" label=\"Data Término\" model=\"vm.item.Data\" type=\"date\"></ng-field></div><div class=\"col-md-2\"><ng-field name=\"HoraTermino\" label=\"Hora Término\" ng-if=\"vm.item.Data\" model=\"vm.item.HoraTermino\" type=\"time\"></ng-field></div></div><div class=\"row\" ng-if=\"!vm.item.IdPromocao\"><div class=\"col-md-12\"><button class=\"btn btn-primary pull-right btn-sm\" type=\"button\" ng-click=\"vm.Copiar();\" ng-disabled=\"!vm.item.IdSessao\">Copiar promoção anterior</button></div></div><div class=\"row\"><div class=\"col-md-12\"><div mapaassento=\"\" mapname=\"mapa1\" real-width=\"vm.layout.Largura\" real-height=\"vm.layout.Comprimento\" tipos-assento=\"vm.tiposAssento\" default-color=\"#0085A4\" selected-color=\"#55ffd7\" read-only=\"true\" setores=\"vm.setores\" objetos=\"vm.objetos\" assentos=\"vm.assentos\" selecionados=\"vm.selecionados\" release=\"vm.release\" style=\"width:1100px; height:800px;\"></div></div></div></form><div class=\"row\"><div class=\"col-md-1 col-md-offset-10\"><button class=\"btn btn-outline pull-right\" type=\"button\" ng-click=\"vm.cancel();\">CANCELAR</button></div><div class=\"col-md-1\"><button class=\"btn btn-primary pull-right\" type=\"button\" ng-click=\"vm.save();\" ng-disabled=\"frm.$invalid || vm.loading\"><i ng-if=\"vm.loading\" class=\"fa fa-spinner fa-pulse\"></i> SALVAR</button></div></div></div></div></div>");
$templateCache.put("view/promocao/grid.html","<div class=\"wrapper wrapper-content animated fadeInDown\"><form name=\"frm\"><div class=\"row\"><div class=\"col-md-12\"><button ng-click=\"vm.add()\" type=\"button\" class=\"btn btn-w-m btn-success m-b-md pull-right\">NOVA PROMOÇÃO</button><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-md-2\"><ng-field ng-enter=\"vm.search()\" type=\"select\" label=\"Estabelecimento\" options=\"vm.estabelecimentos\" changed=\"vm.TrocarEstabelecimento\" model=\"vm.Filter.IdEstabelecimento\"></ng-field></div><div class=\"col-md-2\"><ng-field ng-enter=\"vm.search()\" type=\"select\" label=\"Atração\" options=\"vm.atracoes\" value-field=\"IdAtracao\" model=\"vm.Filter.IdAtracao\"></ng-field></div><div class=\"col-md-2\"><ng-field type=\"text\" label=\"Promoção\" model=\"vm.Filter.Nome\"></ng-field></div><div class=\"col-md-2\"><ng-field type=\"date\" label=\"Início\"></ng-field></div><div class=\"col-md-2\"><ng-field type=\"date\" label=\"Fim\"></ng-field></div><div class=\"col-md-2\"><button type=\"button\" class=\"btn btn-w-m btn-success pull-right col-offset-m1\" ng-click=\"vm.search()\" ng-disabled=\"vm.searching || !frm.$valid\">FILTRAR</button></div></div></div><div class=\"ibox-content\"><div class=\"pull-right\" ng-show=\"vm.items.length>0\"><button class=\"btn btn-sm btn-danger\" ng-click=\"vm.Suspender()\"><i class=\"fa fa-times-circle-o\"></i> Suspender Promoção</button> <button class=\"btn btn-sm btn-primary\" ng-click=\"vm.Liberar()\"><i class=\"fa fa-check\"></i> Liberar Promoção</button></div><div class=\"alert alert-warning\" ng-show=\"!vm.initial && vm.items.length==0\">Nenhum registro encontrado para os filtros informados.</div><table class=\"table table-hover table-striped\" role=\"grid\" ng-show=\"vm.items.length>0\"><thead><tr role=\"row\"><th><input type=\"checkbox\" ng-change=\"vm.MarcarTodos()\" ng-model=\"vm.chkTodos\"></th><th>Estabelecimento</th><th>Atração</th><th>Data atração</th><th>Promoção</th><th>Término Promoção</th><th>Status da Promoção</th><th style=\"width: 45px;\">Ações</th></tr></thead><tbody><tr class=\"gradeA odd\" role=\"row\" ng-repeat=\"item in vm.items\"><td class=\"project-title\"><input type=\"checkbox\" ng-model=\"item.checked\"></td><td class=\"project-title\"><span>{{item.NomeEstabelecimento}}</span></td><td class=\"project-title\"><span>{{item.NomeAtracao}}</span></td><td class=\"project-title\"><span>{{item.InicioSessao | date: \'dd/MM/yyyy HH:mm\'}}</span></td><td class=\"project-title\"><span>{{item.Nome}}</span></td><td class=\"project-title\"><span>{{item.DataTermino | date: \'dd/MM/yyyy HH:mm\'}}</span></td><td class=\"project-title\"><span style=\"color:darkgray; font-weight: 600\" ng-if=\"item.Status != 1\">Inativa</span> <span style=\"color:green; font-weight: 600\" ng-if=\"(!item.DataTermino || item.DataTermino > vm.Current ) && item.InicioSessao > vm.Current && item.Status == 1\">Liberada</span> <span style=\"color:red; font-weight: 600\" ng-if=\"(item.DataTermino <= vm.Current || item.InicioSessao <= vm.Current ) && item.Status == 1\">Encerrada</span></td><td class=\"project-actions\"><span uib-dropdown=\"\" on-toggle=\"toggled(open)\"><a role=\"button\" uib-dropdown-toggle=\"\"><i class=\"fa fa-wrench\"></i></a><ul class=\"pull-right\" uib-dropdown-menu=\"\" aria-labelledby=\"simple-dropdown\"><li><a role=\"button\" ng-click=\"vm.edit(item);\" ng-if=\"item.InicioSessao > vm.Current\"><i class=\"fa fa-edit\"></i> Editar</a> <a role=\"button\" ng-click=\"vm.del(item);\"><i class=\"fa fa-trash\"></i> Excluir</a></li></ul></span></td></tr></tbody></table></div></div></div></div></form></div>");
$templateCache.put("view/promocao/index.html","<div ui-view=\"\"></div>");
$templateCache.put("view/site/_content.html","<div id=\"wrapper\"><menu-left></menu-left><div id=\"page-wrapper\" class=\"gray-bg {{$state.current.name}}\"><breadcrumb displayname-property=\"data.displayName\" abstract-proxy-property=\"data.proxy\"></breadcrumb><div ui-view=\"\"></div><div ng-include=\"\'view/common/footer.html\'\"></div></div><div ng-include=\"\'view/common/right_sidebar.html\'\"></div></div>");
$templateCache.put("view/authentication/forgot/forgot.html","<div class=\"passwordBox animated fadeInDown\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"ibox-content\"><h2 class=\"font-bold\">Esqueci minha senha</h2><p>Digite o código que aparece na imagem e entre com o seu e-mail</p><form class=\"m-t\" role=\"form\" name=\"frm\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"widget-head-color-box navy-bg p-lg text-center\"><div ng-if=\"!vm.ImgCaptcha\"><i class=\"fa fa-4x\" ng-class=\"{\'fa-spinner fa-pulse\':!vm.loadingError, \'fa-chain-broken\': vm.loadingError}\"></i></div><img ng-src=\"{{vm.ImgCaptcha}}\" class=\"img-responsive\" ng-if=\"vm.ImgCaptcha\"></div><div class=\"widget-text-box\"><a class=\"btn btn-sm btn-white btn-block\" ng-click=\"vm.renderCaptcha()\" ng-disabled=\"vm.loadingCaptcha\"><i class=\"fa fa-refresh\" ng-class=\"{\'fa-spin\': vm.loadingCaptcha}\"></i> Não consigo ler a imagem</a></div></div></div><div class=\"row\"><div class=\"col-md-12\"><ng-field label=\"Código\" name=\"codigo\" model=\"vm.user.Captcha\" type=\"text\" required=\"true\"></ng-field></div></div><div class=\"row\"><div class=\"col-md-12\"><ng-field label=\"Email\" name=\"email\" model=\"vm.user.Email\" type=\"email\" required=\"true\"></ng-field></div></div><div class=\"row\"><div class=\"col-md-12\"><button type=\"button\" class=\"btn btn-primary block full-width m-b\" ng-click=\"vm.resetClick()\" ng-disabled=\"vm.reseting || !frm.$valid\"><i class=\"fa\" ng-class=\"{\'fa-sign-in\':!vm.reseting, \'fa-spinner fa-pulse\': vm.reseting}\"></i> Enviar minha senha</button></div></div></form></div></div></div></div><hr><div class=\"row\"><div class=\"col-md-6\">Copyright Example Company</div><div class=\"col-md-6 text-right\"><small>© 2014-2015</small></div></div>");
$templateCache.put("view/authentication/forgot/reset.html","<div class=\"passwordBox animated fadeInDown\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"ibox-content\"><h2 class=\"font-bold\">{{vm.pageTitle}}</h2><p ng-if=\"vm.showFields\">Informe sua nova senha e redigite-a para confirmar a alteração.</p><form class=\"m-t\" role=\"form\" name=\"frm\" ng-if=\"vm.showFields\"><div class=\"row\"><div class=\"col-md-12\"><ng-field label=\"Senha\" name=\"senha\" model=\"vm.user.Password\" type=\"password\" required=\"true\"></ng-field></div></div><div class=\"row\"><div class=\"col-md-12\"><ng-field label=\"Confirme sua senha\" name=\"confirma\" model=\"vm.user.Confirma\" type=\"password\" required=\"true\" validate-async=\"vm.ComparaSenha\" validate-async-error=\"Os campos são diferentes\"></ng-field></div></div><div class=\"row\"><div class=\"col-md-12\"><button type=\"button\" class=\"btn btn-primary block full-width m-b\" ng-click=\"vm.Change()\" ng-disabled=\"vm.loading || !frm.$valid\"><i class=\"fa\" ng-class=\"{\'fa-sign-in\':!vm.loading, \'fa-spinner fa-pulse\': vm.loading}\"></i> Confirmar</button></div></div></form></div></div></div></div><hr><div class=\"row\"><div class=\"col-md-6\">Copyright Example Company</div><div class=\"col-md-6 text-right\"><small>© 2014-2015</small></div></div>");
$templateCache.put("view/authentication/login/login.html","<div class=\"middle-box text-center loginscreen animated fadeInDown\"><div><div><h1 class=\"logo-name\">IN+</h1></div><h3><span translate=\"\">Bem vindo a</span>DIVERTIX</h3><p>Identifique-se para continuar.</p><form class=\"m-t\" role=\"form\" novalidate=\"\" name=\"frm\"><ng-field label=\"Email\" ng-enter=\"vm.loginClick()\" name=\"email\" model=\"vm.user.email\" type=\"email\" required=\"true\"></ng-field><ng-field label=\"Senha\" ng-enter=\"vm.loginClick()\" name=\"pwd\" model=\"vm.user.password\" type=\"password\" required=\"true\"></ng-field><button type=\"button\" class=\"btn btn-primary block full-width m-b\" ng-click=\"vm.loginClick()\" ng-disabled=\"vm.loading || frm.$invalid\"><i class=\"fa\" ng-class=\"{\'fa-sign-in\': !vm.loading, \'fa-spinner fa-pulse\': vm.loading}\" ng-disabled=\"vm.loading\"></i> Login</button> <a class=\"btn btn-sm btn-white btn-block\" href=\"#/forgot\"><i class=\"fa fa-circle-o\"></i> Esqueci minha senha</a></form></div></div>");
$templateCache.put("view/authentication/profile/profile.html","<div class=\"panel panel-info\"><div class=\"panel-heading\">Profile</div>{{vm.user }}<div class=\"panel-body\"><form name=\"frm\"><div class=\"row\"><div class=\"col-md-6\"><ng-field name=\"Nome\" label=\"Apelido\" model=\"vm.item.Apelido\" type=\"text\" maxlength=\"40\"></ng-field></div></div><div class=\"row\"><div class=\"col-md-6\"><ng-field name=\"Login\" label=\"Email\" model=\"vm.item.Login\" type=\"email\" maxlength=\"120\" required=\"\" ng-disabled=\"true\"></ng-field></div></div><div class=\"row\"><div class=\"col-md-6\"><ng-field name=\"DataNascimento\" label=\"Data Nascimento\" model=\"vm.item.DataNascimento\" type=\"date\"></ng-field></div></div><div class=\"row\"><div class=\"col-md-4\"><ng-field name=\"Telefone\" label=\"Telefone\" model=\"vm.item.Telefone\" type=\"text\" mask=\"(99)99999-999?9\"></ng-field></div><div class=\"col-md-2\"><ng-field name=\"Ramal\" label=\"Ramal\" model=\"vm.item.Ramal\" type=\"text\" mask=\"?9?9?9?9?9?9\"></ng-field></div></div><div class=\"row\"><div class=\"col-md-6\"><ng-field name=\"Perfil\" label=\"Perfil\" model=\"vm.item.Perfil\" type=\"text\" ng-disabled=\"true\"></ng-field></div></div></form></div><div class=\"panel-footer pull-right\"><button class=\"btn btn-warning\" type=\"button\" ng-click=\"vm.cancel();\">Cancelar</button> <button class=\"btn btn-primary\" type=\"button\" ng-click=\"vm.save();\" ng-disabled=\"!frm.$valid\">Salvar</button></div></div>");
$templateCache.put("view/configuracao/cidade/form.html","<div class=\"wrapper wrapper-content animated fadeInDown\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><form name=\"frm\"><div class=\"row\"><div class=\"col-xs-11 col-md-6\"><ng-field name=\"Nome\" label=\"Nome da cidade\" model=\"vm.item.Nome\" type=\"text\" required=\"true\" maxlength=\"50\"></ng-field></div><div class=\"col-xs-11 col-md-6\"><ng-field label=\"UF\" required=\"true\" type=\"select\" model=\"vm.item.UF\" options=\"vm.ufList\" value-field=\"Id\" text-field=\"Nome\"></ng-field></div></div></form><div class=\"row\"><div class=\"form-group\"><div class=\"col-md-1 col-md-offset-10\"><button class=\"btn btn-outline pull-right\" type=\"button\" ng-click=\"vm.cancel();\">CANCELAR</button></div><div class=\"col-md-1\"><button class=\"btn btn-primary pull-right\" type=\"button\" ng-disabled=\"validateForm\" ng-click=\"vm.save();\">Atualizar</button></div></div></div></div></div></div>");
$templateCache.put("view/configuracao/cidade/grid.html","<div class=\"wrapper wrapper-content animated fadeInDown\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><button type=\"button\" class=\"btn btn-w-m btn-success pull-right col-offset-m1\" ng-click=\"vm.search()\">FILTRAR</button><div class=\"input-group col-xs-7 col-sm-8 col-md-9 col-lg-10\"><div class=\"input-group-addon\"><i class=\"fa fa-search\"></i></div><input type=\"search\" ng-model=\"vm.Filter.Nome\" class=\"form-control\" placeholder=\"Digite para filtrar os resultados\" aria-controls=\"DataTables_Table_0\"></div></div><br><div class=\"ibox-content\"><table class=\"table table-striped table-hover\" role=\"grid\"><thead><tr role=\"row\"><th>Nome</th><th>UF</th></tr></thead><tbody><tr class=\"gradeA odd\" role=\"row\" ng-repeat=\"item in vm.items\"><td class=\"project-title\"><span>{{item.Nome}}</span></td><td class=\"project-title\"><span>{{item.UF}}</span></td></tr></tbody></table></div></div></div></div></div>");
$templateCache.put("view/configuracao/cidade/index.html","<div ui-view=\"\"></div>");
$templateCache.put("view/configuracao/filafraude/form.html","<div class=\"wrapper wrapper-content animated fadeInDown\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><form name=\"frm\"><div class=\"row\"><div class=\"col-lg-6\"><ng-field required=\"true\" label=\"Tipo Fila Fraude\" changed=\"vm.chengeTipoFilaFraude\" type=\"select\" model=\"vm.TipoFilaFraude\" options=\"vm.tipofilafraude\" value-field=\"Cod\" text-field=\"Nome\"></ng-field></div></div><div ng-show=\"vm.TipoFilaFraude\" class=\"row\"><div class=\"hr-line-dashed\"></div><div class=\"col-lg-6\" ng-if=\"vm.TipoFilaFraude == \'E\' || vm.TipoFilaFraude == \'A\'\"><ng-field label=\"Estabelecimento\" type=\"select\" required=\"true\" model=\"vm.item.Estabelecimento.IdEstabelecimento\" options=\"vm.estabelecimentos\" value-field=\"Id\" text-field=\"Nome\"></ng-field></div><div ng-if=\"(vm.TipoFilaFraude == \'A\') && vm.item.Estabelecimento.IdEstabelecimento\" class=\"col-lg-6\"><ng-field label=\"Atracao\" type=\"select\" ng-if=\"vm.atracoes.length > 0\" model=\"vm.item.Atracao.IdAtracao\" required=\"true\" options=\"vm.atracoes\" value-field=\"IdAtracao\" text-field=\"Nome\"></ng-field><h4 ng-if=\"vm.atracoes.length == 0\"><strong style=\"color: red; line-height: 80px\">Não existem Atrações para este estabelecimento</strong></h4></div></div><div class=\"hr-line-dashed\"></div><div class=\"row\"><div class=\"col-lg-2\"><ng-field required=\"true\" label=\"Data de Início\" min-date=\"currentDate\" name=\"DataInicio\" model=\"vm.item.DataInicio\" type=\"date\"></ng-field></div><div class=\"col-lg-2\"><ng-field required=\"true\" label=\"Data de Fim\" min-date=\"currentDate\" name=\"DataFim\" model=\"vm.item.DataFim\" type=\"date\"></ng-field></div></div></form><div class=\"row\"><div class=\"form-group\"><div class=\"col-md-1 col-md-offset-10\"><button class=\"btn btn-outline pull-right\" type=\"button\" ng-click=\"vm.cancel();\">CANCELAR</button></div><div class=\"col-md-1\"><button class=\"btn btn-primary pull-right\" ng-disabled=\"frm.$invalid\" type=\"button\" ng-click=\"vm.save();\">SALVAR <i ng-class=\"{\'fa fa-spinner fa-pulse\' : vm.loading }\"></i></button></div></div></div></div></div></div>");
$templateCache.put("view/configuracao/filafraude/grid.html","<div class=\"wrapper wrapper-content animated fadeInDown\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><form><div class=\"row\"><div class=\"col-lg-12\"><button type=\"button\" ng-click=\"vm.include();\" class=\"btn btn-w-m btn-success pull-right col-offset-m1\">INCLUIR</button></div></div><div class=\"row\"><div class=\"col-lg-3\"><ng-field label=\"Tipo Fila Fraude\" ng-enter=\"vm.search()\" type=\"select\" model=\"vm.Filter.TipoFilaFraude\" options=\"vm.tipofilafraude\" value-field=\"Cod\" text-field=\"Nome\"></ng-field></div><div class=\"col-lg-3\"><ng-field label=\"Estabelecimentos\" ng-enter=\"vm.search()\" type=\"select\" model=\"vm.Filter.IdEstabelecimento\" options=\"vm.estabelecimentos\" value-field=\"Id\" text-field=\"Nome\"></ng-field></div><div class=\"col-lg-2\"><ng-field label=\"Data Inicio\" ng-enter=\"vm.search()\" name=\"DataInicio\" model=\"vm.Filter.DataInicio\" type=\"date\"></ng-field></div><div class=\"col-lg-2\"><ng-field label=\"Data Fim\" ng-enter=\"vm.search()\" name=\"DataFim\" model=\"vm.Filter.DataFim\" type=\"date\"></ng-field></div><div class=\"col-lg-2\" style=\"margin-top: 25px;\"><button type=\"button\" class=\"btn btn-w-m btn-success pull-right col-offset-m1\" ng-click=\"vm.search()\">FILTRAR</button></div></div></form></div><br><div style=\"overflow-x: scroll\" class=\"ibox-content\"><table class=\"table table-striped table-hover\" role=\"grid\"><thead><tr role=\"row\"><th>Tipo Fila Fraude</th><th>Estabelecimento</th><th>Atração</th><th>Data Início</th><th>Data Fim</th><th>Data Criação</th><th class=\"text-right\">Ações</th></tr></thead><tbody><tr class=\"gradeA odd\" role=\"row\" ng-repeat=\"item in vm.items\"><td class=\"project-title\" ng-switch=\"item.TipoFilaFraude\"><span ng-style=\"{\'text-decoration\':((item.Status != 1) ? \'line-through\' : \'\')}\" ng-switch-when=\"A\">Atração</span> <span ng-style=\"{\'text-decoration\':((item.Status != 1) ? \'line-through\' : \'\')}\" ng-switch-when=\"E\">Estabelecimento</span></td><td class=\"project-title\"><span ng-style=\"{\'text-decoration\':((item.Status != 1) ? \'line-through\' : \'\')}\">{{item.Estabelecimento}}</span></td><td class=\"project-title\"><span ng-style=\"{\'text-decoration\':((item.Status != 1) ? \'line-through\' : \'\')}\">{{item.Atracao}}</span></td><td class=\"project-title\"><span ng-style=\"{\'text-decoration\':((item.Status != 1) ? \'line-through\' : \'\')}\">{{item.DataInicio | date: \'dd/MM/yyyy\' : \'UTC\'}}</span></td><td class=\"project-title\"><span ng-style=\"{\'text-decoration\':((item.Status != 1) ? \'line-through\' : \'\')}\">{{item.DataFim | date: \'dd/MM/yyyy\' : \'UTC\'}}</span></td><td class=\"project-title\"><span ng-style=\"{\'text-decoration\':((item.Status != 1) ? \'line-through\' : \'\')}\">{{item.DataCriacao | date: \'dd/MM/yyyy HH:mm\' : \'UTC\'}}</span></td><td class=\"project-actions\"><span uib-dropdown=\"\" on-toggle=\"toggled(open)\"><a role=\"button\" uib-dropdown-toggle=\"\"><i class=\"fa fa-wrench\"></i></a><ul class=\"pull-right\" uib-dropdown-menu=\"\" aria-labelledby=\"simple-dropdown\"><li><a role=\"button\" ng-if=\"item.Status == 1\" ng-click=\"vm.inativar(item)\"><i class=\"fa\" ng-class=\"{\'fa-toggle-on\': itm.Status == 1, \'fa-toggle-off\': itm.Status != 1}\"></i> Inativar</a> <a role=\"button\" ng-if=\"item.Status != 1\" style=\"color: lightgrey;\"><i class=\"fa\" ng-class=\"{\'fa-toggle-on\': itm.Status == 1, \'fa-toggle-off\': itm.Status != 1}\"></i> Inativo</a></li></ul></span></td></tr></tbody></table></div></div></div></div></div>");
$templateCache.put("view/configuracao/filafraude/index.html","<div ui-view=\"\"></div>");
$templateCache.put("view/conteudo/artista/form.html","<div class=\"wrapper wrapper-content animated fadeInDown\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><form name=\"frm\"><div class=\"row\"><div class=\"col-xs-12 col-md-6\"><ng-field name=\"Nome\" label=\"Nome do artista\" model=\"vm.ArtistaVersao.NomeArtisticoHistorico\" type=\"text\" ng-disabled=\"!vm.ArtistaVersao.PodeEditar\" required=\"true\" maxlength=\"70\" ng-trim=\"false\"></ng-field></div><div class=\"col-xs-12 col-md-6\"><ng-field name=\"Uri\" label=\"Uri\" model=\"vm.items.Uri\" type=\"text\" required=\"true\"></ng-field></div><div class=\"col-xs-12 col-md-6\"><ng-field name=\"Nome\" label=\"Nome do completo\" model=\"vm.ArtistaVersao.NomeCompleto\" type=\"text\" ng-disabled=\"!vm.ArtistaVersao.PodeEditar\" maxlength=\"150\" ng-trim=\"false\"></ng-field></div><div class=\"col-xs-12 col-md-6\"><ng-field name=\"Sexo\" label=\"Sexo\" model=\"vm.ArtistaVersao.Sexo\" type=\"select\" options=\"vm.sexoList\" text-field=\"Nome\" value-field=\"Id\"></ng-field></div></div><div class=\"row\"><div class=\"col-xs-12 col-md-6\"><div class=\"table-responsive constrained\"><table class=\"table table-hover table-striped\"><thead><tr><th>Artista</th><th style=\"width: 115px\">Tipo do Artista</th></tr></thead><tbody><tr ng-repeat=\"item in vm.TipoArtistas\"><td>{{item.NomeMasculino}} / {{item.NomeFeminino}}</td><td style=\"text-align: center\"><input type=\"checkbox\" icheck=\"\" ng-model=\"item.Selecionado\" name=\"{{item.Id}}\" ng-value=\"true\"></td></tr></tbody></table><div class=\"alert alert-danger alert-dismissible\" role=\"alert\" ng-if=\"vm.LugarNaoMarcado\"><strong>Escolha pelo menos um Tipo de Artista.</strong></div></div></div><div class=\"col-xs-12 col-md-6 m-t-lg\"><input type=\"checkbox\" ng-model=\"vm.Artista.ModeradoSite\" icheck=\"\"> <strong>Artista Moderado no site</strong><br><br><br><input type=\"checkbox\" ng-model=\"vm.ArtistaVersao.ModeradoSite\" icheck=\"\"> <strong>Artista Versao Moderado no site</strong></div></div><div class=\"row\"><div class=\"col-md-4 col-lg-5 m-t\"><div class=\"capa\"><h4>Foto de perfil</h4><div ngf-drop=\"\" ngf-select=\"\" ng-model=\"vm.FotoPerfil\" ngf-drag-over-class=\"dragover\" ngf-multiple=\"true\" ngf-allow-dir=\"true\" accept=\"image/*\" layout-align=\"center center\" class=\"layout-align-center-center layout-column img-vazio capa alinhar-centro\"><div class=\"upload-content\" ng-if=\"!vm.ArtistaVersao.FotoPerfil\"><button class=\"btn btn-success btn-circle btn-lg upload-btn-icon\"><i ng-class=\"{\'fa fa-cloud-upload idle\' : !vm.spinFotoPerfil, \'fa fa-spinner fa-pulse\': vm.spinFotoPerfil}\"></i></button><br><br><br><br><h3 class=\"upload-btn-text\">Clique ou arraste a foto para fazer upload</h3></div><div ng-if=\"vm.ArtistaVersao.FotoPerfil\"><img ng-src=\"{{vm.ArtistaVersao.FotoPerfil}}\"></div></div><div class=\"list-group list-group-horizontal pull-right\"><button class=\"btn btn-link btn-lg\" ng-disabled=\"!vm.ArtistaVersao.FotoPerfil\" ng-click=\"vm.DeleteFotoPerfil(vm.ArtistaVersao.FotoPerfil)\"><i class=\"fa fa-trash\"></i></button> <button class=\"btn btn-link btn-lg\" ng-disabled=\"!vm.ArtistaVersao.FotoPerfil\" ngf-select=\"vm.uploadFotoPerfil($files)\"><i class=\"fa fa-pencil\"></i></button> <a class=\"btn btn-link btn-lg\"><span class=\"btn btn-link\" popover-placement=\"auto top\" uib-popover=\"Foto que será exibida no perfil do Artista\" popover-trigger=\"mouseenter\"><i class=\"fa fa-question-circle\" style=\"font-size:1.3em;\"></i></span></a></div></div></div></div><div class=\"row\"><div class=\"form-group\"><div class=\"col-md-1 col-md-offset-10\"><button class=\"btn btn-outline pull-right\" type=\"button\" ng-click=\"vm.cancel();\">CANCELAR</button></div><div class=\"col-md-1\"><button class=\"btn btn-primary pull-right\" ng-disabled=\"frm.$invalid\" type=\"button\" ng-click=\"vm.save();\">SALVAR</button></div></div></div></form></div></div></div>");
$templateCache.put("view/conteudo/artista/grid.html","<div class=\"wrapper wrapper-content animated fadeInDown\"><div class=\"row\"><div class=\"col-lg-12\"><button ng-click=\"vm.add()\" type=\"button\" class=\"btn btn-w-m btn-success m-b-md pull-right\">NOVO ARTISTA</button><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><button type=\"button\" class=\"btn btn-w-m btn-success pull-right col-offset-m1\" ng-click=\"vm.search()\" ng-disabled=\"vm.searching\"><i class=\"fa\" ng-class=\"{\'fa fa-spinner fa-spin\' : vm.searching}\"></i> FILTRAR</button><div class=\"input-group col-xs-7 col-sm-8 col-md-9 col-lg-10\"><div class=\"input-group-addon\"><i class=\"fa fa-search\"></i></div><input type=\"search\" ng-enter=\"vm.search()\" class=\"form-control\" placeholder=\"Digite para filtrar os resultados\" ng-model=\"vm.Filter.Nome\" aria-controls=\"DataTables_Table_0\"></div></div><br><div class=\"ibox-content\"><div class=\"table-responsive constrained\" ts-wrapper=\"\" ts-no-data-text=\"Utilize o filtro para filtrar os usuários\"><table class=\"table table-hover table-striped\" data-sorting=\"true\" role=\"grid\" infinite-scroll=\"vm.search(true)\" infinite-scroll-disabled=\"vm.complete || vm.searching\" infinite-scroll-immediate-check=\"false\" infinite-scroll-distance=\"0\"><thead><tr><th ts-criteria=\"NomeArtisticoHistorico|lowercase\">Nome Artistico</th><th ts-criteria=\"Usuario|lowercase\">Incluido por</th><th ts-criteria=\"Data|lowercase\">Data</th><th class=\"text-right\">Ações</th></tr></thead><tbody><tr ng-repeat=\"item in vm.items\" ng-class=\"{\'success\' : itm.updated}\" ts-repeat=\"\"><td class=\"project-title\"><span>{{item.NomeArtisticoHistorico}}</span></td><td class=\"project-title\"><span>{{item.Usuario}}</span></td><td class=\"project-title\"><span>{{item.Data | date: \'dd/MM/yyyy\' : \'UTC\'}}</span></td><td class=\"project-actions\"><span uib-dropdown=\"\" on-toggle=\"toggled(open)\"><a role=\"button\" uib-dropdown-toggle=\"\"><i class=\"fa fa-wrench\"></i></a><ul class=\"pull-right\" uib-dropdown-menu=\"\" aria-labelledby=\"simple-dropdown\"><li><a role=\"button\" ng-click=\"vm.edit(item);\"><i class=\"fa fa-edit\"></i> Editar</a> <a role=\"button\" ng-click=\"vm.del(item);\"><i class=\"fa fa-trash\"></i> Excluir</a></li></ul></span></td></tr></tbody></table><div class=\"row\"><div class=\"col-md-6 col-md-offset-5\" ng-show=\"vm.searching\"><i class=\"fa fa-spinner fa-pulse fa-1x fa-fw\"></i> Carregando...</div></div></div></div></div></div></div></div>");
$templateCache.put("view/conteudo/artista/index.html","<div ui-view=\"\"></div>");
$templateCache.put("view/conteudo/atracao/form.html","<div class=\"panel panel-info\"><div class=\"panel-heading\">Edição</div><div class=\"panel-body\"><p>Preencha os dados do formulário</p><form name=\"frm\"><div class=\"row\"><div class=\"col-md-12\"><ng-field name=\"Nome\" label=\"Nome\" model=\"vm.item.Nome\" type=\"text\" required=\"true\"></ng-field></div></div></form></div><div class=\"panel-footer pull-right\"><button class=\"btn btn-warning\" type=\"button\" ng-click=\"vm.cancel();\" \"=\"\">Cancelar</button> <button class=\"btn btn-primary\" type=\"button\" ng-click=\"vm.save();\" ng-disabled=\"!frm.$valid\"><i class=\"fa\" ng-class=\"{\'fa fa-spinner fa-spin\' : vm.loading}\"></i> Salvar</button></div></div>");
$templateCache.put("view/conteudo/atracao/form_wizard.html","<style>\n    .wizard > .content {\n        background: white !important;\n    }\n</style><div class=\"wrapper wrapper-content animated fadeInRight\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox\"><div class=\"ibox-content wizard\"><div class=\"steps clearfix\"><ul><li ui-sref-active=\"current\"><button ui-sref=\".ficha_tecnica\" style=\"width:90%!important;text-align:left\" class=\"btn-default\"><span>1</span> Ficha Técnica</button></li><li ui-sref-active=\"current\"><button ui-sref=\".participantes\" style=\"width:90%!important;text-align:left\" class=\"btn-default\" ng-disabled=\"AtracaoForm.$invalid || vm.itensCount < 7\"><span>2</span> Participantes <i class=\"fa pull-right\" ng-class=\"{\'\' : vm.itensCount == 7, \'fa-spinner fa-pulse\' : vm.itensCount < 7}\"></i></button></li><li ui-sref-active=\"current\"><button ui-sref=\".sinopse\" style=\"width:90%!important;text-align:left\" class=\"btn-default\" ng-disabled=\"AtracaoForm.$invalid\"><span>1</span> Sinopse</button></li><li ui-sref-active=\"current\"><button ui-sref=\".midia\" style=\"width:90%!important;text-align:left\" class=\"btn-default\" ng-disabled=\"AtracaoForm.$invalid\"><span>2</span> Mídia</button></li></ul></div><div class=\"hr-line-dashed\" style=\"margin-bottom:10px;\"></div><div class=\"wizard\"><div class=\"content\"><form name=\"AtracaoForm\" class=\"p-lg\"><div id=\"form-views\" ui-view=\"\"></div></form></div></div><div></div></div></div></div></div></div>");
$templateCache.put("view/conteudo/atracao/grid.html","<style>\n\n.alinhar-centro {\ndisplay: -webkit-box;\ndisplay: -ms-flexbox;\ndisplay: flex;\n-webkit-box-align: center;\n-ms-flex-align: center;\nalign-items: center;\n-webkit-box-pack: center;\n-ms-flex-pack: center;\njustify-content: center;\n}\n</style><div class=\"wrapper wrapper-content animated fadeInRight\"><div class=\"row\"><div class=\"col-lg-12\"><button type=\"button\" class=\"btn btn-w-m btn-success pull-right m-b-lg\" ng-click=\"vm.novaAtracao()\">NOVA ATRAÇÃO</button> <button type=\"button\" class=\"btn btn-w-m btn-success pull-right m-b-lg\" ng-click=\"vm.ordenar()\">ORDENAR</button><form name=\"frm\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-lg-8\"><ng-field label=\"Estabelecimento\" type=\"select\" model=\"vm.Filter.IdEstabelecimento\" options=\"vm.lstEstabelecimento\" value-field=\"Id\" text-field=\"Nome\"></ng-field></div><div class=\"col-md-8\"><div class=\"input-group\"><div class=\"input-group-addon\"><i class=\"fa fa-search\"></i></div><input type=\"search\" class=\"form-control\" placeholder=\"Digite para filtrar os resultados\" ng-enter=\"vm.search()\" ng-model=\"vm.Filter.Nome\" aria-controls=\"DataTables_Table_0\"></div></div><div class=\"col-md-2\"><button type=\"button\" class=\"btn btn-w-m btn-success pull-right col-offset-m1\" ng-click=\"vm.search()\" ng-disabled=\"vm.searching\"><i class=\"fa\" ng-class=\"{\'fa fa-spinner fa-spin\' : vm.searching}\"></i> FILTRAR</button></div><div class=\"col-md-2\"><div class=\"pull-right m-t-sm\"><input icheck=\"\" type=\"checkbox\" ng-model=\"vm.Filter.Status\" ng-true-value=\"1\" ng-false-value=\"2\" style=\"text-align: right\"><strong>&nbsp;EXIBIR ATIVOS</strong></div></div></div></div><br><div class=\"ibox-content\"><div class=\"table-responsive constrained\" ts-wrapper=\"\" ts-no-data-text=\"Utilize o filtro para filtrar os usuários\"><table class=\"table table-hover table-striped\" data-sorting=\"true\" role=\"grid\" infinite-scroll=\"vm.search(true)\" infinite-scroll-disabled=\"vm.complete || vm.searching\" infinite-scroll-immediate-check=\"false\" infinite-scroll-distance=\"0\"><thead><tr><th ts-criteria=\"NomeAtracao|lowercase\" width=\"200\">Atração</th><th ts-criteria=\"NomeEstabelecimento|lowercase\">Estabelecimento</th><th>Diretores</th><th>Autores</th><th ts-criteria=\"AnoLancamento|lowercase\">Ano</th><th ts-criteria=\"NomeTipoAtracao|lowercase\">Tipo</th><th ts-criteria=\"DataCriacao|lowercase\">Data de criação</th><th class=\"text-right\">Ações</th></tr></thead><tbody><tr ng-repeat=\"itm in vm.items\" ng-class=\"{\'success\' : itm.updated}\" ts-repeat=\"\"><td class=\"project-title\"><span ng-style=\"{\'text-decoration\':((itm.Status != 1) ? \'line-through\' : \'\')}\">{{itm.NomeAtracao}}</span></td><td class=\"project-title\"><span ng-style=\"{\'text-decoration\':((itm.Status != 1) ? \'line-through\' : \'\')}\">{{itm.NomeEstabelecimento}}</span></td><td class=\"project-title\"><span ng-style=\"{\'text-decoration\':((itm.Status != 1) ? \'line-through\' : \'\')}\">{{itm.Diretores}}</span></td><td class=\"project-title\"><span ng-style=\"{\'text-decoration\':((itm.Status != 1) ? \'line-through\' : \'\')}\">{{itm.Autores}}</span></td><td class=\"project-title\"><span ng-style=\"{\'text-decoration\':((itm.Status != 1) ? \'line-through\' : \'\')}\">{{itm.AnoLancamento}}</span></td><td class=\"project-title\"><span ng-style=\"{\'text-decoration\':((itm.Status != 1) ? \'line-through\' : \'\')}\">{{itm.NomeTipoAtracao}}</span></td><td class=\"project-title\"><span ng-style=\"{\'text-decoration\':((itm.Status != 1) ? \'line-through\' : \'\')}\">{{itm.DataCriacao | date: \'dd/MM/yyyy\' }}</span></td><td class=\"project-actions\"><span uib-dropdown=\"\" on-toggle=\"toggled(open)\"><a role=\"button\" uib-dropdown-toggle=\"\"><i class=\"fa fa-wrench\"></i></a><ul class=\"pull-right\" uib-dropdown-menu=\"\" aria-labelledby=\"simple-dropdown\"><li><a role=\"button\" ng-click=\"vm.editarAtracao(itm);\"><i class=\"fa fa-edit\"></i> Editar atração</a> <a role=\"button\" ng-click=\"vm.editarInformacoesExclusivas(itm);\"><i class=\"fa fa-edit\"></i> Editar informações exclusivas</a> <a role=\"button\" ng-click=\"vm.customToggle(itm);\"><i class=\"fa\" ng-class=\"{\'fa-toggle-on\': itm.Status == 1, \'fa-toggle-off\': itm.Status != 1}\"></i> {{(itm.Status == 1)?\'Desabilitar atração\' : \'Habilitar atração\'}}</a> <a role=\"button\" ng-if=\"!itm.ExistiuSessao\" ng-click=\"vm.desassociar(itm);\"><i class=\"fa fa-toggle-off\"></i> Desassociar atração</a></li></ul></span></td></tr></tbody></table><div class=\"row\"><div class=\"col-md-6 col-md-offset-5\" ng-show=\"vm.searching\"><i class=\"fa fa-spinner fa-pulse fa-1x fa-fw\"></i> Carregando...</div></div></div></div></div></form></div></div></div>");
$templateCache.put("view/conteudo/atracao/index.html","<div ui-view=\"\"></div>");
$templateCache.put("view/conteudo/atracao/informacoesexclusivas.html","<div class=\"wrapper wrapper-content animated fadeInRight\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><form name=\"frm\" novalidate=\"\"><div class=\"row\"><div class=\"col-md-4\"><ng-field name=\"NomeIngresso\" label=\"Nome ingresso\" model=\"vm.item.NomeImpressao\" type=\"text\" required=\"true\" maxlength=\"60\"></ng-field></div><div class=\"col-md-4\"><ng-field name=\"DataEstreia\" label=\"Data da estréia\" model=\"vm.item.DataEstreia\" type=\"date\"></ng-field></div><div class=\"col-md-2\"><br><br><input icheck=\"\" type=\"checkbox\" ng-model=\"vm.item.Status\" ng-true-value=\"1\" ng-false-value=\"2\" class=\"m-t-md\"><strong class=\"m-l-md\">&nbsp;STATUS ATIVO</strong></div></div><div class=\"row\"><div class=\"col-md-12\"><ng-field name=\"DescricaoAuxiliar\" label=\"Descrição auxiliar\" model=\"vm.item.DescricaoAuxiliar\" type=\"text\"></ng-field></div></div><div class=\"row\"><div class=\"col-md-6\"><ng-field name=\"NotasCompra\" label=\"Notas antes compra\" model=\"vm.item.NotasCompra\" type=\"textarea\" rows=\"3\" maxlength=\"500\"></ng-field></div><div class=\"col-md-6\"><ng-field name=\"NotasImpressao\" label=\"Notas impressas\" model=\"vm.item.NotasImpressao\" type=\"textarea\" rows=\"3\" maxlength=\"100\"></ng-field></div></div><br></form><div class=\"form-group\"><p><button type=\"button\" class=\"btn btn-w-m btn-success pull-right\" ng-click=\"vm.save();\" ng-disabled=\"!frm.$valid\">SALVAR</button> <button type=\"button\" class=\"btn btn-outline btn-link pull-right\" ng-click=\"vm.cancel();\">CANCELAR</button></p><br></div></div></div></div></div></div>");
$templateCache.put("view/conteudo/atracao/ordenacao.html","<style>\n  .dracula-p{\n    background-color: #D3D3D3;\n    margin-bottom: 7px;\n    padding: 5px;\n    color: black;\n    font-weight: 600;\n    cursor:move;\n    border-radius: 5px;\n  }\n  .dracula-div{\n    cursor:move;\n  }\n</style><div class=\"wrapper wrapper-content animated fadeInRight\"><div class=\"row\"><div class=\"col-lg-12\"><form name=\"frm\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><div class=\"row m-b-xs\"><button type=\"button\" class=\"btn btn-w-m btn-success pull-right m-b-lg m-r-md\" ng-disabled=\"vm.loading || vm.items.length == 0\" ng-click=\"vm.save()\">SALVAR <i class=\"fa fa-spinner fa-pulse fa-fw\" ng-if=\"vm.loading\"></i></button></div><div class=\"row\"><div class=\"wrapper\"><div class=\"dracula-div\" dragula=\'\"another-bag\"\' dragula-model=\"vm.items\"><p class=\"dracula-p\" ng-repeat=\"item in vm.items\" ng-class=\"item.type\">{{$index + 1}} - {{item.Nome}}</p></div></div></div></div></div></form></div></div></div>");
$templateCache.put("view/conteudo/atracao/pre_cadastro.html","<style>\n  h3 {\n    text-transform: uppercase;\n  }\n\n  .table {\n    border-bottom: 0px !important;\n  }\n\n  .table th,\n  .table td {\n    border: 1px !important;\n  }\n\n  .fixed-table-container {\n    border: 0px !important;\n  }\n\n  table tr {\n    height: 5px !important;\n  }\n\n  .associado {\n    background-color: #ebebeb !important;\n  }\n\n  .panel-min-height {\n    min-height: 120px;\n  }\n\n  div.panel.panel-default.ng-scope  p {\n    margin: 0;\n  }\n\n  .card {\n    height: 230px;\n    margin-bottom: 40px;\n  }\n\n  .responsive {\n    max-width: 90px;\n    border-radius: 4px;\n  }\n\n  .bg-success{\n    background-color: #94bed8;\n    color: white;\n  }\n\n</style><div class=\"wrapper wrapper-content animated fadeInRight ng-scope\"><div class=\"row\"><div class=\"panel panel-default\"><div class=\"panel-body\"><div class=\"row\"><div class=\"col-md-12 m-b-md\"><div class=\"col-md-1 m-t-sm\"><img src=\"../img/icons/ico-star-atracao.png\"></div><div class=\"col-md-11\"><h4>Veja se a atração já existe na divertix.com.br</h4><h5>Use os filtros abaixo para facilitar sua busca</h5></div></div></div><br><form name=\"frm\"><div class=\"row\"><div class=\"col-md-8\"><ng-field label=\"Estabelecimento\" type=\"select\" model=\"vm.Filter.IdEstabelecimento\" options=\"vm.lstEstabelecimento\" value-field=\"Id\" text-field=\"Nome\" required=\"true\"></ng-field></div><div class=\"col-md-12\" ng-if=\"vm.lstTipoAtracao.length > 1\"><h4>Tipos de Atração</h4><label class=\"radio-inline\" ng-repeat=\"item in vm.lstTipoAtracao\"><input icheck=\"\" type=\"radio\" name=\"optradio\" ng-model=\"vm.Filter.TipoAtracao\" ng-disabled=\"!vm.Filter.IdEstabelecimento\" value=\"{{item.IdTipoAtracao}}\"> <label>{{item.NomeTipoAtracao}}</label></label><br><br></div><div class=\"col-md-8\"><div class=\"input-group\"><span class=\"input-group-addon\" id=\"basic-addon1\"><div class=\"glyphicon glyphicon-search\"></div></span> <input ng-disabled=\"!vm.Filter.IdEstabelecimento\" ng-enter=\"vm.search()\" type=\"text\" class=\"form-control\" placeholder=\"Pesquisar\" ng-model=\"vm.Filter.Nome\" aria-describedby=\"basic-addon1\"></div></div><div class=\"col-md-4\"><button type=\"button\" class=\"btn btn-success\" ng-click=\"vm.search()\" ng-disabled=\"vm.loading || frm.$invalid\">VERIFICAR NA DIVERTIX <i ng-class=\"{\'fa fa-spinner fa-pulse\' : vm.loading }\"></i></button></div></div></form></div></div></div><div class=\"row\" ng-if=\"vm.items.length >= 0\"><div class=\"col-md-6\"><div class=\"contact-box\" style=\"background-color:#F3F3F4; border:none\"><div ng-if=\"vm.showCard && vm.items.length == 0\">Nenhuma atração encontrada</div><div ng-if=\"vm.showCard && vm.items.length == 1\">1 atração escontrada</div><div ng-if=\"vm.showCard && vm.items.length > 1\">{{vm.items.length}} atrações escontradas</div><div ng-if=\"!vm.Filter.IdEstabelecimento\">Selecione um estabelecimento</div></div></div><div class=\"col-md-6\"><div class=\"panel panel-default\"><div class=\"panel-body bg-success\"><span class=\"glyphicon glyphicon-plus-sign pull-left\" style=\"font-size:40px\"></span> <button type=\"button\" ng-disabled=\"frm.$invalid\" ng-click=\"vm.NovaAtracao()\" class=\"btn btn-success pull-right\">CRIAR {{ vm.ObterTitulo() == \'1\' ? \'SHOW\' : vm.ObterTitulo() == \'2\' ? \'PEÇA\' : vm.ObterTitulo() == \'3\' ? \'FILME\' : \'\' }}</button></div></div></div></div><div class=\"row\" ng-if=\"vm.showCard\"><div class=\"col\"><div class=\"col-lg-4 col-md-6 card\" ng-repeat=\"itm in vm.items\"><div class=\"panel panel-default\" ng-class=\"itm.Associada ? \'associado\': \'\'\"><div class=\"panel-body\"><div class=\"row\"><div class=\"col-md-8 col-sm-8 col-xs-7\"><div class=\"row\"><div class=\"col-md-12\"><h3>{{itm.NomeAtracao}}</h3></div><div class=\"panel panel-default\" ng-class=\"itm.Associada ? \'associado\': \'\'\" style=\"border:none\" ng-if=\"itm.IdTipoAtracao == 2 || itm.IdTipoAtracao == 3\"><div class=\"panel-body\"><div class=\"row\"><div class=\"col-md-2\" style=\"\">Produtor</div><div class=\"col-md-10\"><p read-more=\"\" content=\"{{itm.Produtor}}\"></p></div></div><div class=\"row\"><div class=\"col-md-2\">Autor</div><div class=\"col-md-10\"><p read-more=\"\" limit=\"10\" content=\"{{itm.Autores}}\"></p></div></div><div class=\"row\"><div class=\"col-md-2\">Atores</div><div class=\"col-md-10\"><p read-more=\"\" limit=\"10\" content=\"{{itm.Elenco}}\"></p></div></div><div class=\"row\"><div class=\"col-md-2\">Ano</div><div class=\"col-md-10\"><p read-more=\"\" content=\"{{itm.Ano}}\"></p></div></div></div></div><div class=\"panel panel-default\" ng-class=\"itm.Associada ? \'associado\': \'\'\" style=\"border:none\" ng-if=\"itm.IdTipoAtracao == 1\"><div class=\"panel-body\"><div class=\"row\"><div class=\"col-md-2\" style=\"\">Produtor</div><div class=\"col-md-10\"><p read-more=\"\" content=\"{{itm.Produtor}}\"></p></div></div><div class=\"row\"><div class=\"col-md-2\">Autor</div><div class=\"col-md-10\"><p read-more=\"\" content=\"{{itm.Autores}}\"></p></div></div><div class=\"row\"><div class=\"col-md-2\">Atores</div><div class=\"col-md-10\"><p read-more=\"\" content=\"{{itm.Elenco}}\"></p></div></div></div></div></div></div><div class=\"col-md-4 col-sm-4 col-xs-5\"><img ng-if=\"itm.FotoCapa != null\" class=\"responsive pull-right\" ng-src=\"{{itm.FotoCapa}}\" fallback-src=\"../img/foto-capa-no-image.png\"> <img ng-if=\"itm.FotoCapa == null\" class=\"responsive pull-right\" src=\"../img/foto-capa-no-image.png\"></div></div></div><div class=\"panel-footer\" style=\"border:none;min-height:50px;background:white\" ng-class=\"itm.Associada ? \'associado\': \'\'\"><div class=\"row top\"><div class=\"col-md-6\"><div class=\"pull-left\" style=\"color:#337ab7\" ng-if=\"itm.Associada == true\">JÁ ASSOCIADA</div><div class=\"pull-left\" ng-if=\"itm.Associada == false\"><a ng-click=\"vm.associarDesassociar(itm)\"><strong>ASSOCIAR</strong></a></div></div><div class=\"col-md-6\"><div ng-if=\"itm.Associada\"><a class=\"pull-right btn\" ng-class=\"{ \'btn-primary btn-outline btn-sm\': itm.Status == 2, \'btn-danger btn-outline btn-sm\': itm.Status == 1 }\" ng-click=\"vm.customToggle(itm)\">{{(itm.Status == 1)? \'Inativar\' : \'Ativar\'}}</a>&nbsp;</div></div></div></div></div></div></div></div></div>");
$templateCache.put("view/conteudo/banda/form.html","<div class=\"wrapper wrapper-content animated fadeInDown\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><form name=\"frm\"><div class=\"row\"><div class=\"col-xs-12 col-md-6\"><ng-field name=\"Nome\" label=\"Nome da banda\" model=\"vm.BandaVersao.NomeHistorico\" type=\"text\" ng-disabled=\"!vm.BandaVersao.PodeEditar\" required=\"true\" maxlength=\"70\"></ng-field></div><div class=\"col-xs-12 col-md-6\"><ng-field name=\"Uri\" label=\"Uri\" model=\"vm.BandaVersao.UriHistorico\" type=\"text\" required=\"true\"></ng-field></div></div><div class=\"row\"><div class=\"col-xs-12 col-md-3 m-t-lg\"><input type=\"checkbox\" ng-model=\"vm.BandaVersao.ModeradoSite\" icheck=\"\"> <strong>Banda Versão Moderado no site</strong></div><div class=\"col-xs-12 col-md-3 m-t-lg\"><input type=\"checkbox\" ng-model=\"vm.Banda.ModeradoSite\" icheck=\"\"> <strong>Banda Moderado no site</strong></div></div><div class=\"row m-t-lg m-b-lg\"><div class=\"col-md-12\"><div class=\"col-md-12\" style=\"padding-left:0; padding-right:0\"><h4>Artistas da banda</h4><chips tags=\"vm.Musicos\" value-field=\"IdArtista\" items=\"vm.artistaBandaFilter\"></chips></div></div></div></form><form name=\"frm2\"><div class=\"row\"><div class=\"col-md-4 col-lg-5 m-t\"><div class=\"capa\"><h4>Foto de perfil</h4><div ngf-drop=\"\" ngf-select=\"\" ng-model=\"vm.FotoPerfil\" ngf-drag-over-class=\"dragover\" ngf-multiple=\"true\" ngf-allow-dir=\"true\" accept=\"image/*\" layout-align=\"center center\" class=\"layout-align-center-center layout-column img-vazio capa alinhar-centro\"><div class=\"upload-content\" ng-if=\"!vm.BandaVersao.FotoPerfil\"><button class=\"btn btn-success btn-circle btn-lg upload-btn-icon\"><i ng-class=\"{\'fa fa-cloud-upload idle\' : !vm.spinFotoPerfil, \'fa fa-spinner fa-pulse\': vm.spinFotoPerfil}\"></i></button><br><br><br><br><h3 class=\"upload-btn-text\">Clique ou arraste a foto para fazer upload</h3></div><div ng-if=\"vm.BandaVersao.FotoPerfil\"><img ng-src=\"{{vm.BandaVersao.FotoPerfil}}\"></div></div><div class=\"list-group list-group-horizontal pull-right\"><button class=\"btn btn-link btn-lg\" ng-disabled=\"!vm.BandaVersao.FotoPerfil\" ng-click=\"vm.DeleteFotoPerfil(vm.BandaVersao.FotoPerfil)\"><i class=\"fa fa-trash\"></i></button> <button class=\"btn btn-link btn-lg\" ng-disabled=\"!vm.BandaVersao.FotoPerfil\" ngf-select=\"vm.uploadFotoPerfil($files)\"><i class=\"fa fa-pencil\"></i></button> <a class=\"btn btn-link btn-lg\"><span class=\"btn btn-link\" popover-placement=\"auto top\" uib-popover=\"Foto que será exibida no perfil do Banda\" popover-trigger=\"mouseenter\"><i class=\"fa fa-question-circle\" style=\"font-size:1.3em;\"></i></span></a></div></div></div></div></form><div class=\"row\"><div class=\"form-group\"><div class=\"col-md-1 col-md-offset-10\"><button class=\"btn btn-outline pull-right\" type=\"button\" ng-click=\"vm.cancel();\">CANCELAR</button></div><div class=\"col-md-1\"><button class=\"btn btn-primary pull-right\" type=\"button\" ng-disabled=\"frm.$invalid\" ng-click=\"vm.save();\">SALVAR</button></div></div></div></div></div></div>");
$templateCache.put("view/conteudo/banda/grid.html","<div class=\"wrapper wrapper-content animated fadeInDown\"><div class=\"row\"><div class=\"col-lg-12\"><button ng-click=\"vm.add()\" type=\"button\" class=\"btn btn-w-m btn-success m-b-md pull-right\">ADICIONAR BANDA</button><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><button type=\"button\" class=\"btn btn-w-m btn-success pull-right col-offset-m1\" ng-click=\"vm.search()\" ng-disabled=\"vm.searching\"><i class=\"fa\" ng-class=\"{\'fa fa-spinner fa-spin\' : vm.searching}\"></i> FILTRAR</button><div class=\"input-group col-xs-7 col-sm-8 col-md-9 col-lg-10\"><div class=\"input-group-addon\"><i class=\"fa fa-search\"></i></div><input type=\"search\" ng-enter=\"vm.search()\" class=\"form-control\" placeholder=\"Digite para filtrar os resultados\" ng-model=\"vm.Filter.Nome\" aria-controls=\"DataTables_Table_0\"></div></div><br><div class=\"ibox-content\"><div class=\"table-responsive constrained\" ts-wrapper=\"\" ts-no-data-text=\"Utilize o filtro para filtrar os usuários\"><table class=\"table table-hover table-striped\" data-sorting=\"true\" role=\"grid\" infinite-scroll=\"vm.search(true)\" infinite-scroll-disabled=\"vm.complete || vm.searching\" infinite-scroll-immediate-check=\"false\" infinite-scroll-distance=\"0\"><thead><tr role=\"row\"><th ts-criteria=\"NomeHistorico|lowercase\">Nome</th><th class=\"text-right\">Ações</th></tr></thead><tbody><tr ng-repeat=\"item in vm.items\" ng-class=\"{\'success\' : itm.updated}\" ts-repeat=\"\"><td class=\"project-title\"><span>{{item.NomeHistorico}}</span></td><td class=\"project-actions\"><span uib-dropdown=\"\" on-toggle=\"toggled(open)\"><a role=\"button\" uib-dropdown-toggle=\"\"><i class=\"fa fa-wrench\"></i></a><ul class=\"pull-right\" uib-dropdown-menu=\"\" aria-labelledby=\"simple-dropdown\"><li><a role=\"button\" ng-click=\"vm.edit(item);\"><i class=\"fa fa-edit\"></i> Editar</a> <a role=\"button\" ng-click=\"vm.del(item);\"><i class=\"fa fa-trash\"></i> Excluir</a></li></ul></span></td></tr></tbody></table></div></div></div></div></div></div>");
$templateCache.put("view/conteudo/banda/index.html","<div ui-view=\"\"></div>");
$templateCache.put("view/conteudo/banner/form.html","<div class=\"wrapper wrapper-content animated fadeInDown\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><div class=\"container-fluid\"><form name=\"midiaForm\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6\"><ng-field required=\"true\" label=\"Estabelecimento\" type=\"select\" model=\"vm.IdEstabelecimento\" options=\"vm.estabelecimentoList\" value-field=\"Id\" text-field=\"Nome\"></ng-field></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6\"><ng-field ng-disabled=\"!vm.atracaoList\" label=\"Atracao\" type=\"select\" model=\"vm.IdAtracao\" options=\"vm.atracaoList\" value-field=\"IdAtracao\" text-field=\"Nome\"></ng-field></div></div><div class=\"row\"><div class=\"col-xs-12 col-md-6\"><ng-field name=\"Prioridade\" label=\"Prioridade\" model=\"vm.Prioridade\" type=\"number\" required=\"true\"></ng-field></div></div><div class=\"row\"><div class=\"col-sm-12 col-md-12 col-lg-9\"><div class=\"banner\"><h4>Banner visão desktop</h4><div ng-disabled=\"vm.loading\" ngf-drop=\"\" ngf-select=\"\" ng-model=\"vm.FileDesktop\" ngf-drag-over-class=\"dragover\" ngf-multiple=\"true\" ngf-allow-dir=\"true\" accept=\"image/*\" layout-align=\"center center\" class=\"layout-align-center-center layout-column alinhar-centro banner\" ng-class=\"{\'img-ok\' : vm.Banner.Desktop != null, \'img-vazio\' : vm.Banner.Desktop == null}\"><div ng-if=\"!vm.Banner.Desktop\"><button class=\"btn btn-success btn-circle btn-lg btn-crop-center\" ng-disabled=\"vm.loading\"><i ng-class=\"{\'fa fa-cloud-upload idle\' : !vm.spinFotoDesktop, \'fa fa-spinner fa-pulse\': vm.spinFotoDesktop}\"></i></button><h3>Clique ou arraste a foto para fazer upload</h3><div ngf-no-file-drop=\"\">Arrastar não suportado pelo browser</div></div><div ng-if=\"vm.Banner.Desktop\"><img ng-src=\"{{vm.Banner.Desktop}}\"></div></div><div class=\"list-group list-group-horizontal pull-right\"><button ng-disabled=\"vm.loading\" class=\"btn btn-link btn-lg\" ngf-select=\"vm.uploadDesktop($files)\" accept=\"image/*\"><i class=\"fa fa-pencil\"></i></button> <a class=\"btn btn-link btn-lg\" style=\"margin: 0; padding: 8px 0;\"><span class=\"btn btn-link\" popover-placement=\"auto top\" uib-popover=\"Foto que será exibida na home do site na visualização desktop\" popover-trigger=\"mouseenter\"><i class=\"fa fa-question-circle\" style=\"font-size:1.3em;\"></i></span></a></div></div></div><div class=\"col-sm-12 col-md-12 col-lg-3\"><div class=\"capa\"><h4>Banner visão celular.</h4><div ng-disabled=\"vm.loading\" ngf-drop=\"\" ngf-select=\"\" ng-model=\"vm.FilePhone\" ngf-drag-over-class=\"dragover\" ngf-multiple=\"true\" ngf-allow-dir=\"true\" accept=\"image/*\" layout-align=\"center center\" class=\"layout-align-center-center layout-column capa alinhar-centro\" ng-class=\"{\'img-ok\' : vm.Banner.Phone != null, \'img-vazio\' : vm.Banner.Phone == null}\"><div ng-if=\"!vm.Banner.Phone\"><button class=\"btn btn-success btn-circle btn-lg btn-crop-center\" ng-disabled=\"vm.loading\"><i ng-class=\"{\'fa fa-cloud-upload idle\' : !vm.spinFotoPhone, \'fa fa-spinner fa-pulse\': vm.spinFotoPhone}\"></i></button><h3>Clique ou arraste a foto para fazer upload</h3></div><div ng-if=\"vm.Banner.Phone\"><img ng-src=\"{{vm.Banner.Phone}}\"></div></div><div class=\"list-group list-group-horizontal pull-right\"><button ng-disabled=\"vm.loading\" class=\"btn btn-link btn-lg\" ngf-select=\"vm.uploadPhone($files)\" accept=\"image/*\"><i class=\"fa fa-pencil\"></i></button> <a class=\"btn btn-link btn-lg\" style=\"margin: 0; padding: 8px 0;\"><span class=\"btn btn-link\" popover-placement=\"auto top\" uib-popover=\"Foto que será exibida na home do site na visualização celular.\" popover-trigger=\"mouseenter\"><i class=\"fa fa-question-circle\" style=\"font-size:1.3em;\"></i></span></a></div></div></div></div><div class=\"hr-line-dashed\"></div></form><div class=\"row m-t-md\"><div class=\"col-md-12\"><div class=\"row pull-right\"><div class=\"inline m-r-md\"><a ui-sref=\"conteudo.banner.grid\" class=\"btn btn-default pull-right offset3\">CANCELAR</a></div><div class=\"inline\"><button type=\"button\" ng-click=\"vm.Save()\" class=\"btn btn-success pull-right\" ng-disabled=\"!vm.Banner.Desktop || !vm.Banner.Phone || !vm.IdEstabelecimento || !vm.IdAtracao || !vm.Prioridade || vm.loading || vm.videoProgress != null\"><i class=\"fa\" ng-class=\"{\'fa fa-spinner fa-spin\' : vm.loading}\"></i> SALVAR</button></div></div></div></div></div></div></div></div>");
$templateCache.put("view/conteudo/banner/grid.html","<div class=\"wrapper wrapper-content animated fadeInDown\"><div class=\"row\"><div class=\"col-lg-12\"><button ng-click=\"vm.add()\" type=\"button\" class=\"btn btn-w-m btn-success m-b-md pull-right\">ADICIONAR BANNER</button><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><button type=\"button\" class=\"btn btn-w-m btn-success pull-right col-offset-m1\" ng-click=\"vm.search()\" ng-disabled=\"vm.searching\"><i class=\"fa\" ng-class=\"{\'fa fa-spinner fa-spin\' : vm.searching}\"></i> FILTRAR</button><div class=\"input-group col-xs-7 col-sm-8 col-md-9 col-lg-10\"><div class=\"input-group-addon\"><i class=\"fa fa-search\"></i></div><input type=\"search\" ng-enter=\"vm.search()\" class=\"form-control\" placeholder=\"Digite para filtrar os resultados\" ng-model=\"vm.Filter.Nome\" aria-controls=\"DataTables_Table_0\"></div></div><br><div class=\"ibox-content\"><div class=\"table-responsive constrained\" ts-wrapper=\"\" ts-no-data-text=\"Utilize o filtro para filtrar os usuários\"><table class=\"table table-hover table-striped\" data-sorting=\"true\" role=\"grid\" infinite-scroll=\"vm.search(true)\" infinite-scroll-disabled=\"vm.complete || vm.searching\" infinite-scroll-immediate-check=\"false\" infinite-scroll-distance=\"0\"><thead><tr role=\"row\"><th ts-criteria=\"Estabelecimento|lowercase\">Estabelecimento</th><th ts-criteria=\"Atracao\">Atração</th><th ts-criteria=\"TipoArquivo\">Prioridade</th><th class=\"text-right\">Ações</th></tr></thead><tbody><tr ng-repeat=\"item in vm.items\" ng-class=\"{\'success\' : itm.updated}\" ts-repeat=\"\"><td class=\"project-title\"><span ng-style=\"{\'text-decoration\':((item.Status != 1) ? \'line-through\' : \'\')}\">{{item.Estabelecimento}}</span></td><td class=\"project-title\"><span ng-style=\"{\'text-decoration\':((item.Status != 1) ? \'line-through\' : \'\')}\">{{item.Atracao}}</span></td><td class=\"project-title\"><span>{{item.Prioridade}}</span></td><td class=\"project-actions\"><span uib-dropdown=\"\" on-toggle=\"toggled(open)\"><a role=\"button\" uib-dropdown-toggle=\"\"><i class=\"fa fa-wrench\"></i></a><ul class=\"pull-right\" uib-dropdown-menu=\"\" aria-labelledby=\"simple-dropdown\"><li><a role=\"button\" ng-click=\"vm.editarBanner(item);\"><i class=\"fa fa-edit\"></i> Editar</a> <a role=\"button\" ng-click=\"vm.customToggle(item);\"><i class=\"fa fa-trash\"></i> {{(item.Status == 1)?\'Desabilitar atração\' : \'Habilitar atração\'}}</a></li></ul></span></td></tr></tbody></table></div></div></div></div></div></div>");
$templateCache.put("view/conteudo/banner/index.html","<div ui-view=\"\"></div>");
$templateCache.put("view/conteudo/genero/form.html","<div class=\"wrapper wrapper-content animated fadeInDown\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><form name=\"frm\"><div class=\"row\"><div class=\"col-xs-12 col-md-6\"><ng-field name=\"Nome\" label=\"Nome do gênero\" model=\"vm.item.Genero.Nome\" type=\"text\" required=\"true\" maxlength=\"50\"></ng-field></div><div class=\"col-xs-12 col-md-6\"><ng-field name=\"TipoAtracao\" required=\"true\" label=\"Tipo Atração\" ng-disabled=\"vm.editing\" model=\"vm.item.GeneroTipoAtracao.IdTipoAtracao\" type=\"select\" options=\"vm.listaTipoAtracao\" value-field=\"Id\" text-field=\"Nome\"></ng-field></div></div></form><div class=\"row\"><div class=\"form-group\"><div class=\"col-md-1 col-md-offset-10\"><button class=\"btn btn-outline pull-right\" type=\"button\" ng-click=\"vm.cancel();\">CANCELAR</button></div><div class=\"col-md-1\"><button class=\"btn btn-primary pull-right\" type=\"button\" ng-click=\"vm.save();\">SALVAR</button></div></div></div></div></div></div>");
$templateCache.put("view/conteudo/genero/grid.html","<div class=\"wrapper wrapper-content animated fadeInDown\"><div class=\"row\"><div class=\"col-lg-12\"><button ng-click=\"vm.add()\" type=\"button\" class=\"btn btn-w-m btn-success m-b-md pull-right\">ADICIONAR GÊNERO</button><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><button type=\"button\" class=\"btn btn-w-m btn-success pull-right col-offset-m1\" ng-click=\"vm.search()\">FILTRAR</button><div class=\"input-group col-xs-7 col-sm-8 col-md-9 col-lg-10\"><div class=\"input-group-addon\"><i class=\"fa fa-search\"></i></div><input type=\"search\" ng-model=\"vm.Filter.Nome\" class=\"form-control\" placeholder=\"Digite para filtrar os resultados\" aria-controls=\"DataTables_Table_0\"></div></div><br><div class=\"ibox-content\"><table class=\"table table-striped table-hover\" role=\"grid\"><thead><tr role=\"row\"><th>Nome</th><th>Ações</th></tr></thead><tbody><tr class=\"gradeA odd\" role=\"row\" ng-repeat=\"item in vm.items\"><td class=\"project-title\"><span>{{item.Nome}}</span></td><td class=\"project-actions\"><span uib-dropdown=\"\" on-toggle=\"toggled(open)\"><a role=\"button\" uib-dropdown-toggle=\"\"><i class=\"fa fa-wrench\"></i></a><ul class=\"pull-right\" uib-dropdown-menu=\"\" aria-labelledby=\"simple-dropdown\"><li><a role=\"button\" ng-click=\"vm.edit(item);\"><i class=\"fa fa-edit\"></i> Editar</a> <a role=\"button\" ng-click=\"vm.del(item);\"><i class=\"fa fa-trash\"></i> Excluir</a></li></ul></span></td></tr></tbody></table></div></div></div></div></div>");
$templateCache.put("view/conteudo/genero/index.html","<div ui-view=\"\"></div>");
$templateCache.put("view/conteudo/programacao/form.html","<div class=\"wrapper wrapper-content animated fadeInDown\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><form name=\"frm\"><div class=\"row\"><div class=\"col-xs-12 col-md-6\"><ng-field name=\"Nome\" label=\"Nome da inadequação\" model=\"vm.item.Nome\" type=\"text\" required=\"true\" maxlength=\"70\"></ng-field></div></div></form><div class=\"row\"><div class=\"form-group\"><div class=\"col-md-1 col-md-offset-10\"><button class=\"btn btn-outline pull-right\" type=\"button\" ng-click=\"vm.cancel();\">CANCELAR</button></div><div class=\"col-md-1\"><button class=\"btn btn-primary pull-right\" type=\"button\" ng-click=\"vm.save();\">SALVAR</button></div></div></div></div></div></div>");
$templateCache.put("view/conteudo/programacao/grid.html","<style>\n  .btn-success-custom {\n    background-color: #27AE60;\n    border-color: #27AE60;\n    color: #FFFFFF;\n  }\n\n  .btn-success-custom:hover {\n    color: #fff;\n    background-color: #29a05d;\n    border-color: #29a05d;\n  }\n\n  .btn-success-custom:focus\n  {\n    color: #fff;\n    background-color: #29a05d;\n    border-color: #29a05d;\n  }\n\n  .btn-success-custom:visited\n  {\n    color: #fff;\n    background-color: #29a05d;\n    border-color: #29a05d;\n  }\n\n  .btn-success-custom:active{\n    color: #fff;\n    background-color: #29a05d;\n    border-color: #29a05d;\n  }\n\n\n  .filtro{\n    padding-right: 8px;\n    vertical-align:36%;\n  }\n\n  .icone{\n    padding: 5px\n  }\n\n</style><div class=\"wrapper wrapper-content animated fadeInRight\"><div class=\"row\"><div class=\"col-lg-12\"><form name=\"frm\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-md-6\"><ng-field ng-enter=\"vm.search()\" name=\"Nome\" label=\"Estabelecimento\" model=\"vm.Filter.IdEstabelecimento\" type=\"select\" options=\"vm.estabelecimentos\" value-field=\"Id\"></ng-field></div><div class=\"col-md-6\"><ng-field ng-enter=\"vm.search()\" ng-disabled=\"!vm.atracoes\" name=\"Nome\" label=\"Atração\" model=\"vm.Filter.IdAtracao\" type=\"select\" options=\"vm.atracoes\" value-field=\"IdAtracao\"></ng-field></div></div><div class=\"row\"><div class=\"col-md-6\"><h3>Escolha o período desejado</h3><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-6\"><ng-field name=\"DataPeriodoInicio\" ng-enter=\"vm.search()\" label=\"\" model=\"vm.Filter.DataPeriodoInicio\" type=\"date\"></ng-field></div><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-6\"><ng-field name=\"DataPeriodoFim\" ng-enter=\"vm.search()\" label=\"\" model=\"vm.Filter.DataPeriodoFim\" type=\"date\"></ng-field></div></div><div class=\"col-md-4\"><div class=\"m-t-xl\"><input ng-change=\"vm.changeNaoLiberada()\" icheck=\"\" type=\"checkbox\" ng-model=\"vm.Filter.VendaLiberada\" style=\"text-align: right;margin: 80px\"> <strong class=\"m-l-sm\">NÃO LIBERADAS</strong> &nbsp; <input ng-change=\"vm.changeNaoLiberada()\" icheck=\"\" type=\"checkbox\" ng-model=\"vm.Filter.Encerrada\" style=\"text-align: right;margin: 80px\"> <strong class=\"m-l-sm\">ENCERRADAS</strong></div></div><div class=\"col-md-2\"><div class=\"m-t-xl\"><button type=\"button\" class=\"btn btn-w-m btn-success pull-right col-offset-m1\" ng-click=\"vm.search()\" ng-disabled=\"vm.searching || vm.loadBordero\"><i class=\"fa\" ng-class=\"{\'fa fa-spinner fa-pulse\' : vm.searching}\"></i> FILTRAR</button></div></div></div><div class=\"row\"></div></div><br><div class=\"ibox-content\"><div class=\"table-responsive constrained\" ts-wrapper=\"\" ts-no-data-text=\"Utilize o filtro para buscar programações\"><table infinite-scroll=\"vm.search(true)\" infinite-scroll-disabled=\"vm.complete || vm.searching\" infinite-scroll-immediate-check=\"false\" infinite-scroll-distance=\"0\" class=\"table table-striped table-hover\" role=\"grid\" data-sorting=\"true\"><thead><tr role=\"row\"><th class=\"sorting\" rowspan=\"1\" colspan=\"1\" style=\"width: 110px;\" ts-criteria=\"DataHoraInicio\" ts-default=\"\">Dia/Mês</th><th class=\"sorting\" rowspan=\"1\" colspan=\"1\" style=\"width: 180px;\" ts-criteria=\"DataHoraInicio\">Horário</th><th class=\"sorting\" rowspan=\"1\" colspan=\"1\" style=\"width: 300px;\" ts-criteria=\"NomeEstabelecimento|lowercase\">Estabelecimento</th><th class=\"sorting\" rowspan=\"1\" colspan=\"1\" style=\"width: 300px;\" ts-criteria=\"NomeAtracao|lowercase\">Atração</th><th class=\"sorting\" rowspan=\"1\" colspan=\"1\" style=\"width: 180px;\" ts-criteria=\"NomeSala|lowercase\">Sala</th><th class=\"sorting\" rowspan=\"1\" colspan=\"1\" style=\"width: 250px;\" ts-criteria=\"VendaLiberada\">Status da Sessão</th><th class=\"sorting\" rowspan=\"1\" colspan=\"1\" style=\"width: 5px;\">Ações</th></tr></thead><tbody><tr class=\"gradeA odd\" ng-repeat=\"itm in vm.items\" ng-class=\"{\'success\' : itm.updated}\" ts-repeat=\"\"><td class=\"project-title\"><span ng-style=\"{\'text-decoration\':((itm.Status != 1) ? \'line-through\' : \'\')}\">{{itm.DataHoraInicio | date : \'dd/MM\'}}{{\' (\' + itm.DiaSemana + \')\'}}</span></td><td class=\"project-title\"><span ng-style=\"{\'text-decoration\':((itm.Status != 1) ? \'line-through\' : \'\')}\">{{itm.DataHoraInicio | date : \'HH:mm\'}}</span></td><td class=\"project-title\"><span ng-style=\"{\'text-decoration\':((itm.Status != 1) ? \'line-through\' : \'\')}\">{{itm.NomeEstabelecimento}}</span></td><td class=\"project-title\"><span ng-style=\"{\'text-decoration\':((itm.Status != 1) ? \'line-through\' : \'\')}\">{{itm.NomeAtracao}}</span></td><td class=\"project-title\"><span ng-style=\"{\'text-decoration\':((itm.Status != 1) ? \'line-through\' : \'\')}\">{{itm.NomeSala}}</span></td><td class=\"project-title\"><span style=\"color:red; font-weight: 600\" ng-if=\"!itm.PossuiBordero && itm.Status == 1 && !itm.VendaLiberada\">Não Liberada</span> <span style=\"color:green; font-weight: 600\" ng-if=\"!itm.PossuiBordero && itm.Status == 1 && itm.VendaLiberada && itm.VendaBilheteria && itm.VendeRemoto\">Liberada Online e Bilheteria</span> <span style=\"color:darkorange; font-weight: 600\" ng-if=\"!itm.PossuiBordero && itm.Status == 1 && itm.VendaLiberada && itm.VendaBilheteria && !itm.VendeRemoto\">Liberada Somente Bilheteria</span> <span style=\"color:#61baf4; font-weight: 600\" ng-if=\"!itm.PossuiBordero && itm.Status == 1 && itm.VendaLiberada && !itm.VendaBilheteria && itm.VendeRemoto\">Liberada Somente Online</span> <span style=\"color:darkgray; font-weight: 600\" ng-if=\"itm.PossuiBordero\">Encerrada</span> <span style=\"color:darkgray; font-weight: 600\" ng-if=\"!itm.PossuiBordero && itm.Status != 1\">Desabilitada</span></td><td class=\"project-actions\"><span uib-dropdown=\"\" on-toggle=\"toggled(open)\" ng-if=\"!itm.searching\" ng-disabled=\"vm.loadBordero\"><a role=\"button\" uib-dropdown-toggle=\"\"><i class=\"fa fa-wrench\"></i></a><ul class=\"pull-right\" uib-dropdown-menu=\"\" aria-labelledby=\"simple-dropdown\"><li><a role=\"button\" ng-click=\"vm.editaringresso(itm);\" ng-if=\"!itm.PossuiBordero\"><i class=\"fa fa-edit\"></i> Editar Ingresso</a> <a role=\"button\" ng-if=\"itm.PossuiBordero\" style=\"color: lightgrey;\"><i class=\"fa fa-edit\" style=\"color: lightgrey;\"></i> Editar Ingresso</a> <a role=\"button\" ng-click=\"vm.resumoProgramacao(itm);\"><i class=\"fa fa-file-text\"></i> Resumo da Programação</a></li></ul></span> <span ng-if=\"itm.searching\"><i class=\"fa\" ng-class=\"{\'fa fa-spinner fa-pulse fa-2x fa-fw\' : itm.searching}\"></i></span></td></tr></tbody></table><div class=\"row\"><div class=\"col-md-6 col-md-offset-5\" ng-show=\"vm.searching\"><i class=\"fa fa-spinner fa-pulse fa-1x fa-fw\"></i> Carregando...</div></div></div></div></div></form></div></div></div>");
$templateCache.put("view/conteudo/programacao/index.html","<div ui-view=\"\"></div>");
$templateCache.put("view/conteudo/programacao/ingresso.html","<style>\n  .uib-tab.ng-scope.ng-isolate-scope.active {\n    color: #000 !important;\n    background-color: #e7eaec !important;\n    text-decoration: none;\n  }\n\n  uib-tab-heading .inline.ng-binding {\n    color: black !important;\n  }\n\n  .nav > li.active {\n    border-left: none;\n    background: none;\n  }\n\n  .panel-body {\n    background-color: #e7eaec;\n  }\n\n  .border {\n    border: 1px solid red;\n    border-radius: 3px !important;\n  }\n\n  .text-muted {\n    color: #333333;\n  }\n\n  .btn-info.disabled {\n    background-color: #ccc;\n  }\n\n  .btn-info.disabled, .btn-info.disabled:hover, .btn-info.disabled:focus, .btn-info.disabled:active, .btn-info.disabled.active, .btn-info[disabled], .btn-info[disabled]:hover, .btn-info[disabled]:focus, .btn-info[disabled]:active, .btn-info.active[disabled], fieldset[disabled] .btn-info, fieldset[disabled] .btn-info:hover, fieldset[disabled] .btn-info:focus, fieldset[disabled] .btn-info:active, fieldset[disabled] .btn-info.active {\n    background-color: #ccc;\n  !important;\n  }\n\n  .addLote {\n    background-color: white !important;\n    boder: none !important;\n  }\n\n  .addLote a:hover {\n    background-color: #a7b1c2 !important;\n    border: solid 1px #ccc;\n  }\n\n  .uib-tab.ng-scope.ng-isolate-scope {\n    background-color: white !important;\n    boder: none !important;\n  }\n\n  .lugaresRestantes {\n    position: absolute;\n    width: 200px;\n    top: 7px;\n    margin-left: 10px;\n  }\n\n</style><div class=\"wrapper wrapper-content animated fadeInDown\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><div class=\"row\" ng-if=\"vm.PossuiLote\"><div class=\"col-md-12\"><div class=\"col-xs-4 col-sm-4 col-md-4\"><ng-field name=\"IdTipoFinalizacao\" model=\"vm.Sessao.IdTipoLote\" label=\"Regra de Finalização de Lote\" ng-disabled=\"vm.Sessao.ExistiuVenda\" type=\"select\" value-field=\"IdTipoFinalizacao\" text-field=\"Nome\" options=\"vm.TipoLotes\" required=\"true\"></ng-field></div><div class=\"col-xs-4 col-sm-4 col-md-4 m-t-xl text-success\" role=\"alert\"><strong>{{ vm.QtdIngressoSetores }} Lugares disponíveis.</strong></div></div></div><div class=\"tabs-container\"><uib-tabset><uib-tab active=\"lote.active\" ng-repeat=\"lote in vm.lotes\" ng-hide=\"lote.deleted\"><uib-tab-heading><span class=\"inline\" ng-if=\"vm.PossuiLote\">Lote {{(lote.IndexLote)}}</span> <span class=\"inline\" ng-if=\"!vm.PossuiLote\" style=\"color:black;\">Ingressos</span> &nbsp;&nbsp;&nbsp;&nbsp; <span class=\"inline\"><a ng-click=\"vm.delLote(lote, $index)\" ng-hide=\"vm.lotes.length == 1 || lote.ExistiuVenda || lote.LoteEncerrado\"><i ng-class=\"{\'fa fa-times-circle\' : !lote.spinDelLote, \'fa fa-spinner fa-pulse\' : lote.spinDelLote }\" style=\"color:#ccc\"></i></a></span></uib-tab-heading><div class=\"panel-body\"><div class=\"alert alert-warning alert-dismissible m-t-md m-b-md\" role=\"alert\" ng-if=\"lote.LoteEncerrado\"><strong>Lote encerrado.</strong></div><div class=\"alert alert-warning alert-dismissible m-t-md m-b-md\" role=\"alert\" ng-if=\"!lote.LoteEncerrado && lote.ExistiuVenda\"><strong>Esse lote já possui venda.</strong></div><div class=\"row\" id=\"PanelConfiguracaoLote\" ng-if=\"vm.PossuiLote\"><div class=\"col-md-12\"><div class=\"panel panel-default\"><div class=\"panel-heading\"><label>Configurações de Lote {{lote.IndexLote}}</label></div><div class=\"panel-body\"><div class=\"col-xs-6 col-sm-6 col-md-6\" ng-if=\"vm.Sessao.IdTipoLote == 1\"><h4>Quantidade de Ingressos</h4><div class=\"input-group col-md-6\"><input ng-blur=\"vm.ValidaLote(lote.QtdIngresso)\" style=\"height:30px\" ng-model=\"lote.QtdIngresso\" ui-hide-group-sep=\"\" ui-number-mask=\"0\" type=\"text\" required=\"\" ng-change=\"vm.calcIngressos(lote.QtdIngresso, \'{{lote.QtdIngresso}}\')\" maxlength=\"{{vm.QtdIngressoSetores.toString().length}}\" max=\"{{vm.QtdIngressoSetores}}\" class=\"form-control\" ng-class=\"{\'border\' : lote.QtdIngresso == null, \'\' : lote.QtdIngresso != null}\"> <span class=\"input-group-addon\"><i class=\"fa fa-question-circle\" aria-hidden=\"true\" popover-placement=\"auto top\" uib-popover=\"Quantidade que será disponibilizada à venda para esse lote\" popover-trigger=\"mouseenter\"></i></span><div class=\"lugaresRestantes\">(Faltam {{vm.lugaresRestantes}} lugares)</div></div></div><div class=\"col-xs-4 col-sm-4 col-md-4\" ng-if=\"vm.Sessao.IdTipoLote == 2\"><h4>Data de encerramento do lote</h4><div class=\"input-group\"><input ng-blur=\"vm.ValidaLote(lote.HoraEncerramentoLote)\" type=\"text\" class=\"form-control\" style=\"height:30px\" ng-model=\"lote.DataEncerramentoLote\" uib-datepicker-popup=\"dd/MM/yyyy\" datepicker-options=\"vm.dateOptions\" is-open=\"pop\" required=\"\" ng-class=\"{\'border\' : lote.DataEncerramentoLote == null, \'\' : lote.DataEncerramentoLote != null}\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-sm btn-primary\" ng-click=\"pop = true\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"col-xs-4 col-sm-4 col-md-4\" ng-if=\"vm.Sessao.IdTipoLote == 2\"><h4>Hora de encerramento do lote</h4><div class=\"input-group col-md-6\"><input ng-blur=\"vm.ValidaLote(lote.HoraEncerramentoLote)\" style=\"height:30px\" ng-model=\"lote.HoraEncerramentoLote\" ui-time-mask=\"short\" type=\"text\" required=\"\" maxlength=\"100\" class=\"form-control\" ng-class=\"{\'border\' : lote.HoraEncerramentoLote == null, \'\' : lote.HoraEncerramentoLote != null}\"> <span class=\"input-group-addon\"><i class=\"fa fa-question-circle\" aria-hidden=\"true\" popover-placement=\"auto top\" uib-popover=\"Hora encerramento\" popover-trigger=\"mouseenter\"></i></span></div></div><div class=\"alert alert-danger alert-dismissible\" role=\"alert\" ng-show=\"lote.DataEncerramentoLote < (moment().add(-1, \'day\'))\"><strong>A data da sessão não pode ser menor que a data atual.</strong></div></div></div></div></div><div ng-if=\"vm.PossuiLote\"><div class=\"alert alert-danger alert-dismissible\" role=\"alert\" ng-if=\"vm.LotesInvalido != null\"><strong>{{vm.LotesInvalido}}</strong></div><div class=\"alert alert-danger alert-dismissible\" role=\"alert\" ng-if=\"vm.QtdIngressosLotesMaior\"><strong>O somatório dos ingressos para os lotes ultrapassa a quantidade permitidade para a SALA.</strong></div></div><div class=\"checkbox\" ng-if=\"vm.setores.length > 1 || lote.setores.length > 1\"><label><input icheck=\"\" type=\"checkbox\" ng-model=\"vm.oneAtATime\"> Abra somente um de cada vez</label></div><div id=\"accordion\" role=\"tablist\" aria-multiselectable=\"false\"><uib-accordion close-others=\"vm.oneAtATime\"><div uib-accordion-group=\"\" class=\"panel-default\" ng-repeat=\"setor in lote.setores track by $index\" is-open=\"vm.accordionArray[$index]\" is-disabled=\"vm.setores.length == 1\"><uib-accordion-heading><div class=\"row\"><div class=\"col-sm-6\"><div><i class=\"pull-left glyphicon\" ng-class=\"vm.accordionArray[$index] ? \'glyphicon-chevron-down\':\'glyphicon-chevron-right\'\" ng-if=\"vm.setores.length > 1\"></i>&nbsp; {{setor.Nome}} {{setor.NomeZona != null ? \"(\" + setor.NomeZona + \")\" : \'\'}}</div></div><div class=\"col-sm-6\"><button type=\"button\" class=\"btn btn-xs btn-w-m btn-success pull-right\" ng-click=\"vm.addTipoIngresso(lote, setor,$event, $index)\">INCLUIR INGRESSO</button></div></div></uib-accordion-heading><div class=\"table-responsive margin-table\"><div class=\"col-xs-12 no-padding\"><div class=\"alert alert-warning alert-dismissible m-t-md m-b-md\" role=\"alert\" ng-if=\"setor.IngNeg\"><strong>O valor dos ingressos devem ser superiores a 0 (Zero).</strong></div><label>Valor Base</label><div class=\"input-group\"><input type=\"text\" maxlength=\"11\" ng-disabled=\"lote.LoteEncerrado || lote.ExistiuVenda\" ui-money-mask=\"\" class=\"form-control no-padding\" ng-model=\"setor.ValorBase\" required=\"\" ng-change=\"vm.ChangeValueIngresso(setor)\" ng-class=\"{\'border\' : setor.ValorBase == null, \'\' : setor.ValorBase != null}\"></div><span class=\"help-block\" ng-show=\"setor.ValorBase == null\" aria-hidden=\"false\">Preenchimento obrigatório</span><br></div><table class=\"table table-striped table-bordered table-hover dataTables-example dataTable\" id=\"DataTables_Table_0\" aria-describedby=\"DataTables_Table_0_info\" role=\"grid\"><thead><tr role=\"row\"><th class=\"sorting\" tabindex=\"0\" aria-controls=\"DataTables_Table_0\" rowspan=\"1\" colspan=\"1\" aria-sort=\"ascending\" aria-label=\"Rendering engine: activate to sort column descending\" style=\"width: 610px;\">Tipo de Ingresso</th><th class=\"sorting\" tabindex=\"0\" aria-controls=\"DataTables_Table_0\" rowspan=\"1\" colspan=\"1\" style=\"width: 170px;\">Local de Venda</th><th class=\"sorting\" tabindex=\"0\" aria-controls=\"DataTables_Table_0\" rowspan=\"1\" colspan=\"1\" style=\"width: 120px;\">Tipo</th><th class=\"sorting\" tabindex=\"0\" aria-controls=\"DataTables_Table_0\" rowspan=\"1\" colspan=\"1\" style=\"width: 150px;\">Valor Regra</th><th class=\"sorting\" tabindex=\"0\" aria-controls=\"DataTables_Table_0\" rowspan=\"1\" colspan=\"1\" style=\"width: 150px;\">Qtd. Máx.</th><th class=\"sorting\" tabindex=\"0\" aria-controls=\"DataTables_Table_0\" rowspan=\"1\" colspan=\"1\" style=\"width: 80px;\">Valor</th></tr></thead><tbody><tr class=\"gradeA odd\" role=\"row\" ng-repeat=\"ti in setor.tipoIngresso | filter: vm.myfilter\" style=\"{{ti.excluido == true ? \'display:none\' : \'\'}}\"><td class=\"sorting_1\">{{ti.Nome}}</td><td>{{ti.VendeRemoto && ti.VendeBilheteria ? \'Todos\' : ti.VendeRemoto ? \'Site\' : ti.VendeBilheteria ? \'Bilheteria\' : \'Nenhum\' }}</td><td class=\"sorting_1\">{{ti.TipoDesconto == \'P\' ? \'Percentual\' : \'Fixo\'}}</td><td class=\"sorting_1\" ng-if=\"ti.TipoDesconto == \'F\'\">{{ti.ValorRegra | currency:\"R$\"}}</td><td class=\"sorting_1\" ng-if=\"ti.TipoDesconto == \'P\'\">{{ti.ValorRegra * 100}} %</td><td class=\"sorting_1\" ng-if=\"!ti.ExibeQtd\">{{ti.QuantidadeIngressos}}</td><td class=\"sorting_1\" ng-if=\"ti.ExibeQtd\"><input type=\"text\" id=\"qtdIngressos\" name=\"qtdIngressos\" ng-model=\"ti.QuantidadeIngressos\" style=\"width:100px;\" ui-hide-group-sep=\"\" ui-number-mask=\"0\" ng-disabled=\"ti.IdSessaoSetorLotePrecoIngresso\"></td><td class=\"center\" ng-if=\"!ti.DefineValorNaSessao\">{{ ti.Valor | currency:\"R$\"}}</td><td class=\"center\" ng-if=\"ti.DefineValorNaSessao\"><input type=\"text\" ng-model=\"ti.Valor\" style=\"width:100px;\" ui-money-mask=\"\" required=\"\" ng-disabled=\"ti.IdSessaoSetorLotePrecoIngresso\"></td><td width=\"30\"><span uib-dropdown=\"\" on-toggle=\"toggled(open)\" ng-if=\"!itm.searching\" ng-disabled=\"vm.loadBordero\"><a role=\"button\" uib-dropdown-toggle=\"\"><i class=\"fa fa-wrench\"></i></a><ul class=\"pull-right\" uib-dropdown-menu=\"\" aria-labelledby=\"simple-dropdown\"><li><a role=\"button\" ng-if=\"!ti.IdSessaoSetorLotePrecoIngresso\" ng-click=\"vm.incluirQuantidade(ti);\"><i class=\"fa fa-trash\"></i> Incluir Qtd Máxima</a> <a role=\"button\" ng-if=\"ti.IdSessaoSetorLotePrecoIngresso\" style=\"color: lightgrey;\" \"=\"\"><i class=\"fa fa-trash\"></i> Incluir Qtd Máxima</a> <a role=\"button\" ng-if=\"ti.ExibeQtd\" ng-click=\"vm.excluirQuantidade(ti);\"><i class=\"fa fa-trash\"></i> Cancelar Qtd Máxima</a> <a role=\"button\" ng-click=\"vm.delIngresso(ti,setor);\"><i class=\"fa fa-trash\"></i> Excluir</a></li></ul></span></td></tr></tbody></table></div></div></uib-accordion></div></div></uib-tab><uib-tab index=\"NewTab\" ng-click=\"vm.addLote(true,false)\" class=\"addLote\" ng-if=\"vm.PossuiLote && vm.lugaresRestantes > 0\"><uib-tab-heading><div class=\"row\"><div class=\"col-md-4\"><a><i class=\"fa fa-plus-circle\"></i></a></div></div></uib-tab-heading></uib-tab></uib-tabset></div><div class=\"row\"><div class=\"form-group\"><div class=\"col-md-1 col-md-offset-10\"><button class=\"btn btn-outline pull-right\" type=\"button\" ng-click=\"vm.cancel();\">CANCELAR</button></div><div class=\"col-md-1\"><button class=\"btn btn-primary pull-right\" type=\"button\" ng-click=\"vm.save();\">SALVAR</button></div></div></div></div></div></div>");
$templateCache.put("view/conteudo/programacao/mapa-assento.html","<div class=\"coluna m-baixo-80\"><div id=\"escolhe-lugar\"><h2 class=\"titulo-wiz\"><span class=\"titulo-bg-circular\">{{vm.etiquetas.Lugar}}</span> Escolha os assentos</h2><div class=\"linha m-top-24\" ng-show=\"vm.controle.LoadingSVG\"><div class=\"coluna\"><i class=\"fa fa-cog fa-spin fa-3x fa-fw\" style=\"color: #F17709;\"></i></div></div><div class=\"linha\" ng-hide=\"vm.controle.LoadingSVG\"><div class=\"coluna m-baixo-8 mapa-assentos\"><div class=\"m-baixo-16 notificacao alerta\" ng-if=\"vm.Limite\"><h5><i class=\"fa fa-exclamation-circle alinhar-e\" aria-hidden=\"true\"></i> Você só pode comprar até 6 ingressos por sessão.</h5></div><div ng-if=\"!vm.Limite\"><p>&nbsp</p></div><ng-svg content=\"vm.mapaSvg\" loaded=\"vm.svgloaded\"></ng-svg></div></div></div><div class=\"linha fixed-footer\"><div class=\"separador\"></div><div class=\"coluna-m-25 alinhar-c notificacao alerta m-baixo-8\" style=\"line-height: 40px\" ng-show=\"vm.clickCount > 0\"><i class=\"fa fa-spinner fa-pulse fa-fw\" aria-hidden=\"true\"></i> Processando escolha</div><div class=\"coluna-m-50 offset-m-25 btn-step\" ng-show=\"vm.controle.LugarMarcado\"><a class=\"btn btn-laranja btn-redondo\" ui-sref=\"checkout.steps.ingresso-lugar-marcado\" ng-class=\"{\'desabilitado\' : !vm.HabilitaIngresso || vm.clickCount > 0 }\">Escolha os tipos de ingresso &nbsp; <i class=\"fa fa-sort-desc\" aria-hidden=\"true\" style=\"vertical-align:text-top;\"></i></a></div><div class=\"coluna-m-50 offset-m-25 btn-step\" ng-hide=\"vm.controle.LugarMarcado\"><a class=\"btn btn-laranja btn-redondo\" ui-sref=\"checkout.steps.ingresso-lugar-livre\" ng-class=\"{\'desabilitado\' : !vm.HabilitaIngresso || vm.clickCount > 0 }\">Escolher os ingressos e a quantidade &nbsp; <i class=\"fa fa-sort-desc\" aria-hidden=\"true\" style=\"vertical-align:text-top;\"></i></a></div></div></div>");
$templateCache.put("view/conteudo/inadequacao/form.html","<div class=\"wrapper wrapper-content animated fadeInDown\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><form name=\"frm\"><div class=\"row\"><div class=\"col-xs-12 col-md-6\"><ng-field name=\"Nome\" label=\"Nome da inadequação\" model=\"vm.item.Nome\" type=\"text\" required=\"true\" maxlength=\"70\"></ng-field></div></div></form><div class=\"row\"><div class=\"form-group\"><div class=\"col-md-1 col-md-offset-10\"><button class=\"btn btn-outline pull-right\" type=\"button\" ng-click=\"vm.cancel();\">CANCELAR</button></div><div class=\"col-md-1\"><button class=\"btn btn-primary pull-right\" type=\"button\" ng-click=\"vm.save();\">SALVAR</button></div></div></div></div></div></div>");
$templateCache.put("view/conteudo/inadequacao/grid.html","<div class=\"wrapper wrapper-content animated fadeInDown\"><div class=\"row\"><div class=\"col-lg-12\"><button ng-click=\"vm.add()\" type=\"button\" class=\"btn btn-w-m btn-success m-b-md pull-right\">ADICIONAR INADEQUAÇÃO</button><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><button type=\"button\" class=\"btn btn-w-m btn-success pull-right col-offset-m1\" ng-click=\"vm.search()\">FILTRAR</button><div class=\"input-group col-xs-7 col-sm-8 col-md-9 col-lg-10\"><div class=\"input-group-addon\"><i class=\"fa fa-search\"></i></div><input type=\"search\" ng-model=\"vm.Filter.Nome\" class=\"form-control\" placeholder=\"Digite para filtrar os resultados\" aria-controls=\"DataTables_Table_0\"></div></div><br><div class=\"ibox-content\"><table class=\"table table-striped table-hover\" role=\"grid\"><thead><tr role=\"row\"><th>Nome</th><th>Ações</th></tr></thead><tbody><tr class=\"gradeA odd\" role=\"row\" ng-repeat=\"item in vm.items\"><td class=\"project-title\"><span>{{item.Nome}}</span></td><td class=\"project-actions\"><span uib-dropdown=\"\" on-toggle=\"toggled(open)\"><a role=\"button\" uib-dropdown-toggle=\"\"><i class=\"fa fa-wrench\"></i></a><ul class=\"pull-right\" uib-dropdown-menu=\"\" aria-labelledby=\"simple-dropdown\"><li><a role=\"button\" ng-click=\"vm.edit(item);\"><i class=\"fa fa-edit\"></i> Editar</a> <a role=\"button\" ng-click=\"vm.del(item);\"><i class=\"fa fa-trash\"></i> Excluir</a></li></ul></span></td></tr></tbody></table></div></div></div></div></div>");
$templateCache.put("view/conteudo/inadequacao/index.html","<div ui-view=\"\"></div>");
$templateCache.put("view/conteudo/video/form.html","<div class=\"wrapper wrapper-content animated fadeInDown\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><div class=\"container-fluid\"><form name=\"midiaForm\"><div class=\"row\"><div class=\"col-xs-4 col-sm-4 col-md-4 col-lg-4\"><ng-field name=\"\" label=\"Nome\" model=\"vm.Nome\" type=\"text\" required=\"true\"></ng-field></div><div class=\"col-xs-4 col-sm-4 col-md-4 col-lg-4\"><ng-field label=\"Atracao\" type=\"select\" model=\"vm.IdAtracao\" options=\"vm.atracaoList\" value-field=\"IdAtracao\" text-field=\"Nome\"></ng-field></div><div class=\"col-xs-4 col-sm-4 col-md-4 col-lg-4\"><ng-field name=\"\" label=\"IdVideo\" model=\"vm.IdYouTube\" type=\"text\" required=\"true\"></ng-field></div></div><div class=\"row\"><div class=\"col-sm-12 col-md-12 col-lg-9\"><div class=\"banner\"><h4>Imagem visão desktop</h4><div ng-disabled=\"vm.loading\" ngf-drop=\"\" ngf-select=\"\" ng-model=\"vm.FileDesktop\" ngf-drag-over-class=\"dragover\" ngf-multiple=\"true\" ngf-allow-dir=\"true\" accept=\"image/*\" layout-align=\"center center\" class=\"layout-align-center-center layout-column alinhar-centro banner\" ng-class=\"{\'img-ok\' : vm.imagem.Desktop != null, \'img-vazio\' : vm.imagem.Desktop == null}\"><div ng-if=\"!vm.imagem.Desktop\"><button class=\"btn btn-success btn-circle btn-lg btn-crop-center\" ng-disabled=\"vm.loading\"><i ng-class=\"{\'fa fa-cloud-upload idle\' : !vm.spinFotoDesktop, \'fa fa-spinner fa-pulse\': vm.spinFotoDesktop}\"></i></button><h3>Clique ou arraste a foto para fazer upload</h3><div ngf-no-file-drop=\"\">Arrastar não suportado pelo browser</div></div><div ng-if=\"vm.imagem.Desktop\"><img ng-src=\"{{vm.imagem.Desktop}}\"></div></div><div class=\"list-group list-group-horizontal pull-right\"><button ng-disabled=\"vm.loading\" class=\"btn btn-link btn-lg\" ngf-select=\"vm.uploadDesktop($files)\" accept=\"image/*\"><i class=\"fa fa-pencil\"></i></button> <a class=\"btn btn-link btn-lg\" style=\"margin: 0; padding: 8px 0;\"><span class=\"btn btn-link\" popover-placement=\"auto top\" uib-popover=\"Foto que será exibida na home do site na visualização desktop\" popover-trigger=\"mouseenter\"><i class=\"fa fa-question-circle\" style=\"font-size:1.3em;\"></i></span></a></div></div></div><div class=\"col-sm-12 col-md-12 col-lg-3\"><div class=\"capa\"><h4>Imagem visão celular.</h4><div ng-disabled=\"vm.loading\" ngf-drop=\"\" ngf-select=\"\" ng-model=\"vm.FilePhone\" ngf-drag-over-class=\"dragover\" ngf-multiple=\"true\" ngf-allow-dir=\"true\" accept=\"image/*\" layout-align=\"center center\" class=\"layout-align-center-center layout-column capa alinhar-centro\" ng-class=\"{\'img-ok\' : vm.imagem.Phone != null, \'img-vazio\' : vm.imagem.Phone == null}\"><div ng-if=\"!vm.imagem.Phone\"><button class=\"btn btn-success btn-circle btn-lg btn-crop-center\" ng-disabled=\"vm.loading\"><i ng-class=\"{\'fa fa-cloud-upload idle\' : !vm.spinFotoPhone, \'fa fa-spinner fa-pulse\': vm.spinFotoPhone}\"></i></button><h3>Clique ou arraste a foto para fazer upload</h3></div><div ng-if=\"vm.imagem.Phone\"><img ng-src=\"{{vm.imagem.Phone}}\"></div></div><div class=\"list-group list-group-horizontal pull-right\"><button ng-disabled=\"vm.loading\" class=\"btn btn-link btn-lg\" ngf-select=\"vm.uploadPhone($files)\" accept=\"image/*\"><i class=\"fa fa-pencil\"></i></button> <a class=\"btn btn-link btn-lg\" style=\"margin: 0; padding: 8px 0;\"><span class=\"btn btn-link\" popover-placement=\"auto top\" uib-popover=\"Foto que será exibida na home do site na visualização celular.\" popover-trigger=\"mouseenter\"><i class=\"fa fa-question-circle\" style=\"font-size:1.3em;\"></i></span></a></div></div></div></div><div class=\"hr-line-dashed\"></div></form><div class=\"row m-t-md\"><div class=\"col-md-12\"><div class=\"row pull-right\"><div class=\"inline m-r-md\"><a ui-sref=\"conteudo.video.grid\" class=\"btn btn-default pull-right offset3\">CANCELAR</a></div><div class=\"inline\"><button type=\"button\" ng-click=\"vm.Save()\" class=\"btn btn-success pull-right\" ng-disabled=\"!vm.imagem.Desktop || !vm.imagem.Phone || !vm.IdYouTube || vm.loading || vm.videoProgress != null\"><i class=\"fa\" ng-class=\"{\'fa fa-spinner fa-spin\' : vm.loading}\"></i> SALVAR</button></div></div></div></div></div></div></div></div>");
$templateCache.put("view/conteudo/video/grid.html","<div class=\"wrapper wrapper-content animated fadeInDown\"><div class=\"row\"><div class=\"col-lg-12\"><button ng-click=\"vm.add()\" type=\"button\" class=\"btn btn-w-m btn-success m-b-md pull-right\">ADICIONAR VÍDEO</button><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><button type=\"button\" class=\"btn btn-w-m btn-success pull-right col-offset-m1\" ng-click=\"vm.search()\" ng-disabled=\"vm.searching\"><i class=\"fa\" ng-class=\"{\'fa fa-spinner fa-spin\' : vm.searching}\"></i> FILTRAR</button><div class=\"input-group col-xs-7 col-sm-8 col-md-9 col-lg-10\"><div class=\"input-group-addon\"><i class=\"fa fa-search\"></i></div><input type=\"search\" ng-enter=\"vm.search()\" class=\"form-control\" placeholder=\"Digite para filtrar os resultados\" ng-model=\"vm.Filter.Nome\" aria-controls=\"DataTables_Table_0\"></div></div><br><div class=\"ibox-content\"><div class=\"table-responsive constrained\" ts-wrapper=\"\" ts-no-data-text=\"Utilize o filtro para filtrar os usuários\"><table class=\"table table-hover table-striped\" data-sorting=\"true\" role=\"grid\" infinite-scroll=\"vm.search(true)\" infinite-scroll-disabled=\"vm.complete || vm.searching\" infinite-scroll-immediate-check=\"false\" infinite-scroll-distance=\"0\"><thead><tr role=\"row\"><th ts-criteria=\"Nome\">Nome</th><th ts-criteria=\"Estabelecimento|lowercase\">IdYouTube</th><th ts-criteria=\"Atracao\">Atração</th><th class=\"text-right\">Ações</th></tr></thead><tbody><tr ng-repeat=\"item in vm.items\" ng-class=\"{\'success\' : itm.updated}\" ts-repeat=\"\"><td class=\"project-title\"><span ng-style=\"{\'text-decoration\':((item.Status != 1) ? \'line-through\' : \'\')}\">{{item.Nome}}</span></td><td class=\"project-title\"><span ng-style=\"{\'text-decoration\':((item.Status != 1) ? \'line-through\' : \'\')}\">{{item.IdYouTube}}</span></td><td class=\"project-title\"><span ng-style=\"{\'text-decoration\':((item.Status != 1) ? \'line-through\' : \'\')}\">{{item.Atracao}}</span></td><td class=\"project-actions\"><span uib-dropdown=\"\" on-toggle=\"toggled(open)\"><a role=\"button\" uib-dropdown-toggle=\"\"><i class=\"fa fa-wrench\"></i></a><ul class=\"pull-right\" uib-dropdown-menu=\"\" aria-labelledby=\"simple-dropdown\"><li><a role=\"button\" ng-click=\"vm.editarVideo(item);\"><i class=\"fa fa-edit\"></i> Editar</a> <a role=\"button\" ng-click=\"vm.customToggle(item);\"><i class=\"fa fa-trash\"></i> {{(item.Status == 1)?\'Desabilitar vídeo\' : \'Habilitar vídeo\'}}</a></li></ul></span></td></tr></tbody></table></div></div></div></div></div></div>");
$templateCache.put("view/conteudo/video/index.html","<div ui-view=\"\"></div>");
$templateCache.put("view/controleingresso/regraIngressoEstabelecimento/form.html","<div class=\"wrapper wrapper-content animated fadeInDown\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><form name=\"frm\"><div class=\"row\"><div class=\"col-xs-11 col-md-10\"><font size=\"4\">Estabelecimento</font>:<font size=\"3\"><b>{{vm.estabelecimento.Nome}}</b></font><br><br><br></div></div><div class=\"row\"><div class=\"col-xs-12 col-md-6\"><div style=\"height:360px; overflow-y: scroll;\" class=\"table-responsive constrained\"><table class=\"table table-hover table-striped\"><thead><tr><th>Regra</th><th>Tipo Documento</th><th>Tipo de desconto</th><th></th></tr></thead><tbody><tr required=\"true\" ng-repeat=\"item in vm.regrasFiltradasList\"><td>{{item.Nome}}</td><td ng-if=\"item.ValidaDocumento == true\">SIM</td><td ng-if=\"item.ValidaDocumento == false\">NÃO</td><td>{{item.TipoDesconto}}</td><td style=\"text-align: center;\"><input type=\"checkbox\" icheck=\"\" ng-model=\"item.Checked\" name=\"{{item.IdRegraIngresso}}\" ng-value=\"true\" ng-change=\"vm.check()\"></td></tr></tbody></table><div class=\"alert alert-danger alert-dismissible\" role=\"alert\" ng-show=\"vm.LugarNaoMarcado\"><strong>Escolha pelo menos um Tipo de Artista.</strong></div></div></div></div></form><div class=\"row\"><div class=\"form-group\"><div class=\"col-md-1 col-md-offset-10\"><button class=\"btn btn-outline pull-right\" type=\"button\" ng-click=\"vm.cancel();\">CANCELAR</button></div><div class=\"col-md-1\"><button class=\"btn btn-primary pull-right\" ng-disabled=\"validateForm\" type=\"button\" ng-click=\"vm.save();\">SALVAR</button></div></div></div></div></div></div>");
$templateCache.put("view/controleingresso/regraIngressoEstabelecimento/grid.html","<div class=\"wrapper wrapper-content animated fadeInDown\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><button type=\"button\" class=\"btn btn-w-m btn-success pull-right col-offset-m1\" ng-click=\"vm.search()\">FILTRAR</button><div class=\"input-group col-xs-7 col-sm-8 col-md-9 col-lg-10\"><div class=\"input-group-addon\"><i class=\"fa fa-search\"></i></div><input type=\"search\" ng-model=\"vm.Filter.Nome\" class=\"form-control\" placeholder=\"Digite para filtrar os resultados\" aria-controls=\"DataTables_Table_0\"></div></div><br><div class=\"ibox-content\"><table class=\"table table-striped table-hover\" role=\"grid\"><thead><tr role=\"row\"><th>Nome</th><th></th></tr></thead><tbody><tr class=\"gradeA odd\" role=\"row\" ng-repeat=\"item in vm.items\"><td class=\"project-title\"><span>{{item.Nome}}</span></td><td class=\"project-actions\"><span uib-dropdown=\"\" on-toggle=\"toggled(open)\"><a role=\"button\" uib-dropdown-toggle=\"\"><i class=\"fa fa-wrench\"></i></a><ul class=\"pull-right\" uib-dropdown-menu=\"\" aria-labelledby=\"simple-dropdown\"><li><a role=\"button\" ng-click=\"vm.edit(item);\"><i class=\"fa fa-edit\"></i> Editar</a></li></ul></span></td></tr></tbody></table></div></div></div></div></div>");
$templateCache.put("view/controleingresso/regraIngressoEstabelecimento/index.html","<div ui-view=\"\"></div>");
$templateCache.put("view/estabelecimento/controleformapagamento/form.html","<style>\n  .checkbox {\n    padding-left: 20px; }\n  .checkbox label {\n    display: inline-block;\n    position: relative;\n    padding-left: 5px; }\n  .checkbox label::before {\n    content: \"\";\n    display: inline-block;\n    position: absolute;\n    width: 17px;\n    height: 17px;\n    left: 0;\n    margin-left: -20px;\n    border: 1px solid #cccccc;\n    border-radius: 0px;\n    background-color: #fff;\n    -webkit-transition: border 0.15s ease-in-out, color 0.15s ease-in-out;\n    -o-transition: border 0.15s ease-in-out, color 0.15s ease-in-out;\n    transition: border 0.15s ease-in-out, color 0.15s ease-in-out; }\n  .checkbox label::after {\n    display: inline-block;\n    position: absolute;\n    width: 16px;\n    height: 16px;\n    left: 0;\n    top: 0;\n    margin-left: -20px;\n    padding-left: 3px;\n    padding-top: 1px;\n    font-size: 11px;\n    color: #555555; }\n  .checkbox input[type=\"checkbox\"] {\n    opacity: 0; }\n  .checkbox input[type=\"checkbox\"]:focus + label::before {\n    outline: thin dotted;\n    outline: 5px auto -webkit-focus-ring-color;\n    outline-offset: -2px; }\n  .checkbox input[type=\"checkbox\"]:checked + label::after {\n    font-family: \'FontAwesome\';\n    content: \"\\f00c\"; }\n  .checkbox input[type=\"checkbox\"]:disabled + label {\n    opacity: 0.65; }\n  .checkbox input[type=\"checkbox\"]:disabled + label::before {\n    background-color: #eeeeee;\n    cursor: not-allowed; }\n  .checkbox.checkbox-circle label::before {\n    border-radius: 50%; }\n  .checkbox.checkbox-inline {\n    margin-top: 0; }\n</style><div class=\"wrapper wrapper-content animated fadeInDown\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><form name=\"frm\"><div class=\"row\"><div class=\"col-xs-11 col-md-10\"><font size=\"4\">Estabelecimento</font>:<font size=\"3\"><b>{{vm.estabelecimento.Nome}}</b></font><br><br><br></div></div><div class=\"row\"><div class=\"col-xs-12 col-md-8\"><div style=\"height:360px; overflow-y: scroll;\" class=\"table-responsive constrained\"><table class=\"table table-hover table-striped\"><thead><tr><th>Nome</th><th>Tipo Forma Pagamento</th><th>Aceita Cancelamento</th><th>Associar</th></tr></thead><tbody><tr required=\"true\" ng-repeat=\"item in vm.listFormaPagamento\"><td>{{item.Nome}}</td><td>{{item.NomeTipoFormaPagamento}}</td><td><div class=\"checkbox checkbox-inline\"><input type=\"checkbox\" id=\"{{item.IdFormaPagamento}}\" ng-model=\"item.AceitaCancelamento\" ng-value=\"true\" ng-disabled=\"!item.Checked\" ng-change=\"vm.checkUpdate()\"> <label for=\"{{item.IdFormaPagamento}}\"></label></div></td><td style=\"text-align: center;\"><input type=\"checkbox\" icheck=\"\" ng-model=\"item.Checked\" ng-value=\"true\" ng-change=\"vm.check()\"></td></tr></tbody></table></div><br><br><div class=\"alert alert-danger alert-dismissible\" role=\"alert\" ng-show=\"vm.LugarNaoMarcado\"><strong>Escolha pelo menos uma forma de pagamento.</strong></div></div></div></form><div class=\"row\"><div class=\"form-group\"><div class=\"col-md-1 col-md-offset-10\"><button class=\"btn btn-outline pull-right\" type=\"button\" ng-click=\"vm.cancel();\">CANCELAR</button></div><div class=\"col-md-1\"><button class=\"btn btn-primary pull-right\" ng-disabled=\"validateForm\" type=\"button\" ng-click=\"vm.save();\">SALVAR</button></div></div></div></div></div></div>");
$templateCache.put("view/estabelecimento/controleformapagamento/grid.html","<div class=\"wrapper wrapper-content animated fadeInDown\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><button type=\"button\" class=\"btn btn-w-m btn-success pull-right col-offset-m1\" ng-click=\"vm.search()\" ng-disabled=\"vm.searching\"><i class=\"fa\" ng-class=\"{\'fa fa-spinner fa-spin\' : vm.searching}\"></i> FILTRAR</button><div class=\"input-group col-xs-7 col-sm-8 col-md-9 col-lg-10\"><div class=\"input-group-addon\"><i class=\"fa fa-search\"></i></div><input type=\"search\" ng-enter=\"vm.search()\" class=\"form-control\" placeholder=\"Digite para filtrar os resultados\" ng-model=\"vm.Filter.Nome\" aria-controls=\"DataTables_Table_0\"></div></div><br><div class=\"ibox-content\"><div class=\"table-responsive constrained\" ts-wrapper=\"\" ts-no-data-text=\"Utilize o filtro para filtrar os usuários\"><table class=\"table table-hover table-striped\" data-sorting=\"true\" role=\"grid\" infinite-scroll=\"vm.search(true)\" infinite-scroll-disabled=\"vm.complete || vm.searching\" infinite-scroll-immediate-check=\"false\" infinite-scroll-distance=\"0\"><thead><tr><th ts-criteria=\"Nome|lowercase\">Nome</th><th class=\"text-right\">Ações</th></tr></thead><tbody><tr ng-repeat=\"item in vm.items\" ng-class=\"{\'success\' : itm.updated}\" ts-repeat=\"\"><td class=\"project-title\"><span>{{item.Nome}}</span></td><td class=\"project-actions\"><span uib-dropdown=\"\" on-toggle=\"toggled(open)\"><a role=\"button\" uib-dropdown-toggle=\"\"><i class=\"fa fa-wrench\"></i></a><ul class=\"pull-right\" uib-dropdown-menu=\"\" aria-labelledby=\"simple-dropdown\"><li><a role=\"button\" ng-click=\"vm.edit(item);\"><i class=\"fa fa-edit\"></i> Editar</a></li></ul></span></td></tr></tbody></table><div class=\"row\"><div class=\"col-md-6 col-md-offset-5\" ng-show=\"vm.searching\"><i class=\"fa fa-spinner fa-pulse fa-1x fa-fw\"></i> Carregando...</div></div></div></div></div></div></div></div>");
$templateCache.put("view/estabelecimento/controleformapagamento/index.html","<div ui-view=\"\"></div>");
$templateCache.put("view/estabelecimento/convenienciaestabelecimento/form.html","<div class=\"wrapper wrapper-content animated fadeInDown\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><form name=\"frm\"><div class=\"row\"><div class=\"col-lg-6\"><ng-field required=\"true\" label=\"Regra da Conveniência\" type=\"select\" model=\"vm.CodRegraConveniencia\" options=\"vm.regrasConveniencia\" value-field=\"Cod\" text-field=\"Nome\"></ng-field></div></div><div ng-show=\"vm.CodRegraConveniencia && vm.CodRegraConveniencia != \'P\'\" class=\"row\"><div class=\"hr-line-dashed\"></div><div class=\"col-lg-6\" ng-if=\"vm.CodRegraConveniencia != \'P\'\"><ng-field label=\"Estabelecimento\" type=\"select\" required=\"true\" model=\"vm.item.Estabelecimento.IdEstabelecimento\" options=\"vm.estabelecimentos\" value-field=\"Id\" text-field=\"Nome\"></ng-field></div></div><div ng-show=\"vm.CodRegraConveniencia && vm.CodRegraConveniencia != \'P\'\" class=\"row\"><div ng-if=\"vm.CodRegraConveniencia == \'TA\' && vm.item.Estabelecimento.IdEstabelecimento\" class=\"col-lg-6\"><ng-field label=\"Tipo Atração\" type=\"select\" ng-hide=\"vm.ListaTipoAtracaoVazia\" model=\"vm.item.TipoAtracao.IdTipoAtracao\" required=\"true\" options=\"vm.tipoAtracoes\" value-field=\"Id\" text-field=\"Nome\"></ng-field><h4 ng-show=\"vm.ListaTipoAtracaoVazia\"><strong style=\"color: red; line-height: 80px\">Não existem Tipo de Atrações para este estabelecimento</strong></h4></div><div ng-if=\"vm.CodRegraConveniencia == \'TS\' && vm.item.Estabelecimento.IdEstabelecimento\" class=\"col-lg-6\"><ng-field label=\"Tipo Sessão\" type=\"select\" ng-hide=\"vm.ListaTipoSessaoVazia\" model=\"vm.item.TipoSessao.IdTipoSessao\" required=\"true\" options=\"vm.tipoSessoes\" value-field=\"Id\" text-field=\"Nome\"></ng-field><h4 ng-show=\"vm.ListaTipoSessaoVazia\"><strong style=\"color: red; line-height: 80px\">Não existem Tipo de Sessões para este estabelecimento</strong></h4></div><div ng-if=\"(vm.CodRegraConveniencia == \'A\' || vm.CodRegraConveniencia == \'S\') && vm.item.Estabelecimento.IdEstabelecimento\" class=\"col-lg-6\"><ng-field label=\"Atracao\" type=\"select\" ng-hide=\"vm.ListaAtracaoVazia\" model=\"vm.item.Atracao.IdAtracao\" required=\"true\" options=\"vm.atracoes\" value-field=\"IdAtracao\" text-field=\"Nome\"></ng-field><h4 ng-show=\"vm.ListaAtracaoVazia\"><strong style=\"color: red; line-height: 80px\">Não existem Atrações para este estabelecimento</strong></h4></div></div><div ng-show=\"vm.CodRegraConveniencia && vm.CodRegraConveniencia != \'P\'\" class=\"row\"><div ng-if=\"vm.CodRegraConveniencia == \'S\' && vm.item.Estabelecimento.IdEstabelecimento && vm.item.Atracao.IdAtracao\" class=\"col-lg-6\"><div ng-repeat=\"item in vm.sessoes\" class=\"inline\" style=\"padding-right: 20px; padding-bottom: 10px\"><input type=\"checkbox\" icheck=\"\" ng-change=\"vm.checkSessao()\" ng-model=\"item.Checked\" name=\"{{item.IdSessao}}\" ng-value=\"true\"> {{item.Nome}}</div><h4 ng-show=\"vm.ListaSessaoVazia\"><strong style=\"color: red;\">Não existem sessões para esta atração</strong></h4></div></div><div class=\"hr-line-dashed\"></div><div class=\"row\"><div class=\"col-lg-2\"><ng-field required=\"true\" label=\"Data de Vigência\" min-date=\"currentDate\" name=\"DataInicio\" model=\"vm.item.DataInicio\" type=\"date\"></ng-field></div><div class=\"col-lg-2\"><ng-field required=\"true\" label=\"Tipo da Taxa\" type=\"select\" model=\"vm.item.TipoTaxa\" options=\"vm.tipoTaxas\" value-field=\"Cod\" text-field=\"Nome\"></ng-field></div><div ng-if=\"vm.item.TipoTaxa == \'P\'\" class=\"col-lg-3\"><ng-field required=\"true\" label=\"Percentual da Taxa de Serviço\" maxlength=\"8\" type=\"percentual|2\" model=\"vm.item.ValorTaxa\"></ng-field></div><div ng-if=\"vm.item.TipoTaxa != \'P\'\" class=\"col-lg-3\"><ng-field required=\"true\" label=\"Valor da Taxa de Serviço\" maxlength=\"9\" type=\"money|2\" model=\"vm.item.ValorTaxa\"></ng-field></div></div><br><div class=\"row\"><div class=\"col-lg-2\"><ng-field label=\"Quantidade de Parcelas\" type=\"select\" model=\"vm.item.QtdParcelas\" options=\"vm.parcelas\" value-field=\"Id\" text-field=\"Nome\" required=\"true\"></ng-field></div><div class=\"col-lg-2\" ng-if=\"vm.item.QtdParcelas > 1\"><ng-field required=\"true\" label=\"Valor Mínimo Parcela\" name=\"ValorMinimoParcela\" model=\"vm.item.ValorMinimoParcela\" type=\"money|2\"></ng-field></div></div><div class=\"row\"><div class=\"col-lg-6\"><h4>Plataformas</h4><ul class=\"list-inline\"><li style=\"padding-bottom:8px;border:0px solid black;\" class=\"list-inline-item col-lg-6 col-sm-6 col-md-6 col-xs-6\" ng-repeat=\"item in vm.sistemas\"><h5><input type=\"checkbox\" icheck=\"\" ng-change=\"vm.checkPlataforma()\" ng-model=\"item.Checked\" name=\"{{item.IdSistema}}\" ng-value=\"true\"> {{item.Nome}}</h5></li></ul></div></div></form><div class=\"row\"><div class=\"form-group\"><div class=\"col-md-1 col-md-offset-10\"><button class=\"btn btn-outline pull-right\" type=\"button\" ng-click=\"vm.cancel();\">CANCELAR</button></div><div class=\"col-md-1\"><button class=\"btn btn-primary pull-right\" ng-disabled=\"validateForm || frm.$valid == false || vm.loading\" type=\"button\" ng-click=\"vm.save();\">SALVAR <i ng-class=\"{\'fa fa-spinner fa-pulse\' : vm.loading }\"></i></button></div></div></div></div></div></div>");
$templateCache.put("view/estabelecimento/convenienciaestabelecimento/grid.html","<div class=\"wrapper wrapper-content animated fadeInDown\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><form><div class=\"row\"><div class=\"col-lg-12\"><button type=\"button\" ng-click=\"vm.include();\" class=\"btn btn-w-m btn-success pull-right col-offset-m1\">INCLUIR</button></div></div><div class=\"row\"><div class=\"col-lg-3\"><ng-field label=\"Regras da Conveniência\" type=\"select\" model=\"vm.Filter.CodRegraConveniencia\" options=\"vm.regrasConveniencia\" value-field=\"Cod\" text-field=\"Nome\"></ng-field></div><div class=\"col-lg-3\"><ng-field label=\"Estabelecimentos\" type=\"select\" model=\"vm.Filter.IdEstabelecimento\" options=\"vm.estabelecimentos\" value-field=\"Id\" text-field=\"Nome\"></ng-field></div><div class=\"col-lg-2\"><ng-field label=\"Data da Vigência\" name=\"DataInicio\" model=\"vm.Filter.DataInicio\" type=\"date\"></ng-field></div><div class=\"col-lg-2\"><ng-field label=\"Plataforma\" type=\"select\" model=\"vm.Filter.IdSistema\" options=\"vm.sistemas\" value-field=\"IdSistema\" text-field=\"Nome\"></ng-field></div><div class=\"col-lg-2\" style=\"margin-top: 25px;\"><button type=\"button\" class=\"btn btn-w-m btn-success pull-right col-offset-m1\" ng-click=\"vm.search()\">FILTRAR</button></div></div></form></div><br><div style=\"overflow-x: scroll\" class=\"ibox-content\"><table class=\"table table-striped table-hover\" role=\"grid\"><thead><tr role=\"row\"><th>Regras da Conveniencia</th><th>Estabelecimento</th><th>Tipo de Sessão</th><th>Tipo de Atração</th><th>Atração</th><th>Sessão</th><th>Data de Vigência</th><th>Plataformas</th><th>Taxa</th><th width=\"100\">Qtd Parcela</th><th width=\"140\">Valor Min. Parcela</th><th class=\"text-right\">Ações</th></tr></thead><tbody><tr class=\"gradeA odd\" role=\"row\" ng-repeat=\"item in vm.items\"><td class=\"project-title\"><span>{{item.RegraConveniencia}}</span></td><td class=\"project-title\"><span>{{item.Estabelecimento}}</span></td><td class=\"project-title\"><span>{{item.TipoSessao}}</span></td><td class=\"project-title\"><span>{{item.TipoAtracao}}</span></td><td class=\"project-title\"><span>{{item.Atracao}}</span></td><td class=\"project-title\"><span>{{item.Sessao}}</span></td><td class=\"project-title\"><span>{{item.DataInicio | date: \'dd/MM/yyyy\'}}</span></td><td class=\"project-title\"><span>{{item.Plataforma}}</span></td><td ng-if=\"item.TipoConveniencia == \'F\'\" class=\"project-title\"><span>{{item.Taxa | currency}}</span></td><td ng-if=\"item.TipoConveniencia == \'P\'\" class=\"project-title\"><span>{{item.Taxa}}%</span></td><td class=\"project-title\"><span>{{item.QtdParcelas}}</span></td><td class=\"project-title\"><span>R$ {{item.ValorMinimoParcela}}</span></td><td class=\"project-actions\"><span uib-dropdown=\"\" on-toggle=\"toggled(open)\"><a role=\"button\" uib-dropdown-toggle=\"\"><i class=\"fa fa-wrench\"></i></a><ul class=\"pull-right\" uib-dropdown-menu=\"\" aria-labelledby=\"simple-dropdown\"><li><a role=\"button\" ng-if=\"item.CodRegraConveniencia == \'S\' && item.Regerado == false\" ng-click=\"vm.regerar(item);\"><i class=\"fa fa-edit\"></i> Regerar Conveniencia</a> <a role=\"button\" ng-if=\"item.CodRegraConveniencia == \'S\' && item.Regerado == true\" style=\"color: grey;\"><i class=\"fa fa-edit\" style=\"color: grey;\"></i> Regerado</a> <a role=\"button\" ng-if=\"item.CodRegraConveniencia != \'S\'\" style=\"color: grey;\"><i class=\"fa fa-edit\" style=\"color: grey;\"></i> Regerar Conveniencia</a></li></ul></span></td></tr></tbody></table></div></div></div></div></div>");
$templateCache.put("view/estabelecimento/convenienciaestabelecimento/index.html","<div ui-view=\"\"></div>");
$templateCache.put("view/estabelecimento/estrutura/form.html","<div class=\"wrapper wrapper-content animated fadeInRight\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><form name=\"frm\"><div class=\"hr-line-dashed\"></div><div class=\"row\"><div class=\"col-sm-12 col-md-12 col-lg-12\"><label><input type=\"checkbox\" icheck=\"\" ng-model=\"vm.item.FluxoAtracao\" class=\"i-checks\" ng-true-value=\"\'R\'\" ng-false-value=\"\'C\'\"> <strong class=\"m-l-md\">Fluxo de venda resumido</strong></label></div></div><div class=\"hr-line-dashed\"></div><div class=\"row\"><div class=\"col-sm-12 col-md-12 col-lg-12\"><label><input type=\"checkbox\" icheck=\"\" ng-model=\"vm.item.PossuiLayout\" class=\"i-checks\" ng-true-value=\"true\" ng-false-value=\"false\"> <strong class=\"m-l-md\">Possui Layout</strong></label></div></div><div class=\"hr-line-dashed\"></div><div class=\"row\"><div class=\"col-sm-12 col-md-12 col-lg-12\"><label><input type=\"checkbox\" icheck=\"\" ng-model=\"vm.item.PossuiSetor\"> <strong class=\"m-l-md\">Possui Setor</strong></label></div></div><div class=\"hr-line-dashed\"></div><div class=\"row\"><div class=\"col-sm-12 col-md-12 col-lg-12\"><label><input type=\"checkbox\" icheck=\"\" ng-model=\"vm.item.PossuiZona\"> <strong class=\"m-l-md\">Possui Zona</strong></label></div></div><div class=\"hr-line-dashed\"></div><div class=\"row\"><div class=\"col-sm-12 col-md-12 col-lg-12\"><label><input type=\"checkbox\" icheck=\"\" ng-model=\"vm.item.PossuiLote\"> <strong class=\"m-l-md\">Possui Lote</strong></label></div></div><div class=\"hr-line-dashed\"></div><div class=\"row\"><div class=\"col-sm-12 col-md-12 col-lg-12\"><label><input type=\"checkbox\" icheck=\"\" ng-model=\"vm.item.GerenteAutorizaCortesia\"> <strong class=\"m-l-md\">Gerente Autoriza Cortesia</strong></label></div></div><div class=\"hr-line-dashed\"></div><div class=\"row\"><div class=\"col-sm-12 col-md-12 col-lg-12\"><label><input type=\"checkbox\" icheck=\"\" ng-model=\"vm.item.GerenteAutorizaDevolucaoDinheiro\"> <strong class=\"m-l-md\">Gerente Autoriza Devolucao Dinheiro</strong></label></div></div><div class=\"hr-line-dashed\"></div><div class=\"row\"><div class=\"col-sm-12 col-md-12 col-lg-12\"><label><input type=\"checkbox\" icheck=\"\" ng-model=\"vm.item.GerenteAutorizaDevolucaoVenda\"> <strong class=\"m-l-md\">Gerente Autoriza Devolucao Venda</strong></label></div></div><div class=\"hr-line-dashed\"></div><div class=\"row\"><div class=\"col-sm-12 col-md-12 col-lg-12\"><label><input type=\"checkbox\" icheck=\"\" ng-model=\"vm.item.VendaIntegradaPinPad\"> <strong class=\"m-l-md\">Venda Integrada Pin Pad</strong></label></div></div><div class=\"hr-line-dashed\"></div><div class=\"row\"><div class=\"col-sm-4 col-md-4 col-lg-4\"><ng-field ng-enter=\"vm.search()\" name=\"FormatoIngresso\" label=\"Formato Ingresso\" model=\"vm.item.IdFormatoIngresso\" options=\"vm.lstFormatoIngresso\" type=\"select\" value-field=\"IdFormatoIngresso\" text-field=\"NomeFormatoIngresso\" required=\"true\"></ng-field></div></div></form><div class=\"row\"><div class=\"form-group\"><div class=\"col-md-1 col-md-offset-10\"><button class=\"btn btn-outline pull-right\" type=\"button\" ng-click=\"vm.cancel();\">CANCELAR</button></div><div class=\"col-md-1\"><button class=\"btn btn-primary pull-right\" ng-disabled=\"validateForm || frm.$invalid\" type=\"button\" ng-click=\"vm.save();\">SALVAR</button></div></div></div></div></div></div></div></div>");
$templateCache.put("view/estabelecimento/estrutura/grid.html","<div class=\"wrapper wrapper-content animated fadeInDown\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><button type=\"button\" class=\"btn btn-w-m btn-success pull-right col-offset-m1\" ng-click=\"vm.search()\" ng-disabled=\"vm.searching\"><i class=\"fa\" ng-class=\"{\'fa fa-spinner fa-spin\' : vm.searching}\"></i> FILTRAR</button><div class=\"input-group col-xs-7 col-sm-8 col-md-9 col-lg-10\"><div class=\"input-group-addon\"><i class=\"fa fa-search\"></i></div><input type=\"search\" ng-enter=\"vm.search()\" class=\"form-control\" placeholder=\"Digite para filtrar os resultados\" ng-model=\"vm.Filter.Nome\" aria-controls=\"DataTables_Table_0\"></div></div><br><div class=\"ibox-content\"><div class=\"table-responsive constrained\" ts-wrapper=\"\" ts-no-data-text=\"Utilize o filtro para filtrar os estabelecimentos\"><table class=\"table table-hover table-striped\" data-sorting=\"true\" role=\"grid\" infinite-scroll=\"vm.search(true)\" infinite-scroll-disabled=\"vm.complete || vm.searching\" infinite-scroll-immediate-check=\"false\" infinite-scroll-distance=\"0\"><thead><tr><th ts-criteria=\"Nome|lowercase\">Nome</th><th ts-criteria=\"Empresa|lowercase\">Empresa</th><th ts-criteria=\"Cidade|lowercase\">Cidade</th><th ts-criteria=\"UF|lowercase\">UF</th><th class=\"text-right\">Ações</th></tr></thead><tbody><tr ng-repeat=\"item in vm.items\" ng-class=\"{\'success\' : itm.updated}\" ts-repeat=\"\"><td class=\"project-title\"><span>{{item.Nome}}</span></td><td class=\"project-title\"><span>{{item.Empresa}}</span></td><td class=\"project-title\"><span>{{item.Cidade}}</span></td><td class=\"project-title\"><span>{{item.UF}}</span></td><td class=\"project-actions\"><span uib-dropdown=\"\" on-toggle=\"toggled(open)\"><a role=\"button\" uib-dropdown-toggle=\"\"><i class=\"fa fa-wrench\"></i></a><ul class=\"pull-right\" uib-dropdown-menu=\"\" aria-labelledby=\"simple-dropdown\"><li><a role=\"button\" ng-click=\"vm.edit(item);\"><i class=\"fa fa-edit\"></i> Editar</a></li></ul></span></td></tr></tbody></table><div class=\"row\"><div class=\"col-md-6 col-md-offset-5\" ng-show=\"vm.searching\"><i class=\"fa fa-spinner fa-pulse fa-1x fa-fw\"></i> Carregando...</div></div></div></div></div></div></div></div>");
$templateCache.put("view/estabelecimento/estrutura/index.html","<div ui-view=\"\"></div>");
$templateCache.put("view/estabelecimento/template/mapa.tmpl.html","<style>\n  .angular-google-map-container { height: 300px; overflow:visible;}\n</style><div ng-if=\"!closeModal\"><div class=\"modal-header\"><h4>Definir localização</h4><form name=\"frm\"><ng-field type=\"text\" placeholder=\"Buscar\" name=\"Endereco\" model=\"map.address\"></ng-field><button class=\"btn btn-w-m btn-success\" type=\"button\" ng-click=\"setarLocalizacao(map.address)\">Buscar</button></form></div><div class=\"modal-body\"><ui-gmap-google-map center=\"map.center\" zoom=\"map.zoom\"><ui-gmap-markers models=\"map.markers\" coords=\"\'self\'\" icon=\"\'icon\'\" click=\"onMarkerClicked\" options=\"\'options\'\" events=\"map.markersEvents\"><ui-gmap-windows show=\"\'showWindow\'\" closeclick=\"\'closeClick\'\" ng-cloak=\"\"></ui-gmap-windows></ui-gmap-markers></ui-gmap-google-map></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-w-m btn-success pull-right\" ng-click=\"vm.confirm(map.markers[0])\">CONFIRMAR</button> <button type=\"button\" class=\"btn btn-outline btn-link pull-right\" data-dismiss=\"modal\" ng-click=\"vm.cancel()\">CANCELAR</button></div></div>");
$templateCache.put("view/moderacao/artista/form.html","<div class=\"wrapper wrapper-content animated fadeInDown\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><h2 class=\"m-b-lg\">{{vm.items.Nome}}</h2><div class=\"row m-b-lg\"><div class=\"col-xs-9 col-sm-9 col-md-4\"><label>Nome do artista</label><br><span class=\"m-t-lg\">{{vm.items.Nome}}</span><br><br><label>URI</label><br><span>{{vm.items.Uri}}</span></div><div class=\"col-xs-9 col-sm-9 col-md-4\"><label>Sexo</label><br><span>{{vm.items.Sexo}}</span></div><div class=\"col-xs-9 col-sm-9 col-md-4\"><img ng-src=\"{{vm.items.FotoPerfil}}\" height=\"250\" width=\"250\" style=\"float:right;\"></div></div><div class=\"hr-line-dashed\"></div><p><button class=\"btn m-r-lg\" type=\"button\" ng-click=\"vm.cancel();\">VOLTAR</button> <button class=\"btn btn-primary pull-right\" type=\"button\" ng-click=\"vm.aprovar();\">APROVAR</button> <button class=\"btn btn-danger\" type=\"button\" ng-click=\"vm.reprovar()\">REPROVAR</button></p></div></div></div>");
$templateCache.put("view/moderacao/artista/grid.html","<div class=\"wrapper wrapper-content animated fadeInDown\"><div class=\"row\"><form name=\"frm\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-3 col-sm-4 col-md-3 col-lg-3\"><ng-field label=\"Período\" type=\"select\" model=\"vm.Filter.Periodo\" options=\"vm.PeriodoList\" value-field=\"Valor\" text-field=\"Nome\"></ng-field></div><div class=\"col-xs-3 col-sm-4 col-md-3 col-lg-3\"><ng-field label=\"Situação\" model=\"vm.Filter.Situacao\" type=\"select\" options=\"vm.SituacaoList\" value-field=\"Valor\" text-field=\"Nome\"></ng-field></div><div class=\"col-xs-3 col-sm-4 col-md-3 col-lg-3\"><ng-field label=\"Ocorrência\" model=\"vm.Filter.Ocorrencia\" type=\"select\" options=\"vm.OcorrenciaList\" value-field=\"Valor\" text-field=\"Nome\"></ng-field></div></div><button type=\"button\" class=\"btn btn-w-m btn-success pull-right col-offset-m1\" ng-click=\"vm.search()\" ng-disabled=\"vm.searching\"><i class=\"fa\" ng-class=\"{\'fa fa-spinner fa-spin\' : vm.searching}\"></i> FILTRAR</button><div class=\"input-group col-xs-7 col-sm-8 col-md-9 col-lg-10\"><div class=\"input-group-addon\"><i class=\"fa fa-search\"></i></div><input type=\"search\" ng-enter=\"vm.search()\" class=\"form-control\" placeholder=\"Digite para filtrar os resultados\" ng-model=\"vm.Filter.Nome\" aria-controls=\"DataTables_Table_0\"></div></div><br><div class=\"ibox-content\"><div class=\"table-responsive constrained\" ts-wrapper=\"\" ts-no-data-text=\"Utilize o filtro para filtrar os usuários\"><table class=\"table table-hover table-striped\" data-sorting=\"true\" role=\"grid\" infinite-scroll=\"vm.search(true)\" infinite-scroll-disabled=\"vm.complete || vm.searching\" infinite-scroll-immediate-check=\"false\" infinite-scroll-distance=\"0\"><thead><tr><th ts-criteria=\"Nome|lowercase\">Artista</th><th ts-criteria=\"DataCriacao|lowercase\">Data Cadastro</th><th ts-criteria=\"Ocorrencia|lowercase\">Registro</th><th class=\"text-right\">Ações</th></tr></thead><tbody><tr ng-repeat=\"item in vm.items\" ng-class=\"{\'success\' : itm.updated}\" ts-repeat=\"\"><td class=\"project-title\">{{item.Nome}}</td><td class=\"project-title\">{{item.DataCriacao | date: \'dd/MM/yyyy\' : \'UTC\'}}</td><td class=\"project-title\">{{item.Ocorrencia}}</td><td class=\"project-title\" align=\"right\"><button type=\"button\" class=\"btn btn-xs btn-success\" ng-click=\"vm.edit(item);\">Moderar</button></td></tr></tbody></table></div></div></div></div></form></div></div>");
$templateCache.put("view/moderacao/artista/index.html","<div ui-view=\"\"></div>");
$templateCache.put("view/moderacao/atracao/form.html","<style>\n    /* css personalizado da página, deverá ser movido ou deletado */\n\n    .img-thumbnail {\n        margin: 10px;\n        height: 140px !important;\n    }\n\n    #wrapper {\n        overflow-x: initial;\n    }\n\n    #page-wrapper > div:nth-child(2) > div > div > div > div > ul {\n        padding: 0;\n    }\n</style><div class=\"wrapper wrapper-content animated fadeInDown\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><div><h2 class=\"m-b-lg\">{{vm.items.Nome}}</h2><h4 class=\"m-b-lg\">Ficha Técnica</h4><div class=\"col-xs-4 col-xs-offset-5 col-sm-4 col-sm-offset-6 col-md-4 col-md-offset-8\"><br><img ng-src=\"{{vm.items.FotoCapa}}\" height=\"320\" width=\"227\" style=\"position:absolute;\"></div><div class=\"row m-b-lg\"><div class=\"col-xs-9 col-sm-9 col-md-4\"><label>Nome da atração</label><br><span>{{vm.items.Nome}}</span></div><div class=\"col-xs-9 col-sm-9 col-md-4\"><label>Nome Original</label><br><span>{{vm.items.NomeOriginal}}</span></div></div><div class=\"row m-b-lg\"><div class=\"col-xs-9 col-sm-9 col-md-4\"><label>Idioma Original</label><br><span>{{vm.items.Idioma}}</span></div><div class=\"col-xs-9 col-sm-9 col-md-4\"><label>País de Origem</label><br><span>{{vm.items.PaisOrigem}}</span></div></div><div class=\"row m-b-lg\"><div class=\"col-xs-9 col-sm-9 col-md-4\"><label>URL oficial</label><br><span>{{vm.items.UrlOficial}}</span></div><div class=\"col-xs-9 col-sm-9 col-md-4\"><label>Duração</label><br><span>{{vm.items.Duracao}}</span></div></div><div class=\"row m-b-lg\"><div class=\"col-xs-9 col-sm-9 col-md-4\"><label>Ano de Lançamento</label><br><span>{{vm.items.AnoLancamento}}</span></div><div class=\"col-xs-9 col-sm-9 col-md-4\"><label>Gêneros</label><br><span ng-repeat=\"genero in vm.items.generos\">{{genero.Nome}}<br></span></div></div><div class=\"row m-b-lg\"><div class=\"col-xs-9 col-sm-9 col-md-4\"><label>Classificação Indicativa</label><br><span>{{vm.items.Classificacao}}</span></div><div class=\"col-xs-9 col-sm-9 col-md-4\"><label>Inadequação</label><br><span ng-repeat=\"inadequacao in vm.items.inadequacoes\">{{inadequacao.Nome}}<br></span></div></div></div><div class=\"hr-line-dashed\"></div><div><h4 class=\"m-b-lg\">Participantes</h4><div class=\"row m-b-lg\"><div class=\"col-xs-9 col-sm-9 col-md-4\"><label>Diretores</label><br><span>{{vm.items.Diretores}}</span></div><div class=\"col-xs-9 col-sm-9 col-md-4\"><label>Autores</label><br><span>{{vm.items.Autores}}</span></div></div><div class=\"row m-b-lg\"><div class=\"col-xs-9 col-sm-9 col-md-4\"><label>Produtores</label><br><span>{{vm.items.Produtores}}</span></div><div class=\"col-xs-9 col-sm-9 col-md-4\"><label>Produtores Musicais</label><br><span>{{vm.items.ProdutoresMusicais}}</span></div></div><div class=\"row m-b-lg\"><div class=\"col-xs-9 col-sm-9 col-md-4\"><label>Elenco</label><br><span>{{vm.items.Elenco}}</span></div><div class=\"col-xs-9 col-sm-9 col-md-4\"><label>Informações sobre o elenco</label><br><span>{{vm.items.InformacaoElenco}}</span></div></div></div><div class=\"hr-line-dashed\"></div><div><h4>Sinopse</h4><div class=\"row m-b-lg\"><div class=\"col-xs-12 col-sm-12 col-md-12\"><iframe src=\"\" name=\"sinopse\" frameborder=\"0\" width=\"100%\" style=\"min-height: 300px;font-family: \'Open Sans\', \'Helvetica\', \'Arial\', sans-serif;\"></iframe></div></div></div><div class=\"hr-line-dashed\"></div><h4>Mídia</h4><ul class=\"gallery\"><li ng-repeat=\"imagem in vm.items.imagensDaGaleria\" style=\"display:inline-block;\"><a ng-click=\"openLightboxModal($index)\"><img ng-src=\"{{imagem.url}}\" class=\"img-thumbnail\"></a></li></ul><br><h4>Avaliações</h4><div style=\"height:300px; overflow-y: scroll;\" ng-if=\"vm.AtracaoAvaliacao.length > 0\" class=\"table-responsive constrained\"><table class=\"table table-hover table-striped\"><thead><tr><th>NomeCliente</th><th>Comentario</th><th>DataHora</th><th>Nota</th></tr></thead><tbody><tr ng-repeat=\"item in vm.AtracaoAvaliacao\"><td>{{item.NomeCliente}}</td><td style=\"white-space: -pre-wrap;\">{{item.Comentario}}</td><td>{{item.DataHora}}</td><td>{{item.Nota}}</td><td><div><input type=\"radio\" icheck=\"\" ng-model=\"item.ModeradoSite\" name=\"{{item.IdAtracao}}\" ng-value=\"true\"> Sim &nbsp; <input type=\"radio\" icheck=\"\" ng-model=\"item.ModeradoSite\" name=\"{{item.IdAtracao}}\" ng-value=\"false\"> Não</div></td></tr></tbody></table></div><div class=\"hr-line-dashed\"></div><p><button class=\"btn m-r-lg\" type=\"button\" ng-click=\"vm.cancel();\">VOLTAR</button> <button class=\"btn btn-primary pull-right\" type=\"button\" ng-click=\"vm.aprovar();\">APROVAR</button> <button class=\"btn btn-danger\" type=\"button\" ng-click=\"vm.reprovar()\">REPROVAR</button></p></div></div></div>");
$templateCache.put("view/moderacao/atracao/grid.html","<div class=\"wrapper wrapper-content animated fadeInDown\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><label>Nome da Atração</label><div class=\"input-group col-xs-12 col-sm-12 col-md-12 col-lg-12 m-b-md\"><input type=\"search\" ng-model=\"vm.Filter.Nome\" class=\"form-control\" placeholder=\"Digite para filtrar os resultados\" aria-controls=\"DataTables_Table_0\"></div><div class=\"row\"><div class=\"col-xs-3 col-sm-3 col-md-3 col-lg-3\"><label>Período</label><select class=\"input-group form-control\" ng-model=\"vm.Filter.Periodo\"><option value=\"3\" ng-selected=\"true\">Últimos 3 dias</option><option value=\"7\">Última semana</option><option value=\"15\">Últimos 15 dias</option><option value=\"30\">1 mês</option><option value=\"60\">3 meses</option><option value=\"180\">6 meses</option><option value=\"365\">1 ano</option></select></div><div class=\"col-xs-3 col-sm-4 col-md-3 col-lg-3\"><label>Situação</label><select class=\"input-group form-control\" ng-model=\"vm.Filter.Situacao\"><option value=\"1\" ng-selected=\"true\">Todos</option><option value=\"2\">Aprovados</option><option value=\"3\">Reprovados</option><option value=\"4\">A Aprovar</option></select></div><div class=\"col-xs-3 col-sm-4 col-md-3 col-lg-3\"><label>Ocorrência</label><select class=\"input-group form-control\" ng-model=\"vm.Filter.Ocorrencia\"><option value=\"1\" ng-selected=\"true\">Todos</option><option value=\"2\">Novos</option><option value=\"3\">Atualização</option></select></div><div class=\"col-xs-3 col-sm-3 col-md-3 col-lg-3\"><button type=\"button\" class=\"btn m-t-md btn-w-m btn-success pull-right\" ng-click=\"vm.search()\">FILTRAR</button></div></div><br><div class=\"ibox-content\"><table class=\"table table-striped table-hover\" role=\"grid\"><thead><tr role=\"row\"><th class=\"sorting\" tabindex=\"0\" aria-controls=\"DataTables_Table_0\" rowspan=\"1\" colspan=\"1\" style=\"width: 300px;\">Atração</th><th class=\"sorting\" tabindex=\"0\" aria-controls=\"DataTables_Table_0\" rowspan=\"1\" colspan=\"1\" style=\"width: 300px;\">Estabelecimento</th><th class=\"sorting\" tabindex=\"0\" aria-controls=\"DataTables_Table_0\" rowspan=\"1\" colspan=\"1\" style=\"width: 110px;\">Data Cadastro</th><th class=\"sorting\" tabindex=\"0\" aria-controls=\"DataTables_Table_0\" rowspan=\"1\" colspan=\"1\" style=\"width: 80px;\">Ocorrência</th><th class=\"sorting\" tabindex=\"0\" aria-controls=\"DataTables_Table_0\" rowspan=\"1\" colspan=\"1\" style=\"width: 5px;\">Ações</th></tr></thead><tbody><tr class=\"gradeA odd\" role=\"row\" ng-repeat=\"item in vm.items\"><td class=\"sorting_1\">{{item.Nome}}</td><td class=\"sorting_1\">{{item.Estabelecimento}}</td><td class=\"sorting_1\">{{item.DataCriacao | defaultDate}}</td><td class=\"sorting_1\">{{item.Ocorrencia}}</td><td class=\"sorting_1\" align=\"center\"><button type=\"button\" class=\"btn btn-xs btn-success\" ng-click=\"vm.edit(item);\">Moderar</button></td></tr></tbody></table></div></div></div></div></div></div>");
$templateCache.put("view/moderacao/atracao/index.html","<div ui-view=\"\"></div>");
$templateCache.put("view/moderacao/banda/form.html","<div class=\"wrapper wrapper-content animated fadeInDown\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><h2 class=\"m-b-lg\">{{vm.items.Nome}}</h2><div class=\"row m-b-lg\"><div class=\"col-xs-9 col-sm-9 col-md-4\"><label>Nome da Banda</label><br><span class=\"m-t-lg\">{{vm.items.Nome}}</span><br><br><div class=\"table-responsive constrained\"><table class=\"table table-hover table-striped\"><thead><tr><th>Artista</th><th>Foto</th><th>Sexo</th><th>Moderar</th></tr></thead><tbody><tr ng-repeat=\"item in vm.BandaArtista\"><td>{{item.Nome}}</td><td><img ng-src=\"{{item.FotoPerfil}}\" class=\"img-circle\" alt=\"\" width=\"30\" height=\"30\"></td><td>{{item.Sexo}}</td><td><div><input type=\"radio\" icheck=\"\" ng-model=\"item.ModeradoSite\" name=\"{{item.IdArtista}}\" ng-value=\"true\"> Sim &nbsp; <input type=\"radio\" icheck=\"\" ng-model=\"item.ModeradoSite\" name=\"{{item.IdArtista}}\" ng-value=\"false\"> Não</div></td></tr></tbody></table></div></div><div class=\"col-xs-9 col-sm-9 col-md-3\"><label>URI</label><br><span>{{vm.items.Uri}}</span></div><div class=\"col-xs-9 col-sm-9 col-md-4\" ng-if=\"vm.items.FotoPerfil !== null\"><img ng-src=\"{{vm.items.FotoPerfil}}\" height=\"280\" width=\"200\" style=\"float:right;\"></div></div><div class=\"row\"></div><div class=\"hr-line-dashed\"></div><p><button class=\"btn m-r-lg\" type=\"button\" ng-click=\"vm.cancel();\">VOLTAR</button> <button class=\"btn btn-primary pull-right\" type=\"button\" ng-click=\"vm.aprovar();\">APROVAR</button> <button class=\"btn btn-danger\" type=\"button\" ng-click=\"vm.reprovar();\">REPROVAR</button></p></div></div></div>");
$templateCache.put("view/moderacao/banda/grid.html","<div class=\"wrapper wrapper-content animated fadeInDown\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><form name=\"frm\"><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-3 col-sm-4 col-md-3 col-lg-3\"><ng-field label=\"Período\" type=\"select\" model=\"vm.Filter.Periodo\" options=\"vm.PeriodoList\" value-field=\"Valor\" text-field=\"Nome\"></ng-field></div><div class=\"col-xs-3 col-sm-4 col-md-3 col-lg-3\"><ng-field label=\"Situação\" model=\"vm.Filter.Situacao\" type=\"select\" options=\"vm.SituacaoList\" value-field=\"Valor\" text-field=\"Nome\"></ng-field></div><div class=\"col-xs-3 col-sm-4 col-md-3 col-lg-3\"><ng-field label=\"Ocorrência\" model=\"vm.Filter.Ocorrencia\" type=\"select\" options=\"vm.OcorrenciaList\" value-field=\"Valor\" text-field=\"Nome\"></ng-field></div></div><button type=\"button\" class=\"btn btn-w-m btn-success pull-right col-offset-m1\" ng-click=\"vm.search()\" ng-disabled=\"vm.searching\"><i class=\"fa\" ng-class=\"{\'fa fa-spinner fa-spin\' : vm.searching}\"></i> FILTRAR</button><div class=\"input-group col-xs-7 col-sm-8 col-md-9 col-lg-10\"><div class=\"input-group-addon\"><i class=\"fa fa-search\"></i></div><input type=\"search\" ng-enter=\"vm.search()\" class=\"form-control\" placeholder=\"Digite para filtrar os resultados\" ng-model=\"vm.Filter.Nome\" aria-controls=\"DataTables_Table_0\"></div></div></form><br><div class=\"ibox-content\"><div class=\"table-responsive constrained\" ts-wrapper=\"\" ts-no-data-text=\"Utilize o filtro para filtrar os usuários\"><table class=\"table table-hover table-striped\" data-sorting=\"true\" role=\"grid\" infinite-scroll=\"vm.search(true)\" infinite-scroll-disabled=\"vm.complete || vm.searching\" infinite-scroll-immediate-check=\"false\" infinite-scroll-distance=\"0\"><thead><tr role=\"row\"><th ts-criteria=\"Nome|lowercase\">Banda</th><th ts-criteria=\"DataCadastro|lowercase\">Data Cadastro</th><th ts-criteria=\"Status|lowercase\">Status</th><th ts-criteria=\"Ocorrencia|lowercase\">Registro</th><th class=\"text-right\">Ações</th></tr></thead><tbody><tr ng-repeat=\"item in vm.items\" ng-class=\"{\'success\' : itm.updated}\" ts-repeat=\"\"><td class=\"project-title\">{{item.Nome}}</td><td class=\"project-title\">{{item.DataCadastro | date: \'dd/MM/yyyy\'}}</td><td class=\"project-title\">{{item.Status | obterStatus}}</td><td class=\"project-title\">{{item.Ocorrencia}}</td><td class=\"project-title\" align=\"right\"><button type=\"button\" class=\"btn btn-xs btn-success\" ng-click=\"vm.edit(item);\">Moderar</button></td></tr></tbody></table></div></div></div></div></div></div>");
$templateCache.put("view/moderacao/banda/index.html","<div ui-view=\"\"></div>");
$templateCache.put("view/moderacao/ingresso/form.html","<div class=\"wrapper wrapper-content animated fadeInDown\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><div class=\"row m-b-lg\"><div class=\"col-xs-9 col-sm-9 col-md-3\"><label>Ingresso</label><br><span>{{vm.item.Nome}}</span></div><div class=\"col-xs-9 col-sm-9 col-md-3\"><label>Valor da Regra</label><br><span class=\"sorting_1\" ng-if=\"vm.item.TipoDesconto == \'F\'\">{{vm.item.ValorRegra | currency: \'R$ \'}}</span> <span class=\"sorting_1\" ng-if=\"vm.item.TipoDesconto == \'P\'\">{{vm.item.ValorRegra * 100}} %</span></div><div class=\"col-xs-9 col-sm-9 col-md-3\"><label>Mensagem</label><br><span>{{vm.item.Mensagem}}</span></div><div class=\"col-xs-9 col-sm-9 col-md-3\"><label>Mensagem abreviada</label><br><span>{{vm.item.MensagemAbreviada}}</span></div></div><div class=\"row m-b-lg\"><div class=\"col-xs-9 col-sm-9 col-md-3\"><label>Tipo de Desconto</label><br><span class=\"sorting_1\">{{vm.item.TipoDesconto == \'F\' ? \'Fixo\' : \'Percentual\'}}</span></div><div class=\"col-xs-9 col-sm-9 col-md-3\"><label>Nome da Regra</label><br><span>{{vm.item.Regra}}</span></div><div class=\"col-xs-9 col-sm-9 col-md-3\"><label>Descrição da Regra</label><br><span>{{vm.item.DescricaoRegra}}</span></div><div class=\"col-xs-9 col-sm-9 col-md-3\"><label>Valida documento</label><br><span class=\"sorting_1\">{{vm.item.ValidaDocumento ? \'Sim\' : \'Não\'}}</span></div></div><div class=\"row m-b-lg\"><div class=\"col-xs-9 col-sm-9 col-md-3\"><label>Vende remoto</label><br><span class=\"sorting_1\">{{vm.item.VendeRemoto ? \'Sim\' : \'Não\'}}</span></div></div><div class=\"hr-line-dashed\"></div><p><button class=\"btn m-r-lg\" type=\"button\" ng-click=\"vm.cancel();\">VOLTAR</button> <button class=\"btn btn-primary pull-right\" type=\"button\" ng-click=\"vm.aprovar(vm.item);\">APROVAR</button> <button class=\"btn btn-danger\" type=\"button\" ng-click=\"vm.reprovar(vm.item)\">REPROVAR</button></p></div></div></div>");
$templateCache.put("view/moderacao/ingresso/grid.html","<div class=\"wrapper wrapper-content animated fadeInDown\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><label>Nome do Ingresso</label><div class=\"input-group col-xs-12 col-sm-12 col-md-12 col-lg-12 m-b-md\"><input type=\"search\" ng-model=\"vm.Filter.Nome\" class=\"form-control\" placeholder=\"Digite para filtrar os resultados\" aria-controls=\"DataTables_Table_0\"></div><div class=\"row\"><div class=\"col-xs-3 col-sm-4 col-md-3 col-lg-3\"><label>Situação</label><select class=\"input-group form-control\" ng-model=\"vm.Filter.Situacao\"><option value=\"1\" ng-selected=\"true\">Todos</option><option value=\"2\">Aprovados</option><option value=\"3\">Reprovados</option><option value=\"4\">A Aprovar</option></select></div><div class=\"col-xs-3 col-sm-3 col-md-3 col-lg-3 pull-right\"><button type=\"button\" class=\"btn m-t-md btn-w-m btn-success pull-right\" ng-click=\"vm.getallmoderacao()\" ng-disabled=\"vm.searching\"><i class=\"fa\" ng-class=\"{\'fa fa-spinner fa-pulse\' : vm.searching}\"></i> FILTRAR</button></div></div><br><div class=\"ibox-content\"><table class=\"table table-striped table-hover\" role=\"grid\"><thead><tr role=\"row\"><th class=\"sorting\" tabindex=\"0\" aria-controls=\"DataTables_Table_0\" rowspan=\"1\" colspan=\"1\" style=\"width: 300px;\">Ingresso</th><th class=\"sorting\" tabindex=\"0\" aria-controls=\"DataTables_Table_0\" rowspan=\"1\" colspan=\"1\" style=\"width: 300px;\">Tipo Desconto</th><th class=\"sorting\" tabindex=\"0\" aria-controls=\"DataTables_Table_0\" rowspan=\"1\" colspan=\"1\" style=\"width: 300px;\">Valor da Regra</th><th class=\"sorting\" tabindex=\"0\" aria-controls=\"DataTables_Table_0\" rowspan=\"1\" colspan=\"1\" style=\"width: 80px;\">Estabelecimento</th><th class=\"sorting\" tabindex=\"0\" aria-controls=\"DataTables_Table_0\" rowspan=\"1\" colspan=\"1\" style=\"width: 80px;\">Ocorrência</th><th class=\"sorting\" tabindex=\"0\" aria-controls=\"DataTables_Table_0\" rowspan=\"1\" colspan=\"1\" style=\"width: 5px;\">Ações</th></tr></thead><tbody><tr class=\"gradeA odd\" role=\"row\" ng-repeat=\"item in vm.items\"><td class=\"sorting_1\">{{item.Nome}}</td><td class=\"sorting_1\">{{item.TipoDesconto == \'F\' ? \'Fixo\' : \'Percentual\'}}</td><td class=\"sorting_1\" ng-if=\"item.TipoDesconto == \'F\'\">{{item.ValorRegra | currency: \'R$ \'}}</td><td class=\"sorting_1\" ng-if=\"item.TipoDesconto == \'P\'\">{{item.ValorRegra * 100}} %</td><td class=\"sorting_1\">{{item.NomeEstabelecimento}}</td><td class=\"sorting_1\">{{item.Ocorrencia}}</td><td class=\"sorting_1\" align=\"center\"><button type=\"button\" class=\"btn btn-xs btn-success\" ng-click=\"vm.moderar(item);\">Moderar</button></td></tr></tbody></table></div></div></div></div></div></div>");
$templateCache.put("view/moderacao/ingresso/index.html","<div ui-view=\"\"></div>");
$templateCache.put("view/moderacao/produtor/form.html","<div class=\"wrapper wrapper-content animated fadeInDown\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><h2 class=\"m-b-lg\">{{vm.items.Nome}}</h2><div class=\"row m-b-lg\"><div class=\"col-xs-9 col-sm-9 col-md-4\"><label>Nome</label><br><span class=\"m-t-lg\">{{vm.items.Apelido}}</span></div><div class=\"col-xs-9 col-sm-9 col-md-4\"><label>Email</label><br><span class=\"m-t-lg\">{{vm.items.Login}}</span></div><div class=\"col-xs-9 col-sm-9 col-md-4\"><label>Data Nascimento</label><br><span>{{vm.items.DataNascimento | date : \'dd/MM/yyyy\'}}</span></div></div><div class=\"row m-b-lg\"><div class=\"col-xs-9 col-sm-9 col-md-4\"><label>Telefone</label><br><span class=\"m-t-lg\">{{vm.items.Telefone}}</span></div><div class=\"col-xs-9 col-sm-9 col-md-4\"><label>Ramal</label><br><span class=\"m-t-lg\">{{vm.items.Ramal}}</span></div><div class=\"col-xs-9 col-sm-9 col-md-4\"><label>Data Cadastro</label><br><span class=\"m-t-lg\">{{vm.items.DataCadastro | date : \'dd/MM/yyyy\'}}</span></div></div><div class=\"hr-line-dashed\"></div><p><button class=\"btn m-r-lg\" type=\"button\" ng-click=\"vm.cancel();\">VOLTAR</button> <button class=\"btn btn-primary pull-right\" type=\"button\" ng-click=\"vm.aprovarreprovar(true);\">APROVAR</button> <button class=\"btn btn-danger\" type=\"button\" ng-click=\"vm.aprovarreprovar(false)\">REPROVAR</button></p></div></div></div>");
$templateCache.put("view/moderacao/produtor/grid.html","<div class=\"wrapper wrapper-content animated fadeInDown\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-6 m-b-md-6\"><label>Nome do Produtor</label> <input type=\"search\" ng-model=\"vm.Filter.Nome\" class=\"form-control\" placeholder=\"Digite para filtrar os resultados\" aria-controls=\"DataTables_Table_0\"></div><div class=\"col-xs-3 col-sm-3 col-md-3 col-lg-3\"><label>Situação</label><select class=\"input-group form-control\" ng-model=\"vm.Filter.Situacao\"><option value=\"1\" ng-selected=\"true\">Todos</option><option value=\"2\">Aprovados</option><option value=\"3\">Reprovados</option><option value=\"4\">A Aprovar</option></select></div><div class=\"col-xs-3 col-sm-3 col-md-3 col-lg-3\"><button type=\"button\" class=\"btn m-t-md btn-w-m btn-success pull-right\" ng-click=\"vm.search()\">FILTRAR</button></div></div><br><div class=\"ibox-content\"><table class=\"table table-striped table-hover\" role=\"grid\"><thead><tr role=\"row\"><th class=\"sorting\" tabindex=\"0\" aria-controls=\"DataTables_Table_0\" rowspan=\"1\" colspan=\"1\" style=\"width: 300px;\">Produtor</th><th class=\"sorting\" tabindex=\"0\" aria-controls=\"DataTables_Table_0\" rowspan=\"1\" colspan=\"1\" style=\"width: 300px;\">Email Validado</th><th class=\"sorting\" tabindex=\"0\" aria-controls=\"DataTables_Table_0\" rowspan=\"1\" colspan=\"1\" style=\"width: 300px;\">Status</th><th class=\"sorting\" tabindex=\"0\" aria-controls=\"DataTables_Table_0\" rowspan=\"1\" colspan=\"1\" style=\"width: 110px;\">Data Cadastro</th><th class=\"sorting\" tabindex=\"0\" aria-controls=\"DataTables_Table_0\" rowspan=\"1\" colspan=\"1\" style=\"width: 5px;\">Ações</th></tr></thead><tbody><tr class=\"gradeA odd\" role=\"row\" ng-repeat=\"item in vm.items\"><td class=\"sorting_1\">{{item.Nome}}</td><td class=\"sorting_1\" ng-switch=\"item.EmailValidado\"><text ng-switch-when=\"true\" style=\"color: green;font-weight: 600\">Sim</text><text ng-switch-when=\"false\" style=\"color: red;font-weight: 600\">Não</text></td><td class=\"sorting_1\" ng-switch=\"item.Moderado\"><text ng-switch-when=\"true\" style=\"color: green;font-weight: 600\">Aprovado</text><text ng-switch-when=\"false\" style=\"color: red;font-weight: 600\">Reprovado</text><text ng-switch-default=\"\" style=\"color: darkgrey;font-weight: 600\">Em análise</text></td><td class=\"sorting_1\">{{item.DataCadastro | defaultDate}}</td><td class=\"sorting_1\" align=\"center\"><button ng-disabled=\"!item.EmailValidado\" type=\"button\" class=\"btn btn-xs btn-success\" ng-click=\"vm.edit(item);\">Moderar</button></td></tr></tbody></table></div></div></div></div></div></div>");
$templateCache.put("view/moderacao/produtor/index.html","<div ui-view=\"\"></div>");
$templateCache.put("view/moderacao/video/form.html","<style>\n    #wrapper {\n        overflow-x: inherit;\n    }\n</style><div class=\"wrapper wrapper-content animated fadeInDown\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-sm-12 col-md-12 col-lg-8\"><h4>Passo 1: Faça o download do vídeo enviado pelo cliente</h4><video controls=\"\" ng-src=\"{{vm.item.UriNt | trusted}}\" type=\"video/*\" style=\"border:1px solid #e7eaec;\"></video><a class=\"btn btn-primary btn-file pull-right\" ng-href=\"{{vm.item.UriNt | trusted}}\" download=\"\"><i class=\"fa fa-download\" aria-hidden=\"true\"></i> Baixar vídeo</a></div><div class=\"col-sm-12 col-md-12 col-lg-12 m-t-lg\"><div><form name=\"frm\"><h4>Passo 2: Envie o vídeo tratado através do formulário abaixo</h4><label class=\"m-b-xs\">Selecione o vídeo:</label> <input class=\"form-control btn btn-default btn-file\" type=\"file\" ngf-validate=\"{size: {max: \'400000MB\', min: \'1B\'}, height: {max: 12000}, width: {max: 12000}, duration: {max: \'200m\'}}\" ngf-select=\"\" ngf-allow-dir=\"true\" ng-model=\"vm.FileVideo\" name=\"file\" accept=\"video/*\" required=\"\" ngf-model-invalid=\"errorFile\"> <span class=\"progress\" ng-show=\"vm.videoProgress >= 0\"><div style=\"width:{{vm.videoProgress}}%\" ng-bind=\"vm.videoProgress + \'%\'\"></div></span> <button class=\"btn btn-success btn-file pull-right\" ng-click=\"vm.uploadVideo(vm.FileVideo)\">Enviar</button><br><br><label>URI</label> <input class=\"form-control m-b-lg\" type=\"text\" ng-model=\"vm.item.Uri\" disabled=\"\" required=\"\"></form></div></div></div><p class=\"m-t-lg\"><button class=\"btn m-r-lg\" type=\"button\" ng-click=\"vm.cancel();\">VOLTAR</button> <button class=\"btn btn-success pull-right\" type=\"button\" ng-click=\"vm.save();\" ng-disabled=\"frm.$invalid\">CONFIRMAR</button></p></div></div></div></div></div>");
$templateCache.put("view/moderacao/video/grid.html","<div class=\"wrapper wrapper-content animated fadeInDown\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><label>Atração ou Identificação do vídeo</label><div class=\"input-group col-xs-12 col-sm-12 col-md-12 col-lg-12 m-b-md\"><input type=\"search\" ng-model=\"vm.Filter.Nome\" class=\"form-control\" placeholder=\"Digite para filtrar os resultados\" aria-controls=\"DataTables_Table_0\"></div><div class=\"row\"><div class=\"col-xs-3 col-sm-3 col-md-3 col-lg-3\"><label>Período</label><select class=\"input-group form-control\" ng-model=\"vm.Filter.Periodo\"><option value=\"3\" ng-selected=\"true\">Últimos 3 dias</option><option value=\"7\">Última semana</option><option value=\"15\">Últimos 15 dias</option><option value=\"30\">1 mês</option><option value=\"60\">3 meses</option><option value=\"180\">6 meses</option><option value=\"365\">1 ano</option></select></div><div class=\"col-xs-3 col-sm-4 col-md-3 col-lg-3\"><label>Status</label><select class=\"input-group form-control\" ng-model=\"vm.Filter.Status\"><option value=\"3\" ng-selected=\"true\">Todos os status</option><option value=\"1\">Aprovados</option><option value=\"2\">Reprovados</option></select></div><div class=\"col-xs-3 col-sm-4 col-md-3 col-lg-3\"><label>Registro</label><select class=\"input-group form-control\" ng-model=\"vm.Filter.StatusRegistro\"><option value=\"3\" ng-selected=\"true\">Todos</option><option value=\"0\">Novos</option><option value=\"1\">Atualizar</option></select></div><div class=\"col-xs-3 col-sm-3 col-md-3 col-lg-3\"><button type=\"button\" class=\"btn m-t-md btn-w-m btn-success pull-right\" ng-click=\"vm.search()\">FILTRAR</button></div></div><br><div class=\"ibox-content\"><table class=\"table table-striped table-hover\" role=\"grid\"><thead><tr role=\"row\"><th class=\"sorting\" tabindex=\"0\" aria-controls=\"DataTables_Table_0\" rowspan=\"1\" colspan=\"1\" style=\"width: 300px;\">Atração</th><th class=\"sorting\" tabindex=\"0\" aria-controls=\"DataTables_Table_0\" rowspan=\"1\" colspan=\"1\" style=\"width: 110px;\">Data Cadastro</th><th class=\"sorting\" tabindex=\"0\" aria-controls=\"DataTables_Table_0\" rowspan=\"1\" colspan=\"1\" style=\"width: 80px;\">Status</th><th class=\"sorting\" tabindex=\"0\" aria-controls=\"DataTables_Table_0\" rowspan=\"1\" colspan=\"1\" style=\"width: 80px;\">Registro</th><th class=\"sorting\" tabindex=\"0\" aria-controls=\"DataTables_Table_0\" rowspan=\"1\" colspan=\"1\" style=\"width: 5px;\">Ações</th></tr></thead><tbody><tr class=\"gradeA odd\" role=\"row\" ng-repeat=\"item in vm.items\"><td class=\"sorting_1\">{{item.Atracao}}</td><td class=\"sorting_1\">{{item.DataCadastro | date}}</td><td class=\"sorting_1\">{{item.Status | obterStatus}}</td><td class=\"sorting_1\">{{item.Registro | obterRegistro}}</td><td class=\"sorting_1\" align=\"center\"><button type=\"button\" class=\"btn btn-xs btn-success\" ng-click=\"vm.edit(item)\">Moderar</button></td></tr></tbody></table></div></div></div></div></div></div>");
$templateCache.put("view/moderacao/video/index.html","<div ui-view=\"\"></div>");
$templateCache.put("view/operacao/caixa/form.html","<style>\n  .table {\n    border: 1px solid white;\n  }\n\n  .table td {\n    border: 1px solid black;\n    /*width: 33%;*/\n    padding-left: 5px;\n  }\n\n  .table > thead > tr > th,\n  .table > tbody > tr > th,\n  .table > tfoot > tr > th,\n  .table > thead > tr > td,\n  .table > tbody > tr > td,\n  .table > tfoot > tr > td {\n    border: 1px solid white;\n  }\n\n  .form-group-sm select.form-control {\n    border-radius: 0px;\n  }\n\n  .btn-default {\n    color: inherit;\n    background: white;\n    /*border: 1px solid #e7eaec;*/\n    border: 1px solid grey;\n  }\n\n\n  .svg-container {\n    width: 100%;\n    background-color: #eee;\n    border: 1px solid #cacaca;\n    padding: 5px;\n  }\n\n</style><div class=\"wrapper wrapper-content animated fadeInDown\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><div class=\"row\"><table class=\"table\"><tr><td><label>Situação:</label></td><td style=\"font-weight: 600\" ng-style=\"{\'color\' : vm.item.IdEstabelecimentoFechamentoDia ? \'red\' : \'green\' }\">{{vm.item.IdEstabelecimentoFechamentoDia == null ? \'Aberto\': \'Fechado\'}}</td><td><label>Data Contábil:</label></td><td>{{vm.item.DataContabil | date: \'dd/MM/yyyy\'}}</td></tr><tr><td><label>Estabelecimento:</label></td><td>{{vm.item.Estabelecimento}}</td><td><label>IdEstabelecimento:</label></td><td>{{vm.item.IdEstabelecimento}}</td></tr><tr><td><label>Caixa:</label></td><td style=\"font-weight: 600\" ng-style=\"{\'color\' : vm.item.Caixa === \'SITE\' ? \'#F17709\' : \'#0085A6\' }\">{{vm.item.Caixa}}</td><td><label>IdCaixa:</label></td><td>{{vm.item.IdCaixa}}</td></tr><tr><td><label>DataHoraAbertura:</label></td><td>{{vm.item.DataHoraAbertura | date: \'dd/MM/yyyy HH:mm\'}}</td><td><label>DataHoraFechamento:</label></td><td>{{vm.item.DataHoraFechamento ? (vm.item.DataHoraFechamento | date: \'dd/MM/yyyy HH:mm\') : \'-\'}}</td></tr><tr><td><label>DataHoraFechamentoDia:</label></td><td>{{vm.item.DataHoraFechamentoDia ? (vm.item.DataHoraFechamentoDia | date: \'dd/MM/yyyy HH:mm\') : \'-\'}}</td><td><label>IdEstabelecimentoFechamentoDia:</label></td><td>{{vm.item.IdEstabelecimentoFechamentoDia ? vm.item.IdEstabelecimentoFechamentoDia : \'-\'}}</td></tr></table></div><div class=\"row\"><div class=\"form-group\"><p><button class=\"btn btn-w-m btn-success pull-right col-offset-m1\" type=\"button\" ng-click=\"vm.cancel();\">VOLTAR</button></p></div></div></div></div></div>");
$templateCache.put("view/operacao/caixa/grid.html","<div class=\"wrapper wrapper-content animated fadeInDown\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><form name=\"frm\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6\"><ng-field ng-enter=\"vm.search()\" label=\"Estabelecimento\" type=\"select\" model=\"vm.Filter.IdEstabelecimento\" options=\"vm.estabelecimentoList\" value-field=\"Id\" text-field=\"Nome\"></ng-field></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-3\"><ng-field ng-enter=\"vm.search()\" label=\"Caixa\" type=\"select\" model=\"vm.Filter.Caixa\" options=\"vm.caixaList\" value-field=\"Nome\" text-field=\"Nome\"></ng-field></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-3\"><ng-field ng-enter=\"vm.search()\" label=\"Situação\" type=\"select\" model=\"vm.Filter.Situacao\" options=\"vm.situacaoList\" value-field=\"Nome\" text-field=\"Nome\"></ng-field></div><div class=\"col-md-12\"><h4>Período Data Abertura</h4></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-3\"><ng-field name=\"Nome\" ng-enter=\"vm.search()\" label=\"\" model=\"vm.Filter.DataAberturaInicio\" type=\"date\"></ng-field></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-3\"><ng-field name=\"Nome\" ng-enter=\"vm.search()\" label=\"\" model=\"vm.Filter.DataAberturaFim\" type=\"date\"></ng-field></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6\"><button ng-disabled=\"frm.$invalid || vm.searching\" type=\"button\" class=\"btn btn-w-m btn-success pull-right col-offset-m1\" ng-click=\"vm.search()\"><i class=\"fa\" ng-class=\"{\'fa fa-spinner fa-spin\' : vm.searching}\"></i> FILTRAR</button></div></div></form></div><br><div class=\"ibox-content\"><div class=\"table-responsive constrained\" ts-wrapper=\"\" ts-no-data-text=\"Utilize o filtro para filtrar os caixas\"><table class=\"table table-hover table-striped\" data-sorting=\"true\" role=\"grid\" infinite-scroll=\"vm.search(true)\" infinite-scroll-disabled=\"vm.complete || vm.searching\" infinite-scroll-immediate-check=\"false\" infinite-scroll-distance=\"0\"><thead><tr role=\"row\"><th ts-criteria=\"Estabelecimento\">Estabelecimento</th><th ts-criteria=\"Caixa\">Caixa</th><th ts-criteria=\"DataContabil\" ts-default=\"descending\">Data Contábil</th><th ts-criteria=\"DataHoraAbertura\">DataHoraAbertura</th><th ts-criteria=\"DataHoraFechamento\">DataHoraFechamento</th><th ts-criteria=\"DataHoraFechamento\">Situação</th><th ts-criteria=\"IdEstabelecimentoFechamentoDia\">Dia</th><th class=\"text-right\">Ações</th></tr></thead><tbody><tr ng-repeat=\"item in vm.items\" ng-class=\"{\'success\' : itm.updated}\" ts-repeat=\"\"><td class=\"project-title\"><span>{{item.Estabelecimento}}</span></td><td class=\"project-title\"><span style=\"font-weight: 600\" ng-style=\"{\'color\' : item.Caixa === \'SITE\' ? \'#0085A6\' : \'#F17709\' }\">{{item.Caixa}}</span></td><td class=\"project-title\"><span>{{item.DataContabil | date: \'dd/MM/yyyy\'}}</span></td><td class=\"project-title\"><span>{{item.DataHoraAbertura | date: \'dd/MM/yyyy HH:mm\'}}</span></td><td class=\"project-title\"><span>{{item.DataHoraFechamento ? (item.DataHoraFechamento | date: \'dd/MM/yyyy HH:mm\') : \'-\'}}</span></td><td class=\"project-title\"><span style=\"font-weight: 600\" ng-style=\"{\'color\' : item.DataHoraFechamento ? \'red\' : \'green\' }\">{{item.DataHoraFechamento == null? \'Aberto\': \'Fechado\'}}</span></td><td class=\"project-title\"><span style=\"font-weight: 600\" ng-style=\"{\'color\' : item.IdEstabelecimentoFechamentoDia ? \'red\' : \'green\' }\">{{item.IdEstabelecimentoFechamentoDia == null? \'Aberto\': \'Fechado\'}}</span></td><td class=\"project-actions\"><span uib-dropdown=\"\" on-toggle=\"toggled(open)\"><a role=\"button\" uib-dropdown-toggle=\"\"><i class=\"fa fa-wrench\"></i></a><ul class=\"pull-right\" uib-dropdown-menu=\"\" aria-labelledby=\"simple-dropdown\"><li><a role=\"button\" ng-click=\"vm.detalhe(item);\"><i class=\"fa fa-edit\"></i> Detalhe</a></li></ul></span></td></tr></tbody></table><div class=\"row\"><div class=\"col-md-6 col-md-offset-5\" ng-show=\"vm.searching\"><i class=\"fa fa-spinner fa-pulse fa-1x fa-fw\"></i> Carregando...</div></div></div></div></div></div></div></div>");
$templateCache.put("view/operacao/caixa/index.html","<div ui-view=\"\"></div>");
$templateCache.put("view/operacao/usuario/form.html","<style>\n  .table {\n    border: 1px solid white;\n  }\n\n  .table td {\n    border: 1px solid black;\n    /*width: 33%;*/\n    padding-left: 5px;\n  }\n\n  .table > thead > tr > th,\n  .table > tbody > tr > th,\n  .table > tfoot > tr > th,\n  .table > thead > tr > td,\n  .table > tbody > tr > td,\n  .table > tfoot > tr > td {\n    border: 1px solid white;\n  }\n\n  .table > thead > tr > th,\n  .table > tbody > tr > th,\n  .table > tfoot > tr > th,\n  .table > thead > tr > td,\n  .table > tbody > tr > td,\n  .table > tfoot > tr > td {\n    border-top: 1px solid white;\n    line-height: 1.42857;\n    padding: 5px;\n    padding-left: 10px;\n    vertical-align: top;\n  }\n\n  .form-group-sm select.form-control {\n    border-radius: 0px;\n  }\n\n  .btn-default {\n    color: inherit;\n    background: white;\n    /*border: 1px solid #e7eaec;*/\n    border: 1px solid grey;\n  }\n\n\n  .svg-container {\n    width: 100%;\n    background-color: #eee;\n    border: 1px solid #cacaca;\n    padding: 5px;\n  }\n\n</style><div class=\"wrapper wrapper-content animated fadeInDown\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h4>Detalhes do Cliente</h4></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-lg-3\"><div class=\"col-lg-4\"><label for=\"\">Cliente:</label></div><div class=\"col-lg-6\">{{vm.Cliente.Nome}} {{vm.Cliente.SobreNome}}</div></div><div class=\"col-lg-3\"><div class=\"col-lg-4\"><label for=\"\">E-mail:</label></div><div class=\"col-lg-6\">{{vm.Cliente.Email}}</div></div><div class=\"col-lg-3\"><div class=\"col-lg-4\"><label for=\"\">Sexo:</label></div><div class=\"col-lg-6\">{{vm.Cliente.Sexo}}</div></div><div class=\"col-lg-3\"><div class=\"col-lg-4\"><label for=\"\">CPF:</label></div><div class=\"col-lg-6\">{{vm.Cliente.Cpf}}</div></div></div><div class=\"row m-t-md\"><div class=\"col-lg-3\"><div class=\"col-lg-4\"><label for=\"\">Telefone:</label></div><div class=\"col-lg-6\">{{vm.Cliente.Tels}}</div></div><div class=\"col-lg-3\"><div class=\"col-lg-4\"><label for=\"\">Estado:</label></div><div class=\"col-lg-6\">{{vm.Cliente.Uf}}</div></div><div class=\"col-lg-3\"><div class=\"col-lg-4\"><label for=\"\">Cidade:</label></div><div class=\"col-lg-6\">{{vm.Cliente.Cidade}}</div></div><div class=\"col-lg-3\"><div class=\"col-lg-4\"><label for=\"\">Bairro:</label></div><div class=\"col-lg-6\">{{vm.Cliente.Bairro}}</div></div></div><div class=\"row m-t-md\"><div class=\"col-lg-3\"><div class=\"col-lg-4\"><label for=\"\">Provedor:</label></div><div class=\"col-lg-6\">{{vm.Cliente.Provedor}}</div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h4>Ultimas compras</h4></div><div class=\"ibox-content\"><div class=\"alert alert-warning alert-dismissible\" role=\"alert\" ng-if=\"vm.items.length == 0\"><strong>Nenhuma venda para esse cliente.</strong></div><div class=\"table-responsive constrained\" ts-wrapper=\"\" ts-no-data-text=\"\" ng-if=\"vm.items.length > 0\"><table class=\"table table-hover table-striped\" data-sorting=\"true\" role=\"grid\" infinite-scroll=\"vm.search(true)\" infinite-scroll-disabled=\"vm.complete || vm.searching\" infinite-scroll-immediate-check=\"false\" infinite-scroll-distance=\"0\"><thead><tr role=\"row\"><th ts-criteria=\"Estabelecimento\">Estabelecimento</th><th width=\"100\" ts-criteria=\"IdTipoStatusPagamento\">Status</th><th ts-criteria=\"Atracao\">Atração</th><th>Assentos</th><th>Quantidade</th><th ts-criteria=\"DataHoraInicio\">Data Sessão</th><th ts-criteria=\"DataVenda\" ts-default=\"descending\">Data Venda</th><th ts-criteria=\"NumeroCartao\">Cartão</th><th ts-criteria=\"DataContabil\">Data Contábil</th></tr></thead><tbody><tr ng-repeat=\"item in vm.items\" role=\"row\" ng-class=\"{\'success\' : itm.updated}\" ts-repeat=\"\"><td class=\"project-title\"><span>{{item.NomeEstabelecimento}}</span></td><td ng-if=\"!item.FilaFraude\" ng-switch=\"item.IdTipoStatusPagamento\"><text style=\"color: green; font-weight: 600\" ng-switch-when=\"1\">Aprovada</text><text style=\"color: orange; font-weight: 600\" ng-switch-when=\"2\">Cancelada</text><text style=\"color: red; font-weight: 600\" ng-switch-when=\"3\">Reprovada</text><text style=\"color: darkgrey; font-weight: 600\" ng-switch-when=\"4\">Em análise</text><text style=\"color: orange; font-weight: 600\" ng-switch-when=\"5\">Devolvido</text></td><td ng-if=\"item.FilaFraude\"><text style=\"color: orange; font-weight: 600\">Em análise</text></td><td class=\"project-title\"><span>{{item.Atracao}}</span></td><td class=\"project-title\"><span>{{item.Assentos}}</span></td><td class=\"project-title\"><span>{{item.Qtd}}</span></td><td class=\"project-title\"><span>{{item.DataHoraInicio | date: \'dd/MM/yyyy HH:mm\'}}</span></td><td class=\"project-title\"><span>{{item.DataVenda | date: \'dd/MM/yyyy HH:mm\'}}</span></td><td class=\"project-title\"><span>{{item.NumeroCartao}}</span></td><td class=\"project-title\"><span>{{item.DataContabil | date: \'dd/MM/yyyy\'}}</span></td></tr></tbody></table><div class=\"row\"><div class=\"col-md-6 col-md-offset-5\" ng-show=\"vm.searching\"><i class=\"fa fa-spinner fa-pulse fa-1x fa-fw\"></i> Carregando...</div></div></div></div></div><button class=\"btn btn-success pull-right\" type=\"button\" ng-click=\"vm.back();\">VOLTAR</button></div></div></div>");
$templateCache.put("view/operacao/usuario/grid.html","<div class=\"wrapper wrapper-content animated fadeInDown\"><div class=\"row\"><div class=\"col-lg-12\"><form name=\"frm\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><div class=\"row\"><button type=\"button\" class=\"btn btn-w-m btn-success pull-right\" ng-click=\"vm.search()\" ng-disabled=\"vm.searching\"><i class=\"fa\" ng-class=\"{\'fa fa-spinner fa-spin\' : vm.searching}\"></i> FILTRAR</button><div class=\"col-xs-7 col-sm-8 col-md-9 col-lg-3\"><ng-field ng-enter=\"vm.search()\" name=\"Nome\" label=\"Nome\" model=\"vm.Filter.Nome\" type=\"text\"></ng-field></div><div class=\"col-xs-7 col-sm-8 col-md-9 col-lg-3\"><ng-field ng-enter=\"vm.search()\" name=\"Email\" label=\"Email\" model=\"vm.Filter.Login\" type=\"text\"></ng-field></div><div class=\"col-xs-7 col-sm-8 col-md-9 col-lg-3\"><ng-field ng-enter=\"vm.search()\" name=\"CPF\" label=\"CPF\" model=\"vm.Filter.CPF\" type=\"number\"></ng-field></div></div></div><br><div class=\"ibox-content\"><div class=\"table-responsive constrained\" ts-wrapper=\"\" ts-no-data-text=\"Utilize o filtro para filtrar os usuários\"><table class=\"table table-hover table-striped\" data-sorting=\"true\" role=\"grid\" infinite-scroll=\"vm.search(true)\" infinite-scroll-disabled=\"vm.complete || vm.searching\" infinite-scroll-immediate-check=\"false\" infinite-scroll-distance=\"0\"><thead><tr><th ts-criteria=\"Nome\">Nome</th><th>Telefone</th><th ts-criteria=\"Login\">Login</th><th>CPF</th><th>Idade</th><th>Ativo</th><th ts-criteria=\"Provedor\">Origem</th><th ts-criteria=\"DataCadastro\" ts-default=\"descending\">Cadastro</th></tr></thead><tbody><tr ng-repeat=\"item in vm.items\" ng-class=\"{\'success\' : itm.updated}\" ts-repeat=\"\"><td>{{item.Nome}}</td><td>{{item.Telefone}}</td><td>{{item.Login}}</td><td>{{item.CPF}}</td><td>{{item.Idade}}</td><td>{{item.Provedor == \'Site\' ? item.EmailValidado == true ? \'Sim\' : \'Não\' : \'-\'}}</td><td style=\"font-weight: 600\" ng-style=\"{\'color\': item.Provedor == \'Facebook\' ? \'#3B5998\' : item.Provedor == \'Google\' ? \'#dd4b39\' : \'#F17921\'}\">{{item.Provedor}}</td><td class=\"project-title\"><span>{{item.DataCadastro | date: \'dd/MM/yyyy HH:mm\' : \'UTC\'}}</span></td><td class=\"project-actions\"><span uib-dropdown=\"\" on-toggle=\"toggled(open)\"><a role=\"button\" uib-dropdown-toggle=\"\"><i class=\"fa fa-wrench\"></i></a><ul class=\"pull-right\" uib-dropdown-menu=\"\" aria-labelledby=\"simple-dropdown\"><li><a ng-if=\"item.Provedor == \'Site\' && item.EmailValidado == false\" role=\"button\" ng-click=\"vm.validar(item);\"><i class=\"fa fa-edit\"></i> Validar</a> <a ng-if=\"item.Provedor == \'Site\' && item.EmailValidado == true\" role=\"button\" style=\"color: darkgrey\"><i class=\"fa fa-edit\" style=\"color: darkgrey\"></i> Validado</a> <a ng-if=\"item.Provedor != \'Site\'\" role=\"button\" style=\"color: darkgrey\"><i class=\"fa fa-edit\" style=\"color: darkgrey\"></i> Validar</a></li><li><a role=\"button\" ng-click=\"vm.detalhes(item);\"><i class=\"fa fa-edit\"></i>Detalhes</a></li></ul></span></td></tr></tbody></table><div class=\"row\"><div class=\"col-md-6 col-md-offset-5\" ng-show=\"vm.searching\"><i class=\"fa fa-spinner fa-pulse fa-1x fa-fw\"></i> Carregando...</div></div></div></div></div></form></div></div></div>");
$templateCache.put("view/operacao/usuario/index.html","<div ui-view=\"\"></div>");
$templateCache.put("view/reports/bordero/form.html","<div class=\"wrapper wrapper-content animated fadeInRight\"><div class=\"row\"><form name=\"frm\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-md-12\"><i class=\"fa\" style=\"margin: 0 auto\" ng-class=\"{\'fa fa-spinner fa-pulse fa-3x fa-fw\' : vm.loading}\"></i><iframe ng-src=\"{{vm.pdfUrl}}\" ng-style=\"vm.style\" ng-show=\"!vm.loading\"></iframe></div><div class=\"col m-t pull-right\"><div class=\"col-md-12\"><button class=\"btn btn-default btn-md\" ng-click=\"vm.voltar()\">Voltar</button> <a class=\"btn btn-success btn-md\" href=\"{{vm.pdfUrl}}\" ng-disabled=\"vm.loading\" download=\"\">Download</a></div></div></div></div></div></div></form></div></div>");
$templateCache.put("view/reports/bordero/grid.html","<div class=\"wrapper wrapper-content animated fadeInDown\"><div class=\"row\"><div class=\"col-lg-12\"><form name=\"frm\" class=\"ibox float-e-margins\"><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-lg-2\"><ng-field ng-enter=\"vm.search()\" name=\"Nome\" label=\"Data\" model=\"vm.Filter.Data\" type=\"date\"></ng-field></div><div class=\"col-lg-4\"><ng-field ng-enter=\"vm.search()\" label=\"Estabelecimento\" type=\"select\" model=\"vm.Filter.IdEstabelecimento\" options=\"vm.lstEstabelecimento\" value-field=\"Id\" text-field=\"Nome\" required=\"true\"></ng-field></div></div><button type=\"button\" class=\"btn btn-w-m btn-success pull-right col-offset-m1\" ng-disabled=\"frm.$invalid\" ng-click=\"vm.search()\"><i class=\"fa\" ng-class=\"{\'fa fa-spinner fa-spin\' : vm.searching}\"></i> FILTRAR</button><div class=\"col\"><div class=\"input-group col-xs-7 col-sm-8 col-md-9 col-lg-10\"><div class=\"input-group-addon\"><i class=\"fa fa-search\"></i></div><input type=\"search\" ng-enter=\"vm.search()\" ng-model=\"vm.Filter.Nome\" class=\"form-control\" placeholder=\"Filtrar pelo nome da atração\" aria-controls=\"DataTables_Table_0\"></div></div></div><br><div class=\"ibox-content\"><table infinite-scroll=\"vm.search(true)\" infinite-scroll-disabled=\"vm.complete || vm.searching\" infinite-scroll-immediate-check=\"false\" infinite-scroll-distance=\"0\" class=\"table table-striped table-hover\" role=\"grid\" data-sorting=\"true\"><thead><tr role=\"row\"><th class=\"sorting\" tabindex=\"0\" aria-controls=\"DataTables_Table_0\" rowspan=\"1\" colspan=\"1\" style=\"width: 310px;\">Atração</th><th class=\"sorting\" tabindex=\"0\" aria-controls=\"DataTables_Table_0\" rowspan=\"1\" colspan=\"1\" style=\"width: 310px;\">Data</th><th class=\"sorting\" tabindex=\"0\" aria-controls=\"DataTables_Table_0\" rowspan=\"2\" colspan=\"0\" style=\"width: 5px;\">Ações</th></tr></thead><tbody><tr class=\"gradeA odd\" role=\"row\" ng-repeat=\"item in vm.items\"><td class=\"project-title\"><span>{{item.Atracao}}</span></td><td class=\"project-title\"><span>{{item.DataHoraInicio | date : \'dd/MM/yyyy HH:mm\' }}</span></td><td class=\"project-actions\"><a role=\"button\" ng-click=\"vm.exibir(item);\" ng-if=\"item.HasBordero\"><i class=\"fa fa-clipboard\"></i> Visualizar</a> <a role=\"button\" ng-click=\"vm.edit(item);\" ng-if=\"!item.HasBordero\"><i class=\"fa fa-clipboard\"></i> Gerar</a></td></tr></tbody></table><div class=\"row\"><div class=\"col-md-6 col-md-offset-5\" ng-show=\"vm.searching\"><i class=\"fa fa-spinner fa-pulse fa-1x fa-fw\"></i> Carregando...</div></div></div></form></div></div></div>");
$templateCache.put("view/reports/bordero/index.html","<div ui-view=\"\"></div>");
$templateCache.put("view/reports/financeiro/form.html","<div class=\"wrapper wrapper-content animated fadeInRight\"><div class=\"row\"><form name=\"frm\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-md-12\"><i class=\"fa\" style=\"margin: 0 auto\" ng-class=\"{\'fa fa-spinner fa-pulse fa-3x fa-fw\' : vm.loading}\"></i><iframe ng-src=\"{{vm.pdfUrl}}\" ng-style=\"vm.style\" ng-show=\"!vm.loading\"></iframe></div><div class=\"row m-t pull-right\"><div class=\"col-md-12\"><button class=\"btn btn-default btn-md\" ng-click=\"vm.voltar()\">Voltar</button> <a ng-disabled=\"vm.loading\" class=\"btn btn-success btn-md\" href=\"{{vm.pdfUrl}}\" download=\"\">Download</a></div></div></div></div></div></div></form></div></div>");
$templateCache.put("view/reports/financeiro/grid.html","<div class=\"wrapper wrapper-content animated fadeInDown\"><div class=\"row\"><div class=\"col-lg-12\"><form name=\"frm\" class=\"ibox float-e-margins\"><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-lg-2\"><ng-field name=\"DataInicio\" label=\"Data\" model=\"vm.Filter.DataInicio\" type=\"date\" required=\"true\"></ng-field></div><div class=\"col-lg-2\"><ng-field name=\"DataFim\" label=\"Data\" model=\"vm.Filter.DataFim\" type=\"date\" required=\"true\"></ng-field></div><div class=\"col-lg-3\"><ng-field label=\"Estabelecimento\" type=\"select\" model=\"vm.Filter.IdEstabelecimento\" options=\"vm.lstEstabelecimento\" value-field=\"Id\" text-field=\"Nome\" required=\"true\"></ng-field></div><div class=\"col-lg-3\"><ng-field label=\"Atração\" type=\"select\" model=\"vm.Filter.IdAtracao\" options=\"vm.lstAtracao\" value-field=\"IdAtracao\" text-field=\"Nome\" ng-disabled=\"!vm.Filter.IdEstabelecimento || vm.lstAtracao.length == 0\"></ng-field></div><div class=\"col-lg-2\" style=\"margin-top: 25px;\"><button type=\"button\" class=\"btn btn-w-m btn-success pull-right col-offset-m1\" ng-disabled=\"vm.gerar || frm.$invalid\" ng-click=\"vm.Gerar()\"><i class=\"fa\" ng-class=\"{\'fa fa-spinner fa-pulse fa-fw\' : vm.gerar}\"></i> Gerar</button></div></div></div></form></div></div></div>");
$templateCache.put("view/reports/financeiro/index.html","<div ui-view=\"\"></div>");
$templateCache.put("view/reports/futuras/form.html","<div class=\"wrapper wrapper-content animated fadeInRight\"><div class=\"row\"><form name=\"frm\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-md-12\"><i class=\"fa\" style=\"margin: 0 auto\" ng-class=\"{\'fa fa-spinner fa-pulse fa-3x fa-fw\' : vm.loading}\"></i><iframe ng-src=\"{{vm.pdfUrl}}\" ng-style=\"vm.style\" \"=\"\" ng-show=\"!vm.loading\"></iframe></div><div class=\"row m-t pull-right\"><div class=\"col-md-12\"><button class=\"btn btn-default btn-md\" ng-click=\"vm.voltar()\">Voltar</button> <a ng-disabled=\"vm.loading\" class=\"btn btn-success btn-md\" href=\"{{vm.pdfUrl}}\" download=\"\">Download</a></div></div></div></div></div></div></form></div></div>");
$templateCache.put("view/reports/futuras/grid.html","<div class=\"wrapper wrapper-content animated fadeInDown\"><div class=\"row\"><div class=\"col-lg-12\"><form name=\"frm\" class=\"ibox float-e-margins\"><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-lg-2\"><ng-field name=\"DataFim\" label=\"Data\" model=\"vm.Filter.Data\" type=\"date\" required=\"true\"></ng-field></div><div class=\"col-lg-6\"><ng-field label=\"Atração\" type=\"select\" model=\"vm.Filter.IdAtracao\" options=\"vm.lstAtracao\" value-field=\"IdAtracao\" text-field=\"Nome\" ng-disabled=\"vm.disabled\"></ng-field></div><div class=\"col-lg-2\" style=\"margin-top: 25px;\"><button type=\"button\" class=\"btn btn-w-m btn-success pull-right col-offset-m1\" ng-disabled=\"vm.gerar || frm.$invalid\" ng-click=\"vm.Gerar()\"><i class=\"fa\" ng-class=\"{\'fa fa-spinner fa-pulse fa-fw\' : vm.gerar}\"></i> Gerar</button></div></div></div></form></div></div></div>");
$templateCache.put("view/reports/futuras/index.html","<div ui-view=\"\"></div>");
$templateCache.put("view/reports/futuras-dia/form.html","<div class=\"wrapper wrapper-content animated fadeInRight\"><div class=\"row\"><form name=\"frm\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-md-12\"><i class=\"fa\" style=\"margin: 0 auto\" ng-class=\"{\'fa fa-spinner fa-pulse fa-3x fa-fw\' : vm.loading}\"></i><iframe ng-src=\"{{vm.pdfUrl}}\" ng-style=\"vm.style\" ng-show=\"!vm.loading\"></iframe></div><div class=\"row m-t pull-right\"><div class=\"col-md-12\"><button class=\"btn btn-default btn-md\" ng-click=\"vm.voltar()\">Voltar</button> <a ng-disabled=\"vm.loading\" class=\"btn btn-success btn-md\" href=\"{{vm.pdfUrl}}\" download=\"\">Download</a></div></div></div></div></div></div></form></div></div>");
$templateCache.put("view/reports/futuras-dia/grid.html","<div class=\"wrapper wrapper-content animated fadeInDown\"><div class=\"row\"><div class=\"col-lg-12\"><form name=\"frm\" class=\"ibox float-e-margins\"><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-md-4\"><ng-field label=\"Estabelecimento\" type=\"select\" model=\"vm.Filter.IdEstabelecimento\" options=\"vm.lstEstabelecimento\" value-field=\"Id\" text-field=\"Nome\" required=\"true\"></ng-field><div class=\"\" ng-if=\"vm.loading\"><i class=\"fa fa-spinner fa-pulse fa-fw\"></i></div></div><div class=\"col-md-3\"><ng-field name=\"DataInicio\" label=\"Data\" model=\"vm.Filter.Data\" type=\"date\" required=\"true\" ng-disabled=\"!vm.Filter.IdEstabelecimento\"></ng-field></div><div class=\"col-md-4\"><ng-field label=\"Atração\" type=\"select\" model=\"vm.Filter.IdAtracao\" options=\"vm.lstAtracao\" value-field=\"IdAtracao\" text-field=\"Nome\" ng-disabled=\"!vm.Filter.IdEstabelecimento || !vm.Filter.Data || vm.lstAtracao.length == 0\" \"=\"\"></ng-field></div><div class=\"col-lg-1 m-t-lg\" ng-if=\"vm.loading\"><i class=\"fa fa-spinner fa-pulse fa-fw\"></i></div></div><div class=\"row\"><div class=\"col-md-6 m-b\"><input type=\"radio\" icheck=\"\" ng-model=\"vm.Filter.DoDia\" name=\"futuras\" ng-value=\"true\" required=\"\"> Somente no dia &nbsp; <input type=\"radio\" icheck=\"\" ng-model=\"vm.Filter.DoDia\" name=\"futuras\" ng-value=\"false\"> Somente na semana</div><div class=\"col-md-6\"><button type=\"button\" class=\"btn btn-w-m btn-success pull-right col-offset-m1\" ng-disabled=\"vm.gerar || frm.$invalid\" ng-click=\"vm.Gerar()\"><i class=\"fa\" ng-class=\"{\'fa fa-spinner fa-pulse fa-fw\' : vm.gerar}\"></i> Gerar</button></div></div></div></form></div></div></div>");
$templateCache.put("view/reports/futuras-dia/index.html","<div ui-view=\"\"></div>");
$templateCache.put("view/reports/previa/form.html","<div class=\"wrapper wrapper-content animated fadeInRight\"><div class=\"row\"><form name=\"frm\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-md-12\"><i class=\"fa\" style=\"margin: 0 auto\" ng-class=\"{\'fa fa-spinner fa-pulse fa-3x fa-fw\' : vm.loading}\"></i><iframe class=\"iframe-responsivo\" ng-style=\"vm.style\" ng-src=\"{{vm.pdfUrl}}\" ng-show=\"!vm.loading\"></iframe></div><div class=\"row\"><div class=\"col pull-right\"><button class=\"btn btn-default btn-md\" ng-click=\"vm.voltar()\">Voltar</button> <a style=\"margin-right: 20px;\" ng-disabled=\"vm.loading\" class=\"btn btn-success btn-md\" href=\"{{vm.pdfUrl}}\" download=\"\">Download</a></div></div></div></div></div></div></form></div></div>");
$templateCache.put("view/reports/previa/grid.html","<div class=\"wrapper wrapper-content animated fadeInDown\"><div class=\"row\"><div class=\"col-lg-12\"><form name=\"frm\" class=\"ibox float-e-margins\"><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-lg-2\"><ng-field ng-enter=\"vm.search()\" name=\"Nome\" label=\"Data\" model=\"vm.Filter.Data\" type=\"date\"></ng-field></div><div class=\"col-lg-4\"><ng-field ng-enter=\"vm.search()\" label=\"Estabelecimento\" type=\"select\" model=\"vm.Filter.IdEstabelecimento\" options=\"vm.lstEstabelecimento\" value-field=\"Id\" text-field=\"Nome\" required=\"true\"></ng-field></div></div><button type=\"button\" class=\"btn btn-w-m btn-success pull-right col-offset-m1\" ng-disabled=\"vm.searching || frm.$invalid\" ng-click=\"vm.search()\"><i class=\"fa\" ng-class=\"{\'fa fa-spinner fa-spin\' : vm.searching}\"></i> FILTRAR</button><div class=\"col\"><div class=\"input-group col-xs-7 col-sm-8 col-md-9 col-lg-10\"><div class=\"input-group-addon\"><i class=\"fa fa-search\"></i></div><input type=\"search\" ng-enter=\"vm.search()\" ng-model=\"vm.Filter.Nome\" class=\"form-control\" placeholder=\"Filtrar pelo nome da atração\" aria-controls=\"DataTables_Table_0\"></div></div></div><br><div class=\"ibox-content\"><table infinite-scroll=\"vm.search(true)\" infinite-scroll-disabled=\"vm.complete || vm.searching\" infinite-scroll-immediate-check=\"false\" infinite-scroll-distance=\"0\" class=\"table table-striped table-hover\" role=\"grid\" data-sorting=\"true\"><thead><tr role=\"row\"><th class=\"sorting\" tabindex=\"0\" aria-controls=\"DataTables_Table_0\" rowspan=\"1\" colspan=\"1\" style=\"width: 310px;\">Atração</th><th class=\"sorting\" tabindex=\"0\" aria-controls=\"DataTables_Table_0\" rowspan=\"1\" colspan=\"1\" style=\"width: 310px;\">Estabelecimento</th><th class=\"sorting\" tabindex=\"0\" aria-controls=\"DataTables_Table_0\" rowspan=\"1\" colspan=\"1\" style=\"width: 310px;\">Data</th><th class=\"sorting\" tabindex=\"0\" aria-controls=\"DataTables_Table_0\" rowspan=\"2\" colspan=\"0\" style=\"width: 5px;\">Ações</th></tr></thead><tbody><tr class=\"gradeA odd\" role=\"row\" ng-repeat=\"item in vm.items\"><td class=\"project-title\"><span>{{item.Atracao}}</span></td><td class=\"project-title\"><span>{{item.NomeEstabelecimento}}</span></td><td class=\"project-title\"><span>{{item.DataHoraInicio | date : \'dd/MM/yyyy HH:mm\' }}</span></td><td class=\"project-actions\"><a role=\"button\" ng-click=\"vm.edit(item);\"><i class=\"fa fa-clipboard\"></i> Visualizar</a></td></tr></tbody></table><div class=\"row\"><div class=\"col-md-6 col-md-offset-5\" ng-show=\"vm.searching\"><i class=\"fa fa-spinner fa-pulse fa-1x fa-fw\"></i> Carregando...</div></div></div></form></div></div></div>");
$templateCache.put("view/reports/previa/index.html","<div ui-view=\"\"></div>");
$templateCache.put("view/site/home/index.html","<div class=\"wrapper wrapper-content animated fadeInDown\"><div class=\"row\"><div class=\"col-lg-12\">pagina inicial</div></div></div>");
$templateCache.put("view/financeiro/repasse/form-relatorio.html","<div class=\"wrapper wrapper-content animated fadeInRight\"><div class=\"row\"><form name=\"frm\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-md-12\"><i class=\"fa\" style=\"margin: 0 auto\" ng-class=\"{\'fa fa-spinner fa-pulse fa-3x fa-fw\' : vm.loading}\"></i><iframe class=\"iframe-responsivo\" ng-style=\"vm.style\" ng-src=\"{{vm.pdfUrl}}\" ng-show=\"!vm.loading\"></iframe></div><div class=\"row\"><div class=\"col pull-right\"><button class=\"btn btn-default btn-md\" ng-click=\"vm.voltar()\">Voltar</button> <a style=\"margin-right: 20px;\" ng-disabled=\"vm.loading\" class=\"btn btn-success btn-md\" href=\"{{vm.pdfUrl}}\" download=\"\">Download</a></div></div></div></div></div></div></form></div></div>");
$templateCache.put("view/financeiro/repasse/form.html","<div class=\"wrapper wrapper-content animated fadeInDown\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><form name=\"frm\"><div class=\"row\"><div class=\"col-xs-11 col-md-6\"><ng-field name=\"Nome\" label=\"Nome da cidade\" model=\"vm.item.Nome\" type=\"text\" required=\"true\" maxlength=\"50\"></ng-field></div><div class=\"col-xs-11 col-md-6\"><ng-field label=\"UF\" required=\"true\" type=\"select\" model=\"vm.item.UF\" options=\"vm.ufList\" value-field=\"Id\" text-field=\"Nome\"></ng-field></div></div></form><div class=\"row\"><div class=\"form-group\"><div class=\"col-md-1 col-md-offset-10\"><button class=\"btn btn-outline pull-right\" type=\"button\" ng-click=\"vm.cancel();\">CANCELAR</button></div><div class=\"col-md-1\"><button class=\"btn btn-primary pull-right\" type=\"button\" ng-disabled=\"validateForm\" ng-click=\"vm.save();\">Atualizar</button></div></div></div></div></div></div>");
$templateCache.put("view/financeiro/repasse/grid.html","<div class=\"wrapper wrapper-content animated fadeInDown\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><button type=\"button\" class=\"btn btn-w-m btn-success pull-right col-offset-m1\" ng-click=\"vm.search()\" ng-disabled=\"vm.exec\">FILTRAR</button><div class=\"input-group col-xs-7 col-sm-8 col-md-9 col-lg-10\"><div class=\"input-group-addon\"><i class=\"fa fa-search\"></i></div><input type=\"search\" ng-model=\"vm.Filter.Nome\" class=\"form-control\" placeholder=\"Digite para filtrar os resultados\" aria-controls=\"DataTables_Table_0\"></div></div><br><div class=\"ibox-content\"><table class=\"table table-striped able-hover\" role=\"grid\"><thead><tr role=\"row\"><th>Nome</th><th>Ano</th><th>Mês</th><th>Referência</th><th>Data</th><th>Aprovado</th><th width=\"60\" class=\"text-right\">Ações</th></tr></thead><tbody><tr class=\"gradeA odd\" role=\"row\" ng-repeat=\"item in vm.items\"><td class=\"project-title\"><span>{{item.Nome}}</span></td><td class=\"project-title\"><span>{{item.ReferenciaAno}}</span></td><td class=\"project-title\"><span>{{item.ReferenciaMes}}</span></td><td class=\"project-title\"><span ng-if=\"item.IdPeriodicidadeRepasse == 1\">Semana {{item.ReferenciaParcial}}</span> <span ng-if=\"item.IdPeriodicidadeRepasse == 2\">Quinzena {{item.ReferenciaParcial}}</span> <span ng-if=\"item.IdPeriodicidadeRepasse == 3\">Mês {{item.ReferenciaParcial}}</span></td><td class=\"project-title\"><span>{{item.DataOperacao | date:\'yyyy-MM-dd\'}}</span></td><td><span ng-if=\"item.UsuarioAprovador\"><i class=\"fa fa-check\" aria-hidden=\"true\" style=\"color:#aebb39\"></i> ({{item.UsuarioAprovador}})</span></td><td class=\"project-actions\"><span uib-dropdown=\"\" on-toggle=\"toggled(open)\" ng-if=\"!item.searching\"><a role=\"button\" uib-dropdown-toggle=\"\" ng-show=\"!vm.exec\"><i class=\"fa fa-wrench\"></i></a> <a role=\"button\" ng-show=\"vm.exec\"><i class=\"fa fa-wrench\" style=\"color: lightgrey;\"></i></a><ul class=\"pull-right\" uib-dropdown-menu=\"\" aria-labelledby=\"simple-dropdown\"><li><a ng-if=\"!item.UsuarioAprovador\" role=\"button\" ng-click=\"vm.aprovar(item);\"><i class=\"fa fa-edit\"></i> Aprovar</a> <a role=\"button\" ng-click=\"vm.repasseResumo(item);\"><i class=\"fa fa-edit\"></i> Relatório</a></li></ul></span> <span ng-if=\"item.searching\"><i class=\"fa\" ng-class=\"{\'fa fa-spinner fa-pulse fa-2x fa-fw\' : item.searching}\"></i></span></td></tr></tbody></table></div></div></div></div></div>");
$templateCache.put("view/financeiro/repasse/index.html","<div ui-view=\"\"></div>");
$templateCache.put("view/conteudo/artista/template/crop_tmpl.html","<style>\n    .cropArea {\n        background: #E4E4E4;\n        overflow: hidden;\n        width: 100% !important;\n        height: 300px;\n    }\n</style><h1>{{vm.type}}</h1><h1>{{vm.resImgFormat}}</h1><div class=\"modal-header\"><h3 class=\"modal-title\">Cortar Imagem</h3></div><div class=\"modal-body\"><div class=\"cropArea medium\"><img-crop image=\"vm.imageDataURI\" result-image=\"vm.resImageDataURI\" change-on-fly=\"changeOnFly\" area-type=\"{{vm.type}}\" area-min-size=\"vm.selMinSize\" [result-image-format=\"{vm.resImgFormat}\" ]=\"\" result-image-quality=\"1.0\" result-image-size=\"vm.resImgSize\" on-change=\"vm.onChange($dataURI)\" on-load-begin=\"vm.onLoadBegin()\" on-load-done=\"vm.onLoadDone()\" on-load-error=\"vm.onLoadError()\"></img-crop></div></div><div class=\"modal-footer\"><button class=\"btn btn-warning\" type=\"button\" ng-click=\"vm.Cancel();\">Não</button> <button class=\"btn btn-primary\" type=\"button\" ng-click=\"vm.Confirm();\">Sim</button></div>");
$templateCache.put("view/conteudo/atracao/template/crop_tmpl.html","<style>\n  .cropArea {\n    background: #E4E4E4;\n    overflow: hidden;\n    width: 100% !important;\n    height: 300px;\n  }\n</style><div class=\"modal-header\"><h3 class=\"modal-title\">Cortar Imagem</h3></div><div class=\"modal-body\"><div class=\"cropArea medium\"><img-crop image=\"vm.imageDataURI\" result-image=\"vm.resImageDataURI\" area-type=\"{{vm.tipoImagem}}\" result-image-size=\"vm.resultImageSize\" [result-image-format=\"{vm.resImgFormat}\" ]=\"\" aspect-ratio=\"vm.ratio\" result-array-image=\"vm.resArrImagens\" chargement=\"\'Carregando...\'\"></img-crop></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-w-m btn-success pull-right\" ng-click=\"vm.Confirm();\" ng-disabled=\"vm.loadingCrop\"><i class=\"fa\" ng-class=\"{\'fa fa-spinner fa-spin\' : vm.loadingCrop}\"></i> CONFIRMAR</button> <button type=\"button\" class=\"btn btn-outline btn-link pull-right\" ng-click=\"vm.Cancel();\">CANCELAR</button></div>");
$templateCache.put("view/conteudo/atracao/template/ficha_tecnica_tmpl.html","<style>\n  .wizard > .content {\n    background: white !important;\n    background-color: red;\n  }\n\n\n</style><form><div ng-form=\"fichaTecnicaForm\"><div class=\"row\"><div class=\"row\"><div class=\"col-lg-6\"><ng-field name=\"Nome\" model=\"vm.Atracao.FichaTecnica.Nome\" label=\"Nome\" required=\"true\" ng-disabled=\"!vm.PodeEditar\" tooltip=\"Nome que será exibido nos pontos de venda.\" maxlength=\"150\"></ng-field></div><div class=\"col-lg-6\"><ng-field name=\"NomeOriginal\" model=\"vm.Atracao.FichaTecnica.NomeOriginal\" label=\"Nome Original\" ng-disabled=\"!vm.PodeEditar\" tooltip=\"Nome original da atração para controle interno.\" maxlength=\"150\"></ng-field></div></div><div class=\"row\"><div class=\"col-lg-12\"><ng-field name=\"UrlOficial\" model=\"vm.Atracao.FichaTecnica.UrlOficial\" label=\"URL Oficial\" maxlength=\"150\" tooltip=\"Site da peça.\"></ng-field></div></div><div class=\"row\"><div class=\"col-md-4\"><ng-field name=\"PaisOrigem\" model=\"vm.Atracao.FichaTecnica.PaisOrigem\" label=\"País de Origem\" maxlength=\"100\" tooltip=\"País onde a peça originalmente foi lançada e exibida pela primeira vez.\"></ng-field></div><div class=\"col-md-4\"><ng-field name=\"IdiomaOficial\" model=\"vm.Atracao.FichaTecnica.IdiomaOriginal\" label=\"Idioma original\" maxlength=\"50\" tooltip=\"Idioma de criação.\"></ng-field></div><div class=\"col-md-4\"><ng-field type=\"number\" name=\"AnoLancamento\" model=\"vm.Atracao.FichaTecnica.AnoLancamento\" label=\"Ano de lançamento\" maxlength=\"4\" tooltip=\"Ano que a peça fora lançada e registrada para fins de exibição.\"></ng-field></div></div><div class=\"row\"><div class=\"col-md-4\"><ng-field name=\"DataEstreia\" model=\"vm.Atracao.FichaTecnica.DataEstreia\" label=\"Data da primeira estréia\" type=\"date\" tooltip=\"Quando a peça irá ao ar.\"></ng-field></div><div class=\"col-md-4\"><ng-field name=\"Duracao\" model=\"vm.Atracao.FichaTecnica.Duracao\" type=\"number\" label=\"Duração\" required=\"true\" maxlength=\"3\" tooltip=\"Duração em minutos.\"></ng-field></div><div class=\"col-md-4\"><ng-field name=\"IdClassificacao\" model=\"vm.Atracao.FichaTecnica.IdClassificacao\" label=\"Classificação\" type=\"select\" tooltip=\"Informação relevante para saber quais pessoas em quais faixas etárias poderão assistir determinadas peças.\" value-field=\"Id\" text-field=\"Nome\" options=\"vm.classificacoes\" required=\"true\"></ng-field></div></div><div class=\"row\"><div class=\"col-md-12\"><h3>Inadequação</h3><div ng-if=\"!vm.loadInadequacoes\"><chips tags=\"vm.Inadequacoes\" has-image=\"false\" allow-new-item=\"false\" items=\"vm.inadequacoesSearch\"></chips></div><div ng-if=\"vm.loadInadequacoes\"><label>Carregando...</label><i class=\"fa pull-left\" ng-class=\"{\'\' : !vm.loadInadequacoes, \'fa-spinner fa-pulse\' : vm.loadInadequacoes}\"></i></div></div></div><div class=\"row m-t-md\"><div class=\"col-md-12\"><h3>Gêneros</h3><div ng-if=\"!vm.loadGeneros\"><chips tags=\"vm.Generos\" selecionado=\"vm.GeneroPrincipal\" has-check=\"true\" has-image=\"false\" allow-new-item=\"false\" items=\"vm.generosSearch\"></chips><span class=\"help-block\" ng-show=\"!vm.ValidaGenero\" aria-hidden=\"false\">Preenchimento obrigatório</span></div><div ng-if=\"vm.loadGeneros\"><label>Carregando...</label><i class=\"fa pull-left\" ng-class=\"{\'\' : !vm.loadGeneros, \'fa-spinner fa-pulse\' : vm.loadGeneros}\"></i></div></div></div></div><div class=\"row m-t-md\"><div class=\"col-md-12\"><div class=\"row pull-right\"><button ui-sref=\"conteudo.atracao.wizard.participantes\" class=\"btn btn-success pull-right\" ng-disabled=\"AtracaoForm.$invalid || vm.itensCount < 7 || !vm.ValidaGenero\">PRÓXIMO</button> <button type=\"button\" class=\"btn btn-outline btn-link pull-right\" ng-click=\"vm.Cancelar();\">CANCELAR</button></div></div></div></div></form>");
$templateCache.put("view/conteudo/atracao/template/midia_tmpl.html","<style>\n  .img-vazio {\n    width: 100%;\n    height: 240px;\n    background-color: #ebebeb !important;\n    border: 5px dashed #DDD;\n    border-radius: 3px;\n  }\n\n  .banner {\n    position: relative;\n    max-width: 740px;\n    max-height: 380px;\n  }\n\n  .capa {\n    position: relative;\n    max-width: 260px;\n    max-height: 380px;\n  }\n\n  .galeria {\n    position: relative;\n    max-width: 360px;\n    max-height: 240px;\n  }\n\n  .banner img, .capa img, .thumb-galeria {\n    width: 100%;\n    height: auto;\n  }\n\n  .banner h3, .capa h3, .img-vazio h3 {\n    position: absolute;\n    top: 55%;\n    left: 0;\n    padding: 0 10px;\n    width: 100%;\n    text-align: center;\n  }\n\n  .img-ok {\n    width: 100%;\n    background-color: #ebebeb !important;\n    border: 1px solid #d7d7d7;\n    border-radius: 3px;\n  }\n\n  .tratar_video {\n    width: 100%;\n    min-height: 250px;\n    background-color: indigo !important;\n    border-radius: 3px;\n    color: white;\n  }\n\n  .img-vazio-peq {\n    min-height: 200px;\n  }\n\n  .centro {\n    width: 100px;\n    height: 100px;\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    margin-top: -50px;\n    margin-left: -50px;\n  }\n\n  li {\n    display: inline-block;\n  }\n\n  .cropArea {\n    background: #E4E4E4;\n    overflow: hidden;\n    width: 600px;\n    height: 350px;\n  }\n\n  .alinhar-centro {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .btn-crop-center {\n    position: absolute;\n    top: calc(50% - 45px);\n    left: calc(50% - 25px);\n    margin: 0;\n  }\n\n  .btn-circle.btn-lg {\n    padding: 10px;\n  }\n\n  .btn-file {\n    position: relative;\n    overflow: hidden;\n  }\n\n  .btn-file input[type=file] {\n    position: absolute;\n    top: 0;\n    right: 0;\n    min-width: 100%;\n    min-height: 100%;\n    font-size: 100px;\n    text-align: right;\n    filter: alpha(opacity=0);\n    opacity: 0;\n    outline: none;\n    background: white;\n    cursor: inherit;\n    display: block;\n  }\n\n  .drop-box {\n    background: #F8F8F8;\n    border: 5px dashed #DDD;\n    /*width: 820px;*/\n    height: 200px;\n    text-align: center;\n    padding-top: 25px;\n    margin: 10px;\n  }\n\n  .dragover {\n    border: 5px dashed #03273D;\n  }\n\n  .progress-bar {\n    background-color: #3f51b5;\n  }\n\n  .notificacao-tratamento {\n    margin-top: 15%;\n    background-color: #086AA6;\n    color: #fff;\n    padding: 0.9em;\n    border-radius: 5px;\n    width: 350px;\n  }\n  .notificacao-tratamento:hover {\n    background-color: #1c84c6;\n  }\n  .teste{\n    background: #71bded;\n    border: none;\n  }\n</style><div class=\"container-fluid\"><form name=\"midiaForm\"><div class=\"row\"><div class=\"col-sm-12 col-md-12 col-lg-9\"><div class=\"banner\"><h4>Foto destaque</h4><div ng-disabled=\"vm.loading\" ngf-drop=\"\" ngf-select=\"\" ng-model=\"vm.FileDestaque\" ngf-drag-over-class=\"dragover\" ngf-multiple=\"true\" ngf-allow-dir=\"true\" accept=\"image/*\" layout-align=\"center center\" class=\"layout-align-center-center layout-column alinhar-centro banner\" ng-class=\"{\'img-ok\' : vm.Atracao.Midia.FotoDestaque != null, \'img-vazio\' : vm.Atracao.Midia.FotoDestaque == null}\"><div ng-if=\"!vm.Atracao.Midia.FotoDestaque\"><button class=\"btn btn-success btn-circle btn-lg btn-crop-center\" ng-disabled=\"vm.loading\"><i ng-class=\"{\'fa fa-cloud-upload idle\' : !vm.spinFotoDestaque, \'fa fa-spinner fa-pulse\': vm.spinFotoDestaque}\"></i></button><h3>Clique ou arraste a foto para fazer upload</h3><div ngf-no-file-drop=\"\">Arrastar não suportado pelo browser</div></div><div ng-if=\"vm.Atracao.Midia.FotoDestaque\"><img ng-src=\"{{vm.Atracao.Midia.FotoDestaque.Uri}}\"></div></div><div class=\"list-group list-group-horizontal pull-right\"><button class=\"btn btn-link btn-lg\" ng-disabled=\"!vm.Atracao.Midia.FotoDestaque\" ng-click=\"vm.DeleteFotoDestaque(vm.Atracao.Midia.FotoDestaque)\"><i class=\"fa fa-trash\"></i></button> <button ng-disabled=\"vm.loading\" class=\"btn btn-link btn-lg\" ngf-select=\"vm.uploadDestaque($files)\" accept=\"image/*\"><i class=\"fa fa-pencil\"></i></button> <a class=\"btn btn-link btn-lg\" style=\"margin: 0; padding: 8px 0;\"><span class=\"btn btn-link\" popover-placement=\"auto top\" uib-popover=\"Foto que será destaque da atração\" popover-trigger=\"mouseenter\"><i class=\"fa fa-question-circle\" style=\"font-size:1.3em;\"></i></span></a></div></div></div><div class=\"col-sm-12 col-md-12 col-lg-3\"><div class=\"capa\"><h4>Foto de capa</h4><div ng-disabled=\"vm.loading\" ngf-drop=\"\" ngf-select=\"\" ng-model=\"vm.FileCapa\" ngf-drag-over-class=\"dragover\" ngf-multiple=\"true\" ngf-allow-dir=\"true\" accept=\"image/*\" layout-align=\"center center\" class=\"layout-align-center-center layout-column capa alinhar-centro\" ng-class=\"{\'img-ok\' : vm.Atracao.Midia.FotoCapa != null, \'img-vazio\' : vm.Atracao.Midia.FotoCapa == null}\"><div ng-if=\"!vm.Atracao.Midia.FotoCapa\"><button class=\"btn btn-success btn-circle btn-lg btn-crop-center\" ng-disabled=\"vm.loading\"><i ng-class=\"{\'fa fa-cloud-upload idle\' : !vm.spinFotoCapa, \'fa fa-spinner fa-pulse\': vm.spinFotoCapa}\"></i></button><h3>Clique ou arraste a foto para fazer upload</h3></div><div ng-if=\"vm.Atracao.Midia.FotoCapa\"><img ng-src=\"{{vm.Atracao.Midia.FotoCapa.Uri}}\"></div></div><div class=\"list-group list-group-horizontal pull-right\"><button class=\"btn btn-link btn-lg\" ng-disabled=\"!vm.Atracao.Midia.FotoCapa\" ng-click=\"vm.DeleteFotoCapa(vm.Atracao.Midia.FotoCapa)\"><i class=\"fa fa-trash\"></i></button> <button ng-disabled=\"vm.loading\" class=\"btn btn-link btn-lg\" ngf-select=\"vm.uploadCapa($files)\" accept=\"image/*\"><i class=\"fa fa-pencil\"></i></button> <a class=\"btn btn-link btn-lg\" style=\"margin: 0; padding: 8px 0;\"><span class=\"btn btn-link\" popover-placement=\"auto top\" uib-popover=\"Foto que será exibida na capa de seus espetáculos\" popover-trigger=\"mouseenter\"><i class=\"fa fa-question-circle\" style=\"font-size:1.3em;\"></i></span></a></div></div></div></div><div class=\"hr-line-dashed\"></div><div class=\"row\"><div class=\"col-sm-12 col-md-12 col-lg-12\"><h4 class=\"m-l-md\">Fotos para galeria na página da atração</h4><div class=\"col-md-3\" ng-if=\"vm.Atracao.Midia.FotoGaleria != nulL\" ng-repeat=\"item in vm.Atracao.Midia.FotoGaleria\"><div class=\"layout-align-center-center layout-column img-ok\" layout-align=\"center center\" ng-disabled=\"item.error\"><span><img ng-src=\"{{item.Thumb.Uri}}\" class=\"thumb-galeria\"></span></div><div class=\"list-group list-group-horizontal pull-left\"><button class=\"btn btn-link btn-lg\" ng-click=\"vm.DeleteFotoGaleria($index, item)\" ng-disabled=\"vm.loading\"><i class=\"fa fa-trash\"></i></button> <button ng-disabled=\"vm.loading\" class=\"btn btn-link btn-lg\" ngf-select=\"vm.updateGaleria($files, $index,item)\" ngf-multiple=\"false\" accept=\"image/*\"><i class=\"fa fa-pencil\"></i></button><div><span class=\"btn btn-link\" popover-placement=\"auto top\" uib-popover=\"Fotos que serão exibidas no corrossel de imagens.\" popover-trigger=\"mouseenter\"><i class=\"fa fa-question-circle\" style=\"font-size:1.3em;\"></i></span></div></div></div><div class=\"col-md-3 col-lg-3\"><div ng-disabled=\"vm.loading\" ngf-drop=\"\" ngf-select=\"\" ng-model=\"vm.FileGaleria\" ngf-drag-over-class=\"dragover\" ngf-multiple=\"true\" ngf-allow-dir=\"true\" accept=\"image/*\" class=\"layout-align-center-center layout-column img-vazio alinhar-centro\" layout-align=\"center center\"><button class=\"btn btn-success btn-circle btn-lg btn-crop-center\" aria-label=\"upload\" ng-disabled=\"vm.loading\"><i ng-class=\"{\'fa fa-cloud-upload idle\' : !vm.spinFotoGaleria, \'fa fa-spinner fa-pulse\': vm.spinFotoGaleria}\"></i></button><h3>Clique ou arraste a foto para fazer upload.</h3></div></div></div></div><div class=\"hr-line-dashed\"></div><div class=\"row\"><div class=\"col-md-8 col-lg-7\" ng-if=\"vm.videoProgress == null\"><p></p><h4>Vídeo destaque</h4><p></p><div><div ng-disabled=\"vm.loading\" class=\"drop-box alinhar-centro\" ng-if=\"vm.Atracao.Midia.Video == null\" ngf-drop=\"\" ngf-select=\"\" ng-model=\"vm.FileVideo\" ngf-drag-over-class=\"dragover\" ngf-multiple=\"true\" ngf-allow-dir=\"true\" accept=\"video/*\" ngf-validate=\"{size: {max: \'400000MB\', min: \'1B\'}, height: {max: 12000}, width: {max: 12000}, duration: {max: \'200m\'}}\"><h3>Arraste o vídeo ou clique para enviar</h3></div><div ngf-no-file-drop=\"\">Arrastar e soltar não suportado pelo browser</div><p ng-show=\"vm.result\">Vídeo enviado com sucesso.</p><div class=\"pull-left\" ng-if=\"vm.Atracao.Midia.Video != null\"><div class=\"list-group list-group-horizontal pull-right\"><label for=\"\">Excluir Vídeo</label> <button ng-disabled=\"vm.loading\" class=\"btn btn-link btn-lg\" ng-click=\"vm.DeleteVideo(vm.Atracao.Midia.Video)\"><i class=\"fa fa-trash\"></i></button> <label for=\"\">Editar Vídeo</label> <button ng-disabled=\"vm.loading\" class=\"btn btn-link btn-lg\" ngf-allow-dir=\"true\" ngf-select=\"vm.UpdateVideo($files)\" ngf-multiple=\"false\" ngf-pattern=\"video/*,application/pdf\" accept=\"video/*\" ngf-validate=\"{size: {max: \'400000MB\', min: \'1B\'}, height: {max: 12000}, width: {max: 12000}, duration: {max: \'200m\'}}\"><i class=\"fa fa-pencil\"></i></button> <span class=\"btn btn-link\" popover-placement=\"auto top\" uib-popover=\"Trailler da atração.\" popover-trigger=\"mouseenter\"><i class=\"fa fa-question-circle\" style=\"font-size:1.3em;\"></i></span></div></div><div class=\"progress\" ng-show=\"vm.progress >= 0\" style=\"width:{{vm.progress}}%\" ng-bind=\"vm.progress + \'%\'\"></div></div></div><div class=\"col-md-8 col-lg-7\" ng-if=\"vm.videoProgress != null\" style=\"margin-top:42px;\"><div class=\"progress\" ng-if=\"vm.videoProgress != null\"><div class=\"progress-bar\" role=\"progressbar\" aria-valuenow=\"{{vm.videoProgress}}\" aria-valuemin=\"0\" aria-valuemax=\"100\" style=\"width: {{vm.videoProgress}}%;\">{{vm.videoProgress}} %</div></div></div><div class=\"col-md-4 col-lg-5 alinhar-centro\"><div class=\"notificacao-tratamento\"><h3>O vídeo será tratado pela divertix.com.br</h3><p>Em breve disponibilizaresmos o link de compartilhamento através do YouTube.</p></div></div></div><br></form><div class=\"row m-t-md\"><div class=\"col-md-12\"><div class=\"row pull-right\"><div class=\"inline m-r-md\"><a ui-sref=\"conteudo.atracao.wizard.sinopse\" class=\"btn btn-default pull-right offset3\">ANTERIOR</a></div><div class=\"inline\"><button type=\"button\" ng-click=\"vm.Save()\" class=\"btn btn-success pull-right\" ng-disabled=\"vm.itensCount < 7 || AtracaoForm.$invalid || vm.loading || vm.videoProgress != null\"><i class=\"fa\" ng-class=\"{\'fa fa-spinner fa-spin\' : vm.loading}\"></i> SALVAR</button></div></div></div></div></div>");
$templateCache.put("view/conteudo/atracao/template/participantes_tmpl.html","<form name=\"participantesForm\"><fieldset><div class=\"row\"><div class=\"col-md-12\" style=\"padding-left:0; padding-right:0\"><h4>Direção</h4><chips tags=\"vm.Direcao\" value-field=\"IdArtista\" icon-field=\"FotoPerfil\" items=\"vm.direcaoSearch\" enter-new=\"true\"></chips></div></div><div class=\"row m-t-md\" ng-if=\"vm.TipoVisao != 1\"><div class=\"col-md-12\" style=\"padding-left:0; padding-right:0\"><h4>Autoria</h4><chips tags=\"vm.Autoria\" value-field=\"IdArtista\" icon-field=\"FotoPerfil\" items=\"vm.autoriaSearch\" enter-new=\"true\"></chips></div></div><div class=\"row m-t-md\"><div class=\"col-md-12\" style=\"padding-left:0; padding-right:0\"><h4>Produção</h4><chips tags=\"vm.Producao\" autocomplete=\"vm.ProducaoArray\" value-field=\"IdArtista\" icon-field=\"FotoPerfil\" items=\"vm.producaoSearch\" enter-new=\"true\"></chips></div></div><div class=\"row m-t-md\" ng-if=\"vm.TipoVisao != 1\"><div class=\"col-md-12\" style=\"padding-left:0; padding-right:0\"><h4>Elenco</h4><chips tags=\"vm.Elenco\" value-field=\"IdArtista\" icon-field=\"FotoPerfil\" items=\"vm.elencoSearch\" enter-new=\"true\"></chips></div></div><div ng-if=\"vm.TipoVisao == 2\"><div class=\"row m-t-md\"><div class=\"col-md-12\" style=\"padding-left:0; padding-right:0\"><h4>Direção Musical</h4><chips tags=\"vm.DirecaoMusical\" value-field=\"IdArtista\" icon-field=\"FotoPerfil\" items=\"vm.direcaoMusicalSearch\" enter-new=\"true\"></chips></div></div><div class=\"row m-t-md\"><div class=\"col-md-12\" style=\"padding-left:0; padding-right:0\"><h4>Elenco Musical</h4><chips tags=\"vm.ElencoMusical\" value-field=\"IdArtista\" icon-field=\"FotoPerfil\" items=\"vm.elencoMusicalSearch\" enter-new=\"true\"></chips></div></div></div><div ng-if=\"vm.TipoVisao == 1\"><div class=\"row m-t-md\"><div class=\"col-md-12\" style=\"padding-left:0; padding-right:0\"><h4>Músico</h4><chips tags=\"vm.Musico\" value-field=\"IdArtista\" icon-field=\"FotoPerfil\" items=\"vm.musicoSearch\" enter-new=\"true\"></chips></div></div><div class=\"row m-t-md\"><div class=\"col-md-12\" style=\"padding-left:0; padding-right:0\"><h4>Banda</h4><chips tags=\"vm.Banda\" value-field=\"IdBanda\" icon-field=\"FotoPerfil\" items=\"vm.searchBanda\" enter-new=\"true\"></chips></div></div></div><div class=\"row m-t-md\"><div class=\"col-md-12\"><div class=\"row pull-right\"><div class=\"inline m-r-md\"><a ui-sref=\"conteudo.atracao.wizard.ficha_tecnica\" class=\"btn btn-default pull-right offset3\">ANTERIOR</a></div><div class=\"inline\"><a ui-sref=\"conteudo.atracao.wizard.sinopse\" class=\"btn btn-success pull-right\">PRÓXIMO</a></div></div></div></div></fieldset></form>");
$templateCache.put("view/conteudo/atracao/template/sinopse_tmpl.html","<style>\n  textarea {\n    resize: none;\n  }\n</style><fieldset><div class=\"row\"><div class=\"form-group\"><text-angular ta-toolbar=\"[ [\'h1\', \'h2\', \'h3\', \'h4\', \'h5\', \'h6\', \'p\'],[\'bold\', \'italics\', \'underline\', \'strikeThrough\', \'ul\', \'ol\', \'redo\', \'undo\', \'clear\'], [\'justifyLeft\', \'justifyCenter\', \'justifyRight\', \'indent\', \'outdent\']]\" ng-model=\"vm.Atracao.Sinopse.Texto\" name=\"your-textAngular-instance-name\" ta-maxlength=\"2000\"></text-angular></div></div><div class=\"row m-t-md\"><div class=\"col-md-12\"><div class=\"row pull-right\"><div class=\"inline m-r-md\"><a ui-sref=\"conteudo.atracao.wizard.participantes\" class=\"btn btn-default pull-right offset3\" ng-disabled=\"vm.itensCount < 7\">ANTERIOR</a></div><div class=\"inline\"><a ui-sref=\"conteudo.atracao.wizard.midia\" class=\"btn btn-success pull-right\">PRÓXIMO</a></div></div></div></div></fieldset>");
$templateCache.put("view/conteudo/banda/template/crop_tmpl.html","<style>\n    .cropArea {\n        background: #E4E4E4;\n        overflow: hidden;\n        width: 100% !important;\n        height: 300px;\n    }\n</style><div class=\"modal-header\"><h3 class=\"modal-title\">Cortar Imagem</h3></div><div class=\"modal-body\"><div class=\"cropArea medium\"><img-crop image=\"vm.imageDataURI\" result-image=\"vm.resImageDataURI\" change-on-fly=\"changeOnFly\" area-type=\"{{vm.type}}\" area-min-size=\"vm.selMinSize\" [result-image-format=\"{vm.resImgFormat}\" ]=\"\" result-image-quality=\"1.0\" result-image-size=\"vm.resImgSize\" on-change=\"vm.onChange($dataURI)\" on-load-begin=\"vm.onLoadBegin()\" on-load-done=\"vm.onLoadDone()\" on-load-error=\"vm.onLoadError()\"></img-crop></div></div><div class=\"modal-footer\"><button class=\"btn btn-warning\" type=\"button\" ng-click=\"vm.Cancel();\">Não</button> <button class=\"btn btn-primary\" type=\"button\" ng-click=\"vm.Confirm();\">Sim</button></div>");
$templateCache.put("view/conteudo/programacao/popup/ingresso.popup.html","<div class=\"modal-header\"><h4>INCLUIR INGRESSO</h4></div><div class=\"modal-body\"><h4>Selecione os ingressos.</h4><form name=\"frm\"><div class=\"ibox-content\"><button type=\"button\" ng-click=\"vm.search()\" ng-disabled=\"vm.searching\" class=\"btn btn-w-m btn-success pull-right col-offset-m1\"><i class=\"fa\" ng-class=\"{\'fa-search\' : !vm.searching, \'fa-spinner fa-pulse\' : vm.searching}\"></i> &nbsp; FILTRAR</button><div class=\"input-group col-xs-7 col-sm-8 col-md-9 col-lg-10\"><div class=\"input-group-addon\"><i class=\"fa fa-search\"></i></div><input ng-enter=\"vm.search()\" type=\"search\" ng-model=\"vm.Filter.Nome\" class=\"form-control\" placeholder=\"Digite para filtrar os resultados\" aria-controls=\"DataTables_Table_0\"></div></div><div class=\"ibox-content\" ng-if=\"vm.items.length > 0\" style=\"max-height: 300px;overflow-y: auto;\"><div class=\"table-responsive\"><table class=\"table table-striped table-bordered table-hover dataTables-example dataTable\" id=\"DataTables_Table_0\" aria-describedby=\"DataTables_Table_0_info\" role=\"grid\"><thead><th class=\"sorting\" tabindex=\"0\" aria-controls=\"DataTables_Table_0\" rowspan=\"1\" colspan=\"1\" style=\"width: 10px;\">Nome</th><th class=\"sorting\" tabindex=\"0\" aria-controls=\"DataTables_Table_0\" rowspan=\"1\" colspan=\"1\" style=\"width: 10px;\">Local de Venda</th></thead><tbody><tr class=\"gradeA odd\" role=\"row\" ng-repeat=\"item in vm.Tabelaingressos\" ng-click=\"vm.selected(vm.items,item)\" ng-class=\"{\'colorir\': item.selected}\"><td class=\"sorting_1\">{{item.Nome}}</td><td>{{item.VendeRemoto && item.VendeBilheteria ? \'Todos\' : item.VendeRemoto ? \'Site\' : item.VendeBilheteria ? \'Bilheteria\' : \'Nenhum\' }}</td></tr></tbody></table></div></div><div class=\"ibox-content\" ng-if=\"vm.items.length == 0 && vm.dirty\" style=\"max-height: 300px;overflow-y: auto;\"><span>Nenhum ingresso encontrado.</span></div><br><div class=\"alert alert-warning alert-dismissible\" role=\"alert\" ng-if=\"vm.Tabelaingressos.length == 0 && vm.items.length > 0\"><strong>Todos os ingressos já foram adicionados para este setor.</strong></div><div class=\"alert alert-warning alert-dismissible\" role=\"alert\" ng-if=\"vm.LimteAlcancado\"><strong>Só é permitido a inclusão de 30 tipos de ingressos por setor.</strong></div></form></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-w-m btn-success pull-right\" ng-click=\"vm.Confirm(vm.items | filter: vm.myfilter)\" ng-disabled=\"!vm.btnPopupIngresso || vm.LimteAlcancado\">CONFIRMAR</button> <button type=\"button\" class=\"btn btn-outline btn-link pull-right\" data-dismiss=\"modal\" ng-click=\"vm.Cancel()\">CANCELAR</button></div>");
$templateCache.put("view/conteudo/programacao/popup/tabelapreco.popup.html","<div class=\"modal-header\"><h4>TABELA DE PREÇOS</h4></div><div class=\"modal-body\"><h4>Selecione a tabela de preços para importar os ingressos.</h4><form name=\"frm\"><div class=\"ibox-content\"><button type=\"button\" ng-click=\"vm.search()\" ng-disabled=\"vm.searching\" class=\"btn btn-w-m btn-success pull-right col-offset-m1\"><i class=\"fa\" ng-class=\"{\'fa-search\' : !vm.searching, \'fa-spinner fa-pulse\' : vm.searching}\"></i> &nbsp; FILTRAR</button><div class=\"input-group col-xs-7 col-sm-8 col-md-9 col-lg-10\"><div class=\"input-group-addon\"><i class=\"fa fa-search\"></i></div><input type=\"search\" ng-model=\"vm.Filter.Nome\" class=\"form-control\" placeholder=\"Digite para filtrar os resultados\" aria-controls=\"DataTables_Table_0\"></div></div><div class=\"ibox-content\" style=\"max-height: 300px;overflow-y: auto;\"><div class=\"table-responsive\"><table class=\"table table-striped table-bordered table-hover dataTables-example dataTable\" id=\"DataTables_Table_0\" aria-describedby=\"DataTables_Table_0_info\" role=\"grid\"><tbody><tr class=\"gradeA odd\" role=\"row\" ng-repeat=\"item in vm.TabelaPrecos\" ng-click=\"vm.selected = $index; vm.Item = item\" ng-class=\"{\'colorir\': vm.selected == $index}\"><td class=\"sorting_1\">{{item.Nome}}</td></tr></tbody></table></div></div><br><div class=\"alert alert-warning alert-dismissible\" role=\"alert\" ng-if=\"vm.setor.tipoIngresso.length > 0\"><strong>Ao importar uma nova tabela de preços, os ingressos já incluídos serão excluídos.</strong></div></form></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-w-m btn-success pull-right\" ng-click=\"vm.Confirm(vm.Item)\" ng-disabled=\"vm.Item == null\">CONFIRMAR</button> <button type=\"button\" class=\"btn btn-outline btn-link pull-right\" data-dismiss=\"modal\" ng-click=\"vm.Cancel()\">CANCELAR</button></div>");
$templateCache.put("view/conteudo/programacao/resumoProgramacao/resumo.html","<style>\n  .status{\n    border-radius: 4px;\n    padding: 2px;\n    color: white;\n    text-align: center;\n    max-width: 200px;\n  }\n\n\n  .panel-body{\n    padding: 0px;\n  }\n</style><div class=\"wrapper wrapper-content animated fadeInDown\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12\"><h3>Informações da Atração</h3><div class=\"hr-line-dashed\"></div></div></div><div class=\"row\"><div class=\"col-xs-4 col-sm-4 col-md-4\"><label>Atração</label></div><div class=\"col-xs-4 col-sm-4 col-md-4\"><label>Sala</label></div><div class=\"col-xs-4 col-sm-4 col-md-4\"><label>Status da Venda</label></div></div><div class=\"row\"><div class=\"col-xs-4 col-sm-4 col-md-4\">{{vm.item.NomeAtracao}}</div><div class=\"col-xs-4 col-sm-4 col-md-4\">{{vm.item.NomeSala}}</div><div class=\"col-xs-4 col-sm-4 col-md-4\"><div class=\"status\" style=\"background-color:red\" ng-if=\"!vm.item.PossuiBordero && vm.item.Status == 1 && !vm.item.VendaLiberada\">Não Liberada</div><div class=\"status\" style=\"background-color:green\" ng-if=\"!vm.item.PossuiBordero && vm.item.Status == 1 && vm.item.VendaLiberada && vm.item.VendaBilheteria && vm.item.VendeRemoto\">Liberada Online e Bilheteria</div><div class=\"status\" style=\"background-color:darkorange\" ng-if=\"!vm.item.PossuiBordero && vm.item.Status == 1 && vm.item.VendaLiberada && vm.item.VendaBilheteria && !vm.item.VendeRemoto\">Liberada Somente Bilheteria</div><div class=\"status\" style=\"background-color:blue\" ng-if=\"!vm.item.PossuiBordero && vm.item.Status == 1 && vm.item.VendaLiberada && !vm.item.VendaBilheteria && vm.item.VendeRemoto\">Liberada Somente Online</div><div class=\"status\" style=\"background-color:slategrey\" ng-if=\"vm.item.PossuiBordero\">Encerrada</div><div class=\"status\" style=\"background-color:silver\" ng-if=\"!vm.item.PossuiBordero && vm.item.Status != 1\">Desabilitada</div><br></div></div><div class=\"row\"><div class=\"col-xs-4 col-sm-4 col-md-4\"><label>Data</label></div><div class=\"col-xs-4 col-sm-4 col-md-4\"><label>Layout</label></div><div class=\"col-xs-4 col-sm-4 col-md-4\"><label>Abertura dos Portões</label></div></div><div class=\"row\"><div class=\"col-xs-4 col-sm-4 col-md-4\">{{vm.item.DataHoraInicio | date : \'dd/MM/yyyy\'}} ({{vm.item.DiaSemana}})</div><div class=\"col-xs-4 col-sm-4 col-md-4\">{{vm.item.NomeLayout}}</div><div ng-maxlength=\"2\" class=\"col-xs-4 col-sm-4 col-md-4\">{{vm.item.HoraAbertura}}<br><br></div></div><div class=\"row\"><div class=\"col-xs-4 col-sm-4 col-md-4\"><label>Horario</label></div><div class=\"col-xs-4 col-sm-4 col-md-4\"><label>Evento com duração de um dia</label></div></div><div class=\"row\"><div class=\"col-xs-4 col-sm-4 col-md-4\">{{vm.item.DataHoraInicio | date : \'HH:mm\'}}<br></div><div class=\"col-xs-4 col-sm-4 col-md-4\">{{vm.item.DuracaoDiaInteiro == false ? \'Não\' : \'Sim\'}}<br><br></div></div></div></div><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-lg-12\"><h3>Valores do Ingresso</h3><div class=\"hr-line-dashed\"></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div id=\"accordion\" role=\"tablist\" aria-multiselectable=\"false\"><uib-accordion close-others=\"vm.oneAtATime\"><div uib-accordion-group=\"\" class=\"panel-default\" ng-repeat=\"setor in vm.ListaSetorTipoIngressos track by $index\" is-open=\"vm.accordionArray[$index]\"><uib-accordion-heading><div class=\"row\"><div class=\"col-sm-6\"><div><i class=\"pull-left glyphicon\" ng-class=\"vm.accordionArray[$index] ? \'glyphicon-chevron-down\':\'glyphicon-chevron-right\'\"></i>&nbsp; {{setor.NomeSetor}}<br></div></div></div></uib-accordion-heading><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><div class=\"row\"><div>&nbsp;<label>Valor Base</label>&nbsp;&nbsp; {{setor.ValorBase | currency:\"R$\"}}</div></div></div><table class=\"table table-striped table-bordered table-hover dataTables-example dataTable\" id=\"DataTables_Table_0\" aria-describedby=\"DataTables_Table_0_info\" role=\"grid\"><thead><tr role=\"row\"><th class=\"sorting\" tabindex=\"0\" aria-controls=\"DataTables_Table_0\" rowspan=\"1\" colspan=\"1\" aria-sort=\"ascending\" aria-label=\"Rendering engine: activate to sort column descending\" style=\"width: 710px;\">Tipo de Ingresso</th><th class=\"sorting\" tabindex=\"0\" aria-controls=\"DataTables_Table_0\" rowspan=\"1\" colspan=\"1\" aria-sort=\"ascending\" aria-label=\"Rendering engine: activate to sort column descending\" style=\"width: 150px;\">Local de Venda</th><th class=\"sorting\" tabindex=\"0\" aria-controls=\"DataTables_Table_0\" rowspan=\"1\" colspan=\"1\" style=\"width: 150px;\">Tipo de Desconto</th><th class=\"sorting\" tabindex=\"0\" aria-controls=\"DataTables_Table_0\" rowspan=\"1\" colspan=\"1\" style=\"width: 150px;\">Qtd. Máxima</th><th class=\"sorting\" tabindex=\"0\" aria-controls=\"DataTables_Table_0\" rowspan=\"1\" colspan=\"1\" style=\"width: 120px;\">Valor da regra</th><th class=\"sorting\" tabindex=\"0\" aria-controls=\"DataTables_Table_0\" rowspan=\"1\" colspan=\"1\" style=\"width: 80px;\">Valor</th></tr></thead><tbody><tr class=\"gradeA odd\" role=\"row\" ng-repeat=\"ti in setor.ListaTipoIngresso | orderBy : \'OrdemIngresso\'\" style=\"{{ti.excluido == true ? \'display:none\' : \'\'}}\"><td class=\"sorting_1\">{{ti.NomeIngresso}}</td><td>{{ti.VendeRemoto && ti.VendeBilheteria ? \'Todos\' : ti.VendeRemoto ? \'Site\' : ti.VendeBilheteria ? \'Bilheteria\' : \'Nenhum\' }}</td><td class=\"sorting_1\">{{ti.TipoDesconto == \'P\' ? \'Percentual\' : \'Fixo\'}}</td><td class=\"sorting_1\" ng-if=\"!ti.ExibeQtd\">{{ti.QuantidadeIngressos}}</td><td class=\"sorting_1\" ng-if=\"ti.ExibeQtd\"><input type=\"text\" id=\"qtdIngressos\" name=\"qtdIngressos\" ng-model=\"ti.QuantidadeIngressos\" style=\"width:100px;\" ui-hide-group-sep=\"\" ui-number-mask=\"0\"></td><td class=\"sorting_1\" ng-if=\"ti.TipoDesconto == \'F\'\">{{ti.ValorRegra | currency:\"R$\"}}</td><td class=\"sorting_1\" ng-if=\"ti.TipoDesconto == \'P\'\">{{ti.ValorRegra * 100}} %</td><td class=\"center\">{{ ti.ValorIngresso | currency:\"R$\"}}</td></tr></tbody></table></div></div></uib-accordion></div></div></div></div></div><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12\"><h3>Detalhes</h3><div class=\"hr-line-dashed\"></div></div></div><div class=\"row\"><div class=\"col-xs-5 col-sm-5 col-md-5\"><label>Tipos de Entrega</label></div><div class=\"col-xs-3 col-sm-3 col-md-3\"><label>Artista(s) Convidado(s)</label></div><div class=\"col-xs-4 col-sm-4 col-md-4\"><label>Encerramento de venda após sessão</label></div></div><div class=\"row\"><div class=\"col-xs-5 col-sm-5 col-md-5\"><span ng-repeat=\"item in vm.item.ListaTipoEntrega.$values\">{{$last ? item.Nome : item.Nome + \'/\'}}</span></div><div ng-if=\"vm.item.ListaConvidado.$values.length > 0\" class=\"col-xs-3 col-sm-3 col-md-3\"><span ng-repeat=\"item in vm.item.ListaConvidado.$values\">{{$last ? item.NomeArtistico : item.NomeArtistico + \',\'}}</span></div><div ng-if=\"vm.item.ListaConvidado.$values.length == 0\" class=\"col-xs-3 col-sm-3 col-md-3\">Nenhum</div><div class=\"col-xs-4 col-sm-4 col-md-4\">{{vm.item.EncerraVendaAposSessao}} min após início da sessão<br><br></div></div><div class=\"row\"><div class=\"col-xs-5 col-sm-5 col-md-5\"><label>Encerramento de vendas remotas automaticamente</label></div><div class=\"col-xs-3 col-sm-3 col-md-3\"><label>Encerramento de vendas remotas</label></div><div class=\"col-xs-4 col-sm-4 col-md-4\"><label>Cancelamento de reservas</label></div></div><div class=\"row\"><div class=\"col-xs-5 col-sm-5 col-md-5\">{{vm.item.EncerraVendaRemotaAutomaticamente == false ? \'Não\' : \'Sim\'}}<br><br></div><div class=\"col-xs-3 col-sm-3 col-md-3\">{{vm.item.EncerraVendaRemota}} min</div><div class=\"col-xs-4 col-sm-4 col-md-4\">{{vm.item.CancelamentoReserva}} min antes do início da sessão<br><br></div></div></div></div><div class=\"row\"><div class=\"form-group\"><div class=\"col-md-1 col-md-offset-10\"></div><div class=\"col-md-1\"><button class=\"btn btn-outline pull-right\" type=\"button\" ng-click=\"vm.cancel()\">CANCELAR</button></div></div></div><br></div>");
$templateCache.put("view/operacao/venda/pesquisar-venda/form.html","<style>\n  .table {\n    border: 1px solid white;\n  }\n\n  .table td {\n    border: 1px solid black;\n    /*width: 33%;*/\n    padding-left: 5px;\n  }\n\n  .table > thead > tr > th,\n  .table > tbody > tr > th,\n  .table > tfoot > tr > th,\n  .table > thead > tr > td,\n  .table > tbody > tr > td,\n  .table > tfoot > tr > td {\n    border: 1px solid white;\n  }\n\n  .table > thead > tr > th,\n  .table > tbody > tr > th,\n  .table > tfoot > tr > th,\n  .table > thead > tr > td,\n  .table > tbody > tr > td,\n  .table > tfoot > tr > td {\n    border-top: 1px solid white;\n    line-height: 1.42857;\n    padding: 5px;\n    padding-left: 10px;\n    vertical-align: top;\n  }\n\n  .form-group-sm select.form-control {\n    border-radius: 0px;\n  }\n\n  .btn-default {\n    color: inherit;\n    background: white;\n    /*border: 1px solid #e7eaec;*/\n    border: 1px solid grey;\n  }\n\n\n  .svg-container {\n    width: 100%;\n    background-color: #eee;\n    border: 1px solid #cacaca;\n    padding: 5px;\n  }\n\n</style><div class=\"wrapper wrapper-content animated fadeInDown\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\" ng-switch=\"vm.venda.IdTipoStatusPagamento\"><h4 style=\"font-weight: 600\" ng-switch-when=\"1\">Detalhes da Venda (<label style=\"color: green;\" for=\"\">APROVADA</label>)</h4><h4 style=\"font-weight: 600\" ng-switch-when=\"2\">Detalhes da Venda (<label style=\"color: orange;\" for=\"\">CANCELADA</label>)</h4><h4 style=\"font-weight: 600\" ng-switch-when=\"3\">Detalhes da Venda (<label style=\"color: red;\" for=\"\">REPROVADA</label>)</h4><h4 style=\"font-weight: 600\" ng-switch-when=\"4\">Detalhes da Venda (<label style=\"color: darkgrey;\" for=\"\">EM ANÁLISE</label>)</h4><h4 style=\"font-weight: 600\" ng-switch-when=\"5\">Detalhes da Venda (<label style=\"color: orange;\" for=\"\">DEVOLVIDO</label>)</h4></div><div class=\"ibox-content\"><div class=\"row\"><table class=\"table\"><tr><td><label>Estabelecimento:</label></td><td>{{vm.venda.Estabelecimento}}</td><td><label>Setor:</label></td><td>{{vm.venda.NomeSetor}}</td><td><label>Atração:</label></td><td>{{vm.venda.NomeAtracao}}</td><td><label>CodVenda:</label></td><td>{{vm.venda.CodRastreio}}</td></tr><tr><td><label>Data da Venda:</label></td><td>{{vm.venda.DataVenda | date:\'dd/MM/yyyy HH:mm\'}}</td><td><label>Data da Sessão:</label></td><td>{{vm.venda.DataHoraInicio | date:\'dd/MM/yyyy HH:mm\'}}</td><td><label>Ingressos:</label></td><td>{{vm.QtdTipoIngresso}}</td><td><label>Valor Total:</label></td><td>{{vm.venda.ValorBruto | currency:\'R$\':2}}</td></tr><tr><td><label>Assentos:</label></td><td>{{vm.venda.LugaresEscolhidos}}</td><td><label>TID:</label></td><td>{{vm.venda.TID}}</td></tr></table></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h4>Detalhes do Cliente</h4></div><div class=\"ibox-content\"><div class=\"row\"><table class=\"table\"><tr><td><label>Cliente:</label></td><td>{{vm.venda.Cliente}}</td><td><label>E-mail:</label></td><td>{{vm.venda.Login}}</td><td><label for=\"\">Sexo</label></td><td>{{vm.venda.Sexo}}</td><td><label for=\"\">CPF</label></td><td>{{vm.venda.CPF}}</td></tr><tr><td><label>Telefone:</label></td><td>{{vm.venda.Telefone}}</td><td><label for=\"\">Estado</label></td><td>{{vm.venda.UF}}</td><td><label for=\"\">Cidade</label></td><td>{{vm.venda.Cidade}}</td><td><label for=\"\">Bairro</label></td><td>{{vm.venda.Bairro}}</td></tr><tr><td><label for=\"\">Provedor</label></td><td>{{vm.venda.Provedor}}</td></tr></table></div></div></div><button class=\"btn btn-success pull-right\" type=\"button\" ng-click=\"vm.cancel();\">VOLTAR</button></div></div></div>");
$templateCache.put("view/operacao/venda/pesquisar-venda/grid.html","<div class=\"wrapper wrapper-content animated fadeInDown\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><form name=\"frm\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6\"><ng-field ng-enter=\"vm.search()\" label=\"Nome\" type=\"text\" model=\"vm.Filter.Nome\"></ng-field></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6\"><ng-field ng-enter=\"vm.search()\" label=\"E-mail\" type=\"text\" model=\"vm.Filter.Login\"></ng-field></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6\"><ng-field ng-enter=\"vm.search()\" label=\"Cod Rastreio\" type=\"text\" model=\"vm.Filter.CodRastreio\"></ng-field></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6\"><ng-field ng-enter=\"vm.search()\" label=\"CPF\" type=\"text\" maxlength=\"11\" model=\"vm.Filter.CPF\"></ng-field></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><button type=\"button\" class=\"btn m-t-md btn-w-m btn-success pull-right\" ng-disabled=\"vm.searching\" ng-click=\"vm.search()\"><i class=\"fa\" ng-class=\"{\'fa-search\' : !vm.searching, \'fa-spinner fa-pulse\' : vm.searching}\"></i> FILTRAR</button> <button type=\"button\" class=\"btn m-t-md btn-w-m btn-outline pull-right\" ng-click=\"vm.limparFiltro()\"><i class=\"fa fa-search\"></i> LIMPAR FILTRO</button></div></div></form></div><br><div class=\"ibox-content\"><div class=\"table-responsive constrained\"><table class=\"table table-hover table-striped\" data-sorting=\"true\" role=\"grid\" infinite-scroll=\"vm.search(true)\" infinite-scroll-disabled=\"vm.complete || vm.searching\" infinite-scroll-immediate-check=\"false\" infinite-scroll-distance=\"0\"><thead><tr role=\"row\"><th>Venda</th><th>Status da Venda</th><th>Atração</th><th>Data da Sessão</th><th>Cliente</th><th ts-default=\"descending\">Data da Venda</th><th>Ações</th></tr></thead><tbody><tr class=\"gradeA odd\" role=\"row\" ng-repeat=\"item in vm.items\"><td class=\"project-title\" style=\"font-weight: 600\"><span>{{item.CodRastreio}}</span></td><td ng-if=\"!item.FilaFraude\" ng-switch=\"item.IdTipoStatusPagamento\"><text style=\"color: green; font-weight: 600\" ng-switch-when=\"1\">Aprovado</text><text style=\"color: orange; font-weight: 600\" ng-switch-when=\"2\">Cancelada</text><text style=\"color: red; font-weight: 600\" ng-switch-when=\"3\">Reprovada</text><text style=\"color: darkgrey; font-weight: 600\" ng-switch-when=\"4\">Em análise</text><text style=\"color: orange; font-weight: 600\" ng-switch-when=\"5\">Devolvido</text></td><td ng-if=\"item.FilaFraude\"><text style=\"color: orangered; font-weight: 600\">Em análise</text></td><td class=\"project-title\"><span>{{item.NomeAtracao}}</span></td><td class=\"project-title\"><span>{{item.DataHoraInicio | date:\'yyyy-MM-dd HH:mm\'}}</span></td><td class=\"project-title\"><span>{{item.Cliente}}</span></td><td class=\"project-title\"><span>{{item.DataVenda | date:\'yyyy-MM-dd HH:mm\'}}</span></td><td class=\"project-actions\"><span uib-dropdown=\"\" on-toggle=\"toggled(open)\"><a style=\"vertical-align:middle\" role=\"button\" uib-dropdown-toggle=\"\"><i class=\"fa fa-wrench\"></i></a><ul class=\"pull-right\" uib-dropdown-menu=\"\" aria-labelledby=\"simple-dropdown\"><li><a ng-if=\"item.IdTipoStatusPagamento == \'1\'\" role=\"button\" ng-click=\"vm.trocasessao(item);\"><i class=\"fa fa-edit\"></i> Troca</a> <a ng-if=\"item.IdTipoStatusPagamento != \'1\'\" role=\"button\" style=\"color: lightgrey;\"><i class=\"fa fa-edit\" style=\"color: lightgrey;\"></i> Troca</a></li><li><a ng-if=\"item.IdTipoStatusPagamento == \'1\'\" role=\"button\" ng-click=\"vm.cancelamento(item);\"><i class=\"fa fa-trash\"></i> Cancelamento</a> <a ng-if=\"item.IdTipoStatusPagamento != \'1\'\" role=\"button\" style=\"color: lightgrey;\"><i class=\"fa fa-trash\" style=\"color: lightgrey;\"></i> Cancelamento</a></li><li><a role=\"button\" ng-click=\"vm.detalhe(item, vm.Filter);\"><i class=\"fa fa-edit\"></i> Detalhe</a></li></ul></span></td></tr></tbody></table><div class=\"row\"><div class=\"col-md-6 col-md-offset-5\" ng-show=\"vm.searching\"><i class=\"fa fa-spinner fa-pulse fa-1x fa-fw\"></i> Carregando...</div></div></div></div></div></div></div></div>");
$templateCache.put("view/operacao/venda/pesquisar-venda/index.html","<div ui-view=\"\"></div>");
$templateCache.put("view/operacao/venda/vendapagamentofilafraude/form.html","<style>\n  .table {\n    border: 1px solid white;\n  }\n\n  .table td {\n    border: 1px solid black;\n    /*width: 33%;*/\n    padding-left: 5px;\n  }\n\n  .table > thead > tr > th,\n  .table > tbody > tr > th,\n  .table > tfoot > tr > th,\n  .table > thead > tr > td,\n  .table > tbody > tr > td,\n  .table > tfoot > tr > td {\n    border: 1px solid white;\n  }\n\n  .form-group-sm select.form-control {\n    border-radius: 0px;\n  }\n\n  .btn-default {\n    color: inherit;\n    background: white;\n    /*border: 1px solid #e7eaec;*/\n    border: 1px solid grey;\n  }\n\n\n  .svg-container {\n    width: 100%;\n    background-color: #eee;\n    border: 1px solid #cacaca;\n    padding: 5px;\n  }\n\n</style><div class=\"wrapper wrapper-content animated fadeInDown\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\" ng-switch=\"vm.item.IdStatusFilaFraude\"><h4 style=\"font-weight: 600\" ng-switch-when=\"1\">Detalhes da Venda (<label style=\"color: green;\" for=\"\">PENDENTE DE APROVAÇÃO</label>)</h4><h4 style=\"font-weight: 600\" ng-switch-when=\"2\">Detalhes da Venda (<label style=\"color: orange;\" for=\"\">EM ANÁLISE</label>)</h4><h4 style=\"font-weight: 600\" ng-switch-when=\"3\">Detalhes da Venda (<label style=\"color: red;\" for=\"\">REPROVADA</label>)</h4><h4 style=\"font-weight: 600\" ng-switch-when=\"4\">Detalhes da Venda (<label style=\"color: darkgrey;\" for=\"\">APROVADA</label>)</h4></div><div class=\"ibox-content\"><div class=\"row\"><table class=\"table borderless table-condensed\"><tr><td><label>Estabelecimento:</label></td><td>{{vm.item.NomeEstabelecimento}}</td><td><label>Atração:</label></td><td>{{vm.item.NomeAtracao}}</td><td><label>Quantidade de Ingresso(s):</label></td><td>{{vm.item.QtdItens}}</td></tr><tr><td><label>Data Venda:</label></td><td>{{vm.item.DataVenda | date: \'dd/MM/yyyy HH:mm\'}}</td><td><label>Data Contábil:</label></td><td>{{vm.item.DataContabil | date: \'dd/MM/yyyy\'}}</td><td><label>Data Sessão:</label></td><td>{{vm.item.DataHoraSessao | date: \'dd/MM/yyyy HH:mm\'}}</td></tr><tr><td><label>Valor Bruto:</label></td><td>{{vm.item.ValorBruto | currency}}</td><td><label>Valor Liquido:</label></td><td>{{vm.item.ValorLiquido | currency}}</td><td><label>Valor Coveniência:</label></td><td>{{vm.item.ValorConveniencia | currency}}</td></tr><tr><td><label>Tipo Ingresso:</label></td><td>{{vm.QtdTipoIngresso}}</td><td><label>Assentos:</label></td><td>{{vm.item.Assentos}}</td><td><label>Nº Cartão</label></td><td>{{vm.item.NumeroCartao}}</td></tr></table></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h4>Detalhes do Cliente</h4></div><div class=\"ibox-content\"><div class=\"row\"><table class=\"table\"><tr><td><label>Cliente</label></td><td>{{vm.item.NomeCliente}}</td><td><label>Email</label></td><td>{{vm.item.Login}}</td><td><label for=\"\">Sexo</label></td><td>{{vm.item.Sexo}}</td><td><label for=\"\">CPF</label></td><td>{{vm.item.CPF}}</td></tr><tr><td><label for=\"\">Telefone</label></td><td>{{vm.item.Telefone}}</td><td><label for=\"\">Estado</label></td><td>{{vm.item.UF}}</td><td><label for=\"\">Cidade</label></td><td>{{vm.item.Cidade}}</td><td><label for=\"\">Provedor</label></td><td>{{vm.item.Provedor}}</td></tr></table></div></div></div><button class=\"btn btn-w-m btn-success pull-right col-offset-m1\" type=\"button\" ng-click=\"vm.AprovarReprovar(true);\" ng-disabled=\"vm.loading\"><i class=\"fa\" ng-class=\"{\'fa fa-spinner fa-pulse\' : vm.loading}\"></i> APROVAR</button> <button class=\"btn btn-w-m btn-danger pull-right col-offset-m1\" type=\"button\" ng-click=\"vm.AprovarReprovar(false);\" ng-disabled=\"vm.loading\"><i class=\"fa\" ng-class=\"{\'fa fa-spinner fa-pulse\' : vm.loading}\"></i> REPROVAR</button> <button class=\"btn btn-outline btn-link pull-right col-offset-m1\" type=\"button\" ng-click=\"vm.cancel();\">VOLTAR</button></div></div></div>");
$templateCache.put("view/operacao/venda/vendapagamentofilafraude/grid.html","<div class=\"wrapper wrapper-content animated fadeInRight\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><form name=\"frm\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6\"><ng-field ng-enter=\"vm.search()\" label=\"Estabelecimento\" type=\"select\" model=\"vm.Filter.IdEstabelecimento\" options=\"vm.estabelecimentoList\" value-field=\"Id\" text-field=\"Nome\"></ng-field></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6\"><ng-field ng-enter=\"vm.search()\" ng-disabled=\"!vm.atracaoList\" label=\"Atracao\" type=\"select\" model=\"vm.Filter.IdAtracao\" options=\"vm.atracaoList\" value-field=\"IdAtracao\" text-field=\"Nome\"></ng-field></div><div class=\"col-md-12\"><h4>Período Data Venda</h4></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-3\"><ng-field name=\"Nome\" ng-enter=\"vm.search()\" label=\"\" model=\"vm.Filter.DataVendaInicio\" type=\"date\"></ng-field></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-3\"><ng-field name=\"Nome\" ng-enter=\"vm.search()\" label=\"\" model=\"vm.Filter.DataVendaFim\" type=\"date\"></ng-field></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6 m-t-n-md\"><button ng-disabled=\"frm.$invalid || vm.searching\" style=\"margin-top: 26px\" type=\"button\" class=\"btn btn-w-m btn-success pull-right col-offset-m1\" ng-click=\"vm.search()\"><i class=\"fa\" ng-class=\"{\'fa fa-spinner fa-pulse\' : vm.searching}\"></i> FILTRAR</button></div></div></form></div><br><div class=\"ibox-content\"><div class=\"table-responsive\" ts-wrapper=\"\" ts-no-data-text=\"Utilize o filtro para filtrar as vendas\"><table class=\"table table-hover table-striped\" data-sorting=\"true\" role=\"grid\" infinite-scroll=\"vm.search(true)\" infinite-scroll-disabled=\"vm.complete || vm.searching\" infinite-scroll-immediate-check=\"false\" infinite-scroll-distance=\"0\"><thead><tr role=\"row\"><th ts-criteria=\"Estabelecimento\">Estabelecimento</th><th ts-criteria=\"Atracao\">Atração</th><th>Assentos</th><th>Quantidade</th><th ts-criteria=\"DataHoraInicio\">Data Sessão</th><th ts-criteria=\"DataVenda\" ts-default=\"descending\">Data Venda</th><th ts-criteria=\"DataContabil\">Data Contábil</th><th class=\"text-right\">Ações</th></tr></thead><tbody><tr ng-repeat=\"item in vm.items\" role=\"row\" ng-class=\"{\'success\' : itm.updated}\" ts-repeat=\"\"><td class=\"project-title\"><span>{{item.NomeEstabelecimento}}</span></td><td class=\"project-title\"><span>{{item.Atracao}}</span></td><td class=\"project-title\"><span>{{item.Assentos}}</span></td><td class=\"project-title\"><span>{{item.Qtd}}</span></td><td class=\"project-title\"><span>{{item.DataHoraInicio | date: \'dd/MM/yyyy HH:mm\'}}</span></td><td class=\"project-title\"><span>{{item.DataVenda | date: \'dd/MM/yyyy HH:mm\'}}</span></td><td class=\"project-title\"><span>{{item.DataContabil | date: \'dd/MM/yyyy\'}}</span></td><td class=\"center\" width=\"30\"><span uib-dropdown=\"\" on-toggle=\"toggled(open)\"><a role=\"button\" uib-dropdown-toggle=\"\"><i class=\"fa fa-wrench\"></i></a><ul class=\"pull-right\" uib-dropdown-menu=\"\" aria-labelledby=\"simple-dropdown\"><li><a role=\"button\" ng-click=\"vm.detalhe(item);\"><i class=\"fa fa-edit\"></i> Detalhe</a></li></ul></span></td></tr></tbody></table><div class=\"row\"><div class=\"col-md-6 col-md-offset-5\" ng-show=\"vm.searching\"><i class=\"fa fa-spinner fa-pulse fa-1x fa-fw\"></i> Carregando...</div></div></div></div></div></div></div></div>");
$templateCache.put("view/operacao/venda/vendapagamentofilafraude/index.html","<div ui-view=\"\"></div>");
$templateCache.put("view/operacao/venda/vendasite/form.html","<style>\n  .table {\n    border: 1px solid white;\n  }\n\n  .table td {\n    border: 1px solid black;\n    /*width: 33%;*/\n    padding-left: 5px;\n  }\n\n  .table > thead > tr > th,\n  .table > tbody > tr > th,\n  .table > tfoot > tr > th,\n  .table > thead > tr > td,\n  .table > tbody > tr > td,\n  .table > tfoot > tr > td {\n    border: 1px solid white;\n  }\n\n  .form-group-sm select.form-control {\n    border-radius: 0px;\n  }\n\n  .btn-default {\n    color: inherit;\n    background: white;\n    /*border: 1px solid #e7eaec;*/\n    border: 1px solid grey;\n  }\n\n\n  .svg-container {\n    width: 100%;\n    background-color: #eee;\n    border: 1px solid #cacaca;\n    padding: 5px;\n  }\n\n</style><div class=\"wrapper wrapper-content animated fadeInDown\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\" ng-switch=\"vm.item.IdTipoStatusPagamento\"><h4 style=\"font-weight: 600\" ng-switch-when=\"1\">Detalhes da Venda (<label style=\"color: green;\" for=\"\">APROVADA</label>)</h4><h4 style=\"font-weight: 600\" ng-switch-when=\"2\">Detalhes da Venda (<label style=\"color: orange;\" for=\"\">CANCELADA</label>)</h4><h4 style=\"font-weight: 600\" ng-switch-when=\"3\">Detalhes da Venda (<label style=\"color: red;\" for=\"\">REPROVADA</label>)</h4><h4 style=\"font-weight: 600\" ng-switch-when=\"4\">Detalhes da Venda (<label style=\"color: darkgrey;\" for=\"\">EM ANÁLISE</label>)</h4><h4 style=\"font-weight: 600\" ng-switch-when=\"5\">Detalhes da Venda (<label style=\"color: orange;\" for=\"\">DEVOLVIDO</label>)</h4></div><div class=\"ibox-content\"><div class=\"row\"><table class=\"table borderless table-condensed\"><tr><td><label>Estabelecimento:</label></td><td>{{vm.item.NomeEstabelecimento}}</td><td><label>Atração:</label></td><td>{{vm.item.NomeAtracao}}</td><td><label>Quantidade de Ingresso(s):</label></td><td>{{vm.item.QtdItens}}</td></tr><tr><td><label>Data Venda:</label></td><td>{{vm.item.DataVenda | date: \'dd/MM/yyyy HH:mm\'}}</td><td><label>Data Contábil:</label></td><td>{{vm.item.DataContabil | date: \'dd/MM/yyyy\'}}</td><td><label>Data Sessão:</label></td><td>{{vm.item.DataHoraSessao | date: \'dd/MM/yyyy HH:mm\'}}</td></tr><tr><td><label>Valor Bruto:</label></td><td>{{vm.item.ValorBruto | currency}}</td><td><label>Valor Liquido:</label></td><td>{{vm.item.ValorLiquido | currency}}</td><td><label>Valor Coveniência:</label></td><td>{{vm.item.ValorConveniencia | currency}}</td></tr><tr><td><label>Tipo Ingresso:</label></td><td>{{vm.QtdTipoIngresso}}</td><td><label>Assentos:</label></td><td>{{vm.item.Assentos}}</td><td><label>IdVenda</label></td><td>{{vm.item.IdVenda}}</td></tr><tr><td><label>TID</label></td><td>{{vm.item.TID}}</td></tr></table></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h4>Detalhes do Cliente</h4></div><div class=\"ibox-content\"><div class=\"row\"><table class=\"table\"><tr><td><label>Cliente</label></td><td>{{vm.item.NomeCliente}}</td><td><label>Email</label></td><td>{{vm.item.Login}}</td><td><label for=\"\">Sexo</label></td><td>{{vm.item.Sexo}}</td><td><label for=\"\">CPF</label></td><td>{{vm.item.CPF}}</td></tr><tr><td><label for=\"\">Telefone</label></td><td>{{vm.item.Telefone}}</td><td><label for=\"\">Estado</label></td><td>{{vm.item.UF}}</td><td><label for=\"\">Cidade</label></td><td>{{vm.item.Cidade}}</td><td><label for=\"\">Bairro</label></td><td>{{vm.item.Bairro}}</td></tr><tr><td><label for=\"\">Provedor</label></td><td>{{vm.item.Provedor}}</td></tr></table></div></div></div><button class=\"btn btn-w-m btn-success pull-right col-offset-m1\" type=\"button\" ng-click=\"vm.cancel();\">VOLTAR</button></div></div></div>");
$templateCache.put("view/operacao/venda/vendasite/grid.html","<div class=\"wrapper wrapper-content animated fadeInRight\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><form name=\"frm\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><ng-field ng-enter=\"vm.search()\" label=\"Estabelecimento\" type=\"select\" model=\"vm.Filter.IdEstabelecimento\" options=\"vm.estabelecimentoList\" value-field=\"Id\" text-field=\"Nome\"></ng-field></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><ng-field ng-enter=\"vm.search()\" ng-disabled=\"!vm.atracaoList\" label=\"Atracao\" type=\"select\" model=\"vm.Filter.IdAtracao\" options=\"vm.atracaoList\" value-field=\"IdAtracao\" text-field=\"Nome\"></ng-field></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-3\"><ng-field name=\"Nome\" ng-enter=\"vm.search()\" label=\"Sessão\" model=\"vm.Filter.IdSessao\" type=\"select\" options=\"vm.lstSessao\" value-field=\"Id\" text-field=\"DataContabil\"></ng-field></div><div class=\"col-md-12\"><h4>Período Data Venda (Data Contábil)</h4></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-3\"><ng-field name=\"Nome\" ng-enter=\"vm.search()\" label=\"\" model=\"vm.Filter.DataVendaInicio\" type=\"date\"></ng-field></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-3\"><ng-field name=\"Nome\" ng-enter=\"vm.search()\" label=\"\" model=\"vm.Filter.DataVendaFim\" type=\"date\"></ng-field></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6 m-t-n-md\"><button ng-disabled=\"frm.$invalid || vm.searching\" style=\"margin-top: 26px\" type=\"button\" class=\"btn btn-w-m btn-success pull-right col-offset-m1\" ng-click=\"vm.search()\"><i class=\"fa\" ng-class=\"{\'fa fa-spinner fa-pulse\' : vm.searching}\"></i> FILTRAR</button></div></div></form></div><br><div class=\"ibox-content\"><div class=\"table-responsive\" ts-wrapper=\"\" ts-no-data-text=\"Utilize o filtro para filtrar as vendas\"><table class=\"table table-striped table-hover\" data-sorting=\"true\" role=\"grid\" infinite-scroll=\"vm.search(true)\" infinite-scroll-disabled=\"vm.complete || vm.searching\" infinite-scroll-immediate-check=\"false\" infinite-scroll-distance=\"0\"><thead><tr role=\"row\"><th ts-criteria=\"Estabelecimento\">Estabelecimento</th><th ts-criteria=\"Estabelecimento\">Código</th><th ts-criteria=\"IdTipoStatusPagamento\">Status</th><th ts-criteria=\"Atracao\">Atração</th><th>Assentos</th><th>Quantidade</th><th ts-criteria=\"DataHoraInicio\">Data Sessão</th><th ts-criteria=\"DataVenda\" ts-default=\"descending\">Data Venda</th><th ts-criteria=\"DataContabil\">Data Contábil</th><th class=\"text-right\">Ações</th></tr></thead><tbody><tr ng-repeat=\"item in vm.items\" role=\"row\" ng-class=\"{\'success\' : itm.updated}\" ts-repeat=\"\"><td class=\"project-title\"><span>{{item.NomeEstabelecimento}}</span></td><td class=\"project-title\"><span style=\"color: black; font-weight: 600\">{{item.CodRastreio | uppercase}}</span></td><td ng-if=\"!item.FilaFraude\" ng-switch=\"item.IdTipoStatusPagamento\"><text style=\"color: green; font-weight: 600\" ng-switch-when=\"1\">Aprovada</text><text style=\"color: orange; font-weight: 600\" ng-switch-when=\"2\">Cancelada</text><text style=\"color: red; font-weight: 600\" ng-switch-when=\"3\">Reprovada</text><text style=\"color: darkgrey; font-weight: 600\" ng-switch-when=\"4\">Em análise</text><text style=\"color: orange; font-weight: 600\" ng-switch-when=\"5\">Devolvido</text></td><td ng-if=\"item.FilaFraude\"><text style=\"color: orangered; font-weight: 600\">Em análise</text></td><td class=\"project-title\"><span>{{item.Atracao}}</span></td><td class=\"project-title\"><span>{{item.Assentos}}</span></td><td class=\"project-title\"><span>{{item.Qtd}}</span></td><td class=\"project-title\"><span>{{item.DataHoraInicio | date: \'dd/MM/yyyy HH:mm\'}}</span></td><td class=\"project-title\"><span>{{item.DataVenda | date: \'dd/MM/yyyy HH:mm\'}}</span></td><td class=\"project-title\"><span>{{item.DataContabil | date: \'dd/MM/yyyy\'}}</span></td><td class=\"center\" width=\"30\"><span uib-dropdown=\"\" on-toggle=\"toggled(open)\"><a role=\"button\" uib-dropdown-toggle=\"\"><i class=\"fa fa-wrench\"></i></a><ul class=\"pull-right\" uib-dropdown-menu=\"\" aria-labelledby=\"simple-dropdown\"><li><a role=\"button\" ng-click=\"vm.detalhe(item);\"><i class=\"fa fa-edit\"></i> Detalhe</a></li></ul></span></td></tr></tbody></table><div class=\"row\"><div class=\"col-md-6 col-md-offset-5\" ng-show=\"vm.searching\"><i class=\"fa fa-spinner fa-pulse fa-1x fa-fw\"></i> Carregando...</div></div></div></div></div></div></div></div>");
$templateCache.put("view/operacao/venda/vendasite/index.html","<div ui-view=\"\"></div>");
$templateCache.put("view/operacao/venda/pesquisar-venda/cancelamento/form.html","<style>\n  .table {\n    border: 1px solid white;\n  }\n\n  .table td {\n    border: 1px solid black;\n    /*width: 33%;*/\n    padding-left: 5px;\n  }\n\n  .table > thead > tr > th,\n  .table > tbody > tr > th,\n  .table > tfoot > tr > th,\n  .table > thead > tr > td,\n  .table > tbody > tr > td,\n  .table > tfoot > tr > td {\n    border: 1px solid white;\n  }\n\n  .table > thead > tr > th,\n  .table > tbody > tr > th,\n  .table > tfoot > tr > th,\n  .table > thead > tr > td,\n  .table > tbody > tr > td,\n  .table > tfoot > tr > td {\n    border-top: 1px solid white;\n    line-height: 1.42857;\n    padding: 5px;\n    padding-left: 10px;\n    vertical-align: top;\n  }\n\n  .btn-default {\n    color: inherit;\n    background: white;\n    /*border: 1px solid #e7eaec;*/\n    border: 1px solid grey;\n  }\n\n</style><div class=\"wrapper wrapper-content animated fadeInDown\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><form name=\"frm\"><div class=\"row\"><table class=\"table\"><tr><td><label>Estabelecimento:</label></td><td>{{vm.venda.Estabelecimento}}</td><td><label>Venda:</label></td><td>{{vm.venda.CodRastreio}}</td><td style=\"vertical-align: inherit; text-align: center\" rowspan=\"4\"><div class=\"btn-group\" uib-dropdown=\"\"><button id=\"split-button\" type=\"button\" class=\"btn btn-danger\" uib-dropdown-toggle=\"\">CANCELAR VENDA</button> <button type=\"button\" class=\"btn btn-danger\" uib-dropdown-toggle=\"\"><span ng-if=\"!vm.loading\" class=\"caret\"></span> <span ng-if=\"vm.loading\" class=\"fa fa-fw fa-spinner fa-pulse\"></span> <span class=\"sr-only\">Split button!</span></button><ul class=\"dropdown-menu\" uib-dropdown-menu=\"\" role=\"menu\" aria-labelledby=\"split-button\"><li role=\"menuitem\"><a role=\"button\" ng-click=\"vm.save(false)\">Apenas o valor do ingresso</a></li><li class=\"divider\"></li><li role=\"menuitem\"><a role=\"button\" ng-click=\"vm.save(true)\">Ingresso + Taxa de serviço</a></li></ul></div></td></tr><tr><td><label>Setor:</label></td><td>{{vm.venda.NomeSetor}}</td><td><label>Cliente:</label></td><td>{{vm.venda.Cliente}}</td></tr><tr><td><label>E-mail:</label></td><td>{{vm.venda.Login}}</td><td><label>Telefone:</label></td><td>{{vm.venda.Telefone}}</td></tr><tr><td><label>Atração:</label></td><td>{{vm.venda.NomeAtracao}}</td><td><label>Data da Sessão:</label></td><td>{{vm.venda.DataHoraInicio | date:\'dd/MM/yyyy HH:mm\'}}</td></tr><tr><td><label>Assentos:</label></td><td>{{vm.venda.LugaresEscolhidos}}</td><td><label>Data da Compra:</label></td><td>{{vm.venda.DataVenda | date:\'dd/MM/yyyy HH:mm\'}}</td></tr><tr><td><label>Ingressos:</label></td><td>{{vm.QtdTipoIngresso}}</td><td><label>Valor:</label></td><td>{{vm.venda.ValorBruto | currency:\'R$\':2}}</td></tr></table></div></form><div class=\"row\"><div class=\"form-group\"><div class=\"col-md-1 col-md-offset-10\"></div><div class=\"col-md-1\"><button class=\"btn btn-success pull-right\" type=\"button\" ng-click=\"vm.cancel();\">VOLTAR</button></div></div></div></div></div></div>");
$templateCache.put("view/operacao/venda/pesquisar-venda/cancelamento/index.html","<div ui-view=\"\"></div>");
$templateCache.put("view/operacao/venda/pesquisar-venda/troca/form.html","<style>\n  .table {\n    border: 1px solid white;\n  }\n\n  .table td {\n    border: 1px solid black;\n    /*width: 33%;*/\n    padding-left: 5px;\n  }\n\n  .table > thead > tr > th,\n  .table > tbody > tr > th,\n  .table > tfoot > tr > th,\n  .table > thead > tr > td,\n  .table > tbody > tr > td,\n  .table > tfoot > tr > td {\n    border: 1px solid white;\n  }\n\n  .table > thead > tr > th,\n  .table > tbody > tr > th,\n  .table > tfoot > tr > th,\n  .table > thead > tr > td,\n  .table > tbody > tr > td,\n  .table > tfoot > tr > td {\n    border-top: 1px solid white;\n    line-height: 1.42857;\n    padding: 5px;\n    padding-left: 10px;\n    vertical-align: top;\n  }\n\n  .form-group-sm select.form-control {\n    border-radius: 0px;\n  }\n\n  .btn-default {\n    color: inherit;\n    background: white;\n    /*border: 1px solid #e7eaec;*/\n    border: 1px solid grey;\n  }\n\n\n  .svg-container {\n    width: 100%;\n    background-color: #eee;\n    border: 1px solid #cacaca;\n    padding: 5px;\n  }\n\n</style><div class=\"wrapper wrapper-content animated fadeInDown\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><form name=\"frm\"><div class=\"row\"><table class=\"table\"><tr><td><label>Estabelecimento:</label></td><td>{{vm.venda.Estabelecimento}}</td><td><label>Venda:</label></td><td>{{vm.venda.CodRastreio}}</td><td style=\"vertical-align: inherit; text-align: center\" rowspan=\"4\"><button type=\"button\" class=\"btn m-t-md btn-w-m btn-default\" ng-click=\"vm.troca()\">TROCAR</button></td></tr><tr><td><label>Setor:</label></td><td>{{vm.venda.NomeSetor}}</td><td><label>Cliente:</label></td><td>{{vm.venda.Cliente}}</td></tr><tr><td><label>E-mail:</label></td><td>{{vm.venda.Login}}</td><td><label>Telefone:</label></td><td>{{vm.venda.Telefone}}</td></tr><tr><td><label>Atração:</label></td><td>{{vm.venda.NomeAtracao}}</td><td><label>Data da Sessão:</label></td><td>{{vm.venda.DataHoraInicio | date:\'dd/MM/yyyy HH:mm\'}}</td></tr><tr><td><label>Assentos:</label></td><td>{{vm.venda.LugaresEscolhidos}}</td><td><label>Data da Compra:</label></td><td>{{vm.venda.DataVenda | date:\'dd/MM/yyyy HH:mm\'}}</td></tr><tr><td><label>Ingressos:</label></td><td>{{vm.QtdTipoIngresso}}</td><td><label>Valor total da compra:</label></td><td>{{vm.venda.ValorBruto | currency:\'R$\':2}}</td></tr></table></div><div class=\"row\" ng-show=\"vm.showSessao\"><hr><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-6\" ng-show=\"vm.showSessao\"><ng-field label=\"Sessao\" type=\"select\" ng-model=\"vm.item.IdSessao\" model=\"vm.item.IdSessao\" options=\"vm.sessaoList\" required=\"true\" value-field=\"Id\" text-field=\"Nome\"></ng-field></div><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-6\" ng-if=\"vm.item.IdSessao && vm.showSetor\"><ng-field label=\"Setor\" type=\"select\" model=\"vm.item.IdSessaoSetor\" options=\"vm.sessaoSetorList\" required=\"true\" value-field=\"IdSessaoSetor\" text-field=\"NomeSetor\"></ng-field></div></div><div class=\"row\" ng-show=\"vm.item.IdSessao && vm.item.IdSessaoSetor\"><hr><div class=\"col-md-12 col-sm-12 col-xs-12 col-lg-10 col-lg-offset-1\"><p style=\"text-align: center\" ng-if=\"vm.loadingSvg\"><i class=\"fa fa-spinner fa-pulse fa-1x fa-fw fa-fd\"></i> Carregando Mapa...</p><p class=\"svg-container\" id=\"svgcontent\" ng-show=\"!vm.loadingSvg\"><ng-svg style=\"pointer-events: none\" content=\"vm.mapaSvg\" loaded=\"vm.svgloaded\"></ng-svg></p></div><div class=\"col-lg-12\"><ng-field label=\"Lotes\" type=\"select\" model=\"vm.item.IdSessaoLote\" options=\"vm.lotes\" required=\"true\" value-field=\"IdSessaoLote\" text-field=\"Ordem\"></ng-field></div><div ng-repeat=\"assento in vm.listVendaIngressoNovo\"><div class=\"col-md-6 col-lg-6 col-sm-6 col-xs-6\"><b>{{assento.Rotulo}}</b><ng-field type=\"select\" model=\"assento.IdAssentoNovo\" options=\"vm.AssentosMapa\" required=\"true\" value-field=\"IdAssento\" text-field=\"Rotulo\"></ng-field></div><div class=\"col-md-6 col-lg-6 col-sm-6 col-xs-6\"><b>{{assento.Ingresso}} - R${{assento.ValorBruto}}</b><ng-field ng-disabled=\"!vm.item.IdSessaoLote || !assento.IdAssentoNovo\" type=\"select\" model=\"assento.IdSessaoSetorLotePrecoIngressoNovo\" options=\"vm.sessaoSetorLotePrecoIngressoList\" required=\"true\" value-field=\"IdSessaoSetorLotePrecoIngresso\" text-field=\"Ingresso\"></ng-field></div></div></div></form><div class=\"row\"><div class=\"form-group\"><p><button class=\"btn btn-outline pull-right\" type=\"button\" ng-click=\"vm.cancel();\">CANCELAR</button> <button ng-disabled=\"frm.$invalid || vm.loading\" class=\"btn btn-primary pull-right\" type=\"button\" ng-click=\"vm.save();\"><i ng-show=\"vm.loading\" class=\"fa fa-fw fa-spinner fa-pulse\"></i>SALVAR</button></p></div></div></div></div></div>");
$templateCache.put("view/operacao/venda/pesquisar-venda/troca/index.html","<div ui-view=\"\"></div>");}]);